import antdData from 'antd/lib/locale/id_ID'
// import localeData from 'react-intl/locale-data/id'

const messages = {
  'text.choose': 'Pilih {title}',
  'text.select': 'Pilih {title}',
  'text.please_choose': 'Silahkan pilih {title}',
  'button.add_with_title': 'Tambah {title}',
  'report.name_with_title': 'Nama {title}',
  'report.product_name_with_title': 'Nama {title}',
  'report.product_category_with_title': 'Kategori {title}',
  'report.total_quantity_product_with_title': 'Total kuantitas {title}',
  'report.finished_product_with_title': '{title} Jadi',
  'report.search_by_product_with_title': 'Cari {title}',
  'report.product_value_with_title': 'Nilai {title}',
  'report.product_profitability_stock_tracking_product_with_title': '{title} Lacak Stok',
  'report.product_profitability_non_stock_tracking_product_with_title': '{title} Tanpa Lacak Stok',
  'report.product_profitability_bundle_product_with_title': '{title} Paket',
  'sales.product_sales_with_title': 'Penjualan Per {title}',
  'sales.sales_contact_with_title': 'Penjualan Per {title}',
  'financeInvoices.product_type_with_title': 'Jenis {title}',
  'financeInvoices.select_product_with_title': 'Pilih {title}',
  'financeInvoices.please_select_tag_with_title': 'Silahkan pilih {title}',
  'financeWareHouses.total_products_with_title': 'Total {title}',
  'financeWareHouses.total_product_value_with_title': 'Total Nilai {title}',
  'financeWareHouses.ref_number_help_with_title':
    'Isikan {title} untuk catatan internal dan mempermudah pencarian.',
  'financeInvoices.used_to_create_transaction_categories_with_title':
    'Digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan {title} ini.',
  'financeWareHouses.please_select_a_product_with_title': 'Silakan pilih {title}.',
  'financeWareHouses.header_column_hpp_help_with_title':
    'Ini adalah harga perolehan dari {title}, atau harga beli.',
  'financeInvoices.product_code_that_not_exist_will_be_inserted_as_a_new_product_with_title':
    'Kode SKU {product} yang belum ada di Kledo akan dimasukkan sebagai {product} baru.',
  'financeProduct.available_stock_product_with_title': '{product} Stok Tersedia',
  'financeProduct.almost_empty_stock_product_with_title': '{product} Stok Hampir Habis',
  'financeProduct.empty_stock_product_with_title': '{product} Stok Habis',
  'financeProduct.total_product_value_with_title': 'Total Nilai {product}',
  'financeProduct.total_product_type_with_title': 'Total Jenis {product}',
  'financeProduct.product_type_per_category_with_title': 'Jenis {product} per Kategori',
  'financeProduct.product_availability_with_title': 'Ketersediaan {product}',
  'financeProduct.product_image_with_title': 'Gambar {product}',
  'financeProduct.show_product_image_with_title': 'Tampilkan Gambar {product}',
  'financeProduct.hide_product_image_with_title': 'Sembunyikan Gambar {product}',
  'financeProduct.raw_material': 'Bahan baku:',
  'financePurchaseOrders.please_select_a_product_with_title': 'Silakan pilih {product}.',
  'financeProduct.package_product_items_with_title': 'Paket {product} terdiri dari :',
  'financeProduct.manufacture_product_items_with_title': '{product} manufaktur terdiri dari :',
  'financeProduct.qty_multiplier': 'Pengali',
  'financeProduct.output_qty_default': 'Kuantitas',
  'priceRule.applies_to_the_following_customers_with_title': 'Berlaku Pada {customer} Berikut',
  'priceRule.applies_to_the_following_products_with_title': 'Berlaku Pada {product} Berikut',
  'priceRule.all_customer_with_title': 'Semua {customer}',
  'priceRule.customer_group_with_title': 'Grup {customer}',
  'priceRule.per_customer_with_title': 'Per {customer}',
  'priceRule.customer_groups_that_will_get_discount_with_title':
    'Grup {customer} yang akan mendapatkan {priceType}',
  'priceRule.customers_that_will_get_discount_with_title':
    '{customer} yang akan mendapatkan {priceType}',
  'priceRule.all_product_with_title': 'Semua {product}',
  'priceRule.product_category_with_title': 'Kategori {product}',
  'priceRule.per_product_with_title': 'Per {product}',
  'priceRule.discounted_product_category_with_title': 'Kategori {product} yang di{priceType}',
  'priceRule.discounted_product_with_title': '{product} yang di{priceType}',
  'posConnect.default_customer_with_title': '{customer} Default',
  'posConnect.please_select_default_customer_with_title': 'Silakan pilih {customer} Default',
  'posConnect.transaction_from_pos_inputed_as_this_customer_with_title':
    'Transaksi dari POS akan dicatatkan sebagai transaksi dari {customer} ini',
  'posConnect.service_charge_product_with_title': '{product} Service Charge',
  'posConnect.please_select_service_charge_product_with_title':
    'Silakan pilih {product} Service Charge',
  'posConnect.if_service_charge_inputes_as_this_product_with_title':
    'Jika terdapat service charge, akan dicatatkan sebagai pembelian pada {product} ini',
  'posConnect.custom_product_with_title': '{product} Custom',
  'posConnect.please_select_custom_product_with_title': 'Silakan pilih {product} Custom',
  'posConnect.if_custom_product_inputes_as_this_product_with_title':
    'Jika terdapat pembelian dengan {product} custom, akan dicatatkan pada {product} ini',
  'emails.insert_tagsment_with_title': 'Sisipkan {tag}',
  'layoutInvoice.show_product_with_title': 'Tampilkan {product}',
  'layoutInvoice.show_item_by_category': 'Tampilkan Item Berdasarkan Kategori',
  'layoutInvoice.show_ref_code_product_with_title': 'Tampilkan SKU {product}',
  'layoutInvoice.show_product_image_with_title': 'Tampilkan Gambar {product}',
  'layoutInvoice.show_tags_with_title': 'Tampilkan {tags}',
  'layoutInvoice.show_reference_with_title': 'Tampilkan {reference}',
  'businessFlow.hide_products_that_are_out_of_stock_with_title':
    'Sembunyikan {products} yang stok habis',
  'businessFlow.hide_products_that_are_out_of_stock_description_with_title':
    'Apakah {products} yang stok habis disembunyikan saat menambah penjualan?',
  'businessFlow.product_price_dont_change_with_title': 'Harga {product} tidak bisa diubah',
  'businessFlow.wether_product_price_can_be_changed_when_add_invoice_with_title':
    'Jika aktif maka harga {product} saat menambah tagihan tidak dapat diubah.',
  'businessFlow.when_product_below_min_stock_email_notification_with_title':
    'Saat stok {product} di bawah stok minimal, akan dikirimkan email notifikasi',
  'bussinesFlow.desc_default_tracking_stock_with_title':
    'Secara default fitur lacak stock aktif saat membuat {product} baru',
  'businessFlow.use_fifo_method_desc_with_title':
    'Metode yang digunakan untuk menghitung HPP. Jika aktif akan menggunakan metode FIFO, jika tidak aktif akan menggunakan metode Averaging. Pengaturan ini tidak dapat diubah jika telah terdapat {product} yang aktif lacak stok nya. Pengaturan hanya tersedia di paket Elite.',
  'businessFlow.auto_update_product_buy_price_with_title': 'Auto update harga beli {product}',
  'businessFlow.auto_update_product_buy_price_desc_with_title':
    'Saat melakukan pembelian {product}, otomatis harga beli-nya dicatatkan ke produk sebagai harga beli default',
  'businessFlow.auto_update_product_sell_price_with_title': 'Auto update harga jual {product}',
  'businessFlow.auto_update_product_sell_price_desc_with_title':
    'Saat melakukan penjualan {product}, otomatis harga jual-nya dicatatkan ke produk sebagai harga jual default',
  'businessFlow.decline_product_conv_if_stock_not_enough_with_title':
    'Tolak konversi {product} jika stok kurang',
  'businessFlow.wether_decline_add_product_conv_if_stock_not_enough_with_title':
    'Apakah tolak penambahan konversi {product} jika stok bahan baku tidak mencukupi?',
  'businessFlow.show_tag_with_title': 'Tampilkan {tag}',
  'businessFlow.show_tag_desc_with_title': 'Apakah input {tag} ditampilkan saat membuat invoice?',
  'businessFlow.input_tag_is_required_with_title': 'Input {tag} wajib diisi',
  'businessFlow.product_reject_lower_sell_purchase_price':
    'Tolak produk baru jika harga beli lebih tinggi dari harga jual',
  'businessFlow.product_reject_lower_sell_purchase_price_desc':
    'Apakah tolak produk baru jika harga beli produk lebih tinggi dari harga jual produk?',
  'businessFlow.input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diisi saat menambahkan transaksi penjualan?',
  'businessFlow.manual_journal_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diiisi saat menambahkan transaksi jurnal umum?',
  'businessFlow.purchase_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diiisi saat menambahkan transaksi tagihan pembelian?',
  'businessFlow.expense_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diiisi saat menambahkan transaksi biaya?',
  'businessFlow.bank_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diiisi saat menambahkan transaksi bank?',
  'businessFlow.product_conversion_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diiisi saat menambahkan transaksi produk konversi?',
  'businessFlow.stock_adjustment_input_tag_is_required_desc_with_title':
    'Apakah {tag} wajib diisi saat menambahkan transaksi penyesuaian stok?',
  'businessFlow.show_reference_with_title': 'Tampilkan {reference}',
  'businessFlow.show_reference_desc_with_title':
    'Apakah input {reference} ditampilkan saat membuat invoice?',
  'businessFlow.reference_multiline_with_title': 'Multiline {reference}',
  'businessFlow.reference_multiline_desc_with_title': 'Apakah {reference} bisa banyak baris?',
  'financeProduct.bundle_type_id_with_title': 'Tipe {product}',
  'salesPerson.show_sales_person_with_title': 'Tampilkan {sales_person}',
  'salesPerson.hide_sales_person_with_title': 'Sembunyikan {sales_person}',
  'salesPerson.select_sales_person_with_title': 'Pilih {sales_person}',
  'salesPerson.faq_answer_give_different_commission_with_title':
    'Anda dapat mengatur besaran komisi tiap {sales_person} melalui {here}. Selain itu komisi juga bisa diatur berbeda untuk masing-masing produk.',
  'businessFlow.wether_save_sales_person_to_sales_with_title':
    'Apakah mencatatkan {sales_person} pada penjualan?',
  'businessFlow.default_trans_date_follow_parent':
    'Default tanggal transaksi sama dengan tanggal transaksi asal',
  'businessFlow.default_trans_date_follow_parent_desc':
    'Jika ya, maka saat membuat tagihan dari pemesanan, tanggal transaksi defaultnya sama dengan tanggal pemesanan. Jika tidak, tanggal transaksi adalah tanggal hari ini.',
  'financeInvoices.with_credit_payment_with_title': 'Dengan {credit}',
  'financeInvoices.with_debit_payment_with_title': 'Dengan {debit}',
  'financePurchaseInvoices.pay_with_credit_memo_with_title': 'Dibayar dengan {credit}',
  'financePurchaseInvoices.please_select_with_credit_memo_with_title':
    'Silahkan pilih dibayar dengan {credit}',
  'financePurchaseInvoices.pay_with_debit_memo_with_title': 'Dibayar dengan {debit}',
  'financePurchaseInvoices.please_select_with_debit_memo_with_title':
    'Silahkan pilih dibayar dengan {debit}',
  'financeContacts.your_net_debt_with_title': 'Net {credit} Anda',
  'financeContacts.you_owe_with_title': 'Anda {credit}',
  'financeContacts.they_owe_with_title': 'Mereka {credit}',
  'financeContacts.your_due_debt_with_title': '{credit} Anda jatuh tempo',
  'financeContacts.their_due_debt_with_title': '{credit} mereka jatuh tempo',
  'financeContacts.debt_you_need_to_pay_with_title': '{credit} yang perlu Anda bayar',
  'financeContacts.max_payable_with_title': 'Maksimal {credit}',
  'financeContacts.total_payable_is_calculated_from_purchase_invoices_with_title':
    'Total {credit} dihitung dari tagihan pembelian, transaksi biaya dan kontak {credit}. Jika total {credit} melebihi maksimal, maka saat membuat tagihan pembelian baru akan ditolak.',
  'financeContacts.max_receivable_with_title': 'Maksimal {debit}',
  'financeContacts.total_accounts_receivable_is_calculated_from_sales_invoices_with_title':
    'Total {debit} dihitung dari tagihan penjualan dan kontak {debit}. Jika total {debit} melebihi maksimal, maka saat membuat tagihan penjualan baru akan ditolak.',
  'financeContacts.payable_account_with_title': 'Akun {credit}',
  'financeContacts.receivable_account_with_title': 'Akun {debit}',
  'financeContacts.awaiting_payment_with_title': '{debit} menunggu pembayaran',
  'creditMemo.add_credit_memo_with_title': 'Tambah {credit}',
  'creditMemo.detail_credit_memo_with_title': 'Detil {credit}',
  'creditMemo.detail_title_with_title': '{credit} {number}',
  'creditMemo.edit_credit_memo_with_title': 'Ubah {credit}',
  'debitMemo.add_debit_memo_with_title': 'Tambah {debit}',
  'debitMemo.detail_debit_memo_with_title': 'Detil {debit}',
  'debitMemo.detail_title_with_title': '{debit} {number}',
  'debitMemo.edit_debit_memo_with_title': 'Ubah {debit}',
  'financeContacts.import_contact_transactions_with_title': 'Import {credit} {debit}',
  'financeContacts.follow_these_steps_to_import_your_contact_transactions_with_title':
    'Ikuti langkah-langkah berikut untuk meng-import {credit} {debit}',
  'financeContacts.1_download_your_contact_transactions_template_file_with_title':
    '1. Download file template {credit} {debit}',
  'financeContacts.start_by_downloading_our_contact_transactions_csv_with_title':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari {credit} {debit}-mu.',
  'financeContacts.2_copy_your_contact_transactions_into_the_template_with_title':
    '2. Salin detail {credit} {debit} ke dalam template',
  'financeContacts.import_contact_transactions_using_excel_or_another_spreadsheet_editor_with_title':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail {credit} {debit} ke dalam file template dari Kledo. Pastikan detail {credit} {debit} sesuai dengan kolom header yang ada di template.',
  'financeInvoices.payment_with_credit_memo_with_title': 'Pembayaran dengan {credit}',
  'financeInvoices.payment_with_debit_memo_with_title': 'Pembayaran dengan {debit}',
  'salesCommission.you_can_manage_sales_person_in_this_page_with_title':
    'Anda dapat mengatur komisi penjualan masing-masing {sales_person} pada halaman ini. Jika sudah, {link} untuk melihat laporan komisi sales-nya.',
  'salesCommission.applies_to_the_following_sales_person_with_title':
    'Berlaku Pada {sales_person} Berikut',
  'financeManualJournal.tag_is_required_with_title': '{tag} wajib diisi',
  'financeTag.who_can_access_this_tag_with_title': 'Siapa yang bisa mengakses {tag} ini?',
  'financeProduct.who_can_access_this_product_with_title':
    'Siapa yang bisa mengakses {product} ini?',
  'financeInvoices.recurring_send_email_to_customer_with_title': 'Kirim Email ke {customer}',
  'text.and': 'dan',
  'topBar.changeLanguage': 'Ubah Bahasa',
  'topBar.latestKledoUpdate': 'Update Kledo Terbaru',
  'topBar.dataChangesTimeline': 'Timeline Perubahan Data',
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Ketik untuk mencari...',
  'topBar.buyNow': 'Buy Now $24',
  'topBar.bitcoin': 'Bitcoin',
  'topBar.profileMenu.hello': 'Halo',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Telp',
  'topBar.profileMenu.logout': 'Keluar',
  'topBar.billing.plan': 'Paket',
  'topBar.billing.forever': 'Selamanya',
  'topBar.billing.active_until': 'Aktif s/d',
  'notification.updates': 'Updates',
  'notification.timeline': 'Timeline',
  'notification.server_error': 'Server Bermasalah',
  'notification.something_went_wrong':
    'Terjadi masalah di server, silahkan hubungi customer support kami.',
  'notification.install_kledo': 'Install Aplikasi Kledo',
  'notification.kledo_is_now_on_google_play': 'Kledo kini tersedia di Google Play',
  'notification.kledo_is_now_on_app_store': 'Kledo kini tersedia di App Store',
  'notification.install_now': 'Install Sekarang',
  'notification.later': 'Nanti Saja',
  'notification.disable': 'Matikan Notifikasi',
  'notification.enable': 'Nyalakan Notifikasi',
  'notification.push_prompt_enable': 'Aktifkan',
  'notification.low_stock': 'Notifikasi stok habis',
  'notification.marketplace_sync_done': 'Notifikasi sinkronisasi marketplace selesai',
  'notification.bank_sync_done': 'Notifikasi sinkronisasi bank selesai',
  'notification.monthly_financial_report_email': 'Email laporan keuangan bulanan',
  'notification.show_nps_mute': 'Mute survei rekomendasi',
  'notification.update_title': 'Versi baru Kledo sudah tersedia',
  'notification.update_description':
    'Muat ulang untuk memakai fitur dan perbaikan terbaru. Hanya butuh beberapa detik.',
  'notification.update_description_form':
    'Simpan dulu data yang sedang Anda isi. Versi baru akan dipasang otomatis saat Anda pindah halaman.',
  'notification.update_data_safe': 'Data Anda aman, halaman ini tidak akan dimuat ulang sendiri',
  'notification.update_reload': 'Muat ulang',
  'notification.update_confirm_title': 'Muat ulang sekarang?',
  'notification.update_confirm_content': 'Data yang belum disimpan di halaman ini akan hilang.',
  'notification.update_confirm_ok': 'Tetap muat ulang',
  'notification.update_installing': 'Memasang versi terbaru…',
  'notification.update_installing_description':
    'Halaman akan dimuat ulang otomatis dalam beberapa detik.',
  'notification.update_installing_failed':
    'Versi terbaru belum berhasil dimuat. Silakan klik Coba Lagi.',
  'notification.update_installing_offline':
    'Anda sedang offline. Sambungkan internet, lalu klik Coba Lagi.',
  'notification.cache_guide_title': 'Hapus cache browser',
  'notification.cache_guide_intro':
    'Versi terbaru masih gagal dimuat. Hapus cache browser dengan langkah berikut.',
  'notification.cache_guide_step_open_in_browser':
    'Klik menu ⋮ di kanan atas app, lalu pilih “Buka di Chrome”. Jalankan langkah berikutnya di tab yang terbuka.',
  'notification.cache_guide_step_shortcut_windows': 'Tekan Ctrl + Shift + Delete.',
  'notification.cache_guide_step_shortcut_mac': 'Tekan ⌘ Cmd + Shift + Delete.',
  'notification.cache_guide_step_range': 'Di “Rentang waktu”, pilih “Semua”.',
  'notification.cache_guide_step_cache_only':
    'Centang hanya “Gambar dan file dalam cache”. Hapus centang lain supaya Anda tidak logout.',
  'notification.cache_guide_step_delete': 'Klik “Hapus data”.',
  'notification.cache_guide_step_safari_develop':
    'Buka menu Safari → Settings → Advanced, lalu centang “Show features for web developers”.',
  'notification.cache_guide_step_safari_empty':
    'Tekan Option + ⌘ Cmd + E untuk mengosongkan cache.',
  'notification.cache_guide_step_mobile_settings': 'Buka pengaturan browser di HP Anda.',
  'notification.cache_guide_step_mobile_cache':
    'Hapus cache atau file sementara. Jangan hapus cookie supaya Anda tidak logout.',
  'notification.cache_guide_footer':
    'Setelah itu, klik Muat Ulang. Kalau masih gagal, hubungi tim support Kledo.',
  'notification.cache_guide_reload': 'Muat Ulang',
  'date.now': 'Sekarang',
  'date.today': 'Hari Ini',
  'date.yesterday': 'Kemarin',
  'date.last_week': 'Minggu Lalu',
  'date.this_month': 'Bulan Ini',
  'date.last_month': 'Bulan Lalu',
  'date.last_7_days': '7 Hari Lalu',
  'date.last_30_days': '30 Hari Lalu',
  'date.last_365_days': '365 Hari Lalu',
  'date.this_year': 'Tahun Ini',
  'date.last_year': 'Tahun Lalu',
  'date.tomorrow': 'Besok',
  'date.next_week': 'Minggu Depan',
  'date.next_month': 'Bulan Depan',
  'date.next_year': 'Tahun Depan',
  'date.daily': 'Harian',
  'date.monthly': 'Bulanan',
  'date.yearly': 'Tahunan',
  'date.day': 'Hari',
  'date.days': 'Hari',
  'date.hour': 'Jam',
  'date.hours': 'Jam',
  'date.minute': 'Menit',
  'date.minutes': 'Menit',
  'date.week': 'Minggu',
  'date.weeks': 'Minggu',
  'date.month': 'Bulan',
  'date.months': 'Bulan',
  'date.year': 'Tahun',
  'date.years': 'Tahun',
  'date.same_date_last_month': 'Tanggal sama bulan lalu',
  'date.same_date_last_year': 'Tanggal sama tahun lalu',
  'date.last_year_value': '{value} Tahun Lalu',
  'date.last_n_months': '{count} bulan terakhir',
  'date.last_n_years': '{count} tahun terakhir',
  'button.page': 'Halaman',
  'button.next': 'Lanjut',
  'button.continue': 'Selanjutnya',
  'button.prev': 'Sebelumnya',
  'button.renew': 'Perpanjang',
  'button.revert': 'Kembalikan',
  'button.upgrade': 'Upgrade',
  'button.delete': 'Hapus',
  'button.archive': 'Arsipkan',
  'button.unarchive': 'Batalkan Arsip',
  'button.add': 'Tambah',
  'button.edit': 'Ubah',
  'button.back': 'Kembali',
  'button.search': 'Cari',
  'button.save': 'Simpan',
  'button.save_add_new': 'Simpan & Tambah Baru',
  'button.cancel': 'Batal',
  'button.print': 'Print',
  'button.retry': 'Coba Lagi',
  'loadError.title': 'Data gagal dimuat',
  'loadError.description':
    'Periksa koneksi internet Anda, lalu coba lagi. Kalau masih gagal, hubungi customer support kami.',
  'button.filter': 'Filter',
  'button.clear_filter': 'Hapus Filter',
  'button.guide': 'Panduan',
  'button.tour': 'Tur',
  'button.video': 'Video',
  'button.article': 'Artikel',
  'button.year': 'Tahun',
  'button.month': 'Bulan',
  'button.close': 'Tutup',
  'button.open_settings': 'Buka Pengaturan',
  'button.error_data_': 'Error data!',
  'button.create_something': 'Buat {title}',
  'input.placeholder.search': 'Cari',
  'input.placeholder.searchWarehouse': 'Cari nama atau kode gudang',
  'button.return': 'Retur',
  'button.hello_can_i_help': 'Halo, ada yang bisa saya bantu?',
  'button.schedule_now': 'Jadwalkan Sekarang',
  'popconfirm.title.delete': 'Apakah Anda yakin untuk menghapus?',
  'popconfirm.title.archive': 'Apakah Anda yakin untuk mengarsipkan?',
  'popconfirm.title.unarchive': 'Apakah Anda yakin untuk batalkan arsip?',
  'popconfirm.title.reset': 'Apakah Anda yakin untuk mengatur ulang?',
  'popconfirm.title.void': 'Apakah Anda yakin untuk melakukan void transaksi ini?',
  'popconfirm.title.unvoid': 'Apakah Anda yakin untuk membatalkan void transaksi ini?',
  'popconfirm.title.logout': 'Apakah Anda yakin ingin logout?',
  'breadcrumb.sales': 'Penjualan',
  'breadcrumb.purchases': 'Pembelian',
  'breadcrumb.conversionbalances': 'Saldo Awal',
  'breadcrumb.conversiondate': 'Tanggal Konversi',
  'breadcrumb.add': 'Tambah',
  'breadcrumb.edit': 'Edit',
  'breadcrumb.detail': 'Detil',
  'suggestion.not_found': 'Data tidak ditemukan',
  'spinner.loading': 'Pemuatan...',
  'app.loading.title': 'Menyiapkan ruang kerja Anda',
  'app.loading.description': 'Mohon tunggu sebentar, kami sedang memuat data perusahaan Anda.',
  'app.loading.page': 'Memuat halaman...',
  'pos.loading': 'Memuat...',
  'pos.saving_order': 'Menyimpan order...',
  'pos.saving_invoice': 'Menyimpan tagihan...',
  'pos.checking_shift': 'Memeriksa shift aktif...',
  'pos.process_invoice': 'Proses Tagihan',
  'pos.payment_connect': 'Payment Connect',
  'pos.save_invoice': 'Simpan Tagihan',
  'pos.order_fully_paid_hint': 'Pesanan sudah lunas. Tambah produk jika pelanggan memesan lagi.',
  'pos.total_below_down_payment': 'Total tidak boleh kurang dari yang sudah dibayar ({amount})',
  'button.yes': 'Ya',
  'button.no': 'Tidak',
  'button.pdf': 'PDF',
  'button.import': 'Import',
  'button.export': 'Ekspor',
  'button.view_journal_entries': 'Lihat Entri Jurnal',
  'button.add_more': 'Tambah baris',
  'button.print_pdf': 'Cetak PDF',
  'button.print_label': 'Cetak Label',
  'button.print_payment': 'Cetak Rekap Pembayaran',
  'button.print_tax': 'Cetak Faktur Pajak',
  'button.print_partial': 'Cetak per Termin',
  'button.copy_link': 'Salin Link',
  'button.copy': 'Salin',
  'button.send_email': 'Kirim Email',
  'button.send_wa': 'Kirim Whatsapp',
  'button.send_sms': 'Kirim SMS',
  'button.send_thank_you_email': 'Kirim Email Terima Kasih',
  'button.send_email_payment': 'Email Rekap Pembayaran',
  'button.send_wa_payment': 'Whatsapp Rekap Pembayaran',
  'button.send_sms_payment': 'SMS Rekap Pembayaran',
  'button.download': 'Download',
  'button.download_word': 'Download MsWord',
  'button.download_xls': 'Download XLS',
  'button.download_csv': 'Download CSV',
  'button.download_now': 'Download Sekarang',
  'button.upload': 'Unggah',
  'button.send': 'Kirim',
  'button.share': 'Bagikan',
  'button.duplicate': 'Duplikat',
  'button.change_layout': 'Ganti Layout',
  'button.reset': 'Kembali pengaturan awal',
  'button.copy_to_clipboard': 'Salin Link ke Clipboard',
  'button.select_all': 'Pilih Semua',
  'button.deselect_all': 'Hapus Semua',
  'button.change_order': 'Ubah Urutan',
  'button.sell': 'Jual',
  'button.buy': 'Beli',
  'message.cannot_update_data': 'Data tidak dapat diubah.',
  'message.cannot_return_data': 'Data tidak dapat di kembalikan.',
  'message.link_has_been_copied': 'Link berhasil disalin.',
  'message.on': 'di',
  'link.show_more': 'Tampilkan selengkapnya',
  'link.show_less': 'Sembunyikan',
  'link.payment': 'Pembayaran {payment}',
  'link.more': 'selengkapnya',
  'link.add_email': 'Tambah email',
  'link.add_shipping_address': 'Tambah Alamat Pengiriman',
  'companies.company_list': 'Daftar Perusahaan',
  'companies.add_company': 'Tambah Perusahaan',
  'companies.created_on': 'Dibuat',
  'companies.as': 'Sebagai',
  'companies.are_you_sure_to_delete_this_company':
    'Apakah Anda yakin untuk menghapus perusahaan ini?\nSetelah dihapus, data tidak dapat dikembalikan',
  'companies.choose_package': 'Pilih Paket',
  'companies.full_name': 'Nama Lengkap',
  'companies.please_input_full_name': 'Silakan masukkan Nama Lengkap',
  'companies.company_name': 'Nama Perusahaan',
  'companies.please_input_company_name': 'Silakan masukkan Nama Perusahaan',
  'companies.role_on_company': 'Jabatan di Perusahaan Sebagai',
  'companies.please_input_role_on_company': 'Silakan masukkan Jabatan di Perusahaan',
  'companies.number_of_employee': 'Jumlah Karyawan',
  'companies.please_input_number_of_employee': 'Silakan masukkan Jumlah Karyawan',
  'companies.please_input_email': 'Silakan masukkan email',
  'companies.please_input_phone_number': 'Silakan masukkan nomor telepon',
  'companies.phone_number_must_08': 'Nomor telepon harus berawalan 08',
  'companies.next_per_month': 'Selanjutnya {price}/bln',
  'companies.free_forever': 'Gratis Selamanya',
  'table.number': 'No',
  'table.show_data': 'Tampilkan Data',
  'table.rows_selected': '{count} baris dipilih',
  'table.min_one_column': 'Minimal tampil satu kolom',
  'table.data_empty': 'Belum ada data di sini',
  'table.data_x_empty': 'Belum ada {name} di sini',
  'table.lets_create_your_first_x': 'Mulai dengan menambahkan {name} baru.',
  'table.no_results_found': 'Tidak ada hasil ditemukan',
  'table.no_results_hint': 'Coba ubah kata kunci atau atur ulang filtermu.',
  'table.reset_filter': 'Reset filter',
  'nps.how_likely_you_recommend':
    'Seberapa besar kemungkinan Anda akan merekomendasikan Kledo kepada teman atau rekan kerja?',
  'nps.not_likely': 'Sama sekali tidak mungkin',
  'nps.very_likely': 'Sangat mungkin',
  'nps.please_mention_another':
    'Mohon sebutkan hal lain yang ingin Anda sampaikan melalui kotak komentar di bawah',
  'nps.cannot_hide_nps': 'Tidak dapat menutup NPS',
  'nps.cannot_send_nps': 'Tidak dapat mengirim NPS',
  'nps.thank_you_your_input':
    'Terima kasih, masukan Anda sangat berarti. Kami mempelajari setiap masukan yang masuk.',
  'nps.happy_to_hear':
    'Kami senang mendengarnya! Apakah Anda bersedia memberikan ulasan di Google Business Profile kami?',
  'nps.review_on_google': 'Beri Ulasan di Google',
  'sms.cannot_send_wa': 'Tidak dapat mengirim Whatsapp.',
  'sms.cannot_send_sms': 'Tidak dapat mengirim SMS.',
  'sms.destination_number': 'Nomor Tujuan',
  'sms.sms_has_been_sent_to': 'SMS telah berhasil terkirim ke',
  'sms.sms_content': 'Isi SMS',
  'sms.wa_content': 'Isi Whatsapp',
  'sms.please_input_content': 'Silakan masukkan isi SMS.',
  'sms.please_input_wa_content': 'Silakan masukkan isi Whatsapp.',
  'sms.please_input_phone': 'Silakan masukkan nomor tujuan.',
  'email.to': 'Kepada',
  'email.from': 'Dari',
  'email.subject': 'Judul',
  'email.message': 'Pesan',
  'email.please_input_subject': 'Silakan masukkan judul.',
  'email.please_input_message': 'Silakan masukkan pesan.',
  'email.cannot_send_email': 'Tidak dapat mengirim email.',
  'email.email_has_been_sent_to': 'Email telah berhasil terkirim ke',
  'email.please_confirm_email':
    'Silakan mengkonfirmasi email Anda {email} terlebih dahulu sebelum bisa mengirimkan email.',
  'email.send_confirmation_email': 'Kirim Email Konfirmasi',
  'email.resend_confirmation_email': 'Kirim Ulang Email Konfirmasi',
  'email.we_have_sent_confirmation_email':
    'Kami telah mengirim email konfirmasi ke {email}. Mohon cek kotak masuk dan konfirmasi email Anda untuk melanjutkan.',
  'email.email_confirmation': 'Konfirmasi Email',
  'email.email_has_been_verified': 'Email {email} telah berhasil diverifikasi.',
  'email.cannot_verify_email': 'Tidak dapat memverifikasi email.',
  'email.email_verification_failed': 'Email {email} gagal diverifikasi.',
  'email.email_template': 'Template Email',
  'emails.edit_email_template': 'Ubah Template Email',
  'emails.are_you_sure_revert_to_default': 'Apakah Anda yakin akan mengembalikan ke default?',
  'emails.revert_to_default': 'Kembalikan ke Default',
  'emails.template_name': 'Nama Templat',
  'emails.please_input_the_email_template_name': 'Silakan masukkan nama template email.',
  'emails.max_100_characters': 'Maks 100 karakter.',
  'emails.email_template_name': 'Nama Template Email',
  'emails.subject': 'Judul',
  'emails.please_input_the_email_template_subject': 'Silakan masukkan judul template email.',
  'emails.email_successfully_updated': 'Email berhasil diperbarui.',
  'emails.error_cannot_update_email_template': 'Gagal memperbarui template email.',
  'emails.email_successfully_reverted_to_default': 'Email berhasil dikembalikan ke default.',
  'emails.error_cannot_revert_email_template': 'Gagal mengembalikan template email.',
  'emails.reply_email_address_successfully_updated': 'Alamat email balasan berhasil diperbarui.',
  'emails.error_cannot_update_reply_email_address': 'Gagal memperbarui alamat email balasan.',
  'emails.email_templates': 'Template Email',
  'emails.reply_email_address': 'Alamat Email Pengirim',
  'emails.body': 'Tubuh',
  'emails.rdw_tags_wrapper': 'rdw-tags-wrapper',
  'emails.insert_tagsment': 'Sisipkan Tag',
  'emails.when_an_agent_or_guest_replies_to_an_email,_this_is_the_email_their_reply_will_be_sent_to':
    'Saat Anda mengirimkan email, email pengirim akan menggunakan alamat email berikut:',
  'emails.display_name': 'Nama tampilan',
  'emails.please_input_the_display_name': 'Silakan masukkan nama tampilan.',
  'emails.max_20_characters': 'Maks 20 karakter.',
  'emails.only_alphanumeric_allowed': 'Hanya alfanumerik yang diizinkan.',
  'emails.email_address': 'Alamat email',
  'emails.please_input_the_email_address': 'Silakan masukkan alamat email.',
  'emails.please_input_unique_email_address': 'Email {email} telah terdaftar.',
  'emails.invalid_email_address_format': 'Format alamat email tidak valid.',
  'email.you_can_resend_an_email_after':
    'Ada dapat mengirimkan konfirmasi email kembali setelah {countDown}.',
  'emails.invoice_attachment_file': 'File Tagihan',
  'emails.order_attachment_file': 'File Pemesanan',
  'emails.delivery_attachment_file': 'File Pengiriman',
  'emails.order_attachment_unavailable': 'Belum ada pemesanan terkait',
  'emails.delivery_attachment_unavailable': 'Belum ada pengiriman terkait',
  'wa.wa_template': 'Template Whatsapp',
  'wa.edit_wa_template': 'Ubah Template Whatsapp',
  'wa.change_template': 'Ubah Template',
  'wa.error_cannot_update_template': 'Tidak dapat mengubah template Whatsapp',
  'wa.error_cannot_revert_template': 'Tidak dapat mengembalikan template Whatsapp',
  'multiCurrency.multi_currency': 'Multi Mata Uang',
  'multiCurrency.base_currency_cannot_changed_after_enabled':
    'Mata uang dasar tidak dapat diubah setelah Anda mengaktifkan multi mata uang',
  'multiCurrency.activate_multi_currency': 'Aktifkan multi mata uang',
  'multiCurrency.set_rate_source': 'Atur sumber kurs',
  'multiCurrency.change_daily_rate': 'Ubah kurs harian',
  'multiCurrency.add_currency': 'Tambah mata uang',
  'multiCurrency.in': 'Dalam',
  'multiCurrency.rate': 'Kurs',
  'multiCurrency.source': 'Sumber',
  'multiCurrency.base_currency': 'Mata uang dasar',
  'multiCurrency.currency': 'Mata uang',
  'multiCurrency.select_currency': 'Pilih mata uang',
  'multiCurrency.rate_source': 'Sumber kurs',
  'multiCurrency.select_rate_source': 'Pilih sumber kurs',
  'multiCurrency.edit_rate_for_date': 'Ubah kurs untuk tanggal',
  'multiCurrency.input_date': 'Masukkan tanggal',
  'multiCurrency.rate_value': 'Nilai kurs',
  'multiCurrency.rate_value_must_more_0': 'Nilai kurs harus lebih dari 0',
  'multiCurrency.select_rate_value': 'Masukkan nilai kurs',
  'multiCurrency.rate_reference': 'Kurs referensi',
  'multiCurrency.please_select_base_currency_to_enable_multi':
    'Silakan pilih mata uang dasar untuk mengaktifkan multi mata uang',
  'multiCurrency.please_select_currency_first': 'Pilih mata uang terlebih dahulu',
  'multiCurrency.change_rate_value': 'Ubah nilai kurs',
  'multiCurrency.transaction_currency': 'Mata uang transaksi',
  'multiCurrency.reset_rate': 'Reset kurs',
  'multiCurrency.rate_not_found': 'Kurs tidak ditemukan',
  'referral.referral': 'Referal',
  'referral.read_more': 'Baca selengkapnya',
  'referral.referral_history': 'Riwayat Referal',
  'referral.your_referral_code': 'Kode Referalmu',
  'referral.company': 'Perusahaan',
  'referral.code': 'Kode',
  'referral.copy_code': 'Salin Kode',
  'referral.add_code': 'Tambah Kode',
  'referral.register': 'Daftar',
  'referral.paid': 'Dibayar',
  'referral.transfered': 'Ditransfer',
  'referral.approved': 'Disetujui',
  'referral.lead': 'Lead',
  'referral.cannot_get_referral': 'Tidak dapat mengambil data referal',
  'referral.cannot_add_referral': 'Tidak dapat menambah referal',
  'referral.cannot_delete_referral': 'Tidak dapat menghapus referal',
  'referral.invite_your_friends': 'Ajak Temanmu Menggunakan Kledo',
  'referral.get_millions_per_month':
    'Dapatkan jutaan rupiah per bulan dengan membagikan kode referalmu.',
  'referral.share_your_referral_code': 'Bagikan kode referalmu',
  'referral.share_via_sosmed_or_anything':
    'Bagikan via sosmed, email, whatsapp, atau apapun ke kolegamu',
  'referral.discount_for_your_friends': 'Diskon {discount}% untuk temanmu',
  'referral.your_friends_will_get_discount':
    'Temanmu akan mendapatkan diskon {discount}% jika mendaftar untuk 1 tahun',
  'referral.reward_per_referral': 'Reward Rp {rewardAmount}rb per referal',
  'referral.get_reward_per_referral':
    'Dapatkan reward sebesar Rp {rewardAmount}rb rupiah tiap referal',
  'referral.referral_program': 'Program Referal Kledo',
  'referral.share_code_to_get_reward':
    'Bagikan kode atau tautan ini untuk mulai mendapatkan reward.',
  'referral.track_referral_progress': 'Pantau perkembangan dan rewardmu dari setiap referal.',
  'referral.waiting_to_be_processed': 'Menunggu diproses',
  'referral.has_paid': 'Sudah membayar',
  'referral.reward_approved': 'Reward disetujui',
  'referral.already_disbursed': 'Sudah dicairkan',
  'customColumn.you_can_add_custom_column_on_invoice':
    'Anda bisa menambahkan custom kolom pada data transaksi tagihan penjualan',
  'customColumn.name': 'Nama',
  'customColumn.please_input_name': 'Silakan Masukkan Nama',
  'customColumn.name_allowed_chars':
    'Hanya boleh huruf, angka, spasi, titik (.), dan garis miring (/)',
  'customColumn.data_type': 'Tipe Data',
  'customColumn.please_input_data_type': 'Silakan Masukkan Tipe Data',
  'customColumn.transaction_field': 'Field Transaksi',
  'customColumn.item_field': 'Field Item',
  'customColumn.contact_field': 'Field Kontak',
  'customColumn.active': 'Aktif',
  'customColumn.option': 'Pilihan',
  'customColumn.default_selected': 'Default Terpilih',
  'customColumn.please_input_option': 'Silakan Masukkan Pilihan',
  'customColumn.min_1_option': 'Minimal 1 pilihan',
  'customColumn.add_more': 'Tambah baris',
  'customColumn.what_difference_of_transaction_and_item_field':
    'Apa beda field transaksi dan field item? Klik di sini.',
  'customColumn.please_select_custom_column': 'Silakan pilih custom field',
  'customColumn.show_custom_column': 'Tampilkan Custom Field',
  'customColumn.hide_custom_column': 'Sembunyikan Custom Field',
  'customColumn.with_custom_fields_you_can_add_data_to_the_bill':
    'Dengan custom fields, Anda bisa menambah data pada tagihan, ataupun juga menambah kolom pada item tagihan sesuai dengan kebutuhan perusahaan Anda.',
  'marketplaceConnect.status': 'Status',
  'marketplaceConnect.status_error_message':
    'Koneksi marketplace {shopName} terputus. Data produk dan transaksi tidak dapat tersinkronisasi dengan Kledo jika koneksi terputus. Silakan melakukan koneksi ulang untuk marketplace tersebut.',
  'marketplaceConnect.marketplace': 'Marketplace',
  'marketplaceConnect.store': 'Toko',
  'marketplaceConnect.store_url': 'Url Toko',
  'marketplaceConnect.integration_with_tokopedia': 'Integrasi dengan Tokopedia',
  'marketplaceConnect.integration_with_tokopedia_help_text':
    'Dengan integrasi ini, transaksi dari Tokopedia yang telah gabung ke Tiktok, dapat tetap masuk ke Kledo menggunakan preferensi marketplace connect Tokopedia.',
  'marketplaceConnect.please_select_tokopedia_marketplace_connect':
    'Silakan Pilih Marketplace Connect Tokopedia',
  'marketplaceConnect.data_integration_schedule': 'Jadwal Tarik Data',
  'marketplaceConnect.created_at': 'Dibuat',
  'marketplaceConnect.last_data_integrated': 'Terakhir Tarik Data',
  'marketplaceConnect.action': 'Aksi',
  'marketplaceConnect.choose_marketplace_to_connect_to_kledo':
    'Pilih marketplace yang akan dihubungkan ke Kledo',
  'marketplaceConnect.marketplace_not_supported_yet': 'Marketplace ini belum didukung',
  'marketplaceConnect.setting': 'Setting',
  'marketplaceConnect.store_name': 'Nama Toko',
  'marketplaceConnect.delete_connection': 'Hapus Koneksi',
  'marketplaceConnect.sync_now': 'Tarik Data Sekarang',
  'marketplaceConnect.sync_interval': 'Jadwal Tarik Data',
  'marketplaceConnect.please_select_sync_interval': 'Silakan Pilih Jadwal Tarik Data',
  'marketplaceConnect.pos_product_linking_strategy': 'Strategi Penautan Produk',
  'marketplaceConnect.please_select_pos_product_linking_strategy':
    'Silakan Pilih Strategi Penautan Produk',
  'marketplaceConnect.pos_product_linking_strategy_tooltip':
    'Mengatur bagaimana sinkronisasi otomatis menautkan produk marketplace ke produk Kledo. Produk yang tidak tertaut tidak akan ikut sinkronisasi stok.',
  'marketplaceConnect.pos_product_linking_strategy_create_missing':
    'Tautkan, buat produk baru jika belum ada',
  'marketplaceConnect.pos_product_linking_strategy_existing_only':
    'Tautkan hanya ke produk yang sudah ada',
  'marketplaceConnect.pos_product_linking_strategy_none': 'Jangan tautkan otomatis',
  'marketplaceConnect.pos_product_linking_strategy_none_hint':
    'Produk marketplace tidak akan ditautkan ke produk Kledo. Anda masih dapat menautkan manual atau membuat produk Kledo lewat aksi Buat Produk pada daftar produk marketplace.',
  'marketplaceConnect.pos_product_linking_strategy_existing_only_hint':
    'Produk marketplace hanya akan ditautkan ke produk Kledo yang sudah ada. Produk yang tidak cocok akan tetap tanpa tautan — gunakan aksi Buat Produk untuk membuat produk Kledo baru.',
  'marketplaceConnect.payment_bank_account': 'Akun Bank Pembayaran',
  'marketplaceConnect.please_select_payment_bank_account': 'Silakan Pilih Akun Bank Pembayaran',
  'marketplaceConnect.shipping_cost_account': 'Akun Biaya Pengiriman',
  'marketplaceConnect.shipping_cost_account_tooltip':
    'Setiap transaksi yang biaya pengirimannya dibayarkan pelanggan ke marketplace, akan dibuatkan transaksi biaya secara otomatis.',
  'marketplaceConnect.start_pulling_data': 'Mulai tarik data',
  'marketplaceConnect.start_pulling_data_tooltip':
    'Kapan tanggal mulai tarik data dari marketplace ke Kledo? Tarik data maksimal 1 minggu dari tanggal sekarang.',
  'marketplaceConnect.start_pulling_data_minimum_date_message':
    'Minimal tanggal mulai penarikan data adalah sekarang.',
  'marketplaceConnect.start_pulling_data_maximum_date_message':
    'Maximal tanggal mulai penarikan data adalah sekarang.',
  'marketplaceConnect.please_select_shipping_cost_account': 'Silakan Pilih Akun Biaya Pengiriman',
  'marketplaceConnect.admin_cost_account': 'Akun Biaya Admin',
  'marketplaceConnect.admin_cost_account_tooltip':
    'Setiap transaksi yang dipotong biaya admin oleh marketplace, akan dibuatkan transaksi biaya secara otomatis.',
  'marketplaceConnect.please_select_admin_cost_account': 'Silakan Pilih Akun Biaya Admin',
  'marketplaceConnect.pph22_account': 'Akun PPh 22 (Pajak Dibayar Di Muka)',
  'marketplaceConnect.please_select_pph22_account': 'Silakan Pilih Akun PPh 22',
  'marketplaceConnect.pph22_account_tooltip':
    'Akun untuk menampung potongan PPh 22 (0,5%) yang dipungut marketplace dari omzet penjualan. Kosongkan untuk memakai akun default.',
  'marketplaceConnect.warehouse': 'Gudang',
  'marketplaceConnect.please_select_warehouse': 'Silakan Pilih Gudang',
  'marketplaceConnect.tag': 'Tag',
  'marketplaceConnect.default_contact_with_title': 'Kontak {customer} Default',
  'marketplaceConnect.default_contact_help':
    'Jika diisi, semua transaksi hasil sync akan menggunakan kontak ini dan tidak membuat kontak baru berdasarkan data pembeli.',
  'marketplaceConnect.record_shipping_cost': 'Catat Biaya Pengiriman',
  'marketplaceConnect.is_shipping_cost_will_be_recorded_on_kledo':
    'Apakah biaya pengiriman akan dicatatkan ke Kledo?',
  'marketplaceConnect.every_hour': 'Setiap {hour} jam',
  'marketplaceConnect.please_input_shop_name': 'Silakan masukkan url toko',
  'marketplaceConnect.yeah_successful': 'Hore berhasil!',
  'marketplaceConnect.next_activation_step_will_be_contacted':
    'Untuk langkah aktifasi berikutnya, Anda akan dihubungi oleh tim customer success kami pada hari dan jam kerja, melalui whatsapp dan email. Mohon ditunggu ya.',
  'marketplaceConnect.if_product_not_track_empty_warehouse':
    'Jika produk Anda tidak lacak stok, silakan kosongkan bagian gudang ini',
  'marketplaceConnect.using_marketplace_connect_shop_transaction_automatic_on_kledo':
    'Dengan menggunakan marketplace connect, transaksi tokomu di marketplace akan otomatis masuk ke data Kledo, asik kan? Yuk hubungkan marketplacemu dengan Kledo.',
  'marketplaceConnect.tutorial_video': 'Video Tutorial',
  'marketplaceConnect.record_transaction': 'Catat Transaksi',
  'marketplaceConnect.please_select_record_transaction': 'Silakan masukkan Catat Transaksi',
  'marketplaceConnect.on_transaction_done': 'Saat transaksi selesai',
  'marketplaceConnect.start_on_item_sent': 'Mulai saat barang dikirim',
  'marketplaceConnect.record_transaction_help':
    'Jika dicatat saat barang dikirim, maka saat barang status sedang kirim di kledo akan dicatatkan transaksi pemesanan dan pengirimannya. Dan saat transaksi selesai, akan dibuatkan transaksi tagihan penjualan dan pembayarannya. Jika dicatat saat transaksi selesai, maka transaksi dimasukkan ke kledo hanya saat status transaksi di marketplace selesai.',
  'posConnect.choose_pos_to_connect_to_kledo': 'Pilih POS yang akan dihubungkan ke Kledo',
  'posConnect.please_input_client_id': 'Silakan masukkan Client ID',
  'posConnect.please_input_client_secret': 'Silakan masukkan Client Secret',
  'posConnect.olsera_credential_hint':
    'Klik {link} untuk mendapatkan App ID dan Secret Key dari Olsera.',
  'posConnect.click_here_to_get_client_id_secret':
    'Klik {link} untuk mendapatkan Client ID dan Secret',
  'posConnect.payment_transaction_input_this_coa_account':
    'Transaksi pembayaran akan dicatatkan pada akun COA ini',
  'posConnect.default_customer': 'Pelanggan Default',
  'posConnect.please_select_default_customer': 'Silakan pilih Pelanggan Default',
  'posConnect.transaction_from_pos_inputed_as_this_customer':
    'Transaksi dari POS akan dicatatkan sebagai transaksi dari pelanggan ini',
  'posConnect.service_charge_product': 'Produk Service Charge',
  'posConnect.please_select_service_charge_product': 'Silakan pilih Produk Service Charge',
  'posConnect.if_service_charge_inputes_as_this_product':
    'Jika terdapat service charge, akan dicatatkan sebagai pembelian pada produk ini',
  'posConnect.custom_product': 'Produk Custom',
  'posConnect.please_select_custom_product': 'Silakan pilih Produk Custom',
  'posConnect.if_custom_product_inputes_as_this_product':
    'Jika terdapat pembelian dengan produk custom, akan dicatatkan pada produk ini',
  'posConnect.your_pos_has_been_connected':
    'POS Anda sudah terkoneksi dengan Kledo. Data dari POS akan otomatis masuk ke Kledo secara berkala',
  'consolidation.you_must_have_more_than_one_companies':
    'Untuk dapat menggunakan fitur konsolidasi, Anda terlebih dahulu harus mempunyai lebih dari satu perusahaan dengan hak akses Administrator.',
  'consolidation.if_you_have_more_companies_you_may_activate':
    'Jika Anda memiliki lebih dari satu perusahaan, Anda dapat mengaktifkan fitur konsolidasi. Fitur konsolidasi akan secara otomatis mengkompilasi laporan dari masing-masing perusahaan kedalam satu laporan konsolidasi.',
  'consolidation.you_must_have_admin_each_companies':
    'Anda harus memilik hak akses sebagai administrator dimasing-masing perusahaan yang akan dikompilasi.',
  'consolidation.please_select_companies_that_will_be_compiled':
    'Silakan pilih perusahaan yang akan dikompilasi ke dalam laporan konsolidasi',
  'consolidation.please_select_coa_accounts':
    'Silakan pilih akun COA untuk dikompilasi kedalam laporan konsolidasi',
  'consolidation.please_select_all_companies_that_will_be_compiled':
    'Silakan pilih semua perusahaan yang akan dikompilasi ke dalam laporan konsolidasi',
  'consolidation.must_enable_2_companies': 'Anda harus mengaktifkan setidaknya 2 perusahaan',
  'consolidation.cannot_select_company': 'Tidak dapat memilih perusahaan',
  'consolidation.add_company': 'Tambah Perusahaan',
  'consolidation.automatic_compilation': 'Kompilasi Otomatis',
  'consolidation.compile': 'Kompilasi',
  'consolidation.cannot_compile': 'Tidak dapat mengkompilasi',
  'consolidation.code': 'Kode',
  'consolidation.name': 'Nama',
  'consolidation.category': 'Kategori',
  'consolidation.account': 'Akun',
  'consolidation.account_total': 'Jumlah Akun',
  'consolidation.activate_consolidation_feature': 'Aktifkan fitur konsolidasi',
  'consolidation.cannot_activate_consolidation': 'Tidak dapat mengaktifkan fitur konsolidasi',
  'consolidation.compilation_saved':
    'Kompilasi akun berhasil, klik tombol di bawah untuk melihat laporan',
  'consolidation.see_report': 'Lihat Laporan',
  'consolidation.confirm_auto_compile':
    'Kompilasi otomatis akan secara otomatis mengkompilasi akun dengan kode yang sama ke dalam akun konsolidasi. Apakah Anda yakin akan mengkompilasi otomatis?',
  'consolidation.code_already_exist': 'Kode sudah ada, silakan ganti dengan yang lain',
  'translation.translation': 'Translasi',
  'translation.title.reset': 'Apakah Anda yakin untuk reset?',
  'translation.reset': 'Reset Translasi',
  'translation.error_cannot_edit': 'TIdak bisa mengubah Translasi',
  'audit.audit': 'Audit',
  'audit.show_audit': 'Lihat Audit',
  'audit.date': 'Tanggal',
  'audit.description': 'Deskripsi',
  'audit.ip': 'IP',
  'audit.by': ' oleh ',
  'audit.user': 'User',
  'audit.item': 'Item',
  'audit.all_item': 'Semua item',
  'audit.filter': 'Filter Audit',
  'audit.allow_users_view_audit_detail_transaction':
    'Izinkan user lihat audit dari detail transaksi',
  'audit.allow_users_view_audit_detail_transaction_help_text':
    'Jika aktif maka menu "{menuName1}" dan "{menuName2}" akan ditampilkan',
  'appSetting.apps': 'Aplikasi',
  'appSetting.date_created': 'Tanggal Dibuat',
  'appSetting.app_name': 'Nama Aplikasi',
  'appSetting.client_id': 'Client ID',
  'appSetting.client_id_has_been_copied': 'Client ID berhasil disalin',
  'appSetting.secret_has_been_copied': 'Secret berhasil disalin',
  'appSetting.endpoint_has_been_copied': 'API Endpoint URL berhasil disalin',
  'appSetting.documentation_has_been_copied': 'Dokumentasi API berhasil disalin',
  'appSetting.api_documentation_endpoint': 'Dokumentasi API Endpoint',
  'appSetting.please_input_name': 'Silakan masukkan nama aplikasi',
  'appSetting.please_redirect_uri': 'Silakan masukkan redirect URI',
  'appSetting.please_valid_uri': 'Silakan masukkan URL yang valid',
  'appSetting.error_cannot_get': 'Tidak dapat mengambil data aplikasi',
  'appSetting.error_cannot_create': 'Tidak dapat membuat aplikasi',
  'appSetting.error_cannot_edit': 'Tidak dapat mengubah aplikasi',
  'appSetting.error_cannot_delete': 'Tidak dapat menghapus aplikasi',
  'appSetting.app_has_been_created_make_sure_save_secret':
    'Aplikasi baru berhasil dibuat, silakan pastikan simpan kode secret di bawah sebelum berpindah ke halaman lain.',
  'appSetting.secret_code_just_shown_once':
    'Kode secret hanya tampil sekali. Simpan kode ini, karena setelah ini Anda tidak dapat melihat kode secret ini lagi.',
  'appSetting.integrate_your_app_with_kledo': 'Integrasikan aplikasimu dengan Kledo',
  'appSetting.now_app_can_be_integrated_with_kledo':
    'Sekarang aplikasi, website, maupun software-mu bisa diintegrasikan dengan Kledo.',
  'appSetting.for_more_details_lets_see_the_video': 'Untuk lebih jelasnya, yuk lihat videonya',
  'appSetting.watch_video': 'Lihat video',
  'settings.shipping_comps': 'Atur perusahaan ekspedisi',
  'settings.failed_to_save': 'Gagal menyimpan pengaturan. Silakan coba lagi.',
  'settings.businessflow': 'Atur alur bisnismu',
  'settings.company': 'Data dan logo perusahaan',
  'settings.taxes': 'Atur pajak',
  'settings.terms': 'Atur data termin pembayaran',
  'settings.billing': 'Upgrade dan perpanjangan paket Kledo',
  'settings.automatic_sequencing': 'Atur penomoran otomatis invoice',
  'settings.lock_date': 'Kunci data lama untuk tutup buku',
  'settings.layout_invoice': 'Atur tampilan print invoice',
  'settings.layout_reporting': 'Atur tampilan print keuangan',
  'settings.users': 'Undang staff dan kolegamu menggunakan Kledo',
  'settings.roles': 'Atur hak akses pengguna',
  'settings.transaction_age_limit': 'Batasi akses transaksi lama untuk peran tertentu',
  'settings.my_profile': 'Atur profil dan ubah password',
  'settings.setup': 'Hapus data demo dan mulai dari awal',
  'settings.translation': 'Ubah bahasa pada menu Kledo',
  'settings.audits': 'Pantau log perubahan data',
  'settings.units': 'Atur satuan produk',
  'settings.product_variants': 'Atur varian produk',
  'settings.product_modifiers': 'Atur modifier produk',
  'settings.consolidation': 'Atur perusahaan dan akun untuk laporan konsolidasi',
  'settings.tags': 'Atur tag untuk pemisahan laporan cabang/departemen/divisi',
  'settings.email_template': 'Atur tampilan email',
  'settings.apps': 'Koneksikan Apps mu dengan API Kledo',
  'settings.account_mappings': 'Pemetaan akun CoA untuk transaksi di Kledo',
  'settings.marketplace_connect': 'Otomatis sinkron Shopee, Tokopedia, dan Lazada ke Kledo',
  'settings.whatsapp_template': 'Atur template default pengiriman invoice via Whatsapp',
  'settings.notification': 'Atur notifikasi yang dikirim ke emailmu',
  'settings.notification_title': 'Notifikasi',
  'settings.custom_columns': 'Custom data pada invoicemu',
  'settings.woocommerce': 'Otomatis sinkron Wordpress & Woocommerce ke Kledo',
  'settings.pos_connect': 'Otomatis sinkron POS ke Kledo',
  'settings.multi_currency': 'Atur penggunaan banyak mata uang',
  'settings.price_forecast': 'Atur skenario kenaikan harga bahan',
  'settings.sales_commission': 'Atur komisi penjualan tiap tim sales',
  'settings.zap_route': 'Atur dan kelola rute pengiriman untuk distribusi',
  'settings.zap_user': 'Kelola pengguna dalam sistem distribusi',
  'settings.zap_fleet': 'Kelola armada kendaraan pengiriman',
  'settings.section.profile_subscription': 'Profil & Langganan',
  'settings.section.flow_transaction': 'Alur & Transaksi',
  'settings.section.finance_accounting': 'Keuangan & Akuntansi',
  'settings.section.data_system': 'Data & Sistem',
  'settings.section.document': 'Dokumen',
  'settings.section.communication': 'Komunikasi',
  'settings.section.auto_email': 'Email Otomatis',
  'settings.section.user_management': 'Manajemen Pengguna',
  'settings.section.my_account': 'Akun Saya',
  'settings.section.transaction_payment': 'Transaksi & Pembayaran',
  'settings.section.product_shipping': 'Produk & Pengiriman',
  'settings.section.organization_data': 'Organisasi & Data',
  'settings.section.sales_marketplace': 'Penjualan & Marketplace',
  'settings.section.payment': 'Pembayaran',
  'settings.section.notification_collaboration': 'Notifikasi & Kolaborasi',
  'settings.section.developer_security': 'Developer & Keamanan',
  'settings.section.distribution': 'Distribusi',
  'settings.section.others': 'Lainnya',
  'settings.section.search_result': 'Hasil Pencarian',
  'settings.category_desc.company': 'Kelola data perusahaan dan langganan paket Kledo Anda',
  'settings.category_desc.business_flow':
    'Atur berbagai alur bisnis sesuai kebutuhan perusahaan Anda',
  'settings.category_desc.layout_template':
    'Sesuaikan tampilan dokumen, template email, dan bahasa aplikasi',
  'settings.category_desc.user_account': 'Kelola pengguna, hak akses, dan preferensi akun Anda',
  'settings.category_desc.master_data':
    'Atur data dasar seperti pajak, termin, satuan, dan tags untuk transaksi',
  'settings.category_desc.integration':
    'Hubungkan Kledo dengan marketplace, pembayaran, dan aplikasi lainnya',
  'settings.category_desc.distribution': 'Atur rute, armada, dan pengguna distribusi',

  'billing.error_cannot_upgrade': 'Tidak dapat upgrade',
  'billing.error_cannot_renew': 'Tidak dapat perpanjangan',
  'billing.error_cannot_delete': 'Tidak dapat menghapus',
  'billing.error_cannot_get_addon': 'Tidak dapat mengambil addon',
  'billing.error_cannot_add_addon': 'Tidak dapat menambah addon',
  'billing.account_expired':
    'Akun Anda telah habis masa aktifnya, silakan order perpanjangan untuk kembali dapat mengakses akun Anda',
  'billing.expired': 'Akun Anda telah habis masa aktifnya, {setup} untuk order perpanjangan',
  'billing.current_expired_date': 'Tanggal expired saat ini',
  'billing.1.expiration_date_after_renewal': 'Tanggal expired setelah perpanjangan',
  'billing.2.expiration_date_after_renewal':
    'Tanggal expired setelah perpanjangan dihitung dari tanggal expired saat ini, bukan dihitung dari tanggal pembayaran.',
  'billing.expired_link': 'klik disini',
  'billing.billing': 'Billing',
  'billing.thankyou': 'Terimakasih',
  'billing.upgrade': 'Upgrade',
  'billing.renew': 'Perpanjang',
  'billing.addon': 'Addon',
  'billing.show_addon': 'Tambah Addon',
  'billing.add_addon': 'Tambah Addon',
  'billing.hide_addon': 'Sembunyikan Addon',
  'billing.upgrade_now': 'Upgrade Sekarang',
  'billing.renew_now': 'Perpanjang Sekarang',
  'billing.order_now': 'Pesan Sekarang',
  'billing.upgrade_plan': 'Upgrade Paket',
  'billing.renew_plan': 'Perpanjang Paket',
  'billing.subscription_plan': 'Paket Berlangganan',
  'billing.billing_detail': 'Detail Billing',
  'billing.plan_quota': 'Kuota Paket',
  'billing.plan_quota_group_capacity': 'Kapasitas',
  'billing.plan_quota_group_services': 'Layanan & Dokumen (Top-up)',
  'billing.plan_quota_users': 'Pengguna',
  'billing.plan_quota_warehouses': 'Gudang',
  'billing.plan_quota_stamp': 'E-meterai',
  'billing.plan': 'Paket',
  'billing.forever': 'Selamanya',
  'billing.payment_history': 'Riwayat Pembayaran',
  'billing.active_until': 'Aktif sampai',
  'billing.order_date': 'Tanggal Order',
  'billing.description': 'Deskripsi',
  'billing.period': 'Periode',
  'billing.payment_date': 'Tanggal Bayar',
  'billing.total': 'Total',
  'billing.status': 'Status',
  'billing.select_plan': 'Silakan pilih paket yang Anda inginkan',
  'billing.select_contract_duration': 'Silakan pilih lama kontrak',
  'billing.total_bill': 'Total tagihan',
  'billing.please_add_an_addon': 'Silakan tambah salah satu addon',
  'billing.please_select_a_plan': 'Silakan pilih paket',
  'billing.please_select_the_contract_duration': 'Silakan pilih lama kontrak',
  'billing.get_x_discount_for_1_year_payment_and_x_discount_for_6_months':
    'Diskon {discountFor1Year} untuk pembayaran 1 tahun dan diskon {discountFor6Months} untuk pembayaran 6 bulan',
  'billing.bill_email_has_been_sent_to_your_email':
    'Email tagihan telah dikirimkan ke alamat email Anda.',
  'billing.please_make_a_payment_of': 'Silakan melakukan pembayaran sebesar',
  'billing.by_click_button_below': 'dengan klik tombol berikut',
  'billing.pay_now': 'Bayar Sekarang',
  'billing.pay': 'Bayar',
  'billing.processing_payment': 'Proses Pembayaran',
  'billing.payment_failed': 'Pembayaran Gagal',
  'billing.please_contact_kledo_if_difficulity_on_payment':
    'Silakan menghubungi tim Hebat Kledo jika mengalami kesulitan dalam pembayaran.',
  'billing.payment_success': 'Pembayaran Berhasil',
  'billing.your_account_activated_thanks': 'Akun Anda telah diaktifkan. Terima kasih.',
  'billing.payment_pending': 'Menunggu Pembayaran',
  'billing.your_account_wiil_be_active_after_payment':
    'Akun Anda akan aktif setelah dilakukan pembayaran. Jika Anda telah melakukan pembayaran, silakan klik tombol berikut. Terimakasih.',
  'billing.to': 'ke',
  'billing.bank': 'Bank',
  'billing.account_number': 'Nomor Rekening',
  'billing.after_make_a_payment_please_confirm_via_whatsapp':
    'Setelah melakukan pembayaran, mohon konfirmasi melalui whatsapp di',
  'billing.back_to_billing': 'Kembali ke Billing',
  'billing.feature_available_in_pro_plan': 'Fitur {feature} tersedia di paket PRO',
  'billing.feature_can_only_be_use_on_pro_plan': '{feature} hanya bisa diakses di paket PRO',
  'billing.pro_plan_features': 'Fitur Paket Pro',
  'billing.feature_available_in_elite_plan': 'Fitur {feature} tersedia di paket Elite',
  'billing.feature_can_only_be_use_on_elite_plan': '{feature} hanya bisa diakses di paket Elite',
  'billing.elite_plan_features': 'Fitur Paket Elite',
  'billing.feature_available_in_champion_plan': 'Fitur {feature} tersedia di paket Champion',
  'billing.feature_can_only_be_use_on_champion_plan':
    '{feature} hanya bisa diakses di paket Champion',
  'billing.champion_plan_features': 'Fitur Paket Champion',
  'billing.quota_is_exhausted_add_an_addon': 'Kuota {feature} Anda Habis, Silahkan Tambah Addon',
  'billing.quota_is_exhausted_upgrade_plan':
    'Kuota {feature} Anda Habis, Silahkan Upgrade Paket untuk Tambah Addon',
  'billing.marketplace_connect_available_in_elite':
    '{feature} Tersedia di Paket Elite, Silahkan Upgrade',
  'billing.paid_plan_features': 'Fitur Paket Berbayar',
  'billing.feature_can_only_be_accessed_on_paid_plan':
    'Fitur {feature} hanya bisa diakses di paket berbayar',
  'billing.warehouse_and_inventory': 'Gudang & Inventori',
  'billing.track_product': 'Lacak produk',
  'billing.attachment': 'Attachment',
  'billing.dashboard_layout_setting': 'Pengaturan tampilan dashboard',
  'billing.feature_locked': 'Fitur Dikunci',
  'billing.your_free_trial_active': 'Akun Free Trial Anda sudah aktif.',
  'billing.account_will_active_until': 'Akun akan aktif sampai dengan',
  'billing.token_required_to_make_payment': 'Token diperlukan untuk melakukan pembayaran',
  'dashboard.hello_name': 'Halo {name},',
  'dashboard.schedule_a_demo_and_consult':
    'Yuk jadwalkan demo dan konsultasi online secara gratis bersama tim hebat Kledo.',
  'dashboard.demo_online_with_zoom':
    'Demo dilakukan online menggunakan Zoom secara 1 on 1 selama 45 menit.',
  'dashboards.dashboard': 'Dashboard',
  'dashboards.select_company': 'Pilih Perusahaan: ',
  'dashboards.gross_profit': 'Laba kotor',
  'dashboards.net_profit': 'Laba bersih',
  'dashboards.net_profit_for_this_year': 'Laba bersih tahun ini',
  'dashboards.sales_value_this_year': 'Nilai penjualan bulan ini',
  'dashboards.sales': 'Penjualan',
  'dashboards.awaiting_payment': 'Menunggu pembayaran',
  'dashboards.overdue': 'Jatuh tempo',
  'dashboards.sales_this_day': 'Penjualan hari ini',
  'dashboards.sales_this_month': 'Penjualan bulan ini',
  'dashboards.sales_this_year': 'Penjualan tahun ini',
  'dashboards.this_month': 'Bulan ini',
  'dashboards.ytd': 'Tahun ini',
  'dashboards.total': 'Total',
  'dashboards.are_you_sure_delete': 'Apakah Anda yakin untuk menghapus?',
  'dashboards.modif': 'Ubah',
  'dashboards.exit': 'Keluar',
  'dashboards.select_account': 'Pilih akun',
  'dashboards.please_select_account': 'Silakan pilih akun!',
  'dashboards.in': 'In',
  'dashboards.out': 'Out',
  'dashboards.net': 'Net',
  'dashboards.edit': 'Ubah Dashboard',
  'dashboards.other': 'Lainnya',
  'dashboards.the_first_date_end_higger_than_second_date_start':
    'Tanggal mulai kedua harus berupa tanggal setelah tanggal pertama berakhir',
  'payments.add_a_payment_method': 'Tambah Metode Pembayaran',
  'payments.delete_a_payment_method': 'Hapus Metode Pembayaran ',
  'payments.are_you_sure_delete': 'Anda yakin menghapus?',
  'payments.payment_metod': 'Metode pembayaran',
  'payments.please_select_a_payment_to_delete': 'Silakan pilih pembayaran untuk dihapus',
  'payments.select_a_payment_method': 'Pilih metode pembayaran',
  'payments.edit_payment_method': 'Ubah Metode Pembayaran',
  'payments.payment_method': 'Metode pembayaran',
  'payments.please_input_the_payment_name': 'Silakan masukkan nama pembayaran.',
  'payments.max_20_characters': 'Maks 20 karakter.',
  'payments.only_alphanumeric_allowed': 'Hanya alfanumerik yang diizinkan.',
  'payments.name': 'Nama',
  'payments.payment': 'Pembayaran',
  'payments.payment_methods': 'Metode pembayaran',
  'payments.successfully_added': 'berhasil ditambahkan.',
  'payments.error_cannot_add': 'Tidak bisa menambahkan pembayaran.',
  'payments.successfully_deleted': 'berhasil dihapus.',
  'payments.error_cannot_delete': 'Gagal menghapus pambayaran.',
  'payments.payment_successfully_updated': 'Pembayaran berhasil diperbarui.',
  'payments.error_cannot_update_payment': 'Gagal memperbarui pembayaran.',
  'payments.payment_moved_successfully': 'Pembayaran berhasil dipindahkan.',
  'payments.error_cannot_move_the_payment': 'Gagal memindahkan pembayaran.',
  'payments.change_status_payment_successfully': 'Ubah pembayaran status berhasil.',
  'payments.error_cannot_change_status_the_payment': 'Gagal mengubah status pembayaran. ',
  'payments.must_have_active_payment': 'Harus ada minimal satu pembayaran aktif.',
  'profile.profile': 'Profil',
  'profile.image_profile': 'Gambar Profil',
  'profile.my_profile': 'Profilku',
  'profile.old_password': 'Password lama',
  'profile.please_input_the_old_password': 'Silakan masukkan password lama.',
  'profile.new_password': 'Password baru',
  'profile.please_input_the_new_password': 'Silakan masukkan password baru.',
  'profile.max_100_characters': 'Maks 100 karakter.',
  'profile.confirm_new_password': 'Ulangi password baru',
  'profile.please_input_the_confirm_new_password':
    'Silakan masukkan password baru yang dikonfirmasi! ',
  'profile.email_or_username': 'Email',
  'profile.please_input_the_email/username': 'Silakan masukkan email.',
  'profile.the_input_is_not_valid-e-mail': 'Silakan masukkan email yang valid',
  'profile.full_name': 'Nama lengkap',
  'profile.please_input_the_full_name': 'Silakan masukkan nama lengkap.',
  'profile.0nly_alphanumeric_allowed': 'Hanya alfanumerik yang diizinkan.',
  'profile.phone_number': 'Nomor telepon',
  'profile.please_input_the_phone_number': 'Silakan masukkan nomor telepon.',
  'profile.max_20_characters': 'Maks 20 karakter.',
  'profile.only_number_allowed': 'Hanya angka yang diizinkan.',
  'profile.user_profile_successfully_updated': 'Profil berhasil diperbarui.',
  'profile.error_cannot_update_user_profile': 'Gagal memperbarui profil.',
  'profile.user_password_successfully_updated': 'Password berhasil diperbarui.',
  'profile.error_cannot_update_user_password': 'Gagal memperbarui password.',
  'profile.change_password': 'Ganti password',
  'profile.two_passwords_that_you_enter_is_inconsistent_':
    'Dua password yang Anda masukkan tidak konsisten.',
  'profile.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit':
    'Password setidaknya 8 karakter, setidaknya 1 huruf besar dan setidaknya 1 digit.',
  'profile.password_atleast_6_characters': 'Password setidaknya 6 karakter.',
  'profile.password_atleast_8_characters': 'Password setidaknya 8 karakter.',
  'profile.password_pattern_minimum_1_capital_and_1_lowercase_letter':
    'Minimal 1 huruf kapital dan 1 huruf kecil.',
  'profile.password_pattern_minimum_1_number': 'Minimal 1 angka.',
  'profile.logout_from_all_device': 'Logout dari semua perangkat',
  'profile.cannot_logout_from_all_device': 'Tidak dapat logout dari semua perangkat',
  'transactionAgeLimit.scope': 'Khusus Faktur Penjualan',
  'transactionAgeLimit.description':
    'Blokir peran tertentu dari faktur penjualan yang tanggalnya melewati batas usia.',
  'transactionAgeLimit.roles': 'Peran',
  'transactionAgeLimit.roles_placeholder': 'Pilih peran',
  'transactionAgeLimit.roles_required': 'Pilih minimal satu peran.',
  'transactionAgeLimit.age_value': 'Usia',
  'transactionAgeLimit.age_value_required': 'Isi usia minimal 1.',
  'transactionAgeLimit.age_unit': 'Satuan',
  'transactionAgeLimit.restrict': 'Peran ini tidak bisa',
  'transactionAgeLimit.restrict_view': 'Melihat',
  'transactionAgeLimit.restrict_modify': 'Mengubah',
  'transactionAgeLimit.restrict_backdate': 'Mundur tanggal',
  'transactionAgeLimit.restrict_view_blocked_hint':
    'Peran ini tidak bisa membuka faktur yang tanggalnya melewati batas usia.',
  'transactionAgeLimit.restrict_modify_blocked_hint':
    'Peran ini tidak bisa mengubah, menghapus, atau void faktur yang tanggalnya melewati batas usia.',
  'transactionAgeLimit.restrict_backdate_blocked_hint':
    'Peran ini tidak bisa membuat faktur, atau mengubah tanggal faktur, ke tanggal yang melewati batas usia.',
  'transactionAgeLimit.restrict_view_allowed_hint':
    'Peran ini bisa membuka faktur yang tanggalnya melewati batas usia.',
  'transactionAgeLimit.restrict_modify_allowed_hint':
    'Peran ini bisa mengubah, menghapus, atau void faktur yang tanggalnya melewati batas usia.',
  'transactionAgeLimit.restrict_backdate_allowed_hint':
    'Peran ini bisa membuat faktur, atau mengubah tanggal faktur, ke tanggal yang melewati batas usia.',
  'transactionAgeLimit.rules_section': 'Aturan pembatasan',
  'transactionAgeLimit.rule_number': 'Aturan {number}',
  'transactionAgeLimit.remove_rule_confirm':
    'Hapus aturan ini? Peran di aturan ini akan bebas mengakses transaksi lama.',
  'transactionAgeLimit.remove_rule_number': 'Hapus aturan {number}',
  'transactionAgeLimit.add_rule': 'Tambah aturan',
  'transactionAgeLimit.remove_rule': 'Hapus aturan',
  'transactionAgeLimit.exception_users': 'Pengguna pengecualian',
  'transactionAgeLimit.exception_users_placeholder': 'Pilih pengguna',
  'transactionAgeLimit.exception_users_tooltip':
    'Pengguna ini tetap bisa mengakses semua faktur, walau perannya diblokir.',
  'transactionAgeLimit.print_count_setting_warning':
    'Peran Anda dibatasi untuk mengubah transaksi lama. Jumlah cetak struk tidak bertambah untuk transaksi yang melewati batas usia akses.',
  'transactionAgeLimit.print_count_not_updated':
    'Jumlah cetak struk tidak bisa diperbarui karena transaksi melewati batas usia akses.',
  'transactionAgeLimit.cannot_modify':
    'Transaksi ini sudah melewati batas usia, peran Anda tidak bisa mengubahnya.',
  'transactionAgeLimit.load_failed': 'Pengaturan gagal dimuat',
  'transactionAgeLimit.cannot_backdate_before':
    'Tanggal transaksi tidak boleh sebelum {date}. Peran Anda dibatasi.',
  'roles.add_role': 'Tambah Peran',
  'roles.delete_role': 'Hapus Peran',
  'roles.select_role_to_delete': 'Pilih Peran untuk Dihapus',
  'roles.please_select_a_role': 'Silakan pilih peran.',
  'roles.select_role': 'Pilih peran',
  'roles.edit_role': 'Ubah Peran',
  'roles.role': 'Peran',
  'roles.roles': 'Peran',
  'roles.please_input_the_role_name': 'Silakan masukkan nama peran.',
  'roles.max_100_characters': 'Maks 100 karakter.',
  'roles.superadmin': 'Superadmin',
  'roles.error_cannot_get_roles': 'Tidak bisa mendapatkan Peran.',
  'roles.successfully_added': 'berhasil ditambahkan.',
  'roles.error_cannot_add': 'Tidak bisa menambahkan',
  'roles.role_successfully_updated': 'Peran berhasil diperbarui.',
  'roles.error_cannot_update_role': 'Gagal memperbarui peran.',
  'roles.successfully_deleted': 'berhasil dihapus.',
  'roles.error_cannot_delete': 'Gagal menghapus',
  'roles.role_moved_successfully': 'Peran berhasil dipindahkan.',
  'roles.error_cannot_move_the_channel': 'Gagal memindahkan channel.',
  'roles.search_by_role_name': 'Cari berdasarkan nama peran',
  'roles.name': 'Nama peran',
  'roles.invoices_payment': 'Pembayaran',
  'roles.orders_payment': 'Pembayaran',
  'roles.purchase_invoices_payment': 'Pembayaran',
  'roles.purchase_orders_payment': 'Pembayaran',
  'roles.product_show_purchase_price': 'Tampilkan Harga Beli',
  'roles.product_show_sale_price': 'Tampilkan Harga Jual',
  'roles.product_show_hpp': 'Tampilkan HPP',
  'roles.inventory_show_hpp': 'Tampilkan Harga',
  'roles.reports_finance': 'Finansial',
  'roles.reports_accounting': 'Akuntansi',
  'roles.reports_sales': 'Penjualan',
  'roles.reports_purchases': 'Pembelian',
  'roles.reports_expenses': 'Biaya',
  'roles.reports_taxes': 'Pajak',
  'roles.reports_inventory': 'Inventori',
  'roles.reports_fixed_assets': 'Aset Tetap',
  'roles.reports_budget': 'Anggaran',
  'roles.reports_consolidation': 'Konsolidasi',
  'roles.apikeys': 'API Keys',
  'roles.sales_other_user_access': 'Akses Milik User Lain',
  'roles.purchase_other_user_access': 'Akses Milik User Lain',
  'roles.expenses_other_user_access': 'Akses Milik User Lain',
  'roles.product_show_manufacture_raw': 'Tampilkan Bahan Baku Manufaktur',
  'report.view_price': 'Lihat Harga',
  'roles.show_purchase_price': 'Tampilkan Harga Beli',
  'roles.show_sales_price': 'Tampilkan Harga Jual',
  'roles.show_cogs': 'Tampilkan HPP',
  'roles.show_manufaktur_materials': 'Tampilkan Bahan Baku Manufaktur',
  'roles.users_with_this_role': 'Pengguna dengan peran ini',
  'roles.click_here_to_set_users': '{clickHere} untuk mengatur pengguna.',
  'roles.role_not_found': 'Peran dengan id {id} tidak ditemukan',
  'shipComp.shipping_company': 'Ekspedisi',
  'shipComp.name': 'Nama',
  'shipComp.status': 'Status',
  'shipComp.error_cannot_move': 'Tidak dapat menambah ekspedisi.',
  'shipComp.error_cannot_add': 'Tidak dapat menambah ekspedisi.',
  'shipComp.error_cannot_update': 'Tidak dapat mengubah ekspedisi.',
  'shipComp.error_cannot_delete': 'Tidak dapat menghapus ekspedisi.',
  'shipComp.error_cannot_change_status': 'Tidak dapat mengubah status ekspedisi.',
  'shipComp.please_select_to_delete': 'Silakan pilih Ekspedisi untuk dihapus',
  'shipComp.select': 'Pilih Ekspedisi',
  'shipComp.please_input_the_name': 'Silakan masukkan nama ekspedisi.',
  'shipComp.must_have_active_shipcomp': 'Harus ada minimal satu ekspedisi aktif.',
  'report.sales_per_period': 'Penjualan Per Periode',
  'report.purchases_per_period': 'Pembelian Per Periode',
  'report.product_sales_per_customer': 'Penjualan Produk per Pelanggan',
  'report.processing_the_data': 'Memproses data',
  'report.access_denied': 'Akses Ditolak',
  'report.open_from_list_price_rule':
    'Detail laporan tidak valid. Silakan buka dari daftar laporan penjualan per aturan harga.',
  'report.back_to_list': 'Kembali ke daftar laporan',
  'report.pos_sales_price_rule': 'Penjualan per Aturan Harga',
  'report.pos_sales_price_rule.product_count': 'Jumlah Produk',
  'report.pos_sales_price_rule.total_discount_tooltip':
    'Akumulasi total diskon / markup dari seluruh transaksi',
  'report.pos_sales_price_rule.item_total_tooltip':
    'Total diskon / markup yang diterapkan pada item ini',
  'report.pos_shift': 'Shift POS',
  'report.select_pos_shift': 'Pilih shift',
  'report.item_count': 'Jumlah Item',
  'report.total_discount_amount': 'Total Diskon',
  'report.profitability_per_invoice': 'Profitabilitas per Tagihan',
  'report.show_account': 'Tampilkan Akun',
  'report.show_zero_account_balance': 'Tampilkan akun bersaldo kosong',
  'report.show_zero_income': 'Tampilkan Pendapatan 0',
  'report.profitloss_show_zero': 'Tampilkan nilai 0',
  'report.account_not_compiled':
    'Terdapat akun yang belum dikompilasi, silahkan {link} untuk mengkompilasi',
  'report.month': 'Bulan',
  'report.date': 'Tanggal',
  'report.expense_claim_customer': 'Kontak',
  'report.general_ledger_reporting': 'Laporan Buku Besar',
  'report.account': 'Akun',
  'report.account_list': 'Daftar Akun',
  'report.general_ledger': 'Buku Besar',
  'report.source': 'Sumber',
  'report.please_select_source': 'Silahkan Pilih Sumber',
  'report.description': 'Deskripsi',
  'report.reference': 'Referensi',
  'report.debit': 'Debit',
  'report.credit': 'Kredit',
  'report.ytd_debit': 'Debit Tahun Ini',
  'report.ytd_credit': 'Kredit Tahun Ini',
  'report.running_balance': 'Saldo Berjalan',
  'report.opening_balance': 'Saldo Awal',
  'report.closing_balance': 'Saldo Akhir',
  'report.next_n_months': '{count} Bulan ke Depan',
  'report.cash_flow_projection_label': 'Keterangan',
  'report.cash_flow_projection_opening_balance': 'Saldo Awal Kas & Bank',
  'report.cash_flow_projection_receivable_receipts': 'Penerimaan Piutang',
  'report.cash_flow_projection_payable_payments': 'Pembayaran Tagihan/Utang',
  'report.cash_flow_projection_closing_balance': 'Proyeksi Saldo Akhir',
  'report.cash_flow_projection_opening_balance_date': 'Saldo awal per {date}',
  'report.cash_flow_projection_note':
    'Penerimaan dan pembayaran dihitung dari sisa tagihan yang belum dibayar sesuai tanggal jatuh temponya. Tagihan yang sudah lewat jatuh tempo dan pembayaran yang sudah terjadi di bulan berjalan tidak dihitung.',
  'report.total': 'Total',
  'report.total_this_page': 'Total Halaman Ini',
  'report.total_all_page': 'Total Seluruh Halaman',
  'report.customer_receivable_snapshot': 'Laporan Piutang Pelanggan',
  'report.payment_connect_kledo_transaction': 'Transaksi Payment Gateway Kledo',
  'report.customer_debt_snapshot': 'Laporan Hutang Vendor',
  'report.customer_receivable_snapshot_detail': 'Detail Laporan Piutang Pelanggan',
  'report.customer_debt_snapshot_detail': 'Detail Laporan Hutang Vendor',
  'report.customer_snapshot_amount': 'Jumlah',
  'report.customer_snapshot_outstanding': 'Sisa',
  'report.customer_snapshot_export_summary': 'Ringkasan',
  'report.customer_snapshot_export_detail': 'Ringkasan + Detail',
  'report.posted_on': 'Dibuat pada',
  'report.no_data': 'No Data',
  'report.journal_reporting': 'Jurnal',
  'report.journal_report': 'Jurnal',
  'report.journal': 'Jurnal',
  'report.account_transaction_reporting': 'Transaksi Akun',
  'report.bank_summary': 'Ringkasan Bank',
  'report.bank_account': 'Akun Bank',
  'report.cash_received': 'Uang Diterima',
  'report.cash_spent': 'Uang Dibelanjakan',
  'report.net_cash_flow': 'Arus Kas Bersih',
  'report.sales_tax': 'Pajak Penjualan',
  'report.net': 'Net',
  'report.tax': 'Pajak',
  'report.customer_invoice': 'Tagihan Pelanggan',
  'report.invoice_number': 'Nomor Tagihan',
  'report.customer_payment_recap': 'Rekap Pembayaran Pelanggan',
  'report.fee': 'Biaya',
  'report.payment_amount': 'Nilai Bayar',
  'report.note': 'Keterangan',
  'report.to': 'Sampai',
  'report.from': 'Dari',
  'report.due_date': 'Tgl. Jatuh Tempo',
  'report.date_and_time': 'Tanggal & waktu',
  'report.invoice_date': 'Tanggal Tagihan',
  'report.invoice_total': 'Total Tagihan',
  'report.dpp': 'DPP',
  'report.ppn': 'PPN',
  'report.paid': 'Dibayar',
  'report.due': 'Jatuh Tempo',
  'report.all': 'Semua',
  'report.ktp': 'KTP',
  'report.npwp': 'NPWP',
  'report.with_id_card': 'Dengan KTP',
  'report.without_id_card': 'Tanpa KTP',
  'report.with_tax_number': 'Dengan NPWP',
  'report.without_tax_number': 'Tanpa NPWP',
  'report.exclude_return': 'Tanpa Retur',
  'report.status': 'Status',
  'report.product_status': 'Status Produk',
  'report.active': 'Aktif',
  'report.income_per_customer': 'Pendapatan Per Pelanggan',
  'report.customer': 'Pelanggan',
  'report.income': 'Pendapatan',
  'report.total_paid': 'Total Dibayar',
  'report.total_unpaid': 'Total Belum Dibayar',
  'report.sales_per_product': 'Penjualan Per Produk',
  'report.order_per_product': 'Pemesanan Per Produk',
  'report.product_name': 'Nama Produk',
  'report.current_unit_price': 'Harga Saat Ini',
  'report.quantity_sold': 'Jumlah Terjual',
  'report.product_quantity_sold_not_sent_yet': 'Jumlah Produk Belum Dikirim',
  'report.quantity_bought': 'Jumlah Dibeli',
  'report.average': 'Rata-rata',
  'report.average_tooltip':
    'Rata-rata merupakan nilai rata-rata penjualan per {product}, yang dihitung dengan rumus Total ÷ Jumlah Terjual. Contoh: jika Total {total} dan Jumlah Terjual 3, maka nilai Rata-rata adalah {average}.',
  'report.purchases': 'Pembelian',
  'report.purchases_per_vendor': 'Pembelian Per Vendor',
  'report.purchases_per_product': 'Pembelian Per Produk',
  'report.expense_per_contact': 'Biaya per Kontak',
  'report.supplier': 'Vendor',
  'report.supplier_invoice': 'Tagihan Vendor',
  'report.purchase_value': 'Nilai Pembelian',
  'report.aged_receivable': 'Umur Piutang',
  'report.aged_receivable_not_yet_due': 'Belum Jatuh Tempo',
  'report.aged_receivable_aged_trans': 'Umur dari Transaksi',
  'report.aged_receivable_aged_due': 'Umur dari Jatuh Tempo',
  'report.aged_receivable_aged_trans_help':
    'Jumlah hari dari tanggal transaksi tagihan tertua sampai tanggal laporan.',
  'report.aged_receivable_aged_due_help':
    'Jumlah hari sejak jatuh tempo yang paling lama terlewati sampai tanggal laporan. Tagihan yang sudah lunas tidak ikut dihitung.',
  'report.aged_receivable_detail': 'Detil Umur Piutang',
  'report.aged_payable': 'Umur Hutang',
  'report.aged_payable_detail': 'Detil Umur Hutang',
  'report.expense_claim': 'Klaim Biaya',
  'report.expense_claim_detail': 'Detil Klaim Biaya',
  'report.trial_balance': 'Trial Balance',
  'report.profit_and_loss': 'Laba Rugi',
  'report.sales': 'Penjualan',
  'report.other_revenue': 'Penghasilan lain',
  'report.cost_of_sales': 'Beban Pokok Penjualan',
  'report.total_cost_of_sales': 'Total Beban Pokok Penjualan',
  'report.expenses': 'Biaya',
  'report.operating_expenses': 'Biaya Operasional',
  'report.total_operating_expenses': 'Total Biaya Operasional',
  'report.other_expenses': 'Biaya Lain-Lain',
  'report.gross_profit': 'Laba Kotor',
  'report.trading_income': 'Pendapatan',
  'report.total_trading_income': 'Total Pendapatan',
  'report.profitloss_comprehensive_income': 'Laba/Rugi Pendapatan Komprehensif',
  'report.profitloss_all_encompassing': 'Mencakup semua',
  'report.profitloss_one_of': 'Salah satu',
  'report.profitloss_filter_by_tags': 'Filter berdasarkan tag',
  'report.profitloss_filter_currency': 'Pilih Mata Uang',
  'report.profitloss_currency': 'Mata Uang',
  'report.total_comprehensive_income_this_period': 'Total Pendapatan Komprehensif Periode ini',
  'report.reports': 'Laporan',
  'report.financial': 'Finansial',
  'report.balance_sheet': 'Neraca',
  'report.compare': 'Bandingkan',
  'report.period': 'Periode',
  'report.cash_summary': 'Ringkasan Uang Tunai',
  'report.executive_summary': 'Ringkasan Eksekutif',
  'report.sales_tax_report': 'Pajak Penjualan',
  'report.accounting': 'Akuntansi',
  'report.aged_receivables': 'Umur Piutang',
  'report.customer_invoice_report': 'Tagihan Pelanggan',
  'report.aged_payables': 'Umur Hutang',
  'report.supplier_invoice_report': 'Tagihan Vendor',
  'report.purchases_per_supplier': 'Pembelian per Vendor',
  'report.cash_flow': 'Arus Kas',
  'report.net_cash_flows_from_': 'Arus kas bersih dari ',
  'report.direct_method': 'Metode Langsung',
  'report.indirect_method': 'Metode Tak Langsung',
  'report.please_select': 'Silakan Pilih',
  'report.cash_and_cash_equivalent': 'Kas dan Setara Kas',
  'report.cash_and_cash_equivalent_at_beginning_period': 'Kas dan setara kas di awal periode',
  'report.cash_and_cash_equivalent_at_end_period': 'Kas dan setara kas di akhir periode',
  'report.net_change_in_cash_for_period': 'Perubahan kas untuk periode',
  'report.net_cash_flows': 'Arus kas bersih',
  'report.equity_movement': 'Pergerakan Ekuitas',
  'report.beginning': 'Awal',
  'report.ending': 'Akhir',
  'report.net_movement': 'Pergerakan Bersih',
  'report.spend': 'Pengeluaran',
  'report.to_customer': 'Ke',
  'report.account_transactions': 'Transaksi Akun',
  'report.account_transactions_title': 'Transaksi {account}',
  'report.fixed_asset': 'Aset Tetap',
  'report.fixed_asset_detail': 'Detil Aset Tetap',
  'report.fixed_asset_summary': 'Ringkasan Aset Tetap',
  'report.fixed_asset_summary_purchase_date_from': 'Tanggal pembelian dari',
  'report.fixed_asset_summary_include_disposed': 'Sertakan aset yang sudah dilepas',
  'report.asset_name': 'Nama Aset',
  'report.number': 'Nomor',
  'report.purchase_date': 'Tanggal Pembelian',
  'report.purchase_price': 'Harga Pembelian',
  'report.depreciation': 'Penyusutan',
  'report.book_value': 'Nilai Buku',
  'report.witholding_tax': 'Pajak Pemotongan',
  'report.witholding': 'Potongan',
  'report.inventory': 'Inventori',
  'report.inventory_summary': 'Ringkasan Inventori',
  'report.inventory_stock_movement': 'Pergerakan Stok Inventori',
  'report.warehouse_stock_summary': 'Ringkasan Stok Gudang',
  'report.warehouse_stock_movement': 'Pergerakan Stok Gudang',
  'report.all_warehouses': 'Semua gudang',
  'report.product_conversion': 'Konversi {title}',
  'report.warehouse': 'Gudang',
  'report.export_warehouse_per_sheet_hint':
    'Tiap gudang yang dipilih akan diekspor menjadi sheet terpisah dalam satu file Excel. Rentang baris di bawah menghitung total semua gudang yang dipilih secara gabungan, bukan per gudang.',
  'report.export_per_range_note':
    'Data diunduh dalam beberapa file berisi maks 1.000 {title} per file.',
  'report.export_all_warehouses_label': 'Semua gudang',
  'report.category': 'Kategori',
  'report.stats_button': 'Statistik',
  'report.customer_purchase_stats': 'Statistik pola pembelian',
  'report.stats_period': 'Periode {date_from} – {date_to}',
  'report.stats_trans_range': 'Transaksi {first} – {last}',
  'report.stats_group_pattern': 'Pola pembelian',
  'report.stats_group_value': 'Nilai transaksi',
  'report.stats_frequency': 'Jumlah transaksi',
  'report.stats_average_interval_days': 'Rata-rata jeda (hari)',
  'report.stats_recency_days': 'Terakhir beli (hari lalu)',
  'report.stats_average_order_value': 'Rata-rata nilai transaksi',
  'report.stats_total_amount': 'Total nilai transaksi',
  'report.stats_empty': 'Belum ada transaksi pada periode ini',
  'report.stats_help_label_formula': 'Rumus',
  'report.stats_help_label_example': 'Contoh',
  'report.stats_help_label_note': 'Catatan',
  'report.stats_help_average_interval_days_desc':
    'Rata-rata berapa hari sekali pelanggan ini bertransaksi.',
  'report.stats_help_average_interval_days_formula':
    'Selisih hari transaksi pertama sampai terakhir ÷ (jumlah hari transaksi berbeda − 1)',
  'report.stats_help_average_interval_days_example':
    'Transaksi 1, 5, dan 11 Sep. Selisih 1 sampai 11 Sep = 10 hari, hari transaksi berbeda = 3. Jadi 10 ÷ (3 − 1) = 5 hari.',
  'report.stats_help_average_interval_days_note':
    'Dua invoice di hari yang sama dihitung satu hari transaksi. Kosong kalau pelanggan hanya bertransaksi di satu hari.',
  'report.stats_help_average_order_value_desc': 'Rata-rata nilai per satu invoice (AOV).',
  'report.stats_help_average_order_value_formula': 'Total nilai transaksi ÷ jumlah invoice',
  'report.stats_help_average_order_value_example':
    'Ada 2 invoice dengan total nilai transaksi Rp 1.000.000. Jadi 1.000.000 ÷ 2 = Rp 500.000.',
  'report.stats_help_average_order_value_note':
    'Total nilai transaksi yang dipakai sudah dikurangi retur. Kosong kalau tidak ada transaksi di periode ini.',
  'report.stats_help_total_amount_desc': 'Total belanja bersih pelanggan di periode ini.',
  'report.stats_help_total_amount_formula': 'Jumlah nilai semua invoice − jumlah semua retur',
  'report.stats_help_total_amount_example':
    'Invoice Rp 1.000.000 dan Rp 1.000.000, ada retur Rp 1.000.000. Jadi (1.000.000 + 1.000.000) − 1.000.000 = Rp 1.000.000.',
  'report.select_category': 'Pilih Kategori',
  'report.code': 'Kode',
  'report.qty': 'Kuantitas',
  'report.opening_qty': 'Kuantitas Awal',
  'report.qty_movement': 'Pergerakan Kuantitas',
  'report.closing_qty': 'Kuantitas Akhir',
  'report.balance_filtered_tooltip':
    'Saat filter jenis transaksi aktif, saldo awal dan akhir tetap menampilkan total riil seluruh transaksi, sedangkan kolom pergerakan hanya dihitung dari jenis transaksi terpilih. Karena itu saldo akhir tidak selalu sama dengan saldo awal + pergerakan.',
  'report.opening_value': 'Nilai Awal',
  'report.value_movement': 'Pergerakan Nilai',
  'report.value': 'Nilai',
  'report.closing_value': 'Nilai Akhir',
  'report.avg_cost': 'Harga Rata-rata',
  'report.avg_cost2': 'Harga Rata-Rata',
  'report.unit_price': 'Harga Satuan',
  'report.product_value': 'Nilai Produk',
  'report.product_stock': 'Stok Produk',
  'report.product': 'Produk',
  'report.until': 's/d',
  'report.budget': 'Anggaran',
  'report.actual': 'Aktual',
  'report.movement': 'Pergerakan',
  'report.price': 'Harga',
  'report.unpaid': 'Belum Dibayar',
  'report.grand_total': 'Grand Total',
  'report.delivery': 'Pengiriman',
  'report.please_input_name': 'Silakan masukkan nama',
  'report.start_period': 'Periode Mulai',
  'report.please_input_start_period': 'Silakan masukkan periode mulai',
  'report.no_of_period': 'Jumlah Periode',
  'report.last_period': 'Periode Sebelumnya',
  'report.last_n_period': '{count} Periode Terakhir',
  'report.cannot_save_budget': 'Tidak dapat menyimpan anggaran',
  'report.cannot_delete_budget': 'Tidak dapat menghapus anggaran',
  'report.interval': 'Interval',
  'report.apply': 'Terapkan',
  'report.delete_figures_this_column': 'Hapus semua angka dari kolom ini',
  'report.apply_figures_to_following_month': 'Terapkan angka dari bulan ini untuk bulan berikutnya',
  'report.adjust_figures_each_month_amount':
    'Sesuaikan angka tiap bulan berikutnya dengan jumlah ini',
  'report.adjust_figures_each_month_percent':
    'Sesuaikan angka tiap bulan berikutnya dengan persentase ini',
  'report.max_n_period_to_print': 'Maksimal {count} periode untuk dapat melakukan print',
  'report.total_income': 'Total Pendapatan',
  'report.operating_costs': 'Biaya Operasional',
  'report.net_profit': 'Laba Bersih',
  'report.search_by_product': 'Cari produk',
  'report.shipping_amount': 'Jumlah Pengiriman',
  'report.shipping_cost_total': 'Total Ongkos Kirim',
  'report.shipping_cost': 'Ongkos Kirim',
  'report.shipping_cost_per_expedition': 'Ongkos Kirim per Ekspedisi',
  'report.sales_per_sales_person': 'Penjualan per Sales Person',
  'report.production_report': 'Laporan Produksi',
  'report.finished_product': 'Produk Jadi',
  'report.transaction_total': 'Total Transaksi',
  'report.receivable_payable_contact': 'Hutang Piutang per Kontak',
  'report.sort_by': 'Urutkan',
  'subsidiaryLedger.without_contact': '(Tanpa Kontak)',
  'subsidiaryLedger.deleted': 'Dihapus',
  'subsidiaryLedger.total_note': 'TOTAL adalah saldo seluruh akun, tidak mengikuti filter kontak',
  'subsidiaryLedger.order_by': 'Arah urutan',
  'subsidiaryLedger.ascending': 'Menaik',
  'subsidiaryLedger.descending': 'Menurun',
  'report.invoice_payment': 'Pelunasan Pembayaran Tagihan',
  'report.purchase_invoice_payment': 'Pelunasan Pembayaran Tagihan Pembelian',
  'report.first_payment_date': 'Tanggal Pembayaran Pertama',
  'report.paid_date': 'Tanggal Pelunasan',
  'report.product_profitability': 'Profitabilitas Produk',
  'report.total_profit': 'Total Profit',
  'report.profit_margin': 'Profit Margin',
  'report.avg_sell_price': 'Harga Jual Rata-Rata',
  'report.hpp_per_unit': 'HPP Per Unit',
  'report.avg_cogs': 'HPP Rata - Rata',
  'report.stock_in': 'Stok Masuk',
  'report.stock_out': 'Stok Keluar',
  'report.product_purchase_per_supplier': 'Pembelian Product per Vendor',
  'report.total_quantity_product': 'Total kuantitas Produk',
  'report.total_price': 'Total Harga',
  'report.product_purchases_per_vendor': 'Pembelian Produk per Supplier',
  'report.vendor': 'Supplier',
  'report.include_unit_conversion': 'Tampilkan konversi unit',
  'report.hide_zero_qty': 'Sembunyikan qty yang kosong',
  'report.sales_per_product_category': 'Penjualan Per Kategori Produk',
  'report.favorite': 'Favorit',
  'report.remove_favorite': 'Hilangkan dari menu favorit',
  'report.add_favorite': 'Tambahkan menu ke menu favorit',
  'trialBalance.show_balance': 'Tampilkan Saldo',
  'attachment.file_name': 'Nama File',
  'attachment.search_by_file_name': 'Cari berdasarkan nama file',
  'reportsImport.amount_of_success_import': 'Jumlah impor yang berhasil',
  'reportsImport.detail': 'Detail Import',
  'reportsImport.status': 'Status Import',
  'reportsImport.failed_to_import': 'Gagal Import',
  'reportsImport.successful_import': 'Import sukses',
  'reportsImport.import_type': 'Tipe Import',
  'reportsImport.import_time': 'Waktu Import',
  'reportsImport.transaction_status': 'Status Transaksi',
  'reportsImport.download_file_import': 'Unduh berkas import',
  'reportsImport.download_file_error': 'Unduh berkas error',
  'reportsImport.sub_account_code': 'Kode Sub Akun (Parent)',
  'reportsImport.sub_account_name': 'Nama Sub Akun (Parent)',
  'reportsImport.imported_by': 'Diimpor oleh',
  'setup.demo_data_successfully_cleared': 'Data demo berhasil dihapus.',
  'setup.error_demo_data_failure_to_cleared_': 'Gagal hapus data demo.',
  'setup.demo_data_successfully_finished': 'Setup berhasil diselesaikan.',
  'setup.error_demo_data_failure_to_finished': 'Gagal menyelesaikan setup.',
  'setup.setup_clear_demo_data': 'Setup Hapus Demo Data',
  'setup.you_are_using_a_demo_of_kledo_at_the_moment':
    'Saat ini Anda sedang menggunakan demo kledo.',
  'setup.click_button_below_to_clear_the_test_data_and_start_setting_up_your_property':
    'Klik tombol di bawah untuk menghapus data demo dan mulai setup perusahaan Anda ',
  'setup.are_you_sure_that_you_want_to_clear_demo_': 'Anda yakin ingin menghapus demo?',
  'setup.this_will_remove_all_rooms_room_types_rates_and_bookings':
    'Ini akan menghapus semua data, dan tidak dapat dikembalikan.',
  'setup.clear_test_data_and_setup': 'Hapus data demo dan lakukan setup',
  'setup.clear_demo_data': 'Hapus data demo',
  'setup.delete_all_data_now': 'Hapus seluruh data sekarang',
  'setup.continue_deleting_data': 'Lanjut hapus data',
  'setup.1_waring':
    'Halaman setup ini akan hanya tampil pada admin dengan hak akses Administrator.',
  'setup.2_waring':
    'Halaman ini akan hilang secara otomatis 1 bulan setelah tanggal pendaftaran di Kledo.',
  'setup.finish': 'Selesai',
  'setup.finish_setup': 'Selesaikan setup',
  'setup.demo':
    'Data yang tampil saat ini adalah data dummy. Setelah Anda siap, {setup} untuk mengosongkan data.',
  'setup.demo_link': 'klik disini',
  'setup.trial': 'Akses free trial Anda akan berakhir {days} hari lagi. {setup}.',
  'setup.trial_one_day': 'Akses free trial Anda akan berakhir dalam {hour} jam lagi. {setup}.',
  'setup.trial_zero_days': 'Akses free trial Anda telah berakhir. {setup}.',
  'setup.subscription': 'Paket berlangganan Anda akan habis dalam {days} hari lagi. {setup}.',
  'setup.subscription_one_day':
    'Paket berlangganan Anda akan berakhir dalam {hour} jam lagi. {setup}.',
  'setup.subscription_zero_days': 'Paket berlangganan Anda telah berakhir. {setup}.',
  'setup.go_to_dashboard': 'Pergi ke dashboard',
  'setup.setup_complete':
    'Data demo telah dihapus dan setup selesai, sekarang kamu bisa mulai menggunakan Kledo.',
  'setup.input_your_cash_and_account_bank_name':
    'Masukkan nama kas & rekening bank perusahaan Anda',
  'setup.input_your_company_name': 'Masukkan data perusahaan Anda',
  'setup.company_logo': 'Logo Perusahaan',
  'setup.cash': 'Kas',
  'setup.bca_account': 'Rekening BCA',
  'setup.mandiri_account': 'Rekening Mandiri',
  'setup.please_input_bank_account_name_or_delete_this_field':
    'Isi nama akun bank atau hapus baris ini.',
  'accountMapping.account_mappinng': 'Pemetaan Akun',
  'users.hello_please_select_company_to_proceed':
    'Halo {name}, silakan pilih perusahaan untuk melanjutkan',
  'users.please_select_company_to_proceed': 'silakan pilih perusahaan untuk melanjutkan',
  'users.hello': 'Halo',
  'users.you_are_invited_to_join': 'Anda diundang untuk bergabung di',
  'users.do_you_agree_to_join': 'Apakah Anda bersedia bergabung di',
  'users.all_users': 'Semua user',
  'users.select_user': 'Pilih pengguna',
  'users.yes': 'Ya',
  'users.no': 'Tidak',
  'users.add_user': 'Tambah pengguna',
  'users.delete_user': 'Hapus pengguna',
  'users.only_displays_users_other_than_you': 'Hanya menampilkan pengguna selain Anda',
  'users.please_select_a_user': 'Silakan pilih pengguna.',
  'users.select_user_to_delete': 'Pilih Pengguna untuk Dihapus',
  'users.edit_user': 'Ubah Pengguna',
  'users.name': 'Nama Lengkap',
  'users.email': 'Email',
  'users.role': 'Peran di perusahaan sebagai',
  'users.roles': 'Peran',
  'users.resending': 'Kirim Ulang',
  'users.resending_help':
    'Untuk mengkonfirmasi, silahkan buka inbox email, dan klik link yang dikirim oleh Kledo.',
  'users.success_resending': 'Sukses Mengirim Undangan',
  'users.success_resending_desc':
    'Undangan berhasil dikirim ulang ke email {email}. Silahkan buka inbox email Anda, dan klik link yang telah dikirm oleh Kledo.',
  'users.waiting_for_confirmation': 'Menunggu Konfirmasi',
  'users.please_input_the_email_address': 'Silakan masukkan alamat email.',
  'users.max_100_characters': 'Maks 100 karakter.',
  'users.invalid_email_address_format': 'Format alamat email tidak valid.',
  'users.please_select_a_role': 'Silakan pilih peran.',
  'users.select_roles': 'Pilih peran',
  'users.pending_invitation': '(Undangan tertunda)',
  'users.user': 'Pengguna',
  'users.successfully_added': 'berhasil ditambahkan.',
  'users.error_cannot_add': 'Tidak bisa menambahkan',
  'users.user_successfully_updated': 'Pengguna berhasil diperbarui.',
  'users.error_cannot_update_user': 'Gagal memperbarui pengguna.',
  'users.successfully_deleted': 'berhasil dihapus.',
  'users.error_cannot_delete': 'Gagal menghapus',
  'users.search_by_name_or_email': 'Cari berdasarkan nama atau email',
  'users.restore_password': 'Pulihkan Password',
  'users.enter_the_email_address_associated_with_your_account_and_well_email_you_a_link_to_reset_your_password':
    'Masukkan alamat email yang dikaitkan dengan akun Anda, dan kami akan mengirimi Anda email tautan untuk mereset password Anda ',
  'users.back_to_login': 'Kembali untuk Login',
  'users.send_reset_link': 'Kirim Reset Link',
  'users.please_check_your_email_inbox_and_follow_the_instruction_to_reset_your_password_if_email_hasnt_received_please_check_the_bulk_and_spam_folder':
    'Silakan periksa kotak masuk email Anda dan ikuti instruksi untuk mereset password Anda. Jika email belum diterima, silakan periksa folder bulk dan spam ',
  'users.please_input_your_email': 'Silakan masukkan email Anda',
  'users.the_input_is_not_valid_email_': 'Silakan masukkan email yang valid.',
  'users.welcome_to_kledo': 'SELAMAT DATANG DI KLEDO ',
  'users.welcome_to2': 'Selamat datang di ',
  'users.phone': 'Telepon',
  'users.password': 'Password',
  'users.confirm_new_password': 'Konfirmasi password baru',
  'users.activate': 'Mengaktifkan',
  'users.invalid_invitation_token': 'Token undangan tidak valid',
  'users.your_invitation_token_is_invalid_please_check_it_again_and_reload_the_page':
    'Silakan periksa lagi dan muat ulang halaman',
  'users.please_fill_the_register_form': 'Silakan isi formulir pendaftaran',
  'users.please_input_your_email_address': 'Silakan masukkan alamat email Anda',
  'users.please_input_your_name': 'Silakan masukkan nama Anda',
  'users.please_input_your_phone': 'Silakan masukkan no ponsel Anda',
  'users.only_number_allowed': 'Hanya angka yang diizinkan.',
  'users.please_input_new_password': 'Silakan masukkan Password Baru',
  'users.min_8_characters': 'Minimal 8 karakter',
  'users.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit':
    'Password setidaknya 8 karakter, setidaknya 1 huruf besar dan setidaknya 1 digit.',
  'users.two_passwords_that_you_enter_is_inconsistent_':
    'Dua password yang Anda masukkan tidak konsisten.',
  'users.welcome_to': 'SELAMAT DATANG DI',
  'users.please_log_in': 'Silakan masuk',
  'users.you_have_logged_out_automatically':
    'Anda sudah terlogout secara otomatis, silahkan login kembali untuk melanjutkan.',
  'users.remember_me': 'Ingat saya',
  'users.forgot_password_': 'lupa password?',
  'users.login': 'Masuk',
  'users.login_with_google': 'Masuk dengan Google',
  'users.login_failed': 'Login Gagal',
  'users.go_back_to_home_page': 'Kembali ke halaman utama',
  'users.failed_to_connect_to_kledo': 'Gagal terhubung ke server Kledo',
  'users.please_check_your_internet_connection_please_contact_wa':
    'Mohon periksa koneksi internet Anda. Jika masih mengalami kendala, silakan menghubungi via Whatsapp ke 6285232300100',
  'network.no_internet_title': 'Tidak ada koneksi internet',
  'network.no_internet_description': 'Periksa kembali koneksi internet Anda, lalu tekan Coba Lagi.',
  'users.please_input_your_password': 'Silakan masukkan password Anda',
  'users.profile': 'Profil',
  'users.reset_password': 'Setel Ulang Password',
  'users.request_new_password_reset': 'Minta reset password lagi',
  'users.new_password': 'Password baru',
  'users.invalid_password_reset_token': 'Token tidak valid',
  'users.your_password_reset_token_is_invalid_please_check_it_again_and_reload_the_page':
    'Token atur ulang password Anda tidak valid, periksa lagi dan muat ulang halaman',
  'users.users': 'Pengguna',
  'users.information': 'Informasi',
  'users.information_invitation_email':
    'Email sudah dikirim ke {email}. Silakan minta kolega Anda untuk membuka email dan mengikuti instruksi berikutnya untuk mengaktifkan akun. Jika email tidak diterima, silahkan cek folder bulk dan folder spam.',
  'users.create_kledo_accounts': 'Buat Akun Kledo',
  'users.congratulation_': 'Selamat!',
  'users.registration_failed': 'Registrasi gagal',
  'users.your_kledo_account_successfully_created': 'Akun Kledo Anda berhasil dibuat.',
  'users.your_username_and_password_already_sent_to_your_email':
    'Nama pengguna dan kata sandi Anda sudah dikirim ke email Anda',
  'users.kledo_app_url': 'Alamat subdomain yang kamu inginkan',
  'users.kledo_app_url_is_required': 'Alamat subdomain Aplikasi Kledo diperlukan',
  'users.kledo_app_arl_must_be_at_least_3_characters':
    'Alamat subdomain Aplikasi Kledo minimal 3 karakter',
  'users.kledo_app_url_cannot_be_longer_than_20_characters':
    'Url Aplikasi Kledo tidak boleh lebih dari 20 karakter',
  'users.name_is_required': 'Nama harus diisi',
  'users.name_must_be_at_least_5_characters': 'Nama harus minimal 5 karakter',
  'users.name_cannot_be_longer_than_20_characters': 'Nama tidak boleh lebih dari 20 karakter',
  'users.property_name': 'Nama perusahaan',
  'users.property_name_is_required': 'Nama perusahaan wajib diisi',
  'users.property_name_must_be_at_least_5_characters': 'Nama perusahaan minimal 5 karakter',
  'users.property_name_cannot_be_longer_than_20_characters':
    'Nama perusahaan tidak boleh lebih dari 20 karakter',
  'users.role_is_required': 'Jabatan harus diisi',
  'users.role_must_be_at_least_3_characters': 'Jabatan minimal 3 karakter',
  'users.role_cannot_be_longer_than_20_characters': 'Jabatan tidak boleh lebih dari 20 karakter',
  'users.phone_number': 'Nomor telepon',
  'users.phone_number_is_required': 'Nomor Telepon harus diisi',
  'users.no_phone_number_worng': 'Nomor telepon salah',
  'users.phone_number_must_be_at_least_5_characters': 'Nomor Telepon minimal 5 karakter',
  'users.phone_number_cannot_be_longer_than_20_characters':
    'Nomor Telepon tidak boleh lebih dari 20 karakter',
  'users.email_is_required': 'Email harus diisi',
  'users.email_is_not_a_valid_email': 'Email bukan email yang valid',
  'users.register_now': 'Daftar sekarang',
  'users.login_now': 'Masuk sekarang',
  'users.domain_value_app_kledo_com_already_used_please_use_another_name':
    'Domain {value}.app.kledo.com sudah digunakan, silakan gunakan nama lain',
  'users.please_contact_hello_kledo_com_for_more_info':
    'Silakan hubungi hello@kledo.com untuk info lebih lanjut.',
  'users.registration_completed': 'Pendaftaran berhasil!',
  'users.password_has_been_sent_to_email_sms':
    'Password telah dikirim ke email dan sms mu, silakan cek ya',
  'users.click_here_to_set_roles': '{clickHere} untuk mengatur peran.',
  'report.point_of_sale': 'Point Of Sale',
  'report.net_sales_per_product_category': 'Net Penjualan per Kategori Produk',
  'report.product_category': 'Kategori Produk',
  'report.volume_per_product_category': 'Volume per KategoriProduk',
  'report.gross_sales': 'Gross Penjualan',
  'report.net_sales': 'Net Penjualan',
  'report.discount': 'Diskon',
  'report.gratuity': 'Gratuity',
  'report.collected': 'collected',
  'report.total_collected': 'Total Collected',
  'report.all_outlets': 'Semua',
  'report.payment': 'Pembayaran',
  'report.day_of_the_week_sales': 'Day Of The Week Penjualan',
  'report.sales_summary': 'Ringkasan Penjualan',
  'report.invoice': 'Invoice',
  'report.transactions': 'Transaksi',
  'posReport.reports_menu': 'Laporan',
  'posReport.omzet': 'Omzet',
  'posReport.all_outlets': 'Semua Outlet',
  'posReport.outlet': 'Outlet',
  'posReport.invoices': 'tagihan',
  'posReport.vs_previous': 'vs periode sebelumnya',
  'posReport.omzet_per_outlet': 'Omzet per Outlet',
  'posReport.outlet_unit': 'outlet',
  'posReport.summary': 'Ringkasan',
  'posReport.hourly_sales': 'Penjualan per Jam',
  'posReport.hourly_empty': 'Data penjualan per jam belum tersedia',
  'posReport.empty': 'Belum ada omzet pada periode ini',
  'posReport.peak': 'Puncak',
  'posReport.need_connection': 'Laporan membutuhkan koneksi internet',
  'posReport.preset.today': 'Hari ini',
  'posReport.preset.yesterday': 'Kemarin',
  'posReport.preset.7d': '7 Hari',
  'posReport.preset.this_month': 'Bulan Ini',
  'posReport.card.total_sales': 'Total Penjualan',
  'posReport.card.total_transactions': 'Total Transaksi',
  'posReport.card.total_products': 'Total Produk',
  'posReport.card.payment_received': 'Terima Pembayaran',
  'posReport.card.refund': 'Refund',
  'posReport.orders.title': 'Rincian Order & Invoice',
  'posReport.orders.order_open': 'Order Terbuka',
  'posReport.orders.invoice_unpaid': 'Belum Dibayar',
  'posReport.orders.invoice_paid': 'Lunas',
  'posReport.orders.remaining': 'Sisa',
  'posReport.orders.unit_order': 'order',
  'posReport.orders.unit_invoice': 'invoice',
  'report.transactions_type': 'Tipe Transaksi',
  'report.choose_transactions_type': 'Pilih tipe transaksi',
  'report.buy_sell_price': 'Harga Jual/Beli',
  'report.hpp': 'HPP',
  'report.avg_per_transaction': 'Avg. Net Sale Per Transactions',
  'report.name': 'Nama',
  'report.volume': 'Volume',
  'report.top_products': 'Top Produk',
  'report.pos': 'Pos',
  'report.pos_reports': 'Pos Reports',
  'report.outlets': 'Outlets',
  'financeAccounts.add_account': 'Tambah Akun',
  'financeAccounts.financeAccounts': 'Akun',
  'financeAccounts.all_accounts': 'Semua akun',
  'financeAccounts.select_category': 'Pilih kategori',
  'financeAccounts.category': 'Kategori',
  'financeAccounts.please_input_the_code': 'Silakan masukkan kode.',
  'financeAccounts.successfully_added': 'berhasil ditambahkan.',
  'financeAccounts.error_cannot_add': 'Tidak dapat menambah',
  'financeAccounts.error_cannot_update': 'Tidak dapat mengubah akun.',
  'financeAccounts.error_cannot_move': 'Tidak dapat memindah akun.',
  'financeAccounts.error_cannot_change_status': 'Tidak dapat mengubah status akun.',
  'financeAccounts.edit_account': 'Ubah Akun',
  'financeAccounts.please_input_the_account_name': 'Silakan masukkan nama akun.',
  'financeAccounts.account_name': 'Nama',
  'financeAccounts.account_name_note': 'Jika EN kosong, sistem otomatis menggunakan ID',
  'financeAccounts.copy_name': 'Salin nama akun',
  'financeAccounts.name_copied': 'Nama akun berhasil disalin',
  'financeAccounts.name_copy_failed': 'Gagal menyalin nama akun',
  'financeAccounts.show_archived': 'Tampilkan akun terarsip',
  'financeAccounts.archive_cascade_note': 'Seluruh sub-akun dari akun ini akan ikut diarsipkan.',
  'financeAccounts.unarchive_cascade_warning':
    'Seluruh sub-akun akun ini akan ikut dipulihkan, termasuk sub-akun yang sebelumnya diarsipkan sendiri. Status arsip masing-masing anak akan hilang secara permanen.',
  'financeAccounts.code': 'Kode',
  'financeAccounts.desc': 'Deskripsi',
  'financeAccounts.please_select_a_category': 'Silakan pilih kategori.',
  'financeAccounts.max_20_characters': 'Maks 20 karakter.',
  'financeAccounts.max_100_characters': 'Maks 100 karakter.',
  'financeAccounts.min_2_characters': 'Min 2 karakter.',
  'financeAccounts.balance': 'Saldo',
  'financeAccounts.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeAccounts.select_account': 'Pilih akun',
  'financeAccounts.set_conversion_balances': 'Saldo Awal',
  'financeAccounts.error_get_conversion_balances': 'Terjadi masalah cek konversi saldo',
  'financeAccounts.error_cannot_load_data': 'Tidak dapat mengambil data akun.',
  'financeAccounts.all_category': 'Semua kategori',
  'financeAccounts.error_cannot_delete': 'Tidak dapat menghapus akun.',
  'financeAccounts.error_cannot_search': 'Tidak dapat mencari akun.',
  'financeAccounts.set_manual_journal': 'Jurnal Umum',
  'financeAccounts.follow_these_steps_to_import_your_account':
    'Ikuti langkah-langkah berikut untuk meng-import akun',
  'financeAccounts.1_download_your_account_template_file': '1. Download file template akun',
  'financeAccounts.start_by_downloading_our_account_csv':
    'Mulai dengan mengunduh file template Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari akun-mu.',
  'financeAccounts.download_template_file': 'Download File Template',
  'financeAccounts.download_template_data_example_file': 'Download File Contoh',
  'financeAccounts.import': 'Import Akun',
  'financeAccounts.2_copy_your_account_into_the_template': '2. Salin detail akun ke dalam template',
  'financeAccounts.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail akun ke dalam file template dari Kledo. Pastikan detail akun sesuai dengan kolom header yang ada di template.',
  'financeAccounts.important': 'PENTING',
  'financeAccounts.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeAccounts.upload': 'Upload',
  'financeAccounts.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeAccounts.a_maximum_of_500_account_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel.',
  'financeAccounts.import_actions_only_insert_new_account_cannot_update_or_delete':
    'Saat meng-import, Kledo membuat akun baru. Jika opsi "Perbarui Duplikat Kode Akun" aktif, akun dengan kode yang sudah ada akan diperbarui; jika nonaktif, baris tersebut gagal. Tidak ada data yang dihapus.',
  'financeAccounts.update_duplicate_account_code': 'Perbarui Duplikat Kode Akun',
  'financeAccounts.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeAccounts.account_successfully_imported': '{rowCount} baris akun berhasil diimport.',
  'financeAccounts.go_to_account_list': 'Ke halaman daftar akun',
  'financeAccounts.sub_account_from': 'Sub Akun dari',
  'financeClosing.closing': 'Tutup Buku',
  'financeClosing.period': 'Periode',
  'financeClosing.note': 'Catatan',
  'financeClosing.profit_loss': 'Laba/Rugi',
  'financeClosing.choose_period': 'Pilih Periode',
  'financeClosing.set_worksheet': 'Set Kertas Kerja',
  'financeClosing.worksheet': 'Kertas Kerja',
  'financeClosing.done': 'Selesai',
  'financeClosing.please_select_period': 'Silakan pilih periode tutup buku',
  'financeClosing.please_select_date': 'Silakan pilih tanggal',
  'financeClosing.please_select_account': 'Silakan pilih akun',
  'financeClosing.closing_report': 'Laporan Tutup Buku',
  'financeClosing.closing_period_to_has_been_saved':
    'Tutup buku periode {from} s/d {to} berhasil disimpan',
  'financeClosing.period_from_to': 'Periode: {from} - {to}',
  'financeClosing.see_closing_report': 'Lihat Laporan Tutup Buku',
  'financeClosing.error_get_start_date': 'Tidak dapat mengambil tanggal awal',
  'financeClosing.error_get_closing_data': 'Tidak dapat mengambil data tutup buku',
  'financeClosing.error_create_closing_data': 'Tidak dapat membuat data tutup buku',
  'financeClosing.error_delete_closing_data': 'Tidak dapat menghapus data tutup buku',
  'financeClosing.debit': 'Debit',
  'financeClosing.credit': 'Kredit',
  'financeClosing.net_profit_loss': 'Laba Bersih',
  'financeClosing.tax_expense': 'Pajak Beban',
  'financeClosing.tax_expense_account': 'Akun Pajak Beban',
  'financeClosing.tax_payable_account': 'Akun Hutang Pajak',
  'financeClosing.tax_amount': 'Jumlah Pajak',
  'financeClosing.tax_percent': 'Persen Pajak',
  'financeClosing.net_profit_loss_after_tax': 'Laba Bersih Setelah Pajak',
  'financeClosing.retained_earnings_account': 'Akun Pendapatan Tertahan',
  'financeClosing.tax_cannot_be_negative': 'Tidak boleh minus',
  'financeClosing.tax_cannot_fill_when_loss': 'Pajak tidak dapat diisi ketika laba bersih minus',
  'financeClosing.early_period': 'Periode Awal',
  'financeContacts.paid_status': 'Status Dibayar',
  'financeContacts.transaction_number': 'Nomor Transaksi',
  'financeContacts.payment_note': 'Catatan Pembayaran',
  'financeContacts.payment_account_code': 'Kode Akun Pembarayan',
  'financeContacts.photo': 'Foto',
  'financeContacts.show_photo': 'Tampilkan Foto',
  'financeContacts.hide_photo': 'Sembunyikan Foto',
  'financeContacts.add_contact': 'Tambah Kontak',
  'financeContacts.financeContacts': 'Kontak',
  'financeContacts.contact_type': 'Tipe Kontak',
  'financeContacts.select_contact_type': 'Pilih tipe kontak',
  'financeContacts.successfully_added': 'berhasil ditambahkan.',
  'financeContacts.error_cannot_add': 'Tidak dapat menambah kontak.',
  'financeContacts.error_cannot_update': 'Tidak dapat mengubah kontak.',
  'financeContacts.edit_contact': 'Ubah Kontak',
  'financeContacts.please_input_the_contact_name': 'Silakan masukkan nama kontak.',
  'financeContacts.please_select_a_contact_type': 'Silakan pilih tipe kontak.',
  'financeContacts.please_select_a_required_contact_type': 'Tipe kontak {contacts} wajib dipilih.',
  'financeContacts.please_select_a_contact_type_with_minimal':
    'Silakan pilih tipe kontak, minimal 1 tipe kontak.',
  'financeContacts.contact_group': 'Grup Kontak',
  'financeContacts.please_select_a_contact_group': 'Silakan pilih grup kontak.',
  'financeContacts.contact_name': 'Nama',
  'financeContacts.all_contact_type': 'Semua tipe kontak',
  'financeContacts.max_characters': 'Maks {value} karakter.',
  'financeContacts.min_characters': 'Min {value} karakter.',
  'financeContacts.balance': 'Saldo',
  'financeContacts.address': 'Alamat',
  'financeContacts.email': 'Email',
  'financeContacts.add_email': 'Tambah Email',
  'financeContacts.npwp': 'NPWP',
  'financeContacts.invalid_email_address_format': 'Format email tidak valid.',
  'financeContacts.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeContacts.company': 'Perusahaan',
  'financeContacts.alternative_email': 'Email Alternatif',
  'financeContacts.email_cannot_be_the_same': 'Email tidak boleh sama',
  'financeContacts.phone': 'Telepon',
  'financeContacts.secondary_phone': 'Telepon sekunder',
  'financeContacts.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeContacts.error_cannot_search': 'Tidak dapat mencari kontak.',
  'financeContacts.group': 'Grup',
  'financeContacts.all_group': 'Semua Grup',
  'financeContacts.add_group': 'Tambah Grup',
  'financeContacts.edit_group': 'Ubah Grup',
  'financeContacts.delete_group': 'Hapus Group',
  'financeContacts.only_group_that_not_assigned_in_contact_could_be_deleted':
    'Catatan: Hanya grup yang belum mempunyai kontak yang dapat dihapus.',
  'financeContacts.billing_address': 'Alamat Penagihan',
  'financeContacts.shipping_address': 'Alamat Pengiriman',
  'financeContacts.account_mapping': 'Pemetaan Akun',
  'financeContacts.section.profile': 'Profil Kontak',
  'financeContacts.section.additional_contact': 'Detail Kontak Tambahan',
  'financeContacts.section.tax_legal': 'Identitas Pajak & Legalitas',
  'financeContacts.section.operating_hours': 'Jam Operasional',
  'financeContacts.section.custom_columns': 'Kolom Tambahan',
  'financeContacts.section.additional_info': 'Informasi Tambahan',
  'financeContacts.show_phone_detail': 'Tampilkan telepon detail',
  'financeContacts.hide_phone_detail': 'Sembunyikan telepon detail',
  'financeContacts.show_account_mapping': 'Tampilkan pemetaan akun',
  'financeContacts.hide_account_mapping': 'Sembunyikan pemetaan akun',
  'financeContacts.payable_account': 'Akun Hutang',
  'financeContacts.receivable_account': 'Akun Piutang',
  'financeContacts.transactions': 'Transaksi',
  'financeContacts.successfully_deleted': 'berhasil dihapus.',
  'financeContacts.error_cannot_delete': 'Tidak dapat menghapus grup kontak.',
  'financeContacts.error_cannot_add_group': 'Tidak dapat menambah grup kontak.',
  'financeContacts.error_cannot_update_group': 'Tidak dapat mengubah grup kontak.',
  'financeContacts.error_cannot_move': 'Tidak dapat memindah grup kontak.',
  'financeContacts.error_cannot_change_status': 'Tidak dapat mengubah status grup kontak.',
  'financeContacts.error_cannot_load_can_be_deleted_group':
    'Tidak dapat mengambil data grup kontak.',
  'financeContacts.follow_these_steps_to_import_your_contact':
    'Ikuti langkah-langkah berikut untuk meng-import kontak',
  'financeContacts.1_download_your_contact_template_file': '1. Download file template kontak',
  'financeContacts.start_by_downloading_our_contact_csv':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari kontak-mu.',
  'financeContacts.download_template_file': 'Download File Template',
  'financeContacts.download_template_data_example_file': 'Download File Contoh',
  'financeContacts.import': 'Import Kontak',
  'financeContacts.2_copy_your_contact_into_the_template':
    '2. Salin detail kontak ke dalam template',
  'financeContacts.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail kontak ke dalam file template dari Kledo. Pastikan detail kontak sesuai dengan kolom header yang ada di template.',
  'financeContacts.important': 'PENTING',
  'financeContacts.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeContacts.upload': 'Upload',
  'financeContacts.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeContacts.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeContacts.a_maximum_of_1000_contact_can_be_imported_at_a_time':
    'Maksimal 1.000 kontak dapat diimport dalam satu waktu.',
  'financeContacts.a_maximum_of_3000_contact_transactions_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel. Setiap baris dihitung, termasuk baris transaksi kontak maupun item.',
  'financeContacts.import_benefit_with_update':
    'Kamu juga dapat menggunakan file yang sudah diimport untuk mengupdate semua kontakmu, menghemat waktu dan tenaga daripada mengupdate kontak satu persatu melalui browser.',
  'financeContacts.warning_update_contact_using_import':
    'Proses import akan menggunakan Nama Kontak, Perusahaan, dan Tipe kontak untuk menentukan apakah suatu kontak sudah ada di Kledo atau belum, jika kontak sudah ada maka kontak akan diupdate, sedangkan jika kontak belum ada maka akan dibuat kontak baru. Kontak tidak akan dihapus, sehingga kamu bisa dengan aman mengupdate sebagian kontakmu saja tanpa khawatir akan kehilangan data dikontak yang lain.',
  'financeContacts.contact_successfully_imported': '{rowCount} baris kontak berhasil diimport.',
  'financeContacts.go_to_contact_list': 'Ke halaman daftar kontak',
  'financeContacts.mass_delete_info':
    '**Kontak  yang telah mempunyai transaksi tidak dapat dihapus, hanya bisa diarsipkan.',
  'financeContacts.want_to_use_this_contact': 'Apakah Anda akan menggunakan kontak ini ?',
  'financeContacts.are_you_sure_to_archive': 'Apakah Anda yakin untuk mengarsipkan kontak ini?',
  'financeContacts.are_you_sure_to_unarchive': 'Apakah Anda yakin untuk batalkan arsip kontak ini?',
  'financeContacts.your_net_debt': 'Net hutang Anda',
  'financeContacts.you_owe': 'Anda hutang',
  'financeContacts.they_owe': 'Mereka Hutang',
  'financeContacts.payment_received': 'Pembayaran diterima',
  'financeContacts.your_due_debt': 'Hutang Anda jatuh tempo',
  'financeContacts.their_due_debt': 'Hutang mereka jatuh tempo',
  'financeContacts.payment_sent': 'Pembayaran dikirim',
  'financeContacts.awaiting_payment': 'Piutang menunggu pembayaran',
  'financeContacts.debt_you_need_to_pay': 'Hutang yang perlu Anda bayar',
  'financeContacts.money_in_out': 'Keluar Masuk Uang',
  'financeContacts.money_in': 'Uang Masuk',
  'financeContacts.money_out': 'Uang keluar',
  'financeContacts.bank_accounts': 'Rekening Bank',
  'financeContacts.bank': 'Bank',
  'financeContacts.branch': 'Cabang',
  'financeContacts.holder_name': 'Nama Pemilik',
  'financeContacts.account_number': 'Nomor Rekening',
  'financeContacts.required': 'Harus diisi',
  'financeContacts.select_shipping_address': 'Pilih Alamat Pengiriman',
  'financeContacts.revert_to_default_address': 'Kembalikan ke alamat default',
  'financeContacts.max_payable': 'Maksimal Hutang',
  'financeContacts.total_payable_is_calculated_from_purchase_invoices':
    'Total hutang dihitung dari tagihan pembelian, transaksi biaya dan kontak hutang. Jika total hutang melebihi maksimal, maka saat membuat tagihan pembelian baru akan ditolak.',
  'financeContacts.max_receivable': 'Maksimal Piutang',
  'financeContacts.total_accounts_receivable_is_calculated_from_sales_invoices':
    'Total piutang dihitung dari tagihan penjualan dan kontak piutang. Jika total piutang melebihi maksimal, maka saat membuat tagihan penjualan baru akan ditolak.',
  'financeContacts.country': 'Negara',
  'financeContacts.province': 'Provinsi',
  'financeContacts.city': 'Kota',
  'financeContacts.district': 'Kecamatan',
  'financeContacts.village': 'Kelurahan',
  'financeContacts.postal_code': 'Kode Pos',
  'financeContacts.postal_code_invalid': 'Silakan masukkan kode pos yang valid (5 digit)',
  'financeContacts.latitude': 'Lintang',
  'financeContacts.latitude_invalid': 'Silakan masukkan lintang yang valid (-90 hingga 90)',
  'financeContacts.latitude_placeholder': 'contoh: -6.2088',
  'financeContacts.longitude': 'Bujur',
  'financeContacts.longitude_invalid': 'Silakan masukkan bujur yang valid (-180 hingga 180)',
  'financeContacts.longitude_placeholder': 'contoh: 106.8456',
  'financeContacts.id_card_type': 'Tipe Kartu Identitas',
  'financeContacts.id_card_number': 'ID Kartu Identitas',
  'financeContacts.please_select_id_card_type': 'Silahkan pilih tipe kartu identitas',
  'financeExpenseTerms.delete_expenseTerm': 'Hapus Termin',
  'financeExpenseTerms.are_you_sure_delete': 'Apakah Anda yakin untuk menghapus?',
  'financeExpenseTerms.select_expenseTerm': 'Pilih Termin',
  'financeExpenseTerms.please_select_expenseTerm_to_delete': 'Silakan pilih Termin untuk dihapus',
  'financeExpenseTerms.add_expenseTerm': 'Tambah Termin',
  'financeExpenseTerms.financeExpenseTerms': 'Termin',
  'financeExpenseTerms.successfully_deleted': 'berhasil dihapus.',
  'financeExpenseTerms.successfully_added': 'berhasil ditambahkan.',
  'financeExpenseTerms.error_cannot_delete': 'Tidak dapat menghapus termin.',
  'financeExpenseTerms.error_cannot_add': 'Tidak dapat menambah termin.',
  'financeExpenseTerms.error_cannot_update': 'Tidak dapat mengubah termin.',
  'financeExpenseTerms.error_cannot_move': 'Tidak dapat memindah termin.',
  'financeExpenseTerms.error_cannot_change_status': 'Tidak dapat mengubah status termin.',
  'financeExpenseTerms.edit_expenseTerm': 'Ubah Termin',
  'financeExpenseTerms.please_input_the_expenseTerm_name': 'Silakan masukkan nama termin.',
  'financeExpenseTerms.please_input_the_days': 'Silakan masukkan jumlah hari.',
  'financeExpenseTerms.expenseTerm_name': 'Nama',
  'financeExpenseTerms.length': 'Lama',
  'financeExpenseTerms.days': 'Hari',
  'financeExpenseTerms.max_characters': 'Maks {value} karakter.',
  'financeExpenseTerms.min_characters': 'Min {value} karakter.',
  'financeExpenseTerms.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeExpenseTerms.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeExpenseTerms.only_0_-_1000_allowed': 'Hanya 0 - 1000 diperkenankan',
  'financeExpenseTerms.only_0_-_10000_allowed': 'Hanya 0 - 10.000 diperkenankan',
  'financeExpenseTerms.must_have_active_termin': 'Harus ada minimal satu termin aktif.',
  'financeTaxes.add_tax': 'Tambah Pajak',
  'financeTaxes.financeTaxes': 'Pajak',
  'financeTaxes.successfully_added': 'berhasil ditambahkan.',
  'financeTaxes.error_cannot_add': 'Tidak dapat menambah pajak.',
  'financeTaxes.error_cannot_update': 'Tidak dapat mengubah pajak.',
  'financeTaxes.error_cannot_move': 'Tidak dapat memindah pajak.',
  'financeTaxes.error_cannot_change_status': 'Tidak dapat mengubah status pajak.',
  'financeTaxes.edit_tax': 'Ubah Pajak',
  'financeTaxes.please_input_the_tax_name': 'Silakan masukkan nama pajak.',
  'financeTaxes.please_input_the_effective_rates': 'Silakan masukkan persentase efektif.',
  'financeTaxes.please_select_a_sell_tax_account': 'Silakan pilih akun pajak penjualan.',
  'financeTaxes.please_select_a_buy_tax_account': 'Silakan pilih akun pajak pembelian.',
  'financeTaxes.select_buy_tax_account': 'Pilih akun pajak pembelian',
  'financeTaxes.select_sell_tax_account': 'Pilih akun pajak penjualan',
  'financeTaxes.tax_name': 'Nama',
  'financeTaxes.effective_rates': 'Persentase efektif',
  'financeTaxes.is_withholding': 'Pemotongan',
  'financeTaxes.buy_tax_account': 'Akun Pajak Pembelian',
  'financeTaxes.sell_tax_account': 'Akun Pajak Penjualan',
  'financeTaxes.max_characters': 'Maks {value} karakter.',
  'financeTaxes.min_characters': 'Min {value} karakter.',
  'financeTaxes.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeTaxes.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeTaxes.effective_rate_%': 'Persentase Efektif %',
  'financeTaxes.must_have_active_tax': 'Harus ada minimal satu pajak aktif.',
  'financeTaxes.witholding': 'Pemotongan',
  'financeTaxes.error_cannot_load_data_detail': 'Tidak dapat memuat data detail pajak.',
  'financeTaxes.delete_tax': 'Hapus Pajak',
  'financeTaxes.are_you_sure_delete': 'Apakah Anda yakin untuk menghapus?',
  'financeTaxes.select_tax': 'Pilih Pajak',
  'financeTaxes.please_select_tax_to_delete': 'Silakan pilih Pajak untuk dihapus',
  'financeTaxes.successfully_deleted': 'berhasil dihapus.',
  'financeTaxes.error_cannot_delete': 'Tidak dapat menghapus pajak.',
  'financeTaxes.manually_edit_tax_amount_allowed': 'Besaran rupiah pajak bisa diubah secara manual',
  'financeTaxes.allow_manual': 'Allow manual',
  'financeTaxes.compound': 'Majemuk',
  'financeTaxes.compound_help_text':
    'Pajak dilipatgandakan akan diterapkan terhadap total setelah pajak sebelumnya diterapkan. Dengan urutan pajak.',
  'financeTaxes.tax_type': 'Tipe Pajak',
  'financeTaxes.one': 'Satu',
  'financeTaxes.consist_of': 'Terdiri dari',
  'financeTaxes.consist_of_is_required': 'Minimal 1 pajak terpilih.',
  'financeTaxes.effective_percentage': 'Persentase Efektif',
  'financeTaxes.error_effective_percentage': 'Tidak dapat mendapatkan persentase efektif',
  'financeTaxes.tax_group': 'Grup Pajak',
  'financeUnits.error_cannot_move': 'Tidak dapat memindah satuan',
  'financeUnits.name': 'Nama',
  'financeUnits.max_characters': 'Maks {value} karakter.',
  'financeUnits.min_characters': 'Min {value} karakter.',
  'financeUnits.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeUnits.please_input_the_unit_name': 'Silakan masukkan nama satuan.',
  'financeUnits.error_cannot_add': 'Tidak dapat menambah satuan.',
  'financeUnits.error_cannot_update': 'Tidak dapat mengubah satuan.',
  'financeUnits.error_cannot_delete': 'Tidak dapat menghapus satuan.',
  'financeUnits.please_select_unit_to_delete': 'Silakan pilih Satuan untuk dihapus',
  'financeUnits.select_unit': 'Pilih Satuan',
  'financeUnits.unit': 'Satuan',
  'financeExpenses.add_expense': 'Tambah Biaya',
  'financeExpenses.financeExpenses': 'Biaya',
  'financeExpenses.successfully_added': 'berhasil ditambahkan.',
  'financeExpenses.error_cannot_add': 'Tidak dapat menambah biaya.',
  'financeExpenses.create_expense': 'Buat Biaya',
  'financeExpenses.related_invoice': 'Nomor Faktur',
  'financeExpenses.related_purchase_invoice': 'Nomor Tagihan Pembelian',
  'financeExpenses.related_transaction': 'Transaksi Terkait',
  'financeExpenses.error_cannot_update': 'Tidak dapat mengubah biaya.',
  'financeExpenses.error_cannot_move': 'Tidak dapat memindah biaya.',
  'financeExpenses.error_cannot_change_status': 'Tidak dapat mengubah status biaya.',
  'financeExpenses.edit_expense': 'Ubah Biaya',
  'financeExpenses.please_input_the_expense_name': 'Silakan masukkan nama biaya.',
  'financeExpenses.please_input_the_effective_rates': 'Silakan masukkan persentase efektif.',
  'financeExpenses.please_select_a_sell_expense_account': 'Silakan pilih akun biaya penjualan.',
  'financeExpenses.please_select_a_buy_expense_account': 'Silakan pilih akun biaya pembelian.',
  'financeExpenses.select_buy_expense_account': 'Pilih akun biaya pembelian',
  'financeExpenses.select_sell_expense_account': 'Pilih akun biaya penjualan',
  'financeExpenses.expense_name': 'Nama',
  'financeExpenses.effective_rates': 'Persentase Efektif',
  'financeExpenses.is_withholding': 'Pemotongan',
  'financeExpenses.buy_expense_account': 'Akun biaya pembelian',
  'financeExpenses.sell_expense_account': 'Akun biaya penjualan',
  'financeExpenses.max_characters': 'Maks {value} karakter.',
  'financeExpenses.min_characters': 'Min {value} karakter.',
  'financeExpenses.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeExpenses.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeExpenses.expense_account': 'Akun Biaya',
  'financeExpenses.select_expense_account': 'Pilih akun',
  'financeExpenses.description': 'Deskripsi',
  'financeExpenses.tax': 'Pajak',
  'financeExpenses.select_tax': 'Pilih pajak',
  'financeExpenses.amount': 'Total',
  'financeExpenses.pay_from': 'Dibayar Dari',
  'financeExpenses.please_select_a_pay_from': 'Silakan pilih dibayar dari',
  'financeExpenses.select_pay_from': 'Pilih dibayar dari',
  'financeExpenses.pay_later': 'Bayar Nanti',
  'financeExpenses.please_activate_pay_later': 'Aktifkan bayar nanti',
  'financeExpenses.benefeciary': 'Penerima',
  'financeExpenses.please_select_a_benefeciary': 'Silakan pilih penerima',
  'financeExpenses.select_benefeciary': 'Pilih penerima',
  'financeExpenses.add_contact': 'Tambah kontak',
  'financeExpenses.all_contacts': 'Semua kontak',
  'financeExpenses.contact_filter_show': 'Tampilkan',
  'financeExpenses.contact_filter_all': 'Semua',
  'financeExpenses.contact_filter_employee': 'Pegawai',
  'financeExpenses.contact_filter_vendor': 'Vendor',
  'financeExpenses.transaction_date': 'Tgl. Transaksi',
  'financeExpenses.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeExpenses.due_date': 'Tgl. Jatuh Tempo',
  'financeExpenses.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financeExpenses.term': 'Termin',
  'financeExpenses.select_term': 'Pilih termin',
  'financeExpenses.add_term': 'Tambah termin',
  'financeExpenses.price_include_tax': 'Harga termasuk pajak',
  'financeExpenses.add_more': 'Tambah baris',
  'financeExpenses.payment_method': 'Metode Pembayaran',
  'financeExpenses.please_select_a_payment_method': 'Silakan pilih metode pembayaran',
  'financeExpenses.select_payment_method': 'Pilih metode pembayaran',
  'financeExpenses.number': 'Nomor',
  'financeExpenses.please_input_the_number': 'Silakan isikan nomor.',
  'financeExpenses.memo': 'Reference',
  'financeExpenses.date': 'Tanggal',
  'financeExpenses.category': 'Kategori',
  'financeExpenses.status': 'Status',
  'financeExpenses.balance_due': 'Sisa Tagihan',
  'financeExpenses.total': 'Total',
  'financeExpenses.please_select_a_term': 'Silakan pilih termin.',
  'financeExpenses.search_by_memo': 'Cari',
  'financeExpenses.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financeExpenses.detail_title': 'Biaya - {status}',
  'financeExpenses.pay_bill': 'Bayar Tagihan',
  'financeExpenses.detail_expense': 'Detil Biaya',
  'financeExpenses.total_amount_must_greater_than_total_payment':
    'Total transaksi harus lebih besar atau sama dengan total pembayaran.',
  'financeExpenses.all': 'Semua',
  'financeExpenses.unpaid': 'Belum Dibayar',
  'financeExpenses.partial': 'Bayar Sebagian',
  'financeExpenses.closed': 'Closed',
  'financeExpenses.follow_these_steps_to_import_your_expenses':
    'Ikuti langkah berikut untuk mengimport biayamu',
  'financeExpenses.1_download_your_expenses_template_file': '1. Download file template biaya',
  'financeExpenses.start_by_downloading_our_expenses_csv':
    'Mulai dengan mengunduh file template Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari biaya-biayamu.',
  'financeExpenses.download_template_file': 'Download File Template',
  'financeExpenses.download_template_data_example_file': 'Download File Contoh',
  'financeExpenses.import': 'Import Biaya',
  'financeExpenses.2_copy_your_expenses_into_the_template':
    '2. Salin detail biaya ke dalam template',
  'financeExpenses.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail biaya ke dalam file template dari Kledo. Pastikan detail biaya sesuai dengan kolom header yang ada di template.',
  'financeExpenses.important': 'PENTING',
  'financeExpenses.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeExpenses.upload': 'Upload',
  'financeExpenses.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeExpenses.a_maximum_of_500_expenses_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel. Setiap baris dihitung, termasuk baris biaya maupun item.',
  'financeExpenses.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financeExpenses.import_actions_only_insert_new_expenses_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeExpenses.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeExpenses.you_can_only_upload_csv_file':
    'Anda hanya dapat mengunggah file csv atau excel.',
  'financeExpenses.upload_file': 'Upload File',
  'financeExpenses.check_the_imported_data': 'Cek Data',
  'financeExpenses.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financeExpenses.import_expenses_done': 'Import Berhasil',
  'financeExpenses.error_upload_file': 'Gagal mengunggah file.',
  'financeExpenses.file_not_found': 'File tidak ditemukan.',
  'financeExpenses.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financeExpenses.contact_name': 'Nama Kontak',
  'financeExpenses.email': 'Email',
  'financeExpenses.address': 'Alamat',
  'financeExpenses.phone': 'Phone',
  'financeExpenses.expense_date': 'Tanggal Biaya',
  'financeExpenses.expense_number': 'Nomor Biaya',
  'financeExpenses.reference': 'Reference',
  'financeExpenses.account_code': 'Kode Akun',
  'financeExpenses.tax_inclusive': 'Termasuk Pajak',
  'financeExpenses.paid': 'Lunas',
  'financeExpenses.paid_account': 'Akun Pembayaran',
  'financeExpenses.row_imported': '{imported} dari {total} baris diproses',
  'financeExpenses.expenses_successfully_imported': '{rowCount} biaya berhasil diimport.',
  'financeExpenses.view_detail': 'Tampilkan detil',
  'financeExpenses.import_another_file': 'Import file lain',
  'financeExpenses.go_to_expenses_list': 'Ke halaman daftar biaya',
  'financeExpenses.success': 'Berhasil',
  'financeExpenses.failed': 'Gagal',
  'financeExpenses.error_cannot_import': 'Gagal import.',
  'financeExpenses.error': 'Error',
  'financeExpenses.import_expenses_in_progress': 'Import in progress',
  'financeExpenses.import_expenses_is_still_in_progress': 'Import is still in progress',
  'financeExpenses.its_ok_to_close_this_page':
    'Tidak apa-apa untuk menutup halaman ini atau mengimport file lain. Ketika import selesai, Anda akan diberitahu melalui email.',
  'financePurchaseOrders.message': 'Pesan',
  'financePurchaseOrders.customer': 'Pelanggan',
  'financePurchaseOrders.show_message': 'Tampilkan Pesan',
  'financePurchaseOrders.hide_message': 'Sembunyikan Pesan',
  'financePurchaseOrders.show_attachment': 'Tampilkan Lampiran',
  'financePurchaseOrders.hide_attachment': 'Sembunyikan Lampiran',
  'financePurchaseOrders.account': 'Akun',
  'financePurchaseOrders.debit': 'Debit',
  'financePurchaseOrders.credit': 'Kredit',
  'financePurchaseOrders.journal_report': 'Laporan Jurnal',
  'financePurchaseOrders.add_purchaseorder': 'Tambah Pesanan Pembelian',
  'financePurchaseOrders.financePurchaseOrders': 'Pesanan Pembelian',
  'financePurchaseOrders.successfully_added': 'berhasil ditambahkan.',
  'financePurchaseOrders.error_cannot_add': 'Tidak dapat menambah pesanan pembelian.',
  'financePurchaseOrders.error_cannot_update': 'Tidak dapat mengubah pesanan pembelian.',
  'financePurchaseOrders.error_cannot_move': 'Tidak dapat memindah pesanan pembelian.',
  'financePurchaseOrders.error_cannot_print_pdf': 'Tidak dapat membuat pdf pesanan pembelian.',
  'financePurchaseOrders.error_cannot_change_status':
    'Tidak dapat mengubah status pesanan pembelian.',
  'financePurchaseOrders.edit_purchaseorder': 'Ubah Pesanan Pembelian',
  'financePurchaseOrders.max_characters': 'Maks {value} karakter.',
  'financePurchaseOrders.min_characters': 'Min {value} karakter.',
  'financePurchaseOrders.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financePurchaseOrders.description': 'Deskripsi',
  'financePurchaseOrders.tax': 'Pajak',
  'financePurchaseOrders.dpp': 'DPP',
  'financePurchaseOrders.select_tax': 'Pilih pajak',
  'financePurchaseOrders.amount': 'Total',
  'financePurchaseOrders.please_select_a_contact': 'Silakan pilih kontak',
  'financePurchaseOrders.select_contact': 'Pilih kontak',
  'financePurchaseOrders.add_contact': 'Tambah kontak',
  'financePurchaseOrders.all_contacts': 'Semua kontak',
  'financePurchaseOrders.transaction_date': 'Tgl. Transaksi',
  'financePurchaseOrders.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financePurchaseOrders.due_date': 'Tgl. Jatuh Tempo',
  'financePurchaseOrders.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financePurchaseOrders.term': 'Termin',
  'financePurchaseOrders.select_term': 'Pilih termin',
  'financePurchaseOrders.add_term': 'Tambah termin',
  'financePurchaseOrders.price_include_tax': 'Harga termasuk pajak',
  'financePurchaseOrders.auto_add_item': 'Tambah baris otomatis',
  'financePurchaseOrders.add_more': 'Tambah baris',
  'financePurchaseOrders.number': 'Nomor',
  'financePurchaseOrders.import_quote_number': 'Nomor Penawaran Pembelian',
  'financePurchaseOrders.please_input_the_number': 'Silakan isikan nomor.',
  'financePurchaseOrders.memo': 'Reference',
  'financePurchaseOrders.date': 'Tanggal',
  'financePurchaseOrders.status': 'Status',
  'financePurchaseOrders.balance_due': 'Sisa Tagihan',
  'financePurchaseOrders.total': 'Total',
  'financePurchaseOrders.please_select_a_term': 'Silakan pilih termin.',
  'financePurchaseOrders.search_by_memo': 'Cari',
  'financePurchaseOrders.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financePurchaseOrders.detail_title': 'Pesanan Pembelian {number}',
  'financePurchaseOrders.vendor': 'Vendor',
  'financePurchaseOrders.reference': 'Reference',
  'financePurchaseOrders.product': 'Produk',
  'financePurchaseOrders.qty': 'Kuantitas',
  'financePurchaseOrders.unit': 'Satuan',
  'financePurchaseOrders.price': 'Harga',
  'financePurchaseOrders.add_product': 'Tambah Produk',
  'financePurchaseOrders.select_product': 'Pilih produk',
  'financePurchaseOrders.attachments': 'Attachment',
  'financePurchaseOrders.save_&_approve': 'Simpan & setujui',
  'financePurchaseOrders.save_&_approve_add_new': 'Simpan & setujui & Tambah Baru',
  'financePurchaseOrders.save_as_draft': 'Simpan sbg draft',
  'financePurchaseOrders.save_as_draft_add_new': 'Simpan sbg draft & Tambah Baru',
  'financePurchaseOrders.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financePurchaseOrders.save_&_submit_for_approval_add_new':
    'Simpan & ajukan approval & Tambah Baru',
  'financePurchaseOrders.please_select_a_product': 'Silakan pilih produk.',
  'financePurchaseOrders.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financePurchaseOrders.please_input_the_price': 'Silakan masukkan harga.',
  'financePurchaseOrders.please_input_the_amount': 'Silakan masukkan total.',
  'financePurchaseOrders.approve': 'Setujui',
  'financePurchaseOrders.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financePurchaseOrders.submit_for_approval': 'Ajukan approval',
  'financePurchaseOrders.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financePurchaseOrders.create_invoice': 'Buat Tagihan',
  'financePurchaseOrders.must_greater_than_0': 'Harus lebih besar dari 0.',
  'financeProduct.product': 'Produk',
  'financeProduct.sell_or_purchase': 'Jual atau Beli',
  'financeProduct.for_sale': 'Dijual',
  'financeProduct.bought': 'Dibeli',
  'financeProduct.track_stock': 'Lacak Stok',
  'financeProduct.not_track_stock': 'Tidak Lacak Stok',
  'financePurchaseOrders.must_be_smaller_than_bill':
    'Total harus lebih kecil atau sama dengan total transaksi.',
  'financePurchaseInvoices.pay_with_credit_memo': 'Dibayar dengan Hutang',
  'financePurchaseInvoices.please_select_with_credit_memo': 'Silahkan pilih dibayar dengan hutang',
  'financePurchaseInvoices.pay_with_debit_memo': 'Dibayar dengan Piutang',
  'financePurchaseInvoices.please_select_with_debit_memo': 'Silahkan pilih dibayar dengan piutang',
  'financePurchaseOrders.follow_these_steps_to_import_your_purchase_orders':
    'Ikuti langkah berikut untuk mengimport pesanan pembelianmu',
  'financePurchaseOrders.1_download_your_purchase_orders_template_file':
    '1. Download file template pesanan pembelian',
  'financePurchaseOrders.start_by_downloading_our_purchase_orders_csv':
    'Mulai dengan mengunduh file template Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari pesanan pembelian-pesanan pembelianmu.',
  'financePurchaseOrders.download_template_file': 'Download File Template',
  'financePurchaseOrders.download_template_data_example_file': 'Download File Contoh',
  'financePurchaseOrders.import': 'Import Pesanan Pembelian',
  'financePurchaseOrders.2_copy_your_purchase_orders_into_the_template':
    '2. Salin detail pesanan pembelian ke dalam template',
  'financePurchaseOrders.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail pesanan pembelian ke dalam file template dari Kledo. Pastikan detail pesanan pembelian sesuai dengan kolom header yang ada di template.',
  'financePurchaseOrders.important': 'PENTING',
  'financePurchaseOrders.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financePurchaseOrders.upload': 'Upload',
  'financePurchaseOrders.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financePurchaseOrders.a_maximum_of_500_purchase_orders_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris pesanan pembelian maupun item.',
  'financePurchaseOrders.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financePurchaseOrders.import_actions_only_insert_new_purchase_orders_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financePurchaseOrders.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financePurchaseOrders.you_can_only_upload_csv_file':
    'Anda hanya dapat mengunggah file csv atau excel',
  'financePurchaseOrders.upload_file': 'Upload File',
  'financePurchaseOrders.check_the_imported_data': 'Cek Data',
  'financePurchaseOrders.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financePurchaseOrders.import_purchase_orders_done': 'Import Berhasil',
  'financePurchaseOrders.error_upload_file': 'Gagal mengunggah file.',
  'financePurchaseOrders.file_not_found': 'File tidak ditemukan.',
  'financePurchaseOrders.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financePurchaseOrders.valid': 'Valid',
  'financePurchaseOrders.invalid': 'Invalid',
  'financePurchaseOrders.import_now': 'Import Sekarang',
  'financePurchaseOrders.contact_name': 'Nama Kontak',
  'financePurchaseOrders.email': 'Email',
  'financePurchaseOrders.address': 'Alamat',
  'financePurchaseOrders.phone': 'Phone',
  'financePurchaseOrders.purchase_order_date': 'Tanggal Tagihan Pembelian',
  'financePurchaseOrders.purchase_order_number': 'Nomor Tagihan Pembelian',
  'financePurchaseOrders.product_name': 'Nama Produk',
  'financePurchaseOrders.code_sku': 'Kode/SKU',
  'financePurchaseOrders.tax_inclusive': 'Termasuk Pajak',
  'financePurchaseOrders.inventory_account': 'Akun Penyimpanan',
  'financePurchaseOrders.purchase_orders_successfully_imported':
    '{rowCount} pesanan pembelian berhasil diimport.',
  'financePurchaseOrders.view_detail': 'Tampilkan detil',
  'financePurchaseOrders.import_another_file': 'Import file lain',
  'financePurchaseOrders.go_to_purchase_order_list': 'Ke halaman daftar pesanan pembelian',
  'financePurchaseOrders.success': 'Berhasil',
  'financePurchaseOrders.failed': 'Gagal',
  'financePurchaseOrders.error_cannot_import': 'Gagal import.',
  'financePurchaseOrders.error': 'Error',
  'financePurchaseOrders.tax_manual': 'Pajak Manual',
  'financePurchaseOrders.tax_manual_must_less_than_amount':
    'Pajak harus kurang dari nilai transaksi.',
  'financePurchaseOrders.discount': 'Discount',
  'financePurchaseOrders.additional_discount': 'Tambahan Diskon',
  'financePurchaseOrders.discount_per_item': 'Diskon per item',
  'financePurchaseOrders.total_discount': 'Total Diskon',
  'financePurchaseOrders.total_cannot_be_negative': 'Nilai sisa tagihan tidak boleh minus.',
  'financePurchaseOrders.product_not_found': 'Produk tidak ditemukan',
  'financePurchaseOrders.product_has_been_added': 'Produk berhasil ditambahkan',
  'financePurchaseOrders.discount_per_quantity': 'Diskon per kuantitas',
  'financePurchaseOrders.discount_type': 'Jenis diskon',
  'salesCommission.sales_commission': 'Komisi Penjualan',
  'salesCommission.commission': 'Komisi',
  'salesCommission.commission_required': 'Komisi harus diisi',
  'salesCommission.commission_name': 'Nama Komisi',
  'salesCommission.commission_name_required': 'Nama komisi wajib diisi',
  'salesCommission.commission_amount_by': 'Besaran Komisi Bertingkat Berdasar',
  'salesCommission.commission_amount': 'Besaran Komisi Bertingkat',
  'salesCommission.target_amount': 'Target Omzet',
  'salesCommission.target_amount_required': 'Target Omzet wajib diisi',
  'salesCommission.min_transaction_per_month': 'Minimal transaksi per bulan',
  'salesCommission.min_transaction_per_month_required': 'Minimal transaksi harus diisi',
  'salesCommission.cannot_get_commission_type': 'Tidak dapat mengambil tipe komisi',
  'salesCommission.cannot_get_commission': 'Tidak dapat mengambil komisi',
  'salesCommission.sales_person_required': 'Sales person wajib diisi',
  'salesCommission.all_sales': 'Semua Sales',
  'salesCommission.not_due_only':
    'Komisi hanya untuk transaksi yang pelunasannya tidak melewati jatuh tempo',
  'salesCommission.not_due_only_desc':
    'Transaksi penjualan yang jatuh tempo tidak akan diperhitungkan sebagai komisi',
  'salesCommission.invalid_format_commission_amount': 'Jumlah Komisi format tidak valid.',
  'salesCommission.commission_is_only_for_transactions_that_have_been_paid':
    'Komisi hanya untuk transaksi yang telah dibayar',
  'salesCommission.commission_is_only_for_transactions_that_have_been_paid_desc':
    'Tagihan yang belum dibayar tidak diperhitungkan sebagai komisi.',
  'salesCommission.commission_type_id_help_text_1':
    'Jika berdasarkan "{commissionTypeName}", maka komisi dihitung berdasarkan jumlah transaksi penjualan tiap bulannya. Misalnya salah seorang sales membuat 5 invoice. Maka sales tersebut terhitung telah melakukan 5 transaksi.',
  'salesCommission.commission_type_id_help_text_2':
    'Jika berdasarkan "{commissionTypeName}", maka komisi dihitung berdasarkan nominal uang penjualan dalam rupiah. Misalnya seorang sales membuat 5 invoice, dengan total tagihan keseluruhan Rp 5 juta. Maka sales tersebut terhitung telah melakukan nominal penjualan Rp 5 jt.',
  'salesCommission.commission_type_id_help_text_3':
    'Jika berdasarkan "{commissionTypeName}", maka komisi dihitung berdasarkan jumlah kuantitas produk yang terjual. Misalnya seorang sales membuat 5 invoice, dimana masing-masing invoice menjual 100pcs produk. Maka sales tersebut terhitung telah menjual sebanyak 500pcs produk.',
  'salesCommission.commission_type_id_help_text_4':
    'Jika berdasarkan "{commissionTypeName}", maka komisi hanya dihitung dari selisih omzet yang melebihi target minimum, bukan dari total omzet. Misalnya target minimum Rp 1 juta dengan komisi 5%, kemudian pada bulan tersebut sales membukukan omzet Rp 1,2 juta. Maka komisi yang didapat adalah 5% x (Rp 1,2 juta - Rp 1 juta) = Rp 10 ribu. Jika omzet belum mencapai target, komisi yang didapat Rp 0.',
  'salesCommission.commission_type_id_help_text_5':
    'Jika berdasarkan "{commissionTypeName}", maka komisi dihitung berdasarkan nominal penjualan yang diakumulasi selama satu kuartal kalender (Jan-Mar, Apr-Jun, Jul-Sep, Okt-Des), bukan per bulan.',
  'priceRule.price_rule': 'Aturan Harga',
  'priceRule.rule_name': 'Nama Aturan',
  'priceRule.rule_name_required': 'Nama aturan wajib diisi',
  'priceRule.discount': 'Diskon',
  'priceRule.discount_required': 'Diskon wajib diisi',
  'priceRule.min_buy': 'Berlaku jika pelanggan membeli dengan:',
  'priceRule.min_qty': 'Minimal Kuantitas',
  'priceRule.min_qty_required': 'Minimal pembelian wajib diisi',
  'priceRule.min_qty_tooltip':
    'Berapa jumlah minimal produk yang dibeli pelanggan agar diskon berlaku?',
  'priceRule.min_qty_mode':
    'Hitung minimal kuantitas dari total gabungan semua produk (bukan per produk)',
  'priceRule.min_qty_mode_tooltip':
    'Jika dicentang, minimal kuantitas dihitung dari gabungan seluruh produk dalam satu transaksi (boleh mix produk berbeda), bukan per masing-masing produk. Diskon atau markup nominal (Rp) berlaku per unit untuk setiap produk yang memenuhi aturan, bukan sekali per transaksi.',
  'priceRule.min_qty_mode_tooltip_list':
    'Minimal kuantitas dihitung dari gabungan seluruh produk dalam satu transaksi (boleh mix produk berbeda), bukan per masing-masing produk.',
  'priceRule.min_qty_mode_label': 'Gabungan',
  'priceRule.min_qty_mode_product_required':
    'Pilih kategori atau {product} tertentu karena minimal kuantitas dihitung dari total gabungan.',
  'priceRule.customer_scope_desc':
    'Tentukan {customer} mana yang berhak mendapatkan aturan harga ini.',
  'priceRule.product_scope_desc': 'Tentukan {product} mana yang dikenai aturan harga ini.',
  'priceRule.outlet_scope_desc': 'Tentukan outlet POS mana yang menerapkan aturan harga ini.',
  'priceRule.ojol_scope_desc':
    'Tentukan layanan ojek online mana yang menerapkan aturan harga ini.',
  'priceRule.min_amount': 'Minimal Pembelian',
  'priceRule.min_amount_tooltip':
    'Berapa rupiah minimal pembelian pelanggan agar diskon berlaku? Dihitung dari total pembelian seluruh produk dalam satu invoice',
  'priceRule.effective_date': 'Tanggal Berlaku',
  'priceRule.forever': 'Selamanya',
  'priceRule.date': 'Tanggal',
  'priceRule.date_start': 'Tanggal Mulai',
  'priceRule.date_end': 'Tanggal Selesai',
  'priceRule.date_is_required': 'Tanggal wajib diisi',
  'priceRule.until': 'sampai',
  'priceRule.applies_to_the_following_customers': 'Berlaku Pada Pelanggan Berikut',
  'priceRule.customer': 'Pelanggan',
  'priceRule.all_customer': 'Semua Pelanggan',
  'priceRule.customer_group': 'Grup Pelanggan',
  'priceRule.customer_groups_that_will_get_discount': 'Grup pelanggan yang akan mendapatkan diskon',
  'priceRule.add_group': 'Tambah grup',
  'priceRule.select_group': 'Pilih grup',
  'priceRule.per_customer': 'Per Pelanggan',
  'priceRule.customers_that_will_get_discount': 'Pelanggan yang akan mendapatkan diskon',
  'priceRule.add_customer': 'Tambah pelanggan',
  'priceRule.name': 'Nama',
  'priceRule.company': 'Perusahaan',
  'priceRule.applies_to_the_following_products': 'Berlaku Pada Produk Berikut',
  'priceRule.product': 'Produk',
  'priceRule.all_product': 'Semua Produk',
  'priceRule.product_category': 'Kategori Produk',
  'priceRule.discounted_product_category': 'Kategori produk yang didiskon',
  'priceRule.add_category': 'Tambah kategori',
  'priceRule.per_product': 'Per Produk',
  'priceRule.discounted_product': 'Produk yang didiskon',
  'priceRule.add_product': 'Tambah produk',
  'priceRule.status': 'Status',
  'priceRule.active': 'Aktif',
  'priceRule.inactive': 'Tidak Aktif',
  'priceRule.rule_mode': 'Jenis Aturan',
  'priceRule.rule_mode_discount': 'Diskon',
  'priceRule.rule_mode_reward': 'Beli X Gratis Y',
  'priceRule.rule_mode_reward_short': 'Gratis Produk',
  'priceRule.reward_products': 'Produk Hadiah',
  'priceRule.reward_products_desc':
    'Tentukan {product} yang diberikan sebagai hadiah saat syarat pembelian terpenuhi. Diskon 100% berarti hadiah diberikan gratis.',
  'priceRule.discount_desc': 'Potongan atau kenaikan harga yang diterapkan ke {product} terpilih.',
  'priceRule.reward_mode_desc': 'Tentukan syarat pembelian, lalu {product} hadiah yang didapat.',
  'priceRule.tab_outlet_pos': 'Outlet POS',
  'priceRule.tab_summary_min_qty': 'min. {value} qty',
  'priceRule.tab_summary_min_amount': 'min. {value}',
  'priceRule.tab_summary_rewards': '{count} produk hadiah',
  'priceRule.tab_summary_selected': '{count} dipilih',
  'priceRule.tab_summary_not_selected': 'belum dipilih',
  'priceRule.reward_product_required': 'Pilih produk hadiah',
  'priceRule.reward_products_min_one': 'Minimal 1 produk hadiah',
  'priceRule.duplicate_reward_product': 'Produk hadiah tidak boleh duplikat',
  'priceRule.reward_discount': 'Diskon Hadiah',
  'priceRule.reward_max_qty_per_product': 'Maks. Qty',
  'priceRule.reward_max_qty': 'Maks. Total Hadiah per Transaksi',
  'priceRule.reward_max_qty_tooltip':
    'Batas gabungan jumlah seluruh produk hadiah dalam satu transaksi.',
  'priceRule.is_repeatable': 'Berlaku Kelipatan',
  'priceRule.is_repeatable_tooltip':
    'Jika dicentang, hadiah dikalikan setiap kelipatan minimal pembelian terpenuhi. Contoh: beli 2 gratis 1, maka beli 4 gratis 2.',
  'priceRule.free': 'Gratis',
  'priceRule.free_n_products': 'Gratis {n} produk',
  'priceRule.select_price_rule': 'Pilih aturan harga',
  'priceRule.to_use_the_pricing_rules_please_first_activate_the_sales_discount_option':
    'Untuk menggunakan aturan harga, silakan aktifkan terlebih dahulu opsi Diskon Penjualan dari menu Pengaturan Alur Bisnis.',
  'financeProduct.cannot_delete_current_photo': 'Tidak bisa menghapus foto ini.',
  'financeProduct.search_in': 'Cari di',
  'financeProduct.available': 'Tersedia',
  'financeProduct.almost_empty': 'Hampir Habis',
  'financeProduct.empty': 'Habis',
  'lowStock.attention_title': 'Ada produk yang perlu perhatian',
  'lowStock.summary_almost_empty': '{count} produk hampir habis stok',
  'lowStock.summary_empty': '{count} produk stok habis',
  'lowStock.chip_empty': 'Stok habis',
  'lowStock.view_detail': 'Lihat detail',
  'lowStock.view': 'Lihat',
  'lowStock.drawer_title': 'Produk perlu perhatian',
  'lowStock.drawer_subtitle': '{total} produk perlu ditindaklanjuti — data per hari ini',
  'lowStock.min_stock': 'Min. stok',
  'lowStock.see_all_products': 'Lihat semua di menu Produk',
  'lowStock.no_data': 'Tidak ada data',
  'lowStock.search_placeholder': 'Cari nama atau kode produk',
  'lowStock.no_search_result': 'Tidak ada produk yang cocok dengan “{search}”',
  'lowStock.showing_count': 'Menampilkan {shown} dari {total} produk',
  'reportLowStock.search_placeholder': 'Cari nama atau kode produk',
  'reportLowStock.filter_all': 'Semua',
  'reportLowStock.filter_empty': 'Habis',
  'reportLowStock.filter_almost_empty': 'Hampir Habis',
  'reportLowStock.column_unit': 'Satuan',
  'reportLowStock.column_qty': 'Stok Saat Ini',
  'reportLowStock.column_buffer_qty': 'Batas Minimum',
  'reportLowStock.column_shortage': 'Kekurangan',
  'reportLowStock.column_status': 'Status',
  'reportLowStock.status_empty': 'Habis',
  'reportLowStock.status_almost_empty': 'Hampir Habis',
  'reportLowStock.summary_empty': 'Produk Habis',
  'reportLowStock.summary_almost_empty': 'Produk Hampir Habis',
  'reportLowStock.summary_total': 'Total Produk Low Stock',
  'reportLowStock.summary_shortage': 'Total Kekurangan',
  'reportWarehouseProductQuota.search_placeholder': 'Cari nama atau kode produk',
  'reportWarehouseProductQuota.filter_all': 'Semua',
  'reportWarehouseProductQuota.filter_unfulfilled': 'Belum Terpenuhi',
  'reportWarehouseProductQuota.filter_fulfilled': 'Terpenuhi',
  'reportWarehouseProductQuota.filter_over': 'Melebihi Kuota',
  'reportWarehouseProductQuota.column_unit': 'Satuan',
  'reportWarehouseProductQuota.column_warehouse': 'Gudang',
  'reportWarehouseProductQuota.column_quota': 'Kuota',
  'reportWarehouseProductQuota.column_qty': 'Stok Saat Ini',
  'reportWarehouseProductQuota.column_fulfillment': 'Pemenuhan',
  'reportWarehouseProductQuota.column_shortage': 'Kekurangan',
  'reportWarehouseProductQuota.column_status': 'Status',
  'reportWarehouseProductQuota.status_unfulfilled': 'Belum Terpenuhi',
  'reportWarehouseProductQuota.status_fulfilled': 'Terpenuhi',
  'reportWarehouseProductQuota.status_over': 'Melebihi Kuota',
  'reportWarehouseProductQuota.summary_unfulfilled': 'Produk Belum Terpenuhi',
  'reportWarehouseProductQuota.summary_fulfilled': 'Produk Terpenuhi',
  'reportWarehouseProductQuota.summary_shortage': 'Total Kekurangan',
  'financeProduct.stock_per_category': 'Stok per Kategori',
  'financeProduct.warehouse_location': 'Lokasi Gudang',
  'financeProduct.total_stock': 'Total Stok',
  'financeProduct.total_avg_base_price': 'Total HPP',
  'financeProduct.total_sales': 'Total Penjualan',
  'financeProduct.total_purchase': 'Total Pembelian',
  'financeProduct.detail_product': 'Detil Produk',
  'financeProduct.code_sku_tooltip':
    'Kode SKU (Stock Keeping Unit) adalah kode unik tiap produk. Kode akan tergenerate secara otomatis, atau Anda bisa juga mengubahnya.',
  'financeProduct.row': 'Baris',
  'financeProduct.conversion_detail_title': 'Konversi Produk {number}',
  'financeProduct.category': 'Kategori',
  'financeProduct.avg_base_price': 'HPP',
  'financeProduct.all_stock': 'Semua stok',
  'financeProduct.all_products': 'Semua produk',
  'financeProduct.product_name': 'Nama Produk',
  'financeProduct.code_sku': 'Kode/SKU',
  'financeProduct.cost_price': 'Harga Beli',
  'financeProduct.purchase_price_must_not_exceed_sale_price':
    'Harga beli tidak boleh lebih tinggi dari harga jual.',
  'financeProduct.sale_price': 'Harga Jual',
  'financeProduct.min_sell_price': 'Harga Jual Minimum',
  'financeProduct.price_must_not_below_min_sell_price': 'Harga jual minimum {value}',
  'financeProduct.quantity': 'Kuantitas',
  'financeProduct.products_and_services': 'Produk dan Layanan',
  'financeProduct.add_category': 'Tambah Kategori',
  'financeProduct.sub_category': 'Sub Kategori',
  'financeProduct.name_category_required': 'Nama kategori wajib diisi',
  'financeProduct.name_category_must_be_at_least_2_characters': 'nama kategori minimal 2 karakter',
  'financeProduct.edit_category': 'Ubah Kategori',
  'financeProduct.edit_product': 'Ubah Produk',
  'financeProduct.edit_product_title': 'Ubah produk {name}',
  'financeProduct.image': 'Gambar',
  'financeProduct.choose_category': 'Pilih Kategori',
  'financeProduct.choose_category_required': 'Silakan pilih kategori',
  'financeProduct.additional_category': 'Kategori Tambahan',
  'financeProduct.choose_additional_category': 'Pilih kategori tambahan',
  'financeProduct.product_name_required': 'Nama produk wajib diisi',
  'financeProduct.product_name_must_be_at_least_2_characters': 'Nama produk minimal 2 karakter',
  'financeProduct.product_name_max_400_characters': 'Nama produk maksimal 400 karakter',
  'financeProduct.code_sku_must_be_at_least_2_characters': 'Kode/SKU minimal 2 karakter',
  'financeProduct.i_purchase_this_item': 'Saya membeli item ini',
  'financeProduct.price': 'Harga',
  'financeProduct.per': 'per',
  'financeProduct.sell_currency_can_differ': 'Boleh berbeda dari mata uang harga beli',
  'financeProduct.currency_follow_sell_price':
    'Mata uang mengikuti harga jual — bukan pilihan terpisah',
  'financeProduct.average_price_base_currency_hint':
    'Nilai persediaan selalu memakai mata uang dasar tenant, tidak ikut mata uang produk.',
  'financeProduct.price_rule_nominal_base_currency_hint':
    'Nilai nominal ditulis dalam mata uang dasar. Untuk produk bermata uang lain, nilai ini otomatis dikonversi memakai kurs tanggal transaksi.',
  'financeProduct.purchase_currency': 'Mata Uang Harga Beli',
  'financeProduct.sell_currency': 'Mata Uang Harga Jual',
  'financeProduct.price_after_discount_tooltip':
    'Harga yang tercantum adalah harga setelah dikurangi diskon',
  'financeProduct.price_required': 'Harga wajib diisi',
  'financeProduct.extra_price_must_greather_than_ziro': 'Harga harus lebih besar dari 0.',
  'financeProduct.account': 'Akun',
  'financeProduct.select_account': 'Pilih Akun',
  'financeProduct.tax': 'Pajak',
  'financeProduct.choose_tax_required': 'Pajak harus diisi',
  'financeProduct.select_tax_rate': 'Pilih Pajak',
  'financeProduct.i_sell_this_item': 'Saya menjual item ini',
  'financeProduct.i_track_this_item': 'Saya melacak inventori item ini',
  'financeProduct.this_treats_your_item_as_a_tracked_inventory':
    'Ini akan mencatat stok item Anda.',
  'financeProduct.date': 'Tanggal',
  'financeProduct.add_adjustment': 'Tambah Penyesuaian',
  'financeProduct.quantity_on_hand': 'Stok di tangan',
  'financeProduct.total_value': 'Nilai Total',
  'financeProduct.purchase': 'Pembelian',
  'financeProduct.tax_rate': 'Pajak',
  'financeProduct.sales': 'Penjualan',
  'financeProduct.inventory': 'Inventori',
  'financeProduct.inventory_asset_account': 'Akun Aset Inventori',
  'financeProduct.total': 'Total',
  'financeProduct.decrease_quantity': 'Kurangi stok',
  'financeProduct.revolution': 'Revolusi',
  'financeProduct.new_adjustment': 'Penyesuaian Stok',
  'financeProduct.adjustment_type': 'Tipe Penyesuaian',
  'financeProduct.adjustment_type_required': 'tipe penyesuaian wajib diisi',
  'financeProduct.select_adjustment_type': 'Pilih Penyesuaian Tipe',
  'financeProduct.date_required': 'tanggal wajib diisi',
  'financeProduct.current_qty': 'Jumlah stok sekarang',
  'financeProduct.qty_required': 'jumlah stok wajib diisi',
  'financeProduct.avg_cost': 'Harga rata-rata',
  'financeProduct.avg_cost_required': 'harga rata-rata wajib diisi',
  'financeProduct.total_value_required': 'nilai total wajib diisi',
  'financeProduct.adjustment': 'Penyesuaian',
  'financeProduct.adjustment_required': 'penyesuaian wajib diisi',
  'financeProduct.cost_price_required': 'harga wajib diisi',
  'financeProduct.new_qty_on_hand': 'Stok ditangan baru',
  'financeProduct.new_qty_on_hand_required': 'stok ditangan baru wajib diisi',
  'financeProduct.choose_account_required': 'akun wajib diisi',
  'financeProduct.note': 'Catatan',
  'financeProduct.note_required': 'catatan wajib diisi',
  'financePurchaseOrders.detail_purchaseorder': 'Detil Pesanan Pembelian',
  'financeProduct.error_cannot_add': 'Tidak dapat menambahkan produk.',
  'financeProduct.error_cannot_export': 'Tidak dapat ekspor produk',
  'financeProduct.error_cannot_add_categorie': 'Tidak dapat menambahkan kategori produk.',
  'financeProduct.recent_transactions': 'Transaksi Terkini',
  'financeProduct.manufacture': 'Manufaktur',
  'financeProduct.package': 'Paket',
  'financeProduct.conversion': 'Konversi',
  'financeProduct.conversion_description': 'Keterangan',
  'financeProduct.follow_these_steps_to_import_your_products':
    'Ikuti langkah berikut untuk mengimport produk-produkmu',
  'financeProduct.follow_these_steps_to_import_your_conversion_units':
    'Ikuti langkah berikut untuk mengimport konversi satuanmu',
  'financeProduct.1_download_your_products_template_file': '1. Download file template produk',
  'financeProduct.1_download_your_conversion_units_template_file':
    '1. Download file template konversi satuan',
  'financeProduct.start_by_downloading_our_products_csv':
    'Mulai dengan mendownload file template produk dalam format Excel. Format ini mempunyai format header yang dibutuhkankledo untuk mengimport detail produkmu.',
  'financeProduct.start_by_downloading_our_conversion_units_csv':
    'Mulai dengan mendownload file template konversi satuan dalam format Excel. Format ini mempunyai format header yang dibutuhkan Kledo untuk mengimport detail konversi satuanmu.',
  'financeProduct.download_template_file': 'Download File Template',
  'financeProduct.download_template_data_example_file': 'Download File Contoh Data',
  'financeProduct.import': 'Import Produk',
  'financeProduct.2_copy_your_products_into_the_template': '2. Salin produkmu ke dalam template',
  'financeProduct.2_copy_your_conversion_units_into_the_template':
    '2. Salin konversi satuanmu ke dalam template',
  'financeProduct.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau program spreadsheet lainnya, masukkan detail produkmu ke dalam file template. Pastikan detail produk sesuai dengan header kolom yang ada di template.',
  'financeProduct.using_excel_or_another_spreadsheet_editor_conversion_unit':
    'Menggunakan Excel atau program spreadsheet lainnya, masukkan detail konversi satuanmu ke dalam file template. Pastikan detail konversi satuan sesuai dengan header kolom yang ada di template.',
  'financeProduct.important': 'PENTING',
  'financeProduct.3_upload_the_updated_template_file_here':
    '3. Upload file template yang telah diupdate di sini',
  'financeProduct.upload': 'Upload',
  'financeProduct.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan template yang sudah diupdate',
  'financeProduct.a_maximum_of_1000_products_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel.',
  'financeProduct.a_maximum_of_1000_product_packages_can_be_imported_at_a_time':
    'Maksimum 1.000 produk dapat diimpot dalam satu waktu.',
  'financeProduct.a_maximum_of_1000_product_conversions_can_be_imported_at_a_time':
    'Maksimum 1.000 produk dapat diimpot dalam satu waktu.',
  'financeProduct.a_maximum_of_1000_product_manufactures_can_be_imported_at_a_time':
    'Maksimum 1.000 produk dapat diimpot dalam satu waktu.',
  'financeProduct.a_maximum_of_1000_conversion_units_can_be_imported_at_a_time':
    'Maksimum 1000 konversi satuan dapat diimport dalam satu waktu.',
  'financeProduct.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom dalam file template. Ini dibutuhkan Kledo untuk proses import pada langkah berikutnya. Kamu juga dapat menggunakan file yang sudah diimport untuk mengupdate semua produk-produkmu, menghemat waktu dan tenaga daripada mengupdate produk satu persatu melalui browser. Proses import akan menggunakan Kode/SKU produk untuk menentukan apakah suatu produk sudah ada di Kledo atau belum, jika produk sudah ada maka produk akan diupdate, sedangkan jika produk belum ada maka akan dibuat produk baru. Produk tidak akan dihapus, sehingga kamu bisa dengan aman mengupdate sebagian produkmu saja tanpa khawatir akan kehilangan data diproduk yang lain.',
  'financeProduct.dont_change_the_column_heading_in_the_template_file_conversion_unit':
    'Jangan mengubah header kolom dalam file template. Ini dibutuhkan Kledo untuk proses import pada langkah berikutnya.',
  'financeProduct.you_can_only_upload_csv_file': 'Anda hanya dapat mengunggah file csv atau excel',
  'financeProduct.upload_file': 'Upload File',
  'financeProduct.check_the_imported_data': 'Cek Data',
  'financeProduct.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financeProduct.import_product_done': 'Import Berhasil',
  'financeProduct.import_conversion_unit_done': 'Import Konversi Satuan Berhasil',
  'financeProduct.conversion_units_successfully_imported':
    '{rowCount} konversi satuan berhasil diimport.',
  'financeProduct.error_upload_file': 'Gagal mengunggah file.',
  'financeProduct.file_not_found': 'File tidak ditemukan.',
  'financeProduct.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang kamu upload sudah sesuai dengan yang diinginkan, silakan klik tombol "Import Sekarang".',
  'financeProduct.valid': 'Valid',
  'financeProduct.invalid': 'Invalid',
  'financeProduct.import_now': 'Import Sekarang',
  'financeProduct.status': 'Status',
  'financeProduct.name': 'Nama',
  'productPopover.type_regular': 'Produk Reguler',
  'productPopover.type_package': 'Produk Paket',
  'productPopover.type_manufacture': 'Produk Manufaktur',
  'productPopover.stock': 'Stok',
  'productPopover.unit': 'Satuan',
  'productPopover.used_in_packages': 'Bahan paket dari',
  'productPopover.used_in_manufactures': 'Bahan baku dari',
  'productPopover.variant_of': 'Produk turunan dari',
  'productPopover.package_contents': 'Isi paket',
  'productPopover.manufacture_materials': 'Bahan baku',
  'productPopover.variant_children': 'Produk turunan',
  'productPopover.product': 'Produk',
  'productPopover.qty': 'Kuantitas',
  'productPopover.category': 'Kategori',
  'productPopover.unit_conversion': 'Konversi satuan',
  'warehousePopover.code': 'Kode',
  'warehousePopover.total_stock': 'Total Stok',
  'accountPopover.category': 'Kategori',
  'accountPopover.balance': 'Saldo',
  'journalPopover.account': 'Akun',
  'journalPopover.debit': 'Debit',
  'journalPopover.credit': 'Kredit',
  'journalPopover.total': 'Total',
  'fixedAssetPopover.date': 'Tanggal',
  'fixedAssetPopover.memo': 'Keterangan',
  'fixedAssetPopover.amount': 'Jumlah',
  'returnPopover.invoice_qty': 'Kuantitas Faktur',
  'returnPopover.return_qty': 'Kuantitas Retur',
  'financeProduct.purchase_price': 'Harga Beli',
  'financeProduct.purchase_account': 'Akun Pembelian',
  'financeProduct.purchase_tax': 'Pajak Pembelian',
  'financeProduct.sell_price': 'Harga Jual',
  'financeProduct.product_name_or_code': 'Nama/Kode {product}',
  'financeProduct.unit_amount': 'Jumlah Satuan',
  'financeProduct.sell_account': 'Akun Penjualan',
  'financeProduct.sell_tax': 'Pajak Penjualan',
  'financeProduct.track_account': 'Akun Pelacakan',
  'financeProduct.product_bundle': 'Produk Bundel',
  'financeProduct.product_bundle_qty': 'Kuantitas Produk Bundel',
  'financeProduct.product_bundle_account': 'Akun Produk Bundel',
  'financeProduct.product_bundle_account_cost': 'Harga Akun Produk Bundel',
  'financeProduct.account_cost': 'Harga Akun',
  'financeProduct.inventory_account': 'Akun Penyimpanan',
  'financeProduct.products_successfully_imported': '{rowCount} produk berhasil diimport.',
  'financeProduct.view_detail': 'Tampilkan detil',
  'financeProduct.import_another_file': 'Import file lain',
  'financeProduct.go_to_product_list': 'Ke halaman daftar produk',
  'financeProduct.success': 'Berhasil',
  'financeProduct.failed': 'Gagal',
  'financeProduct.error_cannot_import': 'Gagal import.',
  'financeProduct.error': 'Error',
  'financeProduct.please_input_the_code_sku': 'Kode/SKU wajib diisi.',
  'financeProduct.code_sku_maximal_150_characters': 'Kode/SKU maksimal 150 karakter.',
  'financeProduct.please_choose_at_least_a_product_action':
    'Silakan pilih minimal satu aksi dari product (Beli/Jual/Inventori).',
  'financeProduct.name_category_already_exist':
    'Nama kategori sudah digunakan, silakan pilih nama kategori yang lain',
  'financeProduct.please_choose_this_action':
    'Beli produk harus aktif jika lacak inventori diaktifkan!',
  'financeProduct.please_choose_the_unit': 'Silakan pilih satuan.',
  'financeProduct.show_qty_per_warehouse': 'Tampilkan stok per gudang',
  'financeProduct.select_category': 'Pilih kategori',
  'financeProduct.qty': 'Qty',
  'financeProduct.min_qty': 'Kuantitas Minimal',
  'financeProduct.min_qty_must_less': 'Kuantitas harus lebih kecil dari kuantitas selanjutnya',
  'financeProduct.min_qty_must_greater': 'Kuantitas harus lebih besar dari kuantitas sebelumnya',
  'financeProduct.wholesale_price': 'Harga Grosir',
  'financeProduct.wholesale_qty': 'Kuantitas Grosir',
  'financeProduct.show_wholesale_price': 'Tampilkan Harga Grosir',
  'financeProduct.hide_wholesale_price': 'Sembunyikan Harga Grosir',
  'financeProduct.warehouses': 'Gudang',
  'financeProduct.warehouse': 'Gudang',
  'financeProduct.set_stock_quota': 'Atur Kuota',
  'financeProduct.stock_quota_per_warehouse': 'Kuota Stok per Gudang',
  'financeProduct.stock_quota_hint': 'Kosongkan atau isi 0 bila gudang tidak memiliki batas kuota.',
  'financeProduct.stock_quota_short': 'Kurang {qty} dari kuota',
  'financeProduct.stock_quota_exceeded': 'Melebihi kuota {qty}',
  'financeProduct.transaction': 'Transaksi',
  'financeProduct.description': 'Deskripsi',
  'financeProduct.type': 'Jenis',
  'financeProduct.stock_movement': 'Pergerakan Stok',
  'financeProduct.sell_price_history': 'Riwayat Harga Jual',
  'financeProduct.warehouse_movement': 'Pergerakan Gudang',
  'financeProduct.stock': 'Stok',
  'financeProduct.initial_stock': 'Stok Awal',
  'financeProduct.initial_stock_toggle_hint': 'Jika produk ini mempunyai stok awal',
  'financeProduct.initial_stock_qty_required': 'Kuantitas wajib diisi',
  'financeProduct.select_stock': 'Pilih Stok',
  'financeProduct.error_load_stock': 'Gagal load stok.',
  'financeProduct.show_accounts_and_taxes_setting': 'Tampilkan pengaturan akun dan pajak',
  'financeProduct.hide_accounts_and_taxes_setting': 'Sembunyikan pengaturan akun dan pajak',
  'financeProduct.categories': 'Kategori',
  'financeProduct.error_cannot_move': 'Tidak dapat memindah kategori.',
  'financeProduct.please_select_a_category_to_delete':
    'Silahkan pilih salah satu kategori untuk menghapus.',
  'financeProduct.delete_a_product_category': 'Hapus Kategori Produk',
  'financeProduct.error_cannot_delete_category': 'Tidak dapat menghapus kategori produk.',
  'financeProduct.error_cannot_update_category': 'Tidak dapat mengubah kategori produk.',
  'financeProduct.error_cannot_update': 'Tidak dapat mengubah produk.',
  'financeProduct.error_cannot_load_can_be_deleted_category':
    'Tidak dapat mengambil data kategori produk.',
  'financeProduct.only_category_that_not_assigned_in_product_could_be_deleted':
    'Catatan: Hanya kategori yang belum mempunyai produk yang dapat dihapus.',
  'financeProduct.reference': 'Reference',
  'financeProduct.error_load_product': 'Tidak dapat menampilkan data produk.',
  'financeProduct.add_product': 'Tambah {title}',
  'financeProduct.duplicate_product_package': 'Duplikat {title} Paket',
  'financeProduct.duplicate_product_manufacture': 'Duplikat {title} Manufaktur',
  'financeProduct.add_product_package': 'Tambah {title} Paket',
  'financeProduct.add_product_manufacture': 'Tambah {title} Manufaktur',
  'financeProduct.add_mass_conversion': 'Tambah Konversi {title}',
  'financeProduct.mass_conversion_title': 'Konversi {title} Massal',
  'financeProduct.mass_conversion_add_row': 'Tambah Konversi',
  'financeProduct.mass_conversion_min_one': 'Tambahkan minimal satu konversi {title}',
  'financeProduct.mass_conversion_select_product': 'Pilih {title} yang akan dikonversi',
  'financeProduct.mass_conversion_success': 'Konversi {title} massal berhasil disimpan',
  'financeProduct.edit_product_package': 'Ubah {title} Paket',
  'financeProduct.edit_product_manufacture': 'Ubah {title} Manufaktur',
  'financeProduct.package_product_items': 'Paket produk terdiri dari',
  'financeProduct.manufacture_product_items': 'Produk manufaktur terdiri dari',
  'financeProduct.error_load_product_detail':
    'Terjadi masalah di sistem saat mengambil data detail produk.',
  'financeProduct.cost_of_production': 'Biaya produksi terdiri dari',
  'financeProduct.product_conversion': 'Konversi Produk',
  'financeProduct.total_cost': 'Biaya total',
  'financeProduct.total_cost_conversion': 'Biaya total konversi',
  'financeProduct.cost_per_unit': 'Biaya per unit',
  'financeProduct.error_cannot_conversion_product':
    'Terjadi masalah server saat mengkonversi produk',
  'financeProduct.conversion_title': 'Konversi {title} {name}',
  'financeProduct.amount': 'Jumlah',
  'financeProduct.conversion_date': 'Tanggal Konversi',
  'financeProduct.error_load_conversion_product_detail':
    'Terjadi masalah di server saat mengambil konversi produk',
  'financeProduct.error_cannot_delete_conversion_product':
    'Terjadi masalah di server saat menghapus konversi produk',
  'financeProduct.multiplier': 'Pengali',
  'financeProduct.please_input_the_multiplier': 'Silahkan isikan pengali',
  'financeProduct.per_pcs': 'Per Pcs',
  'financeProduct.unit_conversion': 'Konversi Satuan',
  'financeProduct.unit': 'Satuan',
  'financeProduct.other_units': 'Satuan Lainnya',
  'financeProduct.other_units_compact': 'Satuan Lainnya Compact',
  'financeProduct.product_unit': 'Satuan {product}',
  'financeProduct.base_unit': 'Satuan Dasar',
  'financeProduct.add_unit_conversion': 'Tambah konversi satuan',
  'financeProduct.edit_unit_conversion': 'Ubah konversi satuan',
  'financeProduct.please_input_unit': 'Silakan masukkan satuan',
  'financeProduct.please_input_unit_conv': 'Silakan masukkan konversi satuan',
  'financeProduct.unit_cannot_same': 'Satuan tidak boleh sama',
  'financeProduct.unit_cannot_same_as_conversion': 'Satuan tidak boleh sama dengan konversi satuan',
  'financeProduct.cannot_edit_unit_conversion': 'Tidak dapat mengubah konversi satuan',
  'financeProduct.mass_delete_info':
    '**Produk yang telah mempunyai transaksi tidak dapat dihapus, hanya bisa diarsipkan.',
  'financeProduct.archive': 'Arsipkan',
  'financeProduct.show_archive': 'Tampilkan Arsip',
  'financeProduct.unarchive': 'Batalkan Arsip',
  'financeProduct.archived': 'Diarsipkan',
  'financeProduct.membership_entity_info': 'Produk ini berasal dari modul Membership ({type})',
  'financeProduct.membership_entity_open': 'Buka detail di modul Membership',
  'financeProduct.membership_entity_here': 'di sini.',
  'financeProduct.membership_entity_type_plan': 'paket',
  'financeProduct.membership_entity_type_addon': 'add-on',
  'financeProduct.membership_entity_type_benefit': 'benefit',
  'financeProduct.without_archive': 'Tanpa arsip',
  'financeProduct.with_archive': 'Dengan arsip',
  'financeProduct.archive_only': 'Arsip saja',
  'financeProduct.are_you_sure_to_archive': 'Apakah Anda yakin untuk mengarsipkan produk ini?',
  'financeProduct.are_you_sure_to_unarchive': 'Apakah Anda yakin untuk batalkan arsip produk ini?',
  'financeProduct.future_transactions': 'Transaksi yang akan datang ',
  'financeProduct.all_transactions': 'Semua transaksi',
  'financeProduct.current_transaction_will_not_be_modified':
    'Tidak akan mempengaruhi transaksi yang sudah dibuat.',
  'financeProduct.current_transaction_and_future_will_be_modified':
    'Akan mempengaruhi jurnal entri dari transaksi yang sudah dibuat.',
  'financeProduct.purchase_account_cannot_be_modified_for_future_transactions':
    'Akun pembelian tidak dapat diubah pada transaksi yang akan datang, karena produk ini telah mempunyai transaksi sebelumnya.',
  'financeProduct.purchase_account_cannot_be_modified_for_all_transactions':
    'Akun pembelian tidak dapat diubah untuk semua transaksi, karena ada transaksi pada produk ini sebelum tanggal penguncian, atau tanggal tutup buku.',
  'financeProduct.sell_account_cannot_be_modified': 'Akun penjualan tidak dapat diubah.',
  'financeProduct.sell_account_cannot_be_modified_for_all_transactions':
    'Akun penjualan tidak dapat diubah untuk semua transaksi, karena ada transaksi pada produk ini sebelum tanggal penguncian, atau tanggal tutup buku.',
  'financeProduct.track_account_cannot_be_modified':
    'Akun persediaan tidak dapat diubah karena ada transaksi pada produk ini sebelum tanggal penguncian, atau tanggal tutup buku.',
  'financeProduct.please_choose_account_update_past':
    'Pengaturan edit akun yang akan datang belum dipilih!',
  'financeProduct.same_as_business_flow': 'Sesuai pengaturan alur bisnis',
  'financeProduct.please_input_buffer_qty': 'Silakan masukkan jumlah stok minimal',
  'financeProduct.data_is_being_processed': 'Data sedang diproses',
  'financePurchaseInvoices.message': 'Pesan',
  'financePurchaseInvoices.customer': 'Pelanggan',
  'financePurchaseInvoices.add_purchaseInvoice': 'Tambah Tagihan Pembelian',
  'financePurchaseInvoices.financePurchaseInvoices': 'Tagihan Pembelian',
  'financePurchaseInvoices.successfully_added': 'berhasil ditambah.',
  'financePurchaseInvoices.error_cannot_print_pdf': 'Tidak dapat membuat pdf tagihan pembelian.',
  'financePurchaseInvoices.error_cannot_add': 'Tidak dapat menambah tagihan pembelian.',
  'financePurchaseInvoices.error_cannot_update': 'Tidak dapat mengubah tagihan pembelian.',
  'financePurchaseInvoices.error_cannot_move': 'Tidak dapat memindah tagihan pembelian.',
  'financePurchaseInvoices.error_cannot_change_status':
    'Tidak dapat mengubah status tagihan pembelian.',
  'financePurchaseInvoices.edit_purchaseInvoice': 'Ubah Tagihan Pembelian',
  'financePurchaseInvoices.max_characters': 'Maks {value}.',
  'financePurchaseInvoices.min_characters': 'Min {value} karakter.',
  'financePurchaseInvoices.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financePurchaseInvoices.description': 'Deskripsi',
  'financePurchaseInvoices.tax': 'Pajak',
  'financePurchaseInvoices.select_tax': 'Pilih pajak',
  'financePurchaseInvoices.please_select_a_contact': 'Silakan pilih kontak',
  'financePurchaseInvoices.select_contact': 'Pilih kontak',
  'financePurchaseInvoices.add_contact': 'Tambah kontak',
  'financePurchaseInvoices.all_contacts': 'Semua kontak',
  'financePurchaseInvoices.transaction_date': 'Tgl. Transaksi',
  'financePurchaseInvoices.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financePurchaseInvoices.payment_date': 'Tgl. Pembayaran',
  'financePurchaseInvoices.please_select_payment_date': 'Silakan pilih tanggal pembayaran',
  'financePurchaseInvoices.due_date': 'Tgl. Jatuh Tempo',
  'financePurchaseInvoices.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financePurchaseInvoices.term': 'Termin',
  'financePurchaseInvoices.select_term': 'Pilih termin',
  'financePurchaseInvoices.add_term': 'Tambah termin',
  'financePurchaseInvoices.price_include_tax': 'Harga termasuk pajak',
  'financePurchaseInvoices.add_more': 'Tambah baris',
  'financePurchaseInvoices.number': 'Nomor',
  'financePurchaseInvoices.please_input_the_number': 'Silakan isikan nomor.',
  'financePurchaseInvoices.memo': 'Reference',
  'financePurchaseInvoices.date': 'Tanggal',
  'financePurchaseInvoices.status': 'Status',
  'financePurchaseInvoices.balance_due': 'Sisa Tagihan',
  'financePurchaseInvoices.total': 'Total',
  'financePurchaseInvoices.please_select_a_term': 'Silakan pilih termin.',
  'financePurchaseInvoices.search_by_memo': 'Cari',
  'financePurchaseInvoices.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financePurchaseInvoices.the_payment_date_max_higger_than_transaction_date':
    'Tanggal pembayaran harus sama atau setelah tanggal transaksi',
  'financePurchaseInvoices.detail_title': 'Tagihan Pembelian {number}',
  'financePurchaseInvoices.vendor': 'Vendor',
  'financePurchaseInvoices.reference': 'Reference',
  'financePurchaseInvoices.product': 'Produk',
  'financePurchaseInvoices.qty': 'Kuantitas',
  'financePurchaseInvoices.price': 'Harga',
  'financePurchaseInvoices.add_product': 'Tambah Produk',
  'financePurchaseInvoices.select_product': 'Pilih produk',
  'financePurchaseInvoices.attachments': 'Attachment',
  'financePurchaseInvoices.save_&_approve': 'Simpan & setujui',
  'financePurchaseInvoices.save_as_draft': 'Simpan sbg draft',
  'financePurchaseInvoices.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financePurchaseInvoices.please_select_a_product': 'Silakan pilih produk.',
  'financePurchaseInvoices.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financePurchaseInvoices.please_input_the_price': 'Silakan masukkan harga.',
  'financePurchaseInvoices.please_input_the_amount': 'Silakan masukkan total.',
  'financePurchaseInvoices.approve': 'Setujui',
  'financePurchaseInvoices.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financePurchaseInvoices.submit_for_approval': 'Ajukan approval',
  'financePurchaseInvoices.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financePurchaseInvoices.create_invoice': 'Buat Tagihan',
  'financePurchaseInvoices.amount_paid': 'Total Dibayar',
  'financePurchaseInvoices.paid_from': 'Dibayar Dari',
  'financePurchaseInvoices.add_payment': 'Tambah Pembayaran',
  'financePurchaseInvoices.select_paid_from': 'Pilih dibayar dari',
  'financePurchaseInvoices.please_select_a_paid_from': 'Silakan pilih dibayar dari.',
  'payment.no_bank_access_title': 'Tidak Ada Akses Akun Kas/Bank',
  'payment.no_bank_access_description':
    'Anda belum memiliki akses ke akun kas/bank mana pun untuk melakukan pembayaran. Silakan hubungi admin untuk diberi akses.',
  'financePurchaseInvoices.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financePurchaseInvoices.payment': 'Pembayaran',
  'financePurchaseInvoices.detail_purchaseInvoice': 'Detil Tagihan Pembelian',
  'financePurchaseInvoices.number_po': 'Nomor PO',
  'financePurchaseInvoices.amount': 'Jumlah',
  'financePurchaseInvoices.paid_to': 'Dibayar Ke',
  'financePurchaseInvoices.select_paid_to': 'Pilih dibayar ke',
  'financePurchaseInvoices.please_select_a_paid_to': 'Silakan pilih dibayar ke.',
  'financePurchaseInvoices.follow_these_steps_to_import_your_purchase_invoices':
    'Ikuti langkah berikut untuk mengimport tagihan pembelianmu',
  'financePurchaseInvoices.1_download_your_purchase_invoices_template_file':
    '1. Download file template tagihan pembelian',
  'financePurchaseInvoices.start_by_downloading_our_purchase_invoices_csv':
    'Mulai dengan mengunduh file template Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari tagihan pembelian-tagihan pembelianmu.',
  'financePurchaseInvoices.download_template_file': 'Download File Template',
  'financePurchaseInvoices.download_template_data_example_file': 'Download File Contoh',
  'financePurchaseInvoices.import': 'Import Tagihan pembelian',
  'financePurchaseInvoices.2_copy_your_purchase_invoices_into_the_template':
    '2. Salin detail tagihan pembelian ke dalam template',
  'financePurchaseInvoices.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail tagihan pembelian ke dalam file template dari Kledo. Pastikan detail tagihan pembelian sesuai dengan kolom header yang ada di template.',
  'financePurchaseInvoices.important': 'PENTING',
  'financePurchaseInvoices.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financePurchaseInvoices.upload': 'Upload',
  'financePurchaseInvoices.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financePurchaseInvoices.a_maximum_of_1000_purchase_invoices_can_be_imported_at_a_time':
    'Maksimal 1.000 tagihan pembelian dapat diimport dalam satu waktu.',
  'financePurchaseInvoices.a_single_import_supports_up_to_n_rows':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel.',
  'financePurchaseInvoices.a_single_import_supports_up_to_n_rows_including_invoice_and_item':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris tagihan pembelian maupun item.',
  'financePurchaseInvoices.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financePurchaseInvoices.import_actions_only_insert_new_purchase_invoices_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financePurchaseInvoices.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financePurchaseInvoices.you_can_only_upload_csv_file':
    'Anda hanya dapat mengunggah file csv atau excel',
  'financePurchaseInvoices.upload_file': 'Upload File',
  'financePurchaseInvoices.check_the_imported_data': 'Cek Data',
  'financePurchaseInvoices.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financePurchaseInvoices.import_purchase_invoices_done': 'Import Berhasil',
  'financePurchaseInvoices.error_upload_file': 'Gagal mengunggah file.',
  'financePurchaseInvoices.file_not_found': 'File tidak ditemukan.',
  'financePurchaseInvoices.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financePurchaseInvoices.valid': 'Valid',
  'financePurchaseInvoices.invalid': 'Invalid',
  'financePurchaseInvoices.import_now': 'Import Sekarang',
  'financePurchaseInvoices.contact_name': 'Nama Kontak',
  'financePurchaseInvoices.email': 'Email',
  'financePurchaseInvoices.address': 'Alamat',
  'financePurchaseInvoices.phone': 'Phone',
  'financePurchaseInvoices.invoice_date': 'Tanggal Tagihan',
  'financePurchaseInvoices.invoice_number': 'Nomor Invoice',
  'financePurchaseInvoices.import_order_number': 'Nomor Pesanan Pembelian',
  'financePurchaseInvoices.product_name': 'Nama Produk',
  'financePurchaseInvoices.code_sku': 'Kode/SKU',
  'financePurchaseInvoices.tax_inclusive': 'Termasuk Pajak',
  'financePurchaseInvoices.paid': 'Lunas',
  'financePurchaseInvoices.paid_account': 'Akun Pembayaran',
  'financePurchaseInvoices.copy_link': 'Salin Link Faktur Pembelian',
  'financePurchaseInvoices.send_email': 'Kirim Email Faktur Pembelian',
  'financeInvoices.on': 'pada',
  'financeInvoices.last_printed_by': 'Terakhir dicetak oleh',
  'financeInvoices.last_modified_by': 'Terakhir diubah oleh',
  'financeInvoices.log': 'Log',
  'financeInvoices.last_sent_email_on': 'Terakhir kirim email ini pada {date}',
  'financeInvoices.last_sent_whatsapp_on': 'Terakhir kirim WhatsApp ini pada {date}',
  'financeInvoices.last_sent_email_recap_on': 'Terakhir kirim email rekap ini pada {date}',
  'financeInvoices.last_sent_sms_recap_on': 'Terakhir kirim SMS rekap ini pada {date}',
  'financeInvoices.preorder_number': 'Nomor PO',
  'financeInvoices.total_before_tax': 'Total Sebelum Pajak',
  'financeInvoices.printStatus': 'Status Print',
  'financeInvoices.deliveryPrintStatus': 'Status Print Surat Jalan',
  'financeInvoices.print_status_printed': 'Sudah',
  'financeInvoices.print_status_unprinted': 'Belum',
  'financeInvoices.import_new_invoice': 'Import Tagihan Baru',
  'financeInvoices.import_invoice_status': 'Import Status Tagihan',
  'financeInvoices.import_recurring_invoice': 'Import Tagihan Berulang',
  'financeInvoices.witholding': 'Pemotongan',
  'financeInvoices.select_holding_from': 'Pilih dipotong dari',
  'financeInvoices.please_select_a_holding_from': 'Silahkan pilih dipotong dari',
  'financeInvoices.print_partial': 'Faktur Per Termin',
  'financeInvoices.print_partial_with_stamp': 'Print dan Bubuhkan E-Meterai',
  'financeInvoices.print_delivery_label': 'Label Pengiriman',
  'financeInvoices.print_delivery': 'Surat Jalan',
  'financeInvoices.print_payment': 'Rekap Pembayaran',
  'financeInvoices.print_tax': 'Faktur Pajak',
  'financeInvoices.download_word': 'Faktur MsWord',
  'financeInvoices.default_label_term': 'Tagihan Termin I',
  'financeInvoices.here': 'di sini',
  'financeInvoices.please_input_label': 'Silakan masukkan label',
  'financeInvoices.insufficient_stock_confirm':
    'Terdapat produk yang  stok nya kurang, Apakah akan tetap membuat tagihan ini ?',
  'financeInvoices.insufficient_stock_warning':
    'Tidak dapat menambah tagihan, karena terdapat produk yang stok nya kurang.',
  'financeInvoices.insufficient_stock': 'Stok tidak mencukupi',
  'financeInvoices.builtin_notes_for_easy_searching':
    'Catatan internal untuk mempermudah pencarian.',
  'financeInvoices.used_to_create_transaction_categories':
    'Digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'financeInvoices.the_number_will_be_automatically_generated_by_the_system':
    'Nomor akan otomatis terbuat oleh sistem, tapi Anda juga bisa mengubahnya disini.',
  'financeInvoices.you_can_set_the_format_of_this_number':
    'Anda bisa mengatur format nomor ini {link}.',
  'financeInvoices.amount_before_tax': 'Total Sblm Pajak',
  'financeInvoices.amount_after_discount': 'Total setelah diskon',
  'financePurchaseInvoices.import_purchase_invoice_status': 'Import Status Tagihan Pembelian',
  'financePurchaseInvoices.inventory_account': 'Akun Penyimpanan',
  'financePurchaseInvoices.purchase_invoices_successfully_imported':
    '{rowCount} tagihan pembelian berhasil diimport.',
  'financePurchaseInvoices.view_detail': 'Tampilkan detil',
  'financePurchaseInvoices.import_another_file': 'Import file lain',
  'financePurchaseInvoices.go_to_purchase_invoice_list': 'Ke halaman daftar tagihan pembelian',
  'financePurchaseInvoices.success': 'Berhasil',
  'financePurchaseInvoices.failed': 'Gagal',
  'financePurchaseInvoices.error_cannot_import': 'Gagal import.',
  'financePurchaseInvoices.error': 'Error',
  'financePurchaseInvoices.make_a_payment': 'Kirim pembayaran',
  'financeQuotes.message': 'Pesan',
  'financeQuotes.error_cannot_print_pdf': 'Tidak dapat membuat pdf penawaran.',
  'financeQuotes.add_quote': 'Tambah Penawaran',
  'financeQuotes.financeQuotes': 'Penawaran',
  'financeQuotes.quote_accepted': 'Penawaran disetujui',
  'financeQuotes.quote_open': 'Penawaran belum selesai',
  'financeQuotes.successfully_added': 'berhasil ditambahkan.',
  'financeQuotes.error_cannot_add': 'Tidak dapat menambah penawaran.',
  'financeQuotes.error_cannot_update': 'Tidak dapat mengubah penawaran.',
  'financeQuotes.error_cannot_move': 'Tidak dapat memindah penawaran.',
  'financeQuotes.error_cannot_change_status': 'Tidak dapat mengubah status penawaran.',
  'financeQuotes.edit_quote': 'Ubah Penawaran',
  'financeQuotes.max_characters': 'Maks {value} karakter.',
  'financeQuotes.min_characters': 'Min {value} karakter.',
  'financeQuotes.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeQuotes.description': 'Deskripsi',
  'financeQuotes.tax': 'Pajak',
  'financeQuotes.select_tax': 'Pilih pajak',
  'financeQuotes.amount': 'Total',
  'financeQuotes.please_select_a_contact': 'Silakan pilih kontak',
  'financeQuotes.select_contact': 'Pilih kontak',
  'financeQuotes.add_contact': 'Tambah kontak',
  'financeQuotes.all_contacts': 'Semua kontak',
  'financeQuotes.transaction_date': 'Tgl. Transaksi',
  'financeQuotes.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeQuotes.due_date': 'Kadaluarsa',
  'financeQuotes.please_select_due_date': 'Silakan pilih tanggal kadaluarsa',
  'financeQuotes.term': 'Termin',
  'financeQuotes.select_term': 'Pilih termin',
  'financeQuotes.add_term': 'Tambah termin',
  'financeQuotes.price_include_tax': 'Harga termasuk pajak',
  'financeQuotes.add_more': 'Tambah baris',
  'financeQuotes.number': 'Nomor',
  'financeQuotes.please_input_the_number': 'Silakan isikan nomor.',
  'financeQuotes.memo': 'Reference',
  'financeQuotes.date': 'Tanggal',
  'financeQuotes.status': 'Status',
  'financeQuotes.balance_due': 'Sisa Tagihan',
  'financeQuotes.please_select_a_term': 'Silakan pilih termin.',
  'financeQuotes.search_by_memo': 'Cari',
  'financeQuotes.the_due_date_max_higger_than_transaction_date':
    'Tanggal kadaluarsa harus sama atau setelah tanggal transaksi',
  'financeQuotes.detail_title': 'Penawaran {number}',
  'financeQuotes.customer': 'Pelanggan',
  'financeQuotes.reference': 'Reference',
  'financeQuotes.product': 'Produk',
  'financeQuotes.qty': 'Kuantitas',
  'financeQuotes.price': 'Harga',
  'financeQuotes.add_product': 'Tambah Produk',
  'financeQuotes.select_product': 'Pilih produk',
  'financeQuotes.attachments': 'Attachment',
  'financeQuotes.save_as_draft': 'Simpan sbg draft',
  'financeQuotes.save_as_draft_add_new': 'Simpan sbg draft & Tambah Baru',
  'financeQuotes.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financeQuotes.please_select_a_product': 'Silakan pilih produk.',
  'financeQuotes.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financeQuotes.please_input_the_price': 'Silakan masukkan harga.',
  'financeQuotes.please_input_the_amount': 'Silakan masukkan total.',
  'financeQuotes.mark_as_sent': 'Tandai sbg terkirim',
  'financeQuotes.are_you_sure_to_mark_as_sent': 'Apakah Anda yakin menandai sebagai terkirim?',
  'financeQuotes.mark_as_accepted': 'Tandai sbg diterima',
  'financeQuotes.are_you_sure_to_mark_as_accepted': 'Apakah Anda yakin menandai sebagai diterima?',
  'financeQuotes.mark_as_declined': 'Tandai sbg ditolak',
  'financeQuotes.are_you_sure_to_mark_as_declined': 'Apakah Anda yakin menandai sebagai ditolak?',
  'financeQuotes.create_invoice': 'Buat Tagihan',
  'financeQuotes.send': 'Kirim',
  'financeQuotes.send_add_new': 'Kirim & Tambah Baru',
  'financeQuotes.detail_quote': 'Detil Penawaran',
  'financeQuotes.create_order': 'Buat Pemesanan',
  'financeInvoices.sales': 'Penjualan',
  'financeInvoices.print_receipt': 'Print Kuitansi Tagihan',
  'financeInvoices.download': 'Unduh',
  'financeInvoices.download_sales_report': 'Unduh Laporan Penjualan',
  'financeInvoices.my_order': 'Pesanan Saya',
  'financeInvoices.all': 'Semua',
  'financeInvoices.export': 'Export',
  'financeInvoices.orders': 'Pesanan',
  'financeInvoices.order_review': 'Tinjauan Pesanan',
  'financeInvoices.manage_order': 'Kelola Pesanan',
  'financeInvoices.download_order': 'Unduh Pesanan',
  'financeInvoices.export_all_order': 'Ekspor Semua Pesanan',
  'financeInvoices.delivery_list': 'Daftar Pengiriman',
  'financeInvoices.done': 'Done',
  'financeInvoices.export_invoice': 'Ekspor E-Faktur',
  'financeInvoices.choose_template': 'Pilih Template',
  'financeInvoices.import_with_kledo_template': 'Import dengan format template Excel dari Kledo',
  'financeInvoices.marketplace_connect_sync_automatic_from_marketplace_without_import':
    'Marketplace Connect: Otomatis sinkronisasi data dari marketplace ke Kledo, tanpa perlu import',
  'financeInvoices.import_with_marketplace_template':
    'Import dengan format template Excel dari Marketplace',
  'financeInvoices.export_sales_data_from_tokopedia': '1. Export Data Penjualan dari Tokopedia',
  'financeInvoices.export_sales_data_from_shopee': '1. Export Data Penjualan dari Shopee',
  'financeInvoices.export_sales_data_from_bukalapak': '1. Export Data Penjualan dari Bukalapak',
  'financeInvoices.export_sales_data_from_lazada': '1. Export Data Penjualan dari Lazada',
  'financeInvoices.export_sales_data_from_tiktok': '1. Export Data Penjualan dari Tiktok Shop',
  'financeInvoices.export_sales_data_from_olsera': '1. Export data penjualan dari dashboard Olsera',
  'financeInvoices.export_sales_data_record_shipping_cost_to_bill':
    'catatkan biaya kirim ke tagihan',
  'financeInvoices.upload_excel_from_tokopedia': '2. Upload File Excel dari Tokopedia di sini',
  'financeInvoices.upload_excel_from_shopee': '2. Upload File Excel dari Shopee di sini',
  'financeInvoices.upload_excel_from_bukalapak': '2. Upload File Excel dari Bukalapak di sini',
  'financeInvoices.upload_excel_from_lazada': '2. Upload File Excel dari Lazada di sini',
  'financeInvoices.upload_excel_from_tiktok': '2. Upload File Excel dari Tiktok Shop di sini',
  'financeInvoices.upload_excel_from_olsera': '2. Upload File Excel dari Olsera di sini',
  'financeInvoices.set_import_option': '3. Atur Opsi Import',
  'financeInvoices.1a_tokopedia':
    'a. Login pada aplikasi TikTok seller center, lalu klik menu Kelola Pesanan. Klik tab “semua” apabila akan mengambil semua transaksi, Klik tab “selesai” apabila akan mengambil transaksi dengan status selesai saja',
  'financeInvoices.1b_tokopedia':
    'b. Klik Filter rentang waktu biaya yang ingin diunduh pada kolom Periode Data “waktu dibuat”. Kemudian apabila transaksi penjualan TikTok dan Tokopedia akan dipisah untuk pemetaan akun kas & bank serta tag, maka klik “dipesan di” dan lakukan eksport data di TikTok serta Tokopedia',
  'financeInvoices.1a_shopee':
    'a. Login pada aplikasi shopee seller center, lalu klik menu Pesanan Saya',
  'financeInvoices.1b_shopee':
    'b. Klik tab “semua” apabila akan mengambil semua transaksi dan Klik tab “selesai” apabila akan mengambil transaksi dengan status selesai saja',
  'financeInvoices.1c_shopee':
    'c. Klik Eksport lalu Filter rentang waktu laporan penjualan yang ingin diunduh',
  'financeInvoices.1d_shopee': 'd. Klik riwayat download untuk unduh hasil export data',
  'financeInvoices.1a_bukalapak': 'a. Pada halaman Home, klik tab {transaction}',
  'financeInvoices.1b_bukalapak': 'b. Klik tombol {downloadTransaction}',
  'financeInvoices.1c_bukalapak':
    'c. Filter rentang waktu dan transaksi laporan penjualan yang ingin di unduh, lalu klik tombol {downloadTransaction}. Simpan file Excel yang baru saja di unduh.',
  'financeInvoices.1a_lazada':
    'a. Pada halaman Home, klik tab {orders}, lalu klik tab {orderReview}',
  'financeInvoices.1b_lazada': 'b. Klik tombol {export}, lalu klik {exportAllOrder}',
  'financeInvoices.1c_lazada':
    'c. Untuk laporan penjualan yang ingin diunduh, klik tombol {download}, lalu klik {done}. Simpan file Excel yang baru saja di unduh.',
  'financeInvoices.1a_tiktok': 'a. Klik menu {order} - {manageOrder}',
  'financeInvoices.1b_tiktok': 'b. Klik tab {done}',
  'financeInvoices.1c_tiktok': 'c. Klik menu {downloadOrder}',
  'financeInvoices.1d_tiktok': 'd. Pilih format unduh Excel',
  'financeInvoices.1e_tiktok': 'e. Centang {deliveryList} pada {chooseTemplate}',
  'financeInvoices.1f_tiktok': 'f. Klik tombol {download}',
  'financeInvoices.1a_olsera': 'a. Klik menu Laporan',
  'financeInvoices.1b_olsera': 'b. Klik menu Laporan Penjualan',
  'financeInvoices.1c_olsera': 'c. Klik menu Item Penjualan Per Tanggal',
  'financeInvoices.1d_olsera': 'd. Pilih status pembayaran telah dibayar',
  'financeInvoices.1e_olsera': 'e. Klik tombol Excel. Simpan file Excel yang baru saja di unduh.',
  'financeInvoices.this_import_will_change_status':
    'Fasilitas import ini akan mengubah status tagihan yang belum lunas menjadi lunas.',
  'financeInvoices.data_will_not_change_even_if_different':
    'Data tagihan tidak akan diubah pada import ini, meskipun data pada sistem kledo dengan data pada file excel berbeda.',
  'financeQuotes.follow_these_steps_to_import_your_quotes':
    'Ikuti langkah berikut untuk mengimport penawaranmu',
  'financeQuotes.1_download_your_quotes_template_file': '1. Download file template penawaran',
  'financeQuotes.start_by_downloading_our_quotes_csv':
    'Mulai dengan mengunduh file template Excel penawaran. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari penawaran-penawaranmu.',
  'financeQuotes.download_template_file': 'Download File Template',
  'financeQuotes.download_template_data_example_file': 'Download File Contoh',
  'financeQuotes.import': 'Import Penawaran',
  'financeQuotes.2_copy_your_quotes_into_the_template':
    '2. Salin detail penawaran ke dalam template',
  'financeQuotes.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail penawaran ke dalam file template dari Kledo. Pastikan detail penawaran sesuai dengan kolom header yang ada di template.',
  'financeQuotes.important': 'PENTING',
  'financeQuotes.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeQuotes.upload': 'Upload',
  'financeQuotes.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeQuotes.a_maximum_of_500_quotes_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris penawaran maupun item.',
  'financeQuotes.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financeQuotes.import_actions_only_insert_new_quotes_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeQuotes.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeQuotes.you_can_only_upload_csv_file': 'Anda hanya dapat mengunggah file csv atau excel',
  'financeQuotes.upload_file': 'Upload File',
  'financeQuotes.check_the_imported_data': 'Cek Data',
  'financeQuotes.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financeQuotes.import_quotes_done': 'Import Berhasil',
  'financeQuotes.error_upload_file': 'Gagal mengunggah file.',
  'financeQuotes.file_not_found': 'File tidak ditemukan.',
  'financeQuotes.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financeQuotes.valid': 'Valid',
  'financeQuotes.invalid': 'Invalid',
  'financeQuotes.total': 'Total',
  'financeQuotes.total_after_additional_discount': 'Total Setelah Diskon',
  'financeQuotes.import_now': 'Import Sekarang',
  'financeQuotes.contact_name': 'Nama Kontak',
  'financeQuotes.email': 'Email',
  'financeQuotes.address': 'Alamat',
  'financeQuotes.phone': 'Phone',
  'financeQuotes.quote_date': 'Tanggal Penawaran',
  'financeQuotes.quote_number': 'Nomor Penawaran',
  'financeQuotes.product_name': 'Nama Produk',
  'financeQuotes.code_sku': 'Kode/SKU',
  'financeQuotes.tax_inclusive': 'Termasuk Pajak',
  'financeQuotes.copy_link': 'Salin Link Penawaran',
  'financeQuotes.send_email': 'Kirim Email Penawaran',
  'financeQuotes.send_sms': 'Kirim SMS Penawaran',
  'financeQuotes.send_wa': 'Kirim Whatsapp Penawaran',
  'financeQuotes.inventory_account': 'Akun Penyimpanan',
  'financeQuotes.quotes_successfully_imported': '{rowCount} quote berhasil diimport.',
  'financeQuotes.view_detail': 'Tampilkan detil',
  'financeQuotes.import_another_file': 'Import file lain',
  'financeQuotes.go_to_quote_list': 'Ke halaman daftar penawaran',
  'financeQuotes.success': 'Berhasil',
  'financeQuotes.failed': 'Gagal',
  'financeQuotes.error_cannot_import': 'Gagal import.',
  'financeQuotes.error': 'Error',
  'financeQuotes.print_quote': 'Cetak Penawaran',
  'pos.pos': 'POS',
  'pos.pos_activity': 'POS Activity',
  'pos.transfer_to_room': 'Transfer to Room',
  'pos.please_choose_a_table': 'please choose a table!',
  'pos.failed_list_item_null': 'failed list item null!',
  'pos.harga_item': 'Harga item',
  'pos.activity': 'Activity',
  'pos.saved_bill': 'Saved Bill',
  'pos.items': 'Items',
  'pos.total_harga_item': 'Total harga item',
  'pos.discount': 'Discount',
  'pos.tax': 'Pajak',
  'pos.total': 'Total',
  'pos.pay': 'Pay',
  'pos.save_bill': 'Save Bill',
  'pos.list_save_bill': 'List Save Bill',
  'pos.table': 'Table',
  'pos.select_table': 'select table',
  'pos.receipt_number': 'Receipt Nomor',
  'pos.details': 'Detils',
  'pos.payment': 'Pembayaran',
  'pos.date_range': 'Tanggal Range',
  'pos.unpaid': 'unpaid',
  'pos.paid_cashier': 'paid cashier',
  'pos.order_cannot_contain_serial_products':
    'Simpan sebagai pesanan tidak dapat menggunakan produk nomor seri. Ubah item atau gunakan simpan sebagai tagihan.',
  'pos.transfer_to_room_': 'transfer to room',
  'pos.please_select_date_range': 'please select tanggal range',
  'pos.select': 'Select',
  'pos.room': 'Room',
  'pos.name': 'Nama',
  'pos.checking': 'Checking',
  'pos.transfer': 'Transfer',
  'pos.new_sale': 'New Sale',
  'pos.transfer_to': 'Transfer To',
  'pos.guest_name': 'Guest Name',
  'pos.pos_outlets': 'POS Outlets',
  'pos.category': 'Kategori',
  'pos.variant_name': 'Variant Name',
  'pos.modify_variant': 'Modify Variant',
  'pos.variant_of': 'Variant of',
  'pos.add_variant_category': 'Tambah Variant Kategori',
  'pos.add_variant': 'Tambah Variant',
  'pos.product_name': 'Nama Produk',
  'pos.enable_table_for_this_outlet': 'Enable table for this outlet',
  'pos.add_product': 'Tambah Produk',
  'pos.add_category': 'Tambah Kategori',
  'pos.product': 'Produk',
  'pos.settings': 'Settings',
  'pos.name_category_required': 'Nama kategori wajib diisi',
  'pos.edit_category': 'Ubah Kategori',
  'pos.category_name': 'Kategori Name',
  'pos.change_multi_required': 'change multi wajib diisi',
  'pos.one_variant_per_product_sale': 'One Variant per produk sale',
  'pos.multiple_variant_per_product_sale': 'Multiple Variant per produk sale',
  'pos.edit_variant_category': 'Ubah Variant Kategori',
  'pos.add_tables': 'Tambah Tables',
  'pos.name_table_required': 'name table wajib diisi',
  'pos.tables': 'Tables',
  'pos.edit_tables': 'Ubah Tables',
  'pos.name_required': 'name wajib diisi',
  'pos.tax_required': 'tax wajib diisi',
  'pos.service_charge': 'Service Charge',
  'pos.service_charge_required': 'service charge wajib diisi',
  'pos.auto_fees.title': 'Aturan Tambahan Biaya',
  'pos.auto_fees.note':
    'Tambahkan aturan biaya yang otomatis dikenakan berdasarkan jenis transaksi (Bungkus, Ojol, dll.) pada outlet ini.',
  'pos.auto_fees.add': 'Tambah Aturan',
  'pos.auto_fees.empty': 'Belum ada aturan. Klik "Tambah Aturan" untuk membuat.',
  'pos.auto_fees.master_fee': 'Master Biaya',
  'pos.auto_fees.invoice_type': 'Jenis Transaksi',
  'pos.auto_fees.value_type': 'Tipe Nilai',
  'pos.auto_fees.value': 'Nilai',
  'pos.auto_fees.include_tax': 'Termasuk Pajak',
  'pos.auto_fees.include_tax_short': 'Pajak',
  'pos.auto_fees.ojol_filter': 'Filter Ojol (opsional)',
  'pos.auto_fees.ojol_filter_placeholder': 'Kosong = berlaku untuk semua ojol',
  'pos.auto_fees.confirm_delete': 'Hapus aturan ini?',
  'pos.auto_fees.add_title': 'Tambah Aturan Biaya',
  'pos.auto_fees.edit_title': 'Ubah Aturan Biaya',
  'pos.auto_fees.value_required': 'Nilai wajib diisi',
  'pos.auto_fees.master_fee_required': 'Master biaya wajib dipilih',
  'pos.auto_fees.invoice_type_required': 'Jenis transaksi wajib dipilih',
  'pos.cashier_settings.search_placeholder': 'Cari pengaturan, mis. diskon, struk, antrian…',
  'pos.cashier_settings.expand_all': 'Buka semua',
  'pos.cashier_settings.collapse_all': 'Tutup semua',
  'pos.cashier_settings.count': '{count} pengaturan',
  'pos.cashier_settings.result_count': '{count} hasil',
  'pos.cashier_settings.no_result': 'Tidak ada pengaturan yang cocok dengan “{query}”',
  'pos.cashier_settings.clear_search': 'Hapus pencarian',
  'pos.cashier_settings.device_only': 'Perangkat ini',
  'pos.cashier_settings.group.shift.title': 'Shift & Kas',
  'pos.cashier_settings.group.shift.description':
    'Kas modal saat buka/tutup kasir dan batas kas keluar',
  'pos.cashier_settings.group.pricing.title': 'Harga & Diskon',
  'pos.cashier_settings.group.pricing.description':
    'Diskon, harga manual, pajak per item, dan service charge',
  'pos.cashier_settings.group.order_type.title': 'Jenis Order & Biaya',
  'pos.cashier_settings.group.order_type.description':
    'Jenis order di kasir dan biaya otomatis per jenis order',
  'pos.cashier_settings.group.receipt.title': 'Struk & Pembayaran',
  'pos.cashier_settings.group.receipt.description':
    'Tampilan struk, jumlah cetak, dan transfer otomatis',
  'pos.cashier_settings.group.queue.title': 'Antrian & Otorisasi',
  'pos.cashier_settings.group.queue.description': 'Nomor antrian dan otorisasi pimpinan',
  'pos.cashier_settings.group.performance.title': 'Performa Kasir',
  'pos.cashier_settings.group.performance.description':
    'Mode Zero-Loading dan riwayat sinkronisasi transaksi',
  'pos.zero_loading.title': 'Mode Kasir Zero-Loading (Beta)',
  'pos.zero_loading.note':
    'Jika diaktifkan, produk & promo diambil sekali lalu disimpan di browser ini, dan setiap penjualan/order disimpan seketika lalu disinkronkan ke server di latar belakang — kasir tak perlu menunggu walau server sedang ramai. Menyalakan akan menyinkronkan katalog terlebih dahulu.',
  'pos.zero_loading.unsupported': 'Browser ini belum mendukung mode Zero-Loading',
  'pos.zero_loading.badge': 'Mode Zero-Loading aktif',
  'pos.zero_loading.enabled': 'Mode Zero-Loading aktif',
  'pos.zero_loading.disabled': 'Mode Zero-Loading dimatikan',
  'pos.zero_loading.disable_pending':
    'Masih ada {count} transaksi yang belum tersinkron. Sinkronkan dulu sebelum mematikan mode Zero-Loading.',
  'pos.zero_loading.sync_catalog': 'Sinkronkan Katalog',
  'pos.zero_loading.sync_catalog_note':
    'Ambil perubahan produk & promo terbaru dari server ke browser ini.',
  'pos.zero_loading.catalog_last_synced': 'Terakhir disinkron {time}',
  'pos.zero_loading.catalog_synced': 'Katalog berhasil disinkronkan',
  'pos.zero_loading.catalog_sync_failed': 'Gagal menyinkronkan katalog',
  'pos.catalog_sync.title': 'Menyiapkan kasir…',
  'pos.catalog_sync.description':
    'Mengunduh katalog produk & promo ke browser ini supaya kasir bisa bertransaksi tanpa menunggu server.',
  'pos.catalog_sync.step.products': 'Produk',
  'pos.catalog_sync.step.price_rules': 'Promo & harga',
  'pos.catalog_sync.step.done': 'Selesai',
  'pos.catalog_sync.fetching.products': 'Mengambil data produk…',
  'pos.catalog_sync.fetching.price_rules': 'Mengambil promo & harga…',
  'pos.catalog_sync.fetching.done': 'Menyelesaikan…',
  'pos.catalog_sync.success': 'Katalog siap dipakai',
  'pos.catalog_sync.error_offline':
    'Tidak ada koneksi internet. Sambungkan dulu untuk mengambil data kasir.',
  'pos.catalog_sync.error_generic': 'Gagal menyinkronkan katalog. Coba lagi.',
  'pos.catalog_sync.retry': 'Coba lagi',
  'pos.catalog_sync.skip': 'Lewati (lanjut tanpa promo)',
  'pos.catalog_sync.disable': 'Matikan Mode Zero-Loading',
  'pos.sync_history.title': 'Pusat Sinkronisasi',
  'pos.sync_history.note':
    'Lihat status sinkron transaksi yang tersimpan di browser ini ke server (menunggu, berhasil, atau gagal), dan kirim ulang yang gagal.',
  'pos.sync_history.open': 'Buka Riwayat',
  'pos.sync_history.status_failed': '{count} gagal',
  'pos.sync_history.status_waiting': '{count} menunggu',
  'pos.sync_history.status_synced': 'Semua tersinkron',
  'pos.sync_history.toast.offline': 'Tidak ada koneksi internet',
  'pos.sync_history.storage_warning':
    'Browser belum mengizinkan penyimpanan permanen. Transaksi yang belum tersinkron bisa hilang bila data browser dihapus — jangan hapus data situs sebelum semua transaksi tersinkron.',
  'pos.sync_history.other_users':
    '{count} transaksi milik kasir lain di browser ini akan dikirim saat kasir tersebut login kembali.',
  'pos.sync_history.disabled': 'Mode Zero-Loading belum aktif di browser ini.',
  'pos.sync_center.today': 'Hari ini',
  'pos.sync_center.yesterday': 'Kemarin',
  'pos.sync_center.sync_now': 'Sinkronkan Sekarang',
  'pos.sync_center.resolve': 'Selesaikan',
  'pos.sync_center.type.invoice': 'Penjualan',
  'pos.sync_center.type.order': 'Order',
  'pos.sync_center.type.other': 'Transaksi tipe {id}',
  'pos.sync_center.action.update': 'ubah',
  'pos.sync_center.action.pay': 'bayar',
  'pos.sync_center.action.close': 'tutup',
  'pos.sync_center.action.void': 'batal',
  'pos.sync_center.status.pending': 'Menunggu',
  'pos.sync_center.status.sent': 'Diproses',
  'pos.sync_center.status.done': 'Berhasil',
  'pos.sync_center.status.failed': 'Perlu tindakan',
  'pos.sync_center.status.blocked': 'Menunggu transaksi lain',
  'pos.sync_center.status.discarded': 'Dibatalkan',
  'pos.sync_center.filter.action': 'Perlu Tindakan',
  'pos.sync_center.filter.progress': 'Diproses',
  'pos.sync_center.filter.done': 'Selesai',
  'pos.sync_center.filter.all': 'Semua',
  'pos.sync_center.hero.action': '{count} transaksi perlu tindakan',
  'pos.sync_center.hero.progress': '{count} transaksi sedang dikirim',
  'pos.sync_center.hero.synced': 'Semua transaksi tersinkron',
  'pos.sync_center.hero.also_progress': '{count} sedang dikirim',
  'pos.sync_center.hero.refresh': 'Muat ulang dari server',
  'pos.sync_center.hero.last_synced': 'Diperbarui {time}',
  'pos.sync_center.empty.action.title': 'Tidak ada yang perlu ditangani',
  'pos.sync_center.empty.action.desc': 'Semua transaksi offline sudah diterima server.',
  'pos.sync_center.empty.progress.title': 'Tidak ada yang sedang dikirim',
  'pos.sync_center.empty.progress.desc': 'Transaksi baru akan muncul di sini saat dikirim.',
  'pos.sync_center.empty.done.title': 'Belum ada transaksi selesai',
  'pos.sync_center.empty.done.desc': 'Transaksi yang tercatat atau dibatalkan muncul di sini.',
  'pos.sync_center.empty.all.title': 'Semua transaksi tersinkron',
  'pos.sync_center.empty.all.desc': 'Belum ada transaksi di antrean sinkronisasi.',
  'pos.sync_center.step.created': 'Dibuat',
  'pos.sync_center.step.sent': 'Dikirim',
  'pos.sync_center.step.processed': 'Diproses',
  'pos.sync_center.step.result': 'Hasil',
  'pos.sync_center.step.done': 'Tercatat',
  'pos.sync_center.step.failed': 'Gagal',
  'pos.sync_center.step.blocked': 'Tertahan',
  'pos.sync_center.step.discarded': 'Dibatalkan',
  'pos.sync_center.detail.items': 'Item ({count})',
  'pos.sync_center.detail.paid': 'Dibayar ({count} pembayaran)',
  'pos.sync_center.detail.total': 'Total',
  'pos.sync_center.detail.product_deleted': 'Produk terhapus',
  'pos.sync_center.detail.saved_as': 'Tersimpan di server (ID {id})',
  'pos.sync_center.detail.empty_title': 'Pilih transaksi',
  'pos.sync_center.detail.empty_subtitle':
    'Detail, penyebab gagal, dan tindakan penyelesaian tampil di sini.',
  'pos.sync_center.issue.server_message': 'Pesan server',
  'pos.sync_center.issue.technical_detail': 'Detail teknis',
  'pos.sync_center.issue.attempts': 'Sudah dicoba {count}× · terakhir {time}',
  'pos.sync_center.issue.missing_product.title': 'Produk sudah dihapus',
  'pos.sync_center.issue.missing_product.desc':
    'Baris ke-{row} memakai produk yang dihapus saat perangkat offline. Buat ulang produknya, atau ganti dengan produk lain.',
  'pos.sync_center.issue.missing_contact.title': 'Pelanggan sudah dihapus',
  'pos.sync_center.issue.missing_contact.desc':
    'Pelanggan #{contact_id} pada transaksi ini sudah tidak ada. Buat ulang pelanggannya, atau pilih pelanggan lain.',
  'pos.sync_center.issue.locked_trans_date.title': 'Periode buku sudah ditutup',
  'pos.sync_center.issue.locked_trans_date.desc':
    'Transaksi tersinkron terlambat dan tanggalnya masuk periode yang sudah dikunci akuntansi.',
  'pos.sync_center.issue.locked_trans_date.sold_on': 'Tanggal jual',
  'pos.sync_center.issue.locked_trans_date.closed_until': 'Buku ditutup s/d',
  'pos.sync_center.issue.locked_trans_date.will_book':
    'Bila digeser, transaksi dibukukan pada {date} (tanggal terbuka pertama).',
  'pos.sync_center.issue.target_not_found.title': 'Menunggu transaksi lain',
  'pos.sync_center.issue.target_not_found.desc':
    'Transaksi yang dirujuk (#{ref}) belum ada di server. Bila transaksi itu sudah tersinkron, tekan Coba Lagi; bila ID-nya salah, arahkan ke transaksi yang benar.',
  'pos.sync_center.issue.duplicate_transaction.title': 'Kemungkinan transaksi ganda',
  'pos.sync_center.issue.duplicate_transaction.desc':
    'Transaksi ini mirip dengan yang sudah tercatat di server (nomor & isi sama). Bandingkan dulu sebelum memutuskan.',
  'pos.sync_center.issue.duplicate_transaction.open_invoice':
    'Lihat invoice #{id} untuk dibandingkan',
  'pos.sync_center.issue.business_rule.title': 'Ditolak aturan transaksi',
  'pos.sync_center.issue.business_rule.desc':
    'Server menolak isi transaksi ini. Perbaiki transaksinya sesuai pesan di bawah.',
  'pos.sync_center.issue.internal_error.title': 'Gangguan server',
  'pos.sync_center.issue.internal_error.desc':
    'Bukan kesalahan kasir — server gagal memproses dan hasilnya tidak tercatat. Aman untuk dicoba lagi.',
  'pos.sync_center.issue.upload_failed.title': 'Gagal dikirim ke server',
  'pos.sync_center.issue.upload_failed.desc':
    'Transaksi belum pernah diterima server setelah beberapa percobaan.',
  'pos.sync_center.issue.unsupported.title': 'Tidak didukung lagi',
  'pos.sync_center.issue.unsupported.desc':
    'Jenis perubahan ini sudah tidak didukung server. Transaksi hanya bisa dibatalkan.',
  'pos.sync_center.issue.unknown.title': 'Gagal diproses server',
  'pos.sync_center.issue.unknown.desc': 'Server tidak dapat memproses transaksi ini.',
  'pos.sync_center.choice.retry_as_is': 'Coba Lagi',
  'pos.sync_center.choice.retry_as_is_desc':
    'Kirim ulang tanpa perubahan (mis. setelah admin memperbaiki datanya)',
  'pos.sync_center.choice.create_product': 'Buat Ulang Produk',
  'pos.sync_center.choice.create_product_desc': 'Buat produk baru lalu kirim ulang',
  'pos.sync_center.choice.create_contact': 'Buat Ulang Pelanggan',
  'pos.sync_center.choice.create_contact_desc': 'Buat pelanggan baru lalu kirim ulang',
  'pos.sync_center.choice.shift_trans_date': 'Geser ke Periode Terbuka',
  'pos.sync_center.choice.shift_trans_date_desc': 'Bukukan pada tanggal terbuka pertama',
  'pos.sync_center.choice.retarget': 'Arahkan ke Transaksi Lain',
  'pos.sync_center.choice.retarget_desc': 'Masukkan ID transaksi server yang benar',
  'pos.sync_center.choice.edit_transaction': 'Ubah Transaksi',
  'pos.sync_center.choice.edit_transaction_desc': 'Buka di kasir, perbaiki, lalu kirim ulang',
  'pos.sync_center.choice.discard': 'Batalkan transaksi',
  'pos.sync_center.choice.other_options': 'Opsi lain',
  'pos.sync_center.choice.danger_zone': 'Zona bahaya',
  'pos.sync_center.choice.missing_permission':
    'Beberapa tindakan disembunyikan karena akun ini butuh izin: {permissions}. Minta supervisor.',
  'pos.sync_center.choice.duplicate_heading': 'Apakah penjualan ini sudah tercatat?',
  'pos.sync_center.choice.duplicate_hint':
    'Bandingkan total & pembayaran dengan invoice di atas, lalu pilih salah satu.',
  'pos.sync_center.choice.duplicate_discard': 'Sudah tercatat — batalkan salinan ini',
  'pos.sync_center.choice.duplicate_discard_desc': 'Salinan ini tidak akan dicatat',
  'pos.sync_center.choice.duplicate_retry_as_is': 'Transaksi berbeda — kirim tetap',
  'pos.sync_center.choice.duplicate_retry_as_is_desc': 'Catat sebagai penjualan terpisah',
  'pos.sync_center.choice.duplicate_edit_transaction': 'Ubah dulu transaksinya',
  'pos.sync_center.choice.duplicate_edit_transaction_desc': 'Buka di kasir sebelum dikirim ulang',
  'pos.sync_center.confirm.discard.title': 'Batalkan transaksi?',
  'pos.sync_center.confirm.discard.desc': 'Transaksi tidak akan pernah tercatat di Kledo.',
  'pos.sync_center.confirm.discard.submit': 'Batalkan Transaksi',
  'pos.sync_center.confirm.discard.warning':
    'Tindakan ini tidak bisa diurungkan. Bila pelanggan sudah membayar, pastikan penjualannya tercatat di tempat lain.',
  'pos.sync_center.confirm.discard.ack': 'Saya mengerti transaksi ini tidak akan tercatat',
  'pos.sync_center.confirm.shift_trans_date.title': 'Geser ke periode terbuka?',
  'pos.sync_center.confirm.shift_trans_date.desc':
    'Server memindahkan tanggal ke hari pertama setelah tanggal kunci dan mencatat tanggal asli di memo. Penjualan akan dibukukan lebih lambat dari kejadiannya.',
  'pos.sync_center.confirm.shift_trans_date.submit': 'Geser & Kirim Ulang',
  'pos.sync_center.confirm.duplicate_retry.title': 'Kirim sebagai transaksi terpisah?',
  'pos.sync_center.confirm.duplicate_retry.desc':
    'Pastikan ini memang penjualan berbeda. Bila sama, penjualan akan tercatat dua kali.',
  'pos.sync_center.confirm.duplicate_retry.submit': 'Ya, Kirim Tetap',
  'pos.sync_center.confirm.retry.title': 'Kirim ulang?',
  'pos.sync_center.confirm.retry.desc': 'Transaksi dikirim ulang tanpa perubahan.',
  'pos.sync_center.confirm.retry.submit': 'Kirim Ulang',
  'pos.sync_center.form.back': 'Kembali',
  'pos.sync_center.form.cancel': 'Batal',
  'pos.sync_center.form.search': 'Cari...',
  'pos.sync_center.form.create_and_retry': 'Buat & Kirim Ulang',
  'pos.sync_center.form.create_product_desc':
    'Produk di baris ke-{row} akan diganti dengan produk baru ini di semua baris yang memakainya.',
  'pos.sync_center.form.product_name': 'Nama produk',
  'pos.sync_center.form.product_name_placeholder': 'mis. Es Kopi Susu',
  'pos.sync_center.form.category': 'Kategori',
  'pos.sync_center.form.category_placeholder': 'Pilih kategori',
  'pos.sync_center.form.unit_price': 'Harga jual',
  'pos.sync_center.form.name_required': 'Nama wajib diisi',
  'pos.sync_center.form.category_required': 'Kategori wajib dipilih',
  'pos.sync_center.form.price_required': 'Harga jual wajib diisi',
  'pos.sync_center.form.create_contact_desc':
    'Pelanggan baru menggantikan pelanggan #{id} pada transaksi ini.',
  'pos.sync_center.form.contact_name': 'Nama pelanggan',
  'pos.sync_center.form.contact_name_placeholder': 'mis. Budi Santoso',
  'pos.sync_center.form.contact_type': 'Tipe kontak',
  'pos.sync_center.form.contact_type_customer': 'Pelanggan',
  'pos.sync_center.form.retarget_desc':
    'Masukkan ID transaksi di server (angka). Transaksi buatan perangkat yang belum tersinkron tidak bisa dirujuk.',
  'pos.sync_center.form.retarget_submit': 'Arahkan & Kirim Ulang',
  'pos.sync_center.form.ref_id': 'ID transaksi server',
  'pos.sync_center.form.ref_id_required': 'ID transaksi wajib diisi',
  'pos.sync_center.form.ref_id_numeric': 'ID transaksi harus berupa angka',
  'pos.sync_center.form.note_required_label': 'Alasan (wajib)',
  'pos.sync_center.form.note_optional_label': 'Catatan (opsional)',
  'pos.sync_center.form.note_placeholder': 'Tulis alasan untuk jejak audit',
  'pos.sync_center.form.note_required': 'Alasan wajib diisi',
  'pos.sync_center.form.note_max': 'Maksimal 255 karakter',
  'pos.sync_center.form.ack_required': 'Centang konfirmasi untuk melanjutkan',
  'pos.sync_center.form.duplicate_note': 'duplikat dari #{id}',
  'pos.sync_center.toast.queued': 'Dikirim ulang — menunggu hasil dari server',
  'pos.sync_center.toast.discarded': 'Transaksi dibatalkan',
  'pos.sync_center.toast.failed': 'Gagal menyelesaikan transaksi',
  'pos.sync_center.toast.uploaded': '{count} transaksi terkirim ke server',
  'pos.sync_center.toast.resent': '{count} transaksi dikirim ulang',
  'pos.sync_center.toast.offline': 'Tidak ada koneksi internet',
  'pos.sync_center.toast.all_synced': 'Semua transaksi sudah tersinkron',
  'pos.sync_center.toast.needs_decision': '{count} transaksi menunggu keputusan Anda',
  'pos.sync_center.toast.no_device': 'Perangkat belum teregistrasi',
  'pos.sync_center.toast.sync_failed': 'Sinkronisasi gagal, coba lagi',
  'pos.sync_center.correction.loading': 'Memuat transaksi...',
  'pos.sync_center.correction.load_failed': 'Gagal memuat transaksi ke kasir',
  'pos.sync_center.correction.banner_title': 'Mengoreksi {ref}',
  'pos.sync_center.correction.banner_original': 'Total asli {amount}',
  'pos.sync_center.correction.banner_current': 'sekarang {amount}',
  'pos.sync_center.correction.cancel': 'Batal koreksi',
  'pos.sync_center.correction.cancel_title': 'Batalkan koreksi?',
  'pos.sync_center.correction.cancel_message':
    'Isi kasir dikosongkan. Transaksi tetap gagal di Pusat Sinkronisasi dan bisa dikoreksi lagi nanti.',
  'pos.sync_center.correction.cancel_ok': 'Ya, Batalkan',
  'pos.sync_center.correction.cancelled': 'Koreksi dibatalkan',
  'pos.sync_center.correction.sent': 'Koreksi dikirim — menunggu hasil dari server',
  'pos.sync_center.correction.not_resolvable':
    'Transaksi ini sudah tidak bisa dikoreksi (statusnya berubah)',
  'pos.sync_center.correction.missing_permission':
    'Akun ini butuh izin {permissions} untuk mengirim koreksi',
  'pos.sync_center.correction.no_deferred':
    'Koreksi transaksi tidak bisa memakai QRIS / payment gateway',
  'pos.sync_center.correction.use_pay': 'Transaksi ini dikoreksi lewat tombol Bayar',
  'pos.sync_center.correction.use_save': 'Order ini dikoreksi lewat tombol Simpan',
  'pos.sync_center.close_shift.title': 'Antrean sinkron belum tuntas',
  'pos.sync_center.close_shift.message': 'Selesaikan dulu agar total shift di server lengkap.',
  'pos.sync_center.close_shift.action': 'Perlu tindakan',
  'pos.sync_center.close_shift.progress': 'Sedang dikirim',
  'pos.sync_center.close_shift.open': 'Buka Pusat Sinkronisasi',
  'pos.sync_center.close_shift.later': 'Nanti',
  'pos.sync_center.issue.shift_closed.title': 'Shift sudah ditutup',
  'pos.sync_center.issue.shift_closed.desc':
    'Shift #{shift} tempat penjualan ini dibuat sudah ditutup (biasanya dari web atau perangkat lain) sebelum transaksi tersinkron. Penjualan perlu dipindah ke shift yang masih terbuka, atau dimasukkan ke shift asalnya.',
  'pos.sync_center.choice.move_shift': 'Pindah ke Shift Terbuka',
  'pos.sync_center.choice.move_shift_desc':
    'Catat di shift yang masih berjalan; tanggal jual tetap',
  'pos.sync_center.choice.bypass_shift_closed': 'Masukkan ke Shift Asal',
  'pos.sync_center.choice.bypass_shift_closed_desc':
    'Laporan & setoran shift yang sudah ditutup ikut berubah',
  'pos.sync_center.confirm.bypass_shift_closed.title': 'Masukkan ke shift yang sudah ditutup?',
  'pos.sync_center.confirm.bypass_shift_closed.desc':
    'Penjualan dicatat ke shift aslinya, lalu angka shift itu dihitung ulang.',
  'pos.sync_center.confirm.bypass_shift_closed.submit': 'Masukkan ke Shift Asal',
  'pos.sync_center.confirm.bypass_shift_closed.ack':
    'Saya menyetujui perubahan pada shift yang sudah ditutup',
  'pos.sync_center.form.move_shift_desc':
    'Pilih shift yang masih terbuka di outlet yang sama. Tanggal penjualan tidak berubah.',
  'pos.sync_center.form.move_shift_submit': 'Pindah & Kirim Ulang',
  'pos.sync_center.form.move_shift_mine': 'Shift Anda saat ini',
  'pos.sync_center.form.move_shift_recommended': 'Disarankan',
  'pos.sync_center.form.move_shift_opened': 'Shift #{id} · dibuka {time}',
  'pos.sync_center.form.move_shift_load_failed':
    'Gagal memuat shift lain di outlet ini. Ketuk untuk coba lagi.',
  'pos.sync_center.form.move_shift_note_placeholder': 'mis. sync telat, masuk shift sore',
  'pos.sync_center.confirm.discard_local.title': 'Batalkan transaksi yang belum terkirim?',
  'pos.sync_center.confirm.discard_local.desc':
    'Server belum pernah mengonfirmasi transaksi ini, jadi perangkat berhenti mengirimnya.',
  'pos.sync_center.confirm.discard_local.submit': 'Batalkan Transaksi',
  'pos.sync_center.confirm.discard_local.warning':
    'Bila sebelumnya ada gangguan jaringan, transaksi bisa saja sudah sampai ke server. Cek dulu daftar penjualan di Kledo sebelum membatalkan.',
  'pos.sync_center.edit_confirm.title': 'Buka transaksi di kasir?',
  'pos.sync_center.edit_confirm.desc':
    'Isi transaksi dimuat ke kasir. Ubah seperlunya, lalu tekan Bayar / Simpan untuk mengirim koreksi. Nomor, tanggal, dan shift asli tetap dipakai — tidak ada transaksi baru.',
  'pos.sync_center.edit_confirm.submit': 'Buka di Kasir',
  'pos.sync_center.edit_confirm.cart_cleared':
    'Keranjang kasir saat ini ({count} item) akan dikosongkan.',
  'pos.sync_center.edit_confirm.other_correction':
    'Koreksi {ref} yang sedang berjalan akan dibatalkan.',
  'pos.sync_center.edit_confirm.repay':
    'Pembayaran perlu dimasukkan ulang. Sebelumnya dibayar {amount}.',
  'pos.sync_center.correction.banner_paid': 'Dibayar sebelumnya {amount}',
  'pos.sync_center.title': 'Pusat Sinkronisasi',
  'pos.sync_center.subtitle':
    'Pantau transaksi offline di browser ini dan selesaikan yang ditolak server.',
  'pos.sync_center.detail.close': 'Tutup',
  'pos.sync_center.correction.cart_not_empty':
    'Keranjang kasir masih berisi. Kosongkan atau selesaikan dulu sebelum mengoreksi transaksi.',
  'pos.close_shift.devices_title': 'Device lain masih membuka shift ini',
  'pos.close_shift.devices_desc':
    'Tutup shift di device berikut terlebih dahulu agar data shift lengkap.',
  'pos.close_shift.unnamed_device': 'Device tanpa nama',
  'pos.close_shift.this_browser': 'Browser ini',
  'pos.close_shift.device_id': 'ID',
  'pos.close_shift.force_close': 'Tutup Paksa',
  'pos.close_shift.force_title': 'Tutup shift secara paksa?',
  'pos.close_shift.force_subtitle':
    'Shift akan ditutup tanpa menunggu device lain. Pahami risikonya sebelum melanjutkan.',
  'pos.close_shift.force_risk_unsynced':
    'Transaksi di device lain yang belum terkirim tidak akan masuk ke rekap shift ini.',
  'pos.close_shift.force_risk_rejected':
    'Transaksi yang dikirim device lain setelah shift ditutup bisa ditolak dan perlu ditangani di Pusat Sinkronisasi device tersebut.',
  'pos.close_shift.force_risk_recap':
    'Selisih kas atau rekap shift perlu dicek dan dikoreksi secara manual.',
  'pos.close_shift.force_zero_loading_title': 'Memakai Mode Zero-Loading?',
  'pos.close_shift.force_zero_loading_desc':
    'Transaksi disimpan di device dulu sebelum dikirim ke server. Cek dulu di Kledo apakah semua transaksi dari device di atas sudah masuk sebelum menutup paksa.',
  'pos.close_shift.force_acknowledge': 'Saya sudah mengecek dan memahami risikonya',
  'pos.close_shift.force_confirm': 'Ya, Tutup Paksa',
  'pos.shift.closed_on_server':
    'Shift ini sudah ditutup (oleh sistem atau perangkat lain). Silakan buka shift baru.',
  'pos.shift.closed_by_system':
    'Shift ini sudah ditutup otomatis oleh sistem. Silakan buka shift baru.',
  'pos.device.checking': 'Memeriksa perangkat…',
  'pos.device.checking_desc':
    'Sebentar, kami memastikan browser ini terdaftar sebagai perangkat kasir.',
  'pos.device.register_title': 'Daftarkan browser ini',
  'pos.device.register_desc':
    'Browser ini belum terdaftar sebagai perangkat kasir. Beri nama supaya mudah dikenali saat beberapa perangkat memakai shift yang sama.',
  'pos.device.nickname': 'Nama perangkat',
  'pos.device.nickname_placeholder': 'mis. Kasir Depan',
  'pos.device.nickname_required': 'Nama perangkat wajib diisi',
  'pos.device.register': 'Daftarkan',
  'pos.device.register_success': 'Perangkat berhasil didaftarkan',
  'pos.device.register_failed': 'Gagal mendaftarkan perangkat',
  'pos.device.device_id': 'ID perangkat',
  'pos.logout.pending_title': 'Transaksi belum tersinkron',
  'pos.logout.pending_desc':
    'Masih ada {count} transaksi yang belum tersinkron. Transaksi ini baru akan dikirim saat Anda login lagi di browser ini.',
  'pos.logout.sync_first': 'Sinkronkan dulu',
  'pos.logout.logout_anyway': 'Tetap keluar',
  'pos.zero_loading.share_after_sync':
    'Kirim struk via WA/Email tersedia setelah transaksi tersinkron ke server.',
  'pos.zero_loading.saved_offline': 'Tersimpan, sedang disinkronkan ke server',
  'pos.web_order_payment.title': 'Bayar Langsung Web Order POS',
  'pos.web_order_payment.note':
    'Jika diaktifkan, order yang masuk dari Web Order POS bisa langsung dibayar.',
  'pos.invoice_types.title': 'Jenis Order',
  'pos.invoice_types.note':
    'Atur jenis order yang bisa dipilih kasir. Jenis yang disembunyikan tidak muncul di kasir, transaksi lama tetap aman. Perubahan berlaku di perangkat kasir lain setelah halaman dimuat ulang.',
  'pos.invoice_types.visible_count': '{visible} dari {total} tampil di kasir',
  'pos.invoice_types.built_in': 'Bawaan',
  'pos.invoice_types.custom': 'Kustom',
  'pos.invoice_types.shown': 'Tampil di kasir',
  'pos.invoice_types.hidden': 'Disembunyikan',
  'pos.invoice_types.add': 'Tambah Jenis Order',
  'pos.invoice_types.add_title': 'Tambah Jenis Order',
  'pos.invoice_types.edit_title': 'Ubah Jenis Order',
  'pos.invoice_types.name': 'Nama jenis order',
  'pos.invoice_types.name_placeholder': 'Contoh: Katering',
  'pos.invoice_types.name_required': 'Nama jenis order wajib diisi',
  'pos.invoice_types.rename_note':
    'Nama baru juga akan tampil di transaksi dan laporan lama yang memakai jenis order ini.',
  'pos.invoice_types.custom_empty':
    'Belum ada jenis order kustom. Tambahkan sesuai kebutuhan bisnis Anda, misalnya Katering atau Pre-order.',
  'pos.invoice_types.confirm_delete': 'Hapus jenis order ini?',
  'pos.invoice_types.cannot_delete_title': 'Jenis order tidak bisa dihapus',
  'pos.invoice_types.hide_instead':
    'Sembunyikan saja dari kasir agar tidak bisa dipilih lagi. Transaksi lama tetap aman.',
  'pos.invoice_types.hide': 'Sembunyikan',
  'pos.invoice_types.load_failed': 'Gagal memuat jenis order.',
  'pos.invoice_types.retry': 'Coba lagi',
  'pos.invoice_types.edit': 'Ubah',
  'pos.invoice_types.delete': 'Hapus',
  'pos.invoice_types.save_failed': 'Gagal menyimpan jenis order.',
  'pos.invoice_types.delete_failed': 'Gagal menghapus jenis order.',
  'pos.product_image': 'Gambar Produk',
  'pos.product_image_required': 'Gambar produk wajib diisi',
  'pos.choose_category_required': 'choose kategori wajib diisi',
  'pos.choose_category': 'Pilih Kategori',
  'pos.product_name_required': 'nama produk wajib diisi',
  'pos.price': 'Harga',
  'pos.price_required': 'price wajib diisi',
  'pos.extra_price_must_greather_than_0': 'Harga harus lebih besar dari 0.',
  'pos.base_price': 'Base Harga',
  'pos.base_price_required': 'Base Harga wajib diisi',
  'pos.description': 'Deskripsi',
  'pos.description_required': 'Description wajib diisi',
  'pos.edit_product': 'Ubah Produk',
  'pos.variant': 'Variant',
  'pos.variant_name_required': 'variant name wajib diisi',
  'pos.edit_variant': 'Ubah Variant',
  'financeInvoices.message': 'Pesan',
  'financeInvoices.show_more_detail': 'Lihat lebih lengkap',
  'financeInvoices.show_less_detail': 'Sembunyikan detail',
  'financeInvoices.order_payment': 'Pembayaran Pemesanan',
  'financeInvoices.add_invoice': 'Tambah Tagihan',
  'financeInvoices.financeInvoices': 'Tagihan',
  'financeInvoices.error_cannot_print_pdf': 'Tidak dapat membuat pdf tagihan.',
  'financeInvoices.error_cannot_export_receipt': 'Tidak dapat ekspor kwitansi',
  'financeInvoices.successfully_added': 'berhasil ditambahkan.',
  'financeInvoices.error_cannot_add': 'Tidak dapat menambah tagihan.',
  'financeInvoices.error_cannot_update': 'Tidak dapat mengubah tagihan.',
  'financeInvoices.error_cannot_move': 'Tidak dapat memindah tagihan.',
  'financeInvoices.error_cannot_change_status': 'Gagal mengubah status tagihan.',
  'financeInvoices.edit_invoice': 'Ubah tagihan',
  'financeInvoices.max_characters': 'Maks {value} karakter.',
  'financeInvoices.min_characters': 'Min {value} karakter.',
  'financeInvoices.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeInvoices.description': 'Deskripsi',
  'financeInvoices.tax': 'Pajak',
  'financeInvoices.dpp': 'DPP',
  'financeInvoices.select_tax': 'Pilih pajak',
  'financeInvoices.no_tax': 'Tanpa Pajak',
  'financeInvoices.please_select_a_contact': 'Silakan pilih kontak',
  'financeInvoices.select_contact': 'Pilih kontak',
  'financeInvoices.add_contact': 'Tambah kontak',
  'financeInvoices.all_contacts': 'Semua kontak',
  'financeInvoices.transaction_date': 'Tgl. Transaksi',
  'financeInvoices.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeInvoices.due_date': 'Tgl. Jatuh Tempo',
  'financeInvoices.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financeInvoices.term': 'Termin',
  'financeInvoices.select_term': 'Pilih termin',
  'financeInvoices.add_term': 'Tambah termin',
  'financeInvoices.price_include_tax': 'Harga termasuk pajak',
  'financeInvoices.add_more': 'Tambah baris',
  'financeInvoices.number': 'Nomor',
  'financeInvoices.import_order_number': 'Nomor Pesanan',
  'financeInvoices.import_previous_trans_number_is_optional':
    'Kolom {column} bersifat opsional. Jika diisi, transaksi hasil import akan otomatis terhubung dengan transaksi tersebut, sama seperti proses Lanjutkan. Jika dikosongkan, transaksi dibuat tanpa referensi.',
  'financeInvoices.please_input_the_number': 'Silakan isikan nomor.',
  'financeInvoices.memo': 'Reference',
  'financeInvoices.date': 'Tanggal',
  'financeInvoices.payment_date': 'Tanggal Pembayaran',
  'financeInvoices.action': 'Aksi',
  'financeInvoices.paid_date': 'Tanggal Pelunasan',
  'financeInvoices.show_payment_amount': 'Tampilkan jumlah pelunasan',
  'financeInvoices.hide_payment_amount': 'Sembunyikan jumlah pelunasan',
  'financeInvoices.edit_total_payment':
    'Ubah total pembayaran. Nominal akan otomatis dialokasikan ke tiap tagihan dari atas ke bawah.',
  'financeInvoices.status': 'Status',
  'financeInvoices.payment_status': 'Status Pembayaran',
  'financeInvoices.balance_due': 'Sisa Tagihan',
  'financeInvoices.billed_to': 'Ditagihkan Kepada',
  'financeInvoices.payment_summary': 'Ringkasan Pembayaran',
  'financeInvoices.total_paid': 'Sudah Dibayar',
  'financeInvoices.percentage_paid': '{percent}% terbayar',
  'financeInvoices.transaction_detail': 'Detail Transaksi',
  'financeInvoices.please_select_a_term': 'Silakan pilih termin.',
  'financeInvoices.search_by_memo': 'Cari',
  'financeInvoices.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financeInvoices.detail_title': ' Tagihan {number}',
  'financeInvoices.customer': 'Pelanggan',
  'financeInvoices.reference': 'Reference',
  'financeInvoices.product': 'Produk',
  'financeInvoices.qty': 'Kuantitas',
  'financeInvoices.price': 'Harga',
  'financeInvoices.add_product': 'Tambah Produk',
  'financeInvoices.select_product': 'Pilih produk',
  'financeInvoices.attachments': 'Attachment',
  'financeInvoices.save_&_approve': 'Simpan & setujui',
  'financeInvoices.save_as_draft': 'Simpan sbg draft',
  'financeInvoices.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financeInvoices.please_select_a_product': 'Silakan pilih produk.',
  'financeInvoices.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financeInvoices.please_input_the_price': 'Silakan masukkan harga.',
  'financeInvoices.please_input_the_amount': 'Silakan masukkan total.',
  'financeInvoices.approve': 'Setujui',
  'financeInvoices.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financeInvoices.submit_for_approval': 'Ajukan approval',
  'financeInvoices.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financeInvoices.create_invoice': 'Buat Tagihan',
  'financeInvoices.amount_paid': 'Total Dibayar',
  'financeInvoices.paid_from': 'Terima pembayaran ke',
  'financeInvoices.add_payment': 'Terima Pembayaran',
  'financeInvoices.receive_a_payment': 'Terima pembayaran',
  'financeInvoices.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financeInvoices.payment': 'Pembayaran',
  'financeInvoices.detail_invoice': 'Detil Tagihan',
  'financeInvoices.number_quotes': 'Nomor Penawaran',
  'financeInvoices.amount': 'Jumlah',
  'financeInvoices.tax_code': 'Kode dan Nomor Seri Faktur',
  'financeInvoices.please_input_the_tax_code': 'Silakan masukkan kode dan nomor seri faktur.',
  'financeInvoices.error_cannot_change_tax_code':
    'Tidak dapat mengubah kode dan nomor seri faktur.',
  'financeInvoices.order': 'Nomor Pemesanan',
  'financeInvoices.quote': 'Nomor Penawaran',
  'financeInvoices.purchase_request': 'Nomor Permintaan Pembelian',
  'financeInvoices.delivery': 'Nomor Pengiriman',
  'financeInvoices.please_select_deliveries': 'Pilih minimal satu nomor pengiriman.',
  'financeInvoices.cannot_greather_than_order': 'Tidak dapat melebihi order.',
  'financeInvoices.down_payment': 'Uang muka',
  'financeInvoices.already_paid': 'Sudah dibayar',
  'financeInvoices.transaction': 'Transaksi',
  'financeInvoices.print_invoice': 'Faktur',
  'financeInvoices.whoever_have_this_link_can_see_pdf':
    'Siapapun yang memiliki link ini dapat melihat invoicenya seperti tampilan format PDF.',
  'financeInvoices.copy_link': 'Salin Link Faktur',
  'financeInvoices.send_email': 'Kirim Email Faktur',
  'financeInvoices.send_sms': 'Kirim SMS Faktur',
  'financeInvoices.send_wa': 'Kirim Whatsapp Faktur',
  'financeInvoices.sales_person': 'Sales Person',
  'financeInvoices.set_paid': 'Set Lunas',
  'financeInvoices.mass_payment': 'Pembayaran Massal',
  'financeInvoices.cannot_mass_payment': 'Tidak dapat pembayaran massal',
  'financeInvoices.can_be_paid': 'Bisa dilunaskan',
  'financeInvoices.cannot_be_paid': 'Tidak bisa dilunaskan',
  'financeInvoices.data_progress_paid': '{count} data dari total {total} telah dilunaskan',
  'financeInvoices.data_has_been_paid': 'Total {count} data telah berhasil dilunaskan',
  'financeInvoices.cash_payment': 'Bayar Tunai',
  'financeInvoices.with_credit_payment': 'Dengan Hutang',
  'financeInvoices.with_debit_payment': 'Dengan Piutang',
  'financeInvoices.payment_with_credit_memo': 'Pembayaran dengan Hutang',
  'financeInvoices.payment_with_debit_memo': 'Pembayaran dengan Piutang',
  'financeInvoices.follow_these_steps_to_import_your_invoices':
    'Ikuti langkah berikut untuk mengimport tagihanmu',
  'financeInvoices.create_mass_trans': 'Buat {title} Massal',
  'financeInvoices.can_be_created_to': 'Bisa dibuat {title}',
  'financeInvoices.cannot_be_created_to': 'Tidak bisa dibuat {title}',
  'financeInvoices.data_progress_create_trans': '{count} {title} dari total {total} telah dibuat',
  'financeInvoices.data_has_been_create_trans': 'Total {count} {title} telah berhasil dibuat',
  'financeInvoices.mass_create_result_more': 'dan {count} lainnya',
  'financeInvoices.data_partial_create_trans': '{count} dari {total} transaksi berhasil dibuat',
  'financeInvoices.1_download_your_invoices_template_file': '1. Download file template tagihan',
  'financeInvoices.start_by_downloading_our_invoices_csv':
    'Mulai dengan mengunduh file template Excel tagihan. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari tagihan-tagihanmu.',
  'financeInvoices.download_template_file': 'Download File Template',
  'financeInvoices.download_template_data_example_file': 'Download File Contoh',
  'financeInvoices.import': 'Import Tagihan',
  'financeInvoices.2_copy_your_invoices_into_the_template':
    '2. Salin detail tagihan ke dalam template',
  'financeInvoices.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail tagihan ke dalam file template dari Kledo. Pastikan detail tagihan sesuai dengan kolom header yang ada di template.',
  'financeInvoices.important': 'PENTING',
  'financeInvoices.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeInvoices.upload': 'Upload',
  'financeInvoices.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeInvoices.a_maximum_of_n_invoices_can_be_imported_at_a_time':
    'Maksimal {max} tagihan dapat diimport dalam satu waktu.',
  'financeInvoices.a_single_import_supports_up_to_n_rows':
    'Satu kali proses impor mendukung hingga {max} baris data Excel.',
  'financeInvoices.a_single_import_supports_up_to_n_rows_including_invoice_and_item':
    'Satu kali proses impor mendukung hingga {max} baris data Excel. Setiap baris dihitung, termasuk baris tagihan maupun item.',
  'financeInvoices.a_maximum_of_2500_invoices_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris tagihan maupun item.',
  'financeInvoices.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financeInvoices.import_actions_only_insert_new_invoices_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeInvoices.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeInvoices.you_can_only_upload_csv_file': 'Anda hanya dapat mengunggah file csv atau excel',
  'financeInvoices.upload_file': 'Upload File',
  'financeInvoices.check_the_imported_data': 'Cek Data',
  'financeInvoices.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financeInvoices.import_invoices_done': 'Import Berhasil',
  'financeInvoices.error_upload_file': 'Gagal mengunggah file.',
  'financeInvoices.file_not_found': 'File tidak ditemukan.',
  'financeInvoices.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financeInvoices.valid': 'Valid',
  'financeInvoices.invalid': 'Invalid',
  'financeInvoices.total': 'Total',
  'financeInvoices.import_now': 'Import Sekarang',
  'financeInvoices.contact_name': 'Nama Kontak',
  'financeInvoices.email': 'Email',
  'financeInvoices.address': 'Alamat',
  'financeInvoices.phone': 'Phone',
  'financeInvoices.invoice_date': 'Tanggal Tagihan',
  'financeInvoices.date_same_as_the_original_transaction':
    'Tanggalnya disamakan dengan transaksi asal',
  'financeInvoices.invoice_number': 'Nomor Invoice',
  'financeInvoices.product_name': 'Nama Produk',
  'financeInvoices.code_sku': 'Kode/SKU',
  'financeInvoices.tax_inclusive': 'Termasuk Pajak',
  'financeInvoices.paid': 'Lunas',
  'financeInvoices.paid_account': 'Akun Pembayaran',
  'financeInvoices.row_imported': '{imported} dari {total} baris diproses',
  'financeInvoices.inventory_account': 'Akun Penyimpanan',
  'financeInvoices.invoices_successfully_imported': '{rowCount} invoice berhasil diimport.',
  'financeInvoices.view_detail': 'Tampilkan detil',
  'financeInvoices.import_another_file': 'Import file lain',
  'financeInvoices.go_to_invoice_list': 'Ke halaman daftar invoice',
  'financeInvoices.success': 'Berhasil',
  'financeInvoices.failed': 'Gagal',
  'financeInvoices.error_cannot_import': 'Gagal import.',
  'financeInvoices.error': 'Error',
  'financeInvoices.import_invoices_in_progress': 'Import sedang berlangsung',
  'financeInvoices.import_invoices_is_still_in_progress': 'Import masih berjalan',
  'financeInvoices.import_warehouse_help_text':
    'Apabila saat melakukan import data dari marketplace diisikan kolom gudang-nya, maka otomatis produk yang terbentuk akibat dari transaksi yang diimport akan "lacak stok". Namun jika produk tidak diisi gudang, otomatis produknya akan "tidak lacak stok".',
  'financeInvoices.its_ok_to_close_this_page':
    'Tidak apa-apa untuk menutup halaman ini atau mengimport file lain. Ketika import selesai, Anda akan diberitahu melalui email.',
  'financeInvoices.duplicate_to_trans': 'Duplikat ke transaksi',
  'financeInvoices.you_can_only_upload_up_to':
    'Anda hanya dapat mengupload maksimum sebanyak {count} file',
  'financeInvoices.please_select_tag': 'Silahkan pilih tag',
  'financeInvoices.recurring_invoice': 'Tagihan Berulang',
  'financeInvoices.1_download_your_invoices_recurring_template_file':
    '1. Download file template tagihan berulang',
  'financeInvoices.start_by_downloading_our_invoices_recurring_csv':
    'Mulai dengan mengunduh file template Excel tagihan berulang. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari tagihan-tagihan berulangmu.',
  'financeInvoices.2_copy_your_invoices_recurring_into_the_template':
    '2. Salin detail tagihan berulang ke dalam template',
  'financeInvoices.invoice_recurring_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail tagihan berulang ke dalam file template dari Kledo. Pastikan detail tagihan berulang sesuai dengan kolom header yang ada di template.',
  'financeInvoices.cannot_upload_this_photo': 'Tidak bisa mengunggah foto ini.',
  'financeInvoices.import_invoice_return': 'Import Tagihan Retur',
  'financeInvoices.invoice_return_number': 'Nomor Tagihan Retur',
  'financeInvoices.import_return_product_name_or_code': 'Nama {product} atau Kode/SKU',
  'financeInvoices.1_download_your_invoices_return_template_file':
    '1. Download file template tagihan retur',
  'financeInvoices.start_by_downloading_our_invoices_return_csv':
    'Mulai dengan mengunduh file template Excel tagihan retur. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari tagihan-tagihan returmu.',
  'financeInvoices.2_copy_your_invoices_return_into_the_template':
    '2. Salin detail tagihan retur ke dalam template',
  'financeInvoices.invoice_return_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail tagihan retur ke dalam file template dari Kledo. Pastikan detail tagihan retur sesuai dengan kolom header yang ada di template.',
  'financeInvoices.follow_these_steps_to_import_your_invoices_return':
    'Ikuti langkah berikut untuk mengimport tagihan returmu',
  'financeBanks.edit_bank_statement': 'Edit Bank Statement',
  'financeBanks.error_load_data': 'Terjadi masalah saat mengambil data transaksi bank',
  'financeBanks.are_you_sure_to_revert': 'Apakah Anda yakin untuk melanjutkan ?',
  'financeBanks.error_cannot_revert': 'Tidak dapat melakukan revert',
  'financeBanks.add_bank': 'Tambah Bank',
  'financeBanks.financeBanks': 'Akun Kas & Bank',
  'financeBanks.manage_account': 'Atur Akun',
  'financeBanks.statement_balance': 'Saldo di bank',
  'financeBanks.balance_in_kledo': 'Saldo di kledo',
  'financeBanks.successfully_added': 'berhasil ditambahkan.',
  'financeBanks.error_cannot_add': 'Tidak dapat menambah bank.',
  'financeBanks.error_cannot_update': 'Tidak dapat mengubah bank.',
  'financeBanks.error_cannot_move': 'Tidak dapat memindah bank.',
  'financeBanks.error_cannot_change_status': 'Tidak dapat mengubah status bank.',
  'financeBanks.edit_bank': 'Ubah bank',
  'financeBanks.max_characters': 'Maks {value} karakter.',
  'financeBanks.min_characters': 'Min {value} karakter.',
  'financeBanks.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeBanks.description': 'Deskripsi',
  'financeBanks.tax': 'Pajak',
  'financeBanks.select_tax': 'Pilih pajak',
  'financeBanks.amount': 'Total',
  'financeBanks.please_select_a_contact': 'Silakan pilih kontak',
  'financeBanks.select_contact': 'Pilih kontak',
  'financeBanks.add_contact': 'Tambah kontak',
  'financeBanks.all_contacts': 'Semua kontak',
  'financeBanks.contact': 'Kontak',
  'financeBanks.transaction_date': 'Tanggal Transaksi',
  'financeBanks.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeBanks.payment_date': 'Tanggal Pembayaran',
  'financeBanks.please_select_payment_date': 'Silakan pilih tanggal pembayaran',
  'financeBanks.due_date': 'Tgl. Jatuh Tempo',
  'financeBanks.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financeBanks.term': 'Termin',
  'financeBanks.select_term': 'Pilih termin',
  'financeBanks.add_term': 'Tambah termin',
  'financeBanks.price_include_tax': 'Harga termasuk pajak',
  'financeBanks.add_more': 'Tambah baris',
  'financeBanks.number': 'Nomor',
  'financeBanks.please_input_the_number': 'Silakan isikan nomor.',
  'financeBanks.memo': 'Reference',
  'financeBanks.date': 'Tanggal',
  'financeBanks.status': 'Status',
  'financeBanks.balance_due': 'Sisa Tagihan',
  'financeBanks.please_select_a_account': 'Silakan pilih akun.',
  'financeBanks.search_by_memo': 'Cari',
  'financeBanks.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financeBanks.detail_title': ' Transaksi: {transTypeName}',
  'financeBanks.customer': 'Pelanggan',
  'financeBanks.reference': 'Reference',
  'financeBanks.attachments': 'Attachment',
  'financeBanks.save_&_approve': 'Simpan & setujui',
  'financeBanks.save_as_draft': 'Simpan sbg draft',
  'financeBanks.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financeBanks.please_input_the_amount': 'Silakan masukkan total.',
  'financeBanks.approve': 'Setujui',
  'financeBanks.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financeBanks.submit_for_approval': 'Ajukan approval',
  'financeBanks.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financeBanks.create_bank': 'Buat Bank',
  'financeBanks.amount_paid': 'Total Dibayar',
  'financeBanks.paid_from': 'Dibayar Dari',
  'financeBanks.add_payment': 'Tambah Pembayaran',
  'financeBanks.make_a_payment': 'Buat pembayaran',
  'financeBanks.select_paid_from': 'Pilih dibayar dari',
  'financeBanks.please_select_a_paid_from': 'Silakan pilih dibayar dari.',
  'financeBanks.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financeBanks.payment': 'Pembayaran',
  'financeBanks.detail_bank': 'Detil  Bank',
  'financeBanks.spent': 'Kirim',
  'financeBanks.received': 'Terima',
  'financeBanks.balance': 'Saldo',
  'financeBanks.transfer_money': 'Transfer Dana',
  'financeBanks.spend_money': 'Kirim Dana',
  'financeBanks.receive_money': 'Terima Dana',
  'financeBanks.receive_multi_invoice_payment': 'Terima Pembayaran Gabungan',
  'financeBanks.spend_multi_purchase_payment': 'Bayar Gabungan (Pembelian)',
  'multiInvoicePayment.bank_account': 'Akun Bank',
  'multiInvoicePayment.number': 'Nomor',
  'multiInvoicePayment.select_invoices': 'Pilih tagihan yang dilunasi',
  'multiInvoicePayment.select_customer_first': 'Pilih pelanggan dulu untuk menampilkan tagihan',
  'multiInvoicePayment.no_invoice': 'No. Faktur',
  'multiInvoicePayment.date': 'Tanggal',
  'multiInvoicePayment.remaining_due': 'Sisa Tagihan',
  'multiInvoicePayment.paid': 'Dibayar',
  'multiInvoicePayment.fees_title': 'Biaya / selisih (opsional)',
  'multiInvoicePayment.fee_type': 'Jenis Biaya',
  'multiInvoicePayment.nominal': 'Nominal',
  'multiInvoicePayment.add_fee_row': 'Tambah baris biaya',
  'multiInvoicePayment.subtotal_allocation': 'Subtotal alokasi',
  'multiInvoicePayment.total_transfer': 'Total transfer',
  'multiInvoicePayment.min_one_invoice': 'Pilih minimal satu tagihan',
  'multiInvoicePayment.amount_required': 'Isi nominal dibayar',
  'multiInvoicePayment.amount_exceeds_due': 'Nominal melebihi sisa tagihan',
  'multiInvoicePayment.different_currency': 'Tagihan dengan kurs berbeda harus dibayar terpisah',
  'multiInvoicePayment.please_select_fee': 'Pilih jenis biaya',
  'multiInvoicePayment.fee_value_required': 'Isi nominal biaya',
  'multiInvoicePayment.fee_value_not_zero': 'Nominal biaya tidak boleh 0',
  'multiInvoicePayment.max_fee_rows': 'Maksimal 5 baris biaya',
  'multiInvoicePayment.max_invoice_rows': 'Maksimal 50 tagihan',
  'multiInvoicePayment.saved': 'Pembayaran gabungan tersimpan',
  'multiInvoicePayment.no_unpaid_invoice': 'Tidak ada tagihan belum lunas untuk pelanggan ini',
  'financeBanks.auto_import_bank_statement': 'Import Transaksi Bank Otomatis',
  'financeBanks.manually_import_bank_statement': 'Import Transaksi Bank Manual',
  'financeBanks.from': 'Dari',
  'financeBanks.to': 'Ke',
  'financeBanks.bank_account': 'Akun Bank',
  'financeBanks.account_transactions': 'Transaksi di Kledo',
  'financeBanks.bank_statements': 'Transaksi di Bank',
  'financeBanks.reconcile': 'Rekonsiliasi',
  'financeBanks.reconcile_mass_reconcile_title': 'Rekonsiliasi Massal',
  'financeBanks.reconcile_mass_can_be_reconcile': 'Bisa direkonsiliasi',
  'financeBanks.reconcile_mass_cannot_be_reconcile': 'Tidak bisa di rekonsiliasi',
  'financeBanks.reconcile_mass_reconcile_are_you_sure':
    'Apakah Anda yakin untuk merekonsiliasi {count} data transaksi ini?',
  'financeBanks.reconcile_data_progress_deleted':
    '{count} data dari total {total} telah terekonsilasi',
  'financeBanks.search_by_reference': 'Cari',
  'financeBanks.please_select_a_from_account': 'Silakan pilih akun asal',
  'financeBanks.please_select_a_to_account': 'Silakan pilih akun tujuan',
  'financeBanks.transfer': 'Transfer',
  'financeBanks.edit_account_transaction': 'Ubah Transaksi Akun',
  'financeBanks.error_cannot_transfer_money': 'Gagal transfer dana',
  'financeBanks.the_to_account_cannot_be_same_with_from_account':
    'Akun tujuan tidak boleh sama dengan akun asal.',
  'financeBanks.the_from_account_cannot_be_same_with_to_account':
    'Akun tujuan tidak boleh sama dengan akun asal.',
  'financeBanks.new_transaction': 'Transaksi Baru',
  'financeBanks.source': 'Sumber',
  'financeBanks.confirm_delete_bank_statement_p1':
    'Tindakan ini akan mengubah saldo rekening Anda di Kledo.',
  'financeBanks.confirm_delete_bank_statement_p2':
    'Pada umumnya tindakan ini hanya dilakukan untuk menghapus transaksi rekening duplikat.',
  'financeBanks.follow_these_steps_to_import_your_transactions':
    'Ikuti langkah-langkah berikut untuk meng-import transaksi',
  'financeBanks.import_bank_transactions': 'Import Transaksi Bank',
  'financeBanks.you_can_only_upload_csv_file': 'Anda hanya dapat mengunggah file csv atau excel',
  'financeBanks.upload_file': 'Upload',
  'financeBanks.set_import_options': 'Opsi Import',
  'financeBanks.import_statement_done': 'Selesai',
  'financeBanks.error_upload_file': 'Gagal mengunggah file.',
  'financeBanks.file_not_found': 'File tidak ditemukan.',
  'financeBanks.statement_heading': 'Header Statement',
  'financeBanks.statement_value': 'Isi Statement',
  'financeBanks.assign_to': 'Assign Ke',
  'financeBanks.please_select_a_assign_to': 'Silakan pilih assign ke.',
  'financeBanks.select_assign_to': 'Pilih assign ke',
  'financeBanks.rows_uploaded_set_the_import_options':
    '{rowCount} baris berhasil diunggah. Lakukan setting opsi import di bawah dan klik tombol Import Sekarang untuk melanjutkan.',
  'financeBanks.please_select_a_date_format': 'Silakan pilih format tanggal.',
  'financeBanks.select_date_format': 'Pilih format tanggal',
  'financeBanks.dont_import_the_first_line':
    'Jangan import baris pertama, karena baris pertama merupakan header.',
  'financeBanks.import_now': 'Import Sekarang',
  'financeBanks.date_format': 'Format Tanggal',
  'financeBanks.error_cannot_import': 'Gagal import.',
  'financeBanks.1_in_a_new_window':
    '1. Bukan tab browser baru, buka dan login ke internet banking Anda.',
  'financeBanks.2_download_your_bank_statement': '2. Download mutasi bank Anda.',
  'financeBanks.file_type_must_be_csv': 'File harus berupa CSV',
  'financeBanks.3_upload_the_bank_statement_here': '3. Unggah mutasi bank disini.',
  'financeBanks.download_our_csv_template': 'Download template import dalam csv',
  'financeBanks.to_create_your_own_bank_statement_file': ' untuk membuat mutasi bank sendiri.',
  'financeBanks.import_maximum_of_1000_bank_statement_line_at_a_time':
    'Import maksimal 1000 baris mutasi dalam satu waktu.',
  'financeBanks.drop_the_file_to_upload': 'Drag file di sini untuk upload',
  'financeBanks.transaction_lines_successfully_imported':
    '{rowCount} baris mutasi berhasil diimport.',
  'financeBanks.view_detail': 'Lihat detil',
  'financeBanks.import_another_file': 'Import file yang lain lagi',
  'financeBanks.go_to_reconciliation': 'Rekonsiliasi sekarang',
  'financeBanks.success': 'Sukses',
  'financeBanks.failed': 'Gagal',
  'financeBanks.invalid_date': 'Tanggal Tidak Valid',
  'financeBanks.invalid_transaction_type': 'Tipe Transaksi Tidak Valid',
  'financeBanks.invalid_amount': 'Total Transaksi Tidak Valid',
  'financeBanks.total': 'Total',
  'financeBanks.review_your_bank_statement': 'Review mutasi bank mu...',
  'financeBanks.then_match_with_your_transactions_in_kledo':
    '...kemudian cocokkan dengan transaksi di Kledo',
  'financeBanks.bank_statement': 'Transaksi di bank',
  'financeBanks.go': 'Go',
  'financeBanks.show_received_item': 'Lihat transaksi masuk',
  'financeBanks.find_&_match': 'Cari & Cocokkan',
  'financeBanks.kledo_transaction': 'Transaksi Kledo',
  'financeBanks.journal_not_available': 'Detail jurnal belum tersedia, coba beberapa saat lagi',
  'financeBanks.subtotal': 'Subtotal',
  'financeBanks.must_match': 'Harus Sesuai',
  'financeBanks.difference': 'Selisih',
  'financeBanks.find_&_select_matching_transactions': '1. Cari dan temukan transaksi yang sesuai',
  'financeBanks.error_cannot_reconcile': 'Gagal tidak dapat merekonsiliasi.',
  'financeBanks.are_you_sure_to_reconcile': 'Apakah Anda yakin akan merekonsiliasi transaksi ini?',
  'financeBanks.reconcile_date_mismatch_confirm':
    'Tanggal transaksi bank dan transaksi Kledo Anda tidak sama. Apakah Anda yakin ingin melanjutkannya?',
  'financeBanks.difference_must_be_zero': 'Selisih harus 0.',
  'financeBanks.view_your_selected_transactions':
    '2. Lihat transaksi yang sudah dipilih, tambah transaksi baru sesuai kebutuhan.',
  'financeBanks.the_sum_of_your_selected_transactions_must_match_the_money_spent':
    '3. Jumlah total transaksi yang dipilih harus sesuai dengan mutasi bank. Lakukan penyesuaian sesuai kebutuhan.',
  'financeBanks.show_spent_item': 'Lihat transaksi keluar',
  'financeBanks.to_reconcile': 'Sampai',
  'financeBanks.transactions': 'Transaksi',
  'financeBanks.minimal_value': 'Minimal {value}',
  'financeBanks.maximal_value': 'Maksimal {value}',
  'financeBanks.error_cannot_print_pdf': 'Tidak dapat membuat pdf bank.',
  'financeBanks.print_receipt': 'Cetak Kuitansi',
  'financeBanks.print_remittance_advice': 'Cetak Bukti Kas Keluar',
  'financeBanks.print_cash_receipt': 'Cetak Bukti Kas Masuk',
  'financeBanks.print_expense_slip': 'Cetak Slip Pengeluaran',
  'financeBanks.print_purchase_payment': 'Cetak Pemberitahuan Pembayaran',
  'financeBanks.print_transfer': 'Cetak Bukti Transfer',
  'financeBanks.copy_link_receipt': 'Salin Link Kuitansi',
  'financeBanks.copy_link_remittance_advice': 'Salin Link Bukti Kas Keluar',
  'financeBanks.copy_link_cash_receipt': 'Salin Link Bukti Kas Masuk',
  'financeBanks.copy_link_expense_slip': 'Salin Link Slip Pengeluaran',
  'financeBanks.copy_link_purchase_payment': 'Salin Link Pemberitahuan Pembayaran',
  'financeBanks.copy_link_transfer': 'Salin Link Bukti Transfer',
  'financeBanks.send_email_receipt': 'Kirim Email Kuitansi',
  'financeBanks.send_email_remittance_advice': 'Kirim Email Bukti Kas Keluar',
  'financeBanks.send_email_cash_receipt': 'Kirim Email Bukti Kas Masuk',
  'financeBanks.send_email_expense_slip': 'Kirim Email Slip Pengeluaran',
  'financeBanks.send_email_purchase_payment': 'Kirim Email Pemberitahuan Pembayaran',
  'financeBanks.send_sms_receipt': 'Kirim SMS Kuitansi',
  'financeBanks.send_sms_remittance_advice': 'Kirim SMS Bukti Kas Keluar',
  'financeBanks.send_sms_cash_receipt': 'Kirim SMS Bukti Kas Masuk',
  'financeBanks.send_sms_expense_slip': 'Kirim SMS Slip Pengeluaran',
  'financeBanks.send_sms_purchase_payment': 'Kirim SMS Pemberitahuan Pembayaran',
  'financeBanks.send_wa_receipt': 'Kirim Whatsapp Kuitansi',
  'financeBanks.send_wa_remittance_advice': 'Kirim Whatsapp Bukti Kas Keluar',
  'financeBanks.send_wa_cash_receipt': 'Kirim Whatsapp Bukti Kas Masuk',
  'financeBanks.send_wa_expense_slip': 'Kirim Whatsapp Slip Pengeluaran',
  'financeBanks.send_wa_purchase_payment': 'Kirim Whatsapp Pemberitahuan Pembayaran',
  'financeBanks.receipt_will_be_sent_via': 'Kuitansi akan dikirim melalui',
  'financeBanks.1_download_your_bankStatement_template_file':
    '1. Download file template mutasi bank',
  'financeBanks.start_by_downloading_our_bankStatement_csv':
    'Mulai dengan mengunduh file template Excel mutasi bank. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari mutasi bank-mu.',
  'financeBanks.2_copy_your_bankStatement_into_the_template':
    '2. Salin detail mutasi bank ke dalam template',
  'financeBanks.a_maximum_of_500_bankStatement_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel.',
  'financeBanks.import_actions_only_insert_new_bankStatement_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeBanks.bankStatement_successfully_imported':
    '{rowCount} baris mutasi bank berhasil diimport.',
  'financeBanks.reconciliation_detail': 'Detil Rekonsiliasi',
  'financeBanks.detail': 'Detil',
  'financeBanks.mutasi_bank': 'Mutasi Bank',
  'financeBanks.transactions_on_kledo': 'Transaksi di Kledo',
  'financeBanks.bank_connect': 'Bank Connect',
  'financeBanks.bank_connect_not_found': 'Bank Connect tidak ditemukan',
  'financeBanks.bank_connect_fallback': 'Kembali ke halaman Bank Connect',
  'financeBanks.add_bank_connect': 'Tambah Bank Connect',
  'financeBanks.edit_bank_connect': 'Ubah Bank Connect',
  'financeBanks.choose_bank': 'Pilih bank yang akan dihubungkan ke Kledo',
  'financeBanks.bank_connected': 'Bank yang sudah terhubung ke Kledo',
  'financeBanks.account': 'Akun',
  'financeBanks.fill_out_the_form': 'Isi Formulir',
  'financeBanks.under_review': 'Dalam Peninjauan',
  'financeBanks.signature_and_send': 'Tanda Tangan & Kirim',
  'financeBanks.activation': 'Aktivasi',
  'financeBanks.submission': 'Pengajuan',
  'financeBanks.review': 'Review',
  'financeBanks.active': 'Aktif',
  'financeBanks.cannot_add_bank_connect': 'Tidak dapat menambah bank connect',
  'financeBanks.cannot_update_sort_order': 'Tidak dapat menyimpan pengurutan',
  'financeBanks.cannot_delete_bank_connect': 'Tidak dapat menghapus bank connect',
  'financeBanks.please_select_account': 'Silakan pilih akun',
  'financeBanks.send_submission': 'Kirim Pengajuan',
  'financeBanks.connect_to_account': 'Hubungkan ke Akun',
  'financeBanks.connect_company_desc_1':
    'Untuk dapat terhubung dengan Rekening BCA Bisnis, diperlukan pengaktifan fitur BCA API di rekening BCA Anda.',
  'financeBanks.connect_company_desc_2': 'Berikut langkah-langkah untuk pengaktifan BCA API:',
  'financeBanks.connect_company_desc_3': '- Masukkan data-data Anda pada form di halaman ini.',
  'financeBanks.connect_company_desc_4':
    '- Tim Hebat Kledo akan menghubungi Anda melalui WhatsApp untuk konfirmasi dan pengumpulan data lainnya.',
  'financeBanks.connect_company_desc_5':
    '- Form pengajuan pengaktifan BCA API akan dikirim Tim Hebat Kledo ke Bank BCA.',
  'financeBanks.connect_company_desc_6':
    '- BCA API aktif, dan mutasi rekening Anda akan otomatis terdownload ke Kledo.',
  'financeBanks.connect_company_desc_7': 'Beberapa hal yang perlu Anda ketahui:',
  'financeBanks.connect_company_desc_8':
    '- Untuk koneksi BCA API dikenakan biaya dari pihak BCA nya sebesar Rp50.000,- per bulan. Dari pihak Kledo tidak mengenakan biaya sama sekali',
  'financeBanks.connect_company_desc_9':
    '- Proses pengajuan pengaktifan dibutuhkan waktu sekitar 2-4 minggu.',
  'financeBanks.connect_company_desc_10':
    '- Koneksi BCA API yang dihubungkan dengan Kledo hanya mengambil data mutasi saja, tidak untuk melakukan transfer dana. Sehingga rekening Anda terjamin keamanannya.',
  'financeBanks.account_information': 'Informasi Rekening',
  'financeBanks.bank_account_type': 'Tipe Rekening Bank',
  'financeBanks.internet_banking_username': 'Username Internet Banking',
  'financeBanks.internet_banking_password': 'Password Internet Banking',
  'financeBanks.repeat_internet_banking_password': 'Ulangi Password Internet Banking',
  'financeBanks.please_input_ib_username': 'Silakan masukkan username internet banking',
  'financeBanks.please_input_ib_password': 'Silakan masukkan password internet banking',
  'financeBanks.last_get_data': 'Terakhir Ambil Data',
  'financeBanks.account_owner_name': 'Nama Pemilik Rekening',
  'financeBanks.account_number': 'Nomor Rekening',
  'financeBanks.please_input_account_owner_name': 'Silakan masukkan nama pemilik rekening',
  'financeBanks.please_input_account_number': 'Silakan masukkan nomor rekening',
  'financeBanks.scan_bank_book': 'Scan/Foto Buku Tabungan',
  'financeBanks.please_input_scan_bank_book': 'Silakan masukkan scan/foto buku tabungan',
  'financeBanks.identity_card_information': 'Informasi KTP',
  'financeBanks.company_information': 'Informasi Perusahaan',
  'financeBanks.trade_name': 'Nama Dagang',
  'financeBanks.please_input_trade_name': 'Silakan masukkan Nama Dagang',
  'financeBanks.website': 'Website',
  'financeBanks.please_input_website': 'Silakan masukkan Website',
  'financeBanks.company_email': 'Email Perusahaan',
  'financeBanks.please_input_company_email': 'Silakan masukkan Email Perusahaan',
  'financeBanks.please_input_a_valid_format_email': 'Silakan masukkan format Email yang valid',
  'financeBanks.company_tax_number': 'Nomor NPWP Perusahaan',
  'financeBanks.please_input_company_tax_number': 'Silakan masukkan Nomor NPWP Perusahaan',
  'financeBanks.company_account_number': 'Nomor Rekening Perusahaan',
  'financeBanks.please_input_company_account_number': 'Silakan masukkan Nomor Rekening Perusahaan',
  'financeBanks.office_address': 'Alamat Kantor',
  'financeBanks.please_input_office_address': 'Silakan masukkan Alamat Kantor',
  'financeBanks.corp_id': 'ID Perusahaan',
  'financeBanks.please_input_corp_id': 'Silakan masukkan ID Perusahaan',
  'financeBanks.main_pic': 'PIC Utama',
  'financeBanks.secondary_pic': 'PIC Kedua',
  'financeBanks.position': 'Posisi',
  'financeBanks.please_input_position': 'Silakan masukkan Posisi',
  'financeBanks.id_number': 'NIK',
  'financeBanks.please_input_id_number': 'Silakan masukkan NIK',
  'financeBanks.please_input_email': 'Silakan masukkan Email',
  'financeBanks.phone_number': 'Nomor Telepon',
  'financeBanks.please_input_phone_number': 'Silakan masukkan Nomor Telepon',
  'financeBanks.address_according_to_id_card': 'Alamat sesuai KTP',
  'financeBanks.please_input_address': 'Silakan masukkan Alamat',
  'financeBanks.name_on_bank_account_owner_card': 'Nama Sesuai KTP Pemilik Rekening',
  'financeBanks.identity_card_number': 'Nomor Induk Kependudukan (NIK)',
  'financeBanks.scan_identity_card': 'Scan/Foto KTP',
  'financeBanks.please_input_name_on_bank_account_owner_card': 'Silakan masukkan nama',
  'financeBanks.please_input_identity_card_number': 'Silakan masukkan NIK',
  'financeBanks.please_input_scan_identity_card': 'Silakan masukkan scan/foto KTP',
  'financeBanks.note': 'Catatan',
  'financeBanks.follow_these_steps_to_import_your_bankTrans':
    'Ikuti langkah-langkah berikut untuk meng-import transaksi bank',
  'financeBanks.1_download_your_bankTrans_template_file':
    '1. Download file template transaksi bank',
  'financeBanks.start_by_downloading_our_bankTrans_csv':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari transaksi bank-mu.',
  'financeBanks.download_template_file': 'Download File Template',
  'financeBanks.download_template_data_example_file': 'Download File Contoh',
  'financeBanks.import_bankTrans': 'Import Transaksi Bank',
  'financeBanks.2_copy_your_bankTrans_into_the_template':
    '2. Salin detail transaksi bank ke dalam template',
  'financeBanks.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail transaksi bank ke dalam file template dari Kledo. Pastikan detail transaksi bank sesuai dengan kolom header yang ada di template.',
  'financeBanks.important': 'PENTING',
  'financeBanks.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeBanks.upload': 'Upload',
  'financeBanks.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeBanks.a_maximum_of_500_bankTrans_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel. Setiap baris dihitung, termasuk baris transaksi bank maupun item.',
  'financeBanks.import_actions_only_insert_new_bankTrans_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeBanks.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeBanks.bankTrans_successfully_imported':
    '{rowCount} baris transaksi bank berhasil diimport.',
  'financeBanks.go_to_bankTrans_list': 'Ke halaman daftar transaksi bank',
  'financeBanks.revert_reconciliation': 'Batalkan Rekonsiliasi',
  'financeBanks.view_reconciliation': 'Lihat Rekonsiliasi',
  'financeBanks.import_with_bank_template': 'Import dengan format template dari Bank',
  'financeBanks.import_bca_1': '1. Login ke internet banking BCA Bisnis Anda',
  'financeBanks.import_bca_2': '2. Klik menu Informasi Rekening - Mutasi Rekening',
  'financeBanks.import_bca_3': '3. Pilih format download CSV, dan klik tombol download',
  'financeBanks.import_mandiri_1': '1. Login ke Kopra Mandiri',
  'financeBanks.import_mandiri_2': '2. Pilih menu Statement Report',
  'financeBanks.import_mandiri_3':
    '3. Klik Report Type kemudian pilih “Account Statement” dan Pilih Periodenya',
  'financeBanks.import_mandiri_4': '4. Klik Generate Report',
  'financeBanks.import_mandiri_5': '5. Klik Download',
  'financeBanks.import_mandiri_6': '6. Pilih File Type CSV',
  'financeBanks.import_mandiri_7': '7. Klik centang dan download pada file yang dipilih',
  'financeBanks.upload_downloaded_excel_on_form_below':
    '8. Unggah file Excel yang baru saja didownload pada form dibawah',
  'financeBanks.the_one_of_accounts_must_be_base_currency': 'Salah satu akun harus mata uang dasar',
  'financeBanks.data_has_been_reconciled': 'Data berhasil di rekonsiliasi.',
  'financeBanks.empty_bank_reconcile_data_message':
    'Untuk merekonsiliasi transaksi bank, silahkan melakukan<br/>import transaksi bank terlebih dahulu.',
  'financeBanks.bank_reconcile_click_here_to_import': 'Klik disini untuk import transaksi bank!',
  'financeBanks.search_bank_statement_at_kledo':
    'Cari mutasi bank yang sesuai dengan transaksi di Kledo',
  'financeBanks.your_selected_transactions':
    'Transaksi yang sudah dipilih, tambah transaksi baru sesuai kebutuhan.',
  'financeBanks.total_transaction_on_kledo_and_bank_mutation_must_be_same':
    'Total transaksi di Kledo harus sama dengan total mutasi',
  'financeBanks.total_transaction_on_kledo': 'Total transaksi di Kledo',
  'financeBanks.total_mutations': 'Total mutasi',
  'purchases.purchases': 'Ringkasan Pembelian',
  'purchases.purchases_invoices': 'Tagihan Pembelian',
  'purchases.awaiting_payment': 'Menunggu Pembayaran',
  'purchases.overdue': 'Jatuh Tempo',
  'purchases.purchases_total_last_30_days': 'Total Pembelian 30 Hari Terakhir',
  'purchases.purchases_total': 'Total Pembelian',
  'purchases.product': 'Produk',
  'purchases.qty': 'Jml',
  'purchases.value': 'Nilai',
  'purchases.payment_made': 'Pembayaran',
  'purchases.purchases_orders': 'Pesanan Pembelian',
  'purchases.draft': 'Draft',
  'purchases.awaiting_approval': 'Menunggu Approval',
  'purchases.approved': 'Disetujui',
  'sales.sales': 'Ringkasan Penjualan',
  'sales.invoices': 'Tagihan',
  'sales.awaiting_payment': 'Menunggu Pembayaran',
  'sales.overdue': 'Jatuh Tempo',
  'sales.purchases_total_last_30_days': 'Penjualan 30 Hari Terakhir',
  'sales.product_sales_last_30_days': 'Penjualan Per Produk 30 Hari Terakhir',
  'sales.product_sales': 'Penjualan Per Produk',
  'sales.sales_contact': 'Penjualan Per Pelanggan',
  'sales.purchases_vendor': 'Pembelian Per Vendor',
  'sales.payments.received': 'Pembayaran Diterima',
  'sales.quotes': 'Penawaran',
  'sales.draft': 'Draft',
  'sales.sent': 'Terkirim',
  'sales.accepted': 'Disetujui',
  'financeNumbers.automatic_sequencing': 'Penomoran Otomatis',
  'financeNumbers.automatic_sequencing_billing': 'Penomoran {title}',
  'financeNumbers.define_the_number_to_be_used':
    'Tentukan nomor yang digunakan untuk membuat penomoran tagihan. Nomor dibawah akan otomatis ditambah setiap dokumen baru dibuat.',
  'financeNumbers.section_desc': 'Atur format penomoran otomatis untuk {name}',
  'financeNumbers.prefix': 'Awalan',
  'financeNumbers.suffix': 'Akhiran',
  'financeNumbers.sequence': 'Nomor saat ini',
  'financeNumbers.please_input_the_next_number': 'Silakan isi nomor saat ini',
  'financeNumbers.sequence_error': 'Nomor saat ini tidak berhasil dibuat.',
  'financeNumbers.error_edit': 'Tidak dapat edit nomor.',
  'financeNumbers.error_check_exist': 'Tidak dapat memeriksa nomor.',
  'financeNumbers.number_is_used': 'Nomor telah di pakai, {link} untuk mendapatkan nomor baru.',
  'financeNumbers.number_format': 'Format Penomoran',
  'financeNumbers.automatic_numbering_output_example': 'Contoh Output Penomoran Otomatis',
  'financeNumbers.reset_number_every': 'Reset Nomor Setiap',
  'financeNumbers.never_reset': 'Tidak pernah reset',
  'financeNumbers.every_day': 'Setiap hari',
  'financeNumbers.every_month': 'Setiap bulan',
  'financeNumbers.every_year': 'Setiap tahun',
  'financeNumbers.on_date': 'Pada tanggal',
  'financeNumbers.add_numbering_code': 'Tambah Kode Penomoran',
  'financeNumbers.please_input_format': 'Silakan isi format nomor',
  'financeNumbers.please_input_date': 'Silakan isi tanggal',
  'financeNumbers.please_input_month': 'Silakan isi bulan',
  'financeNumbers.trans_number_same_as_original_trans':
    'Nomor transaksi disamakan dengan transaksi asal',
  'financeNumbers.trans_number_same_as_original_trans_desc':
    'Jika aktif, maka saat membuat tagihan dari pemesanan, nomornya akan disamakan dengan pemesanan. Begitu juga untuk transaksi lainnya.',
  'financeNumbers.auto_numbering_lock': 'Nomor transaksi dikunci supaya tidak dapat diubah',
  'financeNumbers.auto_numbering_lock_desc':
    'Jika aktif, maka nomor transaksi akan mengikuti sistem Kledo, tidak dapat diubah oleh pengguna.',
  'financeNumbers.default_settings': 'Pengaturan Default',
  'financeNumbers.add_setting': 'Tambah Pengaturan',
  'financeNumbers.setting_name': 'Nama Pengaturan',
  'financeNumbers.setting_name_is_required': 'Nama Pengaturan wajib diisi!',
  'financeNumbers.valid_for_bank_accounts': 'Berlaku untuk akun bank',
  'financeNumbers.bank_account_is_required': 'Akun bank wajib diisi!',
  'financeNumbers.select_bank_account': 'Pilih Akun Bank',
  'financeNumbers.last_reset_number_log':
    'Terakhir reset nomor pada {date}, [{clickHere}] untuk lihat log',
  'financeNumbers.reset_number_automatic': 'Reset Nomor Otomatis',
  'financeConversion.your_opening_balances_will_be_set_as_at':
    'Saldo awal akan di set per tanggal {date}',
  'financeConversion.conversion_date': 'Tanggal Konversi',
  'financeConversion.show_zero_balances': 'Tampilkan balance yang nol',
  'financeConversion.conversion_balances': 'Saldo Awal',
  'financeConversion.add_comparative_balances': 'Saldo Pembanding',
  'financeConversion.error_cannot_add_comparative_balances':
    'Tidak dapat menambah saldo pembanding',
  'financeConversion.error_cannot_save_comparative_balances':
    'Tidak dapat menyimpan saldo pembanding',
  'financeConversion.are_you_sure': 'Apakah Anda yakin?',
  'financeConversion.warning': 'Perhatian',
  'financeConversion.reversal_detail': 'Detail Reversal',
  'financeConversion.opening_balance': 'Opening Balance',
  'financeConversion.error_cannot_delete_comparative_balances': 'Gagal menghapus saldo awal',
  'financeConversion.confirm_balances': 'Konfirmasi saldo akun per {endDate}',
  'financeConversion.your_debit_and_credit_total_must_be_balanced':
    'Total debit dan kredi harus sama. Jika kamu tetap ingin menyimpannya, selisih sebesar {diff} akan disimpan sebagai Ekuitas saldo awal.',
  'financeConversion.enter_the_date_that_you_began_processing':
    'Masukkan tanggal Anda memulai memproses transaksi menggunakan Kledo. Akan lebih mudah jika Anda set tanggal konversi sama dengan awal dari periode pajak.',
  'financeConversion.error_cannot_save_conversion_date': 'Tidak dapat menyimpan tanggal konversi',
  'financeConversion.cannot_set_conversion_date':
    'Tidak dapat set tanggal konversi, karena telah dilakukan tutup buku pada bulan ini.',
  'financeConversion.back_to_account_list': 'Back to account list',
  'financeConversion.follow_these_steps_to_import_your_conversion_balance':
    'Ikuti langkah-langkah berikut untuk meng-import saldo awal',
  'financeConversion.1_download_your_conversion_balance_template_file':
    '1. Download file template saldo awal',
  'financeConversion.start_by_downloading_our_conversion_balance_csv':
    'Mulai dengan mengunduh file template Excel saldo awal. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari saldo awal-mu.',
  'financeConversion.download_template_file': 'Download File Template',
  'financeConversion.download_template_data_example_file': 'Download File Contoh',
  'financeConversion.import': 'Import Saldo Awal',
  'financeConversion.2_copy_your_conversion_balance_into_the_template':
    '2. Salin detail saldo awal ke dalam template',
  'financeConversion.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail saldo awal ke dalam file template dari Kledo. Pastikan detail saldo awal sesuai dengan kolom header yang ada di template.',
  'financeConversion.important': 'PENTING',
  'financeConversion.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeConversion.upload': 'Upload',
  'financeConversion.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeConversion.a_maximum_of_500_conversion_balance_can_be_imported_at_a_time':
    'Maksimal 1.000 saldo awal dapat diimport dalam satu waktu.',
  'financeConversion.import_actions_only_insert_new_conversion_balance_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeConversion.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeConversion.conversion_balance_successfully_imported':
    '{rowCount} baris saldo awal berhasil diimport.',
  'financeConversion.go_to_conversion_balance_list': 'Ke halaman daftar saldo awal',
  'financeManualJournal.add_manual_journal': 'Tambah Jurnal Umum',
  'financeManualJournal.financeManualJournal': 'Jurnal Umum',
  'financeManualJournal.successfully_added': 'berhasil ditambahkan',
  'financeManualJournal.error_cannot_add': 'Tidak dapat menambah jurnal umum',
  'financeManualJournal.error_cannot_update': 'Jurnal umum gagal diperbarui',
  'financeManualJournal.edit_manual_journal': 'Ubah Jurnal Umum',
  'financeManualJournal.max_characters': 'Maks. {value} karakter',
  'financeManualJournal.min_characters': 'Min. {value} karakter',
  'financeManualJournal.only_number_allowed': 'Hanya angka yang diperbolehkan',
  'financeManualJournal.description': 'Deskripsi',
  'financeManualJournal.tax': 'Pajak',
  'financeManualJournal.select_tax': 'Pilih pajak',
  'financeManualJournal.amount': 'Jumlah',
  'financeManualJournal.transaction_date': 'Tanggal Transaksi',
  'financeManualJournal.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeManualJournal.due_date': 'Jatuh tempo',
  'financeManualJournal.please_select_due_date': 'Silakan isi tanggal jatuh tempo',
  'financeManualJournal.price_include_tax': 'Harga termasuk pajak',
  'financeManualJournal.add_more': 'Tambah baris',
  'financeManualJournal.number': 'Nomor',
  'financeManualJournal.please_input_the_number': 'Silakan masukkan nomor.',
  'financeManualJournal.memo': 'Reference',
  'financeManualJournal.date': 'Tanggal',
  'financeManualJournal.detail_title': 'Jurnal Umum {number}',
  'financeManualJournal.reference': 'Reference',
  'financeManualJournal.attachments': 'Attachment',
  'financeManualJournal.please_input_the_amount': 'Silakan masukkan jumlah',
  'financeManualJournal.follow_these_steps_to_import_your_manualJournal':
    'Ikuti langkah-langkah berikut untuk meng-import jurnal umum',
  'financeManualJournal.1_download_your_manualJournal_template_file':
    '1. Download file template jurnal umum',
  'financeManualJournal.start_by_downloading_our_manualJournal_csv':
    'Mulai dengan mengunduh file template Excel jurnal umum. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari jurnal umum-mu.',
  'financeManualJournal.download_template_file': 'Download File Template',
  'financeManualJournal.download_template_data_example_file': 'Download File Contoh',
  'financeManualJournal.import': 'Import Jurnal Umum',
  'financeManualJournal.2_copy_your_manualJournal_into_the_template':
    '2. Salin detail jurnal umum ke dalam template',
  'financeManualJournal.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail jurnal umum ke dalam file template dari Kledo. Pastikan detail jurnal umum sesuai dengan kolom header yang ada di template.',
  'financeManualJournal.important': 'PENTING',
  'financeManualJournal.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeManualJournal.upload': 'Upload',
  'financeManualJournal.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeManualJournal.a_maximum_of_500_manualJournal_can_be_imported_at_a_time':
    'Maksimal 1.000 jurnal umum dapat diimport dalam satu waktu.',
  'financeManualJournal.import_actions_only_insert_new_manualJournal_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeManualJournal.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeManualJournal.manualJournal_successfully_imported':
    '{rowCount} baris jurnal umum berhasil diimport.',
  'financeManualJournal.go_to_manualJournal_list': 'Ke halaman daftar jurnal umum',
  'financeManualJournal.status': 'Status',
  'financeManualJournal.balance_due': 'Sisa Tagihan',
  'financeManualJournal.total': 'Total',
  'financeManualJournal.search_by_memo': 'Cari',
  'financeManualJournal.the_due_date_max_higger_than_transaction_date':
    'Tanggal kadaluarsa harus sama atau setelah tanggal transaksi',
  'financeManualJournal.customer': 'Pelanggan',
  'financeManualJournal.detail_manual_journal': 'Detil Jurnal Umum',
  'financeManualJournal.account': 'Akun',
  'financeManualJournal.debit': 'Debit',
  'financeManualJournal.credit': 'Kredit',
  'financeManualJournal.select_account': 'Pilih akun',
  'financeManualJournal.diff': 'Kredit dan debit terdapat selisih sebesar {diff}',
  'financeManualJournal.total_debits_must_equal_total_credits':
    'Total pemasukan harus sama dengan total pengeluaran.',
  'financeManualJournal.debit_or_credit_must_greater_than_0':
    'Debit atau credit harus lebih besar dari 0.',
  'financeManualJournal.total_debit': 'Total Debit',
  'financeManualJournal.total_credit': 'Total Kredit',
  'financeFixedAssets.register': 'Daftarkan',
  'financeFixedAssets.fixed_assets': 'Aset Tetap',
  'financeFixedAssets.add_fixed_asset': 'Tambah Aset Tetap',
  'financeFixedAssets.asset_name': 'Nama Aset',
  'financeFixedAssets.purchase_invoice': 'Tagihan Pembelian',
  'financeFixedAssets.purchase_date': 'Tanggal Pembelian',
  'financeFixedAssets.purchase_price': 'Harga Beli',
  'financeFixedAssets.book_value': 'Nilai Buku',
  'financeFixedAssets.init_cost': 'Biaya Awal',
  'financeFixedAssets.disposal_date': 'Tanggal Pelepasan',
  'financeFixedAssets.disposal_price': 'Harga Jual',
  'financeFixedAssets.gain': 'Untung/Rugi',
  'financeFixedAssets.number': 'Nomor',
  'financeFixedAssets.purchase_price_from': 'Dari',
  'financeFixedAssets.purchase_price_to': 'Sampai',
  'financeFixedAssets.details': 'Detil',
  'financeFixedAssets.please_input_the_asset_name': 'Silakan isikan nama aset',
  'financeFixedAssets.max_characters': 'Maks {value} karakter.',
  'financeFixedAssets.min_characters': 'Min {value} karakter.',
  'financeFixedAssets.only_alphanumeric_and_special_characters_allowed':
    'Hanya huruf, angka, spasi, dan karakter khusus -/().&_\'" yang diperbolehkan.',
  'financeFixedAssets.please_select_purchase_date': 'Silakan masukkan tanggal pembelian',
  'financeFixedAssets.please_input_the_purchase_price': 'Silakan masukkan harga pembelian',
  'financeFixedAssets.fixed_asset_account': 'Akun Aset Tetap',
  'financeFixedAssets.please_select_a_fixed_asset_account': 'Silakan pilih akun aset tetap',
  'financeFixedAssets.select_fixed_asset_account': 'Pilih akun aset tetap',
  'financeFixedAssets.credited_from_account': 'Dikreditkan Dari Akun',
  'financeFixedAssets.please_select_a_credit_from_account': 'Silakan pilih dikreditkan dari akun',
  'financeFixedAssets.select_credit_from_account': 'Silakan pilih dikreditkan dari akun',
  'financeFixedAssets.description': 'Deskripsi',
  'financeFixedAssets.must_greater_than_0': 'Harus lebih besar dari 0',
  'financeFixedAssets.depreciation': 'Penyusutan',
  'financeFixedAssets.with_depreciation': 'Dengan penyusutan',
  'financeFixedAssets.no_depreciation': 'Tanpa penyusutan',
  'financeFixedAssets.accumulated_depreciation_account': 'Akun Akumulasi Penyusutan',
  'financeFixedAssets.select_accumulated_depreciation_account':
    'Silakan pilih akun akumulasi penyusutan',
  'financeFixedAssets.depreciation_expense_account': 'Akun penyusutan',
  'financeFixedAssets.select_depreciation_expense_account': 'Silakan pilih akubn penyusutan',
  'financeFixedAssets.depreciation_method': 'Metode Penyusutan',
  'financeFixedAssets.select_depreciation_method': 'Silakan pilih metode penyusutan',
  'financeFixedAssets.rate': 'Nilai penyusutan per tahun',
  'financeFixedAssets.effective_life': 'Masa Manfaat',
  'financeFixedAssets.show_more_options': 'Tampilkan opsi lainnya',
  'financeFixedAssets.depreciation_start_date': 'Tanggal Mulai Penyusutan',
  'financeFixedAssets.accumulated_depreciation': 'Akumulasi Penyusutan',
  'financeFixedAssets.cost_limit': 'Batas Biaya',
  'financeFixedAssets.residual_value': 'Nilai Residu',
  'financeFixedAssets.hide_more_options': 'Sembunyikan opsi lainnya',
  'financeFixedAssets.please_select_a_accumulated_depreciation_account':
    'Silakan pilih akun akumulasi penyusutan',
  'financeFixedAssets.please_select_a_depreciation_expense_account':
    'Silakan pilih akun penyusutan',
  'financeFixedAssets.please_select_a_depreciation_method': 'Silakan pilih metode penyusutan',
  'financeFixedAssets.must_equal_or_smaller_than_cost_limit_minus_residual_value':
    'Harus sama atau lebih kecil dari batas biaya dikurang nilai residu',
  'financeFixedAssets.must_equal_or_smaller_than_purchase_price':
    'Harus sama atau lebih kecil dari harga pembelian',
  'financeFixedAssets.must_equal_or_smaller_than_cost_limit':
    'Harus sama atau lebih kecil dari batas biaya',
  'financeFixedAssets.transactions': 'Transaksi',
  'financeFixedAssets.detail_fixed_asset': 'Detil Aset Tetap',
  'financeFixedAssets.detail_title': 'Aset Tetap {detail}',
  'financeFixedAssets.date': 'Tanggal',
  'financeFixedAssets.reference': 'Reference',
  'financeFixedAssets.debit': 'Debit',
  'financeFixedAssets.credit': 'Kredit',
  'financeFixedAssets.undo_dispose': 'Kembalikan Pelepasan',
  'financeFixedAssets.dispose': 'Lepas/Jual',
  'financeFixedAssets.rollback_depreciation': 'Kembalikan Penyusutan',
  'financeFixedAssets.error_cannot_add': 'Gagal menambah aset tetap.',
  'financeFixedAssets.error_cannot_update': 'Gagal mengubah aset tetap.',
  'financeFixedAssets.edit_title': 'Ubah Aset Tetap {detail}',
  'financeFixedAssets.dispose_fixed_asset': 'Lepas/Jual Aset Tetap',
  'financeFixedAssets.dispose_title': 'Lepas/Jual {title}',
  'financeFixedAssets.last_depreciation': 'Penyusutan Terakhir',
  'financeFixedAssets.sale_price': 'Harga Penjualan/Pelepasan',
  'financeFixedAssets.journal_entries': 'Entri Journal',
  'financeFixedAssets.name': 'Nama',
  'financeFixedAssets.account': 'Akun',
  'financeFixedAssets.acquisition_const': 'Biaya Akuisisi',
  'financeFixedAssets.gain_on_disposal': 'Untung pada pelepasan/penjualan',
  'financeFixedAssets.loss_on_disposal': 'Kerugian pada pelepasan/penjualan',
  'financeFixedAssets.please_select_disposal_date': 'Silakan pilih tanggal pelepasan',
  'financeFixedAssets.please_input_the_sale_price': 'Silakan isikan harga penjualan/pelepasan',
  'financeFixedAssets.deposit_to': 'Didepositkan ke',
  'financeFixedAssets.deposit_to_account': 'Deposit ke akun',
  'financeFixedAssets.please_select_a_deposit_to_account': 'Silakan pilih deposit ke akun.',
  'financeFixedAssets.must_equal_or_higher_than_purchase_date_and_last_depreciation_date':
    'Harus sama atau setelah tanggal pemnbelian dan tanggal penyusutan terakhir',
  'financeFixedAssets.must_equal_or_higher_than_purchase_date':
    'Harus sama atau setelah tanggal pemnbelian',
  'financeFixedAssets.register_fixed_asset': 'Daftarkan Aset Tetap',
  'financeFixedAssets.run_depreciation': 'Penyusutan',
  'financeFixedAssets.period': 'Periode',
  'financeFixedAssets.method': 'Metode',
  'financeFixedAssets.depreciation_amount': 'Jumlah Penyusutan',
  'financeFixedAssets.error_cannot_run_depreciation': 'Gagal menjalankan penyusutan.',
  'financeFixedAssets.please_select_at_least_a_depreciation':
    'Silakan pilih paling tidak satu penyusutan.',
  'financeFixedAssets.depreciation_executed_successfully': 'Penyusutan berhasil dijalankan.',
  'financeFixedAssets.back_to_asset_list': 'Kembali ke daftar aset tetap',
  'financeFixedAssets.apply_depreciation': 'Jalankan Penyusutan',
  'financeFixedAssets.are_u_sure_to_undo_dispose':
    'Apakah kamu yakin akan membatalkan penjualan/pelepasan?',
  'financeFixedAssets.are_u_sure_to_rollback_depreciation':
    'Apakah kamu yakin akan membatalkan/mengembalikan penyusutan?',
  'financeFixedAssets.please_input_the_number': 'Silakan isikan nomor.',
  'financeFixedAssets.select_deposit_to_account': 'Pilih akun pengeluaran',
  'financeFixedAssets.edit_fixed_asset': 'Ubah Aset Tetap',
  'financeFixedAssets.error_cannot_rollback_depreciation':
    'Error tidak dapat mengembalikan penyusutan.',
  'financeFixedAssets.detail_fixed_asset_transaction': 'Detil Transaksi Aset Tetap',
  'financeFixedAssets.dispose_detail': 'Pelepasan/Penjualan',
  'financeFixedAssets.follow_these_steps_to_import_your_fixedAsset':
    'Ikuti langkah-langkah berikut untuk meng-import aset tetap',
  'financeFixedAssets.1_download_your_fixedAsset_template_file':
    '1. Download file template aset tetap',
  'financeFixedAssets.start_by_downloading_our_fixedAsset_csv':
    'Mulai dengan mengunduh file template Excel aset tetap. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari aset tetap-mu.',
  'financeFixedAssets.download_template_file': 'Download File Template',
  'financeFixedAssets.download_template_data_example_file': 'Download File Contoh',
  'financeFixedAssets.import': 'Import Aset Tetap',
  'financeFixedAssets.2_copy_your_fixedAsset_into_the_template':
    '2. Salin detail aset tetap ke dalam template',
  'financeFixedAssets.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail aset tetap ke dalam file template dari Kledo. Pastikan detail aset tetap sesuai dengan kolom header yang ada di template.',
  'financeFixedAssets.important': 'PENTING',
  'financeFixedAssets.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeFixedAssets.upload': 'Upload',
  'financeFixedAssets.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeFixedAssets.a_maximum_of_500_fixedAsset_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel.',
  'financeFixedAssets.import_actions_only_insert_new_fixedAsset_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeFixedAssets.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeFixedAssets.fixedAsset_successfully_imported':
    '{rowCount} baris aset tetap berhasil diimport.',
  'financeFixedAssets.go_to_fixedAsset_list': 'Ke halaman daftar aset tetap',
  'financeFixedAssets.the_date_this_asset_was_purchased_or_acquired':
    'Tanggal aset ini dibeli atau diperoleh.',
  'financeFixedAssets.the_total_cost_of_acquiring_this_asset':
    'Total biaya untuk memperoleh aset ini, tanpa pajak.',
  'financeFixedAssets.account_to_hold_the_balance_of_this_fixed_asset':
    'Akun untuk menampung saldo aset tetap ini.',
  'financeFixedAssets.account_for_crediting_the_purchase_of_fixed_asset':
    'Akun untuk mengkreditkan pembelian aset tetap. Contohnya Kas, Pinjaman atau Modal.',
  'financeFixedAssets.an_expense_account_to_record_monthly_depreciation':
    ' Akun biaya untuk merekam penyusutan setiap bulannya.',
  'financeFixedAssets.accounts_for_contra_assets_to_accommodate_accumulated_depreciation':
    'Akun untuk kontra aset untuk menampung akumulasi penyusutan.',
  'financeFixedAssets.percent_depreciation_value_each_year':
    'Nilai persen penyusutan setiap tahunnya.',
  'financeFixedAssets.the_longevity_of_the_asset_since_purchase': 'Panjang usia aset sejak dibeli.',
  'financeFixedAssets.method_of_calculating_assets_each_months':
    'Metode perhitungan aset tiap bulannya{br}Straight Line = Penyusutan secara rata- rata sepanjang masa manfaat aset.{br}Sebagai contoh jika harga beli aset 1000 dan nilai penyusutan 20%, maka depresiasi per tahunnya adalah 1000 * 20% = 200{br}Declining Balance 100% = Penyusutan dengan tingkat penurunan lebih besar diawal usia aset.{br}Sebagai contoh jika harga beli aset 1000 dan nilai penyusutan 20%, maka{br}Penyusutan Tahun Pertama = 1000 x 20% = 200{br}Penyusutan Tahun Kedua = (1000 - 200) x 20% = 160<br/>Penyusutan Tahun Ketiga = (800 - 160) x 20% = 128{br}Declining Balance 150% menghitung penuyutan dengan nilai penyusutan dikali 150%{br}Declining Balance 200% menghitung penuyutan dengan nilai penyusutan dikali 200%',
  'financeFixedAssets.the_commencement_date_of_the_accumulated_depreciation_account_opening_balance':
    'Tanggal dimulainya saldo awal akun akumulasi penyusutan. Bisa diisi sama dengan tanggal pembelian aset, atau lebih baik menggunakan tanggal awal periode atau tanggal migrasi.',
  'financeFixedAssets.beginning_balance_for_accumulated_depreciation_accounts':
    'Saldo awal untuk akun akumulasi penyusutan dari pembukuan atau pencatatan yang lalu.',
  'financeFixedAssets.the_upper_limit_on_the_value_of_the_depreciated_assets':
    'Batas atas nilai aset yang disusutkan. Misalnya aset dibeli dengan harga Rp1000, kemudian diset batas biaya Rp600, maka hanya Rp600 saja yang disusutkan.',
  'financeFixedAssets.the_residual_value_is_the_minimum_amount_of_assets':
    'Nilai residu adalah batas minimal nilai aset yang sudah tidak dapat disusutkan kembali. Misalnya aset dibeli dengan harga Rp1000, kemudian nilai residu diset Rp200. Maka saat aset tersebut disusutkan tiap bulannya, dan nilai aset akhirnya tinggal Rp200, maka aset tersebut sudah tidak disusutkan kembali.',
  'financeFixedAssets.image': 'Gambar Aset Tetap',
  'financeFixedAssets.show_image': 'Tampilkan gambar aset tetap',
  'financeFixedAssets.hide_image': 'Sembunyikan gambar aset tetap',
  'financeLockDate.lock_date': 'Tanggal Penguncian',
  'financeLockDate.lock_date_will_stop_data_from_being_changed':
    'Dengan tanggal penguncian maka semua transaksi pada dan sebelum tanggal penguncian tidak dapat diubah, dihapus dan ditambah. Kamu bisa mengubah tanggal penguncian setiap saat.',
  'financeLockDate.stop_all_users_making_changes_on_and_before':
    'Cegah semua pengguna untuk membuat perubahan pada tanggal dan sebelum tanggal',
  'financeLockDate.please_select_a_date': 'Silakan pilih tanggal.',
  'financeLockDate.error_cannot_set_lock_date': 'Gagal mengubah tanggal penguncian',
  'financeLockDate.cannot_higher_than_now':
    'Tanggal penguncian harus sebelum atau sama dengan hari ini',
  'financeLockDate.cannot_select_before_lock_date':
    'Tidak dapat memilih tanggal sebelum tanggal penguncian',
  'financeLockDate.this_transaction_is_locked':
    'Transaksi ini dikunci. Silakan buka kunci dengan mengubah tanggal penguncian',
  'financeLockDate.click_button_below_to_remove_the_lock_date':
    'Klik tombol di bawah untuk menghapus tanggal penguncian',
  'financeLockDate.remove_lock_date': 'Hapus Tanggal Penguncian',
  'financeFixedAssets.error_cannot_delete': 'Gagal menghapus tanggal penguncian.',
  'property.property': 'Properti',
  'property.company': 'Perusahaan',
  'property.property_details': 'Detil Properti',
  'property.company_details': 'Data Perusahaan',
  'property.tax_details': 'Pengaturan Pajak',
  'property.system_settings': 'Pengaturan Sistem',
  'property.property_logo': 'Logo Properti',
  'property.company_logo': 'Logo Perusahaan',
  'property.error_cannot_update_tax_details': 'tipe Gagal',
  'property.property_details_successfully_updated': 'Detil properti berhasil diperbarui.',
  'property.company_details_successfully_updated': 'tipe Perusahaan',
  'property.error_cannot_update_property_details': 'Gagal memperbarui detail properti.',
  'property.error_cannot_update_company_details': 'Tidak dapat mengubah company details.',
  'property.system_details_successfully_updated': 'Detil sistem berhasil diperbarui.',
  'property.error_cannot_update_system_details': 'tipe Gagal',
  'property.tax_details_successfully_updated': 'Rincian pajak berhasil diperbarui.',
  'property.property_name': 'Nama',
  'property.company_name': 'Nama',
  'property.please_input_the_property_name': 'Silakan masukkan nama properti.',
  'property.please_input_the_company_name': 'Silakan masukkan company name.',
  'property.max_100_characters': 'Maks 100 karakter.',
  'property.emai_address': 'Alamat email',
  'property.invalid_email_address_format': 'Format alamat email tidak valid.',
  'property.phone_number': 'Nomor telepon',
  'property.max_20_characters': 'Nomor telepon',
  'property.only_number_allowed': 'Hanya angka yang diizinkan.',
  'property.address': 'Alamat Penagihan',
  'property.address_delivery': 'Alamat Pengiriman',
  'property.country': 'Negara',
  'property.tax_number': 'Nomor NPWP Perusahaan',
  'property.please_select_the_country': 'Silakan pilih negara.',
  'property.select_country': 'Pilih negara',
  'property.arrival_time': 'Jam kedatangan',
  'property.departure_time': 'Jam keberangkatan',
  'property.image_file_size_maximal': 'Ukuran file gambar maksimal',
  'property.language': 'Bahasa',
  'property.select_time_region': 'Pilih zona waktu',
  'property.timezone': 'Zona waktu',
  'property.please_select_the_language': 'Silakan pilih bahasanya.',
  'property.select_timezone': 'Pilih zona waktu',
  'property.please_select-the_timezone': 'Silakan pilih zona waktu.',
  'property.date_format': 'Format tanggal',
  'property.please_select_the_date_format': 'Silakan pilih format tanggal.',
  'property.select_date_format': 'Pilih format tanggal',
  'property.time_format': 'Format waktu',
  'property.please_select_the_time_format': 'Silakan pilih format waktu.',
  'property.select_time_format': 'Pilih format waktu',
  'property.Currency_Format': 'Format mata uang',
  'property.please_select_the_currency_format': 'Silakan pilih format mata uang.',
  'property.select_currency_format': 'Pilih format mata uang ',
  'property.country_tax_identifier_name': 'Nama Pengenal Pajak Negara',
  'property.only_alphanumeric_allowed': 'Hanya alfanumerik yang diizinkan.',
  'property.company_tax_number': 'Nomor Pajak Perusahaan',
  'property.tax_name': 'Nama Pajak',
  'property.tax_rate': 'Persentase pajak',
  'property.image_file_dimension_maximal': 'Dimensi file gambar maksimal',
  'property.click_or_drag_file_to_this_area_to_upload':
    'Klik atau seret file ke area ini untuk mengunggah',
  'property.paste_image_from_clipboard': 'Tempel gambar dari clipboard',
  'property.no_image_in_clipboard': 'Tidak ada gambar di clipboard',
  'property.clipboard_read_failed':
    'Gagal membaca clipboard. Pastikan browser mengizinkan akses clipboard.',
  'property.preview': 'Pratinjau',
  'property.file_uploaded_successfully': 'berkas berhasil diunggah.',
  'property.file_upload_failed': 'gagal unggah file.',
  'property.you_can_only_upload_jpg_or_png_file_': 'Anda hanya dapat mengunggah file JPG / PNG.',
  'property.image_must_smaller_than': 'Gambar harus lebih kecil dari',
  'property.image_width_must_smaller_than': 'Lebar gambar harus lebih kecil dari',
  'property.image_height_must_smaller_than': 'Tinggi gambar harus lebih kecil dari ',
  'property.image_dimension_must_be_at_least': 'Lebar dan tinggi gambar minimal',
  'property.currency': 'Mata uang',
  'property.please_select_the_currency': 'Silakan pilih mata uang.',
  'property.select_currency': 'Pilih Mata Dana',
  'property.number_after_comma': 'Jumlah angka di belakang koma',
  'property.please_select_the_number_after_comma': 'Silakan pilih jumlah angka di belakang koma.',
  'property.select_number_after_comma': 'Pilih jumlah angka di belakang koma',
  'financeWareHouses.add_warehouse': 'Tambah Gudang',
  'financeWareHouses.financeWareHouses': 'Gudang',
  'financeWareHouses.warehouse_per_item': 'Gudang Peritem',
  'financeWareHouses.warehouse_name': 'Nama Gudang',
  'financeWareHouses.successfully_added': 'berhasil ditambahkan.',
  'financeWareHouses.error_cannot_add': 'Tidak dapat menambah',
  'financeWareHouses.error_cannot_update': 'Tidak dapat mengubah gudang.',
  'financeWareHouses.error_cannot_move': 'Tidak dapat memindah gudang.',
  'financeWareHouses.error_cannot_change_status': 'Tidak dapat mengubah status gudang.',
  'financeWareHouses.rack.management': 'Manajemen Rak',
  'financeWareHouses.rack.add': 'Tambah Rak',
  'financeWareHouses.rack.max_reached': 'Maksimal {max} rak per gudang.',
  'financeWareHouses.rack.edit': 'Ubah Rak',
  'financeWareHouses.rack.name': 'Nama Rak',
  'financeWareHouses.rack.code': 'Kode Rak',
  'financeWareHouses.rack.desc': 'Deskripsi Rak',
  'financeWareHouses.rack.is_active': 'Status Aktif',
  'financeWareHouses.rack.active': 'Aktif',
  'financeWareHouses.rack.inactive': 'Nonaktif',
  'financeWareHouses.rack.no_rack': 'Tanpa Rak',
  'financeWareHouses.rack.please_input_name': 'Silakan masukkan nama rak.',
  'financeWareHouses.rack.name_placeholder': 'Masukkan nama rak',
  'financeWareHouses.rack.code_placeholder': 'Masukkan kode rak',
  'financeWareHouses.rack.desc_placeholder': 'Masukkan deskripsi rak',
  'financeWareHouses.rack.select_rack': 'Pilih Rak',
  'financeWareHouses.rack.picker_placeholder': 'Pilih rak',
  'financeWareHouses.rack.delete_confirm': 'Yakin ingin menghapus rak ini?',
  'financeWareHouses.rack.successfully_added': 'Rak berhasil ditambahkan.',
  'financeWareHouses.rack.successfully_updated': 'Rak berhasil diubah.',
  'financeWareHouses.rack.successfully_deleted': 'Rak berhasil dihapus.',
  'financeWareHouses.rack.error_cannot_add': 'Tidak dapat menambah rak.',
  'financeWareHouses.rack.error_cannot_update': 'Tidak dapat mengubah rak.',
  'financeWareHouses.rack.error_cannot_delete': 'Tidak dapat menghapus rak.',
  'financeWareHouses.rack.error_parent_invalid':
    'Rak tidak dapat dibuat di bawah sebuah rak. Rak hanya bisa berada langsung di bawah gudang induk.',
  'financeWareHouses.rack.error_not_empty':
    'Rak masih memiliki pergerakan stok. Pindahkan stok terlebih dahulu sebelum menghapus.',
  'financeWareHouses.rack.error_not_found': 'Rak tidak ditemukan atau bukan milik gudang ini.',
  'financeWareHouses.rack.error_role_not_allowed':
    'Pengaturan hak akses tidak berlaku untuk rak. Rak mewarisi akses dari gudang induknya.',
  'financeWareHouses.rack.per_rack': 'Per Rak',
  'financeWareHouses.rack.column_title': 'Rak',
  'financeWareHouses.rack.without_rack': 'Tanpa Rak',
  'financeWareHouses.error_cannot_load_warehouses': 'Tidak dapat memuat data gudang.',
  'financeWareHouses.edit_warehouse': 'Ubah Gudang',
  'financeWareHouses.please_input_the_name': 'Silakan masukkan nama.',
  'financeWareHouses.please_input_the_code': 'Silakan masukkan kode.',
  'financeWareHouses.name': 'Nama',
  'financeWareHouses.code': 'Kode',
  'financeWareHouses.max_characters': 'Maks {value} karakter.',
  'financeWareHouses.min_characters': 'Min {value} karakter.',
  'financeWareHouses.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeWareHouses.desc': 'Deskripsi',
  'financeWareHouses.is_canvas_warehouse': 'Gudang canvassing',
  'financeWareHouses.total_value': 'Total Nilai',
  'financeWareHouses.stock_adjustment': 'Penyesuaian Stok',
  'financeWareHouses.warehouse_transfer': 'Transfer Gudang',
  'financeWareHouses.import_warehouse_transfer': 'Import Transfer Gudang',
  'financeWareHouses.transfer_in': 'Transfer Masuk',
  'financeWareHouses.transfer_out': 'Transfer Keluar',
  'financeWareHouses.qty': 'Qty',
  'financeWareHouses.value': 'Nilai',
  'financeWareHouses.detail_warehouse': 'Detail Gudang',
  'financeWareHouses.show_transactions': 'Lihat Transaksi',
  'financeWareHouses.hide_transactions': 'Sembunyikan Transaksi',
  'financeWareHouses.purchase_&_sale': 'Pembelian & Penjualan',
  'financeWareHouses.transactions': 'Transaksi',
  'financeWareHouses.date': 'Tanggal',
  'financeWareHouses.type': 'Tipe',
  'financeWareHouses.number': 'Nomor',
  'financeWareHouses.debit': 'Debit',
  'financeWareHouses.credit': 'Kredit',
  'financeWareHouses.from': 'Dari',
  'financeWareHouses.to': 'Ke',
  'financeWareHouses.adjustment_type': 'Tipe penyesuaian stok',
  'financeWareHouses.please_select_date': 'Silakan pilih tanggal',
  'financeWareHouses.warehouse_transfer_out': 'Transfer Keluar Gudang',
  'financeWareHouses.warehouse_transfer_in': 'Transfer Masuk Gudang',
  'financeWareHouses.qty_before': 'Qty Sebelumnya',
  'financeWareHouses.qty_after': 'Qty Setelahnya',
  'financeWareHouses.transfer_qty': 'Transfer Qty',
  'financeWareHouses.add_more': 'Tambah baris',
  'financeWareHouses.attachments': 'Attachments',
  'financeWareHouses.select_warehouse': 'Pilih gudang',
  'financeWareHouses.from_and_to_cannot_be_same': 'Asal dan tujuan tidak boleh sama.',
  'financeWareHouses.please_input_the_transfer_qty': 'Silakan masukkan jumlah yang ditransfer.',
  'financeWareHouses.please_select_a_warehouse': 'Silakan pilih gudang.',
  'financeWareHouses.must_greater_than_0': 'Harus lebih dari 0.',
  'financeWareHouses.detail_transfer': 'Transfer Gudang {number}',
  'financeWareHouses.detail_transfer_title': 'Detail Transfer Gudang',
  'financeWareHouses.detail_transfer_group': 'Transfer Gabungan {number}',
  'financeWareHouses.detail_transfer_group_title': 'Detail Transfer Gudang Gabungan',
  'financeWareHouses.print_blocked_title': 'Transfer belum bisa dicetak',
  'financeWareHouses.print_blocked_waiting_approval':
    'Transfer ini masih menunggu persetujuan. Anda belum punya akses untuk menyetujuinya. Transfer bisa dicetak setelah disetujui.',
  'financeWareHouses.print_blocked_rejected':
    'Transfer ini sudah ditolak, jadi tidak bisa dicetak.',
  'financeWareHouses.warehouse_transfer_group': 'Transfer Gudang Gabungan',
  'financeWareHouses.add_warehouse_transfer_group': 'Tambah Transfer Gudang Gabungan',
  'financeWareHouses.edit_warehouse_transfer_group': 'Ubah Transfer Gudang Gabungan',
  'financeWareHouses.transfer_group_serial_not_supported':
    'Untuk sementara produk serial number belum didukung di transfer gudang gabungan. Silakan pilih produk lain.',
  'financeWareHouses.transfer_group_detail_load_failed':
    'Sebagian detail transfer gagal dimuat. Muat ulang dulu sebelum menyimpan agar data tidak hilang.',
  'financeWareHouses.add_transfer_to_group': 'Tambah Transfer',
  'financeWareHouses.min_one_transfer': 'Minimal 1 transfer dalam grup.',
  'financeWareHouses.group_validation_error':
    'Ada data yang belum benar. Cek field yang ditandai di bawah.',
  'financeWareHouses.failed_save_group': 'Gagal menyimpan transfer gudang gabungan.',
  'financeWareHouses.warehouse_from_to_must_differ': 'Gudang asal dan tujuan harus berbeda.',
  'financeWareHouses.product': 'Produk',
  'financeWareHouses.unit': 'Satuan',
  'financeWareHouses.qty_max': 'Kuantitas maksimal {value}.',
  'financeWareHouses.please_select_a_product': 'Silakan pilih produk.',
  'financeWareHouses.transfer_group': 'Transfer Gabungan',
  'financeWareHouses.status_completed': 'Selesai',
  'financeWareHouses.edit_warehouse_transfer': 'Ubah Transfer Gudang',
  'financeWareHouses.insufficient_stock': 'Stok tidak mencukupi',
  'financeWareHouses.detail_stockadjustment_title': 'Detail Penyesuaian Stok',
  'financeWareHouses.detail_stockadjustment': 'Penyesuaian Stok {number}',
  'financeWareHouses.difference': 'Selisih',
  'financeWareHouses.average_price': 'Harga Rata-rata',
  'financeWareHouses.actual_qty': 'Qty Aktual',
  'financeWareHouses.actual_qty_2': 'Kuantitas Aktual',
  'financeWareHouses.account': 'Akun',
  'financeWareHouses.account_per_item': 'Akun per item',
  'financeWareHouses.follow_header_account': 'Ikut akun header ({code})',
  'financeWareHouses.follow_header_account_empty': 'Ikut akun header',
  'financeWareHouses.account_per_item_conflict': 'Samakan dengan baris {product} lainnya',
  'financeWareHouses.pic': 'Penanggung Jawab',
  'financeWareHouses.counted_by': 'Dikerjakan Oleh',
  'financeWareHouses.add_stock_adjustment': 'Tambah Penyesuaian Stok',
  'financeWareHouses.import_stock_adjustment': 'Import Penyesuaian Stok',
  'financeWareHouses.download': 'Download',
  'financeWareHouses.please_select_adjustment_type': 'Silakan pilih tipe penyesuaian stok',
  'financeWareHouses.select_account': 'Pilih akun',
  'financeWareHouses.recorded_qty': 'Qty Tercatat',
  'financeWareHouses.please_input_the_actual_qty': 'Silakan isi jumlah aktual',
  'financeWareHouses.please_input_the_difference_qty': 'Silakan isi perbedaan jumlah',
  'financeWareHouses.please_input_the_average_price': 'Silakan isi harga rata-rata',
  'financeWareHouses.error_cannot_update_stock_adjustment': 'Tidak dapat mengubah penyesuaian stok',
  'financeWareHouses.error_cannot_add_stock_adjustment': 'Tidak dapat menambah penyesuaian stok',
  'financeWareHouses.edit_stock_adjustment': 'Ubah Penyesuaian Stok',
  'financeWareHouses.transfer': 'Transfer',
  'financeWareHouses.total_qty': 'Total Kuantitas',
  'financeWareHouses.cannot_less_than_0': 'Tidak boleh kurang dari 0.',
  'financeWareHouses.follow_these_steps_to_import_your_stockAdjustment':
    'Ikuti langkah-langkah berikut untuk menyensuaikan stok',
  'financeWareHouses.1_download_your_stockAdjustment_template_file':
    '1. Download file template penyesuaian stok',
  'financeWareHouses.start_by_downloading_our_stockAdjustment_csv':
    'Mulai dengan mengunduh file template Excel penyesuaian stok. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari penyesuaian stok-mu.',
  'financeWareHouses.download_template_file': 'Download File Template',
  'financeWareHouses.download_template_data_example_file': 'Download File Contoh',
  'financeWareHouses.import': 'Import Penyesuaian Stok',
  'financeWareHouses.2_copy_your_stockAdjustment_into_the_template':
    '2. Salin detail penyesuaian stok ke dalam template',
  'financeWareHouses.important': 'PENTING',
  'financeWareHouses.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeWareHouses.upload': 'Upload',
  'financeWareHouses.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeWareHouses.a_maximum_of_500_stockAdjustment_can_be_imported_at_a_time':
    'Maksimal 1.000 penyesuaian stok dapat diimport dalam satu waktu.',
  'financeWareHouses.import_actions_only_insert_new_stockAdjustment_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeWareHouses.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeWareHouses.stockAdjustment_successfully_imported':
    '{rowCount} baris penyesuaian stok berhasil diimport.',
  'financeWareHouses.go_to_stockAdjustment_list': 'Ke halaman daftar penyesuaian stok',
  'financeWareHouses.account_id_help': 'Pilih akun penyesuaian stok untuk penjurnalan.',
  'financeWareHouses.count_stock_help':
    'Jika ingin melakukan stok opname, pilih tipe perhitungan stok. Dengan tipe ini, jumlah stok barang akan dikunci sehingga seluruh pergerakan stok sebelum dilakukannya penyesuaian stok ini akan diabaikan.',
  'financeWareHouses.count_stock_in_out_help':
    'Jika ingin menambah atau mengurangi stok dari suatu gudang, pilih tipe Stok Masuk / Keluar.',
  'financeWareHouses.warehouse_transfer_successfully_imported':
    '{rowCount} transfer gudang berhasil diimport.',
  'financeWareHouses.go_to_warehouse_page': 'Ke halaman gudang',
  'financeWareHouses.follow_these_steps_to_import_your_warehouse_transfer':
    'Ikuti langkah berikut untuk mengimport transfer gudangmu',
  'financeWareHouses.1_download_your_warehouse_transfer_template_file':
    '1. Download file template transfer gudang',
  'financeWareHouses.start_by_downloading_our_warehouse_transfer_csv':
    'Mulai dengan mengunduh file template Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari transfer gudangmu.',
  'financeWareHouses.2_copy_your_warehouse_transfer_into_the_template':
    '2. Salin detail transfer gudang ke dalam template',
  'financeWareHouses.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail transfer gudang ke dalam file template dari Kledo. Pastikan detail transfer gudang sesuai dengan kolom header yang ada di template.',
  'financeWareHouses.a_maximum_of_500_warehouse_transfer_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel. Setiap baris dihitung, termasuk baris transfer gudang maupun item.',
  'financeWareHouses.change_access': 'Ubah Hak Akses',
  'financeWareHouses.who_can_access_this_warehouse': 'Siapa yang bisa mengakses gudang ini?',
  'financeWareHouses.all_user': 'Semua Pengguna',
  'financeWareHouses.access': 'Hak Akses',
  'financeWareHouses.recorded_amount': 'Jumlah Yang Tercatat',
  'financeWareHouses.actual_amount': 'Jumlah Sebenarnya',
  'financeWareHouses.difference_2': 'Perbedaan',
  'approvals.approval': 'Persetujuan',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Tolak',
  'approvals.waiting_for_approval': 'Menunggu Persetujuan',
  'approvals.waiting_for_my_approval': 'Menunggu Persetujuanku',
  'approvals.rejected': 'Ditolak',
  'approvals.rejected_because': 'Ditolak karena:',
  'approvals.wait': 'Menunggu',
  'approvals.are_you_sure_to_approve': 'Apakah Anda yakin approve transaksi ini?',
  'approvals.are_you_sure_to_reject': 'Apakah Anda yakin menolak transaksi ini?',
  'approvals.enable_approvals': 'Aktifkan Approval',
  'approvals.approval_levels': 'Berapa jumlah level approval?',
  'approvals.approval_authority': 'Peran yang mempunyai wewenang approval level {level}',
  'approvals.role_is_required': 'Silahkan pilih peran',
  'approvals.approval_progress': 'Progress persetujuan',
  'approvals.and_number_others': 'dan {value} lainnya',
  'approvals.cancel_approval': 'Batalkan persetujuan',
  'approvals.cancel_rejection': 'Batalkan penolakan',
  'approvals.are_you_sure_to_cancel_approval':
    'Apakah Anda yakin untuk batalkan approval di transaksi ini?',
  'approvals.save_and_resubmit': 'Simpan dan ajukan kembali',
  'approvals.resubmit_confirm_title': 'Ajukan kembali transaksi ini?',
  'approvals.resubmit_confirm_content':
    'Transaksi akan diajukan kembali untuk persetujuan dan approval dimulai lagi dari awal. Jika tidak ada isi yang diubah, transaksi tidak diajukan ulang dan tetap berstatus Ditolak.',
  'approvals.rejected_at_level': 'Ditolak di level {level} pada {date}',
  'approvals.rejected_by_at_level': 'Ditolak oleh {name} di level {level} pada {date}',
  'approvals.submitted_by_name': 'Diajukan oleh {name}',
  'approvals.resubmit_hint':
    'Perbaiki transaksi ini lalu simpan untuk mengajukannya kembali. Menyimpan tanpa mengubah isi tidak mengajukan ulang.',
  'approvals.cycle_history': 'Riwayat Siklus Persetujuan',
  'approvals.cycle': 'Siklus {cycle}',
  'approvals.current_cycle': 'Berjalan',
  'approvals.initial_submission': 'Pengajuan awal',
  'approvals.cycle_trigger_1': 'Diajukan ulang setelah ditolak',
  'approvals.cycle_trigger_2': 'Transaksi yang sudah disetujui diubah',
  'approvals.cycle_trigger_3': 'Transaksi yang menunggu persetujuan diubah',
  'approvals.approval_config_changed': 'Pengaturan approval berubah',
  'approvals.previous_rejection': 'Penolakan sebelumnya',
  'approvals.changed_fields': 'Field yang berubah',
  'approvals.approved_levels': 'Disetujui',
  'approvals.changed_field_contact': 'Kontak',
  'approvals.changed_field_items': 'Item',
  'layoutInvoice.layout_invoice': 'Layout Invoice',
  'layoutInvoice.invoice': 'Faktur Penjualan',
  'layoutInvoice.joined_sales_invoice': 'Gabungan Faktur Penjualan',
  'layoutInvoice.joined_purchase_invoice': 'Gabungan Faktur Pembelian',
  'layoutInvoice.tax_invoice': 'Faktur Pajak',
  'layoutInvoice.proforma': 'Proforma',
  'layoutInvoice.proforma_order': 'Proforma Pemesanan',
  'layoutInvoice.delivery': 'Surat Jalan',
  'layoutInvoice.order': 'Pemesanan',
  'layoutInvoice.receipt': 'Kuitansi',
  'layoutInvoice.expense_slip': 'Slip Pengeluaran',
  'layoutInvoice.purchase_payment': 'Pemberitahuan Pembayaran',
  'layoutInvoice.send_receive_money': 'Kirim/Terima Dana',
  'layoutInvoice.remittance_advice': 'Bukti Kas Keluar',
  'layoutInvoice.cash_receipt': 'Bukti Kas Masuk',
  'layoutInvoice.account_code': 'Kode Akun',
  'layoutInvoice.account_name': 'Nama Akun',
  'layoutInvoice.error_cannot_load_data': 'Tidak berhasil mengambil data.',
  'layoutInvoice.error_cannot_save_data': 'Tidak berhasil menyimpan data.',
  'layoutInvoice.error_cannot_reset_data': 'Tidak berhasil mengatur ulang data.',
  'layoutInvoice.sale': 'Penjualan',
  'layoutInvoice.purchase': 'Pembelian',
  'layoutInvoice.company_logo': 'Company Logo',
  'layoutInvoice.signature': 'Signature',
  'layoutInvoice.upload_logo': 'Upload logo',
  'layoutInvoice.change_logo_size': 'Ubah ukuran logo',
  'layoutInvoice.upload_signature': 'Upload signature',
  'layoutInvoice.change_signature_size': 'Ubah ukuran signature',
  'layoutInvoice.change_signature_spacing': 'Ubah jarak tanda tangan',
  'layoutInvoice.purchase_order': 'Pesanan Pembelian',
  'layoutInvoice.purchase_invoice': 'Faktur Pembelian',
  'layoutInvoice.purchase_return': 'Retur Pembelian',
  'layoutInvoice.purchase_quote': 'Penawaran Pembelian',
  'layoutInvoice.quote': 'Penawaran',
  'layoutInvoice.sell_invoice': 'Tagihan Penjualan',
  'layoutInvoice.show_discount': 'Tampilkan Diskon',
  'layoutInvoice.show_discount_percent_and_amount': 'Tampilkan Persen & Nominal Diskon',
  'layoutInvoice.show_additional_discount_detail': 'Tampilkan Detil Tambahan Diskon',
  'layoutInvoice.show_account': 'Tampilkan Akun',
  'layoutInvoice.show_price': 'Tampilkan Harga',
  'layoutInvoice.show_tax_total': 'Tampilkan Total Pajak',
  'layoutInvoice.invoice_show_tax_amount': 'Tampilkan Nominal Pajak Item',
  'layoutInvoice.tax_amount_nominal': 'Nominal Pajak',
  'layoutInvoice.show_subtotal': 'Tampilkan Subtotal',
  'layoutInvoice.show_subtotal_plus_tax': 'Tampilkan Subtotal + Pajak',
  'layoutInvoice.show_total': 'Tampilkan Total',
  'layoutInvoice.show_amount_column': 'Tampilkan Kolom Jumlah',
  'layoutInvoice.show_tax': 'Tampilkan Pajak',
  'layoutInvoice.show_product': 'Tampilkan Produk',
  'layoutInvoice.show_ref_code_product': 'Tampilkan SKU Produk',
  'layoutInvoice.show_product_image': 'Tampilkan Gambar Produk',
  'layoutInvoice.show_invoice': 'Tampilkan Tagihan',
  'layoutInvoice.show_invoice_items': 'Tampilkan Item Invoice',
  'layoutInvoice.show_invoice_items_receipt': 'Tampilkan Item Transaksi',
  'layoutInvoice.show_invoice_hpp': 'Tampilkan HPP',
  'layoutInvoice.show_invoice_hpp_subtotal': 'Tampilkan Subtotal',
  'layoutInvoice.show_qty': 'Tampilkan Kuantitas',
  'layoutInvoice.show_total_qty': 'Tampilkan Total Kuantitas',
  'layoutInvoice.show_unit': 'Tampilkan Satuan',
  'layoutInvoice.show_description': 'Tampilkan Deskripsi',
  'layoutInvoice.show_tags': 'Tampilkan Tag',
  'layoutInvoice.show_term': 'Tampilkan Termin',
  'layoutInvoice.show_payment': 'Tampilkan Pembayaran',
  'layoutInvoice.show_payment_detail': 'Tampilkan Detail Pembayaran',
  'layoutInvoice.show_sales_person': 'Tampilkan Sales Person',
  'layoutInvoice.show_paid_status': 'Tampilkan Status Lunas',
  'layoutInvoice.show_warehouse': 'Tampilkan Gudang',
  'layoutInvoice.show_amount_in_word': 'Tampilkan Jumlah dalam Kata',
  'layoutInvoice.show_contact_name': 'Tampilkan Nama Kontak',
  'layoutInvoice.show_npwp': 'Tampilkan NPWP Perusahaan',
  'layoutInvoice.show_company_name': 'Tampilkan Nama Perusahaan',
  'layoutInvoice.show_reconciliation_status': 'Tampilkan Status Rekonsiliasi',
  'layoutInvoice.debit_memo_payment': 'Terima Pembayaran Piutang',
  'layoutInvoice.portrait': 'Potret',
  'layoutInvoice.landscape': 'Lanskap',
  'layoutInvoice.show_company_information': 'Tampilkan Informasi Perusahaan',
  'layoutInvoice.show_email': 'Tampilkan Email',
  'layoutInvoice.show_phone': 'Tampilkan Telepon',
  'layoutInvoice.show_address': 'Tampilkan Alamat Bisnis',
  'layoutInvoice.show_contact': 'Tampilkan Kontak',
  'layoutInvoice.show_memo': 'Tampilkan Memo',
  'layoutInvoice.show_issued_qty': 'Tampilkan Qty Dikeluarkan',
  'layoutInvoice.show_outstanding_qty': 'Tampilkan Sisa Qty',
  'layoutInvoice.show_signature_issuer': 'Tampilkan Kolom TTD Yang Mengeluarkan',
  'layoutInvoice.show_signature_receiver': 'Tampilkan Kolom TTD Yang Menerima',
  'layoutInvoice.signature_issuer_default_title': 'Tim yang Mengeluarkan',
  'layoutInvoice.signature_receiver_default_title': 'Tim yang Menerima',
  'layoutInvoice.show_material_request_ref': 'Tampilkan Nomor Permintaan Material',
  'layoutInvoice.invoice_show_contact_npwp': 'Tampilkan NPWP Kontak',
  'layoutInvoice.invoice_show_contact_phone': 'Tampilkan Nomor Telepon Kontak',
  'layoutInvoice.show_currency_symbol_table': 'Tampilkan Simbol Mata Uang Pada Tabel Item',
  'layoutInvoice.show_attention': 'Tampilkan UP/ATTN',
  'layoutInvoice.show_detail_contact': 'Tampilkan Detail Kontak',
  'layoutInvoice.show_manufacturing_product_materials_sales':
    'Tampilkan Bahan Produk Manufaktur / Paket',
  'layoutInvoice.show_manufacturing_product_materials_purchase':
    'Tampilkan Bahan Produk Manufaktur',
  'layoutInvoice.show_manufacturing_product_materials_only':
    'Tampilkan Bahan Produk Manufaktur / Paket Saja',
  'layoutInvoice.show_manufacturing_product_materials_only_help_text':
    'Hanya menampilkan bahan bakunya saja, tanpa menampilkan produk hasilnya.',
  'layoutInvoice.show_the_calculated_value_of_the_remaining_bill':
    'Tampilkan Nilai Terbilang dari Sisa Tagihan',
  'layoutInvoice.show_total_after_discount': 'Tampilkan Total Setelah Diskon',
  'layoutInvoice.show_termin_summary_detail': 'Tampilkan Detail Ringkasan Termin',
  'layoutInvoice.invoice_show_termin_payment_terms': 'Tampilkan Payment Terms',
  'layoutInvoice.invoice_show_termin_at_end': 'Tampilkan Termin di Akhir',
  'layoutInvoice.invoice_show_termin_at_end_disabled':
    'Tidak berlaku saat Tampilkan Payment Terms aktif',
  'layoutInvoice.show_coa': 'Tampilkan COA',
  'layoutInvoice.show_reference': 'Tampilkan Reference',
  'layoutInvoice.change_template': 'Ganti template',
  'layoutInvoice.template': 'Template',
  'layoutInvoice.stamp': 'Stempel',
  'layoutInvoice.change_stamp': 'Ganti Stempel',
  'layoutInvoice.edit_header': 'Ubah Header',
  'layoutInvoice.please_choose_template': 'Silahkan pilih template di bawah :',
  'layoutInvoice.please_choose_stamp': 'Silahkan pilih stempel di bawah :',
  'layoutInvoice.select_this_template': 'Gunakan template ini',
  'layoutInvoice.select_this_stamp': 'Gunakan Stempel ini',
  'layoutInvoice.current_template': 'Template saat ini',
  'layoutInvoice.current_stamp': 'Stempel saat ini',
  'layoutInvoice.name': 'Nama',
  'layoutInvoice.transfer_money': 'Transfer Dana',
  'layoutInvoice.label_delivery': 'Label Pengiriman',
  'layoutInvoice.proof_of_goods_receipt': 'Bukti Terima Barang',
  'layoutInvoice.payment_recap': 'Rekap Pembayaran',
  'layoutInvoice.production_orders': 'Perintah Produksi',
  'layoutInvoice.show_due_date': 'Tampilkan Tanggal Jatuh Tempo',
  'layoutInvoice.show_invoice_time': 'Tampilkan Waktu',
  'layoutInvoice.show_invoice_dp_sequence': 'Tampilkan Nomor Urut DP pada Invoice',
  'layoutInvoice.show_number': 'Tampilkan Nomor Item',
  'layoutInvoice.show_expedition': 'Tampilkan Ekspedisi',
  'layoutInvoice.show_message': 'Tampilkan Pesan',
  'layoutInvoice.show_signature': 'Tampilkan Tanda Tangan',
  'layoutInvoice.show_signature_detail': 'Tampilkan TTd Pengirim & Penerima',
  'layoutInvoice.font_size': 'Ukuran Font',
  'layoutInvoice.ref_trans_label_case': 'Huruf Label Transaksi Terkait',
  'layoutInvoice.ref_trans_label_case.uppercase': 'HURUF BESAR SEMUA',
  'layoutInvoice.ref_trans_label_case.lowercase': 'huruf kecil semua',
  'layoutInvoice.ref_trans_label_case.capitalize': 'Huruf Besar Awal Kata',
  'layoutInvoice.additional_message': 'Tambahan Pesan',
  'layoutInvoice.additional_message_desc':
    'Pesan pada tambahan pesan ini akan ditempelkan secara otomatis di bagian bawah dari pesan dari transaksi.',
  'layoutInvoice.default_message': 'Pesan Default',
  'layoutInvoice.default_message_desc':
    'Pesan default akan diload secara otomatis pada input pesan saat menambahkan transaksi baru.',
  'layoutInvoice.account': 'Rekening',
  'layoutInvoice.show_due': 'Tampilkan Sisa Tagihan',
  'layoutInvoice.show_receivable_account': 'Tampilkan Akun Piutang',
  'layoutInvoice.show_payable_account': 'Tampilkan Akun Hutang',
  'layoutInvoice.show_invoice_due': 'Tampilkan Sisa Piutang',
  'layoutInvoice.show_attachment': 'Tampilkan Lampiran',
  'layoutInvoice.show_payments_received': 'Tampilkan Pembayaran Diterima',
  'layoutInvoice.date_format': 'Format Tanggal',
  'layoutInvoice.show_percentage_number_on_additional_number':
    'Tampilkan Angka Persentase Tambahan Diskon',
  'layoutInvoice.discount_price': 'Harga Diskon',
  'layoutInvoice.show_discount_price': 'Tampilkan Harga Diskon',
  'layoutInvoice.show_total_discount': 'Tampilkan Total Diskon',
  'layoutInvoice.show_qty_actual': 'Tampilkan Kuantitas Aktual',
  'layoutInvoice.show_avg_price': 'Tampilkan Harga Rata - Rata',
  'layoutReport.layout_report': 'Layout Laporan',
  'layoutReport.manage_your_finance_print_pdf_layout_here':
    'Atur tampilan print pdf keuangan Anda di sini',
  'layoutReport.report_logo': 'Logo Laporan',
  'layoutReport.report_setting': 'Setting Laporan',
  'layoutReport.show_logo': 'Tampilkan Logo',
  'layoutReport.logo_position': 'Posisi Logo',
  'layoutReport.logo_position_left': 'Kiri',
  'layoutReport.logo_position_center': 'Tengah',
  'layoutReport.logo_position_right': 'Kanan',
  'layoutReport.show_comp_name': 'Tampilkan Nama Perusahaan',
  'layoutReport.font_family': 'Font Family',
  'layoutReport.font_size': 'Ukuran Font',
  'layoutReport.margin_size': 'Ukuran Margin',
  'layoutReport.margin_top': 'Margin Atas',
  'layoutReport.margin_right': 'Margin Kanan',
  'layoutReport.margin_bottom': 'Margin Bawah',
  'layoutReport.margin_left': 'Margin Kiri',
  'layoutReport.header_spacing': 'Jarak Header Laporan',
  'layoutReport.header_to_table_spacing': 'Jarak Header ke Tabel (px)',
  'layoutReport.report_text': 'Teks Laporan',
  'layoutReport.comp_name': 'Nama Perusahaan',
  'layoutReport.report_title': 'Judul Laporan',
  'layoutReport.report_date': 'Tanggal Laporan',
  'layoutReport.click_here_to_reset_layout':
    'Klik di sini untuk mengembalikan layout laporan ke default',
  'layoutReport.show_comp_sign': 'Tampilkan Tanda Tangan',
  'layoutReport.show_comp_sign_left': 'Tampilkan Tanda Tangan Bagian Kiri',
  'layoutReport.show_comp_sign_center': 'Tampilkan Tanda Tangan Bagian Tengah',
  'layoutReport.show_comp_sign_right': 'Tampilkan Tanda Tangan Bagian Kanan',
  'layoutReport.signature': 'Tanda Tangan',
  'financeTag.add_tag': 'Tambah Tag',
  'financeTag.financeTag': 'Tag',
  'financeTag.all_tags': 'Semua tag',
  'financeTag.only_archive': 'Hanya arsip',
  'financeTag.successfully_added': 'berhasil ditambahkan.',
  'financeTag.error_cannot_add': 'Tidak dapat menambah tag.',
  'financeTag.error_cannot_update': 'Tidak dapat mengubah tag.',
  'financeTag.edit_tag': 'Ubah Tag',
  'financeTag.please_input_the_tag_name': 'Silakan masukkan nama tag.',
  'financeTag.name': 'Nama',
  'financeTag.sale': 'Penjualan',
  'financeTag.purchase': 'Pembelian',
  'financeTag.expense': 'Biaya',
  'financeTag.fixed_asset': 'Aset Tetap',
  'financeTag.other': 'Lain-lain',
  'financeTag.date': 'Tanggal',
  'financeTag.transaction': 'Transaksi',
  'financeTag.desc': 'Deskripsi',
  'financeTag.total': 'Total',
  'financeTag.max_characters': 'Maks {value} karakter.',
  'financeTag.min_characters': 'Min {value} karakter.',
  'financeTag.only_alphanumeric_allowed': 'Hanya huruf dan angka yang diperkenankan.',
  'financeTag.only_alphanumeric_and_dot_allowed':
    'Hanya huruf, angka, spasi, dan simbol . - / _ yang diperkenankan.',
  'financeTag.error_cannot_search': 'Tidak dapat mencari tag.',
  'financeTag.select_tag': 'Pilih tag',
  'financeTag.reference': 'Referensi',
  'financeTag.tag_per_item_with_title': '{tag} Peritem',
  'financeTag.tag_per_item_help':
    'Aktifkan untuk memberi {tag} berbeda di tiap baris item. Laporan berfilter {tag} akan menghitung tiap baris sesuai {tag} item-nya.',
  'financeTag.tag_per_item_help_non_journal':
    'Aktifkan untuk memberi {tag} berbeda di tiap baris item. {tag} item ikut terbawa saat transaksi ini dijadikan transaksi turunan.',
  'financeOrder.default_label_term': 'Order Termin I',
  'financeOrder.message': 'Pesan',
  'financeOrder.add_order': 'Tambah Pemesanan',
  'financeOrder.financeOrder': 'Pemesanan',
  'financeOrder.open_order': 'Pesanan belum selesai',
  'financeOrder.order_waiting_approval': 'Pesanan tunggu approval',
  'financeOrder.order_partial_shipped': 'Pesanan kirim sebagian',
  'financeOrder.error_cannot_print_pdf': 'Tidak dapat membuat pdf pemesanan.',
  'financeOrder.successfully_added': 'berhasil ditambahkan.',
  'financeOrder.error_cannot_add': 'Tidak dapat menambah pemesanan.',
  'financeOrder.error_cannot_update': 'Tidak dapat mengubah pemesanan.',
  'financeOrder.error_cannot_move': 'Tidak dapat memindah pemesanan.',
  'financeOrder.error_cannot_change_status': 'Gagal mengubah status pemesanan.',
  'financeOrder.edit_order': 'Ubah pemesanan',
  'financeOrder.max_characters': 'Maks {value} karakter.',
  'financeOrder.min_characters': 'Min {value} karakter.',
  'financeOrder.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeOrder.description': 'Deskripsi',
  'financeOrder.tax': 'Pajak',
  'financeOrder.select_tax': 'Pilih pajak',
  'financeOrder.please_select_a_contact': 'Silakan pilih kontak',
  'financeOrder.select_contact': 'Pilih kontak',
  'financeOrder.add_contact': 'Tambah kontak',
  'financeOrder.all_contacts': 'Semua kontak',
  'financeOrder.transaction_date': 'Tgl. Transaksi',
  'financeOrder.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeOrder.due_date': 'Tgl. Jatuh Tempo',
  'financeOrder.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financeOrder.term': 'Termin',
  'financeOrder.select_term': 'Pilih termin',
  'financeOrder.add_term': 'Tambah termin',
  'financeOrder.price_include_tax': 'Harga termasuk pajak',
  'financeOrder.add_more': 'Tambah baris',
  'financeOrder.number': 'Nomor',
  'financeOrder.import_quote_number': 'Nomor Penawaran',
  'financeOrder.please_input_the_number': 'Silakan isikan nomor.',
  'financeOrder.memo': 'Reference',
  'financeOrder.date': 'Tanggal',
  'financeOrder.status': 'Status',
  'financeOrder.balance_due': 'Sisa Tagihan',
  'financeOrder.total': 'Total',
  'financeOrder.please_select_a_term': 'Silakan pilih termin.',
  'financeOrder.search_by_memo': 'Cari',
  'financeOrder.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financeOrder.detail_title': ' Tagihan {number}',
  'financeOrder.customer': 'Pelanggan',
  'financeOrder.reference': 'Reference',
  'financeOrder.product': 'Produk',
  'financeOrder.qty': 'Kuantitas',
  'financeOrder.not_sent_yet': 'Belum Dikirim',
  'financeOrder.price': 'Harga',
  'financeOrder.add_product': 'Tambah Produk',
  'financeOrder.select_product': 'Pilih produk',
  'financeOrder.attachments': 'Attachment',
  'financeOrder.save_&_approve': 'Simpan & setujui',
  'financeOrder.save_as_draft': 'Simpan sbg draft',
  'financeOrder.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financeOrder.please_select_a_product': 'Silakan pilih produk.',
  'financeOrder.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financeOrder.please_input_the_price': 'Silakan masukkan harga.',
  'financeOrder.please_input_the_amount': 'Silakan masukkan total.',
  'financeOrder.approve': 'Setujui',
  'financeOrder.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financeOrder.submit_for_approval': 'Ajukan approval',
  'financeOrder.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financeOrder.create_order': 'Buat Tagihan',
  'financeOrder.amount_paid': 'Total Dibayar',
  'financeOrder.paid_from': 'Terima pembayaran ke',
  'financeOrder.add_payment': 'Terima Pembayaran',
  'financeOrder.make_a_payment': 'Terima pembayaran',
  'financeOrder.select_paid_from': 'Pilih tujuan pembayaran',
  'financeOrder.please_select_a_paid_from': 'Silakan pilih terima pembayaran ke.',
  'financeOrder.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financeOrder.payment': 'Pembayaran',
  'financeOrder.detail_order': 'Detil Tagihan',
  'financeOrder.number_quotes': 'Nomor Penawaran',
  'financeOrder.amount': 'Jumlah',
  'financeOrder.dp': 'DP',
  'financeOrder.create_delivery': 'Buat Pengiriman',
  'financeOrder.follow_these_steps_to_import_your_order':
    'Ikuti langkah-langkah berikut untuk meng-import pemesanan',
  'financeOrder.1_download_your_order_template_file': '1. Download file template pemesanan',
  'financeOrder.start_by_downloading_our_order_csv':
    'Mulai dengan mengunduh file template Excel pemesanan. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari pemesanan-mu.',
  'financeOrder.download_template_file': 'Download File Template',
  'financeOrder.download_template_data_example_file': 'Download File Contoh',
  'financeOrder.import': 'Import Pemesanan',
  'financeOrder.2_copy_your_order_into_the_template': '2. Salin detail pemesanan ke dalam template',
  'financeOrder.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail pemesanan ke dalam file template dari Kledo. Pastikan detail pemesanan sesuai dengan kolom header yang ada di template.',
  'financeOrder.important': 'PENTING',
  'financeOrder.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financeOrder.upload': 'Upload',
  'financeOrder.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financeOrder.a_maximum_of_500_order_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris pesanan maupun item.',
  'financeOrder.import_actions_only_insert_new_order_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financeOrder.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financeOrder.order_successfully_imported': '{rowCount} baris pemesanan berhasil diimport.',
  'financeOrder.go_to_order_list': 'Ke halaman daftar pemesanan',
  'financeOrder.print_order': 'Cetak Pemesanan',
  'financeOrder.order_will_be_sent_via': 'Pemesanan akan dikirim melalui',
  'financeOrder.copy_link': 'Salin Link Pemesanan',
  'financeOrder.send_email': 'Kirim Email Pemesanan',
  'financeOrder.send_sms': 'Kirim SMS Pemesanan',
  'financeOrder.send_wa': 'Kirim Whatsapp Pemesanan',
  'financeOrder.insufficient_stock_warning':
    'Tidak dapat menambah pemesanan, karena terdapat produk yang stok nya kurang.',
  'financeOrder.cannot_edit_insufficient_stock_warning':
    'Tidak dapat merubah pemesanan, karena terdapat produk yang stok nya kurang.',
  'financeDelivery.message': 'Pesan',
  'financeDelivery.add_delivery': 'Tambah Pengiriman',
  'financeDelivery.financeDelivery': 'Pengiriman',
  'financeDelivery.open_delivery': 'Pengiriman belum selesai',
  'financeDelivery.error_cannot_print_pdf': 'Tidak dapat membuat pdf pengiriman.',
  'financeDelivery.successfully_added': 'berhasil ditambahkan.',
  'financeDelivery.error_cannot_add': 'Tidak dapat menambah pengiriman.',
  'financeDelivery.error_cannot_update': 'Tidak dapat mengubah pengiriman.',
  'financeDelivery.error_cannot_move': 'Tidak dapat memindah pengiriman.',
  'financeDelivery.error_cannot_change_status': 'Gagal mengubah status pengiriman.',
  'financeDelivery.edit_delivery': 'Ubah pengiriman',
  'financeDelivery.max_characters': 'Maks {value} karakter.',
  'financeDelivery.min_characters': 'Min {value} karakter.',
  'financeDelivery.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financeDelivery.description': 'Deskripsi',
  'financeDelivery.tax': 'Pajak',
  'financeDelivery.select_tax': 'Pilih pajak',
  'financeDelivery.please_select_a_contact': 'Silakan pilih kontak',
  'financeDelivery.select_contact': 'Pilih kontak',
  'financeDelivery.add_contact': 'Tambah kontak',
  'financeDelivery.all_contacts': 'Semua kontak',
  'financeDelivery.transaction_date': 'Tgl. Transaksi',
  'financeDelivery.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financeDelivery.due_date': 'Tgl. Jatuh Tempo',
  'financeDelivery.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financeDelivery.term': 'Termin',
  'financeDelivery.select_term': 'Pilih termin',
  'financeDelivery.add_term': 'Tambah termin',
  'financeDelivery.price_include_tax': 'Harga termasuk pajak',
  'financeDelivery.add_more': 'Tambah baris',
  'financeDelivery.number': 'Nomor',
  'financeDelivery.please_input_the_number': 'Silakan isikan nomor.',
  'financeDelivery.memo': 'Reference',
  'financeDelivery.date': 'Tanggal',
  'financeDelivery.status': 'Status',
  'financeDelivery.balance_due': 'Sisa Tagihan',
  'financeDelivery.total': 'Total',
  'financeDelivery.please_select_a_term': 'Silakan pilih termin.',
  'financeDelivery.search_by_memo': 'Cari',
  'financeDelivery.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financeDelivery.detail_title': ' Tagihan {number}',
  'financeDelivery.customer': 'Pelanggan',
  'financeDelivery.reference': 'Reference',
  'financeDelivery.product': 'Produk',
  'financeDelivery.qty': 'Kuantitas',
  'financeDelivery.price': 'Harga',
  'financeDelivery.add_product': 'Tambah Produk',
  'financeDelivery.select_product': 'Pilih produk',
  'financeDelivery.attachments': 'Attachment',
  'financeDelivery.save_&_approve': 'Simpan & setujui',
  'financeDelivery.save_as_draft': 'Simpan sbg draft',
  'financeDelivery.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financeDelivery.please_select_a_product': 'Silakan pilih produk.',
  'financeDelivery.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financeDelivery.please_input_the_price': 'Silakan masukkan harga.',
  'financeDelivery.please_input_the_amount': 'Silakan masukkan total.',
  'financeDelivery.approve': 'Setujui',
  'financeDelivery.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financeDelivery.submit_for_approval': 'Ajukan approval',
  'financeDelivery.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financeDelivery.create_delivery': 'Buat Tagihan',
  'financeDelivery.amount_paid': 'Total Dibayar',
  'financeDelivery.paid_from': 'Terima pembayaran ke',
  'financeDelivery.add_payment': 'Terima Pembayaran',
  'financeDelivery.make_a_payment': 'Terima pembayaran',
  'financeDelivery.select_paid_from': 'Pilih tujuan pembayaran',
  'financeDelivery.please_select_a_paid_from': 'Silakan pilih terima pembayaran ke.',
  'financeDelivery.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financeDelivery.payment': 'Pembayaran',
  'financeDelivery.detail_delivery': 'Detil Tagihan',
  'financeDelivery.number_quotes': 'Nomor Penawaran',
  'financeDelivery.amount': 'Jumlah',
  'financeDelivery.shipping_delivery': 'Biaya Pengiriman',
  'financeDelivery.print_delivery': 'Cetak Surat Jalan',
  'financeDelivery.print_delivery_label': 'Cetak Label Pengiriman',
  'financeDelivery.copy_link': 'Salin Link Surat Jalan',
  'financeDelivery.send_email': 'Kirim Email Surat Jalan',
  'financeDelivery.send_sms': 'Kirim SMS Surat Jalan',
  'financeDelivery.send_wa': 'Kirim Whatsapp Surat Jalan',
  'shipping.show_shipping_information': 'Tampilkan Informasi Pengiriman',
  'shipping.hide_shipping_information': 'Sembunyikan Informasi Pengiriman',
  'shipping.shipping_date': 'Tanggal Pengiriman',
  'shipping.shipping_expedition': 'Ekspedisi',
  'shipping.shipping_tracking': 'No. Resi',
  'shipping.select_expedition': 'Pilih ekspedisi',
  'shipping.add_expedition': 'Tambah ekspedisi',
  'shipping.shipping_cost': 'Biaya pengiriman',
  'shipping.please_select_shipping_date': 'Silahkan pilih tanggal pengiriman.',
  'shipping.shipping_information': 'Informasi pengiriman',
  'creditMemo.add_credit_memo': 'Tambah Hutang',
  'creditMemo.credit_memo': 'Hutang',
  'creditMemo.add_transactions': 'Tambah Transaksi',
  'creditMemo.successfully_added': 'Berhasil ditambahkan',
  'creditMemo.error_cannot_add': 'Tidak dapat menambah hutang',
  'creditMemo.error_cannot_update': 'Hutang gagal diperbarui',
  'creditMemo.edit_credit_memo': 'Ubah Hutang',
  'creditMemo.max_characters': 'Maks. {value} karakter',
  'creditMemo.min_characters': 'Min. {value} karakter',
  'creditMemo.only_number_allowed': 'Hanya angka yang diperbolehkan',
  'creditMemo.description': 'Deskripsi',
  'creditMemo.message': 'Pesan',
  'creditMemo.amount': 'Jumlah',
  'creditMemo.transaction_date': 'Tanggal Transaksi',
  'creditMemo.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'creditMemo.number': 'Nomor',
  'creditMemo.please_input_the_number': 'Silakan masukkan nomor.',
  'creditMemo.memo': 'Reference',
  'creditMemo.date': 'Tanggal',
  'creditMemo.total': 'Total',
  'creditMemo.credit_balance': 'Sisa Hutang',
  'creditMemo.detail_title': 'Hutang {number}',
  'creditMemo.reference': 'Reference',
  'creditMemo.attachments': 'Attachment',
  'creditMemo.please_input_the_amount': 'Silakan masukkan jumlah',
  'creditMemo.status': 'Status',
  'creditMemo.balance_due': 'Sisa Tagihan',
  'creditMemo.search_by_memo': 'Cari',
  'creditMemo.customer': 'Pelanggan',
  'creditMemo.detail_credit_memo': 'Detil Hutang',
  'creditMemo.account': 'Akun',
  'creditMemo.select_account': 'Pilih akun',
  'creditMemo.balancer_account': 'Akun Hutang',
  'creditMemo.balancer_account_placeholder': 'Ikut pengaturan kontak',
  'creditMemo.balancer_account_tooltip': 'Kosongkan untuk memakai akun dari pemetaan akun kontak.',
  'creditMemo.balancer_account_locked':
    'Tidak bisa diubah karena transaksi ini sudah dilunasi atau sudah dipakai membayar.',
  'creditMemo.make_a_payment': 'Buat pembayaran',
  'creditMemo.return_number': 'Nomor Retur',
  'return.add_return': 'Tambah Retur',
  'return.return': 'Retur',
  'return.detail_return': 'Detail Retur',
  'return.vendor': 'Vendor',
  'return.add_transactions': 'Tambah Transaksi',
  'return.successfully_added': 'Berhasil ditambahkan',
  'return.error_cannot_add': 'Tidak dapat menambah retur',
  'return.error_cannot_update': 'Retur gagal diperbarui',
  'return.edit_return': 'Ubah Retur',
  'return.max_characters': 'Maks. {value} karakter',
  'return.min_characters': 'Min. {value} karakter',
  'return.only_number_allowed': 'Hanya angka yang diperbolehkan',
  'return.description': 'Deskripsi',
  'return.message': 'Pesan',
  'return.amount': 'Jumlah',
  'return.transaction_date': 'Tanggal Retur',
  'return.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'return.number': 'Nomor',
  'return.please_input_the_number': 'Silakan masukkan nomor.',
  'return.memo': 'Reference',
  'return.date': 'Tanggal',
  'return.total': 'Total',
  'return.credit_balance': 'Sisa Retur',
  'return.detail_title': 'Retur {number}',
  'return.reference': 'Reference',
  'return.attachments': 'Attachment',
  'return.please_input_the_amount': 'Silakan masukkan jumlah',
  'return.status': 'Status',
  'return.balance_due': 'Sisa Tagihan',
  'return.search_by_memo': 'Cari',
  'return.customer': 'Pelanggan',
  'return.detail_credit_memo': 'Detil Retur',
  'return.account': 'Akun',
  'return.select_account': 'Pilih akun',
  'return.make_a_payment': 'Buat pembayaran',
  'return.invoice': 'Tagihan',
  'return.faktur_balance': 'Jumlah Faktur',
  'return.qty_faktur': 'Qty Faktur',
  'return.available_return': 'Yang Bisa Diretur',
  'return.product': 'Produk',
  'return.discount_percent': 'Diskon',
  'return.tax': 'Pajak',
  'return.qty_return': 'Qty Retur',
  'return.price': 'Price',
  'return.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'return.price_include_tax': 'Harga termasuk pajak',
  'return.cannot_greather_than_available': 'Tidak dapat melebihi jumlah yang tersedia.',
  'return.amount_cannot_greather_than_available':
    'Jumlah tidak dapat melebihi jumlah yang tersedia.',
  'return.total_return': 'Total Retur',
  'financePurchaseQuotes.message': 'Pesan',
  'financePurchaseQuotes.error_cannot_print_pdf': 'Tidak dapat membuat pdf penawaran.',
  'financePurchaseQuotes.add_quote': 'Tambah Penawaran',
  'financePurchaseQuotes.financePurchaseQuotes': 'Penawaran',
  'financePurchaseQuotes.financePurchaseQuotes2': 'Penawaran Pembelian',
  'financePurchaseQuotes.successfully_added': 'berhasil ditambahkan.',
  'financePurchaseQuotes.error_cannot_add': 'Tidak dapat menambah penawaran.',
  'financePurchaseQuotes.error_cannot_update': 'Tidak dapat mengubah penawaran.',
  'financePurchaseQuotes.error_cannot_move': 'Tidak dapat memindah penawaran.',
  'financePurchaseQuotes.error_cannot_change_status': 'Tidak dapat mengubah status penawaran.',
  'financePurchaseQuotes.edit_quote': 'Ubah Penawaran',
  'financePurchaseQuotes.max_characters': 'Maks {value} karakter.',
  'financePurchaseQuotes.min_characters': 'Min {value} karakter.',
  'financePurchaseQuotes.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financePurchaseQuotes.description': 'Deskripsi',
  'financePurchaseQuotes.tax': 'Pajak',
  'financePurchaseQuotes.select_tax': 'Pilih pajak',
  'financePurchaseQuotes.amount': 'Total',
  'financePurchaseQuotes.please_select_a_contact': 'Silakan pilih kontak',
  'financePurchaseQuotes.select_contact': 'Pilih kontak',
  'financePurchaseQuotes.add_contact': 'Tambah kontak',
  'financePurchaseQuotes.all_contacts': 'Semua kontak',
  'financePurchaseQuotes.transaction_date': 'Tgl. Transaksi',
  'financePurchaseQuotes.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financePurchaseQuotes.due_date': 'Kadaluarsa',
  'financePurchaseQuotes.please_select_due_date': 'Silakan pilih tanggal kadaluarsa',
  'financePurchaseQuotes.term': 'Termin',
  'financePurchaseQuotes.select_term': 'Pilih termin',
  'financePurchaseQuotes.add_term': 'Tambah termin',
  'financePurchaseQuotes.price_include_tax': 'Harga termasuk pajak',
  'financePurchaseQuotes.add_more': 'Tambah baris',
  'financePurchaseQuotes.number': 'Nomor',
  'financePurchaseQuotes.please_input_the_number': 'Silakan isikan nomor.',
  'financePurchaseQuotes.memo': 'Reference',
  'financePurchaseQuotes.date': 'Tanggal',
  'financePurchaseQuotes.status': 'Status',
  'financePurchaseQuotes.balance_due': 'Sisa Tagihan',
  'financePurchaseQuotes.please_select_a_term': 'Silakan pilih termin.',
  'financePurchaseQuotes.search_by_memo': 'Cari',
  'financePurchaseQuotes.the_due_date_max_higger_than_transaction_date':
    'Tanggal kadaluarsa harus sama atau setelah tanggal transaksi',
  'financePurchaseQuotes.detail_title': 'Penawaran {number}',
  'financePurchaseQuotes.customer': 'Pelanggan',
  'financePurchaseQuotes.reference': 'Reference',
  'financePurchaseQuotes.product': 'Produk',
  'financePurchaseQuotes.qty': 'Kuantitas',
  'financePurchaseQuotes.price': 'Harga',
  'financePurchaseQuotes.add_product': 'Tambah Produk',
  'financePurchaseQuotes.select_product': 'Pilih produk',
  'financePurchaseQuotes.attachments': 'Attachment',
  'financePurchaseQuotes.save_as_draft': 'Simpan sbg draft',
  'financePurchaseQuotes.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financePurchaseQuotes.please_select_a_product': 'Silakan pilih produk.',
  'financePurchaseQuotes.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financePurchaseQuotes.please_input_the_price': 'Silakan masukkan harga.',
  'financePurchaseQuotes.please_input_the_amount': 'Silakan masukkan total.',
  'financePurchaseQuotes.mark_as_sent': 'Tandai sbg terkirim',
  'financePurchaseQuotes.are_you_sure_to_mark_as_sent':
    'Apakah Anda yakin menandai sebagai terkirim?',
  'financePurchaseQuotes.mark_as_accepted': 'Tandai sbg diterima',
  'financePurchaseQuotes.are_you_sure_to_mark_as_accepted':
    'Apakah Anda yakin menandai sebagai diterima?',
  'financePurchaseQuotes.mark_as_declined': 'Tandai sbg ditolak',
  'financePurchaseQuotes.are_you_sure_to_mark_as_declined':
    'Apakah Anda yakin menandai sebagai ditolak?',
  'financePurchaseQuotes.create_invoice': 'Buat Tagihan',
  'financePurchaseQuotes.send': 'Kirim',
  'financePurchaseQuotes.detail_quote': 'Detil Penawaran',
  'financePurchaseQuotes.create_order': 'Buat Pemesanan',
  'financePurchaseQuotes.follow_these_steps_to_import_your_quotes':
    'Ikuti langkah berikut untuk mengimport penawaranmu',
  'financePurchaseQuotes.1_download_your_quotes_template_file':
    '1. Download file template penawaran',
  'financePurchaseQuotes.start_by_downloading_our_quotes_csv':
    'Mulai dengan mengunduh file template Excel penawaran. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari penawaran-penawaranmu.',
  'financePurchaseQuotes.download_template_file': 'Download File Template',
  'financePurchaseQuotes.download_template_data_example_file': 'Download File Contoh',
  'financePurchaseQuotes.import': 'Import Penawaran',
  'financePurchaseQuotes.2_copy_your_quotes_into_the_template':
    '2. Salin detail penawaran ke dalam template',
  'financePurchaseQuotes.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail penawaran ke dalam file template dari Kledo. Pastikan detail penawaran sesuai dengan kolom header yang ada di template.',
  'financePurchaseQuotes.important': 'PENTING',
  'financePurchaseQuotes.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'financePurchaseQuotes.upload': 'Upload',
  'financePurchaseQuotes.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'financePurchaseQuotes.a_maximum_of_500_quotes_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 2.500 baris data Excel. Setiap baris dihitung, termasuk baris penawaran pembelian maupun item.',
  'financePurchaseQuotes.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Nama kontak yang yang belum ada di Kledo akan dimasukkan sebagai kontak baru.',
  'financePurchaseQuotes.import_actions_only_insert_new_quotes_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'financePurchaseQuotes.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'financePurchaseQuotes.you_can_only_upload_csv_file':
    'Anda hanya dapat mengunggah file csv atau excel',
  'financePurchaseQuotes.upload_file': 'Upload File',
  'financePurchaseQuotes.check_the_imported_data': 'Cek Data',
  'financePurchaseQuotes.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'financePurchaseQuotes.import_quotes_done': 'Import Berhasil',
  'financePurchaseQuotes.error_upload_file': 'Gagal mengunggah file.',
  'financePurchaseQuotes.file_not_found': 'File tidak ditemukan.',
  'financePurchaseQuotes.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'financePurchaseQuotes.valid': 'Valid',
  'financePurchaseQuotes.invalid': 'Invalid',
  'financePurchaseQuotes.total': 'Total',
  'financePurchaseQuotes.import_now': 'Import Sekarang',
  'financePurchaseQuotes.contact_name': 'Nama Kontak',
  'financePurchaseQuotes.email': 'Email',
  'financePurchaseQuotes.address': 'Alamat',
  'financePurchaseQuotes.phone': 'Phone',
  'financePurchaseQuotes.quote_date': 'Tanggal Penawaran',
  'financePurchaseQuotes.quote_number': 'Nomor Penawaran',
  'financePurchaseQuotes.product_name': 'Nama Produk',
  'financePurchaseQuotes.code_sku': 'Kode/SKU',
  'financePurchaseQuotes.tax_inclusive': 'Termasuk Pajak',
  'financePurchaseQuotes.inventory_account': 'Akun Penyimpanan',
  'financePurchaseQuotes.quotes_successfully_imported': '{rowCount} quote berhasil diimport.',
  'financePurchaseQuotes.view_detail': 'Tampilkan detil',
  'financePurchaseQuotes.import_another_file': 'Import file lain',
  'financePurchaseQuotes.go_to_quote_list': 'Ke halaman daftar quote',
  'financePurchaseQuotes.success': 'Berhasil',
  'financePurchaseQuotes.failed': 'Gagal',
  'financePurchaseQuotes.error_cannot_import': 'Gagal import.',
  'financePurchaseQuotes.error': 'Error',
  'financePurchaseQuotes.vendor': 'Vendor',
  'debitMemo.add_debit_memo': 'Tambah Piutang',
  'debitMemo.debit_memo': 'Piutang',
  'debitMemo.add_transactions': 'Tambah Transaksi',
  'debitMemo.successfully_added': 'Berhasil ditambahkan',
  'debitMemo.error_cannot_add': 'Tidak dapat menambah hutang',
  'debitMemo.error_cannot_update': 'Piutang gagal diperbarui',
  'debitMemo.edit_debit_memo': 'Ubah Piutang',
  'debitMemo.max_characters': 'Maks. {value} karakter',
  'debitMemo.min_characters': 'Min. {value} karakter',
  'debitMemo.only_number_allowed': 'Hanya angka yang diperbolehkan',
  'debitMemo.description': 'Deskripsi',
  'debitMemo.message': 'Pesan',
  'debitMemo.amount': 'Jumlah',
  'debitMemo.transaction_date': 'Tanggal Transaksi',
  'debitMemo.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'debitMemo.number': 'Nomor',
  'debitMemo.please_input_the_number': 'Silakan masukkan nomor.',
  'debitMemo.memo': 'Reference',
  'debitMemo.date': 'Tanggal',
  'debitMemo.total': 'Total',
  'debitMemo.debit_balance': 'Sisa Piutang',
  'debitMemo.detail_title': 'Piutang {number}',
  'debitMemo.reference': 'Reference',
  'debitMemo.attachments': 'Attachment',
  'debitMemo.please_input_the_amount': 'Silakan masukkan jumlah',
  'debitMemo.status': 'Status',
  'debitMemo.balance_due': 'Sisa Tagihan',
  'debitMemo.search_by_memo': 'Cari',
  'debitMemo.customer': 'Pelanggan',
  'debitMemo.detail_debit_memo': 'Detil Piutang',
  'debitMemo.account': 'Akun',
  'debitMemo.select_account': 'Pilih akun',
  'debitMemo.balancer_account': 'Akun Piutang',
  'debitMemo.balancer_account_placeholder': 'Ikut pengaturan kontak',
  'debitMemo.balancer_account_tooltip': 'Kosongkan untuk memakai akun dari pemetaan akun kontak.',
  'debitMemo.balancer_account_locked':
    'Tidak bisa diubah karena transaksi ini sudah dilunasi atau sudah dipakai membayar.',
  'debitMemo.make_a_payment': 'Terima Pembayaran',
  'debitMemo.return_number': 'Nomor Retur',
  'financePurchaseDelivery.message': 'Pesan',
  'financePurchaseDelivery.add_delivery': 'Tambah Pengiriman',
  'financePurchaseDelivery.financePurchaseDelivery': 'Pengiriman',
  'financePurchaseDelivery.error_cannot_print_pdf': 'Tidak dapat membuat pdf pengiriman.',
  'financePurchaseDelivery.successfully_added': 'berhasil ditambahkan.',
  'financePurchaseDelivery.error_cannot_add': 'Tidak dapat menambah pengiriman.',
  'financePurchaseDelivery.error_cannot_update': 'Tidak dapat mengubah pengiriman.',
  'financePurchaseDelivery.error_cannot_move': 'Tidak dapat memindah pengiriman.',
  'financePurchaseDelivery.error_cannot_change_status': 'Gagal mengubah status pengiriman.',
  'financePurchaseDelivery.edit_delivery': 'Ubah pengiriman',
  'financePurchaseDelivery.max_characters': 'Maks {value} karakter.',
  'financePurchaseDelivery.min_characters': 'Min {value} karakter.',
  'financePurchaseDelivery.only_number_allowed': 'Hanya angka yang diperkenankan.',
  'financePurchaseDelivery.description': 'Deskripsi',
  'financePurchaseDelivery.tax': 'Pajak',
  'financePurchaseDelivery.select_tax': 'Pilih pajak',
  'financePurchaseDelivery.please_select_a_contact': 'Silakan pilih kontak',
  'financePurchaseDelivery.select_contact': 'Pilih kontak',
  'financePurchaseDelivery.add_contact': 'Tambah kontak',
  'financePurchaseDelivery.all_contacts': 'Semua kontak',
  'financePurchaseDelivery.transaction_date': 'Tgl. Transaksi',
  'financePurchaseDelivery.please_select_transaction_date': 'Silakan pilih tanggal transaksi',
  'financePurchaseDelivery.due_date': 'Tgl. Jatuh Tempo',
  'financePurchaseDelivery.please_select_due_date': 'Silakan pilih tanggal jatuh tempo',
  'financePurchaseDelivery.term': 'Termin',
  'financePurchaseDelivery.select_term': 'Pilih termin',
  'financePurchaseDelivery.add_term': 'Tambah termin',
  'financePurchaseDelivery.price_include_tax': 'Harga termasuk pajak',
  'financePurchaseDelivery.add_more': 'Tambah baris',
  'financePurchaseDelivery.number': 'Nomor',
  'financePurchaseDelivery.please_input_the_number': 'Silakan isikan nomor.',
  'financePurchaseDelivery.memo': 'Reference',
  'financePurchaseDelivery.date': 'Tanggal',
  'financePurchaseDelivery.status': 'Status',
  'financePurchaseDelivery.balance_due': 'Sisa Tagihan',
  'financePurchaseDelivery.total': 'Total',
  'financePurchaseDelivery.please_select_a_term': 'Silakan pilih termin.',
  'financePurchaseDelivery.search_by_memo': 'Cari',
  'financePurchaseDelivery.the_due_date_max_higger_than_transaction_date':
    'Tanggal jatuh tempo harus sama atau setelah tanggal transaksi',
  'financePurchaseDelivery.detail_title': ' Tagihan {number}',
  'financePurchaseDelivery.customer': 'Pelanggan',
  'financePurchaseDelivery.reference': 'Reference',
  'financePurchaseDelivery.product': 'Produk',
  'financePurchaseDelivery.qty': 'Kuantitas',
  'financePurchaseDelivery.price': 'Harga',
  'financePurchaseDelivery.add_product': 'Tambah Produk',
  'financePurchaseDelivery.select_product': 'Pilih produk',
  'financePurchaseDelivery.attachments': 'Attachment',
  'financePurchaseDelivery.save_&_approve': 'Simpan & setujui',
  'financePurchaseDelivery.save_as_draft': 'Simpan sbg draft',
  'financePurchaseDelivery.save_&_submit_for_approval': 'Simpan & ajukan approval',
  'financePurchaseDelivery.please_select_a_product': 'Silakan pilih produk.',
  'financePurchaseDelivery.please_input_the_qty': 'Silakan masukkan kuantitas.',
  'financePurchaseDelivery.please_input_the_price': 'Silakan masukkan harga.',
  'financePurchaseDelivery.please_input_the_amount': 'Silakan masukkan total.',
  'financePurchaseDelivery.approve': 'Setujui',
  'financePurchaseDelivery.are_you_sure_to_approve': 'Apakah Anda yakin untuk menyutujui?',
  'financePurchaseDelivery.submit_for_approval': 'Ajukan approval',
  'financePurchaseDelivery.are_you_sure_to_submit_for_approval':
    'Apakah Anda yakin untuk mengajukan approval?',
  'financePurchaseDelivery.create_delivery': 'Buat Tagihan',
  'financePurchaseDelivery.amount_paid': 'Total Dibayar',
  'financePurchaseDelivery.paid_from': 'Terima pembayaran ke',
  'financePurchaseDelivery.add_payment': 'Terima Pembayaran',
  'financePurchaseDelivery.make_a_payment': 'Terima pembayaran',
  'financePurchaseDelivery.select_paid_from': 'Pilih tujuan pembayaran',
  'financePurchaseDelivery.please_select_a_paid_from': 'Silakan pilih terima pembayaran ke.',
  'financePurchaseDelivery.error_cannot_add_payment': 'Tidak bisa menambah pembayaran.',
  'financePurchaseDelivery.payment': 'Pembayaran',
  'financePurchaseDelivery.detail_delivery': 'Detil Tagihan',
  'financePurchaseDelivery.number_quotes': 'Nomor Penawaran',
  'financePurchaseDelivery.amount': 'Jumlah',
  'financePurchaseDelivery.shipping_delivery': 'Biaya Pengiriman',
  'financePurchaseDelivery.vendor': 'Vendor',
  'financePurchaseDelivery.print_receipt_of_goods': 'Cetak Bukti Terima Barang',
  'businessFlow.businessFlow': 'Pengaturan Alur Bisnis',
  'businessFlow.sales_discount': 'Diskon penjualan',
  'businessFlow.sales_discount_desc': 'Apakah perusahaan Anda dapat memberikan diskon penjualan?',
  'businessFlow.delivery_desc': 'Apakah perusahaan Anda membuat surat jalan saat pengiriman?',
  'businessFlow.order_desc': 'Apakah perusahaan Anda menerima pemesanan penjualan?',
  'businessFlow.quote_desc': 'Apakah perusahaan Anda mengirimkan penawaran penjualan?',
  'businessFlow.down_payment': 'Uang muka',
  'businessFlow.down_payment_desc': 'Apakah perusahaan Anda dapat menerima uang muka penjualan?',
  'businessFlow.purchase_down_payment_desc':
    'Apakah perusahaan Anda dapat membayarkan uang muka pembelian?',
  'businessFlow.purchase_discount': 'Diskon pembelian',
  'businessFlow.purchase_discount_desc': 'Apakah perusahaan Anda dapat menerima diskon pembelian?',
  'businessFlow.purchase_delivery': 'Pengiriman pembelian',
  'businessFlow.purchase_delivery_desc': 'Apakah fitur pengiriman pembelian diaktifkan?',
  'businessFlow.purchase_order': 'Pesanan pembelian',
  'businessFlow.purchase_order_desc': 'Apakah perusahaan Anda melakukan pemesanan pembelian?',
  'businessFlow.purchase_quote': 'Penawaran pembelian',
  'businessFlow.purchase_quote_desc': 'Apakah perusahaan Anda menerima pemesanan pembelian?',
  'businessFlow.purchase_request': 'Permintaan pembelian',
  'businessFlow.purchase_request_desc':
    'Apakah perusahaan Anda melakukan pengajuan permintaan pembelian internal sebelum pemesanan?',
  'businessFlow.reconciliation': 'Rekonsiliasi',
  'businessFlow.reconciliation_desc':
    'Apakah Anda merekonsiliasi transaksi di Kledo dengan mutasi di rekening bank?',
  'businessFlow.tracking_stock': 'Lacak inventori/stok secara default',
  'businessFlow.tracking_stock_desc':
    'Saat menambah produk, secara default set produk untuk melacak stok',
  'businessFlow.error_cannot_update': 'Tidak dapat mengubah pengaturan.',
  'businessFlow.decline_new_sales_if_stock_not_enough': 'Tolak tagihan baru jika stok kurang',
  'businessFlow.decline_new_order_if_stock_not_enough': 'Tolak pemesanan jika stok kurang',
  'businessFlow.decline_new_delivery_if_stock_not_enough': 'Tolak pengiriman baru jika stok kurang',
  'businessFlow.show_available_stock_when_making_a_sale':
    'Tampilkan stok tersedia saat membuat penjualan',
  'businessFlow.show_sales_description': 'Tampilkan deskripsi di penjualan',
  'businessFlow.show_sales_description_desc': 'Apakah kolom deskripsi di penjualan ditampilkan?',
  'businessFlow.show_purchases_description': 'Tampilkan deskripsi di pembelian',
  'businessFlow.show_purchases_description_desc':
    'Apakah kolom deskripsi di pembelian ditampilkan?',
  'businessFlow.hide_products_that_are_out_of_stock': 'Sembunyikan produk yang stok habis',
  'businessFlow.hide_products_that_are_out_of_stock_description':
    'Apakah produk yang stok habis disembunyikan saat menambah penjualan?',
  'businessFlow.show_profit_margin_when_making_transaction':
    'Tampilkan profit margin saat membuat transaksi',
  'businessFlow.show_details_of_average_price_and_profit_margin_when_making_a_new_transaction':
    'Menampilkan detail harga rata-rata dan profit margin saat membuat transaksi baru.',
  'businessFlow.whether_stock_is_in_the_warehouse':
    'Apakah stok yang ada di gudang perlu ditampilkan saat membuat penjualan?',
  'businessFlow.show_available_stock_per_warehouse':
    'Perhitungan stok berdasarkan gudang yang dipilih',
  'businessFlow.whether_displayed_stock_needs_per_warehouse':
    'Jika diaktifkan, maka perhitungan stok berdasarkan gudang yang dipilih, bukan berdasarkan kesuluruhan stok',
  'businessFlow.decline_to_add_sales_if_the_total_stock_not_enough':
    'Tolak tambah tagihan jika total stok di gudang tidak mencukupi?',
  'businessFlow.decline_to_add_order_if_the_total_stock_not_enough':
    'Tolak pemesanan jika total stok di gudang tidak mencukupi?',
  'businessFlow.decline_to_add_delivery_if_the_total_stock_not_enough':
    'Tolak tambah pengiriman jika total stok di gudang tidak mencukupi?',
  'businessFlow.discount_in_nominal': 'Input diskon dalam nominal',
  'businessFlow.wether_discount_input_when_add_invoice_in_nominal_format_or_percent_format':
    'Jika aktif maka input diskon saat menambah tagihan akan dalam format nominal, bukan dalam format persen.',
  'businessFlow.product_price_dont_change': 'Harga produk tidak bisa diubah',
  'businessFlow.wether_product_price_can_be_changed_when_add_invoice':
    'Jika aktif maka harga produk saat menambah tagihan tidak dapat diubah.',
  'businessFlow.sales_person': 'Sales person',
  'businessFlow.default_sale_include_tax': 'Default harga penjualan termasuk pajak',
  'businessFlow.wether_create_sale_invoice_include_tax':
    'Apakah saat membuat tagihan defaultnya harga penjualan termasuk pajak?',
  'businessFlow.default_purchase_include_tax': 'Default harga pembelian termasuk pajak',
  'businessFlow.wether_create_purchase_invoice_include_tax':
    'Apakah saat membuat tagihan defaultnya harga pembelian termasuk pajak?',
  'businessFlow.min_stock': 'Stok minimal',
  'businessFlow.when_product_below_min_stock_email_notification':
    'Saat stok produk di bawah stok minimal, akan dikirimkan email notifikasi',
  'businessFlow.decline_product_conv_if_stock_not_enough': 'Tolak konversi produk jika stok kurang',
  'businessFlow.wether_decline_add_product_conv_if_stock_not_enough':
    'Apakah tolak penambahan konversi produk jika stok bahan baku tidak mencukupi?',
  'businessFlow.lang_date_currency': 'Bahasa, Tanggal, & Mata Uang',
  'businessFlow.module_desc.sales': 'Alur transaksi, stok, dan form penjualan',
  'businessFlow.module_desc.purchases': 'Alur transaksi dan form pembelian',
  'businessFlow.module_desc.expenses': 'Validasi form biaya',
  'businessFlow.module_desc.products': 'Perilaku harga, stok, dan data produk',
  'businessFlow.module_desc.inventory': 'Transfer gudang dan penyesuaian stok',
  'businessFlow.module_desc.contacts': 'Validasi dan kelengkapan data kontak',
  'businessFlow.module_desc.reports': 'Preferensi tampilan laporan',
  'businessFlow.module_desc.cash_bank': 'Rekonsiliasi dan validasi transaksi bank',
  'businessFlow.module_desc.manual_journal': 'Validasi jurnal manual',
  'businessFlow.module_desc.format_dropdown': 'Format tampilan pilihan di dropdown',
  'businessFlow.module_desc.lang_date_currency': 'Preferensi regional aplikasi',
  'businessFlow.module_desc.system': 'Fitur tingkat sistem',
  'businessFlow.module_desc.fixed_assets': 'Perilaku aset tetap',
  'businessFlow.search_result_count': '{count} hasil untuk "{query}" di modul ini',
  'businessFlow.see_example': 'Lihat contoh',
  'businessFlow.app_lang': 'Bahasa Invoice',
  'businessFlow.app_lang_desc':
    'Bahasa yang digunakan secara default untuk seluruh staff perusahaan Anda',
  'businessFlow.time_zone': 'Zona waktu',
  'businessFlow.time_zone_desc': 'Zona waktu lokasi perusahaan Anda',
  'businessFlow.date_format': 'Format tanggal',
  'businessFlow.date_format_desc': 'Tampilan tanggal di aplikasi Kledo',
  'businessFlow.time_format': 'Format waktu',
  'businessFlow.time_format_desc': 'Tampilan jam dan menit di aplikasi Kledo',
  'businessFlow.number_after_comma': 'Jumlah angka di belakang koma',
  'businessFlow.number_after_comma_desc':
    'Berapa jumlah angka di belakang koma yang ditampilkan di aplikasi Kledo?',
  'businessFlow.currency_format': 'Format mata uang',
  'businessFlow.currency_format_desc': 'Tampilan mata uang di aplikasi Kledo',
  'businessFlow.activate_multi_currency': 'Aktifkan fitur multi mata uang',
  'businessFlow.activate_multi_currency_desc':
    'Apakah perusahaan Anda menggunakan lebih dari satu mata uang?',
  'businessFlow.base_currency': 'Mata uang dasar',
  'businessFlow.base_currency_desc':
    'Mata uang yang digunakan sebagai mata uang utama di perusahaan Anda',
  'businessFlow.show_coa': 'Tampilkan COA',
  'businessFlow.show_coa_desc': 'Tampilkan COA di laporan laba rugi',
  'businessFlow.show_currency_symbol': 'Tampilkan simbol mata uang',
  'businessFlow.show_currency_symbol_desc':
    'Apakah simbol mata uang akan ditampilkan di tampilan antar muka?',
  'businessFlow.show_reference': 'Tampilkan reference',
  'businessFlow.show_reference_desc': 'Apakah input reference ditampilkan saat membuat invoice?',
  'businessFlow.show_tag': 'Tampilkan tag',
  'businessFlow.show_tag_desc': 'Apakah input tag ditampilkan saat membuat invoice?',
  'businessFlow.input_tag_is_required': 'Input tag wajib diisi',
  'businessFlow.input_tag_is_required_desc':
    'Apakah tag wajib diiisi saat menambahkan transaksi penjualan?',
  'businessFlow.show_delivery_info': 'Tampilkan informasi pengiriman',
  'businessFlow.show_delivery_info_desc':
    'Apakah input informasi pengiriman ditampilkan saat membuat invoice?',
  'businessFlow.lock_price_from_quote': 'Kunci harga dari penawaran',
  'businessFlow.lock_price_from_quote_desc':
    'Apakah saat membuat tagihan dari penawaran, harganya dibuat tidak bisa diubah?',
  'businessFlow.lock_price_from_purchase_quote': 'Kunci harga dari penawaran pembelian',
  'businessFlow.lock_price_from_purchase_quote_desc':
    'Apakah saat membuat tagihan pembelian dari penawaran, harganya dibuat tidak bisa diubah?',
  'businessFlow.product_search_settings': 'Pengaturan Pencarian Produk',
  'businessFlow.product_search_settings_desc':
    'Atur metode pencarian Produk yang digunakan saat membuat transaksi',
  'businessFlow.product_search_mode': 'Metode pencarian',
  'businessFlow.product_search_mode_desc': 'Pilih metode pencarian Produk pada transaksi',
  'businessFlow.product_search_mode_simple': 'Simple',
  'businessFlow.product_search_mode_advance': 'Advance (Full text)',
  'businessFlow.product_search_mode_advance_example':
    'Pencarian teks penuh (full text), lebih cepat untuk data besar. Cari "meja makan" → cocok dengan Produk yang memuat kata "meja" atau "makan"',
  'businessFlow.product_search_wildcard': 'Pola pencarian',
  'businessFlow.product_search_wildcard_desc':
    'Posisi kata kunci yang dicocokkan pada pencarian simple',
  'businessFlow.product_search_wildcard_contains': 'Mengandung Kata Kunci',
  'businessFlow.product_search_wildcard_contains_example':
    'Kata kunci di posisi mana pun. Cari "meja" → "meja makan", "kursi meja lipat"',
  'businessFlow.product_search_wildcard_front': 'Diakhiri Kata Kunci',
  'businessFlow.product_search_wildcard_front_example':
    'Cocok bila teks diakhiri kata kunci. Cari "meja" → "kursi meja"',
  'businessFlow.product_search_wildcard_back': 'Diawali Kata Kunci',
  'businessFlow.product_search_wildcard_back_example':
    'Cocok bila teks diawali kata kunci. Cari "meja" → "meja makan"',
  'businessFlow.product_search_field': 'Cari berdasarkan kolom',
  'businessFlow.product_search_field_desc': 'Kolom Produk yang dipakai saat pencarian',
  'businessFlow.product_search_field_both': 'Nama dan Kode Produk',
  'businessFlow.product_search_field_both_example':
    'Pencarian dilakukan pada data nama dan kode Produk',
  'businessFlow.product_search_field_name': 'Nama Produk',
  'businessFlow.product_search_field_name_example':
    'Pencarian dilakukan pada data nama Produk saja',
  'businessFlow.product_search_field_code': 'Kode Produk',
  'businessFlow.product_search_field_code_example':
    'Pencarian dilakukan pada data kode Produk saja',
  'businessFlow.use_fifo_method': 'Gunakan metode FIFO untuk perhitungan biaya inventori',
  'businessFlow.use_fifo_method_desc':
    'Metode yang digunakan untuk menghitung HPP. Jika aktif akan menggunakan metode FIFO, jika tidak aktif akan menggunakan metode Averaging. Pengaturan ini tidak dapat diubah jika telah terdapat produk yang aktif lacak stok nya. Pengaturan hanya tersedia di paket Elite.',
  'businessFlow.auto_update_product_buy_price': 'Auto update harga beli produk',
  'businessFlow.auto_update_product_buy_price_desc':
    'Saat melakukan pembelian produk, otomatis harga beli-nya dicatatkan ke produk sebagai harga beli default',
  'businessFlow.auto_update_product_sell_price': 'Auto update harga jual produk',
  'businessFlow.auto_update_product_sell_price_desc':
    'Saat melakukan penjualan produk, otomatis harga jual-nya dicatatkan ke produk sebagai harga jual default',
  'businessFlow.reference_multiline': 'Multiline reference',
  'businessFlow.reference_multiline_desc': 'Apakah reference bisa banyak baris?',
  'businessFlow.show_due_date': 'Tampilkan jatuh tempo',
  'businessFlow.is_the_due_date_shown_on_the_purchase_invoice_form':
    'Apakah tanggal jatuh tempo ditampilkan di form pembelian?',
  'businessFlow.is_the_due_date_shown_on_the_invoice_form':
    'Apakah tanggal jatuh tempo ditampilkan di form penjualan?',
  'businessFlow.show_witholding': 'Tampilkan pemotongan',
  'businessFlow.show_witholding_desc': 'Apakah pemotongan ditampilkan saat membuat tagihan?',
  'businessFlow.show_shipping_cost': 'Tampilkan biaya pengiriman',
  'businessFlow.show_shipping_cost_desc':
    'Apakah biaya pengiriman ditampilkan saat membuat tagihan?',
  'businessFlow.show_transaction_fee': 'Tampilkan biaya transaksi',
  'businessFlow.show_transaction_fee_desc':
    'Apakah biaya transaksi ditampilkan saat membuat tagihan?',
  'businessFlow.show_sequence': 'Tampilkan nomor urut',
  'businessFlow.show_sequence_desc': 'Apakah tampilkan kolom urutan item transaksi?',
  'businessFlow.auto_update_selling_price_from_orders_and_quotes':
    'Auto update harga jual dari pemesanan & penawaran',
  'businessFlow.auto_update_selling_price_from_orders_and_quotes_desc':
    'Jika aktif maka harga produk akan diupdate jika ada pemesanan atau penawaran. Jika tidak aktif maka hanya update harga saat di tagihan saja.',
  'businessFlow.product_last_price_after_discount': 'Harga jual terakhir setelah diskon',
  'businessFlow.product_last_price_after_discount_desc':
    'Jika aktif, riwayat harga jual terakhir menampilkan harga yang sudah dipotong diskon',
  'businessFlow.product_last_buy_price_after_discount': 'Harga beli terakhir setelah diskon',
  'businessFlow.product_last_buy_price_after_discount_desc':
    'Jika aktif, riwayat harga beli terakhir menampilkan harga yang sudah dipotong diskon',
  'businessFlow.auto_update_purchase_price_from_purchases_orders_and_purchases_quotes':
    'Auto update harga beli dari pembelian pemesanan & pembelian penawaran',
  'businessFlow.auto_update_purchase_price_from_purchases_orders_and_purchases_quotes_desc':
    'Jika aktif maka harga produk akan diupdate jika ada pembelian pemesanan atau pembelian penawaran. Jika tidak aktif maka hanya update harga saat di tagihan pembelian saja.',
  'businessFlow.default_message': 'Gunakan pesan yang sama dengan transaksi asal',
  'businessFlow.default_message_desc':
    'Saat membuat tagihan dari pemesanan, maka isi pesan di tagihan otomatis disamakan dengan pesan di pemesanan.',
  'businessFlow.invoice_lock_messages': 'Kunci Pesan Invoice',
  'businessFlow.invoice_lock_messages_desc':
    'Apabila diaktifkan, kolom Pesan pada Tagihan Penjualan tidak dapat diubah dan akan selalu menggunakan pesan default dari Layout Invoice.',
  'businessFlow.default_message_delivery':
    'Gunakan pesan pengiriman yang sama dengan transaksi pemesanan',
  'businessFlow.default_message_delivery_desc':
    'Saat membuat pengiriman, maka isi pesan disamakan dengan transaksi pemesanan.',
  'businessFlow.delivery_items_default_zero':
    'Default kuantitas produk dari pemesanan ke pengiriman',
  'businessFlow.delivery_items_default_zero_desc':
    'Kuantitas produk akan diubah ke 0 ketika membuat pengiriman dari pemesanan',
  'businessFlow.invoice_show_tax_column': 'Tampilkan kolom pajak di tagihan penjualan',
  'businessFlow.invoice_show_tax_column_desc':
    'Apakah kolom pajak ditampilkan saat membuat tagihan penjualan?',
  'businessFlow.invoice_show_tax_column_disabled_tooltip':
    'Silakan matikan opsi "Input pajak wajib diisi" dan "Default harga penjualan termasuk pajak" terlebih dahulu.',
  'businessFlow.purchase_show_tax_column': 'Tampilkan kolom pajak di tagihan pembelian',
  'businessFlow.purchase_show_tax_column_desc':
    'Apakah kolom pajak ditampilkan saat membuat tagihan pembelian?',
  'businessFlow.purchase_show_tax_column_disabled_tooltip':
    'Silakan matikan opsi "Default harga pembelian termasuk pajak" terlebih dahulu.',
  'businessFlow.input_tax_is_required': 'Input pajak wajib diisi',
  'businessFlow.input_tax_is_required_desc': 'Apakah input pajak wajib diisi saat membuat invoice?',
  'businessFlow.invoice_show_dpp_form': 'Tampilkan Dasar Pengenaan Pajak',
  'businessFlow.invoice_show_dpp_form_desc':
    'Apakah nilai DPP (Dasar Pengenaan Pajak) nilai lain ditampilkan saat input/edit invoice dan di detail invoice?',
  'businessFlow.invoice_create_from_shipment_only':
    'Tagihan hanya bisa dibuat dari transaksi pengiriman',
  'businessFlow.invoice_create_from_shipment_only_desc':
    'Apakah untuk membuat tagihan, diwajibkan membuat transaksi pengirimannya terlebih dahulu?',
  'businessFlow.order_create_from_quotation_only':
    'Pemesanan hanya bisa dibuat dari transaksi penawaran',
  'businessFlow.order_create_from_quotation_only_desc':
    'Apakah untuk membuat pemesanan, diwajibkan membuat transaksi penawarannya terlebih dahulu?',
  'businessFlow.invoice_profit_margin_not_minus':
    'Tolak tagihan dan pemesanan baru jika margin laba minus',
  'businessFlow.invoice_profit_margin_not_minus_desc':
    'Tolak tagihan dan pemesanan jika produk dijual dengan margin laba dibawah 0',
  'businessFlow.sale_reject_price_below_min_sell':
    'Tolak penjualan jika harga di bawah harga jual minimum',
  'businessFlow.sale_reject_price_below_min_sell_desc':
    'Apakah transaksi penjualan ditolak jika harga produk lebih kecil dari harga jual minimum?',
  'businessFlow.quote_reject_forecast_margin_minus': 'Tolak penawaran baru jika margin minus',
  'businessFlow.quote_reject_forecast_margin_minus_desc':
    'Tolak penawaran penjualan jika produk dijual dengan profit margin di bawah 0',
  'businessFlow.purchase_invoice_create_from_shipment_only':
    'Tagihan pembelian hanya bisa dibuat dari transaksi pengiriman pembelian',
  'businessFlow.purchase_invoice_create_from_shipment_only_desc':
    'Apakah untuk membuat tagihan pembelian, diwajibkan membuat transaksi pengiriman pembeliannya terlebih dahulu?',
  'businessFlow.purchase_order_create_from_quotation_only':
    'Pemesanan pembelian hanya bisa dibuat dari transaksi penawaran pembelian',
  'businessFlow.purchase_order_create_from_quotation_only_desc':
    'Apakah untuk membuat pemesanan pembelian, diwajibkan membuat transaksi penawaran pembeliannya terlebih dahulu?',
  'salesPerson.sales_person': 'Sales Person',
  'salesPerson.show_sales_person': 'Tampilkan Sales Person',
  'salesPerson.hide_sales_person': 'Sembunyikan Sales Person',
  'salesPerson.select_sales_person': 'Pilih sales person',
  'salesPerson.sales_name': 'Nama Sales',
  'salesPerson.sales_amount': 'Jumlah Penjualan',
  'salesPerson.sales_value': 'Nilai Penjualan',
  'salesPerson.sales_total': 'Total Penjualan',
  'salesPerson.sales_qty': 'Total Kuantitas',
  'salesPerson.customer': 'Pelanggan',
  'salesPerson.sales_incentive': 'Insentif Sales',
  'salesPerson.sales_commission': 'Komisi Sales',
  'salesPerson.manage_sales_commission': 'Atur Komisi Sales',
  'salesPerson.commission_rule': 'Aturan Komisi',
  'salesPerson.faq_question_commission_calculated':
    'Bagaimana perhitungan komisi pada laporan ini?',
  'salesPerson.faq_answer_commission_calculated':
    'Komisi dihitung dari total tagihan setelah didiskon. Komponen pajak dan ongkos kirim tidak digunakan untuk menghitung komisi.',
  'salesPerson.faq_question_give_different_commission':
    'Bagaimana untuk memberikan komisi yang berbeda untuk masing-masing sales?',
  'salesPerson.faq_answer_give_different_commission_menu_here': 'menu disini',
  'salesPerson.faq_question_give_commission_progressively':
    'Bagaimana untuk memberikan komisi secara progresif, semakin banyak penjualan maka komisi semakin besar?',
  'salesPerson.faq_answer_give_commission_progressively':
    'Anda dapat mengatur komisi bertingkat dari pengaturan, silakan {here}.',
  'massEmail.mass_email': 'Kirim Email Massal',
  'massEmail.cannot_mass_email': 'Tidak dapat kirim email massal',
  'massEmail.can_be_sent': 'Dapat dikirim',
  'massEmail.cannot_be_sent': 'Tidak dapat dikirim',
  'massEmail.are_you_sure': 'Apakah Anda yakin akan mengirim {count} email {title}?',
  'massEmail.data_progress_sent': '{count} email dari total {total} telah dikirim',
  'massEmail.data_has_been_sent': 'Total {count} email telah berhasil dikirim',
  'massDelete.mass_delete': 'Hapus Massal',
  'massDelete.cannot_mass_delete': 'Tidak dapat menghapus massal',
  'massDelete.can_be_deleted': 'Bisa dihapus',
  'massDelete.cannot_be_deleted': 'Tidak bisa dihapus',
  'massDelete.archived': 'Diarsipkan',
  'massDelete.invalid_detail_data': 'Data',
  'massDelete.invalid_detail_reason': 'Alasan',
  'massDelete.view_detail': 'Lihat detail',
  'massDelete.are_you_sure': 'Apakah Anda yakin akan menghapus {count} {title}?',
  'massDelete.are_you_sure_archive':
    'Apakah Anda yakin akan menghapus/mengarsipkan {count} {title}?',
  'massDelete.deleted_data_is_irreversible': 'Data yang dihapus tidak dapat dikembalikan',
  'massDelete.data_progress_deleted': '{count} data dari total {total} telah terhapus',
  'massDelete.data_has_been_deleted': 'Total {count} data telah berhasil dihapus',
  'massDelete.data_failed_count': '{count} data gagal diproses',
  'massDelete.still_running_in_background':
    'Proses masih berjalan di latar belakang, silakan cek beberapa saat lagi',
  'massDelete.transaction_before_lock_date_and_reconciled_cannot_be_deleted':
    '**Transaksi sebelum tanggal penguncian dan transaksi yang sudah direkonsiliasi tidak dapat dihapus',
  'massDelete.transaction_before_lock_date_reconciled_and_related_cannot_be_deleted':
    '**Transaksi sebelum tanggal penguncian, transaksi yang telah direkonsiliasi, dan transaksi yang terkait dengan transaksi lainnya tidak dapat dihapus',
  'massVoid.mass_void': 'Void',
  'massVoid.cannot_mass_void': 'Tidak dapat melakukan void massal',
  'massVoid.can_be_voided': 'Bisa void',
  'massVoid.cannot_be_voided': 'Tidak bisa void',
  'massVoid.are_you_sure': 'Apakah Anda yakin akan melakukan void {count} {title}?',
  'massVoid.preparing_void_process': 'Sedang mempersiapkan proses void...',
  'massVoid.data_progress_voided': '{count} data dari total {total} telah di-void',
  'massVoid.data_has_been_voided': 'Total {count} data telah berhasil di-void',
  'massPrint.cannot_mass_print': 'Tidak dapat mencetak massal',
  'massApproval.mass_approve': 'Approve Massal',
  'massApproval.mass_reject': 'Tolak Massal',
  'massApproval.cannot_mass_approve': 'Tidak dapat approve massal',
  'massApproval.cannot_mass_reject': 'Tidak dapat tolak massal',
  'massApproval.can_be_approved': 'Bisa approve',
  'massApproval.can_be_rejected': 'Bisa ditolak',
  'massApproval.are_you_sure_will_approved':
    'Apakah Anda yakin akan approve {count} transaksi ini?',
  'massApproval.are_you_sure_will_rejected':
    'Apakah Anda yakin akan menolak {count} transaksi ini?',
  'massApproval.approved_data_is_irreversible':
    'Data yang telah di approve tidak dapat dikembalikan',
  'massApproval.rejected_data_is_irreversible': 'Data yang telah ditolak tidak dapat dikembalikan',
  'massApproval.data_progress_approved': '{count} data dari total {total} telah approve',
  'massApproval.data_progress_rejected': '{count} data dari total {total} telah ditolak',
  'massApproval.data_has_been_approved': 'Total {count} data telah berhasil di approve',
  'massApproval.data_has_been_rejected': 'Total {count} data telah berhasil ditolak',
  'financeOnboarding.welcome_eyebrow': 'Panduan awal · 3 langkah',
  'financeOnboarding.welcome_title': 'Selamat datang di Kledo, {name} 👋',
  'financeOnboarding.welcome_lead':
    'Akun Anda sudah siap. Dalam ±3 menit kami pandu Anda mencoba alur inti Kledo: membuat tagihan, mengirimnya ke pelanggan lewat WhatsApp, dan melihat hasilnya langsung di laporan Laba Rugi.',
  'financeOnboarding.step1_title': 'Buat tagihan penjualan',
  'financeOnboarding.step1_desc':
    'Tambah kontak dan produk pertama Anda, lalu lengkapi tagihannya. Ada data contoh di tiap langkah.',
  'financeOnboarding.step2_title': 'Kirim tagihan via WhatsApp',
  'financeOnboarding.step2_desc': 'Pelanggan menerima tagihan lengkap dengan link pembayaran.',
  'financeOnboarding.step3_title': 'Lihat laporan Laba Rugi',
  'financeOnboarding.step3_desc': 'Transaksi tadi langsung muncul di laporan keuangan, realtime.',
  'financeOnboarding.start': 'Mulai Sekarang',
  'financeOnboarding.welcome_note':
    'Selama panduan berjalan, menu lain terkunci sampai 3 langkah selesai.',
  'financeOnboarding.rail_title': 'Panduan awal',
  'financeOnboarding.rail_step1': 'Buat tagihan',
  'financeOnboarding.rail_step2': 'Kirim WhatsApp',
  'financeOnboarding.rail_step3': 'Lihat Laba Rugi',
  'financeOnboarding.snooze': 'Nanti saja',
  'financeOnboarding.guide_title': 'Panduan Memulai',
  'financeOnboarding.guide_resume': 'Klik untuk melanjutkan panduan',
  'financeOnboarding.guide_page_desc':
    'Ikuti 3 langkah singkat ini untuk mengenal alur inti Kledo, dari membuat tagihan sampai melihat laporan keuangan.',
  'financeOnboarding.guide_page_card': 'Kenali alur inti Kledo',
  'financeOnboarding.guide_page_eyebrow': 'Panduan awal · {done} dari {total} selesai',
  'financeOnboarding.guide_page_title': 'Hai {name}, tinggal {left} langkah lagi',
  'financeOnboarding.guide_page_lead':
    'Progres Anda tersimpan otomatis. Langkah yang sudah dilalui kami tandai, lanjutkan dari posisi terakhir kapan pun Anda siap.',
  'financeOnboarding.guide_page_done': 'Selesai',
  'financeOnboarding.guide_page_now': 'Sedang berjalan',
  'financeOnboarding.guide_page_last': 'Posisi terakhir: {title}',
  'financeOnboarding.guide_page_continue': 'Lanjutkan',
  'financeOnboarding.guide_page_locked': 'Terbuka setelah langkah {n}',
  'financeOnboarding.badge': 'Langkah {n} dari 3',
  'financeOnboarding.sub_contact': 'Kontak',
  'financeOnboarding.sub_product': 'Produk',
  'financeOnboarding.sub_save': 'Simpan',
  'financeOnboarding.hint_click': 'Klik bagian yang disorot untuk lanjut',
  'financeOnboarding.locked': 'Selesaikan langkah ini dulu, menu lain masih terkunci.',
  'financeOnboarding.menu_invoices_title': 'Buka menu Tagihan',
  'financeOnboarding.menu_invoices_desc':
    'Semua penjualan ke pelanggan dicatat sebagai Tagihan (invoice). Klik menu Penjualan › Tagihan untuk mulai.',
  'financeOnboarding.btn_add_title': 'Tambah tagihan pertama',
  'financeOnboarding.btn_add_desc':
    'Daftar tagihan Anda masih kosong. Klik tombol Tambah untuk membuat tagihan pertama.',
  'financeOnboarding.contact_field_title': 'Mulai dari pelanggan',
  'financeOnboarding.contact_field_desc':
    'Setiap tagihan ditujukan ke satu kontak. Daftar kontak Anda masih kosong, klik kolom Pelanggan lalu pilih Tambah untuk membuatnya tanpa keluar dari form.',
  'financeOnboarding.contact_field_hint': 'Klik kolom Pelanggan, lalu pilih “+ Tambah”',
  'financeOnboarding.contact_modal_title': 'Siapa pelanggan pertama Anda?',
  'financeOnboarding.contact_modal_desc':
    'Isi nama pelanggan, atau pakai data contoh supaya cepat.',
  'financeOnboarding.contact_modal_ready_title': 'Data sudah terisi, siap disimpan',
  'financeOnboarding.contact_modal_ready_desc':
    'Lengkapi data lain bila perlu, lalu klik Tambah. Kontak ini langsung terpilih sebagai pelanggan di tagihan Anda.',
  'financeOnboarding.contact_modal_save_title': 'Simpan kontak',
  'financeOnboarding.contact_modal_save_desc':
    'Setelah nama terisi, klik Tambah. Kontak langsung terpilih di form tagihan.',
  'financeOnboarding.product_field_title': 'Kontak terpilih. Sekarang produknya',
  'financeOnboarding.product_field_desc':
    'Berikutnya tentukan apa yang Anda jual. Klik kolom Produk lalu pilih Tambah untuk membuat produk atau jasa pertama Anda.',
  'financeOnboarding.product_field_hint': 'Klik kolom Produk, lalu pilih “+ Tambah”',
  'financeOnboarding.product_modal_title': 'Apa yang Anda jual?',
  'financeOnboarding.product_modal_desc':
    'Isi nama dan harga jual, atau pakai data contoh supaya cepat.',
  'financeOnboarding.product_modal_ready_title': 'Nama dan harga sudah terisi, siap disimpan',
  'financeOnboarding.product_modal_ready_desc':
    'Lengkapi data lain bila perlu, lalu klik Tambah. Produk dan harganya langsung masuk ke baris tagihan.',
  'financeOnboarding.product_category_title': 'Pilih kategori dulu',
  'financeOnboarding.product_category_desc':
    'Kategori wajib diisi. Klik kolom Kategori dan pilih salah satu sebelum menyimpan produk.',
  'financeOnboarding.product_category_hint': 'Klik kolom Kategori, lalu pilih salah satu',
  'financeOnboarding.product_modal_save_title': 'Simpan produk',
  'financeOnboarding.product_modal_save_desc':
    'Setelah nama dan harga terisi, klik Tambah. Produk langsung masuk ke baris tagihan.',
  'financeOnboarding.fill_sample': 'Isi dengan data contoh',
  'financeOnboarding.sample_contact_name': 'Contoh – PT Maju Jaya',
  'financeOnboarding.sample_contact_company': 'PT Maju Jaya',
  'financeOnboarding.sample_product_name': 'Contoh – Jasa Konsultasi',
  'financeOnboarding.btn_save_title': 'Simpan tagihan',
  'financeOnboarding.btn_save_desc':
    'Data sudah lengkap. Klik Simpan, tagihan langsung tercatat di pembukuan dan piutang pelanggan.',
  'financeOnboarding.btn_send_title': 'Kirim ke pelanggan',
  'financeOnboarding.btn_send_desc':
    'Tagihan tersimpan. Sekarang kirim ke pelanggan lewat WhatsApp, lengkap dengan link pembayaran.',
  'financeOnboarding.wa_send_title': 'Kirim sekarang',
  'financeOnboarding.wa_send_desc':
    'Pastikan metode WhatsApp dipilih dan nomor tujuan terisi, lalu klik Kirim. Nomor Anda sendiri juga bisa dipakai untuk mencoba.',
  'financeOnboarding.wa_done_title': 'Terkirim!',
  'financeOnboarding.wa_done_desc':
    'Pesan sudah sampai ke HP Anda. Langkah terakhir: lihat efeknya di laporan keuangan.',
  'financeOnboarding.wa_done_next': 'Lanjut: Lihat Laba Rugi',
  'financeOnboarding.realtime_chip': 'REALTIME',
  'financeOnboarding.realtime_title': 'Tagihan Anda sudah masuk ke laporan ini',
  'financeOnboarding.realtime_desc':
    'Setiap transaksi yang Anda catat langsung memperbarui laporan keuangan, termasuk Laba Rugi, Neraca, dan Arus Kas. Tidak perlu tutup buku manual, tidak perlu menunggu akhir bulan. Silakan scroll untuk melihat rincian, lalu klik Selesai untuk mengakhiri panduan.',
  'financeOnboarding.finish': 'Selesai',
  'financeOnboarding.finish_title': 'Panduan selesai, {name}! 🎉',
  'financeOnboarding.finish_desc':
    'Anda baru saja menjalankan alur inti Kledo dari awal sampai laporan. Sekarang semua menu sudah terbuka.',
  'financeOnboarding.finish_item1': 'Tagihan pertama tersimpan',
  'financeOnboarding.finish_item2': 'Terkirim lewat WhatsApp',
  'financeOnboarding.finish_item3': 'Laba Rugi langsung terupdate',
  'financeOnboarding.finish_button': 'Mulai pakai Kledo',
  'financeOnboarding.finish_note':
    'Kontak dan produk contoh yang tadi dibuat bisa diubah atau dihapus dari menu Kontak dan Produk kapan saja.',
  'onBoarding.greeting': 'Hallo {name},',
  'onBoarding.welcome_to_kledo': 'Selamat datang di Kledo!',
  'onBoarding.setup_kledo_account': 'Yuk kita setup dulu akun Kledo nya :)',
  'onBoarding.start_to_setup': 'Mulai setup',
  'onBoarding.inventory_question':
    'Apakah Anda ingin mengatur stok dan inventori produk yang dijual ?',
  'onBoarding.quote_question': 'Apakah Anda memerlukan surat penawaran ke pelanggan ?',
  'onBoarding.order_question': 'Apakah Anda melakukan purchase order ke supplier ?',
  'onBoarding.delivery_question': 'Apakah Anda memerlukan surat jalan ?',
  'onBoarding.horee': 'Horee!',
  'onBoarding.checklist_greeting': 'Yuk mulai menggunakan Kledo',
  'onBoarding.setup_complete': 'Setup selesai, sekarang kamu bisa mulai menggunakan Kledo.',
  'onBoarding.go_to_dashboard': 'Masuk ke Dashboard',
  'onBoarding.cannot_access_onboarding': 'Tidak dapat mengakses onboarding',
  'onBoarding.next_step': 'Selanjutnya',
  'onBoarding.prev_step': 'Sebelumnya',
  'onBoarding.step_question': 'Pertanyaan - {step}',
  'onBoarding.company_location_question': 'Dimana lokasi perusahaan {company}?',
  'onBoarding.company_location_question_province': 'Provinsi wajib diisi!',
  'onBoarding.company_location_question_city': 'Kota wajib diisi',
  'onBoarding.role_question': 'Sebagai apakah anda di perusahaan {company}?',
  'onBoarding.role_question_error':
    'Silakan pilih peran atau masukkan peran khusus sebelum melanjutkan',
  'onBoarding.employee_question': 'Berapakah jumlah karyawan di perusahaan Anda?',
  'recurring.add': 'Tambah {title} Berulang',
  'recurring.edit': 'Ubah {title} Berulang',
  'recurring.add_invoice': 'Tambah tagihan berulang',
  'recurring.edit_invoice': 'Ubah tagihan berulang',
  'recurring.add_order': 'Tambah pemesanan berulang',
  'recurring.edit_order': 'Ubah pemesanan berulang',
  'recurring.add_purchaseinvoice': 'Tambah tagihan pembelian berulang',
  'recurring.edit_purchaseinvoice': 'Ubah tagihan pembelian berulang',
  'recurring.add_purchaseorder': 'Tambah pemesanan pembelian berulang',
  'recurring.edit_purchaseorder': 'Ubah pemesanan pembelian berulang',
  'recurring.add_expense': 'Tambah biaya berulang',
  'recurring.edit_expense': 'Ubah biaya berulang',
  'recurring.add_manualjournal': 'Tambah jurnal manual berulang',
  'recurring.edit_manualjournal': 'Ubah jurnal manual berulang',
  'recurring.add_cashbank': 'Tambah {title} berulang',
  'recurring.edit_cashbank': 'Edit kas & bank berulang',
  'recurring.recurring_transaction_periode': 'Ulang transaksi ini setiap',
  'recurring.start_date': 'Tanggal mulai',
  'recurring.end_date': 'Tanggal selesai (Optional)',
  'recurring.end_date_column': 'Tanggal selesai',
  'recurring.next_date_transaction': 'Tanggal transaksi berikutnya',
  'recurring.automatic_send_email_on_created_transaction':
    'Kirim email ke customer setiap transaksi dibuat',
  'recurring.reminder_enabled': 'Kirim pengingat sebelum transaksi dibuat',
  'recurring.reminder_days_before': 'Kirim pengingat berapa hari sebelumnya',
  'recurring.reminder_days_suffix': 'hari',
  'recurring.please_input_reminder_days_before': 'Silahkan isi jumlah hari pengingat',
  'recurring.reminder_days_min': 'Minimal 1 hari',
  'recurring.reminder_days_max': 'Maksimal {max} hari, tidak boleh melebihi jarak antar transaksi',
  'recurring.day': 'Hari',
  'recurring.week': 'Minggu',
  'recurring.month': 'Bulan',
  'recurring.please_input_the_recurring': 'Silahkan isi jumlah pengulangan',
  'recurring.please_select_start_date': 'Silahkan pilih tanggal mulai',
  'recurring.please_select_end_date': 'Silahkan pilih tanggal selesai',
  'recurring.title': 'Transaksi Berulang {name}',
  'recurring.cannot_select_before_start_date': 'Tidak dapat memilih sebelum tanggal mulai',
  'recurring.recurring': 'Transaksi Berulang',
  'recurring.number': 'Nomor',
  'recurring.repeat_every': 'Ulang Setiap',
  'recurring.next_date': 'Transaksi Berikutnya',
  'recurring.total': 'Total',
  'recurring.error_load_data': 'Error saat mengambil data',
  'recurring.error_cannot_recurring': 'Error tidak dapat membuat transaksi berulang',
  'recurring.error_cannot_delete': 'Error tidak dapat membuat transaksi berulang',
  'recurring.error_load_detail': 'Error saat mengambil data detail',
  'recurring.new_transaction': 'Transaksi Berulang Baru',
  'recurring.cannot_select_before_current_date': 'Tidak dapat memilih sebelum tanggal sekarang',
  'recurring.repeat': 'Berulang',
  'tutorial.video_tutorial': 'Tutorial Video',
  'report.the_total_number_of_bills_issued_during_this_period':
    'Total jumlah tagihan yang diterbitkan pada periode ini.',
  'report.average_value_of_invoices_issued_during_this_period':
    'Rata-rata nilai tagihan yang diterbitkan pada periode ini.',
  'report.gross_profit_margin_is_the_ratio_of_gross_profit_to_total_revenue':
    'Margin laba kotor merupakan rasio laba kotor terhadap total pendapatan.',
  'report.gross_profit_margin_is_the_ratio_of_net_income_to_total_revenue':
    'Margin laba kotor merupakan rasio dari laba bersih terhadap total pendapatan.',
  'report.roi_is_the_ratio_of_net_income_to_net_assets_per_year':
    'ROI merupakan rasio laba bersih terhadap aset bersih per tahun. Dimana aset bersih merupakan total aset dikurangi liabilitas.<br/>ROI = (Net profit / Net asset) x 12 bulan x 100%',
  'report.the_average_number_of_days_it_takes_your_customer_to_pay_the_bill':
    'Rata-rata jumlah hari yang dibutuhkan pelanggan Anda untuk membayar tagihan.',
  'report.the_average_number_of_days_it_take_you_to_pay_a_bill_to_a_vendor':
    'Rata-rata jumlah hari yang Anda butuhkan untuk membayar tagihan kepada vendor.',
  'report.is_the_percentage_of_liabilities_divided_by_equity':
    'Merupakan persentase liabilitas dibagi ekuitas.',
  'report.is_the_percentage_of_current_assets_divided_by_labilities':
    'Merupakan persentase aset lancar dibagi liabilitas.',
  'report.percentage': 'Persentase',
  'invoicePaymentCreditMemo.invoicePaymentCreditMemo': 'Pembayaran Tagihan dengan Hutang',
  'purchaseInvoicePaymentDebitMemo.purchaseInvoicePaymentDebitMemo':
    'Pembayaran Tagihan Pembelian dengan Piutang',
  'unrealizedGain.unrealizedGain': 'Laba/Rugi Belum Terealisasi',
  'financeProduct.profit_margin': 'Margin laba',
  'financeProduct.total_profit_margin': 'Total margin laba',
  'financeProduct.average_purchase_price': 'Harga beli rata-rata',
  'financeProduct.last_purchase_price': 'Harga beli terakhir',
  'financeProduct.this_customer_selling_price': 'Harga jual pelanggan ini',
  'financeProduct.last_sell_price': 'Harga jual terakhir',
  'financeProduct.insufficient_payment': 'Kurang Bayar',
  'settings.menu_cannot_be_found': 'Menu Pengaturan Yang Anda Cari Tidak Ditemukan',
  'report.avg': 'Rata-Rata',
  'reports.stock_adjustment': 'Laporan Penyesuaian Stok',
  'reports.cache.data_per': 'Data per {date} · {age} lalu',
  'reports.cache.data_per_live': 'Data per {date} · Baru saja diperbarui',
  'reports.cache.just_updated': 'Baru saja diperbarui',
  'reports.cache.reload': 'Muat ulang',
  'reports.cache.reload_tooltip': 'Ambil data terbaru dari server',
  'reports.cache.live': 'Live',
  'reports.cache.cached': 'Cached',
  'reports.cache.age_seconds': '{value} detik',
  'reports.cache.age_minutes': '{value} menit',
  'reports.cache.age_hours': '{value} jam',
  'reports.cache.age_days': '{value} hari',
  'summary.cache.updated_ago': 'Diperbarui {age} lalu',
  'summary.cache.load_failed': 'Gagal memuat data. Coba Muat ulang dari menu ⋮.',
  'bussinesFlow.default_tracking_stock': 'Default lacak stok',
  'bussinesFlow.desc_default_tracking_stock':
    'Secara default fitur lacak stock aktif saat membuat produk baru',
  'settings.reset': 'Reset',
  'financeContacts.taxable': 'Kena pajak',
  'financeContacts.not_taxable': 'Tidak Kena Pajak',
  'tooltip.next': '{title} Selanjutnya',
  'tooltip.prev': '{title} Sebelumnya',
  'financeBanks.bank_transaction': 'Transaksi Bank',
  'picker.select_year': 'Pilih tahun',
  'picker.select_month': 'Pilih bulan',
  'picker.select_date': 'Pilih tanggal',
  'chart.from_param_to_param': 'dari {from} s/d {to}',
  'gajihub.hash_tag': '#jadilebihbaik, mudah, dan praktis.',
  'gajihub.head_title_1': 'Proses',
  'gajihub.head_title_2': 'Payroll',
  'gajihub.head_title_3': 'Absensi',
  'gajihub.head_title_4': 'dan',
  'gajihub.head_title_5': 'Akuntansi',
  'gajihub.head_title_6': 'Bisnis Anda Kini Saling Terintegrasi',
  'gajihub.head_desc_1': 'Kini Anda bisa melakukan',
  'gajihub.head_desc_2': 'penghitungan',
  'gajihub.head_desc_3': 'pencatatan gaji',
  'gajihub.head_desc_4': 'tunjangan',
  'gajihub.head_desc_5': 'sampai',
  'gajihub.head_desc_6': 'pajak',
  'gajihub.head_desc_7':
    'seluruh karyawan secara otomatis dalam pembukuan perusahaan dengan integrasi GajiHub dan Kledo.',
  'gajihub.integrate': 'Integrasikan Sekarang',
  'appConnect.crm.processing_title': 'Menghubungkan ke CRM.ID...',
  'appConnect.crm.processing_subtitle':
    'Koneksi aplikasi sedang diproses. Mohon tunggu sebentar, jangan tutup halaman ini.',
  'appConnect.hr.processing_title': 'Menghubungkan ke GajiHub...',
  'appConnect.hr.processing_subtitle':
    'Koneksi aplikasi sedang diproses. Mohon tunggu sebentar, jangan tutup halaman ini.',
  'appConnect.success_title': 'Integrasi berhasil!',
  'appConnect.success_subtitle': 'Akun Anda berhasil terhubung. Mengalihkan...',
  'gajihub.footer_note':
    'Dapatkan solusi manajemen SDM dan kemudahan pengelolaan akuntansi perusahaan yang saling terintegrasi secara sempurna.',
  'gajihub.feat_title_1': 'Apa yang Akan',
  'gajihub.feat_title_2': 'Anda Dapatkan',
  'gajihub.feat_title_3': 'Dari Integrasi GajiHub dan Kledo?',
  'gajihub.feat_1_sub_title': 'Integrasi sistem payroll dan akuntansi',
  'gajihub.feat_1_description':
    'Proses pencatatan gaji dan seluruh tunjangan seluruh karyawan bisa tercatat pada sistem pembukuan perusahaan Anda secara otomatis dalam satu platform terintegrasi.',
  'gajihub.feat_2_sub_title': 'Penghitungan PPh 21 otomatis',
  'gajihub.feat_2_description':
    'Tidak perlu pusing menghitung pajak penghasilan seluruh karyawan. Dengan integrasi ini, Kledo akan secara otomatis mencatat PPh 21 karyawan sesuai data yang tersimpan di GajiHub.',
  'gajihub.feat_3_sub_title': 'Melakukan pencatatan presensi melalui smartphone',
  'gajihub.feat_3_description':
    'Seluruh karyawan Anda juga akan mendapatkan kemudahan dalam melakukan presensi kehadiran dan pengajuan cuti dari smartphone melalui aplikasi ESS GajiHub.',
  'gajihub.feat_4_sub_title': 'Pencatatan kasbon dan reimburse karyawan langsung ke pembukuan',
  'gajihub.feat_4_description':
    'Anda dapat mencatat semua nilai kasbon dan reimburse karyawan dalam sistem GajiHub. Kemudian, data tersebut akan otomatis tercatat dalam sistem akuntansi Kledo.',
  'gajihub.feat_5_sub_title': 'Buat dan kirim slip gaji karyawan real time',
  'gajihub.feat_5_description':
    'Buat slip gaji hitungan detik dan kirim langsung ke seluruh karyawan Anda. Slip gaji ini juga bisa diakses melalui aplikasi ESS GajiHub di smartphone karyawan Anda.',
  'gajihub.feat_6_sub_title': 'Iuran BPJS Ketenagakerjaan tercatat otomatis',
  'gajihub.feat_6_description':
    'Anda bisa mengelola BPJS Ketenagakerjaan dan Kesehatan seluruh karyawan Anda di GajiHub. Nantinya, pembayaran iuran akan otomatis tercatat di sistem akuntansi Kledo.',
  'payroll.goto_gajihub': 'Pergi ke GajiHub',
  'payroll.integrate_with_gajihub': 'Integrasikan dengan GajiHub',
  'payroll.payroll': 'Payroll',
  'payroll.perform_employee_payroll_quickly_and_neatly':
    'Melakukan penggajian karyawan dengan cepat dan rapi.',
  'payroll.employee_payroll_is_automatically_recorded_in_kledo_accounting_software':
    'Penggajian karyawan otomatis tercatat pada software akuntansi Kledo.',
  'payroll.automatically_calculating_PPH_21_Tax': 'Otomatis penghitungan Pajak PPH 21.',
  'payroll.automatic_employee_BPJS_calculation': 'Perhitungan BPJS karyawan otomatis.',
  'payroll.employee_attendance_via_mobile_app': 'Absensi karyawan via mobile app.',
  'payroll.application_for_leave_and_permission': 'Pengajuan cuti dan izin.',
  'payroll.employee_cash_account': 'Kasbon Karyawan.',
  'payroll.employee_reimbursement': 'Reimburse Karyawan.',
  'payroll.and_many_more': 'Dan masih banyak lagi.',
  'payroll.click_the_button_below_to_start_the_integration':
    'Klik tombol dibawah untuk memulai integrasi.',
  'payroll.what_benefits_will_you_get_with_this_integration':
    'Apa saja keuntungan yang akan kamu dapatkan dengan integrasi ini ?',
  'payroll.this_feature_is_avilable_for_free': 'Fitur ini tersedia gratis lho.',
  'payroll.kledo_is_now_automatically_integrated_with_gajihub_payroll_software':
    'Kledo kini terintegrasi secara otomatis dengan Software Payroll GajiHub.',
  'payroll.please_wait': 'Mohon tunggu ya!',
  'payroll.integrating_kledo_with_gajihub': 'Sedang mengintegrasikan Kledo dengan GajiHub...',
  'payroll.integrating_success_1': 'Horee!, Akun',
  'payroll.integrating_success_2': 'Kledo',
  'payroll.integrating_success_3': 'sudah berhasil dikoneksikan dengan Software Payroll',
  'payroll.integrating_success_4': 'GajiHub.',
  'companies.success_message_title': 'Perusahaanmu berhasil dibuat.',
  'companies.success_message_subtitle': 'Silahkan klik tombol di bawah ini untuk melanjutkan.',
  'companies.go_to_dashboard': 'Pergi ke dashboard',
  'message.sorry_you_are_not_authorized_to_access_this_page':
    'Maaf, Anda tidak mempunya akses untuk halaman ini.',
  'message.you_have_some_unsaved_transaction_entries':
    'Anda mempunyai {countTransaction} draft isian transaksi yang belum disimpan, {clickHere} untuk melihat.',
  'message.click_here': 'klik disini',
  'message.click_here_2': 'Klik disini',
  'message.image_is_being_uploaded': 'Gambar sedang diunggah...',
  'message.for_the_detail': 'untuk penjelasan detail.',
  'emailTemplate.invoice_due_reminder_email': 'Email Pengingat {transType} Jatuh Tempo',
  'emailTemplate.send_email': 'Kirim email',
  'emailTemplate.days_before_due': 'hari sebelum jatuh tempo',
  'emailTemplate.days_after_due': 'hari setelah jatuh tempo',
  'emailTemplate.send_a_due_reminder_email_to_the_group':
    'Kirim email pengingat jatuh tempo ke group kontak pelanggan sebagai berikut',
  'emailTemplate.send_reminder': 'Kirim Pengingat',
  'report.stock_tracking_product': 'Produk Lacak Stok',
  'report.non_stock_tracking_product': 'Produk Tanpa Lacak Stok',
  'report.package_product': 'Produk Paket',
  'return.product_not_found_in_this_transaction': 'Product tidak ditemukan di transaksi ini',
  'return.maximum_qty_that_can_be_returned': 'Jumlah maksimal yang dapat di retur {max}',
  'return.the_product_has_met_the_maximum_return_limit':
    'Produk telah memenuhi batas pengembalian maksimum',
  'financeWareHouses.the_product_is_already_on_the_list': 'Produk sudah ada di daftar',
  'report.minimum_stock': 'Stok Minimal',
  'report.control_stock': 'Stok Kontrol',
  'report.control_stock_tooltip': 'Selisih dari stok akhir dan stok minimal',
  'businessFlow.reject_the_transaction_if_the_balance_is_insufficient':
    'Tolak transaksi jika kurang saldo',
  'businessFlow.reject_the_transaction_if_the_balance_is_insufficient_desc':
    'Tolak tambah transaksi kas dan bank jika saldo kas dan bank tidak mencukupi. Tidak berlaku untuk transaksi POS dan Marketplace Connect',
  'settings.finance_approval_setting': 'Atur alur approval transaksi',
  'businessFlow.journal_desc_include_contact': 'Tampilkan kontak pada deskripsi jurnal',
  'businessFlow.journal_desc_include_contact_desc':
    'Apakah nama kontak akan ditampilkan di deskripsi jurnal?',
  'financeProduct.mass_unarchive_info':
    '**Hanya produk yang berstatus arsip yang dapat dibatalkan pengarsipannya.',
  'financeProduct.mass_unarchive': 'Batalkan Arsip Massal',
  'financeProduct.can_be_unarchive': 'Bisa dibatalkan arsipnya',
  'financeProduct.cannot_be_unarchive': 'Tidak bisa dibatalkan arsipnya',
  'financeProduct.mass_unarchive_confirm_message':
    'Apakah Anda yakin akan membatalkan arsip {count} produk?',
  'financeProduct.preparing_unarchive_process': 'Mempersiapkan proses batal arsip',
  'massDelete.cannot_mass_unarchive': 'Tidak dapat membatalkan arsip secara massal',
  'massDelete.data_progress_unarchived':
    '{count} data dari total {total} telah dibatalkan arsipnya',
  'massDelete.data_has_been_unarchived': 'Total {count} data berhasil dibatalkan arsipnya',
  'financeContacts.salutation': 'Sapaan',
  'financeContacts.choose_salutation': 'Pilih sapaan',
  'product.the_maximum_number_of_uploads_is_5_photos': 'Jumlah upload maksimal 5 gambar',
  'reports.profitloss_hide_sub_account': 'Sembunyikan Sub Akun',
  'reports.account_view': 'Tampilan Akun',
  'reports.change_account_view_loading': 'Mengubah format tampilan akun...',
  'reports.change_account_view_success': 'Format tampilan akun berhasil diubah',
  'reports.format_account_profit_loss_1': 'Kode - Nama Akun',
  'reports.format_account_profit_loss_2': '(Kode) Nama Akun',
  'reports.format_account_profit_loss_3': 'Nama Akun - Kode',
  'reports.format_account_profit_loss_4': 'Nama Akun (Kode)',
  'reports.format_account_profit_loss_5': 'Nama Akun',
  'reports.separate_others_income_and_expenses': 'Pisah Pendapatan & Biaya Lain-Lain',
  'reports.only_account_name': 'Hanya Tampilkan Nama Akun',
  'financeWarehouse.qty_per_unit': 'Qty per Satuan',
  'faqs.whats_your_question': 'Apa Pertanyaan Anda?',
  'faqs.most_popular': 'Terpopuler',
  'faqs.most_help': 'Paling Membantu',
  'faqs.search_result': 'Hasil Pencarian {value}',
  'faqs.title_by_category': 'Berdasarkan Kategori {value}',
  'faqs.title_by_tag': 'Berdasarkan Tag {value}',
  'faqs.was_this_answer_helpful': 'Apakah jawaban ini membantu?',
  'faqs.last_update': 'Update Terakhir',
  'faqs.copy_raw_text': 'FAQ berhasil disalin',
  'faqs.help_center': 'Pusat Bantuan Kledo',
  'faqs.hero_title': 'Ada yang bisa kami bantu?',
  'faqs.hero_subtitle':
    'Cari jawaban dari ratusan pertanyaan seputar fitur, harga, dan penggunaan Kledo.',
  'faqs.most_viewed': 'Paling banyak dilihat',
  'faqs.highest_rated': 'Rating tertinggi dari pengguna',
  'faqs.explore_category': 'Jelajahi Kategori',
  'faqs.explore_category_subtitle': 'Pilih topik untuk menemukan jawaban lebih cepat.',
  'faqs.article_count': '{count} artikel',
  'financeProduct.total_cost_summary': 'Total Biaya',
  'financeWareHouses.production_warehouse': 'Gudang produk hasil',
  'financeWareHouses.raw_material_warehouse_is_the_same_as_product_warehouse':
    'Gudang bahan baku sama dengan gudang produk hasil',
  'conversionProduct.avg_price': 'HPP',
  'financeProduct.product_conversion_cost_per_unit_help_text':
    'Total biaya produk untuk setiap unitnya (Biaya bahan baku + Biaya produksi)',
  'layoutInvoice.show_the_print_delivery_on_the_invoice_with_title':
    'Tampilkan Surat Jalan di {title}',
  'queue.data_is_waiting_to_be_processed': '{value} data sedang menunggu diproses...',
  'billing.using_the_invoicing_feature': 'Penggunaan fitur tagihan',
  'billing.this_month': 'Bulan ini',
  'billing.last_month': 'Bulan lalu',
  'businessFlow.reject_warehouse_transfer_if_stock_is_less_with_title':
    'Tolak {title} Jika Stok Kurang',
  'businessFlow.reject_warehouse_transfer_if_stock_is_less_desc_with_title':
    'Jika ya, maka {title} akan ditolak jika stok kurang',
  'financeProduct.products_with_stock_tracking_with_title': '{title} dengan lacak stok',
  'financeFixedAssets.run_automatic_deprecation': 'Jalankan Penyusutan Sekarang',
  'financeFixedAssets.automatic_deprecation': 'Penyusutan Otomatis',
  'financeFixedAssets.automatic_depreciation_every_month': 'Penyusutan otomatis setiap bulan',
  'financeFixedAssets.automatic_depreciation_every_month_desc_with_title':
    'Jika fitur ini aktif, maka {title} akan otomatis disusutkan pada tanggal 1 setiap bulannya.',
  'financeProduct.regular_product_with_title': '{title} reguler',
  'financeProduct.package_product_with_title': '{title} paket',
  'financeProduct.manufacturing_product_with_title': '{title} manufaktur',
  'button.void': 'Void',
  'button.unvoid': 'Unvoid',
  'financeBanks.spend_money_and_receive_money': 'Kirim Dana dan Terima Dana',
  'financeBanks.receive_transfers': 'Terima Transfer',
  'financeBanks.send_transfers': 'Kirim Transfer',
  'financeBanks.expense_payment': 'Pembayaran Biaya',
  'financeBanks.invoice_payment': 'Pembayaran Tagihan',
  'financeBanks.purchase_invoice_payment': 'Pembayaran Tagihan Pembelian',
  'financeBanks.purchase_order_payment': 'Pembayaran Pemesanan Pembelian',
  'financeBanks.credit_memo_payment': 'Pembayaran Hutang',
  'financeBanks.debit_memo_payment': 'Pembayaran Piutang',
  'financeBanks.fixed_asset_payment': 'Pembayaran Aset Tetap',
  'financeBanks.sales_shipping_costs': 'Biaya Pengiriman Penjualan',
  'financeBanks.purchase_shipping_costs': 'Biaya Pengiriman Pembelian',
  'financeBanks.invoice_withholding': 'Pemotongan Penjualan',
  'financeBanks.purchase_invoice_withholding': 'Pemotongan Pembelian',
  'financeBanks.reversal': 'Reversal',
  'financeProduct.product_list_with_title': 'Daftar {title}',
  'financeProduct.product_detail_with_title': 'Detil {title}',
  'financeProduct.print_a_number': 'Print sejumlah',
  'layoutBarcode.label_size': 'Ukuran kertas',
  'layoutBarcode.number_of_columns': 'Jumlah Kolom',
  'layoutBarcode.show_product_name': 'Tampilkan nama produk',
  'layoutBarcode.barcode_show_text': 'Tampilkan angka barcode',
  'layoutBarcode.barcode_show_product_price': 'Tampilkan harga',
  'layoutBarcode.click_here_to_reset_layout':
    'Klik di sini untuk mengembalikan layout barcode ke default',
  'settings.layout_barcode': 'Atur tampilan print barcode',
  'financeContacts.date_of_birth': 'Tanggal Lahir',
  'financeInvoices.witholding_total': 'Total Pemotongan',
  'financeInvoices.total_after_witholding': 'Total Setelah Pemotongan',
  'financeContacts.total_from_value': 'Total dari {value}',
  'pos.choose_product_favorites_with_title':
    'Pilih {title} yang akan ditampilkan dihalaman depan POS',
  'pos.page_note':
    'Halaman ini untuk mengatur produk yang dijadikan favorit di POS. Jika Anda ingin menambah produk baru, silahkan {clickHere}!',
  'pos.add_product_favorite_with_title': 'Tambah {title} Favorit',
  'pos.save_to_favorite': 'Simpan ke Dalam Favorit',
  'pos.choose_product_to_become_favorite': 'Pilih {title} untuk dijadikan favorit',
  'pos.choose_product_to_become_favorite_with_title': 'Pilih {title} untuk dijadikan favorit',
  'pos.add_outlet': 'Tambah Outlet',
  'pos.edit_outlet': 'Ubah Outlet',
  'pos.name_is_required': 'Nama wajib diisi',
  'pos.name_at_least_3_characters': 'Nama minimal 3 karakter',
  'pos.code_is_required': 'Kode wajib diisi',
  'pos.code_at_least_3_characters': 'Kode minimal 3 karakter',
  'pos.not_yet_connected_to_the_warehouse': 'Belum terhubung ke gudang',
  'pos.connect_now': 'Hubungkan sekarang!',
  'pos.connect_outlets_and_warehouses': 'Hubungkan outlet dan gudang',
  'webPos.title': 'Selamat Datang di Web POS',
  'webPos.description':
    'Kelola transaksi penjualan Anda dengan cepat dan praktis langsung dari browser. Klik tombol di bawah untuk membuka kasir.',
  'webPos.open_cashier': 'Buka Kasir',
  'customerDisplay.pageTitle': 'Layar Pelanggan',
  'customerDisplay.settingsTitle': 'Layar Pelanggan',
  'customerDisplay.settingsIntro':
    'Tampilkan isi keranjang, total belanja, dan media promo ke pelanggan di TV, tablet, atau monitor kedua. Cukup buka link di bawah, tanpa perlu login.',
  'customerDisplay.openDisplay': 'Buka layar pelanggan',
  'customerDisplay.step3Label': '3. Media promo',
  'customerDisplay.mediaPanelTop': 'Panel atas',
  'customerDisplay.mediaPanelTopHint': 'Panel besar. Ukuran disarankan 1600 × 900 px (16:9).',
  'customerDisplay.mediaPanelBottom': 'Panel bawah',
  'customerDisplay.mediaPanelBottomHint': 'Panel kecil. Ukuran disarankan 1600 × 600 px (8:3).',
  'customerDisplay.mediaDrop': 'Klik atau tarik gambar/video ke sini',
  'customerDisplay.mediaDropHint':
    'Maks. {imageCount} gambar JPG, PNG, WebP @ {imageMb} MB · {videoCount} video MP4 @ {videoMb} MB dan {videoSeconds} detik',
  'customerDisplay.mediaEmpty': 'Belum ada media. Layar menampilkan sambutan outlet.',
  'customerDisplay.mediaMaxImages': 'Maksimal {max} gambar per panel.',
  'customerDisplay.mediaMaxVideos': 'Maksimal {max} video per panel.',
  'customerDisplay.mediaInvalidType': 'Format tidak didukung. Gunakan JPG, PNG, WebP, atau MP4.',
  'customerDisplay.mediaTooLarge': 'Ukuran file melebihi {max} MB.',
  'customerDisplay.mediaVideoTooLong': 'Durasi video melebihi {max} detik.',
  'customerDisplay.mediaImage': 'Gambar',
  'customerDisplay.mediaVideo': 'Video',
  'customerDisplay.mediaSeconds': 'detik',
  'customerDisplay.mediaMoveUp': 'Naikkan',
  'customerDisplay.mediaMoveDown': 'Turunkan',
  'customerDisplay.mediaRemove': 'Hapus',
  'customerDisplay.mediaScheduleStart': 'Mulai tayang',
  'customerDisplay.mediaScheduleEnd': 'Selesai',
  'customerDisplay.mediaActive': 'Tayang',
  'customerDisplay.mediaInactive': 'Tidak tayang',
  'customerDisplay.mediaPreview': 'Pratinjau layar',
  'customerDisplay.mediaUploadFailed': 'Gagal mengunggah {name}. Periksa koneksi lalu coba lagi.',
  'customerDisplay.mediaUploading': 'Mengunggah…',
  'customerDisplay.mediaRemoveConfirm': 'Hapus media ini dari layar pelanggan?',
  'customerDisplay.mediaNoAccess':
    'Anda tidak punya akses untuk mengatur media promo layar pelanggan.',
  'customerDisplay.mediaLoadFailed': 'Gagal memuat media promo.',
  'customerDisplay.previewSample1': 'Es Kopi Susu',
  'customerDisplay.previewSample2': 'Croissant Butter',
  'customerDisplay.previewSample3': 'Air Mineral',
  'customerDisplay.statusPaired': 'Terhubung',
  'customerDisplay.statusChecking': 'Memeriksa layar…',
  'customerDisplay.statusOffline': 'Layar tidak aktif',
  'customerDisplay.statusOfflineHint':
    'Layar pelanggan tidak merespons. Pastikan link layar pelanggan terbuka di perangkat layar, lalu klik Periksa ulang.',
  'customerDisplay.recheckButton': 'Periksa ulang',
  'customerDisplay.disconnectButton': 'Putuskan',
  'customerDisplay.disconnectConfirm': 'Putuskan layar ini dari kasir?',
  'customerDisplay.pairingTitle': 'Hubungkan layar ini ke kasir',
  'customerDisplay.cartEmpty': 'Siap melayani Anda',
  'customerDisplay.subtotal': 'Subtotal',
  'customerDisplay.fees': 'Biaya tambahan',
  'customerDisplay.total': 'Total',
  'customerDisplay.thankYouTitle': 'Terima kasih!',
  'customerDisplay.thankYouSubtitle': 'Sampai jumpa lagi.',
  'customerDisplay.welcome': 'Selamat datang di',
  'customerDisplay.youSave': 'Hemat {amount}',
  'customerDisplay.greetingMorning': 'Selamat pagi!',
  'customerDisplay.greetingAfternoon': 'Selamat siang!',
  'customerDisplay.greetingEvening': 'Selamat sore!',
  'customerDisplay.greetingNight': 'Selamat malam!',
  'customerDisplay.cartEmptyHint': 'Pesanan Anda akan tampil di sini saat kasir mulai mencatat.',
  'customerDisplay.yourOrder': 'Pesanan Anda',
  'customerDisplay.itemsCount': '{count} item',
  'customerDisplay.paidTotal': 'Total dibayar',
  'customerDisplay.mediaTagline': 'Pastikan pesanan di layar sudah sesuai sebelum membayar.',
  'customerDisplay.pairingScan': 'Pindai dari aplikasi Kledo POS',
  'customerDisplay.pairingOr': 'atau',
  'customerDisplay.pairingSubtitle': 'Kode layar',
  'customerDisplay.pairingStep1': 'Di kasir, buka Pengaturan › Layar Pelanggan',
  'customerDisplay.pairingStep2': 'Klik Hubungkan',
  'customerDisplay.pairingStep3': 'Ketik kode di atas, lalu klik Hubungkan',
  'customerDisplay.linkLabel': '1. Buka link ini di TV, tablet, atau monitor kedua',
  'customerDisplay.showQr': 'Tampilkan QR',
  'customerDisplay.qrModalTitle': 'Pindai untuk membuka layar pelanggan',
  'customerDisplay.linkUnavailable': 'Link layar pelanggan belum tersedia untuk outlet ini.',
  'customerDisplay.sendLabel': '2. Kirim pesanan dari kasir ini',
  'customerDisplay.sendHint':
    'Aktifkan di satu perangkat kasir saja per outlet. Jika lebih dari satu, layar menampilkan keranjang dari kasir yang terakhir mengirim.',
  'customerDisplay.linkInvalidTitle': 'Link layar pelanggan tidak berlaku',
  'customerDisplay.linkInvalidHint':
    'Minta link terbaru dari kasir di Pengaturan › Layar Pelanggan, lalu buka di perangkat ini.',
  'kledoPos.hash_tag': '#jadilebihbaik, mudah, dan praktis.',
  'kledoPos.head_title_1':
    'Catat, Pantau, dan Analisis Setiap Transaksi Penjualan Lebih Mudah dengan Kledo POS',
  'kledoPos.head_title_description':
    'Aplikasi kasir yang terintegrasi secara sempurna dengan software akuntansi Kledo. Solusi terbaik untuk pencatatan transaksi dari berbagai outlet, toko, dan cabang usaha dalam satu platform.',
  'kledoPos.download': 'Download Kledo POS',
  'kledoPos.try_pos_web_version': 'Coba Versi Web POS',
  'kledoPos.footer_note':
    'Catat setiap transaksi dan lakukan analisa keuangan bisnis lebih mudah menggunakan integrasi Kledo POS dan software akuntansi Kledo sekarang juga.',
  'kledoPos.feat_title_1': 'Apa yang Akan',
  'kledoPos.feat_title_2': 'Anda Dapatkan',
  'kledoPos.feat_title_3': 'Jika Menggunakan Kledo POS?',
  'kledoPos.feat_1_sub_title': 'Menerima berbagai jenis pembayaran',
  'kledoPos.feat_1_description':
    'Dengan Kledo POS, Anda bisa mencatat pembayaran dari berbagai metode pembayaran mulai dari pembayaran tunai, non tunai, e-wallet, dan dari mesin EDC.',
  'kledoPos.feat_2_sub_title': 'Aplikasi kasir yang mudah digunakan',
  'kledoPos.feat_2_description':
    'Kledo POS bisa Anda install di smartphone atau tablet Android dengan mudah dan bisa digunakan secara online dan offline.',
  'kledoPos.feat_3_sub_title': 'Pengaturan promo',
  'kledoPos.feat_3_description':
    'Buat promo yang memanjakan pelanggan Anda dan catat setiap transaksi yang menggunakan promo tersebut tanpa ada satupun yang terlewat.',
  'kledoPos.feat_4_sub_title': 'Implementasi gratis',
  'kledoPos.feat_4_description':
    'Sudah beli software POS mahal tapi masih harus bayar training? Sekarang Anda bisa menggunakan Kledo POS gratis tanpa batasan cabang dan kami menjanjikan implementasi dan training gratis sampai Anda bisa menggunakannya.',
  'kledoPos.feat_5_sub_title': 'Profil pelanggan',
  'kledoPos.feat_5_description':
    'Data pelanggan merupakan hal penting yang harus dimiliki setiap bisnis. Dengan menggunakan Kledo POS, Anda bisa menyimpan semuanya dengan lebih praktis.',
  'kledoPos.feat_6_sub_title': 'Integrasi dengan sistem akuntansi',
  'kledoPos.feat_6_description':
    'Terintegrasi sempurna dengan ekosistem Kledo sehingga memudahkan Anda dalam mengelola data keuangan dalam satu platform yang optimal.',
  'kledoPos.setting': 'Pengaturan POS',
  'kledoPos.setting_custom_product': 'Custom Produk',
  'kledoPos.setting_custom_product_desc':
    'Anda dapat membuat transaksi di POS untuk produk yang belum tercatat di data, atau disebut custom produk. Untuk transaksi custom produk, sistem Kledo akan mencatatkannya sebagai penjualan untuk produk sesuai pada pengaturan ini.',
  'kledoPos.setting_default_customer': 'Default Pelanggan',
  'kledoPos.setting_default_customer_desc':
    'Anda dapat mencatatkan penjualan di POS dengan tanpa mencatatkan pelanggannya. Apabila transaksi tidak dicatatkan pelanggannya, maka sistem Kledo akan mencatatkannya sebagai transaksi milik `default Pelanggan` pada pengaturan ini.',
  'kledoPos.setting_product_placeholder': 'Pilih Produk',
  'kledoPos.setting_customer_placeholder': 'Pilih Pelanggan',
  'kledoPos.error_cannot_update': 'Gagal simpan pengaturan',
  'kledoPos.setting_default_outlet_placeholder': 'Pilih Outlet',
  'kledoPos.setting_default_spend_account': 'Default Akun Kirim Dana',
  'kledoPos.setting_default_spend_account_placeholder': 'Pilih Akun',
  'kledoPos.setting_default_spend_account_desc':
    'Saat mencatatkan keluar masuk kas di POS, maka di akunting akan dicatatkan pada akun COA ini.',
  'kledoPos.setting_default_receive_account': 'Default Akun Terima Dana',
  'billing.pos_add_outlet_label': 'Berapa Jumlah Outlet yang akan ditambahkan?',
  'billing.pos_current_quota': 'Kuota POS saat ini: {outlet} Outlet',
  'billing.pos_add_outlet': 'Tambah Outlet',
  'billing.pos_please_add_addon': 'Silakan tambah satu addon POS',
  'financeBanks.import_bank_transfer': 'Import Transfer Bank',
  'financeBanks.follow_these_steps_to_import_your_bank_transfer':
    'Ikuti langkah-langkah berikut untuk meng-import transfer bank',
  'financeBanks.1_download_your_bank_transfer_template_file':
    '1. Download file template transfer bank',
  'financeBanks.start_by_downloading_our_bank_transfer_csv':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari transfer bank-mu.',
  'financeBanks.2_copy_your_bank_transfer_into_the_template':
    '2. Salin detail transfer bank ke dalam template',
  'financeBanks.bank_transfer_import_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail transfer bank ke dalam file template dari Kledo. Pastikan detail transfer bank sesuai dengan kolom header yang ada di template.',
  'financeBanks.a_maximum_of_500_bank_transfer_can_be_imported_at_a_time':
    'Maksimal 1.000 transfer bank dapat diimport dalam satu waktu.',
  'financeBanks.bank_transfer_import_from_account': 'Dari Rekening (Kode Akun)',
  'financeBanks.bank_transfer_import_to_account': 'Ke Rekening (Kode Akun)',
  'financeBanks.bank_transfer_import_transfer_amount': 'Jumlah Transfer',
  'financeBanks.in': 'Masuk',
  'financeBanks.out': 'Keluar',
  'financeAccounts.balance_per_category': 'Saldo Per Kategori',
  'financeAccounts.balance_per_account': 'Saldo Per Akun',
  'reports.show_graph': 'Tampilkan Grafik',
  'reports.hide_graph': 'Sembunyikan Grafik',
  'reports.number_of_transactions_per_source': 'Jumlah transaksi per sumber',
  'massRevertReconcile.mass_unreconciled': 'Batalkan Rekonsiliasi Massal',
  'massRevertReconcile.cannot_mass_unreconciled': 'Tidak dapat membatalkan rekonsiliasi',
  'massRevertReconcile.can_be_unreconciled': 'Bisa membatalkan rekonsiliasi',
  'massRevertReconcile.are_you_sure_want_to_unreconciled':
    'Apakah Anda yakin akan membatalkan {count} rekonsiliasi?',
  'massRevertReconcile.data_progress_unreconciled':
    '{count} data dari total {total} telah dibatalkan dari rekonsiliasi',
  'massRevertReconcile.data_has_been_unreconciled':
    'Total {count} data telah berhasil dibatalkan dari rekonsiliasi',
  'billing.downgrade_warning_title': 'Perhatian!!!',
  'billing.downgrade_warning_description_1':
    'Akun yang telah di downgrade tidak dapat dibatalkan. Diperlukan melakukan upgrade dan pembayaran untuk mengembalikan ke paket sebelumnya.',
  'billing.downgrade_warning_description_2':
    'Akun yang telah di downgrade, akan mengikuti harga paket terbaru dan batasan fitur terbaru.',
  'billing.downgrade_warning_description_3':
    'Akun yang lebih lama di Kledo, biasanya mendapatkan harga yang lebih murah, dan fitur yang lebih lengkap dibandingkan dengan akun baru di Kledo.',
  'billing.what_package_will_you_downgrade_to': 'Akan di downgrade ke paket apa?',
  'billing.downgrade_now': 'Downgrade Sekarang',
  'billing.button_confirm_title':
    'Aksi ini tidak dapat dibatalkan, dan Anda akan kehilangan benefit sebagai pemilik akun lama. Apakah Anda yakin untuk mendowngrade paket Anda?',
  'billing.button_downgrade_now': 'Ya, Downgrade Sekarang',
  'financeFixedAssets.asset_value': 'Nilai Aset',
  'financeFixedAssets.asset_depreciation': 'Depresiasi Aset',
  'financeFixedAssets.asset_disposal': 'Laba/Rugi Pelepasan Aset',
  'financeFixedAssets.new_assets': 'Aset Baru',
  'financeFixedAssets.depreciation_chart': 'Depresiasi',
  'financeFixedAssets.profit_and_loss_on_asset_disposal': 'Untung Rugi Pelepasan Aset',
  'financeFixedAssets.highest_value_assets': '{count} Nilai Asset Tertinggi',
  'financeFixedAssets.the_highest_acquisition_costs': '{count} Biaya Akuisisi Tertinggi',
  'financeFixedAssets.profit': 'Untung',
  'financeFixedAssets.loss': 'Rugi',
  'financeProduct.this_product_is_a_package_material_from_with_title':
    '{title} ini bahan paket dari',
  'financeProduct.this_product_is_raw_material_from_with_title': '{title} ini bahan baku dari',
  'settings.due_reminder': 'Kirim email ke pelanggan yang mempunyai tagihan jatuh tempo',
  'businessFlow.system': 'Sistem',
  'businessFlow.enable_white_label': 'Aktifkan whitelabel?',
  'businessFlow.enable_white_label_desc':
    'Jika whitelabel aktif, maka web app, konten whatsapp, dan konten email akan dihilangkan teks kledo pada bagian footernya.',
  'financeOrder.amount_unbilled': 'Nominal Belum Ditagih',
  'settings.download_description':
    'Anda dapat mengunduh database Kledo Anda untuk disimpan secara offline di komputer Anda. Data yang diunduh dalam format excel (.xls), dan diperlukan beberapa menit untuk menyiapkan file backupnya.',
  'settings.download_button': 'Mulai Siapkan File Backup Sekarang',
  'settings.please_wait_download_backup':
    'Mohon menunggu beberapa saat, file download database sedang disiapkan.',
  'settings.preparing_data': 'Menyiapkan data {dataName}',
  'settings.backup_auto_delete': '* File backup akan dihapus otomatis dalam 1-4 hari',
  'settings.download_backup_finish':
    'File backup database telah siap, klik tombol dibawah untuk mendownload:',
  'settings.finance_backup_database': 'Mengunduh database Kledo Anda',
  'settings.backup_date': 'Tanggal Backup',
  'sales_overview.vs_same_date_with_another_date': 'vs tanggal sama {date}',
  'sales_overview.vs_another_date': 'vs {date}',
  'sales_overview.invoices_this_month_with_title': '{title} {date}',
  'sales_overview.of_the_total_unpaid_invoices_with_title': 'dari total {title} belum dibayar',
  'sales_overview.invoices_paid_vs_total_invoices_for_the_month_with_title':
    '{title} lunas vs total {title} {date}',
  'sales_overview.paid_ratio': 'Rasio Lunas',
  'sales_overview.sales_flow_not_completed_with_title': 'Alur {title} Belum Selesai',
  'sales_overview.quote_accepted_with_title': '{title} disetujui',
  'sales_overview.order_not_finished_with_title': '{title} belum selesai',
  'sales_overview.delivery_has_not_been_invoiced_with_title': '{title} belum ditagih',
  'sales_overview.invoices_due_with_title': '{title} jatuh tempo',
  'purchases_overview.purchase_payment_sent_with_title': 'Pembayaran {title} dikirim',
  'purchases_overview.payment_purchases_pending_with_title': 'Menunggu Pembayaran {title}',
  'financeProduct.qty_per_warehouse': 'Stok per Gudang',
  'financeProduct.product_value_per_warehouse_with_title': 'Nilai {title} per Gudang',
  'billing.most_chosen': 'Paling Banyak Dipilih',
  'billing.see_more': 'Lihat Selengkapnya',
  'billing.show_less': 'Tampilkan Lebih Sedikit',
  'billing.product_manufacture': 'Produk Manufaktur',
  'billing.contract_length': 'Pilih Lama Kontrak',
  'billing.please_choose_contract_length': 'Silakan Pilih Lama Kontrak',
  'billing.saving': 'Hemat',
  'billing.addon_user_description': 'Tambahkan user untuk terlibat membantu mengelola akun Anda.',
  'billing.addon_warehouse_description':
    'Makin banyak gudang, makin mudah mengkategorikan item atau produk.',
  'billing.addon_marketplace_description':
    'Memberikan Anda untuk melakukan integrasi toko Anda dengan Marketplace',
  'billing.addon_invoice_description':
    'Menambahkan jumlah invoice di akunmu, 1 addons invoice = 5.000 invoice.',
  'billing.addon_product_description':
    'Menambahkan jumlah {products} di akunmu, 1 addons {product} = 1.000 {products}.',
  'billing.addon_bank_connect_description':
    'Mengintegrasikan bisnis yang Anda miliki dengan layanan bank yang Anda punya.',
  'billing.invoices': 'Invoice',
  'billing.employee': 'Karyawan ',
  'billing.select_add_on_hris': 'Pilih Paket Addon Payroll & HRIS',
  'billing.hris_elite': 'Paket Elite',
  'billing.hris_pro': 'Paket Pro',
  'billing.active_package': 'Paket Aktif',
  'billing.expired_date': 'Tanggal expired',
  'billing.at_the_moment': 'Saat Ini',
  'billing.after_extension': 'Setelah Perpanjangan',
  'billing.extend_now': 'Perpanjang Sekarang',
  'billing.upgrade_plan_to': 'Upgrade Paket {planName}',
  'billing.contract': 'Kontrak',
  'billing.per_month': 'Perbulan',
  'billing.calculation_details': 'Rincian Perhitungan',
  'billing.most_chosen_subs_with_x_discount':
    'Dengan berlangganan {targetContract}, Anda akan mendapatkan diskon sebesar {discount}.',
  'billing.most_chosen_subs_with_x_discount_warning':
    'Apakah Anda yakin berlangganan {term} dan tidak mendapatkan diskon {discount}?',
  'billing.i_want_discount': 'Saya mau diskon {discount}',
  'billing.i_dont_want_discount': 'Ya, saya tidak mau diskon',
  'financeBanks.bank_connect_less': 'Lebih Sedikit',
  'financeBanks.error_cannot_export': 'Tidak dapat ekspor {bankName}',
  'report.total_due': 'Total Jatuh Tempo',
  'settings.set_roles': 'Atur Peran',
  'settings.set_users': 'Atur Pengguna',
  'report.aged_receivable_from_until_less_than_equal_months':
    '{firstMonth} s/d <= {secondMonth} bulan',
  'report.aged_receivable_greater_than_months': '> {month} bulan',
  'financeFixedAssets.last_automatic_depreciation': 'Penyusutan otomatis terakhir pada {dateTime}',
  'financeFixedAssets.see_automatic_depreciation_history': 'Lihat histori penyusutan otomatis',
  'report.downloading_data': 'Sedang mengunduh data...',
  'contacts.info_is_as_employee':
    'Beberapa data tidak bisa diubah karena kontak juga sebagai pegawai.',
  'report.balance_sheet_previous_month': 'bulan sebelumnya',
  'report.balance_sheet_previous_year': 'tahun sebelumnya',
  'report.balance_sheet_vs_1_month_ago': 'vs 1 bulan lalu',
  'report.balance_sheet_structure': 'Struktur Neraca',
  'report.balance_sheet_trend': 'Tren Neraca',
  'report.balance_sheet_component_trend': 'Tren Komponen Neraca',
  'report.balance_sheet_component': 'Komponen Neraca',
  'report.balance_sheet_equity': 'Ekuitas',
  'report.balance_sheet_asset': 'Aset',
  'report.balance_sheet_liability': 'Liabilitas',
  'report.balance_sheet_trend_net_position': 'Tren Posisi Net Neraca',
  'report.quick_ratio_help_1':
    'Quick ratio berfungsi sebagai indikator likuiditas jangka pendek perusahaan, atau kemampuannya untuk memenuhi kewajiban jangka pendeknya. Dengan kata lain, ini menguji seberapa banyak perusahaan memiliki aset untuk melunasi semua kewajibannya.',
  'report.quick_ratio_help_2':
    'Saat nilai dari quick ratio di atas 1, artinya aset lancar perusahaan atau bisnis mampu memenuhi segala kewajiban lancarnya. Hal ini mengindikasikan kondisi keuangan bisnis yang sehat karena mampu melunasi seluruh tanggungannya jika diperlukan.',
  'report.quick_ratio_help_3':
    'Sebaliknya, jika nilai quick ratio kurang dari 1, artinya entitas tersebut tidak mampu melunasi kewajiban lancarnya menggunakan semua aset lancar yang dimiliki.',
  'report.quick_ratio_help_4':
    'Rumus quick ratio : (Aset Lancar – Stok atau Persediaan) / Kewajiban Lancar',
  'report.current_ratio_help_1':
    'Current ratio digunakan untuk mengevaluasi kemampuan perusahaan agar bisa membayar kewajiban jangka pendek, seperti utang dan upah. Current ratio ini dihitung dengan membagi aset lancar dengan kewajiban lancar. Semakin tinggi hasilnya, semakin kuat posisi keuangan perusahaan.',
  'report.current_ratio_help_2':
    'Namun, perlu diingat bahwa rasio lancar yang terlalu tinggi juga dapat menunjukkan bahwa perusahaan tidak mengoptimalkan penggunaan asetnya.',
  'report.current_ratio_help_3': 'Rumus Current Ratio = Total Aset Lancar / Total Kewajiban Lancar',
  'report.debt_equity_ratio_help_1':
    'Debt to Equity Ratio adalah rasio keuangan yang membandingkan jumlah hutang dengan ekuitas.',
  'report.debt_equity_ratio_help_2':
    'Ekuitas dan jumlah hutang piutang yang digunakan untuk operasional perusahaan harus berada dalam jumlah yang proporsional. Debt to Equity Ratio juga sering dikenal sebagai rasio leverage atau rasio pengungkit.',
  'report.debt_equity_ratio_help_3': 'Rumus Debt to Equity Ratio (DER) = Total Hutang / Ekuitas',
  'report.debt_equity_ratio_help_4':
    'Nilai debt to equity ratio di atas 2 atau 200% menunjukkan bahwa kondisi keuangan perusahaan sudah sangat rawan terhadap berbagai jenis risiko.',
  'report.equity_ratio_help_1':
    'Equity Ratio menunjukkan nilai aset yang dibiayai menggunakan ekuitas pemilik. Semakin tinggi proporsi dana dari pemilik, maka dianggap semakin rendah resikonya.',
  'report.equity_ratio_help_2':
    'Rasio ini dihitung dengan membagi total ekuitas perusahaan dengan total asetnya.',
  'report.equity_ratio_help_3': 'Rumus Equity Ratio  = Total Ekuitas / Total Aset',
  'birthday.please_input_the_birthday_template_subject':
    'Silakan masukkan judul untuk template ulang tahun.',
  'birthday.send_an_email_to_a_customer_having_a_birthday':
    'Kirim email ke pelanggan yang berulang tahun',
  'birthday.when_email_birthday_sent':
    'Pada hari ulang tahun, pelanggan akan secara otomatis dikirim email ucapan selamat ulang tahun. Pastikan telah mengisi tanggal lahir pelanggan dari masing-masing data kontak pelanggan Anda!',
  'birthday.active': 'Aktif',
  'birthday.inactive': 'Nonaktif',
  'birthday.recipient_title': 'Penerima {channel}',
  'birthday.all_customers': 'Semua {customer}',
  'birthday.specific_groups': 'Grup tertentu',
  'birthday.select_group': 'Pilih grup',
  'birthday.select_min_one_group': 'Pilih minimal 1 grup',
  'birthday.send_whatsapp_to_customer': 'Kirim WhatsApp ke pelanggan yang berulang tahun',
  'birthday.send_whatsapp_to_customer_desc':
    'Dikirim otomatis di hari ulang tahun. Pastikan tanggal lahir dan nomor HP pelanggan terisi.',
  'birthday.whatsapp_setting_saved': 'Pengaturan WhatsApp ulang tahun berhasil disimpan',
  'birthday.whatsapp_not_sent_until_ok':
    'WhatsApp ulang tahun tidak dikirim sampai masalah ini selesai.',
  'birthday.status_template_params_incomplete': 'Isi variabel template belum lengkap.',
  'birthday.status_template_not_usable':
    'Template WhatsApp yang dipilih tidak bisa dipakai. Pilih template lain.',
  'birthday.status_app_disconnected':
    'App WhatsApp tidak terhubung. Hubungkan lagi atau pilih pengirim lain.',
  'birthday.status_number_inactive': 'Nomor WhatsApp pengirim sudah tidak aktif. Pilih nomor lain.',
  'birthday.status_crm_balance_empty':
    'Saldo App WhatsApp habis. Isi saldo supaya ucapan terkirim.',
  'birthday.sender': 'Pengirim',
  'birthday.sender_official_title': 'Nomor WhatsApp Official Kledo',
  'birthday.sender_official_desc': 'Pakai kuota addon WhatsApp Kledo.',
  'birthday.sender_own_title': 'Nomor sendiri',
  'birthday.sender_own_desc': 'Kirim dari nomor di App WhatsApp, pakai saldo App WhatsApp.',
  'birthday.official_quota_left': 'Sisa kuota WhatsApp Official: {count}',
  'birthday.official_quota_empty':
    'Kuota WhatsApp Official habis. Ucapan tidak terkirim sampai kuota ditambah.',
  'birthday.buy_whatsapp_addon': 'Tambah kuota',
  'birthday.template_locked_info':
    'Kalimat template sudah terkunci sesuai standar WhatsApp Official. Kamu hanya bisa mengubah bagian variabel (hijau).',
  'birthday.official_template_unavailable': 'Template WhatsApp Official belum tersedia.',
  'birthday.wa_app_not_connected':
    'App WhatsApp belum terhubung. Hubungkan dulu untuk mengirim dari nomor sendiri.',
  'birthday.connect_wa_app': 'Hubungkan',
  'birthday.wa_app_no_active_number':
    'App WhatsApp sudah terhubung, tapi belum ada nomor aktif. Aktifkan nomor di App WhatsApp.',
  'birthday.open_wa_app': 'Buka App WhatsApp',
  'birthday.phone_number': 'Nomor WhatsApp',
  'birthday.select_phone_number': 'Pilih nomor WhatsApp',
  'birthday.template': 'Template',
  'birthday.select_template': 'Pilih template',
  'birthday.whatsapp_preview': 'Pratinjau WhatsApp',
  'birthday.message_content': 'Isi pesan',
  'birthday.variable_label': 'Variabel {number}',
  'birthday.insert_tag': 'Sisipkan Tag',
  'birthday.variable_required': 'Variabel wajib diisi',
  'birthday.variable_max_length': 'Maksimal {max} karakter',
  'birthday.variable_invalid_whitespace':
    'Variabel tidak boleh berisi baris baru, tab, atau 4 spasi berturut-turut',
  'birthday.variable_unknown_tag': 'Tag tidak dikenal: {tags}',
  'birthday.own_number_not_ready':
    'Pengirim tidak disimpan karena nomor dan template belum dipilih. Pilih dulu, atau pakai WhatsApp Official Kledo.',
  'birthday.own_number_preview_name': 'Nomor WhatsApp kamu',
  'birthday.setting_load_failed': 'Pengaturan ulang tahun gagal dimuat',
  'birthday.setting_load_failed_desc':
    'Form tidak ditampilkan supaya pengaturan yang tersimpan tidak tertimpa. Coba muat lagi.',
  'birthday.wa_senders_load_failed': 'Daftar nomor App WhatsApp gagal dimuat.',
  'birthday.email_template_not_saved':
    'Template email tidak disimpan karena gagal dimuat. Muat ulang halaman lalu coba lagi.',
  'birthday.save_network_error':
    'Sebagian pengaturan gagal disimpan karena tidak bisa terhubung ke server. Coba lagi.',
  'settings.customer_birthday': 'Kirim email ke pelanggan yang sedang berulang tahun',
  'financeInvoices.profit_margin_minus': 'Profit margin minus',
  'financeInvoices.select_name': 'Pilih {name}',
  'financeWareHouses.stock_adjustment_price': 'Harga Penyesuaian Stok',
  'financeWareHouses.recorded_average_price': 'Harga Rata-Rata Tercatat',
  'financeApproval.cannot_approve_transaction': 'Gagal melakukan approve pada transaksi ini.',
  'report.equity_movement_capital_balance': 'Saldo Modal',
  'report.equity_movement_capital_increase': 'Penambahan Modal',
  'report.equity_movement_capital_reduction': 'Pengurangan Modal',
  'report.equity_movement_capital_component_trends': 'Tren Komponen Modal',
  'report.equity_movement_capital_component': 'Komponen Modal',
  'report.receivable_payable_debt_widget': 'Hutang',
  'report.receivable_payable_receivable_widget': 'Piutang',
  'report.receivable_payable_net_debt_receivable_widget': 'Net Hutang Piutang',
  'report.receivable_payable_debt_receivable_contact_widget': 'Kontak',
  'report.receivable_payable_debt': 'Hutang Terbanyak',
  'report.receivable_payable_receivable': 'Piutang Terbanyak',
  'report.receivable_payable_ratio_debt_receivable': 'Rasio Hutang Piutang',
  'report.receivable_payable_trend_debt_receivable': 'Tren Hutang Piutang',
  'report.receivable_payable_transaction': 'transaksi',
  'report.receivable_payable_this_month': 'bulan ini',
  'report.receivable_payable_this_year': 'tahun ini',
  'report.receivable_payable_contact_debt_with_title': 'kontak punya {title}',
  'report.receivable_payable_contact_receivable_with_title': 'kontak punya {title}',
  'report.executive_summary_equity_movement': 'Perubahan Modal',
  'financeProduct.change_column_display': 'Mengubah tampilan kolom...',
  'financeProduct.column_display_changed_successfully': 'Tampilan kolom berhasil diubah',
  'reports.add_menu_to_favorites_menu': 'Tambahkan menu ke menu favorit',
  'reports.remove_from_favorites_menu': 'Hilangkan dari menu favorit',
  'page404.title': 'Halaman tidak ditemukan',
  'page404.description':
    'Halaman tersebut tidak digunakan lagi, dihapus, atau tidak ada sama sekali',
  'page404.fallback': 'Kembali ke halaman beranda',
  'page404.custom_detail_title': 'Halaman detail {title} tidak ditemukan',
  'page404.custom_import_title': 'Halaman import {title} tidak ditemukan',
  'page404.custom_detail_description': '{title} ini telah dihapus atau tidak ada sama sekali',
  'page404.custom_fallback': 'Kembali ke halaman {title}',
  'notFoundState.title': 'Data tidak dapat ditemukan',
  'notFoundState.description':
    'Data yang kamu cari mungkin sudah dihapus, dipindahkan, atau tautannya keliru.',
  'notFoundState.code_label': 'Kode transaksi',
  'notFoundState.back': 'Kembali',
  'notFoundState.home': 'Ke Beranda',
  'report.cash_change': 'Perubahan Kas',
  'report.end_period': 'Saldo Penutupan',
  'report.cash_out': 'Kas Keluar',
  'report.cash_in': 'Kas Masuk',
  'report.trend_cash_flow': 'Tren Arus Kas',
  'report.chart_cash_flow': 'Saldo Kas',
  'report.funding_components': 'Komponen Pendanaan',
  'report.investment_components': 'Komponen Investasi',
  'report.operational_components': 'Komponen Operasional',
  'report.vs_1_year_ago': 'vs 1 tahun lalu',
  'report.bank_summary_balance_per_bank': 'Saldo per Bank',
  'report.bank_summary_trend_balance_per_bank': 'Trend Saldo per Bank',
  'report.bank_summary_trend_received_per_bank': 'Trend Kas Masuk per Bank',
  'report.bank_summary_balance_all_bank': 'Saldo Seluruh Bank',
  'report.bank_summary_trend_spent_per_bank': 'Trend Kas Keluar per Bank',
  'report.bank_summary_trend_net_per_bank': 'Trend Net Pergerakan per Bank',
  'financeContacts.contact_information': 'Informasi Kontak',
  'financeInvoices.void_reason_label': 'Silahkan masukkan alasan void transaksi',
  'financeInvoices.void_reason_placeholder': 'Silahkan masukkan alasan anda',
  'report.profit_loss_net_profit_margin': 'Margin Laba Bersih',
  'report.profit_loss_gross_profit_margin': 'Margin Laba Kotor',
  'report.profit_loss_operating_expense_ratio': 'Rasio Biaya Operasional',
  'report.profit_loss_profit_loss_trend': 'Tren Laba Rugi',
  'report.profit_loss_print_graph': 'Print Grafik',
  'report.profit_loss_print_graph_selected': '{count} dari {total} grafik dipilih',
  'report.profit_loss_print_graph_failed': 'Gagal memuat data grafik. Silakan coba lagi.',
  'report.profit_loss_flow': 'Alur Laba Rugi',
  'report.profit_loss_income_details': 'Rincian Pendapatan',
  'report.profit_loss_expense_details': 'Rincian Biaya',
  'report.profit_loss_component_trends': 'Tren Komponen Laba Rugi',
  'report.budget_profit_loss_component_trends': 'Tren Komponen Anggaran',
  'report.budget_profit_loss_income_details': 'Rincian Pendapatan Anggaran',
  'report.budget_profit_loss_expense_details': 'Rincian Biaya Anggaran',
  'reports.sales_value_per_product_category_graph': 'Nilai Penjualan per Kategori Produk',
  'reports.total_sales_per_product_category_graph': 'Jumlah Penjualan per Kategori Produk',
  'reports.sales_delivery_summary_graph': 'Ringkasan Pengiriman',
  'reports.sales_delivery_amount': 'Nilai Pengiriman',
  'reports.sales_delivery_total_amount_widget': 'Total Nilai Pengiriman',
  'reports.sales_delivery_total_qty_widget': 'Total Kuantitas Dikirim',
  'reports.sales_delivery_total_transaction_widget': 'Total Transaksi Pengiriman',
  'reports.sales_delivery_top_entities': 'Top {count} {title} — Nilai Pengiriman',
  'reports.sales_per_product_summary_graph': 'Ringkasan Penjualan per Produk',
  'reports.sales_per_product_amount': 'Nilai Penjualan',
  'reports.sales_per_product_top_entities': 'Top {count} {title} — Nilai Penjualan',
  'reports.purchases_per_product_summary_graph': 'Ringkasan Pembelian per Produk',
  'reports.purchases_per_product_amount': 'Nilai Pembelian',
  'reports.purchases_per_product_top_entities': 'Top {count} {title} — Nilai Pembelian',
  'report.total_purchases': 'Total Pembelian',
  'reports.sales_per_period_transaction_count_widget': 'Jumlah Invoice',
  'reports.purchase_order_per_product_summary_graph': 'Ringkasan Pesanan Pembelian per Produk',
  'reports.purchase_order_per_product_amount': 'Nilai Pesanan Pembelian',
  'reports.purchase_order_per_product_top_entities':
    'Top {count} {title} — Nilai Pesanan Pembelian',
  'report.total_purchase_orders': 'Total Pesanan Pembelian',
  'report.quantity_ordered': 'Jumlah Dipesan',
  'reports.product_purchases_per_vendor_summary_graph': 'Ringkasan Pembelian Produk per Vendor',
  'reports.purchase_return_per_product_summary_graph': 'Ringkasan Retur Pembelian per Produk',
  'reports.purchase_return_per_product_amount': 'Nilai Retur Pembelian',
  'reports.purchase_return_per_product_top_entities': 'Top {count} {title} — Nilai Retur Pembelian',
  'report.total_purchase_returns': 'Total Retur Pembelian',
  'reports.sales_detail_summary_graph': 'Ringkasan Penjualan Detail',
  'reports.sales_detail_by_status_graph': 'Invoice per Status Pembayaran',
  'reports.sales_detail_paid': 'Tertagih',
  'reports.sales_detail_outstanding': 'Belum Tertagih',
  'report.number_of_invoices': 'Jumlah Invoice',
  'reports.sales_return_per_product_summary_graph': 'Ringkasan Retur Penjualan per Produk',
  'reports.sales_return_per_product_amount': 'Nilai Retur Penjualan',
  'reports.sales_return_per_product_top_entities': 'Top {count} {title} — Nilai Retur Penjualan',
  'report.total_sales_returns': 'Total Retur Penjualan',
  'reports.graph_top_others': 'Lainnya ({count})',
  'transactionFees.total_transaction_fees': 'Total Biaya Transaksi',
  'settings.fees': 'Atur biaya transaksi penjualan dan pembelian',
  'settings.witholdings': 'Atur master pemotongan untuk transaksi dan POS',
  'transactionFees.fees': 'Biaya Transaksi',
  'witholdings.title': 'Pemotongan',
  'witholdings.outlets': 'Outlet',
  'witholdings.all_outlets': 'Tersedia di semua outlet',
  'witholdings.all_outlets_help':
    'Jika dimatikan, pemotongan hanya bisa dipakai di kasir pada outlet yang dipilih',
  'witholdings.please_select_outlet': 'Silahkan pilih outlet',
  'witholdings.please_select_witholding': 'Silahkan pilih pemotongan',
  'witholdings.select_witholding': 'Pilih pemotongan',
  'witholdings.exceed_total': 'Total pemotongan melebihi total tagihan',
  'witholdings.save_order_disabled':
    'Pemotongan hanya untuk bayar langsung. Hapus pemotongan untuk menyimpan ke pesanan',
  'transactionFees.nominal': 'Nominal',
  'transactionFees.please_input_the_nominal': 'Silahkan masukkan nominal',
  'transactionFees.please_select_transaction_fee': 'Silahkan pilih biaya transaksi',
  'transactionFees.select_transaction_fee': 'Pilih biaya transaksi',
  'transactionFees.include_tax': 'Termasuk Pajak',
  'transactionFees.include_tax_help':
    'Aktifkan agar persen dihitung dari subtotal + pajak. Matikan untuk hitung dari subtotal saja.',
  'reports.total_of_transactions_per_customer': 'Jumlah Transaksi per Pelanggan',
  'reports.total_of_transactions_per_vendor': 'Jumlah Transaksi per Vendor',
  'reports.expense_claim_per_term': 'Klaim Biaya Per Tempo',
  'reports.term_expense_claim': 'Tempo Klaim Biaya',
  'reports.total_due_expense_claim': 'Total Klaim Biaya Jatuh Tempo',
  serial_or_production_number: 'Nomor Seri / Produksi',
  'financeProduct.unique_number': 'Nomor Unik',
  'financeProduct.production_number': 'Nomor Produksi',
  'financeProduct.use_expired_date': 'Menggunakan tanggal kadaluarsa',
  'financeProduct.series_type': 'Jenis',
  'financeBanks.bank_statements_empty_title': 'Anda belum mempunyai data transaksi bank',
  'financeBanks.bank_statements_empty_description':
    'Data transaksi bank dapat diimport otomatis dari rekening Bank Anda atau import secara <br/> manual dengan upload filex Excel.',
  'financeBanks.bank_statements_automatic_import': 'Import Otomatis',
  'financeBanks.bank_statements_manual_import': 'Import Manual',
  'financeInvoices.enter_the_number_of_shipping_items': 'Masukkan jumlah item pengiriman',
  'billing.pos_renew_outlet': 'Perpanjang Outlet',
  'billing.pos_length_of_contract': 'Lama Kontrak',
  'billing.add_pos_addon': 'Tambah Addon POS',
  'billing.renew_pos': 'Perpanjang POS',
  'hideFeature.add_pos_addon_or_upgrade':
    'Addon POS anda telah habis masa aktifnya, silahkan order<br/>perpanjangan untuk kembali dapat mengakses POS',
  'report.journal_transaction_value': 'Nilai Transaksi',
  'report.journal_transaction_amount': 'Jumlah Transaksi',
  'report.journal_journal_row': 'Baris Jurnal',
  'report.journal_value_per_transaction_type': 'Nilai Per Tipe Transaksi',
  'report.journal_total_transaction_per_type': 'Jumlah Transaksi Per Tipe',
  'report.journal_total_transaction_value': 'Total Nilai Transaksi',
  'report.journal_total_transaction_amount': 'Total Jumlah Transaksi',
  'report.journal_total_journal_row': 'Total Baris Jurnal',
  'bankConnect.hash_tag': '#bankconnect',
  'bankConnect.head_title_1': 'Otomatis Download',
  'bankConnect.head_title_2': 'Mutasi Rekening',
  'bankConnect.head_title_3': 'Bank ke Kledo',
  'bankConnect.head_title_description':
    'Kini setiap transaksi di rekening bank mu bisa otomatis masuk ke Kledo dan direkonsiliasi. Tidak ada lagi deh selisih laporan keuangan dengan transaksi riil di bank.',
  'bankConnect.sales_contact': 'Hubungi Tim Hebat Kledo',
  'bankConnect.add_bank_connect': 'Tambah Bank Connect',
  'bankConnect.set_bank_connect': 'Atur Bank Connect',
  'bankConnect.feat_title_1': 'Apa yang',
  'bankConnect.feat_title_2': 'Anda Dapatkan',
  'bankConnect.feat_title_3': 'Dengan Bank Connect',
  'bankConnect.feat_1_sub_title': 'Otomatis Download Mutasi',
  'bankConnect.feat_1_description':
    'Setiap hari, data transaksi mutasi bank akan otomatis terdownload ke aplikasi Kledo. Tak perlu lagi repot export transaksi dari ibanking dan import ke Kledo.',
  'bankConnect.feat_2_sub_title': 'Gratis, Tanpa Biaya',
  'bankConnect.feat_2_description':
    'Kledo tidak mengenakan biaya sepeserpun untuk menggunakan fitur Bank Connect. Tetapi bank akan mengenakan biaya untuk koneksi API, biaya bervariasi untuk masing-masing bank.',
  'bankConnect.feat_3_sub_title': 'Koneksi Langsung via Bank API',
  'bankConnect.feat_3_description':
    'Tanpa menggunakan pihak ke 3, Kledo akan langsung terhubung dengan bank Anda melalui API.',
  'bankConnect.feat_4_sub_title': 'Aman dan Terjamin',
  'bankConnect.feat_4_description':
    'Kerjasama Kledo dan Bank hanya dibatasi pada pengambilan mutasi rekening saja, sehingga tidak memungkinkan adanya transaksi uang keluar dari rekening Anda.',
  'bankConnect.feat_5_sub_title': 'Unlimited',
  'bankConnect.feat_5_description':
    'Tanpa batasan jumlah transaksi tiap harinya, dan tanpa batasan jumlah rekening yang Anda hubungkan. Semuanya gratis!',
  'bankConnect.footer_note': 'Yuk mudahkan proses rekonsiliasi bank mu sekarang juga!',
  'report.number_of_shipments_per_expedition': 'Jumlah Pengiriman per Ekspedisi',
  'report.sales_value_per_expedition': 'Nilai Penjualan per Ekspedisi',
  'reports.product_sales_per_customer': 'Penjualan Produk Per Pelanggan',
  'reports.product_sales_per_customer_group': 'Penjualan Produk Per Grup Pelanggan',
  'reports.product_purchases_per_vendor': 'Pembelian Produk Per Vendor',
  'reports.product_purchases_per_vendor_group': 'Pembelian Produk Per Grup Vendor',
  'reports.sales_contribution_per_vendor': 'Kontribusi Penjualan per Vendor',
  'reports.cash_movement': 'Pergerakan Kas',
  'reports.account_component': 'Komponen Akun',
  'reports.excluded_accounts': 'Akun yang dikecualikan',
  'reports.select_excluded_accounts': 'Pilih akun yang ingin dikecualikan',
  'kledoPos.setting_default_account_receive_payment': 'Default Akun Terima Pembayaran',
  'kledoPos.setting_default_account_receive_payment_desc':
    'Saat melakukan pembayaran transaksi di POS, maka di akunting akan dicatatkan pada akun COA ini.',
  'billing.show_coupon': 'Tambah Kupon',
  'billing.hide_coupon': 'Sembunyikan Kupon',
  'billing.input_coupon': 'Masukkan Kupon',
  'reports.purchase_per_period_value': 'Nilai Pembelian',
  'reports.purchase_per_period_amount': 'Jumlah Pembelian',
  'layoutInvoice.invoice_show_witholding': 'Tampilkan Pemotongan',
  'layoutInvoice.invoice_show_witholding_detail': 'Tampilkan Detail Pemotongan',
  'financeContacts.new_contact': 'Kontak Baru',
  'financeContacts.total_contact': 'Total Kontak',
  'financeContacts.contact_per_group': 'Kontak Per Grup',
  'financeContacts.contact_per_province': 'Kontak Per Provinsi',
  'reportsImport.date_and_time': 'Tanggal & Waktu',
  'reportsImport.total': 'Jumlah Import',
  'reportsImport.valid': 'Berhasil',
  'reportsImport.invalid': 'Gagal',
  'pos.pos_role': 'Peran POS',
  'approval.financeBanks': 'Kas & Bank',
  'financeWareHouses.change_access_per_contact': 'Ubah Akses Per Kontak',
  'financeWareHouses.per_contact_warehouse_access': 'Akses Gudang Per Kontak',
  'financeWareHouses.per_contact_warehouse_access_desc':
    'Gudang dapat dikhususkan hanya dapat digunakan untuk grup kontak yang terpilih. <br /> Misalnya, Gudang Surabaya hanya bisa digunakan untuk pelanggan dalam grup Surabaya. Sedangkan Gudang Nasional bisa digunakan untuk semua pelanggan',
  'financeWareHouses.warehouse_per_contact_type':
    'Gudang dapat digunakan oleh grup kontak mana saja?',
  'financeWareHouses.all_contact_groups': 'Semua Grup Kontak',
  'financeWareHouses.select_contact_group': 'Pilih Grup Kontak',
  'reports.using_new_table_view': 'Anda sedang menggunakan tampilan tabel baru',
  'reports.using_legacy_table_view': 'Anda sedang menggunakan tampilan tabel lama',
  'reports.switch_to_new_table_view': 'Ganti ke tampilan tabel baru',
  'reports.switch_to_old_table_view': 'Ganti ke tampilan tabel lama',
  'settings.finance_payment_connect': 'Terima pembayaran dari ewallet, kartu kredit, VA',
  'paymentConnect.connection_test': 'Tes Koneksi',
  'paymentConnect.activate_payment_via_provider_name': 'Aktifkan pembayaran melalui {providerName}',
  'paymentConnect.section_kledo': 'Pengaturan Kledo Payment Connect',
  'paymentConnect.section_accounting': 'Akun COA',
  'paymentConnect.section_integration': 'Kredensial & callback',
  'paymentConnect.coa_cash_bank_accounts': 'Akun COA Kas & Bank',
  'paymentConnect.coa_cash_bank_accounts_help_text':
    'Pembayaran dari payment gateway akan dicatatkan pada akun bank ini',
  'paymentConnect.coa_expense_account': 'Akun COA Beban',
  'paymentConnect.coa_expense_account_help_text':
    'Biaya Transaksi atas pembayaran akan dicatatkan pada akun COA ini',
  'paymentConnect.tax_coa_account': 'Akun COA Pajak',
  'paymentConnect.tax_coa_account_help_text':
    'Pengenaan pajak transaksi atas pembayaran akan dicatatkan pada akun COA ini',
  'paymentConnect.midtrans_api_key_help_text':
    'Salin API Key dari akun Midtrans Anda, melalui menu Pengaturan >> Access Keys >> Server Key',
  'paymentConnect.xendit_api_key_help_text':
    'Salin API Key dari akun Xendit Anda, melalui menu Pengaturan >> Developer >> API keys >> Buat secret key baru >> Secret API Key',
  'paymentConnect.doku_api_key_help_text':
    'Salin API Key dari akun DOKU Anda, melalui menu Integration >> API Keys >> Secret Key',
  'paymentConnect.required_title': 'Pengaturan Payment Connect Diperlukan',
  'paymentConnect.required_message':
    'Silakan atur Payment Connect terlebih dahulu di halaman pengaturan sebelum menggunakan fitur QRIS atau Payment Gateway. Setelah diatur, pastikan untuk menyetel Payment Connect sebagai default terlebih dahulu.',
  'paymentConnect.required_message_1':
    'Silakan atur Payment Connect di halaman pengaturan sebelum menggunakan fitur QRIS atau Payment Gateway.',
  'paymentConnect.required_message_2':
    'Setelah diatur, pastikan untuk menyetel Payment Connect sebagai default terlebih dahulu untuk mengaktifkan semua saluran pembayaran.',
  'paymentConnect.bank_verification_title': 'Rekening bank belum terverifikasi',
  'paymentConnect.bank_verification_message':
    'Akun bank untuk Payment Connect Kledo Anda masih dalam proses verifikasi. Silakan tunggu hingga verifikasi selesai sebelum menggunakan Payment Gateway di kasir. Jika sudah lama, periksa statusnya di pengaturan Payment Connect.',
  'paymentConnect.qris_not_activated':
    'Pembayaran menggunakan QRIS belum diaktifkan di provider Anda. Silakan aktifkan terlebih dahulu melalui pengaturan Payment Connect.',
  'paymentConnect.required_link_text': 'di sini',
  'paymentConnect.required_link_text_full': 'Buka pengaturan di tab baru',
  'paymentConnect.required_link_description': 'untuk membuka halaman pengaturan di tab baru.',
  'paymentConnect.required_link_prefix': 'Klik',
  'paymentConnect.token_callback_help_text':
    'Klik tombol salin URL dibawah, kemudian masukkan ke akun {providerName}',
  'invoices.payment_link': 'Link Pembayaran {providerName}',
  'invoices.link_payment_button': 'Link Pembayaran',
  'invoices.link_payment_title': 'LINK PEMBAYARAN',
  'invoices.select_payment_gateway': 'Pilih Gateway Pembayaran',
  'invoices.share_link_description':
    'Bagikan tautan ini dengan pelanggan Anda untuk menerima pembayaran secara instan melalui Kledo.',
  'invoices.link_ready_for': 'Link pembayaran {providerName} siap dibagikan ke pelanggan',
  'invoices.payment_connect_not_activated':
    'Anda belum mengaktifkan fitur {title}. Dengan {title}, pelanggan Anda dapat melakukan pembayaran melalui berbagai channel pembayaran, seperti GoPay, Kartu Kredit, Virtual Account, Alfamart, Kredivo dan banyak lagi.',
  'invoices.activate': 'Aktifkan',
  'paymentConnect.please_input_api_key': 'Silahkan masukkan API Key',
  'paymentConnect.please_input_tax_coa_account': 'Silahkan pilih Akun COA Pajak',
  'paymentConnect.please_input_coa_expense_account': 'Silahkan pilih Akun COA Beban',
  'paymentConnect.please_input_coa_cash_bank_accounts': 'Silahkan pilih Akun COA Kas & Bank',
  'layoutInvoice.show_reference_as_message_with_title': 'Tampilkan {reference} Sebagai Pesan',
  'tags.choose_a_color': 'Pilih warna',
  'report.profitloss_delta_tooltip':
    'Perbedaan antara pendapatan periode sebelumnya dan pendapatan periode ini.',
  'report.profitloss_delta_percentage_tooltip':
    'Pertumbuhan atau penurunan dari pendapatan periode sebelumnya.',
  'report.profitloss_percent_of_parent_tooltip': 'Persentase terhadap hpp',
  'reports.production_number_expires_soon': 'Nomor Produksi Segera Kadaluarsa',
  'reports.expired_date': 'Tanggal Kedaluwarsa',
  'reports.remaining_days_expiry': 'Sisa Hari (Kadaluarsa)',
  'reports.serial_no': 'No Seri',
  'reports.remaining_life_per_production_number': 'Sisa Umur Per Nomor Produksi',
  'report.serial_number': 'Nomor Seri',
  'report.all_serial_products': 'Semua Produk Serial',
  'report.unique': 'Unik',
  'report.production_code': 'Kode Produksi',
  'report.serial_type': 'Jenis Serial',
  'report.select_serial_type': 'Pilih Jenis Serial',
  'kledoPos.setting_sales_tags': 'Tags Penjualan',
  'kledoPos.setting_sales_tags_description':
    'Penjualan melalui POS akan otomatis menggunakan tags berikut.',
  'sso.please_input_your_code': 'Silakan masukkan kode Anda',
  'sso.verified': 'Diverifikasi',
  'sso.pending_verification': 'Verifikasi Tertunda',
  'sso.domain_verification': 'Verifikasi Domain',
  'sso.domain_verification_successful': 'Verifikasi Domain Berhasil',
  'sso.add_domain': 'Tambah Domain',
  'sso.add_domain_desc':
    'Silahkan masukkan alamat email Anda yang mengandung nama domain perusahaan Anda. Misalnya namaku@namaperusahaan.com',
  'sso.domain_successfully_verified': 'Selamat! Domain {domainName} berhasil diverifikasi.',
  'sso.verify_domain_desc':
    'Kode verifikasi telah dikirim ke alamat email Anda. Silahkan masukkan kode verifikasi pada form di bawah',
  'sso.verification': 'Verifikasi',
  'sso.resend_code': 'Kirim ulang kode',
  'sso.sso_configuration_service_provider_desc':
    'Silahkan masukkan data SP Entity ID dan SP ACS URL di bawah ke dalam halaman administrasi identity provider anda',
  'sso.sso_configuration_identity_provider_desc':
    'Ambil data IDP Entity ID dan SAML Login URL dari identity provider Anda, kemudian masukkan ke form di bawah',
  'sso.sso_please_enter_idp_entity_id': 'Silahkan masukkan IDP Entity ID',
  'sso.sso_please_enter_saml_login_url': 'Silahkan masukkan SAML Login URL',
  'sso.sso_configuration': 'Konfigurasi SSO',
  'settings.sso_setting': 'Login Kledo dengan hanya satu akun',
  'sso.continue_with_sso': 'Lanjutkan dengan SSO',
  'sso.login_with_sso': 'Masuk dengan SSO',
  'sso.login_sso_desc':
    'Akun Anda telah mengaktifkan Single Sign-On. Lanjutkan dengan SSO <br /> untuk mengakses akun Kledo Anda',
  'sso.return_to_login': 'Kembali ke login',
  'businessFlow.enable_login_with_sso': 'Aktifkan login dengan SSO?',
  'businessFlow.enable_login_with_sso_desc': 'Apakah Anda menggunakan SSO untuk login?',
  'contacts.group_with_title': 'Grup {title}',
  'contacts.who_can_access_this_contact_group': 'Siapa yang bisa mengakses grup ini?',
  'settings.approval_setting': 'Pengaturan Approval',
  'financeExpenseTerms.select_terms': 'Pilih Termin',
  'approval.transfer_money': 'Transfer Dana',
  'dashboard.the_maximum_number_that_can_be_displayed_on_the_dashboard':
    'Jumlah maksimal yang dapat ditampilkan di dashboard adalah 30',
  'sso.faq_question_what_is_sso': 'Apa itu Single Sign On (SSO)?',
  'sso.faq_answer_what_is_sso':
    'SSO memungkinkan pengguna untuk login ke banyak aplikasi dan website menggunakan satu identity provider. Sehingga pengguna tidak perlu menghafal banyak user dan password untuk masing-masing aplikasi atau website.',
  'sso.faq_question_how_does_sso_work': 'Bagaimana cara kerja SSO?',
  'sso.faq_answer_1_how_does_sso_work': 'Pengguna berusaha login ke Kledo menggunakan SSO',
  'sso.faq_answer_2_how_does_sso_work': 'Kledo mengirimkan data pengguna ke Identity Provider',
  'sso.faq_answer_3_how_does_sso_work':
    'Identity Provider melakukan pengecekan kredensial pengguna',
  'sso.faq_answer_4_how_does_sso_work':
    'Identity Provider mengirimkan respon ke Kledo, memberitahukan bahwa pengguna diperbolehkan login',
  'sso.faq_answer_5_how_does_sso_work':
    'Kledo menerima info tersebut dari Identity Provider, dan meloginkan pengguna tersebut ke Kledo',
  'sso.faq_question_how_to_setup_sso_in_kledo': 'Bagaimana cara setup SSO di Kledo?',
  'sso.faq_answer_how_to_setup_sso_in_kledo': 'Klik {here} untuk tutorial cara setup SSO di Kledo.',
  'sso.here': 'di sini',
  'report.average_unit_price': 'Harga Satuan Rata-Rata',
  'report.average_product_value': 'Nilai Produk Rata-Rata',
  'report.total_product_value': 'Total Nilai Produk',
  'billing.payment_balance': 'Saldo Pembayaran',
  'roles.time_access_limit': 'Terapkan batas waktu akses',
  'roles.access_limit': 'Batas waktu akses',
  'roles.restricted_access_type_monday_friday': 'Senin - Jumat Jam Kerja',
  'roles.restricted_access_type_monday_saturday': 'Senin - Sabtu Jam Kerja',
  'roles.restricted_access_type_custom': 'Custom',
  'roles.active_days_monday': 'Senin',
  'roles.active_days_tuesday': 'Selasa',
  'roles.active_days_wednesday': 'Rabu',
  'roles.active_days_thursday': 'Kamis',
  'roles.active_days_friday': 'Jumat',
  'roles.active_days_saturday': 'Sabtu',
  'roles.active_days_sunday': 'Minggu',
  'businessFlow.enable_contact_group_is_required': 'Grup wajib diisi',
  'businessFlow.enable_contact_group_is_required_desc':
    'Apakah saat menambah dan mengubah kontak harus ada grup?',
  'report.unit_price_help':
    'Harga Satuan yang ditampilkan merupakan harga pembelian terakhir (bukan harga rata-rata)',
  'report.product_value_help':
    'Nilai Produk yang ditampilkan merupakan harga satuan terakhir dikalikan kuantitas (bukan nilai produk rata-rata)',
  'scheduler_lock_date.monday': 'Senin',
  'scheduler_lock_date.tuesday': 'Selasa',
  'scheduler_lock_date.wednesday': 'Rabu',
  'scheduler_lock_date.thursday': 'Kamis',
  'scheduler_lock_date.friday': 'Jumat',
  'scheduler_lock_date.saturday': 'Sabtu',
  'scheduler_lock_date.sunday': 'Minggu',
  'scheduler_lock_date.days': 'Hari',
  'scheduler_lock_date.weeks': 'Minggu',
  'scheduler_lock_date.months': 'Bulan',
  'scheduler_lock_date.create_successfully': 'Opsi berhasil diperbarui',
  'scheduler_lock_date.create_failed': 'Tidak dapat memperbarui opsi',
  'scheduler_lock_date.subtitle_1': 'Kini Anda bisa secara otomatis mengubah tanggal penguncian.',
  'scheduler_lock_date.subtitle_2':
    'Tentukan aturan otomatis perubahannya pada form di bawah, dan nantinya tanggal penguncian akan otomatis terupdate sesuai pengaturanmu.',
  'scheduler_lock_date.is_automatically_changed':
    'Apakah tanggal penguncian otomatis diubah berkala?',
  'scheduler_lock_date.label1': 'Setiap kapan tanggal penguncian diubah?',
  'scheduler_lock_date.label2': 'Setiap tanggal berapa tanggal penguncian diubah?',
  'scheduler_lock_date.label3': 'Setiap hari apa tanggal penguncian diubah?',
  'scheduler_lock_date.label4': 'Ubah tanggal penguncian ke tanggal kapan?',
  'scheduler_lock_date.daily': 'Harian',
  'scheduler_lock_date.weekly': 'Mingguan',
  'scheduler_lock_date.monthly': 'Bulanan',
  'scheduler_lock_date.example': 'Contoh:',
  'scheduler_lock_date.example_sub':
    'Jika tanggal penguncian otomatis diubah pada 1 Maret, dan tanggal penguncian diubah ke 2 bulan sebelumnya, maka tanggal penguncian akan berubah menjadi 1 Januari',
  'scheduler_lock_date.earlier': 'Sebelumnya',
  'scheduler_lock_date.update_successfully': 'Schedule Tanggal Penguncian berhasil diaktifkan.',
  'scheduler_lock_date.update_failed': 'Tidak dapat mengaktifkan Schedule Tanggal Penguncian.',
  'scheduler_lock_date.update_successfully_inactive':
    'Schedule Tanggal Penguncian berhasil dinonaktifkan.',
  'scheduler_lock_date.update_failed_inactive':
    'Tidak dapat menonaktifkan Schedule Tanggal Penguncian.',
  'financeFixedAssets.effective_life_title': 'Masa Manfaat',
  'financeFixedAssets.upgrade_cost': 'Harga Upgrade',
  'financeFixedAssets.purchase_price_after_upgrade': 'Harga Pembelian Setelah Upgrade',
  'paymentConnect.faq_question_payment_gateway': 'Apa itu Payment Gateway?',
  'paymentConnect.faq_answer_payment_gateway':
    'Dengan menggunakan payment gateway, pelanggan Anda dapat melakukan pembayaran tagihan yang Anda terbitkan melalui berbagai channel pembayaran, seperti kartu kredit, gopay, virtual account dan sebagainya. \n\nKode QR akan disematkan pada tagihan Anda, sehingga pelanggan dapat membayar dengan mudah melalui scan QR Code.',
  'paymentConnect.faq_question_when_customer_pays_through_payment_gateway':
    'Apa yang terjadi saat pelanggan saya membayar melalui Payment Gateway?',
  'paymentConnect.faq_answer_when_customer_pays_through_payment_gateway':
    'Saat pembayaran dilakukan, maka tagihan Anda akan otomatis terupdate status pembayarannya. Sehingga Anda tidak perlu lagi repot mencatatkan setiap pembayaran yang masuk.',
  'paymentConnect.faq_question_payment_gateway_supported_by_kledo':
    'Payment Gateway apa saja yang didukung oleh Kledo?',
  'paymentConnect.faq_answer_payment_gateway_supported_by_kledo':
    'Anda dapat menggunakan Midtrans, Xendit maupun Doku.',
  'paymentConnect.faq_question_charge_a_fee':
    'Apakah Kledo memungut biaya untuk penggunaan Payment Gateway?',
  'paymentConnect.faq_answer_charge_a_fee':
    'Tidak. Namun pihak payment gateway provider akan mengenakan biaya per transaksi. Untuk informasi lebih detailnya, bisa ditanyakan langsung ke pihak Midtrans, Xendit maupun Doku.',
  'paymentConnect.faq_question_how_to_setup': 'Bagaimana cara setup nya?',
  'paymentConnect.faq_answer_how_to_setup': 'Klik tautan berikut:',
  'report.see_report': 'Lihat Laporan',
  'paymentConnect.click_here_to_go_to_tutorial':
    '{clickHere} untuk detail cara setup payment connect {providerName}.',
  'kledoPos.service_charge': 'Service Charge Pada Biaya Tagihan',
  'kledoPos.service_charge_desc':
    'Pada penjualan yang terdapat service charge, biaya dicatatkan pada master biaya tagihan ini.',
  'paymentConnect.success_copy_url_callback': 'Url callback berhasil disalin',
  'paymentConnect.activate_payment_methods': 'Aktifkan Jenis Pembayaran',
  'paymentConnect.payment_methods_required': 'Silakan pilih minimal 1 metode pembayaran',
  'paymentConnect.payment_methods_intro':
    'Pilih metode pembayaran yang ingin diaktifkan untuk menerima pembayaran dari pelanggan.',
  'paymentConnect.section.virtual_account.title': 'Bank Transfer',
  'paymentConnect.section.virtual_account.subtitle': 'BCA, Mandiri, BNI, BRI',
  'paymentConnect.section.e_wallet.title': 'E-Wallet',
  'paymentConnect.section.e_wallet.subtitle': 'GoPay, OVO, ShopeePay',
  'paymentConnect.section.over_the_counter.title': 'Over the Counter',
  'paymentConnect.section.over_the_counter.subtitle': 'Indomaret, Alfamart',
  'paymentConnect.section.qris.title': 'QRIS',
  'paymentConnect.section.qris.subtitle': 'Pembayaran via QR code',
  'paymentConnect.section.card.title': 'Kartu',
  'paymentConnect.section.card.subtitle': 'Pembayaran kartu debit/kredit',
  'paymentConnect.section.paylater.title': 'PayLater',
  'paymentConnect.section.paylater.subtitle': 'Akulaku, Kredivo',
  'paymentConnect.section.others.title': 'Lainnya',
  'paymentConnect.section.others.subtitle': 'Metode pembayaran lainnya',
  'paymentConnect.kledo_empty_active_methods':
    'Belum ada metode pembayaran aktif di pengaturan Payment Connect Kledo.',
  'paymentConnect.processing_payment': 'Memproses Pembayaran',
  'paymentConnect.failed_create_payment': 'Gagal membuat pembayaran',
  'paymentConnect.payment_code_not_available': 'Kode pembayaran belum tersedia',
  'paymentConnect.failed_copy_payment_code': 'Gagal menyalin kode pembayaran',
  'paymentConnect.virtual_account_copied': 'Nomor Virtual Account berhasil disalin',
  'paymentConnect.billing_code_copied': 'Kode Billing berhasil disalin',
  'paymentConnect.virtual_account_number_label': 'Nomor Virtual Account',
  'paymentConnect.amount_to_pay': 'Jumlah yang harus dibayar',
  'paymentConnect.company_code_biller_code': 'Kode Perusahaan (Biller Code)',
  'paymentConnect.billing_code_bill_key': 'Kode Billing (Bill Key)',
  'paymentConnect.qr_code_payment_alt': 'QR Code Pembayaran',
  'paymentConnect.pay_with_method': 'Bayar dengan {methodName}',
  'paymentConnect.e_wallet': 'E-Wallet',
  'paymentConnect.payment_code_label': 'Kode Pembayaran',
  'paymentConnect.payment_code_copied': 'Kode Pembayaran berhasil disalin',
  'paymentConnect.cstore_show_at_cashier_hint': 'Tunjukkan kode ini di kasir',
  'paymentConnect.continue_payment': 'Lanjutkan Pembayaran',
  'paymentConnect.card_number_label': 'Nomor Kartu',
  'paymentConnect.card_number_required': 'Nomor kartu wajib diisi',
  'paymentConnect.card_number_invalid': 'Nomor kartu tidak valid (12–19 digit)',
  'paymentConnect.card_expiry_label': 'Masa Berlaku',
  'paymentConnect.card_expiry_invalid': 'Isi masa berlaku sebagai MM/YY',
  'paymentConnect.card_exp_month_invalid': 'Bulan tidak valid (01–12)',
  'paymentConnect.card_expired': 'Kartu sudah kedaluwarsa',
  'paymentConnect.card_cvv_label': 'CVV',
  'paymentConnect.card_cvv_required': 'CVV wajib diisi',
  'paymentConnect.card_cvv_invalid': 'CVV harus 3 atau 4 digit angka',
  'paymentConnect.pay_now': 'Bayar Sekarang',
  'paymentConnect.midtrans_client_key_missing':
    'Client key Midtrans belum dikonfigurasi. Atur VITE_MIDTRANS_CLIENT_KEY di environment.',
  'paymentConnect.card_token_timeout':
    'Waktu habis menunggu Midtrans. Periksa koneksi, atau apakah client key cocok dengan environment (sandbox vs production).',
  'paymentConnect.card_token_failed':
    'Gagal mendapatkan token kartu. Periksa data kartu atau coba lagi.',
  'paymentConnect.kartu_kredit': 'Kartu Kredit',
  'paymentConnect.va_bca': 'Virtual Account BCA',
  'paymentConnect.va_bni': 'Virtual Account BNI',
  'paymentConnect.va_mandiri': 'Virtual Account Mandiri',
  'paymentConnect.va_bri': 'Virtual Account BRI',
  'paymentConnect.retail': 'Retail (Alfamart/Indomaret)',
  'paymentConnect.disbursement.title': 'Pencairan',
  'paymentConnect.disbursement.click_to_setup': 'Klik di sini',
  'paymentConnect.disbursement.click_to_setup_suffix': 'untuk mengatur rekening pencairan dana.',
  'paymentConnect.disbursement.funds_will_be_forwarded': 'Dana akan diteruskan ke rekening:',
  'paymentConnect.disbursement.change': 'Ubah',
  'paymentConnect.disbursement.rejected_message': 'Pengajuan Anda ditolak,',
  'paymentConnect.disbursement.rejected_because': 'Pengajuan Anda ditolak karena:',
  'paymentConnect.disbursement.reapply_suffix': 'untuk mengajukan ulang!',
  'paymentConnect.disbursement.pending_message': 'Menunggu proses verifikasi oleh admin.',
  'paymentConnect.disbursement.pending_info':
    'Proses verifikasi membutuhkan waktu paling cepat 1 hari kerja dalam jam operasional.',
  'paymentConnect.disbursement.form_title': 'Rekening Pencairan',
  'paymentConnect.disbursement.form_description':
    'Masukkan rekening tujuan untuk pencairan dana Anda. Pastikan Nama pemilik rekening sama dengan data diri Anda atau perusahaan.',
  'paymentConnect.disbursement.account_info': 'Informasi Rekening',
  'paymentConnect.disbursement.documents': 'Dokumen',
  'paymentConnect.disbursement.bank': 'Bank',
  'paymentConnect.disbursement.account_number': 'Rekening',
  'paymentConnect.disbursement.account_holder_name': 'Nama Pemilik Rekening',
  'paymentConnect.disbursement.whatsapp_number': 'Nomor Whatsapp Penanggung Jawab',
  'paymentConnect.disbursement.whatsapp_help':
    'Pastikan whatsapp dapat dihubungi oleh tim kami untuk verifikasi. Dan nomor whatsapp sama dengan nomor HP akun Anda.',
  'paymentConnect.disbursement.ktp_upload':
    'Foto KTP atau Akta Perusahaan Sesuai Nama Pemilik Rekening',
  'paymentConnect.disbursement.selfie_upload':
    'Foto selfie dengan latar belakang lokasi perusahaan',
  'paymentConnect.disbursement.selfie_help':
    'Pastikan logo perusahaan dan situasi lokasi perusahaan terlihat jelas.',
  'paymentConnect.disbursement.submit_verification': 'Ajukan Verifikasi',
  'paymentConnect.disbursement.success_message_1': 'Terima kasih! Data Anda telah kami terima.',
  'paymentConnect.disbursement.success_message_2':
    'Anda akan mendapatkan informasi pengajuan verifikasi dalam 1 hari kerja melalui WhatsApp.',
  'paymentConnect.disbursement.please_select_bank': 'Silakan pilih bank',
  'paymentConnect.disbursement.please_fill': 'Silakan lengkapi field ini',
  'paymentConnect.disbursement.please_upload_photo': 'Silakan upload foto',
  'paymentConnect.disbursement.digits_only': 'Hanya boleh angka (0–9)',
  'paymentConnect.disbursement.placeholder_account_number': 'Masukkan nomor rekening pencairan',
  'paymentConnect.disbursement.placeholder_account_holder_name': 'Masukkan nama pemilik rekening',
  'paymentConnect.disbursement.placeholder_phone_number':
    'Masukkan nomor WhatsApp penanggung jawab',
  'paymentConnect.disbursement_schedule.label': 'Dana diteruskan setiap',
  'paymentConnect.disbursement_schedule.daily': 'Hari Kerja',
  'paymentConnect.disbursement_schedule.weekly': '1 Minggu pada hari kerja pertama tiap minggu',
  'paymentConnect.disbursement_schedule.monthly': '1 Bulan pada hari kerja pertama tiap bulan',
  'paymentConnect.disbursement_schedule.placeholder': 'Pilih jadwal',
  'paymentConnect.disbursement_schedule.please_select': 'Silakan pilih jadwal penerusan dana',
  'paymentConnect.fee_charge_to.label': 'Biaya dibebankan kepada',
  'paymentConnect.fee_charge_to.customer': 'Pelanggan',
  'paymentConnect.fee_charge_to.seller': 'Penjual',
  'paymentConnect.fee_charge_to.please_select': 'Silakan pilih pihak yang dibebankan biaya',
  'paymentConnect.fee_charge_to.help':
    'Biaya payment gateway akan dibebankan kepada pihak yang dipilih pada setiap transaksi.',
  'paymentConnect.report.invoice_count': 'Jumlah Tagihan',
  'paymentConnect.report.account': 'Rekening',
  'financeContacts.search_on_google_map': 'Cari di Google Map',
  please_fill_the_serial_numbers: 'Silahkah isi nomor Seri / Produksi',
  'report.start_date': 'Tanggal Awal',
  'report.end_date': 'Tanggal Akhir',
  'report.show': 'Tampilkan',
  'report.serial_number_mutation': 'Mutasi Nomor Seri',
  'reports.stock_serial_number_per_warehouse': 'Stok Nomor Seri Per Gudang',
  'reports.inventory_product_serial_stock_detail_title': 'Detil Stok Nomor Seri Per Gudang',
  'users.check_user_quota_availability': 'Cek ketersediaan kuota {title}',
  'businessFlow.duplicate_contact_email': 'Duplikat email kontak',
  'businessFlow.duplicate_contact_email_desc': 'Jika aktif maka email kontak bisa duplikat.',
  'businessFlow.duplicate_contact_name': 'Duplikat nama kontak',
  'businessFlow.duplicate_contact_name_desc': 'Jika aktif maka nama kontak bisa duplikat.',
  fill_the_name: 'Isi {name}',
  the_serial_number_must_be_the_same_as_the_item_quantity:
    'Jumlah serial harus sama dengan kuantitas barang.',
  must_not_exceed_the_available_qty: 'Tidak boleh melebihi dari jumlah yang tersedia',
  'audit.ip_address': 'Alamat IP',
  'audit.enter_ip_address': 'Masukkan alamat IP',
  please_fill_serial_or_production_number: 'Silahkan isi nomor Seri / Produksi',
  serial_or_production_number_is_empty: 'Nomor Seri / Produksi masih kosong',
  setting_serial_or_production_number_sequencial: 'Pengaturan Nomor Seri / Produksi Berurutan',
  fill_serial_number_prefix: 'Masukkan awalan nomor seri',
  prefix: 'Awalan',
  create_serial_or_production_number_sequential_for: 'Buat nomor berurutan sejumlah',
  qty: 'Kuantitas',
  expired: 'Kadaluwarsa',
  preview: 'Hasil',
  serial_or_production_number_not_found: 'Nomor Seri / Produksi tidak ditemukan',
  serial_or_production_number_already_in_use: 'Nomor Seri / Produksi sudah digunakan',
  scan_barcode_or_sku_or_type_then_press_enter: 'Scan Barcode/SKU lalu ketik kemudian [Enter]',
  delete: 'Hapus',
  amount: 'Jumlah',
  add_amount_more: 'Tambahkan {amount} lagi',
  advantages_amount: 'kelebihan {amount}',
  please_select_serial_or_production_number: 'Pilih {value} nomor Seri / Produksi',
  select_serial_or_production_number: 'Pilih nomor Seri / Produksi',
  search: 'Cari',
  stock: 'Stok',
  less_than_amount: 'kurang {amount}',
  setting_serial_or_production_number: 'Pengaturan nomor Seri / Produksi',
  select: 'Pilih',
  'topBar.show_dark_mode': 'Tampilkan mode gelap',
  'topBar.show_light_mode': 'Tampilkan mode terang',
  'financeInvoices.reject_reason_label': 'Silahkan masukkan alasan Anda menolak transaksi',
  please_select_expired_date: 'Silakan pilih tanggal kadaluarsa',
  no_items_have_been_added_yet: 'Belum ada item yang ditambahkan',
  'massDownload.data_progress_processed': '{count} data dari total {total} telah diproses',
  'billing.enter_coupon_code': 'Masukkan Kode Kupon',
  'approval.receive_invoice_payment': 'Terima Pembayaran Tagihan',
  'approval.receive_sales_order_payment': 'Terima DP Pemesanan Penjualan',
  'approval.purchase_payment': 'Pembayaran Pembelian',
  'approval.purchase_order_payment': 'Pembayaran DP Pemesanan Pembelian',
  'financeInvoices.detail_something': 'Detail {something}',
  'financeInvoices.logistic': 'Logistik',
  'financeInvoices.location': 'Lokasi',
  select_transaction_status: 'Pilih status transaksi',
  'placeholder.attachment': 'Pilih Attachment',
  'option.with_attachment': 'Punya Attachment',
  'option.without_attachment': 'Tanpa Attachment',
  'placeholder.attachment_photo': 'Pilih Foto',
  'option.with_attachment_photo': 'Punya Foto',
  'option.without_attachment_photo': 'Tanpa Foto',
  'title.attachment_photo': 'Foto',
  'layoutInvoice.show_transaction_fee': 'Tampilkan Biaya Transaksi',
  'layoutInvoice.show_transaction_fee_details': 'Tampilkan Detail Biaya Transaksi',
  'massPrint.data_progress_processed': '{count} data dari total {total} telah diproses',
  'massPrint.mass_print': 'Cetak Massal',
  'pos.table_list': 'Daftar Meja',
  'pos.add_table': 'Tambah Meja',
  'pos.example_table_index': 'Contoh: Meja {index}',
  'pos.floor_name': 'Nama Lantai',
  'pos.add_floor': 'Tambah Lantai',
  'pos.edit_floor': 'Ubah {floorName}',
  'pos.floor_list': 'Daftar Lantai',
  'pos.floor': 'Lantai',
  'pos.maximum_guests': 'Maksimal Tamu',
  'pos.total_table': 'Total Meja',
  'pos.minimum_guests': 'Minimal Jumlah Tamu 1',
  'pos.outlet_name': 'Nama Outlet',
  'pos.shift_id': 'ID Shift',
  'pos.are_you_sure_to_delete_room': 'Apakah anda yakin menghapus {roomName} ini?',
  select_status: 'Pilih status',
  revert_count_reconciliation: 'Batalkan {count} Rekonsiliasi',
  reload_window: 'Muat ulang halaman',
  welcome_to_company: 'Selamat datang di {value}',
  thankyou_you_have_successfully_joined_to_company:
    'Terimakasih, Anda berhasil bergabung di {value}',
  please_click_next_to_start_the_application:
    'Silahkan klik lanjut, untuk mulai menggunakan aplikasi',
  'uploadImage.image_with_title': 'Gambar {title}',
  'uploadImage.show_image_with_title': 'Tampilkan Gambar {title}',
  'uploadImage.hide_image_with_title': 'Sembunyikan Gambar {title}',
  'reports.serial_number_history': 'Histori Nomor Seri',
  'reports.no_stock_details_transaction': 'No. Transaksi Rincian Stok',
  'reports.products_with_expiration_dates': 'Produk dengan tanggal kedaluwarsa',
  'financeInvoices.this_customer': '{customer} Ini',
  'financeInvoices.all_customer': 'Seluruh {customer}',
  'financeInvoices.customer_name': 'Nama {customer}',
  'financeInvoices.sales_price_history': 'Riwayat Harga Jual',
  'financeInvoices.sales_price_history_of_all_customers': 'Riwayat Harga Jual Seluruh {customer}',
  'financeInvoices.something_has_been_applied': '{something} telah diterapkan',
  'financeBanks.total_of_selected_rows_reconcile': 'total nominal rekonsiliasi : {count}',
  'financePurchaseInvoices.transaction_date_must_be_gt_date':
    'Tgl Transaksi harus lebih dari {date}',
  'financeInvoices.failed_to_get_sales_price_history':
    'Gagal mendapatkan riwayat harga jual terakhir',
  'report.create_data': 'Buat Data',
  'report.change_data': 'Ubah Data',
  'report.delete_data': 'Hapus Data',
  'report.data_change': 'Perubahan Data',
  'report.data_change_activity': 'Aktivitas Perubahan Data',
  'report.last_month_login_day': 'Hari Login Bulan Lalu',
  'report.number_of_team_members_login': 'Jumlah Anggota Tim Login',
  'report.new': 'Baru',
  'report.change': 'Perubahan',
  'report.actions_taken_by_the_team': 'Aksi yang dilakukan tim',
  'report.action_name': 'Nama Aksi',
  'report.total_action': 'Total Aksi',
  'report.times': 'kali',
  'report.team_activities': 'Aktivitas Tim',
  'report.activity_per_transaction': 'Aktivitas per Transaksi',
  'report.activity_per_transaction_desc':
    'Ringkasan aktivitas input transaksi tiap anggota tim pada periode terpilih',
  'report.menu': 'Menu',
  'report.member_name': 'Nama Anggota',
  'report.login_count': 'Jumlah Login',
  'report.activity_count': 'Total Aktivitas',
  'report.create_count': 'Dibuat',
  'report.update_count': 'Diubah',
  'report.delete_count': 'Dihapus',
  'report.activity_percentage': 'Persentase',
  'report.all_menu': 'Semua Menu',
  'report.menu_sales': 'Penjualan',
  'report.menu_purchase': 'Pembelian',
  'report.menu_expense': 'Biaya',
  'financePurchaseInvoices.recurring_purchase_invoice': 'Tagihan Pembelian Berulang',
  'financePurchaseInvoices.1_download_your_purchase_invoices_recurring_template_file':
    '1. Download file template tagihan pembelian berulang',
  'financePurchaseInvoices.start_by_downloading_our_purchase_invoices_recurring_csv':
    'Mulai dengan mengunduh file template Excel tagihan pembelian berulang. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari tagihan-tagihan pembelian berulangmu.',
  'financePurchaseInvoices.2_copy_your_invoices_purchase_recurring_into_the_template':
    '2. Salin detail tagihan pembelian berulang ke dalam template',
  'financePurchaseInvoices.purchase_invoice_recurring_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail tagihan pembelian berulang ke dalam file template dari Kledo. Pastikan detail tagihan pembelian berulang sesuai dengan kolom header yang ada di template.',
  'financeWarehouse.upload_photo': 'Unggah Gambar Gudang Anda',
  'financeWarehouse.upload_photo_maxsize': '(Maks Ukuran Attachment 10 MB)',
  'billing.term_and_conditions':
    'Dengan klik tombol di atas, Anda setuju dengan {termOfUse} kami dan mengonfirmasi bahwa Anda telah membaca {privacyPolicy} kami.',
  'billing.terms_of_use': 'Ketentuan Penggunaan',
  'billing.privacy_policy': 'Kebijakan Privasi',
  'report.mass_export': 'Ekspor Massal',
  'massExport.data_has_been_exported': 'Total {count} data telah berhasil diekspor',
  'massExport.its_ok_to_close_this_process':
    'Eskpor sedang diproses, Anda dapat meninggalkan halaman ini. Setelah proses ekspor selesai, kami akan mengirimkan notifikasi melalui email. Anda juga dapat memantau status ekspor melalui halaman laporan ekspor {here}.',
  'massExport.cannot_mass_export': 'Tidak dapat mengekspor massal',
  'massExport.part': 'Sebagian',
  'massExport.data_progress_exported': '{count} data dari total {total} telah terekspor',
  'massExport.retrieving_the_necessary_data': 'Sedang mengambil data yang diperlukan',
  'financeProduct.all_row': 'Semua Baris',
  'financeBanks.manual_get_data': 'Ambil Data Manual',
  'button.get_data': 'Ambil data',
  'financeBanks.schedule_get_data': 'Jadwal Pengambilan Mutasi',
  'users.login_with_facebook': 'Masuk dengan Facebook',
  'warehouses.avg_cogs': 'Rata-Rata HPP',
  'pos.table_name_is_already_in_use': '{tableName} sudah digunakan.',
  each_stock_items_has_a_unique_serial_number_for_example_cellphones_have_a_unique_imei_number_for_each_item:
    'Tiap 1 stok barang, mempunyai nomor seri yang unik. Misalnya handphone, mempunyai nomor IMEI unik tiap barangnya.',
  the_same_serial_number_can_be_owned_by_more_than_1_product_stock_for_example_products_produced_by_factory_in_the_same_batch_are_given_the_same_production_number:
    'Nomor seri yang sama dapat dimiliki oleh lebih dari 1 stok produk. Misalnya produk yang dihasilkan oleh pabrik dalam 1 batch yang sama, diberikan nomor produksi yang sama.',
  production_code_that_has_an_expiration_date_for_example_for_medical_products_or_food_products:
    'Kode produksi yang memiliki tanggal kadaluarsa. Misalnya untuk produk obat atau produk makanan.',
  this_product_has_a_serial_number_or_production_number:
    'Produk ini mempunyai nomor seri / nomor produksi',
  enter_value_serial_numbers: 'Masukkan {value} nomor seri',
  issue_value_serial_numbers: 'Keluarkan {value} nomor seri',
  value_serial_numbers: '{value} nomor seri',
  list_serial_numbers: 'Daftar nomor seri',
  scan_barcode_or_type: 'Scan Barcode',
  automatic_sequence: 'Otomatis',
  take_from_existing_data: 'Pilih Serial',
  please_add: 'Tambahkan',
  excees_value_serial_numbers: 'Kelebihan {value} nomor seri',
  a_total_of_value_serial_numbers_match: 'Total {value} nomor seri sudah sesuai',
  there_are_still_value_serial_numbers_missing: 'Masih kurang {value} nomor seri lagi',
  value_serial_numbers_are_selected: '{value} nomor seri dipilih',
  must_be_an_integer: 'Harus bilangan bulat',
  serial_numbers: 'Nomor Seri',
  custom_fields: 'Custom Fields',
  please_fill_serial_or_production_number_template: 'Silahkan masukkan awalan nomor seri',
  no_results_displayed: 'Tidak hasil yang ditampilkan',
  please_fill_number_of_sequences: 'Silahkan masukkan jumlah urutan',
  export_bank_successfully: 'Berhasil expor {value}',
  'report.diff_qty_help': 'Selisih kuantitas bahan baku dan barang jadi',
  'roles.start_time_must_be_before_end_time': 'Waktu awal harus sebelum waktu akhir',
  'roles.end_time_must_be_after_start_time': 'Waktu akhir harus setelah waktu awal',
  'roles.custom_options_require_minimum_1_active_day':
    'Opsi custom membutuhkan minimal 1 hari aktif',
  'financeWareHouses.approval_status': 'Status Approval',
  'report.production_amount_help': 'Nilai produksi = HPP x kuantitas',
  'report.production_value': 'Nilai Produksi',
  'report.production_raw_material_chart_title': 'Bahan Baku Paling Sering Dipakai',
  'report.production_raw_material_chart_showing': 'Menampilkan {count} dari {total} bahan baku',
  'report.production_raw_material_chart_frequency': 'Frekuensi: {count}x',
  'report.production_raw_material_chart_usage': 'Jumlah pemakaian: {qty}',
  'report.production_raw_material_chart_empty':
    'Belum ada bahan baku yang dipakai pada periode ini.',
  'report.production_audit.qty_result': 'Qty Hasil',
  'report.production_audit.qty_formula': 'Qty Formula',
  'report.production_audit.qty_actual': 'Qty Aktual',
  'report.production_audit.status.sesuai': 'Sesuai',
  'report.production_audit.status.kurang': 'Kurang',
  'report.production_audit.status.lebih': 'Lebih',
  'billing.addon_stamp_description': 'Bubuhkan E-Meterai ke transaksimu',
  'billing.stamp': 'Meterai',
  'financeInvoices.stamp': 'E-Meterai',
  'stamp.billing_title': 'Billing E-Meterai',
  'stamp.balance': 'Saldo E-Meterai',
  'stamp.yes': 'Ya',
  'stamp.no': 'Tidak',
  'stamp.affix_description':
    'Yuk bubuhkan E-meterai ke dokumen {value} dalam satu klik! E-meterai telah dijamin legalitasnya berdasarkan Undang Undang No.10 Tahun 2020.',
  'stamp.zero_quota_description':
    'Tak perlu repot lagi menempelkan manual meterai pada dokumen. Cukup dengan E-meterai, dan legalitas telah dijamin Undang Undang!',
  'stamp.add_stamp_quota_description':
    'Yuk tambahkan saldo E-meterai mu terlebih dahulu, supaya dapat mulai membubuhkan E-meterai pada tagihanmu',
  'stamp.total_billing': 'Total Tagihan',
  'stamp.user': 'Pembubuh',
  'stamp.document': 'Dokumen',
  'stamp.affix_stamp': 'Bubuhkan E-Meterai',
  'stamp.stamped': 'Bermaterai',
  'stamp.affix': 'Bubuhkan',
  'stamp.add_stamp_balance': 'Tambah Saldo E-meterai',
  'stamp.sheets': 'Lembar',
  'stamp.your_stamp_quota': 'Kuota E-meterai Anda',
  'stamp.bill_preview': 'Preview {value}',
  'stamp.balance_left': 'Sisa Saldo',
  'stamp.amount': 'Jumlah',
  'stamp.description': 'Deskripsi',
  'stamp.date': 'Tanggal',
  'stamp.confirm_message':
    'Apakah Anda membubuhkan E-meterai pada dokumen {value}? Pembubuhan E-meterai akan mengurangi saldo, dan tidak dapat dibatalkan.',
  'stamp.cancel': 'Batal',
  'stamp.usage': 'Penggunaan',
  'stamp.add_balance': 'Tambah Saldo',
  'stamp.loading_document': 'Memuat dokumen...',
  'stamp.drag_help_text': 'Seret untuk mengubah posisi e-meterai',
  'stamp.drag_text':
    'Mohon pastikan e-Meterai tidak menutupi tanda tangan. Letakkan di sisi tanda tangan untuk keabsahan dokumen',
  'stamp.page': 'Halaman {page} dari {total}',
  'stamp.print_confirm_title': 'Cetak dokumen',
  'stamp.print_confirm_message':
    'E-meterai berhasil dibubuhkan pada dokumen {value}. Cetak dokumen sekarang?',
  'stamp.select_user': 'Pilih Pembubuh',
  'stamp.progress_starting': 'Menyiapkan pembubuhan...',
  'stamp.progress_milestone_queued': 'Antrean diterima',
  'stamp.progress_milestone_document': 'Menyiapkan dokumen',
  'stamp.progress_milestone_serial': 'Menerbitkan meterai',
  'stamp.progress_milestone_signed': 'Membubuhkan meterai',
  'stamp.progress_milestone_uploaded': 'Mengunggah dokumen',
  'stamp.progress_milestone_complete': 'Selesai',
  'stamp.progress_waiting_peruri': 'Menunggu Peruri...',
  'stamp.progress_waiting_peruri_note': 'Menunggu penerbitan dari Peruri, mohon tunggu…',
  'stamp.progress_failed_title': 'Pembubuhan gagal.',
  'stamp.retry': 'Coba lagi',
  'stamp.result_opened_new_tab': 'PDF bermaterai dibuka di tab baru.',
  'stamp.result_title': 'Pembubuhan berhasil',
  'stamp.result_success_title': 'Meterai berhasil dibubuhkan',
  'stamp.open_result_pdf': 'Buka PDF',
  'reporting.warehouse_transfer_report.total_price': 'Total Harga Produk',
  'reporting.warehouse_transfer_report.total_price.tooltip': 'Harga jual produk dikali kuantitas.',
  please_select_serial_or_production_number_type: 'Silahkan pilih tipe Nomor Seri / Produksi',
  no_value_number_has_selected_yet: 'Belum ada {value} yang dipilih',
  'audit.reload': 'Muat Ulang',
  'layoutInvoice.document_receipt': 'Tanda Terima Dokumen',
  'layoutInvoice.document_receipt_show_logo': 'Tampilkan logo',
  'layoutInvoice.document_receipt_show_company_information': 'Tampilkan informasi perusahaan',
  'layoutInvoice.document_receipt_show_detail_table': 'Tampilkan Tabel Detail',
  'layoutInvoice.document_receipt_show_detail_no': 'Tampilkan No',
  'layoutInvoice.document_receipt_show_detail_invoice_date': 'Tampilkan Tanggal Invoice',
  'layoutInvoice.document_receipt_show_detail_invoice_number': 'Tampilkan Nomor Invoice',
  'layoutInvoice.document_receipt_show_detail_sale_price': 'Tampilkan Harga Jual',
  'layoutInvoice.document_receipt_show_detail_ppn': 'Tampilkan PPN',
  'layoutInvoice.document_receipt_show_detail_amount': 'Tampilkan Jumlah',
  'layoutInvoice.document_receipt_detail_no': 'No',
  'layoutInvoice.document_receipt_detail_invoice_date': 'Tanggal Invoice',
  'layoutInvoice.document_receipt_detail_invoice_number': 'Nomor Invoice',
  'layoutInvoice.document_receipt_detail_sale_price': 'Harga Jual',
  'layoutInvoice.document_receipt_detail_ppn': 'PPN',
  'layoutInvoice.document_receipt_detail_amount': 'Jumlah',
  'layoutInvoice.print_document_receipt': 'Cetak Tanda Terima Dokumen',
  'layoutInvoice.hide_checklist': 'Sembunyikan Checklist',
  'financeInvoices.received': 'Telah Terima',
  'financeInvoices.order_number': 'Nomor Order',
  'financeInvoices.tax_number': 'Nomor Pajak',
  'kledoPos.setting_default_open_shift_account_id': 'Default Akun Buka Kasir',
  'kledoPos.setting_default_open_shift_account_id_desc':
    'Saat melakukan buka kasir POS, maka di akunting akan dicatatkan pada akun COA ini.',
  'kledoPos.setting_default_close_shift_account_id': 'Default Akun Tutup Kasir',
  'kledoPos.setting_default_close_shift_account_id_desc':
    'Saat melakukan tutup kasir POS, maka di akunting akan dicatatkan pada akun COA ini.',
  'invoice_layout.invoice_lang_account_code_and_name': 'Kode & Nama Akun',
  'layoutInvoice.show_coa_in_description': 'Tampilkan COA di Deskripsi',
  'businessFlow.show_available_stock_when_making_a_purchase':
    'Tampilkan stok tersedia saat membuat pembelian',
  'businessFlow.show_available_stock_when_making_a_purchase_desc':
    'Apakah stok yang ada di gudang perlu ditampilkan saat membuat pembelian?',
  'businessFlow.fixed_asset_depreciation_on': 'Default Tanpa Penyusutan Nonaktif',
  'businessFlow.fixed_asset_depreciation_on_desc': 'Apakah default tanpa penyusutan nonaktif?',
  'report.comparison_date': 'Tanggal Pembanding',
  'businessFlow.warehouse_transfer_items_description':
    'Tampilkan deskripsi produk di {warehouseTransfer}',
  'businessFlow.warehouse_transfer_items_description_desc':
    'Apakah deskripsi produk ditampilkan di {warehouseTransfer}?',
  'businessFlow.split_in_out_reporting_warehouse_transfer':
    'Pisahkan print laporan transfer gudang masuk & keluar',
  'businessFlow.split_in_out_reporting_warehouse_transfer_desc':
    'Apakah print laporan transfer gudang dipisah menjadi transaksi masuk dan keluar?',
  'businessFlow.material_module_enabled': 'Aktifkan modul Permintaan & Pengeluaran Barang',
  'businessFlow.material_module_enabled_desc':
    'Jika ya, menu Permintaan Barang dan Pengeluaran Barang aktif dan bisa digunakan',
  'businessFlow.material_request_create_as_draft': 'Simpan Permintaan Barang sebagai draf',
  'businessFlow.material_request_create_as_draft_desc':
    'Jika ya, Permintaan Barang baru dibuat berstatus draf dan perlu diajukan dulu sebelum diproses',
  'menu.warehouses': 'Gudang',
  'menu.material_requests': 'Permintaan Material',
  'menu.purchase_requests': 'Permintaan Pembelian',
  'menu.material_issues': 'Pengeluaran Material',
  'menu.other_apps': 'Aplikasi Lainnya',
  'menu.sidebar_apps_saved': 'Pengaturan menu aplikasi pada sidebar berhasil disimpan.',
  'menu.sidebar_apps_move_group': 'Pindahkan ke Aplikasi Lainnya',
  'menu.sidebar_apps_show_main': 'Tampilkan di menu utama',
  'menu.search_placeholder': 'Cari menu',
  'financeInvoices.sales_person_required': '{sales_person} wajib diisi',
  'businessFlow.required_sales_person': '{sales_person} wajib diisi',
  'businessFlow.required_sales_person_desc':
    'Apakah {sales_person} wajib diisi saat menambahkan transaksi penjualan?',
  'businessFlow.show_conversion_variance':
    'Tampilkan selisih bahan baku dan produk jadi pada konversi produk',
  'businessFlow.show_conversion_variance_desc':
    'Pada halaman konversi produk, apakah selisih jumlah dari bahan baku dan produk jadi ditampilkan?',
  'businessFlow.product_conversion_show_qty_multiplier':
    'Tampilkan kolom Pengali pada Konversi Produk',
  'businessFlow.product_conversion_show_qty_multiplier_desc':
    'Apakah kolom pengali ditampilkan pada konversi produk?',
  'financeWareHouses.product_description': 'Deskripsi Produk',
  'report.noPO': 'Nomor PO',
  'report.total_qty': 'Total Qty',
  'report.total_price_after_discount': 'Total Harga Setelah Diskon',
  item_description: 'Deskripsi Item',
  'financeTag.alphanumeric_and_this_regex_allowed':
    'Hanya huruf, angka dan _ @ . / # & + - yang diperkenankan.',
  'businessFlow.invoice_locked_discount': 'Kunci Diskon Produk',
  'businessFlow.invoice_locked_discount_desc': 'Apakah diskon produk di penjualan akan dikunci?',
  'layoutInvoice.alternative_invoice': 'Faktur Penjualan Alternatif',
  'layoutInvoice.use_invoice_alternative_layout': 'Aktifkan layout alternatif',
  'layoutInvoice.updating_option_loading': 'Mengubah opsi...',
  'financeInvoices.print_invoice_alternative': 'Faktur Alternatif',
  please_adjust_user_permissions_based_on_their_role:
    'Silahkan sesuaikan hak akses pengguna berdasarkan perannya',
  pos_user_permissions: 'Hak Akses Pengguna POS',
  manage_pos_user_permissions: 'Atur Hak Akses Pengguna POS',
  'report.reference_number': 'Nomor {reference}',
  'approval.approval_status': 'Status Approval',
  'layoutInvoice.paper_size': 'Ukuran Kertas',
  'businessFlow.invoice_user_maximum_receivables': 'Batasi maksimal piutang per {salesPerson}',
  'businessFlow.invoice_user_maximum_receivables_desc':
    'Tolak penjualan jika piutang dari {salesPerson} melebihi batas.',
  'businessFlow.default_value_maximum_receivable': 'Default Batas untuk semua {salesPerson}',
  'businessFlow.limit_per_sales_person': 'Batas per {salesPerson}',
  'financeProduct.total_product_value': 'Total Nilai {product}',
  'financeProduct.inventory_journal': 'Jurnal Persediaan',
  'financeProduct.total_inventory_journal': 'Total Jurnal Persediaan',
  'financeProduct.non_stock_journal': 'Jurnal Non Stok',
  'financeProduct.active_product_value': 'Nilai {product} Aktif',
  'financeProduct.archive_product_value': 'Nilai {product} Arsip',
  'financeProduct.inventory_journal_from_non_stock_transactions':
    'Jurnal Persediaan dari Transaksi Non Stok',
  'financeProduct.total_inventory_journal_from_non_stock_transactions':
    'Total Jurnal Persediaan dari Transaksi Non Stok',
  'financeProduct.stock_adjustment_with_inventory_account':
    '{stockAdjustment} dengan Akun Persediaan',
  'financeProduct.total_product_value_details': 'Detail Total Nilai {product}',
  'priceRule.follow_these_steps_to_import_your_price_rule':
    'Ikuti langkah-langkah berikut untuk mengimport aturan hargamu',
  'priceRule.1_download_your_price_rule_template_file': '1. Download file template aturan harga',
  'priceRule.start_by_downloading_our_price_rule_csv':
    'Mulai dengan mengunduh file template Excel aturan harga. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari aturan harga-mu.',
  'priceRule.2_copy_your_price_rule_into_the_template':
    '2. Salin detail aturan harga ke dalam template',
  'priceRule.a_maximum_of_1000_price_rule_can_be_imported_at_a_time':
    'Maksimal 1.000 aturan harga dapat diimport dalam satu waktu.',
  'import.upload_file': 'Upload File',
  'import.check_the_imported_data': 'Cek Data',
  'import.import_done': 'Import Berhasil',
  'import.import_in_progress': 'Import sedang berlangsung',
  'import.please_check_the_imported_data': 'Silakan cek data yang diimport',
  'import.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'Jika data yang diimport sesuai dengan yang kamu harapkan, silakan klik tombol "Import Sekarang".',
  'import.valid': 'Valid',
  'import.invalid': 'Invalid',
  'import.total': 'Total',
  'import.import_now': 'Import Sekarang',
  'import.view_detail': 'Tampilkan detil',
  'import.success': 'Berhasil',
  'import.failed': 'Gagal',
  'import.import_another_file': 'Import file lain',
  'import.import_is_still_in_progress': 'Import sedang berlangsung',
  'import.its_ok_to_close_this_page':
    'Tidak apa-apa untuk menutup halaman ini atau mengimport file lain. Ketika import selesai, Anda akan diberitahu melalui email.',
  'import.row_imported': '{imported} dari {total} baris diproses',
  'import.download_template_file': 'Download File Template',
  'import.important': 'PENTING',
  'import.3_upload_the_updated_template_file_here':
    '3. Upload template yang sudah diupdate ke sini',
  'import.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Simpan file template yang sudah diupdate',
  'import.import_actions_only_insert_new_data_cannot_update_or_delete':
    'Saat meng-import, Kledo hanya akan memasukkan data baru, tidak ada data yang dihapus atau diupdate.',
  'import.dont_change_the_column_heading_in_the_template_file':
    'Jangan mengubah header kolom di dalam template. Ini dibutuhkan agar import dapat berjalan.',
  'priceRule.price_rule_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail aturan harga ke dalam file template dari Kledo. Pastikan detail aturan harga sesuai dengan kolom header yang ada di template.',
  'priceRule.import_price_rule': 'Import Aturan Harga',
  'priceRule.percent': 'Persen',
  'priceRule.purchase_type_minimum_type': 'Tipe Minimal Pembelian Harga',
  'priceRule.discount_type': 'Tipe Diskon',
  'priceRule.does_it_last_forever': 'Apakah Berlaku Selamanya?',
  'priceRule.customer_type': 'Tipe Pelanggan',
  'priceRule.go_to_price_rule_list': 'Ke halaman daftar aturan harga',
  'priceRule.price_rule_successfully_imported': '{rowCount} baris aturan harga berhasil diimport.',
  'layoutInvoice.invoice_show_empty_qty': 'Tampilkan Produk dengan Kuantitas 0',
  'businessFlow.input_reference_is_required': '{reference} wajib diisi',
  'businessFlow.sales_input_reference_is_required_desc':
    'Apakah {reference} wajib diisi saat menambahkan transaksi {sales}?',
  'businessFlow.expense_pay_later_required': 'Default Bayar Nanti Aktif',
  'businessFlow.expense_pay_later_required_desc': 'Apakah default bayar nanti di biaya aktif?',
  'businessFlow.purchase_input_reference_is_required_desc':
    'Apakah {reference} wajib diisi saat menambahkan transaksi {purchases}?',
  'businessFlow.expense_input_reference_is_required_desc':
    'Apakah {reference} wajib diisi saat menambahkan {expenses}?',
  'financeExpenses.reference_is_required': '{reference} wajib diisi',
  'financePurchaseInvoices.purchase_price_history': 'Riwayat Harga Beli',
  'financePurchaseInvoices.purchase_price_history_of_all_vendors':
    'Riwayat Harga Beli Seluruh {vendors}',
  'financePurchaseInvoices.this_vendor_purchase_price': 'Harga beli {vendor} ini',
  'financePurchaseInvoices.last_purchase_price': 'Harga beli terakhir',
  'financePurchaseInvoices.this_vendor': '{vendor} Ini',
  'financePurchaseInvoices.all_vendors': 'Seluruh {vendors}',
  'financePurchaseInvoices.failed_to_get_buy_price_history':
    'Gagal mendapatkan riwayat harga beli terakhir',
  'financeContacts.default_term': 'Default termin',
  data_exported_successfully: 'Data berhasil diexpor',
  'import.download_template_data_example_file': 'Download File Contoh',
  'financeTag.follow_these_steps_to_import_your_tags':
    'Ikuti langkah-langkah berikut untuk meng-import {tags}',
  'financeTag.1_download_your_tag_template_file': '1. Download file template {tag}',
  'financeTag.start_by_downloading_our_tags_csv':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari {tags}-mu.',
  'financeTag.2_copy_your_tags_into_the_template': '2. Salin detail {tags} ke dalam template',
  'financeTag.using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail {tag} ke dalam file template dari Kledo. Pastikan detail {tag} sesuai dengan kolom header yang ada di template.',
  'financeTag.import_benefit_with_update':
    'Kamu juga dapat menggunakan file yang sudah diimport untuk mengupdate semua {tags}mu, menghemat waktu dan tenaga daripada mengupdate {tags} satu persatu melalui browser.',
  'financeTag.a_maximum_of_1000_tags_can_be_imported_at_a_time':
    'Maksimal 1.000 {tags} dapat diimport dalam satu waktu.',
  'financeTag.warning_update_tag_using_import':
    'Proses import akan menggunakan Nama {tag} untuk menentukan apakah suatu {tag} sudah ada di Kledo atau belum, jika {tag} sudah ada maka {tag} akan diupdate, sedangkan jika {tag} belum ada maka akan dibuat {tag} baru. {tag} tidak akan dihapus, sehingga kamu bisa dengan aman mengupdate sebagian {tag} mu saja tanpa khawatir akan kehilangan data di {tag} yang lain.',
  'financeTag.go_to_tag_list': 'Ke halaman daftar {tag}',
  'financeTag.tags_successfully_imported': '{rowCount} baris {tags} berhasil diimport.',
  'financeTag.color': 'Warna',
  'layoutInvoice.show_tax_percentage': 'Tampilkan Persentase Pajak',
  'businessFlow.invoice_multi_currency_manual_input_required': 'Multi Mata Uang manual wajib diisi',
  'businessFlow.invoice_multi_currency_manual_input_required_desc':
    'Apakah Multi Mata Uang manual wajib diisi saat menambahkan transaksi penjualan?',
  please_input_manual_multi_currency: 'Silahkan masukkan mata uang manual',
  'businessFlow.invoice_allow_negative_stock_movement':
    'Perbolehkan tambah transaksi yang selalu mengurangi stok',
  'businessFlow.invoice_allow_negative_stock_movement_desc':
    'Apakah diperbolehkan jika beberapa transaksi terakhir selalu mengurangi stok {product}?\nTidak direkomendasikan untuk diperbolehkan, karena akan menyebabkan stok produk menjadi minus.',
  'financePurchaseInvoices.follow_these_steps_to_import_your_purchase_return':
    'Ikuti langkah berikut untuk mengimport retur pembelian Anda',
  'financePurchaseInvoices.1_download_your_purchase_return_template_file':
    '1. Download file template retur pembelian',
  'financePurchaseInvoices.start_by_downloading_our_purchase_return_csv':
    'Mulai dengan mengunduh file template Excel retur pembelian. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari retur pembelian Anda.',
  'financePurchaseInvoices.2_copy_your_purchase_return_into_the_template':
    '2. Salin detail retur pembelian ke dalam template',
  'financePurchaseInvoices.purchase_return_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail retur pembelian ke dalam file template dari Kledo. Pastikan detail retur pembelian sesuai dengan kolom header yang ada di template.',
  'financePurchaseInvoices.a_maximum_of_1000_purchase_returns_can_be_imported_at_a_time':
    'Satu kali proses impor mendukung hingga 3.000 baris data Excel. Setiap baris dihitung, termasuk baris tagihan pembelian maupun item.',
  'layoutInvoice.invoice_use_termin_as_amount_in_word':
    'Tampilkan Nilai Terbilang dari Nilai Tagihan Termin',
  'layoutInvoice.only_valid_for_printed_terms': 'Hanya berlaku untuk cetak termin',
  'report.export_summary': 'Ekspor Ringkasan',
  'report.export_per_sales_person': 'Ekspor Per {salesPerson}',
  'report.please_select_a_sales_person': 'Silahkan pilih {salesPerson}',
  'kledoPos.settings_title': 'Pengaturan',
  'kledoPos.settings_driver_online': 'Ojek Online',
  'kledoPos.add_online_driver': 'Tambah Ojek Online',
  'kledoPos.edit_online_driver': 'Ubah Ojek Online',
  'kledoPos.discounted_product_with_title': '{product} yang didiskon',
  'kledoPos.markup_product_with_title': '{product} yang dimarkup',
  'kledoPos.outlet_required': 'Outlet wajib diisi',
  'kledoPos.ojol_placeholder': 'Nama Ojek Online',
  'kledoPos.outlet': 'Outlet',
  'kledoPos.outlet_placeholder': 'Pilih Outlet',
  'kledoPos.price': 'Harga',
  'kledoPos.markup': 'Markup',
  'kledoPos.discount': 'Diskon',
  'kledoPos.name': 'Nama',
  'kledoPos.price_type': 'Tipe Harga',
  'kledoPos.nominal': 'Nominal',
  'kledoPos.outlets': 'Outlet',
  'kledoPos.products': 'Produk',
  'kledoPos.setting_pos': 'Pengaturan POS',
  'kledoPos.setting_pos_desc': 'Atur sistem POS untuk mendukung bisnis Anda.',
  'kledoPos.setting_ojol': 'Ojek Online',
  'kledoPos.setting_ojol_desc': 'Sesuaikan layanan Ojol sesuai kebutuhan bisnis Anda.',
  'kledoPos.label_applies': 'Berlaku Pada {subject} POS Berikut',
  'kledoPos.markup_': 'markup',
  'kledoPos.discount_': 'diskon',
  'kledoPos.free_reward_item': 'Gratis — {name}',
  'kledoPos.ojek_online': 'Ojek Online',
  'priceRule.per_desc': '{subject} yang akan mendapatkan {priceType} harga',
  'kledoPos.discounted': 'diskon',
  'kledoPos.outlet_product_label': 'Produk yang ditampilkan pada outlet ini',
  'kledoPos.outlet_product_category': 'Kategori Produk',
  'kledoPos.outlet_per_product': 'Per Produk',
  'kledoPos.outlet_info_title': 'Informasi Outlet',
  'kledoPos.outlet_users_desc': 'Pengguna yang bisa masuk ke POS di outlet ini.',
  'kledoPos.outlet_product_desc': 'Tentukan {product} mana yang tampil di POS outlet ini.',
  'kledoPos.outlet_price_title': 'Harga di Outlet',
  'kledoPos.outlet_price_desc':
    'Markup atau diskon ini langsung mengubah harga jual {product} di POS, tidak tampil sebagai promo.',
  'kledoPos.outlet_price_remove_warning':
    '{count} harga khusus per kategori/{product} akan dihapus saat Anda menyimpan dengan pilihan ini.',
  'kledoPos.outlet_price_other_product_rows':
    '{count} harga per {product} juga tersimpan dan lebih diutamakan daripada harga kategori.',
  'kledoPos.outlet_price_other_category_rows':
    '{count} harga per kategori juga tersimpan dan berlaku untuk {product} yang tidak punya harga sendiri.',
  'kledoPos.outlet_price_archived': 'Diarsipkan',
  'kledoPos.outlet_price_serial_not_allowed':
    '{product} dengan nomor seri tidak bisa diberi harga khusus outlet.',
  'kledoPos.outlet_price_min_one': 'Tambahkan minimal 1 harga khusus.',
  'kledoPos.outlet_price_empty_category':
    'Belum ada kategori. Pilih kategori untuk memberi markup atau diskon.',
  'kledoPos.outlet_price_empty_product':
    'Belum ada {product}. Pilih {product} untuk memberi markup atau diskon.',
  'kledoPos.outlet_shown_empty_category':
    'Belum ada kategori. Pilih kategori yang ditampilkan di POS outlet ini.',
  'kledoPos.outlet_shown_empty_product':
    'Belum ada {product}. Pilih {product} yang ditampilkan di POS outlet ini.',
  'kledoPos.outlet_photo_title': 'Foto Outlet',
  'kledoPos.outlet_photo_upload': 'Unggah foto',
  'kledoPos.outlet_photo_change': 'Ganti foto',
  'kledoPos.outlet_photo_hint':
    'Klik atau seret file ke kotak. JPG/PNG, maks. {size} MB, maks. {width} × {height} px.',
  'kledoPos.outlet_users_count': '{count} orang',
  'kledoPos.outlet_users_empty': 'Belum ada pengguna.',
  'kledoPos.outlet_price_add_category': 'Pilih kategori untuk ditambahkan',
  'kledoPos.outlet_price_add_product': 'Cari {product} untuk ditambahkan',
  'kledoPos.outlet_price_on_pos': 'Harga di POS',
  'kledoPos.outlet_price_category_overridden': '{count} {product} punya harga sendiri',
  'kledoPos.outlet_price_overrides_category': 'menimpa kategori {name}',
  'kledoPos.outlet_save_hint': 'Perubahan harga langsung berlaku di POS setelah disimpan.',
  'kledoPos.outlet_floor_title': 'Lantai & Meja',
  'kledoPos.outlet_floor_desc': 'Atur lantai dan meja yang tersedia di outlet ini.',
  'kledoPos.all_outlet': 'Semua Outlet',
  'kledoPos.all_ojol': 'Semua Ojek Online',
  'kledoPos.all_product': 'Semua Produk',
  'financeFixedAssets.view_total': 'Lihat Total',
  consult_now: 'Konsultasi Sekarang',
  direct_consultation_with_kledo_amazing_team:
    'Konsultasi Langsung Bersama Tim Hebat Kledo. Gabung Live Sekarang!',
  'businessFlow.invoice_order_validation_receivable':
    'Tolak pembuatan pemesanan dan pengiriman jika piutang kontak melebihi batas',
  'businessFlow.invoice_order_validation_receivable_desc':
    'Apakah pemesanan dan pengiriman akan menggunakan batas maksimal piutang kontak?',
  decline_new_sales_if_there_are_still_past_due_bill_that_have_not_been_paid:
    'Tolak penjualan baru jika masih ada tagihan lewat jatuh tempo yang belum dibayar',
  decline_new_sales_if_there_are_still_unpaid_past_due_bills_in_the_selected_contact:
    'Tolak penjualan baru jika masih ada tagihan lewat jatuh tempo yang belum dibayar di kontak yang dipilih?',
  customer_still_has_past_due_bills_unpaid:
    '{customer} masih mempunyai tagihan lewat jatuh tempo belum dibayar, {link} untuk melihat detail!',
  'layoutInvoice.order_alternative': 'Order Alternatif',
  'report.subtotal_value': 'Subtotal Nilai',
  'report.total_value': 'Total Nilai',
  'report.total_avg_base_price_product': 'Total HPP {product}',
  'page404.data_you_accessed_has_been_deleted_or_does_not_exist_at_all':
    'Data yang Anda akses telah dihapus atau tidak ada sama sekali',
  'financeWarehouses.qty_serial_or_production_number': 'Qty Nomor Seri / Produksi',
  with_serial: 'Punya Nomor Seri',
  without_serial: 'Tanpa Nomor Seri',
  with_modifier: 'Punya Ekstra',
  without_modifier: 'Tanpa Ekstra',
  with_serial_unique: 'Punya Nomor Seri Unik',
  with_serial_production: 'Punya Nomor Seri Produksi',
  with_expiry_date: 'Punya Tanggal Kadaluwarsa',
  manage_expiry_date: 'Tanggal Kedaluwarsa',
  'report.show_paid_transactions': 'Tampilkan Transaksi yang Sudah Dibayar',
  'report.total_before_discount': 'Total Sebelum Diskon',
  'report.total_after_tax': 'Total Setelah Pajak',
  'report.avg_after_tax': 'Rata-rata Setelah Pajak',
  'report.other_units': 'Unit Lain',
  'financeInvoices.number_2': 'No Urut',
  please_input_the_group_name: 'Silahkan masukkan nama grup',
  please_input_the_value: 'Silahkan masukkan {value}',
  please_select_at_least_1_group: 'Silahkan pilih minimal 1 grup',
  please_select_at_least_1_contact: 'Silahkan pilih minimal 1 kontak',
  please_select_at_least_1_category: 'Silahkan pilih minimal 1 kategori',
  please_select_at_least_1_product: 'Silahkan pilih minimal 1 produk',
  'report.total_payment_and_witholding': 'Total Pembayaran & Pemotongan',
  'report.per_week': 'Per Minggu',
  select_custom_column: 'Pilih custom field',
  'notification.live_webinar_event_notification': 'Notifikasi event live webinar',
  'notification.error_cannot_update': 'Tidak dapat mengubah notifikasi.',
  'financeInvoices.join_invoice': 'Tagihan Gabungan',
  'financeInvoices.join_purchase_invoice': 'Tagihan Gabungan Pembelian',
  'financeInvoices.edit_join_purchase_invoice': 'Ubah Tagihan Pembelian Gabungan',
  'financeInvoices.sales_invoice': 'Tagihan Penjualan',
  'financeInvoices.amount_billed': 'Jumlah Tagihan',
  'financeInvoices.remaining_billed': 'Sisa Tagihan',
  'financeInvoices.remaining_billed_total': 'Total Sisa Tagihan',
  'financeInvoices.date_cannot_be_earlier_than_item_date':
    'Tanggal transaksi tidak boleh lebih awal dari tanggal tagihan.',
  'financeInvoices.proforma': 'Proforma',
  'financeInvoices.create_proforma_invoice': 'Buat Proforma',
  'financeInvoices.edit_proforma_invoice': 'Ubah Proforma',
  'financeInvoices.print_proforma': 'Proforma',
  'financeInvoices.proforma_invoice': 'Proforma',
  'financeInvoices.combined_invoice': 'Tagihan Gabungan',
  'financeInvoices.print_join_invoice': 'Cetak Tagihan Gabungan',
  'financeInvoices.master_invoice': 'Tagihan Utama',
  'financeInvoices.merged_invoice_title': 'Tagihan ini telah digabungkan',
  'financeInvoices.merged_invoice_description': 'Tagihan digabung dengan tagihan lain pada {date}',
  'financeInvoices.view_invoice': 'Lihat tagihan',
  'financeInvoices.related_invoice_tag': 'Tagihan digabung',
  'financeOrder.there_is_still_0_data': 'Total data yang Anda inputkan masih 0',
  'financeOrder.are_you_sure_you_want_to_continue': 'Apakah yakin melanjutkan?',
  'layoutInvoice.invoice_show_sale_price': 'Tampilkan Harga Jual',
  'financeInvoices.export_coretax': 'Ekspor Coretax',
  'layoutInvoice.invoice_show_remaining_credit_memo': 'Tampilkan Sisa Hutang & Total Hutang',
  'report.less_than_1_month': 'Kurang Dari 1 Bulan',
  'report.less_than_1_week': 'Kurang Dari 1 Minggu',
  'report.until_less_than_equal_months': '{firstMonth} s/d ≤ {secondMonth} Bulan',
  'report.until_less_than_equal_weeks': '{firstWeek} s/d ≤ {secondWeek} Minggu',
  'report.more_than_months': 'Lebih Dari {month} Bulan',
  'report.more_than_weeks': 'Lebih Dari {week} Minggu',
  'report.more_than_now_date': 'Lebih Dari {now}',
  'layoutInvoice.invoice_show_dpp': 'Tampilkan DPP',
  'dueReminder.send_reminder_to_customers_who_have_invoices_due':
    'Kirim reminder ke pelanggan yang mempunyai {transType} jatuh tempo',
  'dueReminder.send_reminder': 'Kirim reminder',
  'dueReminder.section_schedule': 'Jadwal Pengiriman',
  'dueReminder.section_schedule_hint':
    'Tentukan kapan pengingat dikirim relatif terhadap tanggal jatuh tempo.',
  'dueReminder.section_channel': 'Saluran Pengiriman',
  'dueReminder.section_channel_hint': 'Pilih ke mana dan lewat kanal apa pengingat dikirim.',
  'dueReminder.section_group': 'Grup Kontak Penerima',
  'dueReminder.section_group_hint':
    'Pilih grup kontak tambahan yang juga menerima email pengingat.',
  'dueReminder.module_desc':
    'Kirim email atau WhatsApp otomatis ke {customer} saat {transType} mendekati atau melewati tanggal jatuh tempo, agar pembayaran tidak terlewat.',
  'dueReminder.send_before_due': 'Kirim sebelum jatuh tempo',
  'dueReminder.send_before_due_desc': 'Ingatkan {customer} menjelang tanggal jatuh tempo.',
  'dueReminder.send_after_due': 'Kirim setelah jatuh tempo',
  'dueReminder.send_after_due_desc': 'Tindak lanjut {transType} yang telah melewati jatuh tempo.',
  'dueReminder.count_days': '{count} hari',
  'dueReminder.before': 'sebelum',
  'dueReminder.after': 'setelah',
  'dueReminder.send_consecutive': 'Kirim beruntun tiap hari',
  'dueReminder.send_consecutive_desc_on':
    'Pengingat dikirim setiap hari hingga tanggal jatuh tempo.',
  'dueReminder.send_consecutive_desc_off':
    'Pengingat hanya dikirim di hari batas dan hari jatuh tempo.',
  'dueReminder.email_to_customer': 'Email ke {customer}',
  'dueReminder.email_to_customer_desc': 'Kirim pengingat langsung ke alamat email {customer}.',
  'dueReminder.email_to_admin': 'Email ke admin',
  'dueReminder.email_to_admin_desc': 'Salin pengingat ke email admin sebagai arsip internal.',
  'dueReminder.whatsapp_to_customer': 'WhatsApp ke {customer}',
  'dueReminder.whatsapp_to_customer_desc':
    'Kirim pengingat via WhatsApp. Menggunakan kuota pesan WhatsApp.',
  'dueReminder.whatsapp_balance_left': 'Sisa {count} pesan',
  'dueReminder.active': 'Aktif',
  'dueReminder.inactive': 'Nonaktif',
  'dueReminder.group_name': 'Nama Grup',
  'dueReminder.receive': 'Terima',
  'dueReminder.setting_menu': 'Atur Pengingat Jatuh Tempo',
  'billing.whatsapp_balance': 'Saldo Whatsapp',
  'billing.whatsapp_title': 'Billing Whatsapp',
  'billing.balance_history': 'Riwayat Saldo',
  'billing.whatsapp_status': 'Status',
  'billing.whatsapp_filter_status': 'Filter status',
  'billing.whatsapp_status_processing': 'Diproses',
  'billing.whatsapp_status_sent': 'Terkirim',
  'billing.whatsapp_status_delivered': 'Diterima',
  'billing.whatsapp_status_read': 'Dibaca',
  'billing.whatsapp_status_replied': 'Dibalas',
  'billing.whatsapp_status_failed': 'Gagal',
  'billing.whatsapp_contact': 'Kontak: {name}',
  'billing.whatsapp_addon': 'Addon Whatsapp',
  'dueReminder.top_up_whatsapp_balance': 'Top Up Saldo Whatsapp',
  'dueReminder.out_of_whatsapp_balance_desc':
    'Untuk dapat mengirimkan pengingat melalui whatsapp, silakan top up saldo Whatsapp terlebih dahulu.',
  'massWhatsapp.mass_whatsapp': 'Kirim Whatsapp Massal',
  'massWhatsapp.cannot_be_sent': 'Data mass Whatsapp tidak dapat dikirim',
  'massWhatsapp.are_you_sure': 'Apakah Anda yakin akan mengirim {count} Whatsapp {title}?',
  'massWhatsapp.data_has_been_sent': 'Total {count} Whatsapp telah berhasil dikirim',
  'massWhatsapp.out_of_whatsapp_balance_desc':
    'Silahkan top up saldo Whatsapp terlebih dahulu untuk dapat mengirimkan Whatsapp secara massal.',
  'whatsappModal.out_of_whatsapp_balance_desc':
    'Untuk dapat mengirimkan pengingat melalui whatsapp, silakan top up saldo Whatsapp terlebih dahulu. Atau Anda juga dapat mengirim menggunakan Whatsapp Personal untuk pengiriman secara gratis.',
  'report.cashier': 'Kasir',
  'report.cashier_open_close_time': 'Waktu Buka / Tutup Kasir',
  'report.initial_capital_with_currency': 'Modal Awal (Rp)',
  'report.initial_capital': 'Modal Awal',
  'report.actual_cash_total': 'Total Tunai Aktual (Rp)',
  'report.total_non_cash_income': 'Total Penerimaan Non Tunai (Rp)',
  'report.cash': 'Tunai',
  'report.cash_refund': 'Refund Tunai',
  'report.cash_payment': 'Pembayaran Tunai',
  'report.total_revenue': 'Total Penerimaan',
  'report.cashless': 'Non Tunai',
  'report.edc_payment': 'Pembayaran EDC',
  'report.transfer_payment': 'Pembayaran Transfer',
  'report.deposit_payment': 'Pembayaran Deposit',
  'report.total_non_cash_revenue': 'Total Penerimaan Non Tunai',
  'report.pos_unpaid': 'Belum Terbayar',
  'report.products_sold': 'Produk Terjual',
  'report.total_sold': 'Total Terjual',
  'report.overall_total': 'Total Keseluruhan',
  'report.total_entered': 'Total yang Dimasukkan',
  'report.total_expected': 'Total yang Diharapkan',
  'report.open_time': 'Waktu Buka',
  'report.close_time': 'Waktu Tutup',
  'report.payment_type': 'Jenis Pembayaran',
  'report.deposit_transaction_amount': 'Jumlah Transaksi Deposit',
  'report.deposit_sales': 'Penjualan Deposit',
  'report.total_transactions_paid': 'Total Transaksi Terbayar',
  'report.total_transactions_paid_help_text':
    'Hanya menampilkan total transaksi dari seluruh transaksi yang telah dibayar',
  'report.total_sales_paid': 'Total Penjualan Terbayar',
  'report.total_sales_paid_help_text':
    'Hanya menampilkan total penjualan dari seluruh transaksi yang telah dibayar',
  'report.total_payment_types': 'Total Jenis Pembayaran',
  'report.total_deposit_transactions': 'Total Transaksi Deposit',
  'report.total_deposit_transactions_help_text':
    'Hanya menampilkan total transaksi deposit yang telah dibayar',
  'report.total_sales_deposit': 'Total Penjualan Deposit',
  'report.total_sales_deposit_help_text':
    'Hanya menampilkan total penjualan deposit yang telah dibayar',
  'report.pos_closing_balance': 'Saldo Akhir (Rp)',
  'report.payment_method': 'Metode Pembayaran',
  'report.cash_movement_physical': 'Pergerakan Kas (Uang Fisik)',
  'report.cash_reconciliation': 'Rekonsiliasi Kas',
  'report.total_omzet': 'Total Omzet',
  'report.sales_transaction_completed': 'Transaksi Selesai',
  'report.pos_unpaid_currency': 'Belum Terbayar (Rp.)',
  'report.non_cash_payment': 'Pembayaran Non Tunai',
  'report.total_non_cash': 'Total Non Tunai',
  'report.received_cash': 'Penerimaan Tunai',
  'report.cash_in_drawer': 'Total Kas di Laci (Kas Tunai Seharusnya)',
  'report.actual_cash_counted': 'Uang Tunai Dihitung (Aktual)',
  'report.expected_cash': 'Kas Tunai Seharusnya',
  'report.cash_difference': 'Selisih Kas',
  'report.status_more': 'LEBIH',
  'report.status_less': 'KURANG',
  'report.status_matched': 'SESUAI',
  'report.cash_movement_formula':
    'Rumus: Modal Awal + Kas Masuk + Penerimaan Tunai − Kas Keluar − Refund Tunai',
  'report.cash_reconciliation_formula':
    'Rumus: Selisih = Uang Tunai Dihitung − Kas Tunai Seharusnya',
  'report.not_available': 'Tidak tersedia',
  'report.unfinished_transactions': 'Transaksi Belum Selesai',
  'report.unpaid_invoice_count': 'Invoice Belum Lunas',
  'report.unpaid_invoice_amount': 'Sisa Tagihan Belum Lunas',
  'report.unpaid_invoices': 'Invoice Belum Lunas',
  'report.open_orders': 'Pesanan Terbuka',
  'report.voided_transactions': 'Transaksi Void',
  'report.voided_transactions_help':
    'Invoice yang sudah dibayar pada shift ini lalu di-void. Nominalnya tidak dihitung ke omzet, total pembayaran, maupun kas.',
  'report.transaction_has_been_voided': 'Transaksi telah di-void',
  'report.no_voided_transactions': 'Tidak ada transaksi yang di-void.',
  'report.cash_reconciliation_legend': '(−) = Kurang     (+) = Lebih',
  'report.vendor_name': 'Nama {vendor}',
  'errors.1_transaction_draft':
    'Untuk menggunakan fitur transaksi draft, pertimbangkan untuk menghapus transaksi draft Anda dan coba lagi.',
  'errors.2_transaction_draft':
    'Jika masalah berlanjut, pertimbangkan untuk menghapus cache dan cookie browser Anda.',
  'errors.3_transaction_draft':
    'Atau abaikan pesan ini jika Anda tidak ingin menggunakan fitur transaksi draft.',
  'report.order_date': 'Tanggal Order',
  'report.transaction_time': 'Jam Transaksi',
  'report.pos_order_date': 'Tanggal Order POS',
  'report.hour_from': 'Dari Jam',
  'report.hour_to': 'Sampai Jam',
  'report.hour_to_must_be_after_hour_from': 'Sampai jam harus setelah dari jam',
  'report.payment_date': 'Tanggal Bayar',
  'report.order_type': 'Jenis Order',
  'report.total_sales': 'Total Penjualan',
  'report.pos_net_sales': 'Penjualan Bersih',
  'report.pos_net_sales_help': 'Total Penjualan - Total Pengembalian',
  'report.total_payment': 'Total Pembayaran',
  'report.total_receivables': 'Total Piutang',
  'report.not_yet_paid_off': 'Belum Lunas',
  'report.paid_off': 'Lunas',
  'report.minimum_sales': 'Minimal Penjualan',
  'report.maximum_sales': 'Maksimal Penjualan',
  'report.minimum_gross_sales': 'Minimal Penjualan Kotor',
  'report.maximum_gross_sales': 'Maksimal Penjualan Kotor',
  'report.price_type': 'Jenis Harga',
  'report.pos_total_price': 'Harga Total',
  'report.order_details': 'Detail Pesanan',
  'report.order_notes': 'Catatan Pesanan',
  'report.receipt_print': 'Cetak Tanda Terima',
  'report.invoice_print': 'Cetak Faktur',
  'report.ordered_details': 'Detail Pemesanan',
  'report.product_subtotal': 'Subtotal {product}',
  'report.service_fee': 'Biaya Pelayanan',
  'report.rounding': 'Pembulatan',
  'report.administration_costs': 'Biaya Administrasi',
  'report.payment_details': 'Detail Pembayaran',
  'report.return': 'Kembalian',
  'report.served_by': 'Dilayani Oleh',
  'report.table_name': 'Nama Meja',
  'report.pos_order_number': 'Nomor Urut',
  'report.points_earned': 'Poin yang didapat',
  'report.transaction_reference': '{reference} Transaksi',
  'pos.total_sales_orders': 'Total Pesanan Penjualan',
  'pos.total_unprocessed': 'Total Belum Diproses',
  'pos.total_completed': 'Total Selesai',
  'pos.customer_name': 'Nama {customer}',
  'pos.partially_sent': 'Dikirim Sebagian',
  'pos.unprocessed': 'Belum Diproses',
  'posSalesOrders.full_address': 'Alamat Lengkap',
  'posSalesOrders.shipping_address_same_with_billing_address':
    'Alamat Penagihan saya sama dengan alamat pengiriman',
  'posSalesOrders.example': 'Contoh',
  'posSalesOrders.please_select_outlet': 'Silahkan pilih outlet',
  'financeInvoices.payment_account': 'Pembayaran Kas & Bank',
  'financeInvoices.no_payment_account': 'Belum ada pembayaran',
  'financeInvoices.contact_bank_account': 'Rekening {something}',
  'financeInvoices.contact_bank_account_number': 'No. Rekening {something}',
  'financeInvoices.contact_bank_account_number_placeholder': 'No. Rekening',
  'businessFlow.invoice_delivery_expedition_required': 'Ekspedisi wajib diisi',
  'businessFlow.invoice_delivery_expedition_required_desc':
    'Apakah ekspedisi wajib diisi saat menambahkan transaksi penjualan?',
  'report.consolidation_balance_sheet_modal_detail': 'Detail {accountName}',
  'report.coa_account': 'Akun COA',
  'layoutInvoice.invoice_show_ref_order': 'Tampilkan Nomor Pemesanan',
  'layoutInvoice.invoice_show_ref_quote': 'Tampilkan Nomor Penawaran',
  'layoutInvoice.invoice_show_barcode': 'Tampilkan Barcode',
  'layoutInvoice.invoice_show_payment_connect_barcode': 'Tampilkan QR Code Payment Connect',
  'layoutInvoice.change_payment_connect_barcode_size': 'Ubah ukuran QR code',
  change_password: 'Ganti Password',
  update_your_current_password: 'Perbarui password Anda saat ini.',
  upload_new_image: 'Unggah Gambar Baru',
  update_your_profile_data: 'Atur data diri Anda.',
  enable_two_factor_authentication: 'Aktifkan two-factor authentication',
  two_factor_authentication: 'Two-Factor Authentication',
  enable_two_factor_authentication_desc:
    'Perkuat keamanan akun Anda dengan mengaktifkan verifikasi dua langkah (2FA).',
  setup_authenticator_app: 'Atur Aplikasi Authenticator',
  download_and_install_aplication_like_google_authenticator:
    'Unduh dan install aplikasi seperti {googleAuthenticator}, {authy}, {microsoftAuthenticator}, atau aplikasi lainnya di ponsel Anda. Aplikasi ini akan menghasilkan password sekali pakai yang digunakan sebagai two-factor authentication untuk memferifikasi identitas Anda saat masuk nantinya.',
  scan_qr_code: 'Scan Kode QR',
  scan_qr_code_below_with_your_authenticator_app:
    'Pindai kode QR di bawah dengan aplikasi Authenticator Anda.',
  or_you_can_manually_add_the_code_below: 'Atau bisa dengan manual menambahkan kode dibawah',
  your_password: 'Password Anda',
  enter_your_password_to_register_two_factor_authentication:
    'Masukkan password Anda saat ini untuk mendaftarkan two-factor authentication',
  enter_the_code_generated_by_your_authenticator_app:
    'Masukkan kode yang dihasilkan oleh aplikasi Authenticator Anda',
  verification_code: 'Kode Verifikasi',
  enter_the_verification_code_that_was_generated_in_the_two_factor_authentication_application:
    'Masukkan kode verifikasi yang telah dihasilkan di aplikasi two-factor authentication.',
  process_two_factor_authentication: 'Proses Two-Factor Authentication',
  please_input_your_password: 'Silahkan masukkan password Anda',
  please_input_the_verification_code: 'Silahkan masukkan kode verifikasi',
  code_has_been_copied: 'Kode telah disalin',
  download_recovery_code: 'Unduh Kode Pemulihan',
  use_recovery_code_as_two_factor_authentication_methode:
    'Gunakan kode pemulihan sebagai metode two-factor authentication, apabila ponsel atau aplikasi two-factor authentication tidak dapat diakses. Setiap recovery codes dapat dipakai satu kali untuk melakukan login nantinya.',
  please_download_print_or_copy_the_code_below:
    'Mohon download, cetak atau salin kode dibawah terlebih dahulu.',
  download_code: 'Unduh Kode',
  print_code: 'Cetak Kode',
  copy_code: 'Salin Kode',
  your_current_password: 'Password Anda saat ini',
  disable_two_factor_authentication: 'Nonaktifkan Two-Factor Authentication',
  yes_disabled: 'Ya, Nonaktifkan',
  are_you_sure_to_disabled_two_factor_authentication:
    'Apakah Anda yakin ingin menonaktifkan Two-Factor Authentication? Akun Anda akan kehilangan lapisan keamanan ekstra.',
  please_input_your_password_to_continue: 'Silakan masukkan password Anda untuk melanjutkan.',
  enter_verification_code_from_authentication_app:
    'Masukkan kode verifikasi dari aplikasi two-factor authentication. ',
  if_you_cannot_access_the_application: 'Jika tidak bisa mengakses aplikasi, {recoveryModeLink}.',
  use_recovery_code: 'gunakan kode pemulihan',
  verify_code: 'Verifikasi Kode',
  continue_with_otp: 'Lanjutkan dengan OTP',
  enter_your_email_so_we_can_send_you_the_otp_code_for_the_login_process:
    'Masukkan email Anda, agar kami dapat mengirimkan kode OTP untuk proses login.',
  send_otp_code: 'Kirim Kode OTP',
  otp_has_been_sent_to_your_email:
    'Kode OTP telah dikirim ke email {email}. Periksa email dan masukkan kode tersebut untuk menyelesaikan login.',
  not_received_otp_code: 'Belum menerima kode OTP?',
  resend_code: 'Kirim Ulang Kode',
  enter_kledo: 'Masuk Kledo',
  recovery_code: 'Kode Pemulihan',
  enter_the_recovery_code: 'Masukkan kode pemulihan',
  please_input_the_recovery_code: 'Silahkan masukkan kode pemulihan',
  use_verification_code: 'Gunakan kode verifikasi',
  otp_has_been_resent_to_your_via_registered_channel:
    'Kode OTP telah dikirim ulang ke {channel} yang terdaftar.',
  product_and_serial_number: 'Produk dan Nomor Seri',
  'financeClosing.product_stock_validation': 'Validasi Stok Produk',
  'financeClosing.please_wait_product_stock_validation':
    'Mohon tunggu sedang dilakukan validasi stok produk',
  'financeClosing.product_stock_validation_desc':
    '{product} berikut mempunyai stok negatif, mohon lakukan penyesuaian stok terlebih dahulu:',
  'financeExpenseTerms.active_in': 'Aktif Di',
  'financeExpenseTerms.please_enable_one_of_the_options': 'Silahkan aktifkan salah satu opsi',
  'financeExpenseTerms.enable_in_sales': 'Aktifkan di Penjualan',
  'financeExpenseTerms.enable_in_purchase': 'Aktifkan di Pembelian',
  'financeExpenseTerms.enable_in_expense': 'Aktifkan di Biaya',
  'financeExpenseTerms.enable_in_contact': 'Aktifkan di Kontak',
  'layoutInvoice.add_default_message': 'Tambah Pesan Default',
  'layoutInvoice.delete_default_message_confirmation': 'Hapus Pesan Default',
  'layoutInvoice.delete_default_message_confirmation_desc':
    'Apakah anda yakin untuk menghapus pesan default ini?',
  'layoutInvoice.set_as_default': 'Atur sebagai default',
  'layoutInvoice.rename_default_message': 'Ubah nama',
  'layoutInvoice.rename_default_message_title': 'Ubah Nama Pesan Default',
  'layoutInvoice.default_message_name': 'Nama pesan default',
  'layoutInvoice.select_default_message': 'Pilih Pesan Default',
  'billing.edit_tax_number': 'Ubah NPWP',
  'billing.yes_correct': 'Ya, Benar',
  'billing.tax_number': 'Nomor NPWP',
  'billing.tax_number_min_length': 'Nomor NPWP minimal 15 karakter',
  'billing.tax_number_max_length': 'Nomor NPWP maksimal 16 karakter',
  'billing.company_name_is_required': 'Nama Perusahaan harus diisi',
  'billing.company_name_min_length': 'Nama perusahaan minimal 10 karakter',
  'billing.tax_number_is_required': 'Nomor NPWP harus diisi',
  'billing.tax_number_is_number': 'Nomor NPWP harus berupa angka',
  'billing.address_is_required': 'Alamat harus diisi',
  'billing.address_min_length': 'Alamat minimal 20 karakter',
  'billing.tax_invoice_is_correct': 'Apakah data diatas sudah benar?',
  'billing.tax_number_successfully_saved': 'Data NPWP berhasil disimpan',
  'billing.tax_number_successfully_saved_desc_1':
    'Mohon tunggu maksimal 2 hari kerja untuk proses verifikasi dari Tim Hebat Kledo.',
  'billing.tax_number_successfully_saved_desc_2':
    'Faktur pajak dapat didownload pada halaman ini maksimal 15 hari setelah pembayaran',
  'billing.tax_invoice_approve_desc_1':
    'Faktur pajak dapat di download pada halaman ini maksimal 15 hari setelah pembayaran.',
  'billing.tax_invoice_approve_desc_2':
    'Berikut adalah data NPWP perusahaan Anda, pastikan data benar dan akurat. Faktur Pajak yang sudah digenerate tidak dapat diubah kembali.',
  'billing.tax_invoice_waiting_approval_desc_1':
    'Data NPWP Anda masih menunggu proses verifikasi oleh Tim Hebat Kledo.',
  'billing.tax_invoice_waiting_approval_desc_2':
    'Mohon menunggu maks. 2 hari kerja untuk proses verifikasi ini.',
  'billing.tax_invoice_waiting_approval_desc_3': 'Terima kasih.',
  'billing.tax_invoice_rejected_desc_1': 'Data NPWP Anda tidak valid:',
  'billing.tax_invoice_rejected_desc_2':
    'Silahkan lakukan pembaruan data untuk dapat mengunduh faktur pajak Anda.',
  'billing.taxt_invoice_step_1_desc':
    'Untuk dapat mengunduh faktur pajak, silahkan masukkan data NPWP perusahaan Anda. Pastikan data yang diinput benar dan akurat.',
  'billing.taxt_invoice_step_2_desc':
    'Mohon pastikan kembali data NPWP yang Anda masukkan sudah benar.',
  'billing.taxt_invoice_step_1_and_2_desc':
    'Faktur yang sudah di-generate tidak dapat diubah kembali.',
  'billing.tax_invoice_hooray': 'Hore!!',
  'financeContacts.hide': 'Sembunyikan',
  'report.period_type': 'Tipe Periode',
  'financeFixedAssets.please_enter_year_or_month': 'Silahkan masukkan tahun atau bulan',
  'financeFixedAssets.asset_upgrade': 'Upgrade Aset',
  'financeFixedAssets.upgrade_date': 'Tanggal Upgrade',
  'financeFixedAssets.add_fixed_asset_upgrade': 'Tambah Upgrade Aset Tetap',
  'financeFixedAssets.edit_fixed_asset_upgrade': 'Ubah Upgrade Aset Tetap',
  'financeFixedAssets.fixed_asset_upgrade': 'Upgrade Aset',
  message_required: 'Pesan wajib diisi',
  'report.re_export': 'Ekspor Ulang',
  'report.download_or_download': 'Download / Unduh',
  'financeLockDate.input_lock_date_help_1':
    'Tanggal penguncian tidak dapat diset menjadi tanggal sebelum tutup buku terakhir.',
  'financeLockDate.input_lock_date_help_2':
    'Seluruh aset tetap yang dapat terdepresiasi, harus telah didepresiasikan terlebih dahulu pada tanggal penguncian yang ditetapkan.',
  'financeLockDate.delete_lock_date_desc':
    'Tanggal penguncian tidak dapat dihapus jika terdapat tutup buku.',
  'massReconcile.mass_reconcile': 'Rekonsiliasi Massal',
  'massReconcile.cannot_mass_reconcile': 'Tidak dapat merekonsiliasi massal',
  'businessFlow.unique_product_name': 'Nama {product} unik',
  'businessFlow.unique_product_name_desc': 'Apakah nama {product} harus unik?',
  'financeProduct.name_is_used': 'Nama {product} telah dipakai',
  'financeProduct.fail_check_unique_product_name': 'Pemeriksaan nama unik {product} gagal',
  'users.roles_help_text':
    'Akun Anda telah mencapai batas jumlah pengguna. Anda hanya dapat menambahkan pengguna untuk POS',
  'report.total_payment_debt': 'Total Pembayaran + Hutang',
  'report.total_payment_receivables': 'Total Pembayaran + Piutang',
  'businessFlow.sale_price_disabled': 'Harga {product} tidak bisa diubah',
  'businessFlow.sale_price_disabled_desc':
    'Jika aktif maka harga {product} saat menambah tagihan, pemesanan dan penawaran tidak dapat diubah.',
  'report.actual_budget': 'Anggaran Aktual',
  'report.profit_and_loss_budget': 'Anggaran Laba Rugi',
  'report.actual_loss': 'Kerugian Aktual',
  'report.realized_loss': 'Kerugian Terealisasi',
  'report.actual_profit': 'Keuntungan Aktual',
  'report.realized_profit': 'Keuntungan Terealisasi',
  duplicate_to_transaction: 'Duplikat ke Transaksi',
  'report.current_rate': 'Kurs Saat Ini',
  'report.balance_in_rupiah': 'Saldo dalam Rupiah',
  'report.revaluation_of_accounts_in_foreign_currency': 'Revaluasi Akun dengan Mata Uang Asing',
  'report.total_revaluation': 'Total Revaluasi',
  'report.total_cash_and_cash_equivalents': 'Total Kas dan setara kas',
  'report.cash_and_cash_equivalents_as_of_date': 'Kas dan setara kas pada {date}',
  'layoutInvoice.invoice_show_qty_not_send': 'Tampilkan Sisa {product} yang Belum Dikirim',
  'financeWarehouses.include_all_tracked': 'Hanya {products} yang terdapat di gudang ini',
  'report.cost': 'Biaya',
  'financeFixedAssets.total_cost_limit': 'Total Batas Biaya',
  'financeWareHouses.data_progress_processed': '{count} data dari total {total} telah diproses',
  please_select_invoice: 'Silahkan pilih tagihan',
  please_select_purchase_invoice: 'Silahkan pilih tagihan pembelian',
  purchase_invoice: 'Tagihan Pembelian',
  minimal_2_invoice: 'Minimal dua tagihan',
  same_currency_required: 'Semua tagihan harus memiliki mata uang yang sama',
  edit_join_invoice: 'Ubah Tagihan Gabungan',
  paid_invoice_cannot_be_edited: 'Tagihan sudah dibayar, tidak dapat diubah',
  'layoutInvoice.invoice_show_cost_production': 'Tampilkan Biaya Produksi',
  'layoutInvoice.invoice_show_cost_per_unit': 'Tampilkan Biaya per Unit',
  mass_duplicate_to: 'Duplikat ke {title}',
  mass_duplicate_selected_transactions: '{count} transaksi dipilih',
  mass_duplicate_items_copied: 'Akan disalin',
  mass_duplicate_items_skipped: 'Dilewati',
  mass_duplicate_items_skipped_hint: 'Produk tidak ditandai bisa dibeli',
  mass_duplicate_trans_without_purchase: 'Transaksi tanpa produk yang bisa dibeli',
  mass_duplicate_skipped_products: 'Produk yang dilewati',
  mass_duplicate_rule_header:
    'Tanggal, jatuh tempo, tag, dan info lainnya mengikuti transaksi pertama. Tanggal pengiriman diatur ke hari ini.',
  mass_duplicate_rule_items:
    'Item dari semua transaksi digabung, hanya produk yang ditandai bisa dibeli.',
  show_less: 'Tampilkan lebih sedikit',
  ok_continue: 'OK, Lanjutkan',
  'import.import_note':
    'Proses import sedang berjalan dan membutuhkan waktu beberapa lama. Pada saat proses import berlangsung, data Buku Besar, Saldo Bank dan Stok akan mengalami perubahan dan memungkinkan terdapat ketidak-sesuaian data temporer. Mohon menunggu setelah proses import selesai untuk kembali cek data.',
  order_type: 'Jenis Order',
  'financeProduct.update_duplicate_sku': 'Perbarui Duplikat SKU',
  'financeFixedAssets.total_asset_upgrade': 'Total Upgrade Aset',
  'financeFixedAssets.acquisition_cost': 'Harga Perolehan',
  'financeInvoices.payment_amount': 'Jumlah Pembayaran',
  'financeInvoices.payment_reference': '{reference} Pembayaran',
  'financeOrders.down_payment_amount': 'Jumlah Uang Muka',
  'financeOrders.down_payment_amount_percent': 'Jumlah Uang Muka (%)',
  'financeOrders.down_payment_account_code': 'Kode Akun Uang Muka',
  'financeInvoices.shipping_receipt_number': 'Nomor Resi Pengiriman',
  'financeInvoices.product_description': 'Deskripsi {product}',
  'financeInvoices.product_unit': 'Satuan {product}',
  'financeInvoices.product_discount': 'Diskon {product}',
  'financeInvoices.payment_account_code': 'Kode Akun Pembayaran',
  create_join_invoice: 'Buat Tagihan Gabungan',
  'layoutInvoice.invoice_show_detail_return': 'Tampilkan Detail Retur',
  automatic_depreciation_history: 'Riwayat Penyusutan Otomatis',
  'layoutInvoice.invoice_show_product_serial_number': 'Tampilkan Nomor Seri {product}',
  'billing.hris_champion': 'Paket Champion',
  'financeContacts.input_that_appears_when_adding_a_contact':
    'Input yang tampil saat tambah kontak',
  'businessFlow.npwp_contact_required': 'NPWP wajib diisi',
  'businessFlow.npwp_contact_required_desc':
    'Apakah saat menambah dan mengubah kontak harus ada NPWP?',
  'financeContacts.please_input_a_npwp': 'Silakan masukkan NPWP.',
  'businessFlow.restore_settings_to_default': 'Kembalikan pengaturan ke default',
  preparing_export_process: 'Mempersiapkan proses ekspor',
  'report.company_bank': 'Bank Perusahaan',
  'report.customer_bank': 'Bank {customer}',
  'report.account_holder': 'Pemegang Rekening',
  maks_n_caracters: 'Maksimal {n} karakter',
  company_name_can_not_be_all_capital: 'Nama tidak boleh menggunakan huruf besar semua',
  company_name_can_not_contain_offensive_words: 'Nama tidak boleh mengandung kata-kata kasar',
  'businessFlow.invoice_allow_duplicate_product': 'Duplikat Produk dalam Item Penjualan',
  'businessFlow.invoice_allow_duplicate_product_desc':
    'Izinkan produk yang sama ditambahkan lebih dari sekali dalam satu transaksi penjualan.',
  'businessFlow.purchase_invoice_allow_duplicate_product': 'Duplikat Produk dalam Item Pembelian',
  'businessFlow.purchase_invoice_allow_duplicate_product_desc':
    'Izinkan produk yang sama ditambahkan lebih dari sekali dalam satu transaksi pembelian.',
  product_already_exists: 'Produk ini sudah ada dalam daftar item!',
  preparing_approval_process: 'Mempersiapkan proses persetujuan',
  preparing_rejection_process: 'Mempersiapkan proses penolakan',
  preparing_reconciliation_process: 'Mempersiapkan proses rekonsiliasi',
  preparing_payment_process: 'Mempersiapkan proses pembayaran',
  preparing_import_process: 'Mempersiapkan proses impor',
  preparing_create_trans_process: 'Mempersiapkan proses pembuatan transaksi',
  preparing_delete_process: 'Mempersiapkan proses penghapusan',
  preparing_mass_print_process: 'Mempersiapkan proses cetak massal',
  preparing_mass_edit_process: 'Mempersiapkan proses ubah massal',
  'report.balance_receivable_termin_detail': 'Detil {title}',
  'report.invoice_age': 'Umur Tagihan',
  'report.invoice_age_to_due_date': 'Umur Tagihan ke Jatuh Tempo',
  'layoutInvoice.invoice_show_stock_count_recorded_qty': 'Tampilkan Qty Tercatat',
  'layoutInvoice.invoice_show_stock_count_diff_qty': 'Tampilkan Selisih',
  'layoutInvoice.show_pic': 'Tampilkan Penanggung Jawab',
  'layoutInvoice.show_counted_by': 'Tampilkan Dikerjakan Oleh',
  please_select_data_to_format: 'Silahkan pilih data untuk format',
  'financeWareHouses.mass_delete_transaction_before_lock_date_and_related_cannot_be_deleted':
    '**Transaksi sebelum tanggal penguncian dan transaksi yang terkait dengan transaksi lainnya tidak dapat dihapus',
  cashier: 'Kasir',
  all: 'Semua',
  order_details: 'Rincian Pesanan',
  remove_all: 'Hapus semua',
  order_details_empty: 'Belum ada pesanan',
  save_to_order: 'Simpan ke Pesanan',
  quantity_cannot_be_negative: 'Jumlah tidak boleh minus',
  remove_all_items: 'Hapus semua item',
  are_you_sure_to_remove_all_items: 'Apakah Anda yakin ingin menghapus semua item?',
  'slackConnect.hash_tag': '#IntegrasiSlack',
  'slackConnect.head_title_1': 'Terima',
  'slackConnect.head_title_2': 'Notifikasi Setiap Transaksi',
  'slackConnect.head_title_3': 'Langsung di Slack Anda',
  'slackConnect.head_desc_1':
    'Dengan mengintegrasikan Kledo dan Slack, setiap transaksi keuangan akan langsung dikirimkan ke channel Slack yang Anda pilih, memastikan tim Anda selalu mendapatkan informasi terkini tanpa harus membuka aplikasi lain.',
  'slackConnect.footer_note':
    'Dapatkan transparansi penuh dalam setiap transaksi keuangan dengan cara yang praktis dan gratis dengan integrasi Kledo dan Slack sekarang juga.',
  'slackConnect.feat_title_1': 'Apa yang Akan',
  'slackConnect.feat_title_2': 'Anda Dapatkan',
  'slackConnect.feat_title_3': 'dari Integrasi Kledo dan Slack?',
  'slackConnect.feat_1_sub_title': 'Notifikasi Transaksi Real-Time di Slack',
  'slackConnect.feat_1_description':
    'Setiap detail transaksi yang terjadi di Kledo POS, faktur, pembayaran, dan penerimaan secara otomatis dikirimkan langsung ke channel Slack. Manajemen keuangan lebih terorganisir dan mudah diakses.',
  'slackConnect.feat_2_sub_title': 'Transparansi Keuangan yang Lebih Baik',
  'slackConnect.feat_2_description':
    'Integrasi Kledo dan Slack memberikan visibilitas penuh terhadap semua transaksi keuangan. Setiap update langsung dikirimkan ke Slack, memudahkan tim untuk memantau setiap detail tanpa kerumitan',
  'slackConnect.feat_3_sub_title': 'Kolaborasi Tim Lebih Efisien',
  'slackConnect.feat_3_description':
    'Diskusikan laporan keuangan, ajukan pertanyaan, atau lakukan validasi transaksi langsung dari Slack. Integrasi ini memungkinkan komunikasi yang lebih cepat dan terorganisir antar anggota tim.',
  'slackConnect.feat_4_sub_title': 'Bisa Akses Dimana Saja',
  'slackConnect.feat_4_description':
    'Anda untuk mendapatkan akses ke setiap informasi transaksi sedetail mungkin, kapan saja dan di mana saja. Memastikan bisnis Anda tetap berjalan lancar meskipun tim bekerja dari lokasi yang berbeda.',
  'slackConnect.feat_5_sub_title': 'Keamanan Data Terjamin',
  'slackConnect.feat_5_description':
    'Dengan integrasi, data transaksi dan keuangan Anda disimpan dengan aman dan hanya dapat diakses oleh anggota tim yang berwenang. Kami memiliki standar keamanan industri untuk melindungi semua data penting Anda.',
  'slackConnect.feat_6_sub_title': 'Gratis untuk Semua Pengguna',
  'slackConnect.feat_6_description':
    'Integrasi Kledo dan Slack dapat digunakan secara gratis. Anda bisa mulai mengoptimalkan manajemen keuangan dan pemantauan transaksi yang lebih baik tanpa biaya tambahan.',
  'slackConnect.integrate_slack': 'Integrasikan Slack',
  'slackConnect.integration_success': 'Hore berhasil integrasikan Slack dan Kledo',
  'slackConnect.back_to_slack_connect_settings': 'Ke Pengaturan Slack Connect',
  'slackConnect.choose_slack_channel_to_integrate_with_kledo':
    'Silakan pilih channel Slack yang akan diintegrasikan dengan Kledo:',
  'slackConnect.select_slack_channel': 'Pilih channel Slack',
  'slackConnect.click_to_integrate_with_slack':
    'Klik tombol di bawah untuk mengintegrasikan Slack dengan Kledo',
  'slackConnect.help_text_integration':
    'Anda akan diarahkan ke website Slack, dan silakan mengisi form pada website Slack, Setelah selesai, Anda akan kembali diarahkan ke halaman ini.',
  'slackConnect.follow_the_tutorial':
    'Silahkan ikuti video tutorial di bawah untuk informasi selengkapnya:',
  'slackConnect.how_to_integrate_kledo_api': 'Cara Integrasi API Kledo',
  'slackConnect.default_send_slack_notification_to_channel':
    'Default kirim notifikasi Slack ke channel',
  'slackConnect.send_notification_every_new_invoice_at_pos':
    'Kirim notifikasi setiap ada tagihan baru di POS',
  'slackConnect.new_invoice': 'Tagihan Baru',
  'slackConnect.daily_report': 'Laporan Harian',
  'slackConnect.pos_daily_sales_report': 'Laporan harian penjualan POS',
  'slackConnect.successfully_updated_default_channel': 'Berhasil memperbarui default channel',
  'slackConnect.notification_options_updated_successfully': 'Opsi notifikasi berhasil diperbarui',
  'slackConnect.successfully_updated_slack_notification': 'Berhasil memperbarui notifikasi Slack',
  'slackConnect.failed_to_updated_slack_notification': 'Gagal memperbarui notifikasi Slack',
  'slackConnect.add_channel': 'Tambah Channel',
  'slackConnect.channel_name': 'Nama Channel',
  'slackConnect.channel_name_is_required': 'Nama channel wajib diisi',
  'slackConnect.max_length_channel_name': 'Nama channel tidak boleh lebih dari 80 karakter.',
  'slackConnect.use_valid_characters':
    'Nama channel tidak boleh mengandung spasi atau tanda baca. Gunakan tanda hubung untuk memisahkan kata.',
  'slackConnect.channel_name_already_taken':
    'Nama tersebut sudah diambil oleh saluran, nama pengguna, atau grup pengguna di workspace Slack Anda.',
  'layoutInvoice.invoice_show_ref_number': 'Tampilkan Nomor',
  'financeProduct.zero_price':
    'Pergerakan stok ini tidak memiliki harga dikarenakan pergerakan stok ini diakibatkan dari pergerakan stok produk paket, yang itemnya salah satunya adalah produk ini.',
  'export.error_cannot_export_data': 'Data tidak dapat ekspor',
  'export.mode.label': 'Mode ekspor',
  'export.mode.expanded': 'Per produk',
  'export.mode.expanded_desc': '(1 baris per produk)',
  'export.mode.compact': 'Per transaksi',
  'export.mode.compact_desc': '(1 baris per transaksi, total bisa langsung dijumlah di Excel)',
  'export.mode.compact_warning':
    'File hasil ekspor mode ini tidak dapat digunakan kembali sebagai template impor.',
  'businessFlow.country_is_required': 'Negara wajib diisi',
  'businessFlow.province_is_required': 'Provinsi wajib diisi',
  'businessFlow.city_is_required': 'Kota wajib diisi',
  'businessFlow.district_is_required': 'Kecamatan wajib diisi',
  'settings.slack_connect': 'Dapatkan notifikasi transaksi di Slack Kantormu',
  'discordConnect.main_webhook': 'Webhook Utama',
  'discordConnect.main_webhook_url': 'URL Webhook Utama',
  'discordConnect.main_webhook_desc': 'URL webhook default untuk semua notifikasi Discord',
  'discordConnect.copy_webhook_info':
    'Silahkan salin link webhook discord Anda dan tambahkan ke Kledo untuk melakukan integrasi',
  'discordConnect.tutorial_title': 'Tutorial Discord Connect',
  'discordConnect.click_here': 'Klik disini',
  'discordConnect.tutorial_description': 'untuk detail cara setup Integrasi Discord ke Kledo',
  'discordConnect.link_webhook': 'Link Webhook',
  'discordConnect.unlink_webhook': 'Unlink Webhook',
  'discordConnect.show_webhook': 'Tampilkan Webhook',
  'discordConnect.hide_webhook': 'Sembunyikan Webhook',
  'discordConnect.webhook_url': 'URL Webhook',
  'discordConnect.enter_webhook_url': 'Masukkan url webhook',
  'discordConnect.pos_order_notification': 'Notifikasi Pemesanan POS',
  'discordConnect.pos_daily_report_notification': 'Notifikasi Laporan Harian POS',
  'discordConnect.pos_invoice_notification': 'Notifikasi Tagihan POS',
  'discordConnect.notification_options': 'Opsi Pemberitahuan',
  'discordConnect.webhook_url_saved': 'URL Webhook berhasil disimpan',
  'discordConnect.notification_options_updated_successfully': 'Opsi notifikasi berhasil diperbarui',
  'discordConnect.disconnected_successfully': 'Integrasi Discord berhasil diputuskan',
  'discordConnect.disconnect': 'Putuskan Discord',
  'discordConnect.confirm_disconnect': 'Apakah Anda yakin ingin memutuskan integrasi Discord?',
  'discordConnect.webhook_url_required': 'URL Webhook wajib diisi',
  'discordConnect.webhook_url_invalid':
    'Masukkan URL webhook Discord yang valid (harus dimulai dengan https://discord.com/api/webhooks)',
  'reportsImport.detail_trans': 'Detail Import {trans}',
  'report.also_show_the_paid_ones': 'Tampilkan juga yang lunas',
  set_to_default: 'Atur sebagai default',
  remove_from_default: 'Hapus dari default',
  default_unit_conversion_tooltip:
    'Ketika satuan dijadikan default, maka di transaksi penjualan dan pembelian satuan akan otomatis terpilih, jika tidak ada yang dijadikan default, maka satuan dasar dari produk yang akan terpilih.',
  weight: 'Berat',
  product_image: 'Gambar {title}',
  'slackConnect.order_notification': 'Notifikasi Order',
  'slackConnect.configure_notifications_for_order_events_at_pos':
    'Konfigurasikan notifikasi untuk setiap perubahan order di POS',
  'slackConnect.add_order': 'Tambah Order',
  'slackConnect.add_order_desc': 'Kirim notifikasi setiap kali ada order baru di POS',
  'slackConnect.update_order': 'Ubah Order',
  'slackConnect.update_order_desc': 'Kirim pemberitahuan setiap kali order diubah di POS',
  'slackConnect.delete_order': 'Hapus Order',
  'slackConnect.delete_order_desc': 'Kirim pemberitahuan setiap kali order dihapus di POS',
  'approvals.minimum_limit': 'Minimum Limit',
  'layoutReport.show_currency_symbol': 'Tampilkan Simbol Mata Uang',
  'financeBanks.import_maybank_1': '1. Login ke MayBank',
  'financeBanks.import_maybank_2': '2. Klik Portfolio',
  'financeBanks.import_maybank_3': '3. Klik Account Statement kemudian Account Report',
  'financeBanks.import_maybank_4': '4. Klik Account Number',
  'financeBanks.import_maybank_5': '5. Klik “Search” kemudian pilih Account Number',
  'financeBanks.import_maybank_6': '6. Isikan Tanggal kemudian klik “Search”',
  'financeBanks.import_maybank_7': '7. Pilih CSV kemudian klik Download',
  'financeBanks.import_maybank_8':
    '8. Kembali ke Beranda kemudian klik kotak centang lalu “Download Select”',
  'financeBanks.import_ocbc_1': '1. Login di https://business.ocbc.id/',
  'financeBanks.import_ocbc_2': '2. Klik Account Management - Account Summary',
  'financeBanks.import_ocbc_3': '3. Scroll ke bawah',
  'financeBanks.import_ocbc_4': '4. Pilih rekening dengan mata uang IDR',
  'financeBanks.import_ocbc_5': '5. Pilih filter tanggal, lalu klik Export',
  'financeBanks.import_ocbc_6': '6. Isi nama file dan pilih format CSV, lalu klik Export',
  'financeBanks.import_ocbc_7': '7. Klik "Click Here"',
  'financeBanks.import_ocbc_8': '8. Klik checklist, lalu klik Download',
  'financeBanks.import_bni_1': '1. Login ke BNI Direct Cash',
  'financeBanks.import_bni_2': '2. Pilih “Informasi Rekening” dan kemudian pilih “Mutasi Rekening”',
  'financeBanks.import_bni_3': '3. Pilih periode mutasi dan No. Rekening',
  'financeBanks.import_bni_4': '4. Pilih Format File yang CSV',
  'financeBanks.import_bni_5': '5. Klik Unduh',
  'financeBanks.import_bni_6': '6. Klik Tanggal Permintaan dan klik Cari',
  'financeBanks.import_bni_7': '7. Klik centang file yang akan diunduh kemudian klik Unduh',
  'financeBanks.import_bri_1': '1. Login ke QLOLA by BRI',
  'financeBanks.import_bri_2': '2. Pilih “Info Rekening” kemudian pilih “Info Mutasi”',
  'financeBanks.import_bri_3': '3. Pilih Nomor Rekening dan Periode Mutasi',
  'financeBanks.import_bri_4': '4. Klik Download',
  'financeBanks.import_bri_5': '5. Pilih format CSV kemudian klik Lanjut',
  'financeBanks.import_bri_6': '6. Pilih Download',
  'financeBanks.import_cimb_1': '1. Login ke CIMB NIAGA',
  'financeBanks.import_cimb_2':
    '2. Klik “Transaction Inquiry” kemudian isikan tanggal lalu klik Account No',
  'financeBanks.import_cimb_3': '3. Pilih “File Format” CSV lalu klik “Download"',
  'financeBanks.import_cimb_4': '4. Klik “Report Name” untuk mengunduh file',
  'financeBanks.import_permata_1': '1. Login ke Permata eBusiness',
  'financeBanks.import_permata_2':
    '2. Pilih Account Information kemudian klik “Transaction Inquiry”',
  'financeBanks.import_permata_3': '3. Pilih Periode Transaksi dan Nomor Rekening',
  'financeBanks.import_permata_4': '4. Pada Custom File Format pilih “Excel”',
  'financeBanks.import_permata_5': '5. Kemudian klik Download',
  'financeBanks.import_btn_1': '1. Login ke Bale Bisnis by BTN',
  'financeBanks.import_btn_2':
    '2. Klik “Rekening Koran” pilih rekening lalu isikan Tanggal kemudian klik “Terapkan”',
  'financeBanks.import_btn_3': '3. Klik “Unduh” kemudian pilih Format File “XLSX”',
  'financeBanks.upload_downloaded_csv_on_form_below':
    'Unggah file CSV yang baru saja didownload pada form dibawah',
  weight_subtotal: 'Sub total berat',
  all_items_weight_total: 'Total berat {product}',
  product_show_weight: 'Tampilkan Berat {product}',
  product_show_weight_desc:
    'Apakah ingin menampilkan informasi berat {product} di transaksi penjualan dan pembelian?',
  'report.price_before_tax': 'Harga Sebelum Pajak',
  'report.price_after_tax': 'Harga Setelah Pajak',
  'financeBanks.schedule_is_required': 'Jadwal wajib diisi',
  'financeBanks.schedule_must_be_unique': 'Jadwal harus unik',
  'financeBanks.set_a_schedule': 'Atur Jadwal',
  'financeBanks.add_schedule': 'Tambah Jadwal',
  'financeBanks.schedule': 'Jadwal',
  not_receive_verification_code_from_email: 'Tidak menerima kode verifikasi melalui email?',
  please_check_your_email_folder_spam: 'Silakan periksa folder spam email Anda atau',
  application_detect_sigin_from_other_different_browser:
    'Aplikasi mendeteksi sign-in dari browser yang berbeda.',
  two_factor_verification_code_has_been_sent_to_your_email:
    'Kode verifikasi telah kami kirimkan ke email Anda {email}, Verifikasi ini diperlukan untuk memastikan keamanan akun Anda.',
  verification_with_otp: 'Verifikasi dengan OTP',
  need_help: 'Butuh bantuan? {callCenterLink}.',
  'financeInvoices.receipt_number': 'Nomor Resi',
  'layoutInvoice.fixed_asset_label': 'Label Aset Tetap',
  'financeFixedAssets.fixed_asset_details': 'Detail Aset Tetap',
  'financeFixedAssets.fixed_assets_label': 'Label Aset Tetap',
  'financeTags.error_cannot_add': 'Tidak dapat menambah {tag}',
  'layoutInvoice.invoice_label_template': 'Aktifkan layout sederhana',
  change_email_verification: 'Verifikasi Perubahan Email',
  you_try_to_change_your_login_email_to:
    'Anda sedang mencoba mengganti alamat email login Anda menjadi:',
  for_security_reasons_we_have_sent_an_otp_to_the_old_email:
    'Demi keamanan akun Anda, kami telah mengirimkan kode OTP ke alamat email lama dan baru Anda.',
  please_fill_the_otp_code_below_to_complete_the_process:
    'Silakan masukkan kode OTP di bawah ini untuk menyelesaikan proses perubahan email.',
  verification_and_save: 'Verifikasi dan Simpan',
  'layoutInvoice.invoice_show_product_percent_qty_from_order':
    'Tampilkan Kuantitas Persentase {product} dari Pemesanan',
  show_selected_rows: 'Tampilkan {selected_rows}',
  hide_selected_rows: 'Sembunyikan {selected_rows}',
  'webhook.webhook_object_help_text':
    'Berikut adalah seluruh objek yang dapat Anda terima notifikasinya melalui webhook',
  'webhook.example_script': 'Contoh Script',
  'webhook.download_example_script':
    'Download contoh penggunaan webhook dalam beberapa bahasa pemrograman berikut:',
  'webhook.successfully_copied_code': 'Berhasil menyalin kode {name}',
  'webhook.successfully_downloaded_code': 'Berhasil mengunduh kode {name}',
  'webhook.successfully_saved_callback_url': 'Berhasil menyimpan callback URL',
  'webhook.successfully_updated_callback_url': 'Berhasil memperbarui callback URL',
  'webhook.failed_to_save_callback_url': 'Gagal menyimpan callback URL',
  'webhook.successfully_verified_webhook': 'Berhasil memverifikasi webhook',
  'webhook.failed_to_verify_webhook': 'Gagal memverifikasi webhook',
  'webhook.successfully_activated_webhook': 'Berhasil mengaktifkan webhook',
  'webhook.successfully_disabled_webhook': 'Berhasil menonaktifkan webhook',
  'webhook.failed_activated_webhook': 'Gagal mengaktifkan webhook',
  'webhook.failed_disabled_webhook': 'Gagal menonaktifkan webhook',
  'webhook.successfully_copied_signature_secret': 'Berhasil menyalin signature secret',
  'webhook.webhook_desc':
    'Terima notifikasi perubahan data secara real-time tanpa perlu memanggil API.',
  'webhook.click_here_for_the_full_tutorial': 'Klik di sini untuk tutorial selengkapnya.',
  'webhook.webhook_configuration': 'Konfigurasi Webhook',
  'webhook.webhook_configuration_desc':
    'Untuk mendapatkan notifikasi saat ada perubahan data, Anda perlu menyiapkan endpoint webhook untuk aplikasi Anda',
  'webhook.enable_webhook': 'Aktifkan webhook',
  'webhook.callback_url_help_text':
    'Ini merupakan URL yang akan dipanggil oleh Kledo saat terdapat perubahan data.',
  'webhook.callback_url_is_required': 'Callback URL wajib diisi',
  'webhook.url_must_use_https': 'URL harus menggunakan https',
  'webhook.invalid_url': 'URL tidak valid',
  'webhook.signature_secret_help_text': 'Signature secret ini hanya akan ditampilkan sekali',
  'webhook.re_request_signature_secret': 'Request ulang signature secret',
  'webhook.url_cannot_same_with_verify_url': 'URL webhook tidak boleh sama dengan URL verify',
  'webhook.webhook_url_must_use_https': 'URL webhook harus menggunakan https',
  'webhook.url_must_have_valid_structure':
    'URL webhook harus memiliki struktur yang valid: https://domain.com/endpoint',
  'webhook.url_must_have_endpoint_after_domain':
    'URL webhook harus memiliki endpoint setelah domain',
  'webhook.url_must_start_with_base_url': 'URL webhook harus dimulai dengan {baseUrl}',
  'webhook.url_must_have_endpoint_after_base_url':
    'URL webhook harus memiliki endpoint setelah {baseUrl}',
  'webhook.url_must_have_single_endpoint_after_base_url':
    'URL webhook harus memiliki satu endpoint setelah base URL (tidak boleh ada segmen path tambahan)',
  'webhook.successfully_updated_object_endpoint': 'Berhasil memperbarui object endpoint',
  'webhook.url_is_required': 'URL wajib diisi',
  'webhook.successfully_subscribed': 'Berhasil subscribe',
  'webhook.failed_to_subscribe': 'Gagal subscribe',
  'webhook.test_connection_successful': 'Test koneksi webhook berhasil',
  'webhook.test_connection_failed': 'Test koneksi webhook gagal',
  'report.subtotal_payable_receivable': 'Subtotal Nilai Tagihan',
  'report.transactions_subtotal': 'Subtotal Sisa Tagihan',
  'report.total_payable_receivable': 'Total Nilai Tagihan',
  'report.total_transactions': 'Total Sisa Tagihan',
  main_transaction: 'Transaksi Utama',
  'financeContacts.account_report_filter': 'Filter Laporan Rekening',
  'financeContacts.view_account_statement': 'Lihat Laporan Rekening',
  'settings.webhook': 'Dapatkan notifikasi data secara real-time',
  'financeInvoices.created_at': 'Tanggal Pembuatan',
  resend_code_by: 'Kirim ulang kode ke kontak yang terdaftar',
  'report.average_per_transaction': 'Rata-rata per Transaksi',
  otp_has_been_resent_to_your_email: 'Kode OTP telah dikirim ulang ke email {email}.',
  'report.actual_status': 'Status Aktual',
  'report.amount_paid': 'Nominal Dibayar',
  'financeWareHouses.error_cannot_delete': 'Gagal menghapus gudang.',
  'report.discount_amount': 'Nominal Diskon',
  loading_tour: 'Memuat tour',
  'tour.sales.step1': 'Anda bisa melihat statistik dan performa penjualan pada menu overview ini.',
  'tour.sales.step2':
    '<div class="text-left">Alur penjualan dimulai dari: <ul class="mt-3 list-group"><li class="list-group-item">1. Penawaran</li><li class="list-group-item">2. Pemesanan</li><li class="list-group-item">3. Pengiriman</li><li class="list-group-item">4. Tagihan</li></ul></div>',
  'tour.sales.step3':
    'Anda bisa membuat Tagihan langsung, atau bisa juga membuat tagihan dari Penawaran/Pemesanan/Pengiriman.',
  'tour.sales.step4':
    'Stok dan jurnal umum otomatis tercatat pada transaksi Pengiriman dan Tagihan. Stok otomatis berkurang saat pencatatan Pengiriman dan Tagihan.',
  'tour.sales.step5':
    'Untuk mempelajari fitur Tagihan Penjualan lebih lanjut, silakan lihat video tutorial disini.',
  'tour.quotes.step1':
    'Fitur Penawaran atau Quotation digunakan saat Anda memberikan penawaran kepada pelanggan atas produk yang Anda jual.<br/>Penawaran yang berhasil dibuat tidak akan mempengaruhi jurnal umum dan tidak mempengaruhi stok produk.',
  'tour.quotes.step2': 'Klik disini untuk membuat penawaran baru.',
  'tour.quotes.step3':
    'Disini Anda bisa mengimport banyak data dari excel, atau mengexport data ke excel.',
  'tour.quotes.step4':
    'Klik tombol filter berikut untuk memfilter Penawaran berdasarkan tanggal, pelanggan ataupun tags.',
  'tour.quotes.step5': 'Gunakan pencarian untuk mencari Penawaran.',
  'tour.quotes.step6':
    'Penawaran Penjualan dikelompokkan berdasarkan status penawaran. Anda bisa mengubah status penawaran dari detail penawaran, kemudian edit penawaran.',
  'tour.quotes.step7':
    'Penawaran dengan status selesai, adalah penawaran yang telah dibuat pemesanannya, atau dibuat tagihannya.',
  'tour.quotes.step8':
    'Untuk mempelajari tentang status penawaran, <a href="https://kledo.com/status-transaksi-penawaran-penjualan-quote/" class="text-primary" target="_blank" rel="noopener noreferrer">klik disini untuk artikel tutorialnya.</a>',
  'tour.purchases.step1':
    'Anda bisa melihat statistik pembelian atau purchasing pada menu overview ini.',
  'tour.purchases.step2':
    '<div class="text-left">Alur pembelian dimulai dari: <ul class="mt-3 list-group"><li class="list-group-item">1. Penawaran Pembelian</li><li class="list-group-item">2. Pemesanan Pembelian / Purchase Order</li><li class="list-group-item">3. Pengiriman Pembelian</li><li class="list-group-item">4. Tagihan Pembelian</li></ul></div>',
  'tour.purchases.step3':
    'Anda bisa membuat Tagihan langsung, atau bisa juga membuat tagihan pembelian dari Penawaran/Pemesanan/Pengiriman.',
  'tour.purchases.step4':
    'Stok dan jurnal umum otomatis tercatat pada transaksi Pengiriman dan Tagihan. Stok otomatis bertambah saat pencatatan Pengiriman dan Tagihan.',
  'tour.purchases.step5':
    'Untuk mempelajari fitur Tagihan Pembelian lebih lanjut, silakan lihat video tutorial disini.',
  'tour.expenses.step1':
    'Fitur Biaya digunakan saat Anda mencatatkan biaya operasional perusahaan.<br/>Biaya yang tercatat akan otomatis tercatat di jurnal umum.',
  'tour.expenses.step2': 'Klik disini untuk mencatatkan biaya baru.',
  'tour.expenses.step3':
    'Disini Anda bisa mengimport banyak data dari excel, atau mengexport data ke excel.',
  'tour.expenses.step4':
    'Klik tombol filter berikut untuk memfilter biaya berdasarkan tanggal, kontak ataupun tags.',
  'tour.expenses.step5': 'Gunakan pencarian untuk mencari Biaya.',
  'tour.expenses.step6':
    'Biaya dikelompokkan berdasarkan pembayaran yang sudah dilakukan, dari belum dibayar hingga lunas.',
  'tour.expenses.step7': 'Klik Lainnya untuk melihat status lainnya.',
  'tour.expenses.step8':
    'Anda bisa membuat Biaya berulang secara otomatis disini. Misalnya membuat biaya sewa gedung rutin setiap bulan.',
  'tour.accounts.step1': 'Disini ditampilkan daftar Akun atau COA (Chart of Accounts)',
  'tour.accounts.step2': 'Anda bisa menambahkan Akun COA baru disini.',
  'tour.accounts.step3': 'Gunakan Jurnal Umum untuk menginput transaksi jurnal secara manual.',
  'tour.accounts.step4':
    'Import banyak data akun sekaligus dengan excel disini, atau bisa juga mengexport data akun ke excel.',
  'tour.accounts.step5': 'Klik disini untuk melihat menu lainnya',
  'tour.accounts.step6': 'Klik disini untuk melakukan setup saldo awal akun COA.',
  'tour.accounts.step7': 'Anda bisa melakukan Tutup Buku disini.',
  'tour.accounts.step8':
    'Anda bisa menghapus Akun COA disini. Akun default sistem kledo dan akun yang telah mempunyai transaksi tidak dapat dihapus.',
  'tour.accounts.step9': 'Disini ditampilkan saldo akhir dari masing-masing Akun COA.',
  'tour.accounts.step10':
    'Untuk mempelajari fitur Akun lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.add_contact.step1': 'Form ini digunakan untuk menambahkan kontak baru.',
  'tour.add_contact.step2': 'Pilih tipe kontak yang sesuai.',
  'tour.add_contact.step3': 'Isikan nama lengkap kontak',
  'tour.add_contact.step4': 'Isikan detail data kontak lainnya disini.',
  'tour.add_contact.step5':
    'Klik disini jika Anda ingin memetakan akun COA Hutang dan Piutang dari kontak yang bersangkutan.',
  'tour.add_contact.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.<br/>Untuk mempelajari fitur Kontak lebih lanjut, silakan lihat video turorial dan <a href='https://kledo.com/cara-membuat-kontak/' class='text-primary' target='_blank'>artikel berikut</a>.",
  'tour.add_delivery.step1':
    'Fitur Pengiriman atau Sales Delivery digunakan saat Anda melakukan pengiriman produk pesanan penjualan kepada pelanggan.<br/>Pengiriman yang berhasil dibuat otomatis akan terbentuk jurnal umum dan akan mengurangi stok produk.',
  'tour.add_delivery.step2':
    'Nomor Pengiriman akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_delivery.step3':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_delivery.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_delivery.step5':
    'Anda bisa mencatatkan ekspedisi pengiriman beserta nomor resi disini.',
  'tour.add_delivery.step6': 'Tentukan jumlah produk yang dikirim',
  'tour.add_delivery.step7':
    'Anda dapat menuliskan pesan untuk ditampilkan saat cetak surat jalan. Anda juga bisa melampirkan berkas pengiriman disini.',
  'tour.add_delivery.step8': 'Silahkan isikan biaya pengiriman disini.',
  'tour.add_delivery.step9':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.<br/>Untuk mempelajari fitur Pengiriman lebih lanjut, silakan lihat video tutorial berikut ini.',
  'tour.add_expense.step1':
    'Fitur Biaya digunakan saat Anda mencatatkan biaya operasional perusahaan.<br/>Biaya yang tercatat akan otomatis tercatat di jurnal umum.',
  'tour.add_expense.step2': 'Pilih Akun yang digunakan untuk membayar biaya.',
  'tour.add_expense.step3': 'Pilih nama penerima pembayaran.',
  'tour.add_expense.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_expense.step5': 'Pilih akun biaya, dan tentukan besaran biayanya.',
  'tour.add_expense.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Biaya lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-posting-biaya-expense/' class='text-primary' target='_blanl'>artikel tutorial</a>.",
  'tour.add_fixed_asset.step1': 'Isikan detail dari Aset Tetap yang akan dicatatkan.',
  'tour.add_fixed_asset.step2':
    'Masukkan harga beli atau hara perolehan dari aset ini, diluar pajak.',
  'tour.add_fixed_asset.step3': 'Pilih Akun untuk menampung saldo aset tetap ini.',
  'tour.add_fixed_asset.step4':
    'Pilihkan Akun untuk mengkreditkan pembelian aset tetap. Contohnya Kas, Pinjaman atau Modal.',
  'tour.add_fixed_asset.step5':
    'Silahkan klik disini jika terdapat penyusutan pada Aset Tetap Anda.',
  'tour.add_fixed_asset.step6': 'Pilih Akun biaya untuk merekam penyusutan setiap bulannya.',
  'tour.add_fixed_asset.step7':
    'Pilih Akun untuk kontra aset untuk menampung akumulasi penyusutan.',
  'tour.add_fixed_asset.step8':
    'Pilih Akun untuk kontra aset untuk menampung akumulasi penyusutan.',
  'tour.add_fixed_asset.step9':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Aset Tetap lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-menambah-aset-tetap/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_invoice.step1':
    'Fitur Tagihan Penjualan atau Invoice digunakan saat Anda akan menagih pembayaran kepada pelanggan atas produk yang Anda jual. <br />Faktur penjualan yang berhasil dibuat akan otomatis tercatat di jurnal umum, dan stok produk akan otomatis berkurang.',
  'tour.add_invoice.step2':
    'Pilih nama pelanggan yang akan ditagihkan, atau bisa juga menambah data pelanggan baru.',
  'tour.add_invoice.step3':
    'Nomor Invoice akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_invoice.step4':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_invoice.step5':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_invoice.step6': 'Pilih produk yang dijual atau bisa juga menambah produk baru disini.',
  'tour.add_invoice.step7':
    'Anda dapat menuliskan pesan untuk ditampilkan saat cetak invoice pelanggan. Anda juga bisa melampirkan berkas tagihan disini.',
  'tour.add_invoice.step8':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Tagihan Penjualan lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-membuat-tagihan-invoice/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_manual_journal.step1':
    'Jurnal umum digunakan sebagai pencatatan manual pada penjurnalan.',
  'tour.add_manual_journal.step2':
    'Nomor Transaksi akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_manual_journal.step3':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_manual_journal.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_manual_journal.step5':
    'Pilih akun COA disini, dan tentukan besaran Kredit atau Debit nya.',
  'tour.add_manual_journal.step6': 'Klik disini untuk menambah baris akun COA',
  'tour.add_manual_journal.step7':
    'Sistem akan secara otomatis memvalidasi balance antara credit dan debit harus sama.',
  'tour.add_manual_journal.step8':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Journal Umum lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-menambah-jurnal-umum/' class='text-primary' target='_blanl'>artikel tutorial</a>.",
  'tour.add_product_conversion.step1':
    'Konversi produk adalah mengubah dari produk bahan baku menjadi produk jadi.',
  'tour.add_product_conversion.step2': 'Tentukan jumlah produk jadi yang akan dibuat.',
  'tour.add_product_conversion.step3': 'Pilih gudang tempat menyimpan produk jadinya.',
  'tour.add_product_conversion.step4':
    'Anda bisa mengubah kuantitas dari masing-masing bahan baku disini.',
  'tour.add_product_conversion.step5': 'Anda dapat mengubah biaya produksinya disini.',
  'tour.add_product_conversion.step6': 'Disini ditampilkan total biaya pokok untuk produk jadinya.',
  'tour.add_product_conversion.step7':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Konversi Produk lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.add_product_manufacture.step1':
    'Produk Manufaktur digunakan jika Anda ingin membuat proses produksi dari beberapa produk bahan baku menjadi produk jadi.',
  'tour.add_product_manufacture.step2':
    'Jika selain dengan proses produksi Anda bisa membeli produk ini, maka isikan harga belinya. Jika tidak, kosongkan harga beli.',
  'tour.add_product_manufacture.step3':
    'Jika produk ini adalah produk jadi, silahkan isi harga jualnya. Tapi jika berupa produk setengah jadi, silahkan kosongkan harga jualnya.',
  'tour.add_product_manufacture.step4':
    'Tambahkan beberapa produk bahan baku. Produk bahan baku harus diaktifkan pelacakan stok nya.',
  'tour.add_product_manufacture.step5': 'Anda bisa menambahkan biaya produksinya disini.',
  'tour.add_product_manufacture.step6':
    'Total harga pokok untuk produk manufaktur ini akan ditampilkan disini.',
  'tour.add_product_manufacture.step7':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Produk manufaktur lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.add_product_package.step1':
    'Produk Paket digunakan jika Anda ingin membundling beberapa produk menjadi satu paket.',
  'tour.add_product_package.step2': 'Tentukan harga jual produk paket',
  'tour.add_product_package.step3':
    'Pilih beberapa produk yang akan dipaketkan. Produk yang bisa dipaketkan hanya yang diaktifkan pelacakan stok nya.',
  'tour.add_product_package.step4':
    'Disini akan ditampilkan total harga pokok penjualan untuk produk paket ini.',
  'tour.add_product_package.step5':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Produk paket lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.add_product.step1':
    'Kode SKU (Stock Keeping Unit) adalah kode unik tiap produk. Kode akan tergenerate secara otomatis, atau Anda bisa juga mengubahnya.',
  'tour.add_product.step2':
    'Centang jika Anda membeli produk ini. Tentukan juga harga beli produknya.',
  'tour.add_product.step3':
    'Centang jika Anda menjual produk ini. Tentukan juga harga jual produknya.',
  'tour.add_product.step4': 'Silahkan centang jika Anda ingin melacak stok produk ini.',
  'tour.add_product.step5':
    'Klik disini untuk mengatur lebih detail tentang akun pembelian dan penjualan produk, serta akun persediaan barang produk.',
  'tour.add_product.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari fitur Produk lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-menambah-produk/' class='text-primary' target='_blanl'>artikel tutorial</a>.",
  'tour.add_purchase_invoice.step1':
    'Fitur Tagihan Pembelian digunakan saat vendor sudah menagihkan faktur yang perlu Anda bayar.<br/>Faktur tagihan pembelian akan otomatis tercatat di jurnal umum, dan stok produk akan otomatis bertambah.',
  'tour.add_purchase_invoice.step2': 'Pilih nama vendor atau bisa juga menambah data vendor baru.',
  'tour.add_purchase_invoice.step3':
    'Nomor tagihan pembelian akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_purchase_invoice.step4':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_purchase_invoice.step5':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_purchase_invoice.step6':
    'Pilih produk yang anda beli atau bisa juga menambah produk baru disini.',
  'tour.add_purchase_invoice.step7':
    'Anda dapat menuliskan pesan untuk ditampilkan saat cetak tagihan pembelian. Anda juga bisa melampirkan berkas tagihan disini.',
  'tour.add_purchase_invoice.step8':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.<br/>Untuk mempelajari fitur Tagihan Pembelian lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-membuat-tagihan-pembelian-purchase-invoice/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_purchase_order.step1':
    'Fitur Pemesanan Pembelian atau Purchase Order digunakan saat Anda melakukan pemesanan produk yang akan Anda beli kepada vendor.<br/>Pemesanan Pembelian yang berhasil dibuat tidak akan mempengaruhi jurnal umum dan tidak mempengaruhi stok produk.',
  'tour.add_purchase_order.step2': 'Pilih nama vendor atau bisa juga menambah data vendor baru.',
  'tour.add_purchase_order.step3':
    'Nomor Purchase Order akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_purchase_order.step4':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_purchase_order.step5':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_purchase_order.step6':
    'Pilih produk yang dipesan atau bisa juga menambah produk baru disini.',
  'tour.add_purchase_order.step7':
    'Anda dapat menuliskan pesan untuk ditampilkan saat cetak purchase order. Anda juga bisa melampirkan berkas purchase order disini.',
  'tour.add_purchase_order.step8':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.<br/>Untuk mempelajari fitur Pemesanan Pembelian lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-membuat-pesanan-pembelian-purchase-order/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_quote.step1':
    'Fitur Penawaran atau Quotation digunakan saat Anda memberikan penawaran kepada pelanggan atas produk yang Anda jual.<br/>Penawaran yang berhasil dibuat tidak akan mempengaruhi jurnal umum dan tidak mempengaruhi stok produk.',
  'tour.add_quote.step2':
    'Pilih nama pelanggan yang akan dibuatkan penawaran, atau bisa juga menambah data pelanggan baru.',
  'tour.add_quote.step3':
    'Nomor Quoatation akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_quote.step4':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_quote.step5':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_quote.step6':
    'Pilih produk yang ditawarkan atau bisa juga menambah produk baru disini.',
  'tour.add_quote.step7':
    'Anda dapat menuliskan pesan untuk ditampilkan saat cetak penawaran. Anda juga bisa melampirkan berkas penawaran disini.',
  'tour.add_quote.step8':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.<br/>Untuk mempelajari fitur Penawaran lebih lanjut, silakan klik <a href='https://kledo.com/cara-membuat-penawaran-quote/' class='text-primary' target='_blank'>artikel tutorial berikut ini</a>.",
  'tour.add_spend_money.step1':
    'Kirim dana digunakan untuk mengirimkan dana dari akun kas & bank kepada penerima',
  'tour.add_spend_money.step2': 'Pilih kontak penerima dana',
  'tour.add_spend_money.step3': 'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_spend_money.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_spend_money.step5': 'Pilih akun dan besar dana yang dikirimkan.',
  'tour.add_spend_money.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara mencatatkan transaksi kas dan bank, silakan lihat video tutorial atau <a href='https://kledo.com/cara-mencatat-kirim-dana-kas-bank/' class='text-primary' target='_blank'>artikel tutorial berikut</a>.",
  'tour.add_receive_money.step1':
    'Terima dana digunakan untuk menerima dana dari pengirim ke akun kas & bank.',
  'tour.add_receive_money.step2': 'Pilih kontak pengirim dana',
  'tour.add_receive_money.step3':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_receive_money.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_receive_money.step5': 'Pilih akun dan besar dana yang diterima.',
  'tour.add_receive_money.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara mencatatkan transaksi kas dan bank, silakan lihat video tutorial atau <a href='https://kledo.com/cara-mencatat-terima-dana-kas-bank/' class='text-primary' target='_blank'>artikel tutorial berikut</a>.",
  'tour.add_stockadjustment.step1':
    'Gunakan penyesuaian stok untuk melakukan penambahan atau pengurangan stok pada suatu gudang, atau melakukan stok opname.',
  'tour.add_stockadjustment.step2':
    'Jika ingin melakukan stok opname, pilih tipe perhitungan stok. Dengan tipe ini, jumlah stok barang akan dikunci sehingga seluruh pergerakan stok sebelum dilakukannya penyesuaian stok ini akan diabaikan.',
  'tour.add_stockadjustment.step3':
    'Jika ingin menambah atau mengurangi stok dari suatu gudang, pilih tipe Stok Masuk / Keluar.',
  'tour.add_stockadjustment.step4':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_stockadjustment.step5': 'Pilih akun penyesuaian stok untuk penjurnalan.',
  'tour.add_stockadjustment.step6':
    'Pilih produk yang akan disesuaikan stok nya, dan tentukan jumlah stok nya.',
  'tour.add_stockadjustment.step7': 'Ini adalah harga perolehan dari produk, atau harga beli.',
  'tour.add_stockadjustment.step8':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara stok opname, silakan lihat video tutorial berikut ini.',
  'tour.add_transfer_money.step1':
    'Transfer dana digunakan untuk memindahkan dana dari satu akun kas & bank ke akun kas & bank lainnya.',
  'tour.add_transfer_money.step2': 'Pilih akun asal dana.',
  'tour.add_transfer_money.step3': 'Pilih akun tujuan dana dikirim.',
  'tour.add_transfer_money.step4': 'Masukkan total dana yang akan ditransfer',
  'tour.add_transfer_money.step5':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_transfer_money.step6':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_transfer_money.step7':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara mencatatkan transaksi kas dan bank, silakan lihat video tutorial atau <a href='https://kledo.com/cara-mencatat-transfer-dana-kas-bank/' class='text-primary' target='_blank'>artikel tutorial berikut</a>.",
  'tour.add_warehouse_transfer_in.step1':
    'Gunakan transfer gudang untuk memindahkan stok produk dari satu gudang ke gudang yang lainnya.',
  'tour.add_warehouse_transfer_in.step2': 'Pilih gudang asalnya disini.',
  'tour.add_warehouse_transfer_in.step3':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_warehouse_transfer_in.step4':
    'Pilih produk yang akan dipindahkan stok nya, dan tentukan jumlah stok yang akan dipindahkan setelah Anda memilih gudang asal.',
  'tour.add_warehouse_transfer_in.step5':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara transfer gudang, silakan lihat video tutorial berikut ini.',
  'tour.add_warehouse_transfer_out.step1':
    'Gunakan transfer gudang untuk memindahkan stok produk dari satu gudang ke gudang yang lainnya.',
  'tour.add_warehouse_transfer_out.step2': 'Pilih gudang tujuannya disini.',
  'tour.add_warehouse_transfer_out.step3':
    'Isikan reference untuk catatan internal dan mempermudah pencarian',
  'tour.add_warehouse_transfer_out.step4':
    'Pilih produk yang akan dipindahkan stok nya, dan tentukan jumlah stok yang akan dipindahkan setelah Anda memilih gudang tujuan',
  'tour.add_warehouse_transfer_out.step5':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari lebih lanjut tentang cara transfer gudang, silakan lihat video tutorial berikut ini.',
  'tour.cash_bank.step1':
    'Fitur Kas & Bank digunakan mencatatkan keluar masuknya uang di suatu kas atau rekening bank.',
  'tour.cash_bank.step2': 'Anda bisa menambah akun kas atau bank disini.',
  'tour.cash_bank.step3':
    'Disini ditampilkan saldo akhir dari suatu bank dan grafik pergerakan saldonya jika kas & bank Anda kurang dari 30.',
  'tour.cash_bank.step4': 'Klik disini untuk mengatur akun bank ini.',
  'tour.cash_bank.step5':
    'Untuk mempelajari fitur Kas & Bank lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.contacts.step1':
    'Pada menu Kontak digunakan untuk menyimpan data kontak perusahaan Anda, termasuk pegawai, pelanggan maupun vendor.',
  'tour.contacts.step2': 'Klik disini untuk menambahkan kontak baru.',
  'tour.contacts.step3':
    'Anda bisa menambah kontak baru secara masal menggunakan excel dari tombol import, atau bisa juga mengexport seluruh data kontak ke excel.',
  'tour.contacts.step4':
    'Gunakan filter untuk memfilter kontak berdasarkan group maupun tipe kontak.',
  'tour.contacts.step5': 'Gunakan pencarian untuk mencari data kontak.',
  'tour.contacts.step6':
    'Untuk mempelajari fitur Kontak lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.conversion_balance.step1':
    'Anda bisa menentukan saldo awal dari masing-masing akun COA. Seluruh transaksi sebelum tanggal saldo awal diabaikan (atau di-reverse) oleh sistem.',
  'tour.conversion_balance.step2': 'Anda bisa mengubah tanggal saldo awal disini.',
  'tour.conversion_balance.step3':
    'Anda dapat mengimport saldo awal dari file excel disini, ataupun mengexport saldo awal ke excel.',
  'tour.conversion_balance.step4':
    'Tentukan nilai debit atau kredit dari masing-masing akun COA disini.',
  'tour.conversion_balance.step5': 'Total kredit dan debit harus sama.',
  'tour.conversion_balance.step6':
    "Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan. Untuk mempelajari cara pengisian saldo awal lebih lanjut, silakan lihat video tutorial atau <a href='https://kledo.com/cara-mengisi-saldo-awal/' class='text-primary' target='_blanl'>artikel tutorial</a>.",
  'tour.detail_inventory.step1': 'Disini ditampilkan detail dari suatu gudang.',
  'tour.detail_inventory.step2': 'Klik disini untuk melakukan penyesuaian stok atau stok opname.',
  'tour.detail_inventory.step3':
    'Klik disini untuk transfer gudang, atau memindahkan barang dari satu gudang ke gudang lainnya.',
  'tour.detail_inventory.step4': 'Berikut adalah daftar seluruh produk yang ada pada gudang ini.',
  'tour.detail_inventory.step5':
    'Disini Anda bisa menampilkan atau menyembunyikan kolom seperti kuantitas dan HPP.',
  'tour.detail_inventory.step6':
    'Klik disini untuk melihat detail transaksi dari seluruh produk pada gudang ini.',
  'tour.detail_inventory.step7':
    'Untuk mempelajari lebih lanjut tentang alur pencatatan stok, silahkan lihat video tutorial berikut ini.',
  'tour.fixed_assets.step1':
    'Dengan menggunakan fitur Aset Tetap, seluruh aset tetap perusahaan Anda tertata rapi, dan penyusutan bisa dijalankan otomatis, tak perlu repot lagi.',
  'tour.fixed_assets.step2':
    'Ini adalah aset tetap yang masih berupa draft. Anda bisa menambahkan draft aset tetap dari tagihan pembelian. Klik disini untuk melihat video tutorialnya.',
  'tour.fixed_assets.step3': 'Aset Terdaftar adalah aset tetap yang masih aktif.',
  'tour.fixed_assets.step4': 'Disini adalah aset tetap yang sudah dijual atau dilepaskan.',
  'tour.fixed_assets.step5': 'Anda bisa menambahkan aset tetap baru disini.',
  'tour.fixed_assets.step6':
    'Untuk menambahkan banyak aset sekaligus, silahkan gunakan fitur import. Anda juga bisa mengexport data aset ke excel disini.',
  'tour.fixed_assets.step7':
    'Klik disini untuk menjalankan penyusutan semua aset tetap secara otomatis.',
  'tour.inventory.step1': 'Pada menu inventori ditampilkan daftar gudang yang Anda miliki.',
  'tour.inventory.step2': 'Anda bisa menambah gudang baru disini.',
  'tour.inventory.step3': 'Total Jumlah adalah total item barang atau produk pada suatu gudang.',
  'tour.inventory.step4':
    'Total Nilai adalah total harga pokok penjualan (HPP) dari seluruh produk.',
  'tour.inventory.step5':
    'Untuk mempelajari lebih detail tentang cara pengelolaan gudang klik disini untuk melihat video tutorial.',
  'tour.layout_invoice.step1':
    'Layout Invoice digunakan untuk mengubah tampilan dari printout transaksi, termasuk cetak invoice, cetak label pengiriman, cetak surat jalan, cetak kwitansi, dll.',
  'tour.layout_invoice.step2':
    'Anda bisa mengupload logo perusahaan yang akan ditampilkan saat diprint.',
  'tour.layout_invoice.step3':
    'Silahkan klik icon berwarna kuning seperti ini untuk mengubah textnya.',
  'tour.layout_invoice.step4':
    'Pada bagian ini Anda bisa mengubah konfigurasi dari layout, misalnya apakah kolom diskon akan ditampilkan atau tidak.',
  'tour.layout_invoice.step5':
    'Anda bisa mengganti template dari printout disini, disediakan lebih dari 60 layout yang menarik. Setelah layout diubah, tampilan pada halaman ini tidak akan berubah ya, tapi saat di print nanti sudah berubah sesuai template yang Anda pilih.',
  'tour.layout_invoice.step6':
    'Untuk mempelajari cara pengaturan layout invoice lebih lanjut, silakan lihat video tutorial berikut.',
  'tour.invoices.step1':
    'Fitur Tagihan Penjualan atau Invoice digunakan saat Anda akan menagih pembayaran kepada pelanggan atas produk yang Anda jual.<br/>Faktur penjualan yang berhasil dibuat akan otomatis tercatat di jurnal umum, dan stok produk akan otomatis berkurang.',
  'tour.invoices.step2': 'Klik disini untuk membuat tagihan baru.',
  'tour.invoices.step3':
    'Disini Anda bisa mengimport banyak data dari excel, atau mengexport data ke excel.',
  'tour.invoices.step4':
    'Klik tombol filter berikut untuk memfilter tagihan berdasarkan tanggal, pelanggan ataupun tags.',
  'tour.invoices.step5': 'Gunakan pencarian untuk mencari Tagihan.',
  'tour.invoices.step6':
    'Tagihan dikelompokkan berdasarkan pembayaran yang sudah dilakukan, dari belum dibayar hingga lunas.',
  'tour.invoices.step7': 'Klik Lainnya untuk melihat status lainnya.',
  'tour.invoices.step8':
    'Anda bisa membuat Tagihan berulang secara otomatis disini. Misalnya membuat tagihan ke pelanggan rutin setiap bulan.',
  'tour.deliveries.step1':
    'Fitur Pengiriman atau Sales Delivery digunakan saat Anda melakukan pengiriman produk pesanan penjualan kepada pelanggan.<br/>Pengiriman yang berhasil dibuat otomatis akan terbentuk jurnal umum dan akan mengurangi stok produk.',
  'tour.deliveries.step2':
    'Untuk membuat pengiriman, silahkan buat pemesanan terlebih dahulu, kemudian buat pengiriman dari detail pemesanan tersebut.',
  'tour.deliveries.step3':
    'Klik tombol filter berikut untuk memfilter pengiriman berdasarkan tanggal, pelanggan ataupun tags.',
  'tour.deliveries.step4': 'Gunakan pencarian untuk mencari pengiriman.',
  'tour.deliveries.step5': 'Disini Anda bisa meng-expor seluruh data pengiriman ke excel.',
  'tour.deliveries.step6':
    'Pengiriman dengan status Open adalah pengiriman yang belum ditagihkan ke pelanggan.',
  'tour.deliveries.step7':
    'Pengiriman dengan status Selesai adalah pengiriman yang sudah ditagihkan ke pelanggan.',
  'tour.deliveries.step8':
    'Untuk mengubah status dari Open ke Selesai, buka detail pengiriman kemudian klik buat Tagihan.',
  'tour.orders.step1':
    'Fitur Pemesanan atau Sales Order digunakan saat Anda menerima pesanan penjualan dari pelanggan atas produk yang Anda jual.<br/>Pemesanan yang berhasil dibuat tidak akan mempengaruhi jurnal umum dan tidak mempengaruhi stok produk.',
  'tour.orders.step2': 'Klik disini untuk membuat pesanan baru.',
  'tour.orders.step3':
    'Disini Anda bisa mengimport banyak data dari excel, atau mengexport data ke excel.',
  'tour.orders.step4':
    'Klik tombol filter berikut untuk memfilter pemesanan berdasarkan tanggal, pelanggan ataupun tags.',
  'tour.orders.step5': 'Gunakan pencarian untuk mencari Pemesanan.',
  'tour.orders.step6':
    'Pesanan Penjualan dikelompokkan berdasarkan pembayaran yang sudah dilakukan, dari belum dibayar hingga lunas.',
  'tour.orders.step7': 'Klik Lainnya untuk melihat status lainnya.',
  'tour.orders.step8':
    'Anda bisa membuat Pemesanan berulang secara otomatis disini. Misalnya membuat sales order dari pelanggan rutin setiap bulan.',
  'tour.purchase_invoices.step1':
    'Fitur Tagihan Pembelian digunakan saat vendor sudah menagihkan faktur yang perlu Anda bayar.<br/>Faktur tagihan pembelian akan otomatis tercatat di jurnal umum, dan stok produk akan otomatis bertambah.',
  'tour.purchase_invoices.step2': 'Klik disini untuk membuat Tagihan Pembelian baru.',
  'tour.purchase_invoices.step3':
    'Disini Anda bisa mengimport banyak data dari excel, atau mengexport data ke excel.',
  'tour.purchase_invoices.step4':
    'Klik tombol filter berikut untuk memfilter Tagihan Pembelian berdasarkan tanggal, vendor ataupun tags.',
  'tour.purchase_invoices.step5': 'Gunakan pencarian untuk mencari Tagihan Pembelian.',
  'tour.purchase_invoices.step6':
    'Tagihan Pembelian dikelompokkan berdasarkan pembayaran yang sudah dilakukan, dari belum dibayar hingga lunas.',
  'tour.purchase_invoices.step7': 'Klik Lainnya untuk melihat status lainnya.',
  'tour.purchase_invoices.step8':
    'Anda bisa membuat Tagihan Pembelian berulang secara otomatis disini. Misalnya membuat tagihan dari vendor rutin setiap bulan.',
  'tour.purchase_deliveries.step1':
    'Fitur Pengiriman Pembelian atau Purchase Delivery digunakan saat Anda menerima pengiriman produk pesanan dari vendor.<br/>Pengiriman yang berhasil dibuat otomatis akan terbentuk jurnal umum dan akan menambah stok produk.',
  'tour.purchase_deliveries.step2':
    'Untuk membuat pengiriman pembelian, silahkan buat pemesanan pembelian terlebih dahulu, kemudian buat pengiriman dari detail pemesanan tersebut.',
  'tour.purchase_deliveries.step3':
    'Klik tombol filter berikut untuk memfilter pengiriman berdasarkan tanggal, vendor ataupun tags.',
  'tour.purchase_deliveries.step4': 'Gunakan pencarian untuk mencari pengiriman.',
  'tour.purchase_deliveries.step5': 'Disini Anda bisa meng-expor seluruh data pengiriman ke excel.',
  'tour.purchase_deliveries.step6':
    'Pengiriman dengan status Open adalah pengiriman yang belum ditagihan oleh vendor.',
  'tour.purchase_deliveries.step7':
    'Pengiriman dengan status Selesai adalah pengiriman yang sudah ditagihkan oleh vendor.',
  'tour.purchase_deliveries.step8':
    'Untuk mengubah status dari Open ke Selesai, buka detail pengiriman kemudian klik buat Tagihan Pembelian.',
  'tour.products.step1':
    'Klik disini untuk menambah produk baru. Anda juga bisa membuat produk paket maupun produk manufaktur.',
  'tour.products.step2':
    'Klik disini untuk mengimport banyak data produk sekaligus dari excel, atau mengexport data produk ke excel.',
  'tour.products.step3': 'Filter produk berdasarkan kategorinya',
  'tour.products.step4': 'Gunakan pencarian untuk mencari Produk',
  'tour.cash_bank_transactions.step1':
    'Fitur Kas & Bank digunakan mencatatkan keluar masuknya uang di suatu kas atau rekening bank.',
  'tour.cash_bank_transactions.step2':
    'Klik disini untuk membuat transaksi baru, kirim dana, terima dana ataupun transfer dana.',
  'tour.cash_bank_transactions.step3':
    'Klik disini untuk mengimport banyak data transaksi baru dengan excel, atau mengexport data kas dan bank ke excel.',
  'tour.cash_bank_transactions.step4':
    'Gunakan filter untuk memfilter data transaksi berdasarkan tanggal, status transaksi, maupun tag.',
  'tour.cash_bank_transactions.step5':
    'Transaksi di kledo merupakan transaksi yang sudah tercatat di aplikasi kledo.',
  'tour.cash_bank_transactions.step6':
    'Transaksi di bank merupakan data mutasi rekening bank Anda. Anda bisa mengconnectkan internet banking Anda dengan kledo, supaya data mutasi otomatis masuk ke Kledo.',
  'tour.cash_bank_transactions.step7':
    'Rekonsiliasi digunakan untuk mencocokkan transaksi di kledo dengan transaksi di bank, sehingga memastikan transaksi tercatat sama persis dengan transaksi riil di rekening bank.',
  'tour.cash_bank_transactions.step8':
    'Anda bisa membuat transaksi bank secara otomatis disini. Misalnya secara otomatis membuat penerimaan dana secara rutin setiap bulan.',
  'tour.cash_bank_transactions.step9':
    'Klik disini untuk mengkoneksikan internet banking Anda dengan Kledo, supaya otomatis data mutasi rekening bank masuk ke Kledo.',
  'tour.add_purchase_delivery.step1':
    'Fitur Pengiriman Pembelian atau Purchase Delivery digunakan saat Anda menerima pengiriman produk pesanan dari vendor.<br/>Pengiriman yang berhasil dibuat otomatis akan terbentuk jurnal umum dan akan menambah stok produk.',
  'tour.add_purchase_delivery.step2':
    'Nomor Pengiriman akan otomatis terbuat, tapi Anda juga bisa mengubahnya disini.',
  'tour.add_purchase_delivery.step3':
    'Anda bisa mengisi reference, sebagai catatan internal untuk mempermudah pencarian.',
  'tour.add_purchase_delivery.step4':
    'Tag dapat digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan tag ini.',
  'tour.add_purchase_delivery.step5':
    'Anda bisa mencatatkan ekspedisi pengiriman beserta nomor resi disini.',
  'tour.add_purchase_delivery.step6': 'Tentukan jumlah produk yang dikirim',
  'tour.add_purchase_delivery.step7':
    'Anda dapat menuliskan pesan dan juga bisa melampirkan berkas pengiriman disini.',
  'tour.add_purchase_delivery.step8': 'Silahkan isikan biaya pengiriman disini.',
  'tour.add_purchase_delivery.step9':
    'Setelah pengisian selesai, silakan klik tombol ini untuk menyimpan.',
  'tour.manual_journal.step1': 'Jurnal umum digunakan sebagai pencatatan manual pada penjurnalan.',
  'tour.manual_journal.step2': 'Anda bisa menambahkan Jurnal Umum disini.',
  'tour.manual_journal.step3':
    'Klik disini untuk mengimport banyak data jurnal umum sekaligus dari excel, atau mengexport data ke excel.',
  'tour.manual_journal.step4':
    'Anda bisa juga membuat transaksi jurnal umum berulang secara otomatis. Misalnya membuat jurnal umum setiap satu bulan sekali.',
  'tour.manual_journal.step5':
    'Gunakan filter untuk memfilter data jurnal umum berdasar tag maupun tanggal transaksi.',
  'tour.manual_journal.step6': 'Anda bisa mencari transaksi Jurnal Umum disini.',
  'financeInvoices.is_required': 'wajib diisi',
  'customColumn.required_field': 'Wajib Diisi',
  please_fill_in_the_custom_column: 'Silahkan isi custom column',
  'layoutReport.invoice_show_ref_trans_date_delivery': 'Tampilkan Tanggal Pengiriman',
  'layoutReport.invoice_show_ref_trans_date_order': 'Tampilkan Tanggal Pemesanan',
  'layoutReport.invoice_show_grand_total': 'Tampilkan Grand Total',
  'report.view_profitability': 'Lihat Profitabilitas',
  'layoutInvoice.invoice_use_payment_received_as_amount_in_word':
    'Tampilkan Nilai Terbilang dari Pembayaran Diterima',
  'businessFlow.invoice_form_show_warehouse': 'Tampilkan Gudang di Penjualan',
  'businessFlow.invoice_form_show_warehouse_desc':
    'Apakah gudang akan ditampilkan di transaksi penjualan?',
  'businessFlow.purchase_form_show_warehouse': 'Tampilkan Gudang di Pembelian',
  'businessFlow.purchase_form_show_warehouse_desc':
    'Apakah gudang akan ditampilkan di transaksi pembelian?',
  'businessFlow.invoice_payment_form_show_reference': 'Tampilkan {reference} di Terima Pembayaran',
  'businessFlow.invoice_payment_form_show_reference_desc':
    'Apakah input {reference} ditampilkan di form terima pembayaran tagihan penjualan? Jika dimatikan, {reference} tidak akan disimpan',
  'businessFlow.invoice_payment_form_show_tag': 'Tampilkan {tag} di Terima Pembayaran',
  'businessFlow.invoice_payment_form_show_tag_desc':
    'Apakah input {tag} ditampilkan di form terima pembayaran tagihan penjualan? Jika dimatikan, {tag} tidak akan disimpan',
  'businessFlow.purchase_payment_form_show_reference':
    'Tampilkan {reference} di Pembayaran Pembelian',
  'businessFlow.purchase_payment_form_show_reference_desc':
    'Apakah input {reference} ditampilkan di form pembayaran tagihan pembelian? Jika dimatikan, {reference} tidak akan disimpan',
  'businessFlow.purchase_payment_form_show_tag': 'Tampilkan {tag} di Pembayaran Pembelian',
  'businessFlow.purchase_payment_form_show_tag_desc':
    'Apakah input {tag} ditampilkan di form pembayaran tagihan pembelian? Jika dimatikan, {tag} tidak akan disimpan',
  'layoutInvoice.invoice_show_custom_field_item': 'Tampilkan Custom Columns Field Item',
  'layoutInvoice.invoice_show_custom_field': 'Tampilkan Custom Field Transaksi',
  'layoutInvoice.invoice_custom_field_selected': 'Custom Field Transaksi yang Ditampilkan',
  'layoutInvoice.invoice_custom_field_selected_placeholder': 'Semua custom field transaksi',
  send_price_changes_notification_to_customer: 'Notifikasi perubahan harga billing',
  still_has_past_due_bills_unpaid_on_this_vendor:
    'Anda masih mempunyai tagihan lewat jatuh tempo yang belum dibayar di {vendor} ini, {link} untuk melihat detail!',
  'businessFlow.reject_purchase_if_overdue':
    'Tolak pembelian baru jika masih ada tagihan lewat jatuh tempo yang belum dibayar',
  'businessFlow.reject_purchase_if_overdue_desc':
    'Tolak pembelian baru jika masih ada tagihan lewat jatuh tempo yang belum dibayar di kontak yang dipilih?',
  additional_discount_total: 'Total Tambahan Diskon',
  'businessFlow.contact_auto_ref_number': 'Apakah nomor di kontak akan diisi otomatis?',
  'businessFlow.contact_auto_ref_number_desc':
    'Nomor di kontak akan diisi otomatis saat membuat kontak baru berdasarkan format di penomoran otomatis.',
  'financeBanks.mass_reconcile_note_1':
    'Transaksi yang dipilih akan direkonsiliasi dengan transaksi di bank.',
  'financeBanks.mass_reconcile_note_2':
    'Jika untuk tanggal yang sama sudah terdapat transaksi di bank yang cocok, maka akan direkonsiliasi dengan transaksi tersebut.',
  'financeBanks.mass_reconcile_note_3':
    'Namun jika transaksi yang cocok tidak ditemukan, maka akan dibuatkan transaksi di bank yang baru.',
  failed_to_get_relation: 'Gagal mendapatkan data relasi',
  'businessFlow.invoice_proforma_desc':
    'Apakah perusahaan Anda membuat proforma sebagai dokumen awal untuk memecah pembayaran, baik di pemesanan maupun tagihan?',
  update_order: 'Ubah Pesanan',
  are_you_sure_to_delete_order: 'Apakah Anda yakin ingin menghapus pesanan ini?',
  delete_confirmation: 'Konfirmasi Hapus',
  'financeContacts.follow_these_steps_to_import_your_contact_payment_transaction':
    'Ikuti langkah-langkah berikut untuk meng-import Pembayaran {credit} {debit}',
  'financeContacts.1_download_your_contact_payment_transaction_template_file':
    '1. Download file template {credit} {debit}',
  'financeContacts.start_by_downloading_our_contact_payment_transaction_csv':
    'Mulai dengan mengunduh file template dalam format Excel. File ini mempunyai kolom header yang yang dibutuhkan Kledo untuk mengimport detail dari pembayaran {credit} {debit}-mu.',
  'financeContacts.2_copy_your_contact_payment_transaction_into_the_template':
    '2. Salin detail pembayaran {credit} {debit} ke dalam template',
  'financeContacts.import_contact_payment_transaction_using_excel_or_another_spreadsheet_editor':
    'Menggunakan Excel atau software spreadsheeet lainnya, masukkan detail pembayaran {credit} {debit} ke dalam file template dari Kledo. Pastikan detail pembayaran {credit} {debit} sesuai dengan kolom header yang ada di template.',
  'financeContacts.import_contact_payment_transactions': 'Import Pelunasan {credit} {debit}',
  'financeInvoices.delivery_order_number': 'Nomor Surat Jalan',
  please_input_the_amount: 'Silakan masukkan nominal',
  'notification.notification_import_success': 'Notifikasi berhasil import',
  'notification.notification_finance_approval': 'Notifikasi email approval',
  'notification.email_production_variance': 'Notifikasi email hasil konversi kurang dari formula',
  'notification.push_production_variance': 'Notifikasi mobile hasil konversi kurang dari formula',
  'notification.email_whatsapp_share_failed': 'Notifikasi email pesan WhatsApp gagal terkirim',
  'notification.push_whatsapp_share_failed': 'Notifikasi mobile pesan WhatsApp gagal terkirim',
  'notification.production_variance_tolerance': 'Toleransi selisih hasil konversi (%)',
  'notification.production_variance_tolerance_required': 'Toleransi selisih wajib diisi',
  'notification.production_variance_tolerance_range': 'Masukkan bilangan bulat 0–100',
  'financeDelivery.insufficient_stock_warning':
    'Tidak dapat menambah pengiriman, karena terdapat produk yang stok nya kurang.',
  'reports.live_dashboard': 'Live Dashboard',
  'reports.live_dashboard_desc1':
    'Live Dashboard digunakan untuk menampilkan statistik secara live pada layar monitor.',
  'reports.live_dashboard_desc2':
    'Live Dashboard memudahkan seluruh tim untuk memantau perkembangan perusahaan secara realtime.',
  scan_qr_code_to_make_payment: 'Scan QR Code untuk melakukan pembayaran',
  payment_total_amount: 'Total Pembayaran',
  qr_code_will_be_updated_automatically_after_each_transaction:
    'QR Code akan otomatis diperbarui setiap transaksi',
  qr_code_has_expired: 'QR Code telah kadaluarsa',
  generate_new_qr_code: 'Generate QR Code Baru',
  time_remaining: 'Waktu Tersisa',
  payment_with_qris_failed_please_try_again:
    'Pembayaran menggunakan QRIS gagal. Silakan coba lagi.',
  try_again: 'Coba Lagi',
  qris_compatible_banking_ewallet: 'Kompatibel dengan semua aplikasi perbankan dan e-wallet utama',
  qris_print_qris: 'CETAK QRIS',
  qris_customer: 'PELANGGAN',
  qris_terminal: 'TERMINAL',
  qris_total_amount_due: 'TOTAL YANG HARUS DIBAYAR',
  qris_payment_gateway_ready: 'Payment gateway siap menerima transaksi',
  qris_transaction_id: 'ID TRANSAKSI',
  qris_payment: 'Pembayaran QRIS',
  qris_pos_terminal: 'ENTERPRISE SAAS POS TERMINAL',
  qris_order: 'PESANAN',
  qris_cancel_payment: 'BATALKAN PEMBAYARAN',
  qris_check_payment_status: 'CEK STATUS PEMBAYARAN',
  qris_scan_to_pay: 'Scan untuk Bayar',
  ewallet_redirection_link: 'Link Pembayaran',
  ewallet_follow_link_description:
    'Berikan link di bawah kepada pelanggan untuk menyelesaikan pembayaran.',
  ewallet_midtrans_xendit_url: 'URL Transaksi',
  ewallet_copy: 'Salin',
  ewallet_open_payment_page: 'Buka Halaman Pembayaran',
  ewallet_redirect_info:
    'Arahkan pelanggan untuk menyelesaikan pembayaran di portal penyedia. Status akan diperbarui secara otomatis setelah diverifikasi.',
  ewallet_link_redirect_info: 'Link ini akan mengarahkan pelanggan ke portal pembayaran aman.',
  ewallet_status_auto_update_info:
    'Status pesanan akan diperbarui otomatis setelah pembayaran berhasil.',
  ewallet_securely_processed_by: 'Diproses Dengan Aman Oleh',
  ewallet_order_summary: 'RINGKASAN PESANAN',
  ewallet_order_reference: 'Referensi Pesanan',
  ewallet_total_amount: 'Jumlah Total',
  ewallet_current_status: 'Status Saat Ini',
  ewallet_payment_pending: 'Pembayaran Tertunda',
  ewallet_check_status_manually: 'Cek Status Secara Manual',
  ewallet_select_payment_method_first: 'Silahkan pilih metode pembayaran terlebih dahulu',
  ewallet_check_status_missing_params: 'Data pembayaran belum lengkap. Silakan coba lagi.',
  ewallet_check_status_failed: 'Gagal mengecek status pembayaran.',
  ewallet_payment_still_pending: 'Masih menunggu pembayaran.',
  ewallet_payment_success: 'Pembayaran Berhasil',
  ewallet_verified: 'TERVERIFIKASI',
  ewallet_secure_system: 'SISTEM AMAN',
  ewallet_transaction_verified: 'Transaksi telah terverifikasi oleh sistem pembayaran.',
  ewallet_transaction_id: 'ID TRANSAKSI',
  ewallet_payment_summary: 'RINGKASAN PEMBAYARAN',
  ewallet_order_number: 'Nomor Pesanan',
  ewallet_payment_method: 'Metode Pembayaran',
  ewallet_e_wallet: 'E-Wallet',
  ewallet_total_paid: 'Total Dibayar',
  ewallet_done: 'Selesai',
  ewallet_print_receipt: 'Cetak Struk',
  ewallet_payment_url_not_available: 'URL pembayaran tidak tersedia',
  ewallet_url_copied: 'URL berhasil disalin',
  ewallet_checking_status: 'Memeriksa status pembayaran...',
  please_input_the_recipient_email_address: 'Silahkan masukkan alamat email penerima',
  reciepent_email_address: 'Alamat Email Penerima',
  'layoutInvoice.invoice_vertical_align_item': 'Tampilkan Teks Kolom Rata Atas',
  you_have_already_entered_serial_numbers:
    'Anda sudah memasukkan serial number, jika tetap ingin melanjutkan maka serial number yang sudah ada akan dihapus.',
  show_all: 'Tampilkan semua',
  if_checked_show_all_serial_numbers:
    'Jika dicentang, semua nomor seri akan ditampilkan — termasuk yang tidak tersedia di gudang yang dipilih.',
  'billing.here': 'disini',
  'billing.is_invoice_quota_exceeded':
    'Kuota invoice Anda sudah habis. Silahkan menambah addon invoice {here} untuk menambah invoice selanjutnya',
  'billing.is_invoice_quota_almost_full':
    'Kuota invoice Anda segera habis. Silahkan menambah addon invoice {here} untuk menambah limit invoice Anda',
  sort_items_by_product_name_asc: 'Urutkan Item Secara Ascending Berdasarkan Nama {product}',
  'layoutInvoice.invoice_show_invoice_number': 'Tampilkan Nomor',
  'financeContacts.opening_hour': 'Jam Buka',
  'financeContacts.closing_hour': 'Jam Tutup',
  'zap.archive': 'Arsip',
  'zap.view_geo_tagging': 'Lihat Geo Tagging',
  'zap.fleet_name': 'Nama Armada',
  'zap.license_plate_number': 'Nomor Plat',
  'zap.length': 'Panjang',
  'zap.width': 'Lebar',
  'zap.height': 'Tinggi',
  'zap.weight': 'Berat',
  'zap.driver_desc': 'Driver yang dapat mengendarai armada',
  'zap.helper_desc': 'Helper yang dapat menjadi helper di armada',
  'zap.customer_desc': '{customer} yang dapat menggunakan armada',
  'zap.all_drivers': 'Semua Driver',
  'zap.all_helpers': 'Semua Helper',
  'zap.all_customers': 'Semua {customer}',
  'zap.select_manual': 'Pilih Manual',
  'zap.select_driver': 'Pilih Driver',
  'zap.driver_help_text':
    'Kontak driver dibuat otomatis jika belum ada email atau nama yang cocok. Bila ditemukan lebih dari satu kecocokan, sistem memakai kontak teratas pada hasil pencarian.',
  'zap.driver_label': 'Pilih driver yang dapat mengendarai Armada',
  'zap.helper_label': 'Pilih helper yang dapat menjadi helper di armada',
  'zap.helper_help_text': 'Helper digunakan seperti driver cadangan atau driver kedua',
  'zap.select_helper': 'Pilih Helper',
  'zap.select_customer': 'Pilih {customer}',
  'zap.customer_label': 'Pilih {customer} yang dapat menjadi customer di armada',
  'zap.fleet_name_is_required': 'Nama armada harus diisi',
  'zap.license_plate_number_is_required': 'Nomor plat harus diisi',
  'zap.length_is_required': 'Panjang harus diisi',
  'zap.width_is_required': 'Lebar harus diisi',
  'zap.height_is_required': 'Tinggi harus diisi',
  'zap.weight_is_required': 'Berat harus diisi',
  'zap.select_location_on_map': 'Pilih Lokasi di Peta',
  'zap.select_location': 'Pilih Lokasi',
  'zap.center_to_marker': 'Center ke marker',
  'zap.route_driver_label': 'Pilih Driver yang dapat menggunakan Rute',
  'zap.select_sales': 'Pilih Sales',
  'zap.all_sales': 'Semua Sales',
  'zap.sales_label': 'Pilih Sales yang dapat menggunakan Rute',
  'zap.route_name': 'Nama Rute',
  'zap.route_name_is_required': 'Nama Rute harus diisi',
  'zap.enter_route_name': 'Masukkan Nama Rute',
  'zap.hide_map': 'Sembunyikan Peta',
  'zap.show_map': 'Tampilkan Peta',
  'zap.selected_customers': '{customer} Terpilih',
  'zap.routes_all_drivers': 'Semua Driver Dapat Menggunakan Rute Ini',
  'zap.routes_all_sales': 'Semua Sales Dapat Menggunakan Rute Ini',
  'financeDelivery.delivery_recap': 'Rekap Pengiriman',
  'financeDelivery.delivery_recap_confirm': 'Konfirmasi Pengiriman',
  'zap.canvassing': 'Canvassing',
  'zap.canvassing_total_days': 'Jumlah Hari',
  'zap.canvassing_qty_item': 'Qty Item',
  'zap.canvassing_page_help':
    'Pada Canvassing, tim Canvasser Anda akan membawa stok {product} untuk dijual langsung ke {customer}.',
  'zap.canvassing_stock_taken': 'Stok Diambil',
  'zap.canvassing_stock_sold': 'Stok Terjual',
  'zap.canvassing_stock_remaining': 'Sisa Stok',
  'zap.canvassing_detail_stock_returned_to_warehouse': 'Stok Dikembalikan ke Gudang',
  'zap.canvassing_detail_per_warehouse': 'Per Gudang',
  'zap.canvassing_lock_stock': 'Kunci Stok',
  'zap.canvassing_set_as_draft': 'Set Sebagai Draft',
  'zap.canvassing_cancel_lock_stock': 'Batalkan Kunci Stok',
  'zap.canvassing_start': 'Mulai Canvassing',
  'zap.canvassing_end': 'Akhiri Canvassing',
  'zap.canvassing_finish_stock': 'Selesaikan Stok',
  'zap.canvassing_return_stock_modal_title': 'Selesaikan Stok Canvassing {refNumber}',
  'zap.canvassing_return_stock_save': 'Simpan & Kembalikan Stok ke Gudang',
  'zap.canvassing_complete_modal_title': 'Akhiri Canvassing {refNumber}',
  'zap.canvassing_complete_confirm': 'Apakah Anda yakin untuk mengakhiri canvassing ini?',
  'zap.canvassing_complete_block_unpaid_invoice':
    'Tidak dapat mengakhiri canvassing karena masih ada invoice yang belum lunas.',
  'zap.settings_business_flow': 'Alur Bisnis',
  'zap.settings_business_flow_desc': 'Atur alur canvassing dan rekap pengiriman Zap.',
  'zap.settings_end_canvassing_with_unpaid_invoice':
    'Izinkan akhiri canvassing dengan faktur belum lunas',
  'zap.settings_end_canvassing_with_unpaid_invoice_note':
    'Apakah canvassing boleh diakhiri walaupun ada faktur yang belum lunas?',
  'zap.settings_delivery_recap': 'Rekap Pengiriman',
  'zap.settings_delivery_recap_fuel_used_required':
    'Wajib isi bahan bakar saat konfirmasi rekap pengiriman',
  'zap.settings_delivery_recap_fuel_used_required_note':
    'Apakah bahan bakar wajib diisi saat konfirmasi rekap pengiriman dengan armada perusahaan?',
  'zap.settings_driver_accounts': 'Akun Driver',
  'zap.settings_driver_delivery_recap_accounts': 'Akun yang ditampilkan untuk driver',
  'zap.settings_driver_delivery_recap_accounts_note':
    'Akun ini ditampilkan pada rekap pengiriman di aplikasi mobile driver.',
  'zap.canvassing_view_warehouse_transfers': 'Lihat Daftar Transfer Gudang',
  'zap.canvassing_warehouse_transfers_modal_title': 'Daftar Transfer Gudang',
  'zap.canvassing_warehouse_transfers_modal_subtitle':
    'Transfer gudang ini terbuat otomatis oleh transaksi canvassing.',
  'zap.canvassing_add_start_date_required': 'Tanggal mulai wajib diisi',
  'zap.canvassing_add_start_not_before_now':
    'Tanggal dan waktu mulai tidak boleh lebih awal dari saat ini',
  'zap.canvassing_add_end_date_required': 'Tanggal selesai wajib diisi',
  'zap.canvassing_add_end_before_start':
    'Tanggal selesai tidak boleh lebih kecil dari tanggal mulai',
  'zap.canvassing_add_qty_available': 'Qty Tersedia',
  'zap.canvassing_add_qty_required': 'Qty wajib diisi',
  'zap.canvassing_add_qty_product_unavailable': 'Qty produk tidak tersedia',
  'zap.canvassing_add_qty_insufficient': 'Qty tidak mencukupi',
  'zap.canvassing_edit_qty_below_sold': 'Qty tidak boleh kurang dari qty yang sudah terjual.',
  'zap.canvassing_add_min_one_product_qty': 'Harus ada minimal 1 produk dengan qty lebih dari 0',
  'zap.hour': 'Jam',
  'zap.hours': 'Jam',
  'zap.minute': 'Menit',
  'zap.minutes': 'Menit',
  'zap.fleet': 'Armada',
  'zap.start_warehouse': 'Mulai dari Gudang',
  'zap.start_warehouse_is_required': 'Mulai dari gudang wajib diisi',
  'zap.end_warehouse': 'Selesai di Gudang',
  'zap.1_end_warehouse_help_text':
    'Jika selesai di gudang tidak dipilih, maka lokasi antaran terakhir menjadi titik akhir',
  'zap.2_end_warehouse_help_text':
    'Jika dipilih maka gudang selesai harus sama dengan gudang mulai',
  'zap.fleet_is_required': 'Armada wajib diisi',
  'zap.driver_is_required': 'Driver wajib diisi',
  'zap.sales_is_required': 'Sales wajib diisi',
  'zap.select_fleet': 'Pilih Armada',
  'zap.geo_tagging_is_not_set': 'Geo tagging belum diset',
  'zap.add_delivery': 'Tambahkan Pengiriman',
  'zap.selected_delivery': 'Pengiriman Terpilih',
  'zap.route': 'Rute',
  'zap.all_routes': 'Semua Rute',
  'zap.per_delivery': 'Per Pengiriman',
  'zap.weight_volume_exceeds_fleet_capacity': 'Berat/volume melebihi kapasitas armada',
  'zap.weight_volume_exceeds_fleet_capacity_desc': 'Apakah Anda yakin untuk melanjutkan?',
  'zap.mark_on_the_go': 'Tandai Dalam Perjalanan',
  'zap.shipping_confirmation': 'Konfirmasi Pengiriman',
  'zap.deliveries': 'Pengiriman',
  'zap.total_distance': 'Total Jarak',
  'zap.total_time': 'Total Waktu',
  'zap.travel_document': 'Surat Jalan',
  'zap.recorded': 'Tercatat',
  'zap.capacity_used': 'Kapasitas Digunakan',
  'zap.deliveries_completed': 'Pengiriman Selesai',
  'zap.products_sent': '{product} Terkirim',
  'zap.estimated_arrival': 'Estimasi Tiba',
  'zap.travel_expenses': 'Pengeluaran Perjalanan',
  'zap.route_map': 'Map Rute',
  'zap.start': 'Berangkat',
  'zap.end': 'Kembali',
  'zap.destination': 'Tujuan',
  'zap.stop': 'Pemberhentian {number}',
  'zap.route_destination_not_found': 'Rute destinasi tidak dapat ditemukan',
  'zap.start_odometer_is_required': 'Odometer berangkat wajib diisi',
  'zap.end_odometer_is_required': 'Odometer kembali wajib diisi',
  'zap.enter_number': 'Masukkan Nomor',
  'zap.departure_time_is_required': 'Waktu berangkat wajib diisi',
  'zap.arrival_time_is_required': 'Waktu datang wajib diisi',
  'zap.confirm_items_note':
    'Silahkan mengisi barang yang telah dikirim oleh Supir dan barang yang ingin Anda kirimkan kembali untuk pengiriman selanjutnya.',
  'zap.time': 'Waktu',
  'zap.attachment_of_proof_of_payment': 'Attachment bukti bayar',
  'zap.description_is_required': 'Deskripsi wajib diisi',
  'zap.expenses': 'Pengeluaran',
  'zap.time_to_arrive': 'Waktu Tiba',
  'zap.order': 'Pesanan',
  'zap.remains': 'Sisa',
  'zap.resend': 'Kirim Lagi',
  'zap.item_sent': 'Barang Terkirim',
  'zap.distance_from_warehouse': 'Jarak dari Gudang',
  'zap.view_delivery_recap': 'Lihat Rekap Pengiriman',
  'zap.map_still_processed': 'Peta pengiriman Anda sedang diproses',
  'zap.warehouse_start': 'Gudang Mulai',
  'zap.warehouse_end': 'Gudang Selesai',
  'zap.has_resend_confirm_title': 'Pengiriman baru akan dibuat',
  'zap.has_resend_confirm_desc':
    'Dikarenakan ada barang yang akan dikirim kembali, maka sistem otomatis akan membuat Pengiriman atau Surat Jalan baru.',
  'zap.minimum_1_delivery': 'Minimal 1 pengiriman',
  'zap.confirm_arrival_time_is_required': 'Waktu tiba wajib diisi',
  'zap.latitude_is_required': 'Latitude wajib diisi',
  'zap.longitude_is_required': 'Longitude wajib diisi',
  'zap.delivery_is_combined_into_delivery_recap': 'Pengiriman digabung ke Rekap Pengiriman',
  'reports.live_dashboard_open_full_screen': 'Buka Layar Penuh',
  fullscreen: 'Layar Penuh',
  exitFullscreen: 'Keluar Layar Penuh',
  validity_without_time_limit: 'Berlaku tanpa batas waktu',
  valid_period: 'Berlaku {start} - {end}',
  percentage: 'Persentase',
  nominal: 'Nominal',
  min_transaction: 'Min. transaksi',
  min_quantity: 'Min. kuantitas',
  promo_period: 'Periode Promo',
  discount: 'Diskon',
  quota: 'Kuota {quota}',
  list_promo: 'Daftar Promo',
  'manualJournal.max_character': 'Maksimal {amount} Karakter',
  address_empty_state:
    'Belum ada alamat yang terdaftar di kontak ini, Anda bisa menambahkan alamat di sini.',
  no_address_yet: 'Data Alamat Kosong',
  adding_tag: 'Tambahkan Tag',
  'financeOrder.cancel_close_order': 'Batalkan Tutup Pemesanan',
  'layoutInvoice.invoice_show_signature_image': 'Tampilkan Gambar Tanda Tangan',
  'layoutInvoice.image_hidden': 'Gambar disembunyikan',
  options: 'Opsi',
  'modifier.extra': 'Ekstra',
  'modifier.price_excludes_extra': 'Belum termasuk ekstra {value} per item',
  'modifier.group_name_label': 'Nama Produk Ekstra',
  'modifier.group_name_placeholder': 'Contoh: Topping',
  'modifier.type_label': 'Jenis Ekstra',
  'modifier.type_optional': 'Opsional',
  'modifier.type_optional_hint': 'Pelanggan tidak wajib memilih sub ekstra yang tersedia.',
  'modifier.type_required': 'Wajib',
  'modifier.type_required_hint': 'Pelanggan wajib memilih minimal satu sub ekstra.',
  'modifier.selection_label': 'Cara Pilih Ekstra',
  'modifier.selection_single': 'Pilih Salah Satu',
  'modifier.selection_single_hint': 'Pelanggan hanya bisa memilih satu sub ekstra.',
  'modifier.selection_multiple': 'Pilih Beberapa',
  'modifier.selection_multiple_hint': 'Pelanggan bisa memilih lebih dari satu sub ekstra.',
  'modifier.allow_qty_hint': 'Izinkan satu sub ekstra dipesan lebih dari 1 (mis. Extra Shot ×2).',
  'modifier.sub_extra': 'Sub Ekstra',
  'modifier.sub_name_label': 'Nama Sub Ekstra',
  'modifier.sub_name_placeholder': 'Contoh: Small',
  'modifier.sub_price_label': 'Harga Jual',
  'modifier.sub_product_label': '{product}',
  'modifier.sub_qty_label': 'Takaran',
  'modifier.without_product': 'Tanpa {product}',
  'modifier.product_qty_must_be_positive': 'Takaran harus lebih dari 0',
  'modifier.add_sub_extra': 'Tambah Sub Ekstra',
  'modifier.required_needs_active_sub': 'Jenis "Wajib" butuh minimal satu sub ekstra yang aktif.',
  'modifier.name_placeholder': 'mis. Level Gula, Tambahan Topping',
  'modifier.min_selected': 'Min. Pilih',
  'modifier.min_selected_hint': 'Jumlah minimum opsi yang wajib dipilih pelanggan. 0 = opsional.',
  'modifier.min_selected_invalid': 'Minimal pilih tidak valid',
  'modifier.min_must_be_lte_max': 'Min. pilih tidak boleh lebih dari maks. pilih',
  'modifier.min_must_be_lte_active_options': 'Min. pilih tidak boleh lebih dari jumlah opsi aktif',
  'modifier.max_selected': 'Maks. Pilih',
  'modifier.max_selected_hint':
    'Jumlah maksimum opsi yang boleh dipilih. 1 = pilihan tunggal (radio).',
  'modifier.max_selected_invalid': 'Maksimal pilih minimal 1',
  'modifier.allow_quantities': 'Izinkan Qty',
  'modifier.allow_quantities_hint': 'Izinkan satu opsi dipesan lebih dari 1 (mis. Extra Shot ×2).',
  'modifier.options_hint': 'Tambahkan opsi beserta harga tambahannya.',
  'modifier.option_name': 'Nama Opsi',
  'modifier.option_price': 'Harga',
  'modifier.option_is_required': 'Nama opsi wajib diisi',
  'modifier.option_price_is_required': 'Harga wajib diisi',
  'modifier.option_must_be_unique': 'Nama opsi harus unik',
  'modifier.active': 'Aktif',
  'modifier.inactive': 'Tidak Aktif',
  'modifier.status': 'Status',
  'modifier.free': 'Gratis',
  'modifier.rules': 'Aturan',
  'modifier.required': 'Wajib',
  'modifier.single_choice': 'Pilih 1',
  'modifier.max_n': 'Maks. {n}',
  'modifier.qty': 'Qty',
  'modifier.confirm_delete': 'Apakah Anda yakin ingin menghapus ekstra ini?',
  'modifier.delete_blocked_title': 'Tidak dapat dihapus',
  'modifier.delete_blocked_used':
    'Ekstra ini sudah digunakan pada produk atau transaksi sehingga tidak dapat dihapus.',
  'modifier.deactivate_instead': 'Nonaktifkan saja',
  'modifier.product_assign_hint': 'Pilih grup ekstra yang akan ditawarkan saat produk ini dipesan.',
  'modifier.product_assign_tooltip':
    'Ekstra adalah pilihan tambahan pada produk yang dapat dipilih saat melakukan pemesanan, seperti topping, ukuran, atau pilihan lainnya.',
  'modifier.select_groups_placeholder': 'Pilih grup ekstra',
  'modifier.assign_failed': 'Gagal menyimpan ekstra produk',
  'modifier.assign_title_add': 'Tambah Ekstra',
  'modifier.assign_title_update': 'Perbarui Ekstra',
  'modifier.assign_empty': 'Belum ada Ekstra. Buat dulu lewat menu Ekstra di daftar produk.',
  'modifier.assign_saved': 'Ekstra produk berhasil diperbarui.',
  'modifier.detach_confirm': 'Lepas ekstra ini dari produk?',
  'modifier.choose_extra': 'Pilih Ekstra',
  'modifier.line_total': 'Total',
  'modifier.below_min_selected': 'Grup "{group}" wajib memilih minimal {n} opsi.',
  'modifier.above_max_selected': 'Grup "{group}" hanya boleh memilih maksimal {n} opsi.',
  variant_option_is_required: 'Opsi varian wajib diisi!',
  variant: 'Varian',
  are_you_sure_you_want_to_delete_this_variant: 'Apakah Anda yakin ingin menghapus varian ini?',
  add_product_variant: 'Tambah {title} Varian',
  duplicate_product_variant: 'Duplikat {title} Varian',
  all_variant: 'Semua Varian',
  select_options: 'Pilih Opsi',
  set_price_for_all_variants: 'Atur harga untuk semua varian yang dipilih',
  select_variant: 'Pilih Varian',
  max_options_count: 'Maksimal {count} opsi yang bisa dipilih',
  max_variants_count: 'Maksimal {count} varian yang bisa ditambahkan',
  please_select_variant: 'Silahkan pilih varian',
  please_select_option: 'Silahkan pilih opsi',
  variant_only: 'Varian Saja',
  variant_with_title: 'Varian {title}',
  this_option_is_used_in: 'Opsi ini digunakan di {count} produk',
  this_option_is_not_used_in: 'Opsi ini belum digunakan di produk',
  main_product_variant: 'Produk Utama Varian',
  main_product: 'Produk Utama',
  main_product_variant_tooltip: 'Jika dicentang, hanya menampilkan produk utama saja',
  edit_product_variant: 'Ubah {title} Varian',
  variant_option_must_be_unique: 'Opsi varian harus unik!',
  'product_variant.option_limit_title': 'Tingkatkan paket Anda',
  'product_variant.option_limit_message':
    'Paket {plan} mendukung maksimal {count} opsi varian. Upgrade ke {nextPlan} untuk menambahkan hingga {nextCount} opsi.',
  'product_variant.option_limit_pill': '{plan}: {count} opsi',
  'report.total_return': 'Total Retur',
  'report.return_amount': 'Jumlah Retur',
  no_transaction_selected: 'Belum ada transaksi yang dipilih',
  outlet_is_required: 'Outlet wajib dipilih',
  please_input_the_cashier_balance: 'Masukkan nominal uang kasir',
  the_cashier_balance_will_be_used_as_the_return_balance:
    'Nominal uang kas yang masuk digunakan sebagai modal kembalian',
  shift_not_found: 'Shift Tidak Ditemukan',
  shift_not_found_on_database:
    'Shift tidak ditemukan di database. Apakah Anda yakin ingin mereset shift dan membuka shift baru?',
  please_input_the_pin_code: 'Silakan masukkan kode PIN',
  input_the_last_cashier_balance: 'Masukkan Total Uang Tunai Kas Kasir',
  input_the_last_cashier_balance_desc: 'Uang kas kasir terakhir yang dipegang saat tutup shift',
  input_yout_pin_code: 'Masukkan kode PIN Anda',
  receipt: 'Struk',
  set_logo_store_information_and_receipt_display:
    'Atur logo, informasi toko, dan detail struk sesuai kebutuhan',
  outlet_logo: 'Logo Outlet',
  business_name: 'Nama Usaha',
  setting_print_receipt_layout: 'Pengaturan Layout Cetak Struk',
  setting_preview: 'Pengaturan Tampilan',
  preview_receipt: 'Tampilan Struk',
  order_number: 'No. Order',
  time: 'Waktu',
  action_value_from_receipt: '{action} {value} di Struk',
  show: 'Tampilkan',
  hidden: 'Sembunyikan',
  print_mode: 'Mode Cetak',
  receipt_logo: 'Logo Struk',
  'layoutInvoice.return_print_delivery': 'Surat Jalan Retur',
  'layoutInvoice.purchase_return_print_delivery': 'Surat Jalan Retur Pembelian',
  'financeInvoices.print_return_delivery': 'Cetak Surat Jalan Retur',
  'financeInvoices.print_purchase_return_delivery': 'Cetak Surat Jalan Retur Pembelian',
  'businessFlow.invoice_lock_future_transaction_date': 'Tolak Transaksi Tanggal Masa Depan',
  'businessFlow.invoice_lock_future_transaction_date_desc':
    'Tolak buat transaksi yang tanggalnya adalah tanggal setelah hari ini',
  'businessFlow.invoice_payment_sync': 'Sinkronkan Tag Invoice dan Pembayaran',
  'businessFlow.invoice_payment_sync_desc':
    'Jika tag pada invoice diubah, tag pada detail pembayaran akan diperbarui secara otomatis sehingga pengguna hanya perlu melakukan perubahan satu kali pada invoice.',
  'businessFlow.quote_auto_delete_enabled': 'Hapus Otomatis {quote} Lama',
  'businessFlow.quote_auto_delete_enabled_desc':
    'Setiap bulan, {quote} yang usianya melewati ambang batas akan dihapus otomatis. {quote} yang sudah selesai atau sudah dipesan sebagian tidak akan dihapus.',
  'businessFlow.quote_auto_delete_months': 'Umur {quote} yang Dihapus (Bulan)',
  'businessFlow.quote_auto_delete_months_desc':
    'Dihitung dari tanggal {quote} dibuat. Isi antara 1 sampai 60 bulan.',
  'businessFlow.quote_auto_delete_months_validation': 'Isi antara 1 sampai 60 bulan.',
  'businessFlow.price_forecast': 'Forecast Harga Bahan Baku',
  'businessFlow.price_forecast_desc':
    'Proyeksikan biaya bahan baku berdasarkan skenario kenaikan harga saat membuat penawaran, sehingga harga jual yang ditawarkan tetap sesuai dengan estimasi biaya di masa depan.',
  'businessFlow.purchase_invoice_lock_future_transaction_date':
    'Tolak Transaksi Tanggal Masa Depan',
  'businessFlow.purchase_invoice_lock_future_transaction_date_desc':
    'Tolak buat transaksi yang tanggalnya adalah tanggal setelah hari ini',
  'businessFlow.purchase_invoice_payment_sync': 'Sinkronkan Tag Invoice dan Pembayaran',
  'businessFlow.purchase_invoice_payment_sync_desc':
    'Jika tag pada invoice diubah, tag pada detail pembayaran akan diperbarui secara otomatis sehingga pengguna hanya perlu melakukan perubahan satu kali pada invoice.',
  can_not_select_future_transaction_date: 'Tidak dapat memilih tanggal transaksi masa depan',
  total_transactions_found: 'Total {count} data ditemukan',
  confirmation: 'Konfirmasi!',
  variant_already_added_will_be_deleted_are_you_sure:
    'Variant yang sudah ditambahkan akan dihapus, apakah anda yakin?',
  close_shift: 'Tutup Shift',
  please_select_all_variants_to_continue: 'Silakan pilih semua variant untuk melanjutkan',
  variant_not_available: 'Variant tidak tersedia',
  cash_in_out: 'Kas Masuk/Keluar',
  are_you_sure_you_want_to_delete_this_data: 'Apakah Anda yakin ingin menghapus data ini?',
  manual_cash_payment: 'Pembayaran Tunai Manual',
  'table.min_two_column': 'Minimal tampil dua kolom',
  'button.print_approval': 'Cetak Approval',
  total_cash_cashier: 'Total Kas Kasir',
  payment_details: 'Rincian Pembayaran',
  success_transaction: 'Transaksi Berhasil!',
  payment_successful: 'Pembayaran Berhasil',
  order_ref: 'Order Ref',
  change_due: 'KEMBALIAN',
  total_paid: 'Total Dibayar',
  order_total: 'Total Pesanan',
  payment_method: 'Metode Pembayaran',
  receipt_summary: 'Ringkasan Struk',
  share_receipt: 'BAGIKAN STRUK',
  print_receipt: 'Cetak Struk',
  new_transaction: 'Transaksi Baru',
  unit: 'unit',
  units: 'unit',
  additional_fee: 'Biaya Tambahan',
  e_wallet: 'E-Wallet',
  online_delivery: 'Pengiriman Online',
  edc: 'EDC',
  e_commerce: 'E-Commerce',
  other: 'Lainnya',
  transfer_bank: 'Transfer Bank',
  bank_transfer_payment_title: 'Transfer Bank',
  edc_payment_title: 'Pembayaran EDC',
  process_enterprise_transaction_details:
    'Proses detail transaksi perusahaan untuk penyelesaian masuk',
  customer_bank_details: 'Detail Bank Pelanggan',
  payment_and_destination: 'Pembayaran & Tujuan',
  transfer_bank_remember_title: 'Gunakan {bank} untuk Transfer seterusnya?',
  transfer_bank_remember_desc:
    'Transaksi berikutnya yang memilih Transfer akan langsung tercatat ke {bank} tanpa membuka form ini lagi. Bisa diubah kapan saja lewat ikon di tombol Transfer atau Pengaturan POS.',
  transfer_bank_remember_answer: 'Ingat jawaban saya',
  transfer_bank_remember_yes: 'Ya, gunakan terus',
  transfer_bank_remember_no: 'Tidak, tanya lagi nanti',
  transfer_bank_auto_to: 'Otomatis ke {bank}',
  transfer_bank_stop_auto: 'Berhenti otomatis',
  transfer_bank_stop_auto_confirm: 'Berhenti pakai {bank} otomatis?',
  transfer_bank_auto_bank_missing: 'Bank tujuan tersimpan sudah tidak aktif, silakan pilih ulang',
  transfer_bank_auto_setting_title: 'Transfer Otomatis',
  transfer_bank_auto_setting_note:
    'Jika diaktifkan, klik Transfer di kasir langsung mencatat pembayaran ke bank tujuan di bawah tanpa membuka form. Pengaturan ini tersimpan di perangkat ini saja.',
  total_payable_amount: 'TOTAL JUMLAH YANG HARUS DIBAYAR',
  deposit: 'Deposit',
  qris: 'QRIS',
  printer_setting: 'Pengaturan Printer',
  printer_name: 'Nama Printer',
  printer_variant: 'Jenis Printer',
  printer_type: 'Tipe Printer',
  please_select_printer: 'Silakan pilih printer',
  please_select_variant_printer: 'Silakan pilih jenis printer',
  print_method: 'Metode Print',
  add_printer: 'Tambah Printer',
  edit_printer: 'Edit Printer',
  select_printer: 'Pilih Printer',
  cashier_printer: 'Printer Kasir',
  kitchen_printer: 'Printer Dapur',
  label_printer: 'Printer Label',
  loading_printer_list: 'Memuat daftar printer...',
  no_printer_detected_make_sure_qztray_is_running:
    'Tidak ada printer yang terdeteksi. Pastikan QZ Tray sudah berjalan.',
  already_used: 'Sudah digunakan',
  selected: 'Dipilih',
  esc_pos_command_thermal_printer_type: 'Jenis printer thermal ESC/POS command',
  pixel_printer_type_that_uses_pixel_printer:
    'Jenis printer pixel (printer yang menggunakan pixel printing)',
  print_type: 'Tipe Printer',
  please_select_type_printer: 'Silakan pilih jenis printer',
  print_command: 'Print Command',
  please_select_print_command: 'Silakan pilih print command',
  paper_size: 'Ukuran Kertas',
  kitchen: 'Dapur',
  printer_added_successfully: 'Printer berhasil ditambahkan',
  printer_updated_successfully: 'Printer berhasil diupdate',
  please_select_paper_size: 'Silakan pilih ukuran kertas',
  print_function: 'Fungsi Print',
  print_function_desc: 'Sesuaikan penggunaan printer sesuai dengan kebutuhan',
  auto_print_invoice: 'Auto Print Bayar',
  number_of_copies: 'Jumlah Copy',
  printer_deleted_successfully: 'Printer berhasil dihapus',
  printer_deleted_failed: 'Gagal menghapus printer',
  search_transaction: 'Cari transaksi ...',
  globalSearch_find_everything: 'Temukan Segalanya',
  globalSearch_find_everything_desc:
    'Akses cepat ke seluruh data bisnis Anda dalam satu pencarian sederhana.',
  globalSearch_data_search: 'PENCARIAN DATA',
  globalSearch_what_are_you_looking_for: 'Apa yang Anda cari hari ini?',
  globalSearch_search_placeholder: 'Mulai mengetik untuk mencari di seluruh data',
  globalSearch_search_hint: 'Ketik nama produk, kontak atau nomor transaksi',
  globalSearch_no_data: 'Tidak ada data',
  globalSearch_no_data_with_keyword:
    'Data tidak ditemukan sesuai dengan pencarian Anda "{keyword}"',
  globalSearch_reset_search: 'Reset pencarian',
  globalSearch_esc_to_close: 'ESC untuk menutup',
  'report.opening_stock': 'Stok Awal',
  'report.closing_stock': 'Stok Akhir',
  'report.avg_stock': 'Stok Rata-rata',
  'report.sold_qty': 'Qty Terjual',
  'report.turnover_ratio': 'Rasio Perputaran',
  'report.storing_duration': 'Durasi Simpan',
  'appSetting.token_name': 'Nama Token',
  'appSetting.token_name_help_text':
    'Masukkan nama token yang berhubungan dengan aplikasi yang menggunakan token atau tujuan dari token.',
  'appSetting.please_input_token_name': 'Silahkan masukkan nama token',
  'appSetting.expiration_date': 'Tanggal Kedaluwarsa',
  'appSetting.add_token': 'Tambah Token',
  'appSetting.expires_in_days_help_text': 'Maksimal tanggal kedaluwarsa token',
  'appSetting.successfully_copied_token': 'Berhasil menyalin token',
  'appSetting.your_personal_access_token': 'Personal Access Token Anda',
  'appSetting.please_copy_and_save_the_token_above':
    'Silahkan salin dan simpan kode token diatas, kode token ini hanya dapat diakses satu kali',
  'appSetting.page_desc':
    'Anda dapat membuat personal access token untuk setiap aplikasi yang membutuhkan token saat diintegrasikan dengan Kledo.',
  'appSetting.app_code': 'Kode Aplikasi',
  'appSetting.token': 'Token',
  'appSetting.last_used_at': 'Terakhir Digunakan',
  'appSetting.never_used': 'Belum pernah digunakan',
  'appSetting.status': 'Status',
  'appSetting.expired': 'Kedaluwarsa',
  'appSetting.active': 'Aktif',
  'appSetting.active_tokens': 'Token aktif',
  'appSetting.expired_tokens': 'Token kedaluwarsa',
  'appSetting.token_never_used': 'Token belum pernah digunakan',
  'zap.address_is_required': 'Alamat wajib diisi',
  'zap.search_fleet_placeholder': 'Cari berdasarkan nama armada atau nomor plat',
  'zap.departure_odometer': 'Odometer Berangkat',
  'zap.odometer_back': 'Odometer Kembali',
  'zap.departure_time': 'Waktu Berangkat',
  'zap.arrival_time': 'Waktu Datang',
  'zap.fleet_name_has_been_used': 'Nama armada telah dipakai',
  'zap.fail_check_unique_fleet_name': 'Pemeriksaan nama unik armada gagal',
  'zap.license_plate_number_has_been_used': 'Nomor plat telah dipakai',
  'zap.fail_check_unique_license_plate_number': 'Pemeriksaan nomor plat unik gagal',
  please_wait: 'Harap tunggu...',
  'zap.recap_per_shipment': 'Rekap per Pengiriman',
  'zap.recap_per_product': 'Rekap per {product}',
  'zap.all_print_delivery': 'Semua Surat Jalan',
  'zap.already_geo_tagged': 'Sudah Geo Tagging',
  'zap.no_geo_tagging': 'Belum Geo Tagging',
  'zap.warning_fleet_company_map_not_available_1':
    'Maps rute pengiriman tidak aktif pada rekap pengiriman ini. Lakukan hal berikut untuk mengaktifkan rute pengiriman:',
  'zap.warning_fleet_company_map_not_available_2':
    '- Pastikan semua alamat pengiriman dan gudang telah mempunyai geo tagging.',
  'zap.warning_fleet_company_map_not_available_3':
    '- Pastikan driver dan armada sudah disematkan pada rekap pengiriman ini.',
  all_items_volume_total: 'Total volume {product}',
  'financeContacts.sales_person_help_text':
    'Pada aplikasi zap app, hanya pelanggan yang sales person-nya sesuai yang muncul',
  'zap.confirmation': 'Konfirmasi',
  'zap.fuel_consumption': 'Konsumsi Bahan Bakar',
  'zap.fuel_consumption_is_required': 'Konsumsi bahan bakar wajib diisi',
  'zap.fuel_used': 'Bahan Bakar Digunakan',
  'zap.fuel_used_is_required': 'Bahan Bakar Digunakan wajib diisi',
  'zap.travel_data': 'Data Perjalanan',
  'zap.estimation': 'Estimasi',
  'zap.difference': 'Selisih',
  'zap.fuel': 'Bahan Bakar',
  'zap.faster': 'Lebih cepat',
  'zap.slower': 'Lebih lambat',
  'zap.more_fuel_used': 'Lebih boros',
  'zap.less_fuel_used': 'Lebih hemat',
  'zap.performance': 'Performa',
  'zap.route_name_has_been_used': 'Nama rute telah dipakai',
  'zap.fail_check_unique_route_name': 'Pemeriksaan nama unik rute gagal',
  'zap.this_expense_is_automatically_created_from_delivery_recap':
    'Biaya ini dibuat otomatis dari transaksi rekap pengiriman',
  'zap.search_by_route_name': 'Cari berdasarkan nama rute',
  total_weight: 'Total Berat',
  total_qty: 'Total Kuantitas',
  'financeDelivery.mark_as_delivered': 'Tandai Sudah Dikirim',
  'financeDelivery.mark_as_not_delivered': 'Tandai Belum Dikirim',
  'zap.minimum_1_customer': 'Minimal 1 {customer}',
  'zap.invoice_is_combined_into': 'Tagihan digabung ke {target}',
  'zap.invoice_is_combined_into_canvassing_and_recap':
    'Tagihan digabung ke {canvassing} & {invoiceRecap}',
  'zap.warehouse_is_combined_into_canvassing': 'Gudang digabung ke Canvassing',
  'zap.warehouse_is_combined_into_group': 'Gudang digabung ke Transfer Gabungan',
  collector: 'Kolektor',
  collector_2: 'Penagih',
  start_date_is_required: 'Tanggal mulai wajib diisi',
  end_date_is_required: 'Tanggal selesai wajib diisi',
  select_collector: 'Pilih Kolektor',
  collector_is_required: 'Kolektor wajib diisi',
  add_invoice: 'Tambahkan Tagihan',
  selected_invoice: 'Tagihan Terpilih',
  mark_as_completed: 'Tandai Sebagai Selesai',
  payment_received: 'Pembayaran diterima',
  search_for_invoice_number: 'Cari Nomor Tagihan',
  zap_balance_due_help_text: 'Sisa tagihan yang perlu ditagih ke {customer}',
  accepted: 'Diterima',
  accepted_help_text: 'Total pembayaran yang diterima oleh kolektor',
  other_payments: 'Pembayaran Lain',
  other_payments_help_text: 'Pembayaran yang tidak melalui kolektor ini',
  cash_or_bank: 'Kash/Bank',
  'zap.delivery_recap_help_text_1':
    'Dengan rekap pengiriman, Anda dapat menggabungkan beberapa pengiriman dari {customer} yang berbeda ke dalam satu rekap pengiriman.',
  'zap.delivery_recap_help_text_2':
    'Rekap ini dapat dimanfaatkan menjadi surat jalan gabungan bagi driver armada.',
  'zap.delivery_recap_help_text_3': 'dan mulai gunakan fitur rekap pengiriman!',
  'zap.invoice_recap_help_text_1':
    'Dengan Rekap Tagihan, Anda dapat menggabungkan beberapa Tagihan dari {customer} yang berbeda ke dalam satu Rekap Tagihan.',
  'zap.invoice_recap_help_text_2':
    'Rekap ini dapat dimanfaatkan menjadi surat tugas penagihan untuk {sales_person} maupun canvasser.',
  'zap.invoice_recap_help_text_3': 'dan mulai gunakan fitur rekap tagihan!',
  add_invoice_recap: 'Tambah Rekap Tagihan',
  minimum_1_invoice_selected: 'Minimal 1 tagihan yang dipilih',
  'appSetting.last_used_date': 'Tanggal Terakhir Digunakan',
  'appSetting.example_script': 'Contoh Script',
  'appSetting.download_example_script':
    'Unduh contoh penggunaan API Kledo dalam berbagai bahasa pemrograman. Ganti API_HOST dan ACCESS_TOKEN dengan nilai milik Anda.',
  'appSetting.successfully_copied_code': 'Kode {name} berhasil disalin',
  'appSetting.successfully_downloaded_code': 'Kode {name} berhasil diunduh',
  'appSetting.postman_collection': 'Postman Collection',
  'appSetting.download_postman_collection': 'Unduh Postman Collection',
  'financeOrder.close_order': 'Tutup Pemesanan',
  'report.asc': 'Terlama',
  'report.desc': 'Terbaru',
  'report.order_by': 'Urutkan Berdasarkan',
  'report.pricelist_unit_conversion_search_placeholder':
    'Cari berdasarkan nama produk atau kode SKU',
  'report.only_unit_conversion': 'Hanya produk dengan konversi satuan',
  'report.qty_base_unit': 'Qty (Satuan Dasar)',
  'report.product_created_date': 'Tanggal Produk Dibuat',
  failed_to_download_file: 'Gagal mengunduh file',
  file_has_been_downloaded: 'File berhasil diunduh',
  refund_all_items: 'Refund semua item',
  otorisation: 'Otorisasi',
  select_otorisation: 'Pilih otorisasi',
  input_otorisation_pin_code: 'Masukkan kode PIN otorisasi',
  please_input_otorisation_pin_code: 'Silakan masukkan kode PIN otorisasi',
  no_data_selected_yet_please_select_first:
    'Belum ada data yang dipilih, silahkan pilih dulu untuk menampilkan detail',
  receipt_and_fee: 'Struk & Biaya',
  open_cashier: 'Buka Kasir',
  initial_capital: 'Tentukan Jumlah Kas Modal',
  initial_capital_note: 'Default memasukan jumlah kas modal setiap kali buka kasir',
  close_cashier: 'Tutup Kasir',
  close_cashier_capital: 'Tentukan Jumlah Kas Modal',
  close_cashier_capital_note: 'Default memasukan jumlah kas modal setiap kali tutup kasir',
  auto_close: 'Auto Tutup Kasir',
  auto_close_note: 'Auto tutup kasir setelah waktu yang ditentukan',
  auto_close_time: 'Waktu Auto Tutup Kasir',
  auto_close_shift_time: 'Jam Tutup Shift',
  auto_close_shift_min_open_hour: 'Minimal Lama Shift Terbuka',
  auto_close_shift_min_open_hour_note:
    'Shift baru ditutup otomatis jika sudah terbuka minimal selama durasi ini',
  auto_close_time_note: 'Waktu auto tutup kasir setelah waktu yang ditentukan',
  auto_close_time_help_text: 'Waktu auto tutup kasir setelah waktu yang ditentukan',
  auto_close_time_help_text_note: 'Waktu auto tutup kasir setelah waktu yang ditentukan',
  cash_out_limit: 'Tentukan Batasan Kas Keluar',
  cash_out_limit_note: 'Mengizinkan kasir untuk mengambil uang kas sesuai yang telah ditentukan',
  activate_to_add_service_fees_when_paying_at_the_cashier:
    'Aktifkan untuk menambahkan biaya layanan ketika pembayaran di kasir',
  additional_discount_note:
    'Jika diaktifkan, Anda dapat menambahkan diskon langsung di kasir sesuai kebutuhan',
  service_charge: 'Biaya Layanan',
  service_charge_note: 'Aktifkan untuk menambahkan biaya layanan ketika pembayaran di kasir',
  manual_product_price: 'Harga Produk Manual',
  manual_product_price_note:
    'Jika diaktifkan, Anda dapat melakukan perubahan harga langsung di kasir sesuai kebutuhan',
  approval_otorization_note:
    'Jika diaktifkan, ketika melakukan refund, diperlukan otorisasi dari pimpinan',
  is_auto_apply_product_discount: 'Otomatis Terapkan Diskon Produk',
  is_auto_apply_product_discount_note:
    'Jika diaktifkan, promo/diskon produk otomatis diterapkan saat item ditambahkan ke keranjang. Jika dinonaktifkan, kasir tetap dapat memilih promo secara manual per item',
  print_style_show_product_price_title: 'Tampilkan Harga Produk',
  print_style_show_product_price_note:
    'Jika diaktifkan, Harga produk dan diskon per item ditampilkan ketika cetak struk dan bill',
  print_style_show_witholding_title: 'Tampilkan Pemotongan',
  print_style_show_witholding_note:
    'Jika dinonaktifkan, baris pemotongan tidak dicetak di struk dan e-receipt, dan total ditampilkan seolah tanpa pemotongan',
  is_manual_tax_item_title: 'Pajak Manual per Item',
  is_manual_tax_item_note: 'Aktifkan untuk mengubah pajak di setiap item di kasir',
  queue_number: 'No. Antrian',
  queue_number_title: 'Nomor Antrian',
  queue_number_active_label: 'Aktifkan Nomor Antrian',
  queue_number_note:
    'Jika aktif, setiap transaksi baru otomatis mendapat nomor antrian. Perubahan hanya berlaku untuk transaksi berikutnya',
  queue_number_reset_daily: 'Reset harian',
  queue_number_prefix: 'Awalan (prefix)',
  queue_number_suffix: 'Akhiran (suffix)',
  queue_number_padding: 'Jumlah Nol di Depan (0-12)',
  queue_number_padding_note: 'Contoh: diisi 1 → nomor antrian menjadi 01, 02, 03, dst.',
  outlet_address: 'Alamat Outlet',
  outlet_phone: 'Telepon Outlet',
  outlet_name: 'Nama Outlet',
  main: 'Utama',
  hardware: 'Perangkat',
  shift_history: 'Riwayat Shift',
  shift_detail: 'Detil Shift',
  shift_history_subtitle: 'Shift yang sedang berjalan maupun yang sudah ditutup',
  shift_status_open: 'Berjalan',
  shift_status_closed: 'Selesai',
  shift_until_now: 'Sekarang',
  no_open_shift: 'Tidak ada shift yang sedang berjalan',
  shift_running_since: 'Shift sedang berjalan · {duration} sejak {time}',
  shift_close_owner_only: 'Hanya kasir pemilik yang dapat menutup shift ini',
  cashier_name: 'Nama Kasir',
  cashier_started: 'Mulai Kasir',
  cashier_ended: 'Akhir Kasir',
  cash_balance: 'Modal Awal',
  cash_payment: 'Pembayaran Tunai',
  cash_from_invoice: 'Uang Tunai dari Invoice',
  cash_refunds: 'Uang Tunai Refund',
  cash_in_or_cash_out: 'Kas Masuk / Kas Keluar',
  expected_amount_of_money: 'Jumlah Uang yang Diharapkan',
  total_cash: 'Total Kas',
  transaction_status: 'Status Transaksi',
  completed: 'Selesai',
  unpaid: 'Belum Terbayar',
  unpaid_amount: 'Belum Terbayar (Rp.)',
  expected_total: 'Total yang Diharapkan',
  total_cash_entered: 'Total Kas yang dimasukkan',
  difference: 'Selisih',
  tax: 'Pajak',
  print_recap: 'Cetak Rekap',
  print_product_sold: 'Cetak Produk Terjual',
  print_payment_detail: 'Cetak Detail Pembayaran',
  shift_report: 'LAPORAN TUTUP KASIR PENJUALAN',
  products: 'Produk Terjual',
  refund: 'Refund',
  please_select_outlet_to_continue: 'Silahkan pilih outlet untuk melanjutkan',
  open_shift: 'Buka Shift',
  please_open_shift_first: 'Buka shift terlebih dahulu',
  active_session: 'SESI AKTIF',
  welcome_back: 'Selamat datang kembali, {name}!',
  lets_provide_best_service: 'Mari berikan layanan terbaik hari ini!',
  employee_id: 'ID KARYAWAN',
  ready_to_start_transactions: 'Siap memulai transaksi Anda',
  opening_balance: 'Saldo Awal',
  quick_select_amounts: 'PILIHAN CEPAT JUMLAH',
  start_shift: 'Mulai Shift',
  logout_account: 'Keluar Akun',
  help: 'Bantuan',
  close_shift_success: 'Tutup Shift Berhasil',
  close_shift_message:
    'Terima kasih banyak untuk kerja kerasmu hari ini, kamu membuat proses transaksi berjalan lancar. Kami sangat bangga dengan kamu.',
  please_input_the_last_cashier_balance: 'Silakan masukkan saldo kasir terakhir',
  shift_duration: 'Durasi shift',
  payment_name: 'Nama Pembayaran',
  cashless_payment: 'Pembayaran Non Tunai',
  please_select_payment_type: 'Silakan pilih jenis pembayaran non tunai',
  payment_type: 'Jenis Pembayaran',
  select_payment_type: 'Pilih jenis pembayaran',
  please_select_provider: 'Silakan pilih provider',
  select_provider: 'Pilih provider',
  please_input_payment_name: 'Silakan masukkan nama pembayaran',
  input_payment_name: 'Masukkan nama pembayaran',
  please_select_a_account: 'Silakan pilih akun',
  mdr_fee: 'Biaya MDR',
  account_coa: 'Akun COA',
  select_account_coa: 'Pilih akun COA',
  outlet_availability: 'Ketersediaan Outlet',
  specific_outlets: 'Outlet Tertentu',
  applies_at_outlet: 'Berlaku di Outlet',
  please_select_min_one_outlet: 'Pilih minimal satu outlet',
  outlet_availability_hint: 'Pembayaran hanya tampil di kasir outlet yang dipilih',
  input_nominal: 'Masukkan nominal',
  total_after_mdr_fee: 'Total setelah biaya tambahan',
  input_note: 'Masukkan catatan',
  customer_bank: 'Bank Pelanggan',
  select_customer_bank: 'Pilih bank pelanggan',
  input_customer_card_number: 'Masukkan nomor kartu pelanggan',
  input_customer_account_number: 'Masukkan nomor rekening pelanggan',
  customer_account_holder: 'Atas nama pelanggan',
  input_customer_account_holder: 'Masukkan nama kartu pelanggan',
  please_select_destination_bank: 'Silakan pilih Bank tujuan',
  select_destination_bank: 'Pilih Bank tujuan',
  destination_bank: 'Bank Tujuan',
  exact_money: 'Uang Pas',
  select_customer: 'Pilih pelanggan',
  please_input_the_nominal: 'Silahkan masukkan nominal',
  'crm.hash_tag': '#Jadilebihbaik layani pelanggan bisnismu',
  'crm.head_title_1': 'Tingkatkan Retensi Pelanggan dan',
  'crm.head_title_2': 'Penjualan Bisnis dengan',
  'crm.head_title_3': 'CRM.ID',
  'crm.head_title_description':
    'Solusi WhatsApp API resmi dan terpercaya, dirancang untuk manajemen komunikasi dan retensi pelanggan lebih baik tanpa risiko blokir nomor. Serba unlimited dengan harga terjangkau.',
  'crm.signup': 'Daftar CRM.ID',
  'crm.sales_contact': 'Hubungi Sales',
  'crm.feat_1_sub_title': 'Unlimited MAU',
  'crm.feat_1_description': 'Anda bisa melayani banyak pelanggan tanpa perlu memikirkan ',
  'crm.feat_1_description_2': 'Monthly Active Users ',
  'crm.feat_1_description_3':
    '(MAU). Cukup fokus melayani pelanggan dengan baik dan tingkatkan produkmu.',
  'crm.feat_2_sub_title': 'Nomor Masking & Centang Hijau',
  'crm.feat_2_description':
    'Dapatkan nomor masking dari WhatsApp secara resmi. Dan jika bisnismu memenuhi syarat, kamu juga akan mendapatkan centang hijau WhatsApp tanpa biaya tambahan.',
  'crm.feat_3_sub_title': 'Multi Agent',
  'crm.feat_3_description':
    'Punya banyak CS? Dengan menggunakan CRM.ID cukup menggunakan satu nomor  WhatsApp maka Anda bisa melayani oleh banyak pelanggan sekaligus.',
  'crm.feat_4_sub_title': 'Pencarian Cepat dan Filter Data',
  'crm.feat_4_description':
    'Riwayat percakapan otomatis tersimpan dan dapat dicari dengan mudah. Percakapan juga dapat difilter untuk mendapatkan hasil yang akurat.',
  'crm.feat_5_sub_title': 'Unlimited 1 on 1 Support',
  'crm.feat_5_description':
    'Dapatkan layanan via zoom 1 on 1 secara gratis, dan tanpa batasan. Tim Hebat CRM.ID akan membantu proses onboarding, training karyawan, hingga atensi selama penggunaan.',
  'crm.feat_6_sub_title': 'Harga Transparan',
  'crm.feat_6_description': 'Pay as you go. ',
  'crm.feat_6_description_2':
    'Harga jujur tanpa drama. Hanya Rp40/pesan, sudah termasuk 1.000 percakapan WhatsApp gratis per bulan. Tanpa batasan fitur.',
  'crm.footer_note':
    'Tingkatkan loyalitas pelanggan dan penjualan dengan lebih efektif melalui integrasi WhatsApp API di CRM.ID. Coba sekarang juga.',
  'crm.feat_title_1': 'Apa yang Akan',
  'crm.feat_title_2': 'Anda Dapatkan',
  'crm.feat_title_3': 'Jika Menggunakan CRM.ID?',
  'crm.crm': 'CRM.ID',
  'crm.integrating_success_1': 'Horee!, Akun',
  'crm.integrating_success_2': 'Kledo',
  'crm.integrating_success_3': 'sudah berhasil dikoneksikan dengan Software ',
  'crm.integrating_success_4': 'CRM.ID.',
  'crm.go-to-crm': 'Pergi ke CRM.ID',
  please_select_reason_to_close_order: 'Silakan pilih alasan untuk menutup pemesanan',
  change_pin: 'Ganti PIN',
  lock_screen: 'Kunci Layar',
  update_your_current_pin: 'Perbarui PIN Anda Saat Ini',
  old_pin: 'PIN Lama',
  new_pin: 'PIN Baru',
  confirm_new_pin: 'Konfirmasi PIN Baru',
  input_your_old_pin: 'Masukkan PIN Lama',
  input_your_new_pin: 'Masukkan PIN Baru',
  input_your_confirm_new_pin: 'Masukkan Konfirmasi PIN Baru',
  pin_must_be_6_characters: 'PIN harus 6 karakter',
  pin_does_not_match: 'PIN tidak cocok',
  please_input_your_old_pin: 'Silakan masukkan PIN lama',
  please_input_your_new_pin: 'Silakan masukkan PIN baru',
  please_input_your_confirm_new_pin: 'Silakan masukkan konfirmasi PIN baru',
  pin_changed_successfully: 'PIN berhasil diperbarui',
  web_order: 'Web Order',
  with_the_web_order_feature_you_can_now_easily_sell_products_online_using_the_qrcode_and_web_link_below:
    'Dengan fitur Web Order, sekarang Anda dapat dengan mudah menjual produk secara online menggunakan kode QR dan tautan web di bawah.',
  web_order_preview: 'Preview Web Order',
  see_web_order: 'Lihat Web Order',
  web_order_link: 'Tautan Web Order',
  web_order_qrcode: 'Kode QR Web Order',
  see_qrcode: 'Lihat Kode QR',
  scan_qrcode_to_view_the_menu: 'Pindai kode QR untuk melihat menu',
  printer_connection_type: 'Pilih jenis printer yang digunakan:',
  printer_network_lan_wifi: 'Printer Network (LAN / WiFi)',
  printer_network_recommended: 'Disarankan untuk POS, Cepat & stabil',
  printer_usb_pc: 'Printer USB / PC',
  printer_usb_pc_desc: 'Printer terpasang di PC',
  scan_automatic: 'Scan Otomatis',
  scan_automatic_desc: 'Cari printer thermal di jaringan lokal Anda',
  search_automatic_printer: 'Cari Printer Otomatis',
  printer_selected_ip_port_filled: 'Printer "{printerName}" dipilih. IP dan Port sudah diisi.',
  printer_selected_manual_input:
    'Printer "{printerName}" dipilih. Silakan masukkan IP dan Port secara manual di bawah.',
  or: 'atau',
  manual_setup: 'Setup Manual',
  ip_address: 'Alamat IP',
  ip_address_placeholder: 'Alamat IP',
  enter_ip_address: 'Masukkan alamat IP',
  invalid_ip_format: 'Format IP tidak valid',
  port: 'Port',
  port_placeholder: 'Port',
  enter_port: 'Masukkan port',
  port_must_be_number: 'Port harus berupa angka',
  ensure_printer_pc_same_network: 'Pastikan printer & PC berada di jaringan yang sama',
  qz_tray_not_installed: 'QZ Tray Belum Terinstall/Dijalankan',
  qz_tray_required_for_printer:
    'QZ Tray diperlukan untuk menggunakan fitur printer. Silakan install QZ Tray terlebih dahulu.',
  download_qz_tray: 'Download QZ Tray',
  download_qz_tray_from_official_website: 'Download QZ Tray dari website resmi',
  install_qz_tray: 'Install QZ Tray',
  install_qz_tray_on_computer: 'Install aplikasi QZ Tray di komputer',
  run_qz_tray: 'Jalankan QZ Tray',
  open_qz_tray_and_ensure_running: 'Buka aplikasi QZ Tray dan pastikan berjalan',
  refresh_page: 'Refresh Halaman',
  refresh_page_to_check_status: 'Refresh halaman ini untuk mengecek status',
  installation_steps: 'Langkah-langkah Instalasi:',
  click_download_qz_tray_button: 'Klik tombol Download QZ Tray di bawah ini',
  or_visit: 'Atau kunjungi',
  select_version_for_your_os:
    'Pilih versi yang sesuai dengan sistem operasi Anda (Windows/macOS/Linux)',
  open_installer_file: 'Buka file installer yang sudah didownload',
  follow_installation_steps: 'Ikuti langkah-langkah instalasi',
  ensure_qz_tray_installed_correctly: 'Pastikan QZ Tray terinstall dengan benar',
  open_qz_tray_from_start_menu:
    'Buka aplikasi QZ Tray dari menu Start (Windows) atau Applications (macOS)',
  qz_tray_icon_will_appear:
    'Icon QZ Tray akan muncul di system tray (Windows) atau menu bar (macOS)',
  ensure_qz_tray_status_running: 'Pastikan status QZ Tray menunjukkan "Running" atau "Connected"',
  after_qz_tray_running_refresh: 'Setelah QZ Tray berjalan, refresh halaman ini',
  system_will_auto_detect_qz_tray: 'Sistem akan otomatis mendeteksi QZ Tray',
  you_can_start_using_printer: 'Anda dapat mulai menggunakan fitur printer',
  important_note: 'Catatan Penting',
  qz_tray_must_run_every_time: 'QZ Tray harus berjalan setiap kali Anda menggunakan fitur printer',
  ensure_qz_tray_not_blocked: 'Pastikan QZ Tray tidak di-block oleh firewall atau antivirus',
  macos_permission_note:
    'Jika menggunakan macOS, mungkin perlu memberikan permission di System Preferences → Security & Privacy',
  qz_tray_certificate_section_title: 'Menghilangkan Dialog Sertifikat (Opsional)',
  qz_tray_certificate_section_desc:
    'Setelah QZ Tray terinstall, dialog konfirmasi mungkin akan muncul setiap kali Anda mencetak. Untuk menghindari hal tersebut, tambahkan sertifikat digital ke Site Manager.',
  qz_tray_download_certificate: 'Download Sertifikat Digital',
  qz_tray_download_certificate_desc:
    'Download file digital-certificate.txt ke komputer Anda. File ini diperlukan untuk mengotorisasi situs Kledo di QZ Tray.',
  qz_tray_open_site_manager: 'Buka Site Manager',
  qz_tray_open_site_manager_desc:
    'Jalankan QZ Tray jika belum berjalan. Klik ikon QZ Tray di system tray/menu bar → pilih Advanced → Site Manager',
  qz_tray_add_certificate: 'Tambahkan Sertifikat',
  qz_tray_add_certificate_desc:
    'Di jendela Site Manager, klik tombol ikon + (plus) di bagian bawah, lalu pilih "Browse..." dan pilih file digital-certificate.txt yang sudah didownload.',
  qz_tray_refresh_and_try: 'Refresh & Coba Lagi',
  qz_tray_refresh_and_try_desc:
    'Setelah sertifikat ditambahkan, tutup Site Manager, refresh halaman ini, lalu coba cetak lagi. Dialog konfirmasi tidak akan muncul lagi.',
  qz_tray_img_caption_advanced: 'Advanced → Site Manager',
  qz_tray_img_caption_site_manager: 'Klik + → Browse... → Pilih digital-certificate.txt',
  summary_detail: 'Rincian',
  printer_connection: 'Koneksi Printer',
  reset_your_current_pin: 'Reset PIN Anda Saat Ini',
  pin_reset_successfully: 'PIN berhasil direset',
  please_input_your_password_to_reset_pin: 'Silakan masukkan password Anda untuk mereset PIN',
  forgot_pin: 'Lupa PIN',
  refund_description: 'Keterangan pengembalian',
  refund_reason_other: 'Alasan Pengembalian Lainnya',
  refund_reason: 'Alasan Pengembalian',
  please_select_refund_reason: 'Silakan pilih alasan pengembalian',
  refund_method: 'Metode Pengembalian',
  please_select_refund_method: 'Silakan pilih metode pengembalian',
  amount_after_tax_must_be_greater_than_0: 'Jumlah nominal harus lebih besar dari 0',
  input_product_name: 'Masukkan nama produk',
  please_input_product_name: 'Silakan masukkan nama produk',
  add_custom_product: 'Tambah Custom Produk',
  total_cashless: 'Total Non Tunai',
  products_sold: 'Produk Terjual',
  please_input_printer_name: 'Silakan masukkan nama printer',
  input_printer_name: 'Masukkan nama printer',
  invoice_successfully_refunded: 'Tagihan berhasil direfund',
  invoice_failed_to_refund: 'Tagihan gagal direfund',
  please_select_tax_to_use_in_pos:
    'Silahkan pilih pajak sesuai dengan ketentuan perusahaan Anda. Pajak yang dipilih akan digunakan untuk semua transaksi di POS Anda.',
  tax_value: 'Nilai Pajak (%)',
  'billing.upgrade_with_3_year_or_3_month':
    '{clickHere} untuk upgrade dengan termin 3 tahun atau 3 bulan.',
  custom_paper_width: 'Lebar (mm)',
  custom_paper_height: 'Tinggi (mm)',
  custom_paper_width_required: 'Lebar harus diisi',
  custom_paper_height_required: 'Tinggi harus diisi',
  custom_paper_width_placeholder: 'Lebar',
  custom_paper_height_placeholder: 'Tinggi',
  'date.next_2_years': '2 Tahun Depan',
  'date.next_3_years': '3 Tahun Depan',
  'financeOrder.close_reason': 'Alasan penutupan',
  'financeOrder.all_closed': 'Semua Selesai',
  'financeOrder.reason_cancel_order': 'Batal Pesan',
  'financeOrder.reason_wrong_process': 'Salah Proses',
  'financeOrder.reason_other': 'Lainnya',
  please_enter_refund_reason_other: 'Silakan masukkan alasan pengembalian lainnya',
  promo_title: 'Promo',
  promo_subtitle:
    'Gunakan promo untuk memberikan potongan harga kepada pelanggan sesuai syarat yang berlaku.',
  promo_empty: 'Belum ada promo yang tersedia',
  promo_show_disabled: 'Tampilkan promo belum bisa dipilih',
  promo_hide_disabled: 'Sembunyikan promo belum bisa dipilih',
  markup_title: 'Markup',
  markup_subtitle:
    'Gunakan markup untuk menambah harga jual pada kondisi tertentu tanpa mengisi kolom diskon.',
  markup_empty: 'Belum ada markup yang tersedia',
  markup_show_disabled: 'Tampilkan markup belum bisa dipilih',
  markup_hide_disabled: 'Sembunyikan markup belum bisa dipilih',
  badge_markup: 'Markup',
  badge_promo: 'Promo',
  promo_recommended: 'Rekomendasi',
  promo_delete_title: 'Hapus Promo',
  promo_apply_title: 'Gunakan Promo',
  promo_cancel: 'Batal',
  print_invoice_successfully: '{printFunction} berhasil dicetak',
  close_order_successfully: 'Pemesanan berhasil ditutup',
  cancel_order: 'Batalkan Pemesanan',
  are_you_sure_to_cancel_order: 'Apakah Anda yakin ingin membatalkan pemesanan ini?',
  reset_selected_tax: 'Reset Pajak yang Dipilih',
  'report.sku_code': 'Kode SKU',
  'report.sell_price_history_search_placeholder': 'Cari berdasarkan nama produk, kode atau nomor',
  cc_email_address: 'Alamat Email CC',
  'emails.cc_email_desc':
    'Saat Anda mengirimkan email, otomatis akan di CC ke alamat email berikut:',
  'dueReminder.send_email_to_customer': 'Kirim Email ke {customer}',
  'dueReminder.send_email_to_admin': 'Kirim Email ke Admin',
  'dueReminder.send_whatsapp_to_customer': 'Kirim Whatsapp ke {customer}',
  no_templates: 'Tidak ada template',
  purchase_join_invoice: 'Tagihan Pembelian Gabungan',
  invoice_thank_you: 'Email Terima Kasih',
  customer_birthday_setting: 'Ulang Tahun Pelanggan',
  minimum_1_delivery_selected: 'Minimal 1 pengiriman yang dipilih',
  'zap.payment_invoice_is_combined_into_invoice_recap':
    'Pembayaran tagihan digabung ke Rekap Tagihan',
  invoice_recap: 'Rekap Tagihan',
  delivery_recap_alert_message:
    'Dengan rekap pengiriman, Anda dapat menggabungkan beberapa pengiriman dari {customer} yang berbeda ke dalam satu rekap pengiriman, rekap ini dapat dimanfaatkan menjadi surat jalan gabungan bagi driver armada.',
  loading_more: 'Memuat data...',
  old_email_otp_code: 'Kode OTP email lama',
  new_email_otp_code: 'Kode OTP email baru',
  sub_category_from: 'Sub Kategori dari',
  'layoutInvoice.invoice_show_number_invoice': 'Tampilkan Nomor Tagihan',
  'layoutInvoice.show_receipt_signature_made_by': 'Tampilkan TTD Dibuat Oleh',
  'layoutInvoice.show_receipt_signature_checked_by': 'Tampilkan TTD Diperiksa Oleh',
  'layoutInvoice.show_receipt_signature_approved_by': 'Tampilkan TTD Disetujui Oleh',
  'layoutInvoice.show_receipt_signature_received_by': 'Tampilkan TTD Diterima Oleh',
  'financeInvoices.select_email': 'Pilih email',
  'financeInvoices.select_sending_method': 'Pilih metode pengiriman untuk pelanggan Anda',
  'financeInvoices.quick_response': 'Respon Cepat',
  'financeInvoices.formal_professional': 'Formal & Profesional',
  'financeInvoices.whatsapp_destination_number': 'Nomor WhatsApp Tujuan',
  'financeInvoices.phone_number_helper_text': 'Nomor ini akan menerima pesan tagihan',
  'financeInvoices.phone_number_invalid': 'Nomor telepon hanya boleh berisi + dan angka',
  'financeInvoices.phone_number_min': 'Nomor telepon minimal {min} karakter',
  'financeInvoices.phone_number_max': 'Nomor telepon maksimal {max} karakter',
  'financeInvoices.email_sent_successfully': 'Email berhasil dikirim',
  'financeInvoices.whatsapp_sent_successfully': 'Pesan WhatsApp berhasil dikirim',
  'financeInvoices.invoice_will_be_sent_via': 'Faktur akan dikirim melalui',
  'financeInvoices.send_now': 'Kirim Sekarang',
  'financeInvoices.add_email': 'Tambahkan email',
  'financeInvoices.send_via_personal_number': 'Kirim via Nomor Pribadi',
  'financeInvoices.send_via_personal_number_desc':
    'Tingkatkan kepercayaan pelanggan Anda dengan nomor resmi Anda sendiri.',
  'financeInvoices.send_whatsapp': 'Kirim WhatsApp',
  'financeInvoices.whatsapp_template_info':
    'Template pesan WhatsApp ini telah disesuaikan dengan standar profesional kledo.com untuk memastikan keterbacaan yang optimal',
  'salesCommission.commissions_help_text_1':
    'Jika menggunakan persen, maka besaran komisi adalah nilai persen dikalikan besaran penjualan. Misalnya untuk penjualan minimal Rp 100 juta, mendapatkan komisi 10%. Kemudian pada bulan tersebut sales menjual Rp 150 juta, maka komisi yang didapat sales tersebut adalah 10% x Rp 150 juta = Rp 15 juta',
  'salesCommission.commissions_help_text_2':
    'Jika menggunakan Rp, maka besaran komisi adalah tetap tidak dipengaruhi oleh besaran penjualan. Misalnya untuk penjualan minimal Rp 100 juta, mendapatkan komisi Rp 1 juta. Kemudian pada bulan tersebut sales menjual Rp 150 juta, maka komisi yang didapat sales tersebut adalah Rp 1 juta.',
  'salesCommission.commissions_help_text_excess_over_target':
    'Komisi dihitung dari persentase dikalikan selisih omzet di atas target minimum, bukan dari total omzet. Misalnya untuk target minimum Rp 1 juta mendapatkan komisi 5%. Kemudian pada bulan tersebut sales menjual Rp 1,2 juta, maka komisi yang didapat sales tersebut adalah 5% x (Rp 1,2 juta - Rp 1 juta) = Rp 10 ribu. Jika omzet belum mencapai target minimum, komisi yang didapat Rp 0.',
  'salesCommission.applies_to_the_following_products_help_text':
    'Apabila komisi berlaku pada sebagian {products} saja, maka perhitungan minimal transaksi perbulan hanya akan diperhitungan dari {products} yang berlaku saja. Dan besaran komisi juga akan diperhitungkan dari nilai penjualan dari {products} yang berlaku saja.',
  'cashier.edit_item': 'Edit Item: {name}',
  'cashier.product_layout_grid': 'Tampilan produk grid',
  'cashier.product_layout_list': 'Tampilan produk baris',
  'cashier.inventory_id': 'INVENTORY ID',
  'cashier.select_promotion': 'Pilih Promo',
  'cashier.calculation_breakdown': 'Ringkasan',
  'cashier.units': 'units',
  'cashier.incl_taxes': '(incl. taxes)',
  'cashier.update_item': 'Update Item',
  'cashier.driver_online_detail.title': 'Detail Driver Online',
  'cashier.driver_online_detail.panel_title': 'Driver Online',
  'cashier.driver_online_detail.panel_description':
    'Catat informasi driver dan pesanan untuk transaksi order online.',
  'cashier.driver_online_detail.form_description':
    'Lengkapi informasi berikut untuk memproses transaksi.',
  'cashier.driver_online_detail.select_driver_service': 'Pilih Layanan Driver',
  'cashier.driver_online_detail.driver_service_placeholder':
    'Pilih Platform (GoFood, ShopeeFood, etc)',
  'cashier.driver_online_detail.select_driver_service_required': 'Pilih layanan driver',
  'cashier.driver_online_detail.driver_name': 'Nama Driver',
  'cashier.driver_online_detail.driver_name_placeholder': 'Masukkan nama lengkap driver',
  'cashier.driver_online_detail.driver_name_required': 'Nama driver wajib diisi',
  'cashier.driver_online_detail.online_order_number': 'Nomor Order Online',
  'cashier.driver_online_detail.online_order_number_placeholder': 'Contoh: INV-99283-X',
  'cashier.driver_online_detail.online_order_number_required': 'Nomor order online wajib diisi',
  'cashier.driver_online_detail.optional': 'Opsional',
  'cashier.driver_online_detail.confirm_driver': 'Konfirmasi Driver',
  'membership.members_title': 'Member',
  'membership.status': 'Status',
  'membership.outlet': 'Outlet',
  'membership.addon_photo': 'Foto',
  'membership.member_name': 'Nama',
  'membership.email': 'Email',
  'membership.phone': 'Telepon',
  'membership.join_date': 'Tanggal Bergabung',
  'membership.search_member': 'Cari nama member',

  'membership.detail_title': 'Detail Member',
  'membership.profile': 'Profil',
  'membership.transactions': 'Transaksi',
  'membership.transactions_title': 'Transaksi Membership',
  'membership.number': 'Nomor',
  'membership.type': 'Tipe',
  'membership.date': 'Tanggal',
  'membership.month': 'Bulan',
  'membership.total': 'Total',
  'membership.settings': 'Pengaturan',
  'membership.settings_paid_membership_activated': 'Membership berhasil diaktifkan.',
  'membership.settings_paid_membership_deactivated': 'Membership berhasil dinonaktifkan.',
  'membership.landing_title': 'Membership',
  'membership.landing_hash_tag': '#jadilebihloyal, mudah, dan praktis.',
  'membership.landing_hero_title': 'Tingkatkan Loyalitas Pelanggan-mu dengan Program Membership',
  'membership.landing_hero_description':
    'Buat program membership dengan biaya bulanan, berikan poin otomatis setiap transaksi, dan sediakan reward yang bisa ditukar pelanggan. Semua aktivitas tercatat rapi untuk membantu meningkatkan loyalitas dan pembelian berulang.',
  'membership.landing_cta': 'Aktifkan Membership, Gratis!',
  'membership.landing_features_title': 'Apa yang Akan Anda Dapatkan dari Fitur Membership?',
  'membership.landing_video_title': 'Kenali Fitur Membership dalam Hitungan Menit',
  'membership.landing_feat_1_title': 'Program membership berbayar',
  'membership.landing_feat_1_description':
    'Buat paket membership mulai dari yang free hingga dengan biaya bulanan sesuai kebutuhan bisnis Anda dan kelola semuanya dengan mudah dalam satu sistem.',
  'membership.landing_feat_2_title': 'Poin otomatis setiap transaksi',
  'membership.landing_feat_2_description':
    'Setiap transaksi pelanggan langsung mendapatkan poin secara otomatis tanpa perhitungan manual.',
  'membership.landing_feat_3_title': 'Penukaran poin dengan reward',
  'membership.landing_feat_3_description':
    'Sediakan berbagai benefit atau reward menarik yang bisa ditukarkan dengan poin yang sudah dikumpulkan pelanggan.',
  'membership.landing_feat_4_title': 'Fitur check-in outlet',
  'membership.landing_feat_4_description':
    'Dorong engagement dengan fitur check-in kehadiran pelanggan di outlet dan pantau aktivitasnya dengan rapi.',
  'membership.landing_feat_5_title': 'Data & aktivitas pelanggan tercatat lengkap',
  'membership.landing_feat_5_description':
    'Lihat riwayat transaksi, poin, dan aktivitas member dalam satu dashboard yang mudah dipahami.',
  'membership.landing_feat_6_title': 'Meningkatkan loyalitas & repeat order',
  'membership.landing_feat_6_description':
    'Bangun hubungan jangka panjang dengan pelanggan dan dorong mereka untuk lebih sering berbelanja melalui sistem loyalty yang terstruktur.',
  'membership.landing_footer_note':
    'Bangun loyalitas pelanggan dan tingkatkan repeat order lebih mudah dengan fitur Membership & Loyalty Program sekarang juga.',
  'membership.points': 'Poin',
  'membership.check_in': 'Check In',
  'membership.check_out': 'Check Out',
  'membership.auto_out': 'Auto Out',
  'membership.branch': 'Cabang',
  'membership.name': 'Nama',
  'membership.yes': 'Ya',
  'membership.no': 'Tidak',
  'membership.not_checked_out_yet': 'Belum Checkout',
  'membership.done': 'Selesai',
  'membership.not_done_yet': 'Belum dilakukan',
  'membership.check_in_info': 'Informasi Check In',
  'membership.edit_check_in_title': 'Ubah Check In',
  'membership.check_out_placeholder': 'Pilih tanggal & waktu check out',
  'membership.automatic': 'Otomatis',
  'membership.duration_auto_hint':
    'Durasi dihitung otomatis berdasarkan waktu check in & check out',
  'membership.add_check_in': 'Tambah',
  'membership.method': 'Metode',
  'membership.auto_check_out': 'Auto Check Out',
  'membership.check_in_date_required': 'Silakan pilih tanggal check in',
  'membership.check_in_detail_title': 'Detail Check In',
  'membership.check_out_now': 'Check Out Sekarang',
  'membership.duration_label': 'Durasi',
  'membership.duration_hours_minutes': '{hours} jam {minutes} menit',
  'membership.duration_minutes_only': '{minutes} menit',
  'membership.check_out_success': 'Check out berhasil',
  'membership.check_out_failed': 'Gagal check out',
  'membership.attendance_updated_success': 'Berhasil diperbarui',
  'membership.attendance_update_failed': 'Gagal memperbarui',
  'membership.attendance_deleted_success': 'Data check-in berhasil dihapus',
  'membership.attendance_delete_failed': 'Gagal menghapus data check-in',
  'membership.points_accumulated': 'Akumulasi',
  'membership.expired': 'Kedaluwarsa',
  'membership.days_left': 'Hari lagi',
  'membership.validity_period': 'Masa Berlaku',
  'membership.forever': 'Selamanya',
  'membership.streak': 'Rentetan',
  'membership.consecutive_days': 'Hari berturut-turut',
  'membership.member_info': 'Informasi Member',
  'membership.full_name': 'Nama Lengkap',
  'membership.address': 'Alamat',
  'membership.package': 'Paket',
  'membership.paid_customer_since': 'Pelanggan Berbayar Sejak',
  'membership.expired_date': 'Tanggal Kedaluarsa',
  'membership.point_balance': 'Saldo Poin',
  'membership.amount': 'Jumlah',
  'membership.benefit': 'Benefit',
  'membership.balance': 'Saldo',
  'membership.add_points_title': 'Tambah Poin',
  'membership.add_points_failed': 'Gagal menambahkan poin',
  'membership.point_adjustment_type': 'Jenis penyesuaian',
  'membership.point_adjustment_placeholder': 'Pilih jenis penyesuaian',
  'membership.point_adjustment_required': 'Pilih jenis penyesuaian',
  'membership.point_adjustment_add': 'Tambah poin',
  'membership.point_adjustment_subtract': 'Kurangi poin',
  'membership.add_points_amount_label': 'Jumlah Poin',
  'membership.add_points_amount_required': 'Masukkan jumlah poin',
  'membership.add_points_amount_placeholder': 'Masukkan jumlah poin',
  'membership.add_points_trans_date_label': 'Tanggal Transaksi',
  'membership.add_points_trans_date_required': 'Pilih tanggal transaksi',
  'membership.add_points_description_placeholder': 'Masukkan deskripsi',
  'membership.registration_location': 'Lokasi Pendaftaran',
  'membership.member_card': 'Kartu Member',
  'membership.remaining': 'Tersisa',
  'membership.premium': 'Premium',
  'membership.member_number': 'NOMOR MEMBER',
  'membership.status_active': 'Aktif',
  'membership.status_inactive': 'Tidak aktif',
  'membership.benefit_archived_banner': 'Diarsipkan',
  'membership.archive_benefit': 'Arsipkan',
  'membership.unarchive_benefit': 'Batalkan arsip',
  'membership.popconfirm_archive_benefit':
    'Arsipkan benefit ini? Benefit akan menjadi tidak aktif.',
  'membership.popconfirm_unarchive_benefit':
    'Batalkan arsip benefit ini? Benefit akan aktif kembali.',
  'membership.archive_benefit_success': 'Benefit berhasil diarsipkan',
  'membership.unarchive_benefit_success': 'Arsip benefit berhasil dibatalkan',
  'membership.archive_benefit_error': 'Gagal mengarsipkan benefit',
  'membership.unarchive_benefit_error': 'Gagal membatalkan arsip benefit',
  'membership.benefit_image_invalid_type': 'Hanya JPG, JPEG, PNG, atau GIF yang diperbolehkan',
  'membership.benefit_image_too_large': 'Ukuran gambar maksimal {maxMb} MB',
  'membership.benefit_validity_forever': 'Selamanya',
  'membership.pagination_total': 'Total {total} data',
  'membership.benefit_validity_period': 'Masa berlaku',
  'membership.benefit_point_price': 'Harga poin',
  'membership.benefit_max_qty': 'Maks. qty',
  'membership.benefit_max_qty_unlimited': 'Tanpa batasan',
  'membership.show_archived_benefits': 'Tampilkan arsip',
  'membership.benefit_name_label': 'Nama Benefit',
  'membership.benefit_name_required': 'Masukkan nama benefit',
  'membership.benefit_name_placeholder': 'Nama Benefit',
  'membership.benefit_name_max_length': 'Nama benefit maksimal 150 karakter',
  'membership.benefit_redeem_packages_hint': 'Dapat di redeem untuk member dengan paket',
  'membership.benefit_max_qty_heading': 'Maksimal kuantitas per member',
  'membership.benefit_exchange_point_price': 'Harga Tukar Poin',
  'membership.benefit_exchange_point_required': 'Masukkan harga tukar poin',
  'membership.benefit_exchange_point_min': 'Harga tukar poin minimal 1',
  'membership.benefit_description_placeholder': 'Masukkan deskripsi',
  'membership.benefit_description_max_length': 'Deskripsi maksimal 3000 karakter',
  'membership.benefit_validity_dates_required': 'Pilih tanggal',
  'membership.benefit_date_start_placeholder': 'Tanggal Mulai',
  'membership.benefit_date_end_placeholder': 'Tanggal Selesai',
  'membership.benefit_added_success': 'Benefit berhasil ditambahkan',
  'membership.benefit_photo_upload_failed': 'Foto gagal diupload',
  'membership.benefit_add_failed': 'Gagal menambahkan benefit',
  'membership.benefit_deleted_success': 'Benefit berhasil dihapus',
  'membership.benefit_delete_failed': 'Gagal menghapus benefit',
  'membership.benefit_updated_success': 'Benefit berhasil diubah',
  'membership.benefit_update_failed': 'Gagal mengubah benefit',
  'membership.benefit_photo_sync_failed': 'Foto gagal disinkronkan',
  'membership.benefit_redeem_chart_title': 'Jumlah Penukaran Per Bulan',
  'membership.benefit_stat_total_redeemed': 'Total Ditukar',
  'membership.benefit_stat_total_redeemed_sub': 'Akumulasi selamanya',
  'membership.benefit_stat_redemptions': 'Penukaran',
  'membership.benefit_stat_last_30_days': '30 hari terakhir',
  'membership.benefit_stat_total_points': 'Total Poin',
  'membership.benefit_stat_current_points': 'Poin saat ini',
  'membership.benefit_stat_new_points': 'Poin Baru',
  'membership.benefit_detail_card_title': 'Detail Benefit',
  'membership.benefit_detail_photos': 'Foto',
  'membership.benefit_detail_validity': 'Berlaku',
  'membership.benefit_validity_range': '{start} s/d {end}',
  'membership.benefit_points_display': '{count} Poin',
  'membership.benefit_chart_dataset_label': 'Jumlah Redeem',
  'membership.benefit_chart_tooltip': 'Redeem: {count}',
  'membership.benefit_chart_empty': 'Belum ada data redeem',
  'membership.benefit_redeem_title': 'Redeem',
  'membership.benefit_redeem_col_name': 'Nama',
  'membership.benefit_redeem_col_date': 'Tanggal',
  'membership.benefit_redeem_col_qty': 'Jumlah Redeem',
  'membership.benefit_redeem_col_points': 'Poin',
  'membership.edit_benefit_title': 'Ubah Benefit',
  'membership.benefit_detail_page_title': 'Detail Benefit',
  'membership.days_remaining': '{count} Hari',
  'membership.edit_member': 'Ubah Member',
  'membership.more_actions': 'Aksi lainnya',
  'membership.member_number_short': 'No. member',
  'membership.registered_at': 'Terdaftar di',
  'membership.last_30_days': '30 hari terakhir',
  'membership.view_contact': 'Lihat kontak',
  'membership.contact_section': 'Kontak',
  'membership.membership_section': 'Keanggotaan',
  'membership.not_yet': 'Belum ada',
  'membership.no_expiry': 'Tanpa batas',
  'membership.days_overdue': 'Lewat {count} hari',
  'membership.days_left_count': '{count} hari lagi',
  'membership.card_preview_note': 'Tampilan kartu sama dengan yang dilihat member di aplikasi',
  'membership.view_member_detail': 'Lihat detail data member',
  'membership.name_required': 'Masukkan nama terlebih dahulu',
  'membership.email_required': 'Masukkan email terlebih dahulu',
  'membership.email_invalid': 'Format email tidak valid',
  'membership.phone_required': 'Masukkan nomor HP terlebih dahulu',
  'membership.enter_name': 'Masukkan Nama',
  'membership.enter_email': 'Masukkan Email',
  'membership.enter_phone': 'Masukkan Nomor Telepon',
  'membership.enter_address': 'Masukkan Alamat',
  'membership.select_plan': 'Pilih Paket',
  'membership.select_status': 'Pilih Status',
  'membership.select_start_paid_date': 'Pilih Tgl. Mulai Berbayar',
  'membership.select_expiry_date': 'Pilih Tanggal Kedaluarsa',
  'membership.select_register_branch': 'Pilih Cabang Tempat Mendaftar',
  'membership.add_transaction_title': 'Tambah Transaksi Membership',
  'membership.select_member': 'Pilih member',
  'membership.select_transaction_type': 'Pilih jenis transaksi',
  'membership.next': 'Selanjutnya',
  'membership.create_transaction': 'Buat Transaksi',
  'membership.back': 'Kembali',
  'membership.transaction_type_register': 'Registrasi',
  'membership.transaction_type_addon': 'Addon',
  'membership.transaction_type_perpanjangan': 'Perpanjangan',
  'membership.transaction_type_upgrade': 'Upgrade',
  'membership.registration_fee': 'Biaya Pendaftaran',
  'membership.select_package': 'Pilih Paket',
  'membership.select_subscription_duration': 'Pilih Lama Berlangganan',
  'membership.select_addon': 'Pilih Addon',
  'membership.per_month': '/bln',
  'membership.upgrade_note': 'Saat upgrade, hanya tampilkan paket di atasnya.',
  'membership.current_package': 'Paket saat ini',
  'membership.renew_package_note':
    'Perpanjangan memakai paket yang sama dengan member saat ini. Paket tidak dapat diubah di sini.',
  'membership.upgrade_cannot_highest':
    'Tidak dapat melakukan upgrade, karena member sudah berada di paket tertinggi.',
  'membership.upgrade_per_month_difference': '/bln (selisih)',
  'membership.upgrade_only': 'Hanya Upgrade',
  'membership.upgrade_only_price_hint': 'Sesuai sisa masa aktif',
  'membership.term_discount_badge': 'Hemat {percent}%',
  'membership.cost_breakdown': 'Rincian Biaya',
  'membership.line_discount_hint': '{gross} − diskon {percent}% ({amount})',
  'membership.prorata_line_label': 'Upgrade {name} masa berlaku',
  'membership.prorata_line_note': 'Untuk sisa masa aktif',
  'membership.duration_1_month': '1 Bulan',
  'membership.duration_2_months': '2 Bulan',
  'membership.status_membership': 'Aktifkan Membership?',
  'membership.paid_membership_question':
    'Ini adalah program loyalti untuk member Anda.\nPenerapan bonus poin setiap transaksi, pemberlakuan biaya membership bulanan, dan banyak lagi.',
  'membership.paid_membership_yes': 'Ya',
  'membership.paid_membership_no': 'Tidak',
  'membership.paid_membership_note': 'Jika On, baru ditampilkan yang dibawahnya',
  'membership.package_config_title': 'Konfigurasi Paket Membership',
  'membership.membership_packages_question': 'Paket yang apa saja yang tersedia untuk membership?',
  'membership.add_package_new': 'Tambah Paket Baru',
  'membership.sorted_by_cheapest': 'diurutkan berdasarkan harga termurah',
  'membership.add_package': 'Tambah paket',
  'membership.cannot_create_transaction_title': 'Tidak dapat membuat transaksi',
  'membership.no_paid_plan_cannot_create_transaction':
    'Anda tidak memiliki paket membership berbayar, sehingga tidak dapat membuat transaksi',
  'membership.no_packages': 'Belum ada paket',
  'membership.package_archived_badge': 'Diarsipkan',
  'membership.package_name': 'Nama Paket',
  'membership.monthly_fee': 'Biaya Per Bulan',
  'membership.registration_fee_label': 'Biaya Pendaftaran',
  'membership.description': 'Deskripsi',
  'membership.can_check_in': 'Bisa Check In / Absensi',
  'membership.plan_description_placeholder': 'Deskripsi paket untuk member (opsional)',
  'membership.plan_image_label': 'Gambar Paket',
  'membership.plan_image_upload': 'Unggah',
  'membership.plan_image_hint': 'JPG, PNG, atau GIF. Maks. {size} MB.',
  'membership.plan_image_invalid_type': 'Hanya file JPG, PNG, atau GIF.',
  'membership.plan_image_too_large': 'Ukuran gambar maksimal {max} MB.',
  'membership.plan_image_upload_failed': 'Gagal mengunggah gambar.',
  'membership.edit_package': 'Ubah Paket',
  'membership.add_package_title': 'Paket Membership',
  'membership.delete_package': 'Hapus',
  'membership.delete_package_confirm': 'Apakah Anda yakin ingin menghapus paket ini?',
  'membership.archive_package': 'Arsipkan',
  'membership.unarchive_package': 'Batalkan arsip',
  'membership.archive_package_confirm':
    'Arsipkan paket ini? Paket tidak akan tersedia untuk langganan baru.',
  'membership.unarchive_package_confirm': 'Kembalikan paket ini agar dapat digunakan lagi?',
  'membership.package_name_required': 'Masukkan nama paket',
  'membership.settings_plan_updated_success': 'Paket berhasil diubah',
  'membership.settings_plan_updated_error': 'Gagal mengubah paket',
  'membership.settings_plan_created_success': 'Paket berhasil ditambahkan',
  'membership.settings_plan_created_error': 'Gagal menambahkan paket',
  'membership.plan_max_reached':
    'Maksimal 5 paket. Hapus paket terlebih dahulu sebelum menambah yang baru.',
  'membership.free_plan_already_exists':
    'Hanya boleh ada satu paket gratis (biaya bulanan 0 dan biaya daftar 0). Ubah paket gratis yang ada atau tetapkan harga pada paket ini.',
  'membership.settings_saved_success': 'Perubahan berhasil disimpan',
  'membership.add_member_empty_plans_body':
    'Belum ada paket aktif. Member tetap bisa dibuat tanpa paket, atau tambahkan paket dulu.',
  'membership.add_member_empty_plans_link': 'Tambah paket',
  'membership.add_member_empty_terms_body':
    'Anda belum memiliki termin. Silakan tambah termin terlebih dahulu.',
  'membership.add_member_empty_terms_link': 'Tambah termin',
  'membership.add_member_empty_branches_body':
    'Anda belum memiliki cabang. Silakan tambah cabang terlebih dahulu.',
  'membership.add_member_empty_branches_link': 'Tambah cabang',
  'membership.add_member_segment_new': 'Tambah Baru',
  'membership.add_member_segment_new_hint': 'Isi data calon member baru',
  'membership.add_member_segment_from_customer': 'Tambah Dari Pelanggan',
  'membership.add_member_segment_from_customer_hint': 'Pilih dari kontak pelanggan',
  'membership.revert_phone_to_default': 'Kembalikan ke nomor default',
  'membership.select_customer': 'Pilih Pelanggan',
  'membership.select_customer_required': 'Pilih pelanggan terlebih dahulu',
  'membership.placeholder_full_name': 'Masukkan Nama',
  'membership.placeholder_email_input': 'Masukkan Email',
  'membership.placeholder_address_input': 'Masukkan Alamat',
  'membership.name_required_first': 'Masukkan nama terlebih dahulu',
  'membership.name_min_two_chars': 'Nama minimal 2 karakter',
  'membership.email_required_first': 'Masukkan email terlebih dahulu',
  'membership.address_required_first': 'Masukkan alamat terlebih dahulu',
  'membership.address_min_ten_chars': 'Alamat minimal 10 karakter',
  'membership.add_member_term_field': 'Termin',
  'membership.registration_branch': 'Cabang Tempat Mendaftar',
  'membership.select_branch': 'Pilih Cabang',
  'membership.term_years_display': '{count} tahun',
  'membership.term_years_display_plural': '{count} tahun',
  'membership.untitled_plan': 'Tanpa judul',
  'membership.open_membership_settings': 'Buka pengaturan membership',
  'membership.subscription_terms': 'Termin Berlangganan',
  'membership.add_term': 'Tambah termin',
  'membership.no_terms': 'Belum ada termin',
  'membership.add_term_title': 'Tambah Termin',
  'membership.edit_term': 'Ubah Termin',
  'membership.delete_term': 'Hapus',
  'membership.delete_term_confirm': 'Apakah Anda yakin ingin menghapus termin ini?',
  'membership.term_months': 'Durasi (bulan)',
  'membership.term_months_required': 'Masukkan durasi dalam bulan',
  'membership.term_months_min': 'Minimal 1 bulan',
  'membership.term_months_max': 'Maksimal 36 bulan',
  'membership.term_months_already_exists': 'Durasi ini sudah ada',
  'membership.term_months_display': '{count} Bulan',
  'membership.term_months_display_plural': '{count} Bulan',
  'membership.transaction_detail_title': 'Detail Transaksi',
  'membership.subscription_duration': 'Lama Berlangganan',
  'membership.accept_payment': 'Terima Pembayaran',
  'membership.payment_select_bank': 'Rekening bank',
  'membership.payment_paid_date': 'Tanggal bayar',
  'membership.payment_recorded_success': 'Pembayaran berhasil dicatat',
  'membership.payment_recorded_error': 'Gagal mencatat pembayaran',
  'membership.payment_no_bank_accounts':
    'Belum ada rekening bank. Tambahkan di pengaturan keuangan terlebih dahulu.',
  'membership.view_invoice': 'Lihat Tagihan',
  'membership.edit_transaction': 'Ubah',
  'membership.edit_transaction_title': 'Ubah transaksi',
  'membership.transaction_updated_success': 'Transaksi berhasil diperbarui',
  'membership.transaction_updated_error': 'Gagal memperbarui transaksi',
  'membership.void_transaction': 'Void',
  'membership.void_transaction_confirm': 'Yakin ingin membatalkan (void) transaksi ini?',
  'membership.transaction_voided_success': 'Transaksi berhasil di-void',
  'membership.transaction_voided_error': 'Gagal mem-void transaksi',
  'membership.delete_transaction': 'Hapus',
  'membership.delete_transaction_confirm': 'Yakin ingin menghapus transaksi ini?',
  'membership.transaction_deleted_success': 'Transaksi berhasil dihapus',
  'membership.transaction_deleted_error': 'Gagal menghapus transaksi',
  'membership.addon_label': 'Addon',
  'membership.order_created_success': 'Transaksi berhasil dibuat',
  'membership.order_created_error': 'Gagal membuat transaksi',
  'membership.load_transaction_detail_error': 'Gagal memuat detail transaksi',
  'membership.subscription_discounts': 'Diskon Berlangganan',
  'membership.add_discount': 'Tambah diskon',
  'membership.no_discounts': 'Belum ada diskon',
  'membership.add_discount_title': 'Tambah Diskon',
  'membership.edit_discount': 'Ubah Diskon',
  'membership.delete_discount': 'Hapus',
  'membership.delete_discount_confirm': 'Apakah Anda yakin ingin menghapus diskon ini?',
  'membership.discount_min_months': 'Minimal bulan',
  'membership.discount_min_months_required': 'Masukkan minimal bulan',
  'membership.discount_min_months_min': 'Minimal 1 bulan',
  'membership.discount_percent': 'Diskon (%)',
  'membership.discount_percent_required': 'Masukkan persentase diskon',
  'membership.discount_percent_range': 'Harus antara 0 dan 100',
  'membership.discount_label': 'Minimal {months} bulan diskon {discount}%',
  'membership.discount_min_display': 'Min. {months} bulan',
  'membership.discount_percent_display': 'Diskon {discount}%',
  'membership.discounts_sorted_by': 'diurutkan berdasarkan diskon terbesar',
  'membership.addon_section_title': 'Layanan Tambahan (Add-on)',
  'membership.addon_subscription': 'Addon Berlangganan',
  'membership.addon_price_per_month': 'Biaya per bulan',
  'membership.addon_price_per_month_2': '{price}/bln',
  'membership.addon_price_per_time': '{price}',
  'membership.addon_one_time': 'Addon Sekali Bayar',
  'membership.addon_one_time_hint': '(sekali bayar)',
  'membership.add_addon': 'Tambah addon',
  'membership.no_addons': 'Belum ada addon',
  'membership.add_addon_title': 'Tambah Addon',
  'membership.edit_addon': 'Ubah Addon',
  'membership.addon_view_related_product': 'Lihat Produk Terkait',
  'membership.delete_addon': 'Hapus',
  'membership.delete_addon_confirm': 'Apakah Anda yakin ingin menghapus addon ini?',
  'membership.archive_addon': 'Arsipkan',
  'membership.unarchive_addon': 'Batalkan arsip',
  'membership.archive_addon_confirm':
    'Arsipkan add-on ini? Add-on tidak akan ditawarkan untuk langganan baru.',
  'membership.unarchive_addon_confirm': 'Kembalikan add-on ini agar dapat dipakai lagi?',
  'membership.addon_name': 'Nama Addon',
  'membership.addon_name_required': 'Masukkan nama addon',
  'membership.addon_price': 'Harga',
  'membership.add_addon_subscription_title': 'Tambah Addon Berlangganan',
  'membership.add_addon_one_time_title': 'Tambah Addon Sekali Bayar',
  'membership.edit_addon_subscription_title': 'Ubah Addon Berlangganan',
  'membership.edit_addon_one_time_title': 'Ubah Addon Sekali Bayar',
  'membership.addon_label_per_month': '{title} Rp {price}.-/bln',
  'membership.addon_label_one_time': '{title} Rp {price}.-',
  'membership.operational_rules_title': 'Aturan Operasional',
  'membership.effective_date_renew_on_title':
    'Saat member melakukan perpanjangannya terlambat, bagaimana perhitungan masa aktifnya?',
  'membership.effective_date_renew_on_paid': 'Masa aktif dihitung dari waktu pembayaran',
  'membership.effective_date_renew_on_expired_date': 'Masa aktif dihitung dari tanggal expired',
  'membership.effective_date_renew_on_tooltip':
    'Misalnya member A expired pada 10 Januari, kemudian perpanjangan 1 bulan pada 20 Januari.\n\nJika masa aktif dihitung dari waktu pembayaran, maka masa aktif member A akan berakhir pada 19 Februari.\n\nJika masa aktif dihitung dari tanggal expired, maka masa aktif member A akan berakhir pada 9 Februari.',
  'membership.effective_date_renew_on_tooltip_aria':
    'Bantuan: contoh perhitungan masa aktif saat perpanjang terlambat',
  'membership.point_rules': 'Aturan Poin',
  'membership.point_rules_spending_prefix': 'Setiap transaksi kelipatan',
  'membership.point_rules_points_suffix': 'mendapatkan',
  'membership.point_rules_points_unit': 'poin',
  'membership.attendance_rules': 'Aturan Attendance',
  'membership.attendance_rules_auto_checkout_prefix':
    'Setiap checkin akan checkout otomatis setelah',
  'membership.attendance_rules_hours_unit': 'jam',
  'membership.branches_title': 'Cabang / Outlet',
  'membership.add_branch': 'Tambah cabang',
  'membership.add_branch_new': 'Tambah cabang baru',
  'membership.no_branches': 'Belum ada cabang',
  'membership.add_branch_title': 'Tambah Cabang',
  'membership.edit_branch_title': 'Ubah Cabang',
  'membership.branch_name': 'Nama Cabang',
  'membership.branch_name_required': 'Masukkan nama cabang',
  'membership.branch_photo': 'Foto',
  'membership.branch_photo_placeholder': 'URL foto',
  'membership.branch_photo_select': 'Pilih foto',
  'membership.branch_photo_upload_hint':
    'Format: JPG, JPEG, PNG, atau GIF. Foto diunggah setelah cabang berhasil disimpan.',
  'membership.branch_photo_remove': 'Hapus foto',
  'membership.branch_photo_delete_confirm': 'Hapus foto cabang dari server?',
  'membership.branch_photo_deleted': 'Foto cabang berhasil dihapus',
  'membership.branch_photo_invalid_type': 'Hanya JPG, JPEG, PNG, atau GIF yang diperbolehkan',
  'membership.branch_address': 'Alamat',
  'membership.branch_address_placeholder': 'Masukkan alamat',
  'membership.branch_latitude': 'Lintang',
  'membership.branch_longitude': 'Bujur',
  'membership.branch_latitude_placeholder': 'contoh: -6.2088',
  'membership.branch_longitude_placeholder': 'contoh: 106.8456',
  'membership.branch_latitude_required': 'Lintang wajib diisi',
  'membership.branch_longitude_required': 'Bujur wajib diisi',
  'membership.branch_latitude_invalid': 'Silakan masukkan lintang yang valid (-90 hingga 90)',
  'membership.branch_longitude_invalid': 'Silakan masukkan bujur yang valid (-180 hingga 180)',
  'membership.branch_pick_on_map': 'Pilih di Peta',
  'membership.branch_is_active': 'Aktif',
  'membership.delete_branch': 'Hapus',
  'membership.delete_branch_confirm': 'Yakin ingin menghapus cabang ini?',
  'membership.branch_search_placeholder': 'Cari cabang',
  'membership.add_location': 'Tambah Lokasi',
  'membership.map_type_map': 'Map',
  'membership.map_type_satellite': 'Satelit',
  'membership.map_fullscreen': 'Layar penuh',
  'membership.branch_filter_all': 'Semua',
  'membership.branch_filter_active': 'Aktif',
  'membership.branch_filter_archived': 'Diarsipkan',
  'membership.branch_map_preview': 'Preview Lokasi',
  'membership.branch_status_archived': 'Diarsipkan',
  'membership.branch_status_active_short': 'Aktif',
  'membership.branch_archive': 'Arsipkan',
  'membership.branch_unarchive': 'Batal arsip',
  'membership.branch_archive_confirm': 'Arsipkan cabang ini?',
  'membership.branch_unarchive_confirm': 'Kembalikan cabang ini dari arsip?',
  'membership.add_location_branch': 'Tambah Lokasi Cabang',
  'membership.branch_phone_label': 'Telepon',
  'membership.branch_created_label': 'Dibuat',
  'membership.branch_menu_loading': 'Memuat…',
  'membership.news_coming_soon': 'Pengaturan News - segera hadir',
  'membership.news_title_column': 'Judul',
  'membership.news_display_from_column': 'Tayang Dari',
  'membership.news_display_until_column': 'Tayang Sampai',
  'membership.news_status_column': 'Status',
  'membership.news_status_active': 'Aktif',
  'membership.news_status_inactive': 'Tidak Aktif',
  'membership.news_filter_all': 'Semua',
  'membership.news_search_placeholder': 'Cari',
  'membership.news_add_button': 'Tambah',
  'membership.news_total': 'Total {total} data',
  'membership.news_title': 'Judul',
  'membership.news_title_required': 'Judul wajib diisi',
  'membership.news_title_placeholder': 'Masukkan judul',
  'membership.news_description': 'Deskripsi',
  'membership.news_description_placeholder': 'Masukkan deskripsi',
  'membership.news_display_from': 'Tayang Dari',
  'membership.news_display_from_required': 'Tayang dari wajib diisi',
  'membership.news_display_until': 'Tayang Sampai',
  'membership.news_display_until_required': 'Tayang sampai wajib diisi',
  'membership.news_start_date': 'Tayang Dari',
  'membership.news_start_date_required': 'Tayang dari wajib diisi',
  'membership.news_end_date': 'Tayang Sampai',
  'membership.news_end_date_required': 'Tayang sampai wajib diisi',
  'membership.news_airing_label': 'Tayang',
  'membership.news_date_range_separator': 's/d',
  'membership.news_date_range_required': 'Tanggal mulai dan selesai tayang wajib diisi',
  'membership.news_date_range_invalid': 'Tanggal mulai tidak boleh setelah tanggal selesai',
  'membership.news_is_active': 'Aktif',
  'membership.news_photos_label': 'Gambar',
  'membership.news_photos_upload': 'Unggah',
  'membership.news_photos_upload_hint':
    'JPG, PNG, atau GIF. Maks. {max} gambar, {size} MB per file.',
  'membership.news_photos_invalid_type': 'Hanya file JPG, PNG, atau GIF.',
  'membership.news_photos_max_count': 'Maksimal {max} gambar.',
  'membership.news_photos_too_large': 'Ukuran file maksimal {max} MB.',
  'membership.add_news_title': 'Tambah News',
  'membership.edit_news_title': 'Ubah News',
  'membership.delete_news': 'Hapus',
  'membership.delete_news_confirm': 'Yakin ingin menghapus news ini?',
  'membership.archive_news': 'Arsipkan',
  'membership.archive_news_confirm': 'Arsipkan news ini?',
  'membership.unarchive_news': 'Batalkan arsip',
  'membership.unarchive_news_confirm': 'Kembalikan news ini dari arsip?',
  'membership.settings_tab_appearance': 'Tampilan Aplikasi',
  'membership.settings_tab_branch_locations': 'Lokasi Cabang',
  'membership.settings_tab_news': 'News',
  'membership.appearance_general_settings': 'Pengaturan Umum',
  'membership.appearance_website_url': 'Alamat Website',
  'membership.appearance_website_subdomain_placeholder': 'subdomain',
  'membership.appearance_website_open': 'Buka website',
  'membership.appearance_download_app': 'Download Aplikasi Member',
  'membership.appearance_upload_logo': 'Unggah Logo',
  'membership.appearance_upload': 'Unggah',
  'membership.appearance_main_color': 'Warna Utama',
  'membership.appearance_secondary_color': 'Warna Sekunder',
  'membership.appearance_qr_checkin': 'QR Code Check In',
  'membership.appearance_profile': 'Profile',
  'membership.appearance_menu_app': 'Menu Aplikasi',
  'membership.appearance_home_layout': 'Tata Letak Beranda',
  'membership.appearance_statistik': 'Statistik',
  'membership.appearance_live_preview': 'Pratinjau Langsung',
  'membership.appearance_logo_hint': 'Format PNG/JPG/GIF, maks {size}MB',
  'membership.appearance_logo_invalid_type': 'Format logo tidak didukung',
  'membership.appearance_logo_too_large': 'Ukuran logo maksimal {size}MB',
  'membership.appearance_logo_upload_success': 'Logo berhasil diunggah',
  'membership.appearance_logo_upload_failed': 'Logo gagal diunggah',
  'membership.appearance_logo_delete_success': 'Logo berhasil dihapus',
  'membership.appearance_logo_delete_failed': 'Logo gagal dihapus',
  'membership.member': 'Member',
  'membership.free': 'Gratis',
  'membership.register_fee': 'Biaya daftar {price}',
  'membership.no_register_fee': 'Tanpa biaya daftar',
  'membership.plan_required': 'Paket wajib dipilih',
  'membership.free_plan_only': 'Paket gratis',
  'membership.free_plan_only_hint':
    'Tanpa akses Membership, member didaftarkan dengan paket gratis.',
  'membership.expiry_optional_hint': 'Opsional. Kosongkan untuk mengikuti paket.',
  'membership.already_member': 'Sudah menjadi member',
  'membership.join_title': 'Jadikan member',
  'membership.join_desc':
    'Daftarkan kontak ini sebagai member sekaligus agar setiap transaksinya mengumpulkan poin.',
  'membership.add_to_membership': 'Tambahkan ke membership',
  'membership.add_to_membership_confirm': 'Jadikan {name} member?',
  'membership.add_to_membership_desc':
    'Pastikan data berikut sudah benar. Nomor telepon dipakai member untuk login.',
  'membership.complete_required_data':
    'Lengkapi data yang masih kosong sebelum mendaftarkan member.',
  'membership.not_member_yet': 'Belum menjadi member',
  'membership.not_member_yet_desc':
    'Daftarkan kontak ini ke membership agar transaksinya menghasilkan poin.',
  'membership.expiry_forever': 'Selamanya',
  'membership.points_count': '{count} poin',
  'membership.valid_until': 's/d {date}',
  'membership.point_movement': 'Pergerakan Poin',
  'membership.member_list': 'Daftar Member',
  'membership.point_in': 'Poin Masuk',
  'membership.point_out': 'Poin Keluar',
  'membership.point_net': 'Selisih Poin',
  'membership.sales_only': 'Penjualan saja',
  'membership.source': 'Sumber',
  'membership.trans_number': 'No. Transaksi',
  'membership.nominal': 'Nominal',
  'membership.all_members': 'Semua member',
  'settings.membership': 'Atur alur membership',
  'cashier.table_detail.title': 'Pilih Meja',
  'cashier.table_detail.panel_title': 'Order Meja',
  'cashier.table_detail.panel_description':
    'Tentukan meja, jumlah tamu, dan nama order untuk transaksi dine in.',
  'cashier.table_detail.form_description':
    'Pilih lantai lalu meja yang tersedia untuk melanjutkan transaksi.',
  'cashier.table_detail.select_floor': 'Pilih Lantai',
  'cashier.table_detail.select_table': 'Pilih Meja',
  'cashier.table_detail.table_empty': 'Belum ada meja di lantai ini',
  'cashier.table_detail.floor_empty': 'Belum ada lantai di outlet ini',
  'cashier.table_detail.guest_count': 'Jumlah Tamu',
  'cashier.table_detail.guest_count_max': 'Maksimal {max} tamu',
  'cashier.table_detail.guest_count_required': 'Jumlah tamu wajib diisi',
  'cashier.table_detail.order_name': 'Nama Order (opsional)',
  'cashier.table_detail.order_name_placeholder': 'Contoh: Budi / Meeting Lantai 2',
  'cashier.table_detail.occupied': 'Terisi',
  'cashier.table_detail.capacity': '{count} tamu',
  'cashier.table_detail.confirm_table': 'Konfirmasi Meja',
  'cashier.table_detail.table_fallback': 'Meja #{id}',
  'cashier.table_detail.reset_table': 'Reset Meja',
  'cashier.table_detail.reset_selected_table': 'Reset Meja Terpilih',
  'cashier.table_detail.reset_all_tables': 'Reset Semua Meja',
  'cashier.table_detail.reset_table_confirm': 'Reset meja {name}?',
  'cashier.table_detail.reset_table_description':
    'Order yang menempati meja ini akan dilepas. Order tidak dihapus.',
  'cashier.table_detail.reset_all_tables_confirm': 'Reset semua meja di lantai ini?',
  'cashier.table_detail.reset_all_tables_description':
    '{count} meja terisi di {floor} akan dilepas dari order-nya.',
  'cashier.table_detail.reset_success': 'Meja berhasil direset',
  'cashier.table_detail.reset_failed': 'Gagal mereset meja',
  'cashier.current_shift_prompt.title': 'Shift Anda Masih Terbuka',
  'cashier.current_shift_prompt.message':
    'Sistem mendeteksi shift yang masih berjalan untuk Anda di outlet ini. Lanjutkan shift sebelumnya agar transaksi tetap berurutan, atau buka shift baru.',
  'cashier.current_shift_prompt.use': 'Lanjutkan Shift',
  'cashier.current_shift_prompt.open_new': 'Buka Shift Baru',
  'cashier.current_shift_prompt.label_employee': 'Karyawan',
  'cashier.current_shift_prompt.label_outlet': 'Outlet',
  'cashier.current_shift_prompt.label_start': 'Mulai',
  'cashier.current_shift_prompt.label_opening_balance': 'Saldo Awal',
  'cashier.current_shift_prompt.open_new_confirm':
    'Shift #{id} yang masih terbuka akan ditutup otomatis saat shift baru dibuka. Lanjutkan?',
  'cashier.current_shift_prompt.open_new_confirm_ok': 'Ya, Buka Shift Baru',
  'cashier.shift_check_failed_title': 'Gagal memeriksa shift',
  'cashier.shift_check_failed_message':
    'Tidak dapat terhubung ke server untuk memeriksa shift yang masih terbuka. Periksa koneksi lalu coba lagi.',
  'cashier.shift_check_retry': 'Coba lagi',
  'cashier.insufficient_stock.title': 'Stok Tidak Mencukupi',
  'cashier.insufficient_stock.message_order':
    'Pesanan tidak dapat disimpan karena ada produk yang stoknya tidak mencukupi.',
  'cashier.insufficient_stock.message_invoice':
    'Tagihan tidak dapat disimpan karena ada produk yang stoknya tidak mencukupi.',
  'cashier.insufficient_stock.requested': 'Diminta',
  'cashier.receipt_ojol_name': 'Nama Ojol',
  'cashier.receipt_ojol_order_no': 'Nomor pesanan',
  'cashier.receipt_table': 'Meja',
  'cashier.receipt_served_by': 'Pegawai',
  'cashier.served_by.title': 'Dilayani Oleh',
  'cashier.served_by.subtitle': 'Pilih pegawai yang melayani transaksi ini, bisa lebih dari satu.',
  'cashier.served_by.panel_title': 'Pegawai Pelayan',
  'cashier.served_by.panel_description':
    'Catat siapa saja yang melayani pelanggan agar kinerja pegawai mudah dipantau.',
  'cashier.served_by.search': 'Cari atau ketik nama pegawai',
  'cashier.served_by.add_manual': 'Tambahkan "{name}"',
  'cashier.served_by.add_manual_hint': 'Nama di luar daftar pegawai',
  'cashier.served_by.manual_badge': 'Manual',
  'cashier.served_by.empty': 'Belum ada data pegawai',
  'cashier.served_by.not_found': 'Pegawai tidak ditemukan',
  'cashier.served_by.selected_empty': 'Belum ada pegawai dipilih',
  'cashier.served_by.save_count': 'Simpan ({count})',
  'cashier.served_by.required': 'Pilih pegawai yang melayani terlebih dahulu',
  'cashier.served_by.fallback_info': 'Menampilkan pegawai outlet ini.',
  'cashier.served_by.retry': 'Coba lagi',
  'cashier.receipt_table_order_name': 'Nama Order',
  'cashier.receipt_table_guests': 'Jumlah Tamu',
  enter_format: 'Masukkan format',
  'layoutInvoice.invoice_show_termin_summary': 'Tampilkan Order Termin',
  please_select_product_to_refund: 'Silahkan pilih produk yang akan direfund',
  payment_information: 'Informasi Pembayaran',
  'sendEmail.email_to_is_required': 'Email Kepada wajib diisi',
  'sendEmail.phone_number_is_required': 'Nomor telepon wajib diisi',
  'sendEmail.enter_phone_number': 'Masukkan nomor telepon',
  'financeInvoices.save_and_send': 'Simpan & Kirim',
  'financeInvoices.mass_whatsapp_and_email': 'Kirim Whatsapp & Email Massal',
  'report.qty_return': 'Kuantitas Retur',
  'report.qty_net': 'Kuantitas (NET)',
  'report.total_after_vat': 'Total Setelah PPN',
  'report.avg_after_vat': 'Rata-rata Setelah PPN',
  'financeInvoices.email_is_not_available_in_demo': 'Fitur kirim email tidak tersedia di akun demo',
  new_badge_text: 'BARU!',
  'appOnboarding.paymentGateway.view_more': 'Lihat lebih detail',
  'appOnboarding.paymentGateway.detail_modal_title': 'Payment Connect',
  'appOnboarding.paymentGateway.dismiss_modal_title': 'Konfirmasi',
  'appOnboarding.paymentGateway.dismiss_warning_title':
    'Yakin tidak ingin meningkatkan rasio tagihan dibayar?',
  'appOnboarding.paymentGateway.detail_paragraph_1':
    'Dengan mengaktifkan fitur payment connect, rasio tagihan dibayar Anda dapat meningkat hingga 50%.',
  'appOnboarding.paymentGateway.detail_paragraph_2':
    'Pelanggan Anda akan dapat melakukan pembayaran tagihan melalui QRIS, Transfer, Kartu Kredit, Gopay, ShopeePay, Indomaret, Paylater dan berbagai metode pembayaran lainnya.',
  'appOnboarding.paymentGateway.detail_confirm_question': 'Aktifkan fitur payment connect?',
  'appOnboarding.paymentGateway.btn_activate_payment_connect': 'Aktifkan payment connect',
  'appOnboarding.paymentGateway.btn_do_not_activate': 'Jangan aktifkan',
  'appOnboarding.paymentGateway.btn_yes_activate': 'Ya, aktifkan',
  'appOnboarding.paymentGateway.btn_no': 'Tidak',
  'appOnboarding.paymentGateway.success_modal_title': 'Payment Connect Kledo aktif',
  'appOnboarding.paymentGateway.success_modal_body':
    'Payment Connect Kledo sudah siap digunakan untuk transaksi Anda. Pelanggan dapat membayar tagihan dengan berbagai metode pembayaran.',
  'appOnboarding.paymentGateway.success_modal_link': 'Buka pengaturan Payment Connect Kledo',
  'appOnboarding.paymentGateway.success_modal_hint':
    'Anda dapat menyesuaikan metode pembayaran dan detail lainnya kapan saja di halaman pengaturan.',
  'appOnboarding.paymentGateway.success_modal_btn': 'Mengerti',
  'appOnboarding.paymentGateway.activate_error_fallback':
    'Tidak dapat mengaktifkan Payment Connect. Silakan coba lagi.',
  'appOnboarding.paymentGateway.info.section1_title': 'Menerima berbagai metode pembayaran',
  'appOnboarding.paymentGateway.info.section1_body':
    'Pembayaran invoice kini dapat dilakukan melalui berbagai metode pembayaran seperti Bank Transfer, E-Wallet, QRIS, Over The Counter, Kartu Debit/Kredit, dan PayLater.',
  'appOnboarding.paymentGateway.info.section2_title': 'Biaya Transaksi Payment Gateway',
  'appOnboarding.paymentGateway.info.section2_body':
    'Setiap transaksi pembayaran akan dikenakan biaya administrasi sesuai metode pembayaran yang digunakan. Berikut detail biaya per metode pembayaran.',
  'appOnboarding.paymentGateway.info.section2_fee_charged_to_title':
    'Biaya transaksi ini dapat diatur untuk dibebankan kepada:',
  'appOnboarding.paymentGateway.info.section2_fee_to_buyer':
    'Pembeli / pelanggan — biaya ditambahkan ke total tagihan.',
  'appOnboarding.paymentGateway.info.section2_fee_to_seller':
    'Penjual / perusahaan — biaya dipotong dari nilai pencairan.',
  'appOnboarding.paymentGateway.info.section2_fee_settings_hint':
    'Pengaturan ini tersedia di halaman Payment Connect Kledo pada kolom “Biaya dibebankan kepada”.',
  'appOnboarding.paymentGateway.info.section3_title': 'Proses Pencairan Dana',
  'appOnboarding.paymentGateway.info.section3_body':
    'Agar dana pembayaran dapat dicairkan ke rekening tujuan, Anda perlu terlebih dahulu menginput data rekening pencairan serta melengkapi data verifikasi yang dibutuhkan.',
  'appOnboarding.paymentGateway.info.section3_step1_title': 'Input rekening pencairan',
  'appOnboarding.paymentGateway.info.section3_step1':
    'Masukkan rekening tujuan untuk pencairan dana. Pastikan nama pemilik rekening sesuai dengan data perusahaan atau diri Anda.',
  'appOnboarding.paymentGateway.info.section3_step2_title': 'Lengkapi data verifikasi',
  'appOnboarding.paymentGateway.info.section3_step2':
    'Unggah dokumen pendukung (KTP/akta sesuai nama pemilik rekening) dan foto selfie dengan latar lokasi perusahaan.',
  'appOnboarding.paymentGateway.info.section3_step3_title': 'Dana dapat dicairkan',
  'appOnboarding.paymentGateway.info.section3_step3':
    'Setelah verifikasi disetujui, dana dari setiap transaksi dapat dicairkan sesuai ketentuan yang berlaku pada Payment Connect Kledo.',
  'appOnboarding.paymentGateway.info.section3_footnote':
    'Tim kami akan menghubungi Anda apabila ada data verifikasi yang perlu dilengkapi.',
  'appOnboarding.paymentGateway.info.fee_unavailable':
    'Detail biaya transaksi belum tersedia saat ini.',
  'appOnboarding.paymentGateway.info.dont_show_again': 'Jangan tampilkan informasi ini lagi',
  'layoutInvoice.orientation': 'Orientasi',
  'shopify.connect_heading': 'Hubungkan toko Shopify Anda dengan Kledo',
  'shopify.connect_subtitle':
    'Sinkronisasi pesanan, produk, dan pembayaran secara otomatis untuk menghemat waktu Anda',
  'shopify.connect_button': 'Hubungkan Toko Shopify',
  'shopify.feature_sync_title': 'Sinkronisasi Otomatis',
  'shopify.feature_sync_desc': 'Data terupdate real-time antar platform.',
  'shopify.feature_invoice_title': 'Faktur Instan',
  'shopify.feature_invoice_desc': 'Buat invoice langsung dari pesanan.',
  'shopify.feature_stock_title': 'Manajemen Stok',
  'shopify.feature_stock_desc': 'Stok terkontrol di satu dashboard.',
  'shopify.footer_note': 'Belum punya toko Shopify? Daftarkan dulu untuk mulai sinkronisasi.',
  'shopify.modal_title': 'Hubungkan Toko Shopify',
  'shopify.modal_store_name_label': 'Nama Toko',
  'shopify.modal_store_name_placeholder': 'Masukkan nama toko',
  'shopify.modal_store_name_help': 'Masukkan subdomain toko Shopify Anda.',
  'shopify.modal_store_name_required': 'Nama toko wajib diisi',
  'shopify.modal_client_id_label': 'Client ID',
  'shopify.modal_client_id_placeholder': 'Masukkan Client ID (API key)',
  'shopify.modal_client_id_required': 'Client ID wajib diisi',
  'shopify.modal_client_secret_label': 'Client Secret',
  'shopify.modal_client_secret_placeholder': 'Masukkan Client Secret (API secret key)',
  'shopify.modal_client_secret_required': 'Client Secret wajib diisi',
  'shopify.modal_alert':
    'Pastikan toko Anda sudah aktif sebelum menghubungkan. Buat toko terlebih dahulu di Shopify.',
  'shopify.modal_cancel': 'Batal',
  'shopify.modal_connect': 'Hubungkan',
  'shopify.connect_success': 'Toko Shopify berhasil terhubung.',
  'shopify.connecting_title': 'Menghubungkan ke Shopify...',
  'shopify.connecting_subtitle':
    'Anda akan dialihkan ke halaman Shopify untuk mengizinkan akses. Mohon tunggu sebentar.',
  'shopify.callback_modal_title': 'Pemberitahuan',
  'shopify.callback_success_title': 'Berhasil Terhubung!',
  'shopify.callback_success_desc':
    'Toko Shopify Anda telah berhasil diintegrasikan dengan Kledo. Anda sekarang dapat mulai melakukan sinkronisasi data.',
  'shopify.callback_error_title': 'Gagal Menghubungkan',
  'shopify.callback_error_desc_default':
    'Terjadi kesalahan saat mencoba menghubungkan ke Shopify. Pastikan domain toko benar dan Anda memiliki izin akses yang diperlukan.',
  'shopify.callback_close': 'Tutup',
  'shopify.callback_try_again': 'Coba Lagi',
  'shopify.tutorial_video': 'Video Tutorial',
  'shopify.store_list_title': 'Daftar Koneksi Toko',
  'shopify.status_connected': 'Terhubung',
  'shopify.status_disconnected': 'Terputus',
  'shopify.created_at': 'Dibuat',
  'shopify.last_updated': 'Update Terakhir',
  'shopify.disconnected_since': 'Terputus sejak',
  'shopify.sync_schedule': 'Jadwal Sync',
  'shopify.manage': 'Kelola',
  'shopify.delete_connection': 'Hapus Koneksi',
  'shopify.delete_success': 'Koneksi berhasil dihapus',
  'shopify.reconnect': 'Reconnect',
  'shopify.detail_tab_payment': 'Akun Pembayaran',
  'shopify.detail_tab_webhook': 'Webhook',
  'shopify.detail_payment_title': 'Pengaturan Kode Akun Pembayaran',
  'shopify.detail_payment_subtitle':
    'Petakan metode pembayaran Shopify Anda untuk pencatatan otomatis yang akurat.',
  'shopify.detail_account_sales': 'Akun Penjualan',
  'shopify.detail_account_sales_placeholder': 'Pilih akun pendapatan...',
  'shopify.detail_account_sales_help':
    'Akun ini akan digunakan untuk mencatat setiap penjualan yang masuk.',
  'shopify.detail_account_sales_required': 'Akun penjualan wajib diisi',
  'shopify.detail_account_receivable': 'Akun Piutang',
  'shopify.detail_account_receivable_placeholder': 'Pilih akun piutang...',
  'shopify.detail_account_receivable_required': 'Akun piutang wajib diisi',
  'shopify.detail_account_discount': 'Akun Diskon',
  'shopify.detail_account_discount_placeholder': 'Pilih Diskon',
  'shopify.detail_account_shipping': 'Akun Ongkos Kirim',
  'shopify.detail_account_shipping_placeholder': 'Pilih Ongkos Kirim',
  'shopify.detail_account_tax': 'Akun Pajak',
  'shopify.detail_account_tax_placeholder': 'Pilih Pajak',
  'shopify.detail_save': 'Simpan',
  'shopify.detail_save_success': 'Pengaturan tersimpan',
  'shopify.detail_webhook_title': 'Webhook Topics',
  'shopify.detail_webhook_subtitle': 'Pilih event yang ingin disinkronkan dari Shopify',
  'shopify.detail_webhook_info':
    'Perubahan akan langsung diterapkan saat checkbox dicentang atau dihapus centangnya.',
  'shopify.detail_webhook_subscribe_success': 'Topik webhook berhasil diaktifkan.',
  'shopify.detail_webhook_unsubscribe_success': 'Topik webhook berhasil dinonaktifkan.',
  'shopify.detail_webhook_update_failed': 'Gagal memperbarui topik webhook.',
  'shopify.detail_group_orders': 'Orders',
  'shopify.detail_group_products': 'Products',
  'shopify.detail_group_customers': 'Customers',
  'shopify.detail_topic_orders_create_desc': 'Triggered saat pesanan baru dibuat.',
  'shopify.detail_topic_orders_updated_desc': 'Triggered saat pesanan diperbarui.',
  'shopify.detail_topic_orders_cancelled_desc': 'Triggered saat pesanan dibatalkan.',
  'shopify.detail_topic_orders_fulfilled_desc': 'Triggered saat pesanan dipenuhi.',
  'shopify.detail_topic_products_create_desc': 'Triggered saat produk baru dibuat.',
  'shopify.detail_topic_products_update_desc': 'Triggered saat produk diperbarui.',
  'shopify.detail_topic_products_delete_desc': 'Triggered saat produk dihapus.',
  'shopify.detail_topic_customers_create_desc': 'Triggered saat customer baru dibuat.',
  'shopify.detail_topic_customers_update_desc': 'Triggered saat customer diperbarui.',
  'shopify.detail_disconnect_title': 'Putuskan Koneksi',
  'shopify.detail_disconnect_desc':
    'Memutuskan koneksi akan menghentikan sinkronisasi data sepenuhnya. Token akses akan dihapus dan Anda perlu melakukan autentikasi ulang untuk menyambungkan kembali.',
  'shopify.detail_disconnect_button': 'Putuskan Koneksi',
  'shopify.detail_disconnect_confirm': 'Yakin ingin memutuskan koneksi toko ini?',
  'shopify.detail_disconnect_info': 'Aksi putuskan koneksi masih frontend-only pada fase ini.',
  'shopify.detail_payment_account_required': 'Akun pembayaran wajib diisi',
  'shopify.detail_payment_account_help':
    'Akun ini akan digunakan untuk mencatat setiap pembayaran yang masuk.',
  'shopify.detail_payment_account_placeholder': 'Pilih akun pembayaran...',
  in_second_value: 'dalam {value} detik.',
  'layoutInvoice.show_shipping_address': 'Tampilkan Alamat Pengiriman',
  'businessFlow.product_conversion_formula_lock':
    'Kunci kuantitas bahan baku saat konversi {product}',
  'businessFlow.product_conversion_formula_lock_desc':
    'Apakah kuantitas bahan baku saat konversi {product} dibuat tidak bisa diubah?',
  'businessFlow.production_plan_show_formula': 'Tampilkan Formula Produksi di Rencana Produksi',
  'businessFlow.production_plan_show_formula_desc':
    'Apakah panel Formula Produksi (perkiraan bahan baku) ditampilkan di form Rencana Produksi?',
  'businessFlow.modifier_product_enabled': 'Opsi modifier terhubung {product}',
  'businessFlow.modifier_product_enabled_desc':
    'Stok & harga pokok {product} ikut tercatat saat opsi dipilih di transaksi.',
  'businessFlow.production_plan_stock_warning_enabled':
    'Peringatan stok bahan baku di Rencana Produksi',
  'businessFlow.production_plan_stock_warning_enabled_desc':
    'Tampilkan kecukupan bahan baku di rencana produksi dan catat kekurangan saat realisasi.',
  'businessFlow.production_plan_stock_priority': 'Dahulukan rencana yang dibuat lebih dulu',
  'businessFlow.production_plan_stock_priority_desc':
    'Saat beberapa rencana berebut bahan yang sama, dahulukan rencana yang dibuat lebih dulu. Kalau mati, dipakai urutan prioritas di daftar.',
  'zap.warehouse_is_required': 'Gudang wajib diisi',
  select_sales_driver: 'Pilih Sales/Driver',
  'settings.discord_connect': 'Dapatkan notifikasi transaksi di Discord Kantormu',
  'settings.shopify_connect': 'Otomatis sinkron Shopify Anda ke Kledo',
  change_outlet: 'Ganti Outlet',
  'businessFlow.sale_hide_product_empty_quantity':
    'Sembunyikan {products} dengan kuantitas kosong di detail tagihan',
  'businessFlow.sale_hide_product_empty_quantity_desc':
    'Apakah {products} dengan kuantitas kosong disembunyikan di detail tagihan?',
  'businessFlow.purchase_hide_product_empty_quantity':
    'Sembunyikan {products} dengan kuantitas kosong di detail tagihan',
  'businessFlow.purchase_hide_product_empty_quantity_desc':
    'Apakah {products} dengan kuantitas kosong disembunyikan di detail tagihan?',
  'businessFlow.purchase_manufacture_product': 'Produk manufaktur dapat dibeli',
  'businessFlow.purchase_manufacture_product_desc':
    'Jika dimatikan, produk manufaktur tidak bisa dipilih di transaksi pembelian. Transaksi yang sudah ada tidak berubah.',
  'report.total_price_product': 'Total harga {title}',
  'report.partial_paid': 'Dibayar Sebagian',
  'layoutInvoice.this_template': 'Template ini',
  'approval.purchase_delivery': 'Pengiriman Pembelian',
  'layoutInvoice.invoice_show_receipt_signature_made_checked':
    'Tampilkan TTD Dibuat Oleh dan Diperiksa Oleh',
  'financeProduct.import_regular_product_2': 'Import {title} Reguler',
  'financeProduct.import_package_product_2': 'Impor {title} Paket',
  'financeProduct.import_manufacturing_product_2': 'Impor {title} Manufaktur',
  'financeProduct.import_conversion_product_2': 'Impor {title} Konversi',
  'financeProduct.import_variant_product_2': 'Impor {title} Varian',
  'financeProduct.import_variant.new_variants_title':
    'Varian & opsi baru yang akan dibuat otomatis',
  'financeProduct.import_variant.new_variant_axis': 'Sumbu varian baru',
  'financeProduct.import_variant.new_variant_option': 'Opsi baru pada varian yang sudah ada',
  'financeProduct.import_variant.combination_title': 'Kombinasi yang dilengkapi otomatis',
  'financeProduct.import_variant.combination_note':
    'Sistem menambah kombinasi di luar berkas agar tiap {product} lengkap.',
  'financeProduct.import_variant.combination_badge': '+{auto} otomatis',
  'financeProduct.import_variant.col_variant': 'Varian',
  'financeProduct.import_variant.col_option': 'Opsi',
  'financeProduct.import_variant.col_note': 'Keterangan',
  'financeProduct.import_variant.col_parent_code': 'Kode induk',
  'financeProduct.import_variant.col_variant_code': 'Kode varian',
  'financeProduct.import_variant.col_row_number': 'Baris',
  'financeProduct.import_variant.total_combination': 'Total kombinasi',
  'financeProduct.import_variant.from_file': 'Dari berkas',
  'financeProduct.import_variant.auto': 'Otomatis',
  'financeProduct.import_variant.completed_by_system': 'Dilengkapi sistem',
  'financeProduct.import_variant.max_rows_hint': 'Maksimal 3000 baris dapat diimpor sekali proses.',
  'financeProduct.export_regular_product_2': 'Ekspor {title} Reguler',
  'financeProduct.export_package_product_2': 'Ekspor {title} Paket',
  'financeProduct.export_manufacturing_product_2': 'Ekspor {title} Manufaktur',
  'zap.canvassing_add_product_required': '{product} wajib diisi',
  'financeBanks.expense_withholding': 'Pemotongan Biaya',
  'financeBanks.expense_payment_withholding': 'Pemotongan Pembayaran Biaya',
  'financeBanks.receive_join_invoice_payment': 'Terima Pembayaran Tagihan Gabungan',
  'financeBanks.join_invoice_payment_withholding': 'Pemotongan Pembayaran Tagihan Gabungan ',
  'financeBanks.purchase_join_invoice_payment': ' Terima Pembayaran Tagihan Gabungan Pembelian',
  'financeBanks.purchase_join_invoice_payment_withholding':
    'Pemotongan Pembayaran Tagihan Gabungan Pembelian',
  'financeProduct.mass_edit': 'Ubah Massal',
  'financeProduct.save_mass_edit': 'Simpan Perubahan Massal',
  'financeProduct.can_be_updated': 'Bisa diubah',
  'financeProduct.cannot_be_updated': 'Tidak bisa diubah',
  'financeProduct.mass_patch_confirm': 'Apakah Anda yakin akan mengubah {count} {title}?',
  'financeProduct.mass_patch_marketplace_question':
    'Terdapat produk yang Anda ubah terhubung dengan marketplace berikut. Terapkan perubahan ini ke marketplace juga?',
  'financeProduct.mass_patch_progress_title': 'Perubahan Massal Produk Sedang Diproses',
  'financeProduct.mass_patch_progress_desc':
    'Perubahan produk sedang berjalan dibelakang layar. Anda dapat menutup jendela ini.',
  'financeProduct.mass_patch_complete_title': 'Horee perubahan massal produk berhasil!!',
  'financeProduct.mass_patch_complete_subtitle': 'Perubahan produk telah selesai.',
  'financeProduct.mass_roles_step_review': 'Periksa',
  'financeProduct.mass_roles_step_process': 'Proses',
  'financeProduct.mass_roles_step_done': 'Selesai',
  'financeProduct.mass_roles_intro': '{count} {title} dipilih. Siapa yang boleh mengakses?',
  'financeProduct.mass_roles_replace_warning': 'Hak akses lama akan diganti',
  'financeProduct.mass_roles_replace_warning_desc':
    'Peran yang Anda pilih menggantikan seluruh peran lama pada {title} terpilih, bukan menambahkannya.',
  'financeProduct.mass_roles_invalid_reason':
    '{title} induk varian tidak bisa diubah hak aksesnya. Atur hak akses pada tiap varian.',
  'financeProduct.mass_roles_public_warning': 'Semua pengguna akan bisa mengakses',
  'financeProduct.mass_roles_public_warning_desc':
    'Hak akses dikosongkan. Semua pengguna di perusahaan ini bisa melihat {title} terpilih.',
  'financeProduct.mass_roles_confirm': 'Ubah hak akses {count} {title} sekarang?',
  'financeProduct.mass_roles_no_valid': 'Tidak ada {title} terpilih yang bisa diubah hak aksesnya.',
  'financeProduct.mass_roles_progress_desc':
    'Proses berjalan di latar belakang. Jangan tutup jendela ini.',
  'financeProduct.mass_roles_progress_count': '{count} dari {total} {title} diperbarui',
  'financeProduct.mass_roles_complete_title': 'Hak akses berhasil diubah',
  'financeProduct.mass_roles_skipped': 'Dilewati',
  'financeProduct.mass_roles_chunk_failed': '{count} {title} gagal diproses: {message}',
  'financeProduct.mass_description': 'Ubah Deskripsi',
  'financeProduct.mass_description_intro':
    '{count} {title} dipilih. Deskripsi baru akan menggantikan deskripsi lama.',
  'financeProduct.mass_description_placeholder': 'Tulis deskripsi baru',
  'financeProduct.mass_description_variant_info':
    'Deskripsi {title} induk varian juga akan diterapkan ke semua variannya.',
  'financeProduct.mass_description_marketplace_question':
    'Beberapa {title} terpilih terhubung dengan toko marketplace berikut. Kirim deskripsi baru ke toko yang dicentang juga?',
  'financeProduct.mass_description_confirm': 'Ubah deskripsi {count} {title} sekarang?',
  'financeProduct.mass_description_no_valid':
    'Tidak ada {title} terpilih yang bisa diubah deskripsinya.',
  'financeProduct.mass_description_complete_title': 'Deskripsi berhasil diubah',
  'financeProduct.no_mp_count_warning':
    '{count} Produk belum terkoneksi dengan satu atau lebih marketplace.',
  'financeProduct.data_progress_updated': '{count} dari {total} produk berhasil disinkronkan',
  'financeProduct.data_has_been_updated': 'Total {count} data berhasil diubah',
  'financeProduct.cannot_mass_update': 'Tidak dapat mengubah massal',
  'financeProduct.mass_update_info': '**Beberapa produk mungkin tidak dapat diubah',
  'zap.canvas_warehouse': 'Gudang Kanvas',
  'financeInvoices.apply_tag_to_all_rows': 'Terapkan tag ke semua baris',
  'financeInvoices.max_tags': 'Maksimal {value} tag',
  'financeProduct.add_product_from_marketplace': 'Tambah Produk dari Marketplace',
  'financeProduct.connect_marketplace_modal_title': 'Sambungkan Marketplace-mu Dengan Kledo',
  'financeProduct.connect_marketplace_modal_line1':
    'Sambungkan marketplace-mu dengan Kledo untuk dapat otomatis sinkronisasi semua produk marketplace ke Kledo.',
  'financeProduct.connect_marketplace_modal_line2':
    'Stok produk juga akan ter-update otomatis lho!',
  'financeProduct.marketplace_label_shopee': 'Shopee',
  'financeProduct.marketplace_dropdown_button': 'Marketplace',
  'financeProduct.marketplace_add_to_marketplace': 'Tambah ke Marketplace',
  'financeProduct.marketplace_view_on_shopee': 'Lihat di {marketplace}',
  'financeProduct.marketplace_view_marketplace_product': 'Lihat Produk Marketplace',
  'financeProduct.marketplace_edit_price_shopee': 'Ubah Harga di {marketplace}',
  'financeProduct.marketplace_edit_stock_shopee': 'Ubah Stok di {marketplace}',
  'financeProduct.marketplace_edit_detail_shopee': 'Ubah Detail di {marketplace}',
  'financeProduct.marketplace_boost_shopee': 'Naikkan di Shopee',
  'financeProduct.marketplace_boost_shopee_success':
    'Permintaan naikkan produk telah dikirim ke Shopee.',
  'financeProduct.marketplace_boost_shopee_failed': 'Gagal menaikkan produk di Shopee.',
  'financeProduct.marketplace_delete_shopee': 'Hapus di {marketplace}',
  'financeProduct.marketplace_delete_listing_success': 'Listing berhasil dihapus dari Shopee.',
  'financeProduct.marketplace_delete_listing_failed': 'Gagal menghapus listing dari Shopee.',
  'financeProduct.marketplace_delete_choice_title': 'Hapus Produk Marketplace',
  'financeProduct.marketplace_delete_choice_description':
    'Pilih cara menghapus. "Hapus di Kledo saja" hanya menghapus data di Kledo (menu produk marketplace). "Hapus juga di marketplace" akan menghapus listing di marketplace juga.',
  'financeProduct.marketplace_delete_kledo_only': 'Hapus di Kledo saja',
  'financeProduct.marketplace_delete_with_marketplace': 'Hapus juga di marketplace',
  'financeProduct.marketplace_delete_kledo_only_success': 'Produk berhasil dihapus dari Kledo.',
  'financeProduct.marketplace_delete_kledo_only_failed': 'Gagal menghapus produk dari Kledo.',
  'financeProduct.marketplace_archive_shopee': 'Arsipkan',
  'financeProduct.marketplace_archive_listing_success': 'Produk berhasil diarsipkan di Shopee.',
  'financeProduct.marketplace_archive_listing_failed': 'Gagal mengarsipkan produk di Shopee.',
  'financeProduct.marketplace_unarchive_shopee': 'Batalkan Arsip',
  'financeProduct.marketplace_unarchive_listing_success':
    'Arsip produk berhasil dibatalkan di Shopee.',
  'financeProduct.marketplace_unarchive_listing_failed':
    'Gagal membatalkan arsip produk di Shopee.',
  'financeProduct.marketplace_push_to_marketplace': 'Dorong ke Marketplace',
  'financeProduct.marketplace_pull_from_marketplace': 'Tarik dari Marketplace',
  'financeProduct.marketplace_pull_confirm_description':
    'Data yang ada di Kledo disamakan dengan data yang ada di Marketplace.',
  'financeProduct.marketplace_pull_confirm_which': 'Mau tarik dari marketplace mana?',
  'financeProduct.marketplace_pull_confirm_action': 'Tarik Sekarang',
  'financeProduct.marketplace_pull_only': 'Tarik saja',
  'financeProduct.marketplace_pull_apply_to_master': 'Tarik & perbarui produk master',
  'financeProduct.marketplace_pull_failed': 'Gagal menarik detail produk dari marketplace.',
  'financeProduct.marketplace_pull_no_connection':
    'Tidak ada koneksi marketplace untuk produk ini.',
  'financeProduct.marketplace_push_confirm_description':
    'Data yang ada di marketplace disamakan dengan data yang ada di Kledo. Meliputi: Gambar, Berat, Ukuran, Deskripsi, dan Harga.',
  'financeProduct.marketplace_push_confirm_action': 'Dorong Sekarang',
  'financeProduct.marketplace_push_failed': 'Gagal memulai sinkronisasi ke marketplace.',
  'financeProduct.marketplace_push_no_connection':
    'Tidak ada koneksi marketplace untuk produk ini.',
  'financeProduct.marketplace_label_tiktok_shop': 'TikTok Shop',
  'financeProduct.marketplace_coming_soon': 'Segera hadir',
  'financeProduct.connect_marketplace_success_title': 'Horee Berhasil Tersambung!',
  'financeProduct.connect_marketplace_success_desc':
    'Marketplace mu telah berhasil tersambung dengan Kledo.',
  'financeProduct.connect_marketplace_start_sync': 'Mulai Sinkronisasi Produk',
  'financeProduct.connect_marketplace_start_add_product_to_marketplace':
    'Mulai Tambahkan Produk ke Marketplace',
  'financeProduct.add_product_to_marketplace_title': 'Tambahkan Produk ke Marketplace',
  'financeProduct.add_product_to_marketplace_cancel': 'Batal',
  'financeProduct.add_product_to_marketplace_save_draft': 'Simpan Draft',
  'financeProduct.add_product_to_marketplace_submit': 'Tambahkan ke Marketplace',
  'financeProduct.save_and_upload_to_marketplace': 'Simpan dan Upload ke Marketplace',
  'financeProduct.add_product_to_marketplace_stores': 'Toko terhubung',
  'financeProduct.add_product_to_marketplace_store_hint':
    'Centang toko untuk mengisi formulir. Toko yang sudah punya listing di marketplace dinonaktifkan.',
  'financeProduct.add_product_to_marketplace_select_store':
    'Centang minimal satu toko di kiri untuk menampilkan formulir.',
  'financeProduct.add_product_to_marketplace_already_listed': 'Sudah terdaftar',
  'financeProduct.add_product_to_marketplace_form_coming':
    'Kategori, deskripsi, pengiriman, dan field lain menyusul.',
  'financeProduct.add_product_to_marketplace_brand': 'Merek',
  'financeProduct.add_product_to_marketplace_no_brand': 'Tidak ada merek',
  'financeProduct.add_product_to_marketplace_size_chart': 'Panduan Ukuran',
  'financeProduct.add_product_to_marketplace_size_chart_required': 'Panduan ukuran wajib diisi',
  'financeProduct.add_product_to_marketplace_size_chart_template': 'Pilih panduan terdaftar',
  'financeProduct.add_product_to_marketplace_size_chart_image': 'Unggah gambar',
  'financeProduct.add_product_to_marketplace_size_chart_choose_template':
    'Pilih panduan ukuran terdaftar',
  'financeProduct.add_product_to_marketplace_size_chart_fallback': 'Panduan ukuran',
  'financeProduct.add_product_to_marketplace_size_chart_unsupported':
    'Kategori ini tidak mendukung panduan ukuran',
  'financeProduct.add_product_to_marketplace_size_chart_hint':
    'Pilih salah satu: panduan ukuran terdaftar atau unggah gambar.',
  'financeProduct.add_product_to_marketplace_material': 'Bahan',
  'financeProduct.add_product_to_marketplace_choose_brand': 'Pilih merek',
  'financeProduct.add_product_to_marketplace_choose_material': 'Pilih bahan',
  'financeProduct.add_product_to_marketplace_product_weight': 'Berat Produk',
  'financeProduct.add_product_to_marketplace_product_weight_required': 'Berat produk wajib diisi',
  'financeProduct.add_product_to_marketplace_images': 'Gambar produk (Shopee)',
  'financeProduct.add_product_to_marketplace_images_required': 'Gambar produk wajib diisi',
  'financeProduct.add_product_to_marketplace_select_store_to_upload':
    'Pilih setidaknya satu toko di sebelah kiri sebelum mengunggah gambar.',
  'financeProduct.add_product_to_marketplace_shipping': 'Pengiriman',
  'financeProduct.add_product_to_marketplace_shipping_pick_logistics':
    'Pilih setidaknya satu logistik',
  'financeProduct.add_product_to_marketplace_shipping_instant': 'Instant',
  'financeProduct.add_product_to_marketplace_shipping_instant_priority': 'Instant Prioritas',
  'financeProduct.add_product_to_marketplace_shipping_hemat_kargo': 'Hemat Kargo',
  'financeProduct.add_product_to_marketplace_shipping_reguler': 'Reguler (Cashless)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_grab':
    'GrabExpress Instant ( max 20000g)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_gosend':
    'Gosend Instant ( max 20000g)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_spx':
    'SPX Instant (min 1g max 20000g)',
  'financeProduct.add_product_to_marketplace_preorder': 'Pre order',
  'financeProduct.add_product_to_marketplace_preorder_no': 'Tidak',
  'financeProduct.add_product_to_marketplace_preorder_yes': 'Ya',
  'financeProduct.add_product_to_marketplace_condition': 'Kondisi',
  'financeProduct.add_product_to_marketplace_choose_condition': 'Pilih kondisi',
  'financeProduct.add_product_to_marketplace_condition_new': 'Baru',
  'financeProduct.add_product_to_marketplace_condition_used': 'Bekas',
  'financeProduct.add_product_to_marketplace_days_to_ship': 'Hari pengiriman pre-order',
  'financeProduct.add_product_to_marketplace_days_to_ship_required': 'Hari pengiriman wajib diisi',
  'financeProduct.add_product_to_marketplace_parcel_size': 'Ukuran paket',
  'financeProduct.add_product_to_marketplace_package_length': 'Panjang',
  'financeProduct.add_product_to_marketplace_package_width': 'Lebar',
  'financeProduct.add_product_to_marketplace_package_height': 'Tinggi',
  'financeProduct.add_product_to_marketplace_package_length_required': 'Panjang wajib diisi',
  'financeProduct.add_product_to_marketplace_package_width_required': 'Lebar wajib diisi',
  'financeProduct.add_product_to_marketplace_package_height_required': 'Tinggi wajib diisi',
  'financeProduct.add_product_to_marketplace_courier_over_axis':
    'Ukuran paket melebihi batas maks kurir ini ({length}×{width}×{height} {unit})',
  'financeProduct.add_product_to_marketplace_courier_over_sum':
    'Total dimensi paket (P+L+T) melebihi {sum} {unit} maks kurir ini',
  'financeProduct.add_product_to_marketplace_price': 'Harga',
  'financeProduct.add_product_to_marketplace_price_required': 'Harga wajib diisi',
  'financeProduct.add_product_to_marketplace_price_min': 'Harga harus lebih dari 0',
  'financeProduct.add_product_to_marketplace_days': 'hari',
  'financeProduct.add_product_to_marketplace_dangerous_product': 'Produk Berbahaya',
  'financeProduct.add_product_to_marketplace_dangerous_no': 'Tidak',
  'financeProduct.add_product_to_marketplace_dangerous_yes':
    'Mengandung baterai/ magnet/ cairan/ bahan mudah terbakar',
  'financeProduct.add_product_to_marketplace_no_couriers': 'Tidak ada kurir tersedia',
  'financeProduct.add_product_to_marketplace_no_delivery_options':
    'Tidak ada opsi pengiriman tersedia',
  'financeProduct.add_product_to_marketplace_priced_manually_label': 'Harga manual',
  'financeProduct.add_product_to_marketplace_priced_manually_help':
    'Aktifkan untuk mengatur harga marketplace terlepas dari harga produk Kledo. Jika dinonaktifkan, harga akan mengikuti harga produk di Kledo.',
  'financeProduct.add_product_to_marketplace_minimum_order_quantity': 'Kuantitas pesanan minimum',
  'financeProduct.add_product_to_marketplace_minimum_order_quantity_min': 'Minimum {value}',
  'financeProduct.add_product_to_marketplace_cod_allowed': 'COD diizinkan',
  'financeProduct.add_product_to_marketplace_pre_owned': 'Produk bekas',
  'financeProduct.add_product_to_marketplace_unit_placeholder': 'Satuan',
  'financeProduct.add_product_to_marketplace_attribute_placeholder': 'Masukkan atribut',
  'financeProduct.add_product_to_marketplace_attribute_required': '{attr} wajib diisi',
  'financeProduct.add_product_to_marketplace_loading': 'Memuat...',
  'financeProduct.add_product_to_marketplace_submit_success':
    'Produk berhasil diterbitkan ke marketplace',
  'financeProduct.add_product_to_marketplace_submit_error':
    'Gagal menerbitkan produk ke marketplace',
  'financeProduct.add_product_to_marketplace_review_modal':
    'Produkmu akan di review oleh marketplace terlebih dahulu sebelum tampil. Kamu juga dapat melihat produknya dari daftar produk di seller center, kemudian pilih tab "Sedang Ditinjau".',
  'financeProduct.add_product_to_marketplace_review_modal_back_to_product': 'Kembali ke Produk',
  'financeProduct.connect_sync_title': 'Tarik Produk Marketplace dengan Kledo',
  'financeProduct.connect_sync_desc_1':
    'Produk marketplace yang tidak memiliki produk master akan dibuatkan produk master sesuai dengan detail dari produk marketplace.',
  'financeProduct.connect_sync_desc_2':
    'Apabila produk master dan produk marketplace memiliki nama dan/atau SKU yang sama, maka produk marketplace akan otomatis dikoneksikan tanpa mengubah data produk master.',
  'financeProduct.connect_sync_marketplace_selected_label': 'Marketplace yang disinkronkan',
  'financeProduct.connect_sync_tiktok_active_notice':
    'Karena cara kerja sistem TikTok, produk yang berstatus nonaktif di marketplace akan otomatis menjadi aktif saat sinkronisasi dijalankan.',
  'financeProduct.connect_sync_demo_store': 'Toko Baru Biru',
  'financeProduct.connect_sync_product_filter':
    'Apakah semua produk di download atau hanya yang aktif?',
  'financeProduct.connect_sync_filter_all': 'Semua',
  'financeProduct.connect_sync_filter_active': 'Hanya yang Aktif',
  'financeProduct.connect_sync_filter_help':
    'Jika semua produk, maka termasuk produk yang di arsip juga akan di download.',
  'financeProduct.connect_sync_stock_title': 'Bagaimana stok produk disinkronkan?',
  'financeProduct.connect_sync_stock_marketplace_source':
    'Stok produk di kledo disamakan dengan yang ada di marketplace',
  'financeProduct.connect_sync_stock_kledo_source':
    'Stok produk di marketplace disamakan dengan yang ada di kledo',
  'financeProduct.connect_sync_stock_kledo_source_help':
    'Jika Anda mengubah stok di kledo, perubahan stok di marketplace akan tersinkron dalam waktu sekitar 10 menit.',
  'financeProduct.connect_sync_stock_as_is': 'Biarkan stok apa adanya',
  'financeProduct.connect_sync_stock_as_is_help':
    'Produk marketplace akan dibuatkan produk master tanpa pencatatan stok.',
  'financeProduct.connect_sync_add_products': 'Tambahkan Produk',
  'financeProduct.connect_sync_progress_title': 'Sinkronisasi Sedang Diproses',
  'financeProduct.connect_sync_progress_desc':
    'Sinkronisasi produk sedang berjalan dibelakang layar. Anda dapat menutup jendela ini.',
  'financeProduct.connect_sync_progress_status':
    '{synced} dari {total} produk berhasil disinkronkan',
  'financeProduct.connect_sync_complete_title': 'Horee sinkronisasi produk berhasil!!',
  'financeProduct.connect_sync_complete_subtitle': 'Sinkronisasi produk telah selesai.',
  'financeProduct.connect_sync_complete_row_success': 'Berhasil',
  'financeProduct.connect_sync_complete_row_failed': 'Gagal',
  'financeProduct.connect_sync_go_to_products': 'Ke Halaman Produk',
  'financeProduct.description_required': 'Deskripsi wajib diisi',
  'financeProduct.add_product_to_marketplace_brand_required': 'Brand wajib dipilih',
  'marketplace.overview_page_title': 'Overview Marketplace',
  'marketplace.landing_page_title': 'Marketplace',
  'marketplace.landing_eyebrow': '#JadiLebihBaik kelola bisnis omnichannel-mu',
  'marketplace.landing_hero_title_1': 'Kelola Pesanan Di Banyak Channel',
  'marketplace.landing_hero_title_highlight': 'Lebih Mudah',
  'marketplace.landing_hero_title_2': 'dengan Rig.id',
  'marketplace.landing_hero_sub':
    'Solusi terbaik untuk order manajemen pesanan terpusat dari berbagai marketplace, sinkronisasi stok real-time, hingga menganalisis performa penjualan dalam satu platform terintegrasi.',
  'marketplace.landing_cta_primary': 'Hubungkan Marketplace',
  'marketplace.landing_meta_1': 'Sinkronisasi stok real-time',
  'marketplace.landing_meta_2': 'Tanpa berpindah aplikasi',
  'marketplace.landing_meta_3': 'Terhubung akuntansi Kledo',
  'marketplace.landing_mock_sales_title': 'Penjualan per-marketplace',
  'marketplace.landing_mock_shops_title': 'Marketplace-ku',
  'marketplace.landing_mock_shops_synced': 'Tersinkron',
  'marketplace.landing_mock_linked_title': 'Produk terhubung per-marketplace',
  'marketplace.landing_mock_products_title': 'Produk Marketplace',
  'marketplace.landing_mock_add_marketplace': 'Tambah Marketplace',
  'marketplace.landing_mock_view_products': 'Lihat Produk',
  'marketplace.landing_mock_unconnected_notice': '{count} produk belum terkoneksi ke marketplace',
  'marketplace.landing_mock_channels_connected': 'Channel Terhubung',
  'marketplace.landing_mock_channel_unit': 'Channel',
  'marketplace.landing_mock_manage': 'Kelola',
  'marketplace.landing_mock_connected': 'Terhubung',
  'marketplace.landing_mock_stock_sync_title': 'Sinkronisasi Stok',
  'marketplace.landing_mock_configure': 'Atur',
  'marketplace.landing_mock_sales_per_channel': 'Penjualan per Channel',
  'marketplace.landing_mock_period_7days': '7 hari',
  'marketplace.landing_mock_finance_title': 'Ringkasan Keuangan',
  'marketplace.landing_mock_period_month': 'Bulan ini',
  'marketplace.landing_mock_fin_col_post': 'Pos Keuangan',
  'marketplace.landing_mock_fin_col_value': 'Nilai',
  'marketplace.landing_mock_fin_gross_sales': 'Penjualan kotor seluruh channel',
  'marketplace.landing_mock_fin_channel_cost': 'Biaya channel & ongkos kirim',
  'marketplace.landing_mock_fin_gross_profit': 'Laba kotor tercatat otomatis',
  'marketplace.landing_mock_fin_journal': 'Jurnal terkirim ke Kledo',
  'marketplace.landing_mock_synced_auto': 'Sinkron otomatis',
  'marketplace.landing_logos_label': 'Terhubung dengan channel penjualan yang Anda pakai.',
  'marketplace.landing_channel_online_store': 'Toko Online',
  'marketplace.landing_features_title_1': 'Satu Aplikasi Untuk Semua',
  'marketplace.landing_features_title_2': 'Channel Penjualan',
  'marketplace.landing_features_sub':
    'Dari pesanan masuk, stok gudang, sampai pencatatan keuangan — semuanya terhubung dalam satu alur kerja.',
  'marketplace.landing_feature_1_title': 'Integrasi ke berbagai marketplace',
  'marketplace.landing_feature_1_desc':
    'Hubungkan data produk dari berbagai marketplace seperti TikTok Shop, Shopee, Tokopedia sampai toko online milik Anda dalam satu platform. Anda dapat mengubah data produk, analisis pesanan dan stok dari berbagai channel tanpa perlu berpindah aplikasi.',
  'marketplace.landing_feature_2_title': 'Manajemen stok terintegrasi',
  'marketplace.landing_feature_2_desc':
    'Dari data di gudang hingga produk sampai ke tangan pelanggan, sinkronkan data stok secara real-time di seluruh channel penjualan dan cabang. Kurangi risiko overselling maupun underselling dengan data inventaris yang selalu akurat.',
  'marketplace.landing_feature_3_title': 'Analisis data penjualan lebih baik',
  'marketplace.landing_feature_3_desc':
    'Data yang tidak sinkron membuat keputusan bisnis menjadi kurang akurat. Dengan Rig.id Anda bisa mendapatkan laporan penjualan yang lengkap dari seluruh channel dalam satu dashboard. Analisis performa bisnis lebih cepat untuk membantu mengambil keputusan yang lebih tepat.',
  'marketplace.landing_feature_4_title': 'Terintegrasi sistem akuntansi otomatis',
  'marketplace.landing_feature_4_desc':
    'Sulit mengetahui keuntungan dari semua channel penjualan? Kini seluruh transaksi penjualan dapat langsung terhubung dengan sistem akuntansi Kledo sehingga pencatatan keuangan menjadi lebih cepat, akurat, dan minim pekerjaan manual.',
  'marketplace.landing_banner_title': 'Jual di Banyak Channel, Pantau di Satu Aplikasi.',
  'marketplace.landing_banner_sub': 'Pengelolaan Omnichannel Lebih Mudah dengan Rig.id',
  'marketplace.landing_banner_card_stock_title': 'Stok',
  'marketplace.landing_banner_card_stock_desc': 'Stok tersinkron otomatis ke seluruh channel.',
  'marketplace.landing_banner_card_stock_pill': 'Akurat',
  'marketplace.landing_banner_card_order_title': 'Pesanan',
  'marketplace.landing_banner_card_order_desc': 'Pesanan dari semua channel dalam satu papan.',
  'marketplace.landing_banner_card_order_pill': 'Terpantau',
  'marketplace.landing_banner_card_sales_title': 'Penjualan',
  'marketplace.landing_banner_card_sales_desc': 'Laporan seluruh channel dalam satu dashboard.',
  'marketplace.landing_banner_card_sales_pill': 'Real-time',
  'marketplace.landing_closing_text':
    'Mudahkan memantau semua pesanan, stok, dan data penjualan dalam satu dashboard terintegrasi. Coba sekarang juga.',
  'marketplace.marketplace_products_title': 'Produk Marketplace',
  'marketplace.shopee_category': 'Kategori Shopee',
  'marketplace.tiktok_category': 'Kategori TikTok',
  'marketplace.manage_price_title': 'Kelola Harga',
  'marketplace.kledo_price': 'Harga di Kledo',
  'marketplace.marketplace_price': 'Harga Marketplace',
  'marketplace.sync_stock': 'Samakan Stok',
  'marketplace.price_linked': 'Harga mengikuti harga di Kledo',
  'marketplace.price_unlinked': 'Harga diatur manual',
  'marketplace.sync_stock_updated': 'Pengaturan samakan stok diperbarui',
  'marketplace.price_updated': 'Harga berhasil diperbarui',
  'marketplace.relink_price_confirm': 'Samakan harga marketplace dengan harga di Kledo?',
  'marketplace.boost_settings_title': 'Pengaturan Naikkan Produk',
  'marketplace.boost_select_store': 'Pilih toko Shopee untuk mengatur produk yang dinaikkan',
  'marketplace.boost_no_shopee_store': 'Belum ada toko Shopee yang terhubung',
  'marketplace.boost_store': 'Toko',
  'marketplace.boost_manage': 'Atur',
  'marketplace.boost_time': 'Waktu',
  'marketplace.boost_current_time': 'Waktu naikkan produk saat ini',
  'marketplace.boost_next_time': 'Waktu naikkan produk selanjutnya',
  'marketplace.boost_boosted_at': 'Waktu Dinaikkan',
  'marketplace.boost_pinned': 'Disematkan',
  'marketplace.boost_pin': 'Sematkan',
  'marketplace.boost_pin_limit': 'Maksimal {limit} produk yang dapat disematkan',
  'marketplace.boost_pin_success': 'Sematan produk diperbarui',
  'marketplace.boost_reorder_success': 'Urutan produk berhasil diperbarui',
  'marketplace.boost_delete_success': 'Produk berhasil dihapus dari daftar',
  'marketplace.boost_save_failed': 'Gagal menyimpan perubahan',
  'marketplace.boost_info_max_products':
    'Setiap toko dapat menaikkan hingga 5 produk dalam satu waktu',
  'marketplace.boost_info_duration': 'Produk yang dinaikkan akan aktif selama 4 jam',
  'marketplace.boost_info_max_pin': 'Maksimal 5 produk yang dapat disematkan',
  'marketplace.boost_info_drag': 'Atur urutan produk dengan menyeret dan melepasnya',
  'marketplace.boost_add_product': 'Tambah Produk',
  'marketplace.boost_max_products_info': 'Maksimal {max} produk yang dapat dinaikkan',
  'marketplace.boost_search_placeholder': 'Cari produk',
  'marketplace.boost_already_added': 'Sudah ditambahkan',
  'marketplace.boost_add_success': 'Produk berhasil ditambahkan',
  'marketplace.boost_add_failed': 'Gagal menambahkan produk',
  'marketplace.boosted_view_button': 'Produk yang Dinaikkan',
  'marketplace.boosted_modal_title': 'Produk yang Sedang Dinaikkan',
  'marketplace.boosted_empty': 'Belum ada produk yang sedang dinaikkan',
  'marketplace.boosted_cooldown': 'Jeda {value}',
  'marketplace.action_boost_product': 'Naikkan Produk',
  'marketplace.action_pull_from_marketplace': 'Tarik dari Marketplace',
  'marketplace.action_view_master_product': 'Lihat Produk Master',
  'marketplace.action_link_product': 'Tautkan ke Produk Kledo',
  'marketplace.action_change_link_product': 'Ubah Tautan Produk',
  'marketplace.action_unlink_product': 'Lepas Tautan Produk',
  'marketplace.action_generate_product': 'Buat Produk Kledo',
  'marketplace.manual_link_badge': 'Manual',
  'marketplace.manual_link_title': 'Ditautkan Manual',
  'marketplace.manual_link_marker_tooltip':
    'Ditautkan manual. Sinkronisasi otomatis tidak akan mengubah tautan ini.',
  'marketplace.link_product_title': 'Tautkan ke Produk Kledo',
  'marketplace.change_link_product_title': 'Ubah Tautan Produk Kledo',
  'marketplace.link_product_for_mp_item': 'Produk marketplace: {name}',
  'marketplace.link_product_pick_label': 'Produk Kledo',
  'marketplace.link_product_pick_required': 'Silakan pilih produk Kledo',
  'marketplace.link_product_success': 'Produk berhasil ditautkan.',
  'marketplace.link_product_failed': 'Gagal menautkan produk.',
  'marketplace.unlink_product_success': 'Tautan produk berhasil dilepas.',
  'marketplace.unlink_product_failed': 'Gagal melepas tautan produk.',
  'marketplace.unlink_product_confirm_title': 'Lepas tautan produk?',
  'marketplace.unlink_product_confirm_message':
    'Tautan akan dilepas. Sinkronisasi berikutnya dapat menautkan kembali produk ini secara otomatis.',
  'marketplace.generate_product_success': 'Produk Kledo berhasil dibuat.',
  'marketplace.generate_product_failed': 'Gagal membuat produk Kledo.',
  'marketplace.generate_product_confirm_title': 'Buat produk Kledo?',
  'marketplace.generate_product_confirm_message_flat':
    'Produk Kledo akan dibuat dari produk marketplace ini dan ditautkan secara manual. Lanjutkan?',
  'marketplace.generate_product_confirm_message_parent':
    'Produk Kledo akan dibuat untuk semua varian pada produk marketplace ini dan ditautkan secara manual. Lanjutkan?',
  'marketplace.bulk_generate_confirm_title': 'Buat produk Kledo secara massal?',
  'marketplace.bulk_generate_confirm_message':
    'Produk Kledo akan dibuat untuk {count} produk marketplace terpilih dan ditautkan secara manual. Proses berjalan di latar belakang. Lanjutkan?',
  'marketplace.bulk_generate_scheduled':
    'Proses pembuatan produk telah dijadwalkan. Refresh daftar beberapa saat lagi untuk melihat tautan baru.',
  'marketplace.bulk_generate_failed': 'Gagal menjadwalkan pembuatan produk Kledo.',
  'marketplace.linking_strategy_override_label': 'Strategi Penautan Produk',
  'marketplace.linking_strategy_override_use_connection': 'Pakai setting koneksi',
  'marketplace.linking_strategy_override_helper':
    'Kosongkan untuk mengikuti pengaturan Strategi Penautan Produk di halaman Pengaturan Koneksi Marketplace.',
  'marketplace.status_available': 'Tersedia',
  'marketplace.status_out_of_stock': 'Habis',
  'marketplace.status_archive': 'Arsip',
  'marketplace.status_draft': 'Draft',
  'marketplace.status_pending': 'Pending',
  'marketplace.status_failed': 'Gagal',
  'marketplace.active': 'Aktif',
  'marketplace.item_status_normal': 'Aktif',
  'marketplace.item_status_banned': 'Diblokir',
  'marketplace.item_status_unlist': 'Diarsipkan',
  'marketplace.item_status_seller_delete': 'Dihapus penjual',
  'marketplace.item_status_inactive': 'Nonaktif',
  'marketplace.item_status_shopee_delete': 'Dihapus Shopee',
  'marketplace.item_status_tiktok_delete': 'Dihapus Tiktok',
  'marketplace.item_status_marketplace_delete': 'Dihapus Marketplace',
  'marketplace.item_status_reviewing': 'Dalam peninjauan',
  'marketplace.stock_available_yes': 'Tersedia',
  'marketplace.stock_available_no': 'Habis',
  'marketplace.my_marketplace_title': 'Marketplace-ku',
  'marketplace.add_marketplace': 'Tambah Marketplace',
  'marketplace.connected_stores': 'Toko Terhubung',
  'marketplace.store_error': 'Koneksi marketplace terputus',
  'marketplace.store_synced': 'Marketplace tersinkronisasi',
  'marketplace.store_setting_title': 'Pengaturan {name}',
  'marketplace.setting_saved': 'Pengaturan disimpan',
  'marketplace.setting_section_product_sync': 'Sinkronisasi Produk',
  'marketplace.setting_sync_stock_question':
    'Apakah stok produk di marketplace otomatis disamakan dengan stok di kledo?',
  'marketplace.setting_section_transaction_sync': 'Sinkronisasi Transaksi',
  'marketplace.setting_warehouse_label': 'Stok dicatatkan di gudang apa?',
  'marketplace.setting_tag_label': 'Tempelkan tag apa saja pada setiap transaksi?',
  'marketplace.setting_tag_tooltip':
    'Digunakan untuk membuat kategori transaksi. Anda juga bisa membuat laporan berdasarkan Tag ini.',
  'marketplace.setting_record_transaction_label':
    'Transaksi dicatatkan di kledo saat status di marketplace bagaimana?',
  'marketplace.setting_record_transaction_tooltip':
    'Jika dicatat saat barang dikirim, maka saat barang status sedang kirim di kledo akan dicatatkan transaksi pemesanan dan pengirimannya. Dan saat transaksi selesai, akan dibuatkan transaksi tagihan penjualan dan pembayarannya. Jika dicatat saat transaksi selesai, maka transaksi dimasukkan ke kledo hanya saat status transaksi di marketplace selesai.',
  'marketplace.setting_return_sync_label': 'Buat retur otomatis dari marketplace',
  'marketplace.setting_return_sync_helper':
    'Jika dimatikan, retur/refund yang selesai di marketplace tidak akan otomatis membentuk Retur Penjualan di Kledo.',
  'marketplace.setting_connected_since': 'Mulai tersambung pada {date}',
  'marketplace.setting_show_advanced': 'Tampilkan pengaturan lanjut',
  'marketplace.setting_hide_advanced': 'Sembunyikan pengaturan lanjut',
  'marketplace.setting_payment_bank_label':
    'Pembayaran transaksi akan dimasukkan ke dalam akun bank apa?',
  'marketplace.setting_admin_cost_label':
    'Biaya admin marketplace akan dicatatkan pada akun COA apa?',
  'marketplace.setting_admin_cost_tooltip':
    'Setiap transaksi yang dipotong biaya admin oleh marketplace, akan dibuatkan transaksi biaya secara otomatis.',
  'marketplace.setting_pph22_label':
    'Potongan PPh 22 (0,5%) dari marketplace akan dicatatkan pada akun COA apa?',
  'marketplace.setting_pph22_tooltip':
    'Akun untuk menampung potongan PPh 22 yang dipungut marketplace dari omzet penjualan. Kosongkan untuk memakai akun default.',
  'marketplace.setting_record_shipping_label': 'Apakah biaya pengiriman akan dicatatkan ke Kledo?',
  'marketplace.setting_shipping_cost_label':
    'Biaya pengiriman marketplace akan dicatatkan pada akun COA apa?',
  'marketplace.setting_shipping_cost_tooltip':
    'Setiap transaksi yang biaya pengirimannya dibayarkan pelanggan ke marketplace, akan dibuatkan transaksi biaya secara otomatis.',
  'marketplace.reconnect_modal_title': 'Koneksi marketplace terputus',
  'marketplace.reconnect_modal_desc':
    'Koneksi ke {shopName} telah terputus. Silakan sambungkan ulang untuk melanjutkan sinkronisasi data.',
  'marketplace.reconnect_btn': 'Sambungkan Ulang',
  'marketplace.sync_products': 'Sinkronisasi Produk',
  'marketplace.sync_transactions': 'Sinkronisasi Transaksi',
  'marketplace.sync_log': 'Log Sinkronisasi',
  'marketplace.sync_history_status_processed': 'Berhasil',
  'marketplace.sync_history_status_processing': 'Diproses',
  'marketplace.sync_history_status_pending': 'Menunggu',
  'marketplace.sync_history_status_failed': 'Gagal',
  'marketplace.sync_history_products_count': '{processed} / {total} produk diproses',
  'marketplace.failed_sync_log': 'Log Sinkronisasi Gagal',
  'marketplace.failed_sync_action_label': 'Aksi',
  'marketplace.failed_sync_item_id_label': 'ID Item',
  'marketplace.failed_sync_action_push': 'Dorong produk',
  'marketplace.failed_sync_action_push_stock': 'Update stok',
  'marketplace.failed_sync_action_push_price': 'Update harga',
  'marketplace.failed_sync_action_push_boost': 'Naikkan produk',
  'marketplace.failed_sync_action_pull': 'Tarik produk',
  'marketplace.failed_sync_action_pull_model': 'Tarik produk varian',
  'marketplace.failed_sync_action_apply_stock_to_kledo': 'Terapkan stok ke Kledo',
  'marketplace.apply_stock_apply_to_marketplace': 'Terapkan stok ke marketplace',
  'marketplace.apply_stock_apply_to_kledo': 'Terapkan stok ke Kledo',
  'marketplace.menu_setting': 'Pengaturan',
  'marketplace.menu_view_products': 'Lihat Produk',
  'marketplace.menu_visit_marketplace': 'Kunjungi Marketplace',
  'marketplace.menu_sync_log': 'Log Sinkronisasi',
  'marketplace.menu_delete': 'Hapus',
  'marketplace.sales_per_marketplace': 'Penjualan per-Marketplace',
  'marketplace.linked_pos_product_per_marketplace': 'Produk terhubung per-Marketplace',
  'marketplace.linked_pos_product': 'Produk terhubung',
  'marketplace.edit_product': 'Ubah Produk Marketplace',
  'marketplace.edit_review_modal':
    'Perubahan produk sedang diproses oleh marketplace dan mungkin perlu beberapa saat untuk muncul.',
  'marketplace.product_detail_title': 'Detail Produk Marketplace',
  'marketplace.detail_images': 'Gambar Produk',
  'marketplace.detail_basic_info': 'Informasi Dasar',
  'marketplace.detail_shop': 'Toko',
  'marketplace.detail_current_price': 'Harga Saat Ini',
  'marketplace.detail_logistics': 'Logistik',
  'marketplace.detail_attributes': 'Atribut',
  'marketplace.detail_delivery_options': 'Opsi Pengiriman',
  'marketplace.detail_yes': 'Ya',
  'marketplace.detail_no': 'Tidak',
  'marketplace.detail_variants': 'Varian',
  'marketplace.detail_variant': 'Varian',
  'marketplace.variant_section_title': 'Varian',
  'marketplace.variant_name': 'Variasi',
  'marketplace.variant_name_placeholder': 'mis. Warna, Ukuran',
  'marketplace.variant_option_placeholder': 'Nama opsi',
  'marketplace.variant_add_variation': 'Tambah Variasi',
  'marketplace.variant_add_option': 'Tambah Opsi',
  'marketplace.variant_required': 'Lengkapi minimal satu variasi beserta opsinya',
  'message.edit_product_save_success': 'Produk marketplace berhasil diubah',
  'report.cogs_percentage': 'Persentase HPP',
  'report.material_no_project': 'Tanpa Tag',
  'report.material_no_project_only': 'Tanpa Tag saja',
  'report.material_deleted_tag': 'Tag #{id} (terhapus)',
  'report.material_value_pending': 'Menunggu perhitungan',
  'report.material_adhoc_no_request': 'Ad-hoc (tanpa MR)',
  'report.material_request_status_draft': 'Draft',
  'report.material_request_status_submitted': 'Diajukan',
  'report.material_request_status_processing': 'Diproses',
  'report.material_request_status_partial_fulfilled': 'Terpenuhi sebagian',
  'report.material_request_status_fully_fulfilled': 'Terpenuhi penuh',
  'report.material_request_status_rejected': 'Ditolak',
  'report.material_request_status_cancelled': 'Dibatalkan',
  'report.material_status': 'Status',
  'report.material_status_all_active': 'Semua aktif',
  'report.material_warehouse': 'Gudang',
  'report.material_project': 'Tag',
  'report.material_subtotal_tag': 'Subtotal Tag',
  'report.material_only_outstanding': 'Hanya sisa belum dipenuhi',
  'report.material_request_filter': 'Permintaan material',
  'report.material_date': 'Tanggal',
  'report.material_requested_qty': 'Diminta',
  'report.material_issued_qty': 'Dikeluarkan',
  'report.material_outstanding_qty': 'Sisa',
  'report.material_issue_number': 'Nomor Pengeluaran',
  'report.material_source_request_number': 'Nomor Permintaan',
  'report.material_qty': 'Qty',
  'report.material_value_cogs': 'Nilai (HPP)',
  'report.material_quantity': 'Kuantitas',
  'report.material_value': 'Nilai',
  'report.material_search_request_placeholder': 'Cari no. permintaan atau {product}',
  'report.material_search_usage_placeholder': 'Cari no. pengeluaran atau {product}',
  'materialRequest.title': 'Permintaan Barang',
  'materialRequest.add': 'Tambah Permintaan Barang',
  'materialRequest.edit': 'Ubah Permintaan Barang',
  'materialRequest.duplicate': 'Duplikat Permintaan Barang',
  'materialRequest.detail': 'Detail Permintaan Barang',
  'materialRequest.ref_number': 'Nomor Permintaan',
  'materialRequest.number': 'Nomor',
  'materialRequest.trans_date': 'Tgl. Permintaan',
  'materialRequest.location': 'Lokasi',
  'materialRequest.location_placeholder': 'Contoh: Menara A',
  'materialRequest.warehouse': 'Gudang',
  'materialRequest.contact': 'Pemohon / PIC Lapangan',
  'materialRequest.contact_required': 'Pemohon / PIC Lapangan wajib diisi',
  'materialRequest.memo': 'Pesan',
  'materialRequest.item_count': 'Jumlah Item',
  'materialRequest.total_qty': 'Total Qty',
  'materialRequest.status': 'Status',
  'materialRequest.status_draft': 'Draf',
  'materialRequest.status_submitted': 'Diajukan',
  'materialRequest.status_processing': 'Diproses Warehouse',
  'materialRequest.status_partial_fulfilled': 'Dipenuhi Sebagian',
  'materialRequest.status_fully_fulfilled': 'Dipenuhi Seluruhnya',
  'materialRequest.status_rejected': 'Ditolak',
  'materialRequest.status_cancelled': 'Dibatalkan',
  'materialRequest.submit': 'Ajukan',
  'materialRequest.approve': 'Setujui',
  'materialRequest.reject': 'Tolak',
  'materialRequest.cancel': 'Batalkan',
  'materialRequest.issue_material': 'Keluarkan Barang',
  'materialRequest.reject_reason': 'Alasan Penolakan',
  'materialRequest.reject_reason_required': 'Alasan penolakan wajib diisi',
  'materialRequest.reject_reason_placeholder': 'Tuliskan alasan penolakan permintaan ini',
  'materialRequest.reviewed_by': 'Ditinjau oleh',
  'materialRequest.reviewed_at': 'Ditinjau pada',
  'materialRequest.confirm_submit': 'Ajukan permintaan barang ini untuk ditinjau?',
  'materialRequest.confirm_approve': 'Setujui permintaan barang ini?',
  'materialRequest.confirm_cancel': 'Batalkan permintaan barang ini?',
  'materialRequest.revert_to_draft': 'Kembalikan ke draf',
  'materialRequest.confirm_revert_to_draft': 'Kembalikan permintaan barang ini ke draf?',
  'materialRequest.confirm_delete': 'Hapus permintaan barang ini?',
  'materialRequest.qty': 'Qty Diminta',
  'materialRequest.issued_qty': 'Qty Dikeluarkan',
  'materialRequest.remaining_qty': 'Sisa',
  'materialRequest.unit': 'Satuan',
  'materialRequest.tag': 'Tag',
  'materialRequest.tag_max': 'Maksimal {value} tag per baris',
  'materialRequest.tag_doc_max':
    'Total tag unik seluruh baris maksimal {value}. Kurangi tag pada baris {row}.',
  'materialRequest.item_desc': 'Catatan',
  'materialRequest.select_product': 'Pilih produk',
  'materialRequest.product_required': 'Produk wajib dipilih',
  'materialRequest.qty_required': 'Qty wajib diisi',
  'materialRequest.qty_must_be_positive': 'Qty harus lebih dari 0',
  'materialRequest.items_required': 'Minimal satu item harus diisi',
  'materialRequest.empty_list': 'Belum ada permintaan barang',

  purchase_request: 'Permintaan Pembelian',
  'purchaseRequest.title': 'Permintaan Pembelian',
  'purchaseRequest.add': 'Tambah Permintaan Pembelian',
  'purchaseRequest.edit': 'Ubah Permintaan Pembelian',
  'purchaseRequest.duplicate': 'Duplikat Permintaan Pembelian',
  'purchaseRequest.detail': 'Detail Permintaan Pembelian',
  'purchaseRequest.import': 'Impor Permintaan Pembelian',
  'purchaseRequest.number': 'Nomor',
  'purchaseRequest.trans_date': 'Tgl. Transaksi',
  'purchaseRequest.due_date': 'Akan Digunakan Pada',
  'purchaseRequest.due_date_placeholder': 'Pilih tanggal',
  'purchaseRequest.due_date_after_trans_date':
    'Akan Digunakan Pada tidak boleh lebih awal dari Tgl. Transaksi',
  'purchaseRequest.requested_by': 'Diminta oleh',
  'purchaseRequest.tag': 'Tag',
  'purchaseRequest.reference': 'Referensi',
  'purchaseRequest.reference_max': 'Referensi maksimal {value} karakter',
  'purchaseRequest.message': 'Pesan',
  'purchaseRequest.item_desc': 'Deskripsi',
  'purchaseRequest.item_source': 'Asal',
  'purchaseRequest.qty': 'Kuantitas',
  'purchaseRequest.remaining_qty': 'Qty Sisa',
  'purchaseRequest.qty_required': 'Kuantitas wajib diisi',
  'purchaseRequest.qty_must_be_positive': 'Kuantitas harus lebih dari 0',
  'purchaseRequest.qty_exceeds_remaining': 'Kuantitas melebihi sisa ({remaining})',
  'purchaseRequest.unit': 'Satuan',
  'purchaseRequest.reference_price': 'Harga Acuan',
  'purchaseRequest.estimation': 'Estimasi',
  'purchaseRequest.estimation_total': 'Estimasi Nilai',
  'purchaseRequest.select_product': 'Pilih produk',
  'purchaseRequest.product_required': 'Produk wajib dipilih',
  'purchaseRequest.save_and_submit': 'Simpan & Ajukan',
  'purchaseRequest.pull_from_material_request': 'Ambil dari Material Request',
  'purchaseRequest.search_placeholder': 'Cari nomor / referensi / pemohon',
  'purchaseRequest.empty_list': 'Belum ada permintaan pembelian',
  'purchaseRequest.status': 'Status',
  'purchaseRequest.status_open': 'Terbuka',
  'purchaseRequest.status_partial_ordered': 'Sebagian Dipesan',
  'purchaseRequest.status_closed': 'Ditutup',
  'purchaseRequest.create_purchase_order': 'Buat Pesanan Pembelian',
  'purchaseRequest.confirm_close': 'Tutup permintaan pembelian ini?',
  'purchaseRequest.confirm_delete': 'Hapus permintaan pembelian ini?',
  'purchaseRequest.create_purchase_request': 'Buat Permintaan Pembelian',
  'purchaseRequest.mr_number': 'Nomor MR',
  'purchaseRequest.mr_date': 'Tanggal',
  'purchaseRequest.mr_add': 'Tambahkan',
  'purchaseRequest.mr_search_placeholder': 'Cari nomor MR',
  'purchaseRequest.mr_select_required': 'Pilih minimal satu Material Request',
  'purchaseRequest.mr_max_100': 'Maksimal 100 Material Request per pengambilan',
  'purchaseRequest.mr_all_fulfilled':
    'Seluruh item Material Request sudah tertutup pengeluaran material.',
  'purchaseRequest.import_done': 'Impor Permintaan Pembelian selesai',
  'purchaseRequest.go_to_list': 'Ke daftar Permintaan Pembelian',
  'purchaseRequest.pr_search_placeholder': 'Cari nomor Permintaan Pembelian',
  'purchaseRequest.pr_skipped': 'Sebagian Permintaan Pembelian dilewati: {refs}',

  'materialIssue.title': 'Pengeluaran Barang',
  'materialIssue.add': 'Tambah Pengeluaran Barang',
  'materialIssue.detail': 'Detail Pengeluaran Barang',
  'materialIssue.ref_number': 'Nomor Pengeluaran',
  'materialIssue.number': 'Nomor',
  'materialIssue.trans_date': 'Tanggal Pengeluaran',
  'materialIssue.warehouse': 'Gudang Asal',
  'materialIssue.warehouse_required': 'Gudang asal wajib dipilih',
  'materialIssue.account': 'Akun Beban',
  'materialIssue.account_required': 'Akun beban wajib dipilih',
  'materialIssue.account_help': 'Akun beban tujuan pemakaian material ini',
  'materialIssue.contact': 'Penerima',
  'materialIssue.memo': 'Pesan',
  'materialIssue.status_posted': 'Aktif',
  'materialIssue.status_void': 'Dibatalkan',
  'materialIssue.void': 'Batalkan Pengeluaran',
  'materialIssue.confirm_void':
    'Batalkan pengeluaran barang ini? Stok akan dikembalikan dan jurnalnya dihapus.',
  'materialIssue.void_cannot_be_undone':
    'Pengeluaran barang tidak bisa diubah. Untuk mengoreksi, batalkan dokumen ini lalu buat yang baru.',
  'materialIssue.from_mr': 'Dari {refNumber}',
  'materialIssue.already_fulfilled': 'Sudah terpenuhi',
  'materialIssue.skipped': 'Dilewati',
  'materialIssue.qty_exceeds_remaining': 'Qty melebihi sisa yang diminta ({remaining})',
  'materialIssue.qty_fulfilled': 'Qty Pemenuhan',
  'materialIssue.serial_number': 'Nomor Seri',
  'materialIssue.empty_list': 'Belum ada pengeluaran barang',

  'ecsysConnect.title': 'Integrasi ECSys',
  'ecsysConnect.tab_connect': 'Koneksi',
  'ecsysConnect.tab_stores': 'Mapping Store',
  'ecsysConnect.tab_syncs': 'Riwayat Pengiriman',
  'ecsysConnect.tabs_locked_hint':
    'Simpan kredensial untuk membuka tab Mapping Store dan Riwayat Pengiriman.',
  'ecsysConnect.group_credentials': 'Kredensial',
  'ecsysConnect.group_push': 'Pengiriman',
  'ecsysConnect.password_help': 'Kosongkan bila tidak ingin mengubah.',
  'ecsysConnect.active': 'Aktif',
  'ecsysConnect.active_help': 'Invoice dikirim otomatis sesuai jadwal.',
  'ecsysConnect.sync_interval': 'Jadwal kirim',
  'ecsysConnect.sync_interval_unit': 'jam',
  'ecsysConnect.last_sync': 'Terakhir sinkron',
  'ecsysConnect.please_input_base_url': 'Silakan masukkan Base URL',
  'ecsysConnect.please_input_username': 'Silakan masukkan Username',
  'ecsysConnect.please_input_password': 'Silakan masukkan Password',
  'ecsysConnect.store_entity': 'Mapping Store',
  'ecsysConnect.store_no_outlet': 'Tanpa outlet',
  'ecsysConnect.airport_code': 'Kode Bandara',
  'ecsysConnect.airport_code_placeholder': 'mis. CGK',
  'ecsysConnect.store_is_default_checkbox': 'Jadikan store default',
  'ecsysConnect.store_is_default_help':
    'Invoice yang tidak terikat outlet mana pun dikirim ke store ini. Tanpa store default, invoice tersebut tidak terkirim ke ECSys.',
  'ecsysConnect.store_edit_title': 'Ubah Mapping Store',
  'ecsysConnect.store_delete_confirm':
    'Invoice yang memakai mapping ini berhenti dikirim ke ECSys.',
  'ecsysConnect.store_delete_default_warning':
    'Baris ini adalah store default. Setelah dihapus, tidak ada store default lagi — invoice yang tidak terikat outlet mana pun berhenti terkirim ke ECSys.',
  'ecsysConnect.store_uncheck_default_warning':
    'Setelah disimpan, tidak ada store default lagi. Invoice yang tidak terikat outlet mana pun berhenti terkirim ke ECSys sampai Anda menetapkan store default baru.',
  'ecsysConnect.please_input_store_id': 'Silakan masukkan ECSys Store ID',
  'ecsysConnect.sync_entity': 'Riwayat Pengiriman',
  'ecsysConnect.sync_ref_number': 'No. Faktur',
  'ecsysConnect.sync_trans_date': 'Tgl. Transaksi',
  'ecsysConnect.sync_pushed_at': 'Waktu Kirim',
  'ecsysConnect.sync_description': 'Keterangan',
  'ecsysConnect.sync_status_success': 'Terkirim',
  'ecsysConnect.sync_status_pending': 'Menunggu',
  'ecsysConnect.sync_status_failed_transient': 'Gagal sementara',
  'ecsysConnect.sync_status_failed_permanent': 'Gagal',
  'ecsysConnect.sync_filter_all': 'Semua',
  'ecsysConnect.sync_retry_at': 'Dicoba lagi {at}',
  'ecsysConnect.sync_empty_filtered_desc': 'Tidak ada pengiriman yang cocok dengan filter ini.',
  // Landing page ECSys Connect
  'ecsysConnect.lp_cta': 'Integrasi ECSys Connect',
  'ecsysConnect.lp_action_config': 'Atur',
  'ecsysConnect.lp_status_active': 'Aktif',
  'ecsysConnect.lp_status_saved': 'Tersimpan',
  'ecsysConnect.lp_status_verified': 'Terverifikasi',
  'ecsysConnect.lp_status_success': 'Berhasil',
  'ecsysConnect.lp_status_sent': 'Terkirim',
  'ecsysConnect.lp_status_waiting': 'Menunggu',
  'ecsysConnect.lp_hero_eyebrow': '#JadiLebihBaik kirim data transaksi ke ECSys',
  'ecsysConnect.lp_hero_title_1': 'Kini Bisa Kirim Data Transaksi Kledo ke ECSys',
  'ecsysConnect.lp_hero_title_2': 'Tanpa Input Ulang',
  'ecsysConnect.lp_hero_sub':
    'Hubungkan Kledo dengan sistem ECSys Angkasa Pura untuk mengirim semua data transaksi secara otomatis tanpa perlu memasukkan kembali transaksi secara manual dengan integrasi ECSys Connect.',
  'ecsysConnect.lp_hero_strip_1': 'Tanpa Input Ulang',
  'ecsysConnect.lp_hero_strip_2': 'Mapping Store',
  'ecsysConnect.lp_hero_strip_3': 'Riwayat Pengiriman',
  'ecsysConnect.lp_hero_tile_payment': 'Pembayaran',
  'ecsysConnect.lp_hero_tile_store': 'Store ECSys',
  'ecsysConnect.lp_hero_tile_validation': 'Validasi',
  'ecsysConnect.lp_hero_tile_history': 'Riwayat',
  'ecsysConnect.lp_about_title_1': 'Apa Itu',
  'ecsysConnect.lp_about_title_2': 'ECSys Angkasa Pura',
  'ecsysConnect.lp_about_title_3': '?',
  'ecsysConnect.lp_about_sub':
    'ECSys (E-POS Data Collection System) adalah aplikasi PT Angkasa Pura Indonesia yang digunakan untuk mengumpulkan data transaksi dari e-POS milik mitra usaha secara terintegrasi.',
  'ecsysConnect.lp_about_card_1':
    'Data transaksi dari sistem e-POS mitra usaha dikirim ke sistem PT Angkasa Pura Indonesia sehingga dapat dipantau dan divalidasi tanpa perlu dilakukan penginputan data transaksi secara manual.',
  'ecsysConnect.lp_about_card_2':
    'Melalui integrasi Kledo dan ECSys, data transaksi seperti nomor invoice, waktu transaksi, informasi produk, jumlah, harga, pajak, metode pembayaran, hingga total transaksi dapat dikirim sesuai format yang telah ditentukan oleh PT Angkasa Pura Indonesia.',
  'ecsysConnect.lp_about_tag_1': 'No. Invoice',
  'ecsysConnect.lp_about_tag_2': 'Waktu Transaksi',
  'ecsysConnect.lp_about_tag_3': 'Informasi Produk',
  'ecsysConnect.lp_about_tag_4': 'Jumlah & Harga',
  'ecsysConnect.lp_about_tag_5': 'Pajak',
  'ecsysConnect.lp_about_tag_6': 'Metode Pembayaran',
  'ecsysConnect.lp_about_tag_7': 'Total Transaksi',
  'ecsysConnect.lp_features_title_1': 'Satu Integrasi untuk Mengirim',
  'ecsysConnect.lp_features_title_2': 'Data Transaksi ke ECSys',
  'ecsysConnect.lp_features_sub':
    'Dari koneksi akun, mapping store, pengiriman transaksi, sampai riwayat pengiriman — semuanya dalam satu alur kerja.',
  'ecsysConnect.lp_feat1_title': 'Terhubung Langsung dengan ECSys',
  'ecsysConnect.lp_feat1_desc':
    'Hubungkan akun Kledo dengan ECSys Angkasa Pura menggunakan konfigurasi koneksi yang telah disediakan. Setelah terhubung, data transaksi dari Kledo dapat dikirim ke ECSys tanpa proses input ulang secara manual.',
  'ecsysConnect.lp_feat1_mock_title': 'Status Koneksi ECSys',
  'ecsysConnect.lp_feat1_mock_hint': 'terhubung',
  'ecsysConnect.lp_feat1_row1': 'URL Endpoint',
  'ecsysConnect.lp_feat1_row2': 'Client ID',
  'ecsysConnect.lp_feat1_row3': 'Secret Key',
  'ecsysConnect.lp_feat1_row4': 'Uji Koneksi',
  'ecsysConnect.lp_feat2_title': 'Mapping Store Lebih Mudah',
  'ecsysConnect.lp_feat2_desc':
    'Tentukan hubungan antara store, gudang, atau lokasi di Kledo dengan store yang terdapat di ECSys. Atur mapping sesuai lokasi usaha Anda agar data transaksi dapat dikirim ke tujuan yang sesuai.',
  'ecsysConnect.lp_feat2_mock_title': 'Mapping Store',
  'ecsysConnect.lp_feat2_mock_tag': 'Kledo · Gudang Terminal 3',
  'ecsysConnect.lp_feat2_mock_target': 'Dipetakan ke ECSys · Store ST-CGK-T3',
  'ecsysConnect.lp_feat2_mock_note': '3 dari 4 lokasi Kledo sudah dipetakan ke store ECSys',
  'ecsysConnect.lp_feat2_mock_add': 'Tambah mapping store',
  'ecsysConnect.lp_feat3_title': 'Kirim Data Transaksi Tanpa Input Ulang',
  'ecsysConnect.lp_feat3_desc':
    'Transaksi yang sudah tercatat di Kledo dapat dikirim ke ECSys secara terintegrasi. Tidak perlu lagi memasukkan kembali data transaksi satu per satu sehingga proses administrasi menjadi lebih praktis.',
  'ecsysConnect.lp_feat3_mock_title': 'Transaksi Dikirim',
  'ecsysConnect.lp_feat3_picker': 'Hari ini',
  'ecsysConnect.lp_feat3_row2_meta': '98 transaksi',
  'ecsysConnect.lp_feat3_row3_title': 'Antrean pengiriman',
  'ecsysConnect.lp_feat3_row3_meta': '1 transaksi',
  'ecsysConnect.lp_feat4_title': 'Pantau Riwayat Pengiriman',
  'ecsysConnect.lp_feat4_desc':
    'Periksa histori transaksi yang telah dikirim dari Kledo ke ECSys melalui tab Riwayat Pengiriman. Gunakan informasi tersebut untuk mengecek transaksi dan menelusuri proses pengiriman data.',
  'ecsysConnect.lp_feat4_mock_title': 'Riwayat Pengiriman',
  'ecsysConnect.lp_feat4_picker': 'Bulan ini',
  'ecsysConnect.lp_feat4_head_status': 'Status Pengiriman',
  'ecsysConnect.lp_feat4_head_count': 'Jumlah',
  'ecsysConnect.lp_feat4_row1': 'Transaksi terkirim ke ECSys',
  'ecsysConnect.lp_feat4_row2': 'Menunggu proses pengiriman',
  'ecsysConnect.lp_feat4_row3': 'Perlu dikirim ulang',
  'ecsysConnect.lp_feat4_row4': 'Pengiriman terakhir ke ECSys',
  'ecsysConnect.lp_banner_title': 'Lebih Praktis, Tanpa Input Ulang Transaksi.',
  'ecsysConnect.lp_banner_sub': 'Gunakan ECSys Connect Sekarang.',
  'ecsysConnect.lp_cta_text':
    'Kirim data transaksi dari Kledo ke ECSys tanpa perlu input ulang secara manual. Hubungkan Kledo dengan ECSys dan kelola proses pengiriman transaksi dengan lebih praktis.',
  'settings.ecsys_connect': 'Otomatis kirim invoice penjualan ke ECSys',
  'approval.budget_management': 'Manajemen Anggaran',
  'zap.landing_title': 'Distribusi',
  'zap.landing_hash_tag': '#Jadilebihbaik kelola manajemen distribusi bisnismu',
  'zap.landing_head_title':
    'Manajemen Distribusi Lebih Optimal Hasilkan Keuntungan Maksimal dengan',
  'zap.landing_head_desc':
    'Zap membantu perusahaan mengelola distribusi secara efisien melalui manajemen rute, monitoring aktivitas sales canvassing, serta pelaporan operasional secara real-time sehingga setiap proses lebih terkontrol.',
  'zap.landing_phone_alt': 'Tampilan aplikasi Zap di smartphone',
  'zap.landing_banner_alt': 'Manajemen distribusi dari gudang hingga pelanggan dengan Zap',
  'zap.landing_start_free': 'Mulai Gratis Sekarang',
  'zap.landing_feat_title_1': 'Apa yang akan',
  'zap.landing_feat_title_2': 'Anda Dapatkan',
  'zap.landing_feat_title_3': 'Jika Menggunakan Zap?',
  'zap.landing_feat_route_title': 'Fitur Smart Route Untuk Manajemen Rute Optimal',
  'zap.landing_feat_route_desc':
    'Dengan fitur smart route dari Zap, sistem akan otomatis mencarikan rute yang paling efisien untuk driver dan salesman sehingga alur kunjungan lebih optimal, biaya operasional berkurang, dan lebih banyak pelanggan dapat dilayani setiap hari.',
  'zap.landing_feat_canvassing_title': 'Aplikasi Canvassing Dari Smartphone',
  'zap.landing_feat_canvassing_desc':
    'Kelola aktivitas sales lapangan secara lebih terstruktur menggunakan aplikasi canvassing Zap. Jadwalkan kunjungan pelanggan, pantau hasil canvassing, dan pastikan setiap aktivitas tercatat secara otomatis tanpa proses manual.',
  'zap.landing_feat_tracking_title': 'Tracking Driver Real-Time',
  'zap.landing_feat_tracking_desc':
    'Pantau lokasi dan pergerakan driver secara langsung melalui sistem Zap. Ketahui status perjalanan, memastikan pengiriman berjalan sesuai rencana, serta memudahkan koordinasi dengan tim lapangan.',
  'zap.landing_feat_accounting_title': 'Terintegrasi Dengan Sistem Akuntansi',
  'zap.landing_feat_accounting_desc':
    'Seluruh transaksi distribusi dan penjualan dapat terhubung dengan sistem akuntansi Kledo, sehingga pencatatan keuangan menjadi lebih cepat, akurat, dan memudahkan Anda dalam mengambil keputusan bisnis yang lebih baik.',
  'zap.landing_feat_fleet_title': 'Manajemen Armada Terpusat',
  'zap.landing_feat_fleet_desc':
    'Kelola seluruh armada distribusi dalam satu dashboard. Pantau kendaraan yang beroperasi, jadwal penggunaan, driver yang menggunakan, serta performa armada agar operasional tetap berjalan optimal.',
  'zap.landing_feat_transparency_title': 'Sistem Penjualan Dan Gudang Lebih Transparan',
  'zap.landing_feat_transparency_desc':
    'Setiap transaksi penjualan dan pergerakan stok tercatat secara real-time sehingga Anda dapat memantau persediaan, distribusi barang, dan performa penjualan dengan lebih akurat.',
  'zap.landing_footer_note':
    'Optimalkan operasional distribusi dan tingkatkan produktivitas tim lapangan dengan Zap. Coba sekarang juga.',
  'priceForecast.title': 'Pengaturan Forecast Harga',
  'priceForecast.page_subtitle':
    'Atur skenario kenaikan harga dan persentase per bulan tiap produk bahan.',
  'priceForecast.target_production_finish': 'Target Selesai Produksi',
  'priceForecast.target_production_finish_help':
    'Jumlah bulan sampai produksi selesai. Jadi dasar proyeksi kenaikan harga bahan.',
  'priceForecast.month_option': '{months} bulan · ± {date}',
  'priceForecast.tab_scenario': 'Skenario',
  'priceForecast.tab_percentage': 'Persentase Produk',
  'priceForecast.scenario_name': 'Nama skenario',
  'priceForecast.scenario_name_required': 'Nama skenario wajib diisi.',
  'priceForecast.scenario_name_length_error': 'Nama skenario harus {min}–{max} karakter.',
  'priceForecast.scenario_name_duplicate_error': 'Nama "{name}" sudah dipakai skenario lain.',
  'priceForecast.add_scenario': 'Tambah skenario',
  'priceForecast.edit_scenario': 'Ubah skenario',
  'priceForecast.delete_scenario_title': 'Hapus skenario "{name}"?',
  'priceForecast.delete_scenario_warning_percentage':
    'Semua persentase produk untuk skenario ini akan ikut terhapus dan tidak bisa dikembalikan.',
  'priceForecast.delete_scenario_warning_snapshot':
    'Snapshot forecast di penawaran yang sudah dibuat tetap utuh (tidak berubah).',
  'priceForecast.delete_scenario_ok': 'Hapus skenario',
  'priceForecast.empty_title': 'Belum ada skenario',
  'priceForecast.empty_desc':
    'Skenario adalah asumsi kenaikan harga (misalnya optimis, normal, atau pesimis). Mulai dari saran umum di bawah, atau buat sendiri.',
  'priceForecast.create_suggested_scenarios': 'Buat 3 skenario saran',
  'priceForecast.create_own_scenario': 'Buat skenario sendiri',
  'priceForecast.suggested_scenarios_created': '3 skenario saran berhasil dibuat.',
  'priceForecast.suggestion_best': 'Terbaik',
  'priceForecast.suggestion_normal': 'Normal',
  'priceForecast.suggestion_worst': 'Terburuk',
  'priceForecast.percentage_no_scenario':
    'Buat skenario dulu di tab Skenario sebelum mengisi persentase produk.',
  'priceForecast.percentage_search_placeholder': 'Cari produk bahan',
  'priceForecast.percentage_product_empty': 'Tidak ada produk yang cocok.',
  'priceForecast.percentage_select_product':
    'Pilih produk di daftar kiri untuk mengisi persentase.',
  'priceForecast.percentage_panel_hint':
    'Persentase kenaikan harga per bulan. Kosongkan untuk menghapus set-an skenario itu.',
  'priceForecast.percentage_not_set': '- belum',
  'priceForecast.percentage_invalid': 'Persentase harus berupa angka.',
  // Batas ditulis langsung di teks: react-intl memformat argumen angka dengan
  // Intl.NumberFormat (maks 3 desimal), jadi -99,9999 akan tampil jadi -100.
  'priceForecast.percentage_range_error': 'Persentase harus di antara -99,9999 dan 999,9999.',
  'priceForecast.percentage_decimal_error': 'Persentase maksimal {max} angka di belakang koma.',
  'priceForecast.percentage_load_error': 'Persentase produk ini gagal dimuat.',
  'priceForecast.panel_title': 'Forecast biaya bahan',
  'priceForecast.panel_basis_current': 'Saat ini {value}',
  'priceForecast.panel_basis_months': 'proyeksi {months} bln',
  'priceForecast.panel_basis_margin': 'margin thd {value}',
  'priceForecast.col_scenario': 'Skenario',
  'priceForecast.col_percentage_month': '% / bln',
  'priceForecast.col_projected_unit': 'Proyeksi bahan / unit',
  'priceForecast.col_margin': 'Margin',
  'priceForecast.margin_safe': 'Margin aman',
  'priceForecast.margin_thin': 'Margin menipis',
  'priceForecast.margin_critical': 'Margin kritis',
  'priceForecast.banner_incomplete':
    'Estimasi belum lengkap. Sebagian komponen belum punya persentase forecast — dihitung sebagai 0%, jadi proyeksi bisa lebih rendah dari kenyataan.',
  'priceForecast.banner_incomplete_count':
    'Estimasi belum lengkap. {count} komponen belum punya persentase forecast — dihitung sebagai 0%, jadi proyeksi bisa lebih rendah dari kenyataan.',
  'priceForecast.banner_truncated':
    'Kedalaman resep dipotong di 10 level — komponen lebih dalam tak ikut dihitung. Proyeksi berikut mungkin sedikit di bawah nilai penuh.',
  'priceForecast.margin_minus_blocked': 'Profit margin forecast minus pada skenario {scenarios}',
  'priceForecast.calculate_error': 'Gagal memuat estimasi.',
  'priceForecast.retry': 'Coba lagi',
  'priceForecast.panel_expand': 'Lihat detail',
  'priceForecast.panel_collapse': 'Tutup',
  'priceForecast.panel_updating': 'Memperbarui…',
  'priceForecast.panel_updating_months': 'Memperbarui ke {months} bln',
  'priceForecast.updating_progress': 'Memperbarui proyeksi… {done}/{total}',
  'priceForecast.detail_card_title': 'Forecast harga bahan - {product}',
  'priceForecast.detail_card_qty': '× {qty}',
  'priceForecast.detail_snapshot_date': 'Snapshot {date}',
  'priceForecast.detail_snapshot_months': 'target produksi {months} bln',
  'priceForecast.detail_snapshot_source': 'basis {source}',
  'priceForecast.source_inventory_avg': 'rata-rata persediaan',
  'priceForecast.source_inventory_fifo': 'persediaan FIFO',
  'priceForecast.source_last_purchase': 'pembelian terakhir',
  'priceForecast.source_base_price': 'harga dasar produk',
  'priceForecast.basis_snapshot': 'Basis (snapshot)',
  'priceForecast.col_material_unit_cost': 'Biaya bahan / unit',
  'priceForecast.col_total_qty': 'Total (× {qty})',
  'priceForecast.live_label': 'Estimasi hari ini · {date}',
  'priceForecast.live_per_unit': '{value} / unit',
  'priceForecast.live_delta': '{value} dari snapshot',
  'priceForecast.live_exceeds_badge': 'Melebihi skenario tertinggi',
  'priceForecast.live_note_exceed':
    'Biaya bahan hari ini sudah di atas proyeksi {scenario} ({value}). Pertimbangkan revisi penawaran atau amankan pembelian bahan lebih awal.',
  'priceForecast.live_note_normal': 'Masih di bawah {scenario}.',
  'priceForecast.live_margin': 'Margin hari ini:',
  'priceForecast.bom_toggle': 'Rincian komponen (BOM) - {count} bahan',
  'priceForecast.bom_col_component': 'Komponen',
  'priceForecast.bom_col_qty_per_unit': 'Qty / unit',
  'priceForecast.bom_col_snapshot_price': 'Harga snapshot',
  'priceForecast.bom_missing_percentage': '· belum ada %',
  'approval.section.transaction_desc': 'Persetujuan transaksi penjualan, pembelian, dan kas & bank',
  'approval.section.warehouse_transfer_desc': 'Persetujuan perpindahan barang antar gudang',
  'approval.section.stock_adjustment_desc': 'Persetujuan penyesuaian jumlah stok barang',
  'approval.section.material_request_desc': 'Persetujuan permintaan barang dari gudang',
  'approval.section.purchase_request_desc': 'Persetujuan permintaan pembelian internal',
  'approval.section.material_issue_desc': 'Persetujuan pengeluaran barang dari gudang',
  'approval.section.budget_management_desc': 'Persetujuan anggaran dan rencana keuangan',
  'approval.section.warehouse_transfer_group_desc': 'Persetujuan grup transfer gudang gabungan',
  'productionPlan.title': 'Rencana Produksi',
  'productionPlan.status_not_started': 'Belum mulai',
  'productionPlan.status_partial': 'Sebagian',
  'productionPlan.status_completed': 'Selesai',
  'productionPlan.transaction_status': 'Status Rencana Produksi',
  'productionPlan.transaction_numbers': 'Nomor Rencana Produksi',
  'productionPlan.column_stock_status': 'Status Bahan',
  'productionPlan.stock_status_enough': 'Bahan Cukup',
  'productionPlan.stock_status_short': 'Bahan Kurang',
  'productionPlan.material_stock_title': 'Kecukupan Bahan Baku',
  'productionPlan.material_stock_empty': 'Tidak ada kebutuhan bahan baku tersisa',
  'productionPlan.material_stock_note':
    'Stok = total semua gudang, hari ini. Angka ini dihitung ulang setiap halaman dibuka.',
  'productionPlan.material_stock_product': 'Bahan',
  'productionPlan.material_stock_need': 'Butuh',
  'productionPlan.material_stock_stock': 'Stok',
  'productionPlan.material_stock_used_by_other_plans': 'Dipakai rencana lain',
  'productionPlan.material_stock_available': 'Tersedia',
  'productionPlan.material_stock_shortage': 'Kurang',
  'productionPlan.column_realization_shortage': 'Kekurangan saat realisasi',
  'productionPlan.shortage_chip': '{name} kurang {shortage} {unit}',
  'productionPlan.column_ref_number': 'Nomor',
  'productionPlan.column_name': 'Nama',
  'productionPlan.column_plan_date': 'Tanggal Rencana',
  'productionPlan.column_status': 'Status',
  'productionPlan.column_actions': 'Aksi',
  'productionPlan.column_priority': 'Prioritas ke',
  'productionPlan.move_success': 'Prioritas rencana produksi berhasil diubah',
  'productionPlan.move_error': 'Prioritas rencana produksi gagal diubah',
  'productionPlan.show_archived': 'Tampilkan yang diarsipkan',
  'productionPlan.filter_archive': 'Arsip',
  'productionPlan.filter_archive_info':
    'Centang untuk ikut menampilkan rencana produksi yang sudah diarsipkan.',
  'productionPlan.field_name_placeholder': 'Masukkan nama rencana',
  'productionPlan.notes_placeholder': 'Catatan (opsional)',
  'productionPlan.qty_placeholder': 'Masukkan kuantitas',
  'productionPlan.date_placeholder': 'Pilih tanggal',
  'productionPlan.delete_confirm': 'Yakin ingin menghapus rencana produksi ini?',
  'productionPlan.delete_success': 'Rencana Produksi berhasil dihapus',
  'productionPlan.delete_error': 'Rencana Produksi tidak dapat dihapus',
  'productionPlan.field_name': 'Nama Rencana',
  'productionPlan.field_name_required': 'Nama wajib diisi',
  'productionPlan.field_plan_date': 'Tanggal Rencana',
  'productionPlan.field_plan_date_required': 'Tanggal rencana wajib diisi',
  'productionPlan.field_notes': 'Catatan',
  'productionPlan.add_item': 'Tambah Baris Produk',
  'productionPlan.item_product': 'Produk Manufaktur',
  'productionPlan.item_product_placeholder': 'Pilih Produk Manufaktur',
  'productionPlan.pull_from_so': 'Tarik data dari Pemesanan Penjualan',
  'productionPlan.from_sales_order': 'Dari Sales Order',
  'productionPlan.from_sales_order_with_ref': 'Dari Sales Order {ref}',
  'productionPlan.so_number': 'Nomor SO',
  'productionPlan.so_date': 'Tanggal',
  'productionPlan.so_customer': 'Pelanggan',
  'productionPlan.so_qty_order': 'Kuantitas Pesanan',
  'productionPlan.so_already_pulled': 'Sudah Ditarik',
  'productionPlan.so_description': 'Deskripsi',
  'productionPlan.so_remaining': 'Sisa',
  'productionPlan.so_add': 'Tambahkan',
  'productionPlan.so_picker_instruction':
    'Silakan pilih pemesanan yang akan dimasukkan ke dalam rencana produksi',
  'productionPlan.help_what':
    'Apa: Rencana Produksi adalah perencanaan manufaktur - daftar produk yang akan diproduksi beserta kuantitas, tanggal, dan prioritas.',
  'productionPlan.help_flow':
    'Alur: Buat rencana (manual atau tarik dari Pemesanan Penjualan) -> atur prioritas -> lakukan Realisasi Produksi per baris atau sekaligus.',
  'productionPlan.help_effect':
    'Efek ke transaksi: Realisasi membentuk transaksi Konversi Produk - mengurangi stok bahan baku, menambah stok produk jadi, dan mencatat jurnal.',
  'productionPlan.so_search_placeholder': 'Cari nomor SO, produk, atau pelanggan',
  'productionPlan.so_select_required': 'Pilih minimal satu baris',
  'productionPlan.item_product_required': 'Produk wajib dipilih',
  'productionPlan.item_planned_qty': 'Kuantitas Rencana',
  'productionPlan.item_planned_qty_required': 'Kuantitas rencana wajib diisi',
  'productionPlan.item_planned_qty_gt_zero': 'Kuantitas harus lebih dari 0',
  'productionPlan.item_planned_qty_min_realized':
    'Kuantitas tidak boleh kurang dari kuantitas yang sudah direalisasi ({qty})',
  'productionPlan.item_target_date': 'Target Tanggal',
  'productionPlan.item_notes': 'Catatan',
  'productionPlan.item_realized_qty': 'Kuantitas Realisasi',
  'productionPlan.remaining': 'Sisa',
  'productionPlan.formula_title': 'Formula Produksi (perkiraan bahan baku)',
  'productionPlan.formula_material': 'Bahan Baku',
  'productionPlan.formula_needed_qty': 'Perkiraan Kebutuhan',
  'productionPlan.formula_empty': 'Belum ada resep bahan baku',
  'productionPlan.save_success': 'Rencana Produksi berhasil disimpan',
  'productionPlan.save_error': 'Rencana Produksi gagal disimpan',
  'productionPlan.add_title': 'Tambah Rencana Produksi',
  'productionPlan.edit_title': 'Ubah Rencana Produksi',
  'productionPlan.detail_title': 'Detail Rencana Produksi',
  'productionPlan.print_error':
    'Tautan cetak sudah tidak berlaku atau rencana produksi tidak ditemukan. Muat ulang halaman lalu coba lagi.',
  'productionPlan.archive': 'Arsipkan',
  'productionPlan.unarchive': 'Batal Arsip',
  'productionPlan.conversion_ref': 'Nomor Konversi',
  'productionPlan.item_warehouse': 'Gudang',
  'productionPlan.realize_title': 'Realisasi Produksi',
  'productionPlan.realize_submit': 'Realisasi',
  'productionPlan.realize_success': 'Realisasi berhasil',
  'productionPlan.realize_error': 'Realisasi gagal',
  'productionPlan.realize_summary':
    'Rencana: {planned} • Terealisasi: {realized} • Sisa: {remaining}',
  'productionPlan.realize_sn_unsupported':
    'Produk ini memakai serial number. Input serial number belum didukung di modal ini dan akan menyusul.',
  'productionPlan.realize_sn_material_unsupported':
    'Bahan baku produk ini memakai serial number — realisasi lewat modal ini belum didukung dan akan menyusul.',
  'productionPlan.output_sn_section': 'Serial Number Produk Jadi',
  'productionPlan.output_sn_hint':
    'Baris serial number dibuat otomatis sesuai kuantitas realisasi. Isi kode untuk setiap serial number.',
  'productionPlan.output_sn_code': 'Kode Serial Number',
  'productionPlan.output_sn_code_required': 'Kode serial number wajib diisi',
  'productionPlan.output_sn_add': 'Tambah Serial Number',
  'productionPlan.output_sn_fill': 'Isi Serial Number',
  'productionPlan.output_sn_count': '{filled} dari {total} terisi',
  'productionPlan.output_sn_incomplete': 'Kode serial number produk jadi belum lengkap',
  'productionPlan.output_sn_qty_mismatch':
    'Total kuantitas serial number harus sama dengan kuantitas realisasi ({qty})',
  'productionPlan.sn_material_section': 'Serial Number Bahan Baku',
  'productionPlan.sn_needed': 'butuh {qty}',
  'productionPlan.sn_available': 'sisa',
  'productionPlan.sn_select': 'Pilih serial number',
  'productionPlan.sn_pick_warehouse_first':
    'Pilih gudang dulu untuk melihat serial number tersedia',
  'productionPlan.item_sn_qty_mismatch': 'Total serial number untuk {name} harus {qty}',
  'productionPlan.realize_qty': 'Kuantitas Realisasi',
  'productionPlan.realize_trans_date': 'Tanggal Transaksi',
  'productionPlan.realize_warehouse_equal': 'Semua bahan dari satu gudang',
  'productionPlan.realize_qty_over': 'Kuantitas tidak boleh melebihi sisa ({remaining})',
  'productionPlan.batch_realize_title': 'Realisasi Sekaligus',
  'productionPlan.batch_realize_submit': 'Realisasikan Semua',
  'productionPlan.batch_select_required': 'Pilih minimal satu baris',
  'productionPlan.batch_item_excluded': 'Tidak diikutkan dalam realisasi',
  'productionPlan.cancel_success': 'Realisasi berhasil dibatalkan',
  'productionPlan.cancel_error': 'Realisasi gagal dibatalkan',
  'productionPlan.cancel_confirm': 'Batalkan realisasi ini? Stok dan jurnal akan dikembalikan.',
  'productionPlan.cancel_confirm_delivery_plan':
    'Jika realisasi ini punya jadwal pengiriman aktif, batalkan jadwalnya dulu.',
  'productionPlan.cancel_realization': 'Batalkan',
  'productionPlan.materials_title': 'Bahan baku yang dipakai',
  'productionPlan.materials_hint':
    'Terisi otomatis dari resep. Ubah bila aktualnya berbeda — perubahan hanya berlaku untuk realisasi ini.',
  'productionPlan.materials_empty': 'Belum ada bahan baku',
  'productionPlan.material_col_name': 'Bahan',
  'productionPlan.material_col_recipe': 'Sesuai resep',
  'productionPlan.material_col_used': 'Dipakai',
  'productionPlan.material_col_sn': 'No. seri',
  'productionPlan.material_badge_added': 'tambahan',
  'productionPlan.material_badge_edited': 'diubah',
  'productionPlan.material_sn_below': 'isi di bawah',
  'productionPlan.material_add': 'Tambah bahan',
  'productionPlan.material_add_placeholder': 'Cari produk (yang dilacak stoknya)',
  'productionPlan.material_qty_required':
    'Kuantitas bahan {name} harus lebih besar dari 0. Ubah nilainya atau hapus barisnya.',
  'productionPlan.material_qty_inline_error': 'Harus lebih dari 0',
  'deliveryPlan.section_title': 'Jadwal Pengiriman Otomatis',
  'deliveryPlan.status_waiting': 'Menunggu',
  'deliveryPlan.status_published': 'Terbit',
  'deliveryPlan.status_failed': 'Gagal',
  'deliveryPlan.status_cancelled': 'Batal',
  'deliveryPlan.column_plan_date': 'Tanggal Kirim',
  'deliveryPlan.column_qty': 'Kuantitas',
  'deliveryPlan.column_order': 'Pesanan',
  'deliveryPlan.column_customer': 'Pelanggan',
  'deliveryPlan.column_status': 'Status',
  'deliveryPlan.column_notes': 'Catatan',
  'deliveryPlan.column_actions': 'Aksi',
  'deliveryPlan.add': 'Jadwalkan Pengiriman',
  'deliveryPlan.edit_title': 'Ubah Jadwal Pengiriman',
  'deliveryPlan.add_title': 'Jadwalkan Pengiriman',
  'deliveryPlan.cancel_action': 'Batalkan',
  'deliveryPlan.retry_action': 'Coba Ulang',
  'deliveryPlan.delete_action': 'Hapus',
  'deliveryPlan.view_delivery': 'Lihat Surat Jalan',
  'deliveryPlan.field_qty': 'Jumlah',
  'deliveryPlan.field_qty_placeholder': 'Masukkan jumlah',
  'deliveryPlan.field_qty_required': 'Jumlah wajib diisi',
  'deliveryPlan.field_qty_gt_zero': 'Jumlah harus lebih dari 0',
  'deliveryPlan.field_qty_over_realization': 'Jumlah melebihi kuantitas realisasi ({remaining})',
  'deliveryPlan.field_plan_date': 'Tanggal Kirim',
  'deliveryPlan.field_plan_date_required': 'Tanggal kirim wajib diisi',
  'deliveryPlan.field_plan_date_min':
    'Tidak boleh lebih awal dari tanggal rencana produksi ({date})',
  'deliveryPlan.sn_disabled_hint':
    'Produk bernomor seri tidak bisa dijadwalkan otomatis. Gunakan pembuatan surat jalan manual.',
  'deliveryPlan.field_notes': 'Catatan',
  'deliveryPlan.field_notes_placeholder': 'Catatan (opsional)',
  'deliveryPlan.hint_realization_qty': 'Kuantitas realisasi: {qty}',
  'deliveryPlan.header_summary':
    'Sudah dijadwalkan {scheduled} · sisa bisa dijadwalkan {remaining}',
  'deliveryPlan.confirm_cancel': 'Yakin ingin membatalkan jadwal pengiriman ini?',
  'deliveryPlan.confirm_delete': 'Yakin ingin menghapus jadwal pengiriman ini?',
  'deliveryPlan.confirm_retry': 'Coba terbitkan surat jalan lagi?',
  'deliveryPlan.add_success': 'Jadwal pengiriman berhasil dibuat',
  'deliveryPlan.add_error': 'Jadwal pengiriman gagal dibuat',
  'deliveryPlan.edit_success': 'Jadwal pengiriman berhasil diubah',
  'deliveryPlan.edit_error': 'Jadwal pengiriman gagal diubah',
  'deliveryPlan.cancel_success': 'Jadwal pengiriman berhasil dibatalkan',
  'deliveryPlan.cancel_error': 'Jadwal pengiriman gagal dibatalkan',
  'deliveryPlan.retry_success': 'Jadwal pengiriman dijalankan ulang',
  'deliveryPlan.retry_error': 'Gagal menjalankan ulang jadwal pengiriman',
  'deliveryPlan.delete_success': 'Jadwal pengiriman berhasil dihapus',
  'deliveryPlan.delete_error': 'Jadwal pengiriman gagal dihapus',
  'deliveryPlan.empty': 'Belum ada jadwal pengiriman untuk realisasi ini',
  'deliveryPlan.failure_reason_label': 'Penyebab gagal',
  'report.receivables_transaction_details': 'Detail Transaksi Piutang',
  'layoutInvoice.invoice_show_contact_bank_account': 'Tampilkan Rekening Bank Kontak',
  'notification.approval_requested': 'Notifikasi mobile pengajuan approval',
  'notification.invoice_created': 'Notifikasi mobile tagihan penjualan dibuat',
  'notification.delivery_created': 'Notifikasi mobile pengiriman penjualan dibuat',
  'notification.order_created': 'Notifikasi mobile pesanan penjualan dibuat',
  'notification.quote_created': 'Notifikasi mobile penawaran penjualan dibuat',
  'notification.push_prompt_title': 'Aktifkan notifikasi browser',
  'notification.push_prompt_description':
    'Dapat kabar pengajuan approval, transaksi baru, dan aktivitas penting bisnis Anda secara langsung, meski tab Kledo sedang tidak dibuka.',
  'notification.push_enabled_success': 'Notifikasi browser aktif di perangkat ini.',
  'notification.push_enable_failed': 'Gagal mengaktifkan notifikasi browser. Silakan coba lagi.',
  'notification.push_denied_hint':
    'Notifikasi diblokir browser. Izinkan lewat ikon gembok di samping alamat situs, lalu muat ulang halaman.',
  'notification.push_view_detail': 'Lihat detail',
  'pinProduct.pin_to_warehouse': 'Pin ke Gudang',
  'pinProduct.badge_pinned': 'Dipin',
  'pinProduct.badge_archived': 'Arsip',
  'pinProduct.modal_title': 'Pin ke Gudang',
  'pinProduct.select_warehouse': 'Pilih gudang',
  'pinProduct.pin_success': '{title} berhasil dipin ke gudang',
  'pinProduct.unpin_success': 'Pin {title} berhasil dihapus',
  'pinProduct.partial_result': '{success} berhasil, {failed} gagal',
  'salesOverview.last_updated': 'Update {time}',
  'salesOverview.realtime_start': 'Mulai live update',
  'salesOverview.realtime_stop': 'Hentikan live update',
  'businessFlow.contact_id_required': 'ID Kontak wajib diisi',
  'businessFlow.contact_id_required_desc':
    'Jika aktif, kolom ID Kontak (Nomor Kontak) pada template impor tagihan pembelian dan penjualan wajib diisi. Kontak dicocokkan berdasarkan Nomor Kontak dan tipe kontak, sehingga baris dengan ID Kontak yang tidak terdaftar akan ditolak dan tidak membuat kontak baru.',
  'financeInvoices.import_contact_id_is_required':
    'Kolom ID Kontak wajib diisi dan harus berupa Nomor Kontak. Kontak dicocokkan berdasarkan Nomor Kontak dan tipe kontak, sehingga baris dengan ID Kontak yang tidak terdaftar akan ditolak dan tidak membuat kontak baru.',
  'financeInvoices.import_contact_id_is_optional':
    'Kolom ID Kontak bersifat opsional dan diabaikan. Kontak tetap dicocokkan berdasarkan nama kontak.',
  'posMaterialRequest.action.cancel': 'Batalkan',
  'posMaterialRequest.action.delete': 'Hapus permintaan',
  'posMaterialRequest.action.draft': 'Kembali ke draf',
  'posMaterialRequest.action.edit': 'Ubah',
  'posMaterialRequest.action.resubmit': 'Ajukan ulang',
  'posMaterialRequest.action.submit': 'Ajukan',
  'posMaterialRequest.champion.ask_admin':
    'Hubungi pemilik akun atau admin perusahaan untuk upgrade paket.',
  'posMaterialRequest.champion.badge': 'PAKET CHAMPION',
  'posMaterialRequest.champion.current_plan': 'Paket Anda saat ini:',
  'posMaterialRequest.champion.title': '{feature} tersedia di paket Champion',
  'posMaterialRequest.champion.upgrade': 'Upgrade Paket',
  'posMaterialRequest.confirm.cancel_message': 'Pusat tidak akan memproses permintaan {ref}.',
  'posMaterialRequest.confirm.cancel_title': 'Batalkan permintaan ini?',
  'posMaterialRequest.confirm.delete_message': 'Permintaan {ref} akan dihapus permanen.',
  'posMaterialRequest.confirm.delete_title': 'Hapus permintaan ini?',
  'posMaterialRequest.confirm.keep': 'Tidak',
  'posMaterialRequest.count.processed': 'Diproses',
  'posMaterialRequest.count.waiting': 'Menunggu',
  'posMaterialRequest.create_short': 'Ajukan',
  'posMaterialRequest.date_from': 'Dari tanggal',
  'posMaterialRequest.date_to': 'Sampai tanggal',
  'posMaterialRequest.detail.back_to_list': 'Kembali ke daftar',
  'posMaterialRequest.detail.date': 'Tanggal',
  'posMaterialRequest.detail.empty_subtitle': 'Detail permintaan akan tampil di sini.',
  'posMaterialRequest.detail.empty_title': 'Pilih permintaan',
  'posMaterialRequest.detail.history': 'Riwayat',
  'posMaterialRequest.detail.issued': 'Dikirim',
  'posMaterialRequest.detail.items': 'Barang diminta',
  'posMaterialRequest.detail.location': 'Lokasi',
  'posMaterialRequest.detail.memo_attachment': 'Memo & lampiran',
  'posMaterialRequest.detail.no_history': 'Belum ada riwayat',
  'posMaterialRequest.detail.no_memo': 'Tidak ada memo',
  'posMaterialRequest.detail.not_found_desc':
    'Dokumen ini mungkin sudah dihapus, atau dibuat oleh outlet lain.',
  'posMaterialRequest.detail.not_found_title': 'Permintaan tidak ditemukan',
  'posMaterialRequest.detail.number': 'Nomor permintaan',
  'posMaterialRequest.detail.outlet': 'Outlet',
  'posMaterialRequest.detail.product': 'Produk',
  'posMaterialRequest.detail.reload': 'Muat ulang',
  'posMaterialRequest.detail.requested': 'Diminta',
  'posMaterialRequest.detail.warehouse': 'Gudang tujuan',
  'posMaterialRequest.empty.desc': 'Ajukan kebutuhan bahan ke gudang pusat langsung dari kasir.',
  'posMaterialRequest.empty.filtered_desc': 'Coba ubah kata kunci, status, atau rentang tanggal.',
  'posMaterialRequest.empty.filtered_title': 'Tidak ada permintaan yang cocok',
  'posMaterialRequest.empty.first': 'Buat permintaan pertama',
  'posMaterialRequest.empty.title': 'Belum ada permintaan',
  'posMaterialRequest.export': 'Ekspor',
  'posMaterialRequest.export_failed': 'Gagal mengekspor data',
  'posMaterialRequest.filter.all': 'Semua',
  'posMaterialRequest.filter.canceled': 'Dibatalkan',
  'posMaterialRequest.filter.fulfilled': 'Dipenuhi',
  'posMaterialRequest.filter.processed': 'Diproses',
  'posMaterialRequest.filter.rejected': 'Ditolak',
  'posMaterialRequest.filter.waiting': 'Menunggu',
  'posMaterialRequest.form.add_file': 'Tambah file',
  'posMaterialRequest.form.add_item': 'Tambah barang',
  'posMaterialRequest.form.attachment': 'Lampiran',
  'posMaterialRequest.form.cancel': 'Batal',
  'posMaterialRequest.form.create_title': 'Permintaan Baru',
  'posMaterialRequest.form.destination': 'Barang akan dikirim ke',
  'posMaterialRequest.form.destination_hint': 'Ditentukan otomatis dari outlet aktif',
  'posMaterialRequest.form.discard': 'Buang perubahan',
  'posMaterialRequest.form.discard_message': 'Perubahan yang belum disimpan akan hilang.',
  'posMaterialRequest.form.discard_title': 'Keluar tanpa menyimpan?',
  'posMaterialRequest.form.edit_title': 'Ubah Permintaan',
  'posMaterialRequest.form.file_too_large': 'Ukuran file maksimal {max} MB',
  'posMaterialRequest.form.items': 'Barang diminta',
  'posMaterialRequest.form.items_empty':
    'Belum ada barang. Tambahkan barang yang dibutuhkan outlet.',
  'posMaterialRequest.form.items_required': 'Tambahkan minimal 1 produk dengan jumlah lebih dari 0',
  'posMaterialRequest.form.location': 'Lokasi',
  'posMaterialRequest.form.location_placeholder': 'Misal: dapur, bar, gerobak depan',
  'posMaterialRequest.form.memo': 'Memo untuk pusat',
  'posMaterialRequest.form.memo_placeholder': 'Tulis keterangan tambahan untuk pusat',
  'posMaterialRequest.form.note_placeholder': 'Catatan untuk barang ini',
  'posMaterialRequest.form.outlet_warehouse': 'Gudang outlet {name}',
  'posMaterialRequest.form.remove_file': 'Hapus lampiran',
  'posMaterialRequest.form.remove_item': 'Hapus produk',
  'posMaterialRequest.form.save': 'Simpan Perubahan',
  'posMaterialRequest.form.save_draft': 'Simpan Draf',
  'posMaterialRequest.form.submit_only': 'Ajukan Permintaan',
  'posMaterialRequest.form.saved_generic': 'Permintaan disimpan',
  'posMaterialRequest.form.save_submit': 'Simpan & Ajukan',
  'posMaterialRequest.form.saved': 'Permintaan disimpan sebagai draf',
  'posMaterialRequest.form.submitted': 'Permintaan berhasil diajukan ke pusat',
  'posMaterialRequest.form.total_qty': 'Total qty',
  'posMaterialRequest.form.trans_date': 'Tanggal permintaan',
  'posMaterialRequest.form.trans_date_required': 'Silakan pilih tanggal permintaan',
  'posMaterialRequest.form.updated': 'Perubahan permintaan disimpan',
  'posMaterialRequest.form.upload_failed': 'Gagal mengunggah lampiran',
  'posMaterialRequest.from_outlet': 'Permintaan dari outlet',
  'posMaterialRequest.info.canceled': 'Permintaan ini sudah dibatalkan.',
  'posMaterialRequest.info.draft': 'Permintaan masih draf. Ajukan agar pusat bisa memproses.',
  'posMaterialRequest.info.fulfilled': 'Semua barang sudah dikirim dari gudang pusat.',
  'posMaterialRequest.info.partial':
    'Sebagian barang sudah dikirim. Sisanya masih diproses gudang pusat.',
  'posMaterialRequest.info.processed': 'Disetujui pusat dan sedang disiapkan gudang.',
  'posMaterialRequest.info.rejected':
    'Permintaan ditolak pusat. Ubah lalu ajukan ulang bila perlu.',
  'posMaterialRequest.info.waiting':
    'Menunggu persetujuan pusat di Kledo. Status diperbarui saat halaman dibuka kembali.',
  'posMaterialRequest.items_count': '{count} barang',
  'posMaterialRequest.load_failed': 'Gagal memuat permintaan',
  'posMaterialRequest.picker.add': 'Tambahkan ({count})',
  'posMaterialRequest.picker.empty': 'Produk tidak ditemukan',
  'posMaterialRequest.picker.hint': 'Hanya produk dengan stok terlacak yang bisa diminta.',
  'posMaterialRequest.picker.in_form': 'Sudah di form',
  'posMaterialRequest.picker.search': 'Cari produk',
  'posMaterialRequest.picker.selected_summary': '{count} barang · {qty} qty',
  'posMaterialRequest.picker.title': 'Pilih Produk',
  'posMaterialRequest.search_placeholder': 'Cari nomor atau memo',
  'posMaterialRequest.status.canceled': 'Dibatalkan',
  'posMaterialRequest.status.draft': 'Draf',
  'posMaterialRequest.status.fulfilled': 'Dipenuhi',
  'posMaterialRequest.status.partial': 'Dipenuhi sebagian',
  'posMaterialRequest.status.processed': 'Diproses gudang',
  'posMaterialRequest.status.rejected': 'Ditolak',
  'posMaterialRequest.status.waiting': 'Menunggu approval',
  'posMaterialRequest.step.canceled': 'Dibatalkan',
  'posMaterialRequest.step.draft': 'Draf',
  'posMaterialRequest.step.fulfilled': 'Dipenuhi',
  'posMaterialRequest.step.processed': 'Diproses gudang',
  'posMaterialRequest.step.rejected': 'Ditolak',
  'posMaterialRequest.step.submitted': 'Diajukan',
  'posMaterialRequest.success.cancel': 'Permintaan dibatalkan',
  'posMaterialRequest.success.delete': 'Permintaan dihapus',
  'posMaterialRequest.success.draft': 'Permintaan dikembalikan ke draf',
  'posMaterialRequest.success.submit': 'Permintaan berhasil diajukan',
  'posMaterialRequest.title': 'Permintaan Material',
  'posMaterialRequest.upgrade.benefit_1': 'Ajukan permintaan barang langsung dari kasir',
  'posMaterialRequest.upgrade.benefit_2':
    'Pantau persetujuan pusat dan pengiriman gudang secara real-time',
  'posMaterialRequest.upgrade.benefit_3':
    'Terhubung otomatis ke transfer gudang dan surat jalan di Kledo',
  'posMaterialRequest.upgrade.desc':
    'Upgrade paket untuk mengajukan kebutuhan bahan dari outlet langsung ke gudang pusat.',
}

export default {
  locale: 'id-ID',
  antdData,
  // localeData,
  messages,
}
